/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 259);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//inject

__webpack_require__(260);

__webpack_require__(261);

__webpack_require__(262);

__webpack_require__(263);

__webpack_require__(264);

__webpack_require__(265);

__webpack_require__(266);

__webpack_require__(267);

__webpack_require__(268);

__webpack_require__(269);

__webpack_require__(270);

__webpack_require__(271);

__webpack_require__(272);

__webpack_require__(273);

__webpack_require__(274);

__webpack_require__(275);

__webpack_require__(276);

__webpack_require__(277);

__webpack_require__(278);

__webpack_require__(279);

__webpack_require__(280);

__webpack_require__(281);

__webpack_require__(282);

__webpack_require__(283);

__webpack_require__(284);

__webpack_require__(285);

__webpack_require__(286);

__webpack_require__(287);

__webpack_require__(288);

__webpack_require__(289);

__webpack_require__(290);

__webpack_require__(291);

__webpack_require__(292);

__webpack_require__(293);

__webpack_require__(294);

__webpack_require__(295);

__webpack_require__(296);

__webpack_require__(297);

__webpack_require__(298);

__webpack_require__(299);

__webpack_require__(300);

__webpack_require__(301);

__webpack_require__(302);

__webpack_require__(303);

__webpack_require__(304);

__webpack_require__(305);

__webpack_require__(306);

__webpack_require__(307);

__webpack_require__(308);

__webpack_require__(309);

__webpack_require__(310);

__webpack_require__(311);

__webpack_require__(312);

__webpack_require__(313);

__webpack_require__(314);

__webpack_require__(315);

__webpack_require__(316);

__webpack_require__(317);

__webpack_require__(318);

__webpack_require__(319);

__webpack_require__(320);

__webpack_require__(321);

__webpack_require__(322);

__webpack_require__(323);

__webpack_require__(324);

__webpack_require__(325);

__webpack_require__(326);

__webpack_require__(327);

__webpack_require__(328);

__webpack_require__(329);

__webpack_require__(330);

__webpack_require__(331);

__webpack_require__(332);

__webpack_require__(333);

__webpack_require__(334);

__webpack_require__(335);

__webpack_require__(336);

__webpack_require__(337);

__webpack_require__(338);

__webpack_require__(339);

__webpack_require__(340);

__webpack_require__(341);

__webpack_require__(342);

__webpack_require__(343);

__webpack_require__(344);

__webpack_require__(345);

__webpack_require__(346);

__webpack_require__(347);

__webpack_require__(348);

__webpack_require__(349);

__webpack_require__(350);

__webpack_require__(351);

__webpack_require__(352);

__webpack_require__(353);

__webpack_require__(354);

__webpack_require__(355);

__webpack_require__(356);

__webpack_require__(357);

__webpack_require__(358);

__webpack_require__(359);

__webpack_require__(360);

__webpack_require__(361);

__webpack_require__(362);

__webpack_require__(363);

__webpack_require__(364);

__webpack_require__(365);

__webpack_require__(366);

__webpack_require__(367);

__webpack_require__(368);

__webpack_require__(369);

__webpack_require__(370);

__webpack_require__(371);

__webpack_require__(372);

__webpack_require__(373);

__webpack_require__(374);

__webpack_require__(375);

__webpack_require__(376);

__webpack_require__(377);

__webpack_require__(378);

__webpack_require__(379);

__webpack_require__(380);

__webpack_require__(381);

__webpack_require__(382);

__webpack_require__(383);

__webpack_require__(384);

__webpack_require__(385);

__webpack_require__(386);

__webpack_require__(387);

__webpack_require__(388);

__webpack_require__(389);

__webpack_require__(390);

__webpack_require__(391);

__webpack_require__(392);

__webpack_require__(393);

__webpack_require__(394);

__webpack_require__(395);

__webpack_require__(396);

__webpack_require__(397);

__webpack_require__(398);

__webpack_require__(399);

__webpack_require__(400);

__webpack_require__(401);

__webpack_require__(402);

__webpack_require__(403);

__webpack_require__(404);

__webpack_require__(405);

__webpack_require__(406);

__webpack_require__(407);

__webpack_require__(408);

__webpack_require__(409);

__webpack_require__(410);

__webpack_require__(411);

__webpack_require__(412);

__webpack_require__(413);

__webpack_require__(414);

__webpack_require__(415);

__webpack_require__(416);

__webpack_require__(417);

//endinject

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

window.JQuery = window.$ = __webpack_require__(2);
// window.angular = require('angular');

angular.module('betosyswebapp', ['ngAnimate', 'ngMaterial', 'ngCookies', 'ngTouch', 'ngSanitize', 'restangular', 'ui.router', 'pascalprecht.translate', 'jqwidgets', 'ab-base64', 'ui.bootstrap', 'LocalStorageModule', 'angular-loading-bar', 'cfp.loadingBar', 'angularMoment', 'ncy-angular-breadcrumb', 'dashboard', 'highcharts-ng', 'timepickerPop', 'ngContextMenu', 'ui-rangeSlider', 'tmh.dynamicLocale', 'dsaComponents', 'daterangepicker', 'toggle-switch', 'trackMap', 'trackReporting', 'telephone', 'driverDashboard', 'portalCommand', 'fmsDashboard', 'tachoHistoryDashboard', 'luegg.directives', 'app.constants', 'contact', 'bookManagement', 'tachoDownloadDashboard', 'sharedConfig']).constant('serverBaseUrl', '/api/fleetapi').constant('localStoragePrefix', 'betoTrack').config(["localStoragePrefix", "serverBaseUrl", "localStorageServiceProvider", "RestangularProvider", function (localStoragePrefix, serverBaseUrl, localStorageServiceProvider, RestangularProvider) {
  localStorageServiceProvider.setPrefix(localStoragePrefix);
  RestangularProvider.setBaseUrl(serverBaseUrl);
}]).config(['$locationProvider', function ($locationProvider) {
  $locationProvider.hashPrefix('');
}]).config(["dsaComponentsConfig", function (dsaComponentsConfig) {
  var config = {
    serverBaseUrl: '/api/fleetapi',
    loginUrl: 'user/login',
    logoutUrl: 'user/logout',
    productName: 'BetoTrack',
    unProtectedStates: ['home'],
    loginSuccessState: 'betotrack.dashboard',
    localStoragePrefix: 'betoTrack',

    adaptClearInput: true,
    jqxCustomSettings: { theme: 'material' // theme: 'bootstrap',
    } };
  dsaComponentsConfig = _.extend(dsaComponentsConfig, config);
}]).config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
  cfpLoadingBarProvider.includeSpinner = false;
}]).config(["$breadcrumbProvider", function ($breadcrumbProvider) {
  $breadcrumbProvider.setOptions({
    templateUrl: 'components/breadcrumb/breadcrumb.tpl.html'
  });
}]).config(["$stateProvider", "$urlRouterProvider", "$translateProvider", "defaultI18n", function ($stateProvider, $urlRouterProvider, $translateProvider, defaultI18n) {
  $stateProvider.state('app', {
    abstract: true,
    views: {
      'framework': {
        templateUrl: 'components/framework/framework.tpl.html',
        controller: 'FrameworkController',
        controllerAs: 'framework'
      }
    },
    resolve: {
      $title: function $title() {
        return 'DSA';
      }
    }
  });

  $urlRouterProvider.otherwise('/');

  _.map(defaultI18n, function (val, key) {
    $translateProvider.translations(key, val);
  });
  //i18n

  // Tell the module what language to use by default
  $translateProvider.preferredLanguage('en');
  $translateProvider.fallbackLanguage('en');
  $translateProvider.useSanitizeValueStrategy('escape');
}]).config(["tmhDynamicLocaleProvider", function (tmhDynamicLocaleProvider) {
  tmhDynamicLocaleProvider.localeLocationPattern('https://code.angularjs.org/1.6.6/i18n/angular-locale_{{locale}}.js');
}]).filter('replacenewline', function () {
  return function (text) {
    return text.replace(/\\n/gm, ' / ');
  };
}).filter('tel', function () {
  return function (tel) {
    if (!tel) {
      return '';
    }
    var value = tel.toString().trim().replace(/^\+/, '');
    if (value.match(/[^0-9]/)) {
      return tel;
    }
    if (value) {
      if (value.length > 20) {
        value = value.slice(0, 20);
      }
      return value.trim();
    }
  };
}).factory('iframeMessageRecieveService', ["$window", "localStorageService", "commonTrackService", "AuthenticationService", "$rootScope", "toastService", "$translate", function ($window, localStorageService, commonTrackService, AuthenticationService, $rootScope, toastService, $translate) {

  var service = {
    initRecieveMessage: activate
  };

  return service;

  function activate() {
    activateIncomingMessageHandler();
  }

  function activateIncomingMessageHandler() {
    $window.addEventListener('message', function (event) {
      var loginID = AuthenticationService.GetLoginID();
      if (typeof event.data !== 'undefined') {
        if (event.data.eventType === 'zoom_changed') {
          localStorageService.set('mapZoomDetails.' + loginID.username + '.' + event.data.frameId, event.data);
        } else if (event.data.eventType === 'map_init') {
          var mapZoomDetailsLocalStorageVal = localStorageService.get('mapZoomDetails.' + loginID.username + '.' + event.data.frameId);
          var method = 'loadLocalStorageLoomDetails_dsa(' + JSON.stringify(mapZoomDetailsLocalStorageVal) + ')';
          commonTrackService.getFleetServerDetails().then(function (gtsServerSettings) {
            var postMessageObj = { method: 'window.' + method, messageOrigin: $window.location.origin };
            event.source.postMessage(postMessageObj, gtsServerSettings.qualifiedServerURL);
          });
          $rootScope.$broadcast('map_init_event', {});
        } else if (event.data.eventType === 'map_direction_init' || event.data.eventType === 'map_place_changed') {
          $rootScope.$broadcast('map_place_route_int_event', {});
        } else if (event.data.eventType === 'map_rotue_canceled' || event.data.eventType === 'map_option_closed') {
          $rootScope.$broadcast('map_option_canceled_event', {});
        } else if (event.data.eventType === 'init-toast-response') {
          if (event.data.errorType === 'success') {
            toastService.showSuccessToast($translate.instant('errorCodes.track.' + event.data.errorId + '.message'));
          }
        }
        // handle message
      }
    });
  }
}]).factory('timeoutHttpIntercept', ["$q", function ($q) {
  return {
    'request': function request(config) {
      config.timeout = 45000; //set request time out to 20 seconds
      return config;
    },
    'responseError': function responseError(rejection) {
      if (rejection.status === 401 && window.location.href.indexOf('login') === -1 || rejection.status === 500 && typeof rejection.data === 'string' && rejection.data.indexOf('Error occured while trying to proxy to') > -1 || rejection.status === 503 && window.location.href.indexOf('login') === -1) {
        {
          window.location = '/#/login';
          return;
        }
      }
      return $q.reject(rejection);
    }
  };
}]).config(["$httpProvider", function ($httpProvider) {
  $httpProvider.interceptors.push('timeoutHttpIntercept');
}]).run(["$rootScope", "$state", "$location", "$cookies", "AuthenticationService", "commonTrackService", "vehicleMapWidgetService", "fleetMapWidgetService", "dsaComponentsConfig", "$translate", "languageService", "dashboard", "iframeMessageRecieveService", function ($rootScope, $state, $location, $cookies, AuthenticationService, commonTrackService, vehicleMapWidgetService, fleetMapWidgetService, dsaComponentsConfig, $translate, languageService, dashboard, iframeMessageRecieveService) {

  iframeMessageRecieveService.initRecieveMessage();
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
    $state.previous = fromState;
  });

  $rootScope.$on('$stateChangeStart', function (event, toState) {
    if (AuthenticationService.IsLogin()) {
      addDynamicCssClasses();
    }
    vehicleMapWidgetService.setWigetInitialized(false);
    fleetMapWidgetService.setWigetInitialized(false);

    if (toState.name === 'login') {
      _updateDsaComponentCustomConfig();
    }
  });

  //DSA fleetmanagement #bug 88863
  $rootScope.$watch(function () {
    var data = $cookies.get('BetoTrack');
    return data;
  }, function (newValue) {

    var isDefined = false;

    if (newValue) {
      isDefined = true;
    }

    if (isDefined === false) {
      var ignoreLogout = $state.current.url === '/login' ? true : false;
      if (ignoreLogout === false) {
        AuthenticationService.logout();
        $location.path('/login');
      }
    }
  }, true);

  var widgetKeys = Object.keys(dashboard.widgets);

  function translzteTltleAndDescription() {
    if (widgetKeys.length) {
      for (var i = 0; i < widgetKeys.length; i++) {
        var key = widgetKeys[i];
        var value = dashboard.widgets[key];
        if (value.resolve && value.resolve.title) {
          dashboard.widgets[key].title = $translate.instant(dashboard.widgets[key].resolve.title(), null, null, languageService.getLanguageSettings().language);
        }
        if (value.resolve && value.resolve.description) {
          dashboard.widgets[key].description = $translate.instant(dashboard.widgets[key].resolve.description(), null, null, languageService.getLanguageSettings().language);
        }
      }
    }
  }

  $rootScope.$on('$locationChangeStart', function (event, toState) {
    if (toState.indexOf('dashboard') > -1) {
      dashboard.setLocale(languageService.getLanguageSettings().language + '-' + languageService.getLanguageSettings().language.toUpperCase());
      translzteTltleAndDescription();
    }
  });

  function addDynamicCssClasses() {
    var userSettings = commonTrackService.getGtsLocalStorageSettings();
    if (userSettings && userSettings.gridsSetting) {
      for (var i = 0; i < Object.keys(userSettings.gridsSetting).length; i++) {
        if (!$('#' + userSettings.gridsSetting[Object.keys(userSettings.gridsSetting)[i]].backgroundColor)[0]) {
          var bgColor = userSettings.gridsSetting[Object.keys(userSettings.gridsSetting)[i]].backgroundColor;
          $('<div></div>', {
            html: '&shy;<style id=' + bgColor + '>' + '.rgb-' + bgColor + ' {  background-color: #' + bgColor + '; }' + '</style>'
          }).appendTo('body');
        }
      }
    }
  }

  function _updateDsaComponentCustomConfig() {
    dsaComponentsConfig.customLoginID = function (loginID) {
      loginID.Account = commonTrackService.getGeneralSettings().login.accountID;
    };
    dsaComponentsConfig = _.extend(dsaComponentsConfig, dsaComponentsConfig);
  }

  _updateDsaComponentCustomConfig();
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/breadcrumb/breadcrumb.tpl.html', '<ol class="breadcrumb"><li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract"><a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel |translate}}</a> <span ng-switch-when="true">{{step.ncyBreadcrumbLabel |translate}}</span></li></ol>');
  }]);
})();

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('sharedConfig', []).constant('accountConfig', {
  imprintUrls: {
    dsa: 'https://www.dsa.de/de/impressum.html',
    default: 'https://www.dsa.de/de/impressum.html'
  },
  dataPrivacyUrls: {
    dsa: 'https://www.dsa.de/de/datenschutzerklaerung.html',
    sph: window.location.origin + '/sph-privacy-policy-3a33806c.html',
    default: 'https://www.dsa.de/de/datenschutzerklaerung.html'
  }
});

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Administrator on 10/19/2015.
 */


angular.module('betosyswebapp').constant('defaultI18n', {
  //please do not change the content manually.It is generated by gulp i18n
  //inject


  de: { 'modal': { 'customer': 'Kunden', 'buildingSite': 'Baustellen' }, 'nav': { 'productName': 'BetoSys', 'productLogoText': { 'fbr': 'BetoTrack', 'lgs': 'BetoTrack-LGS' }, 'productLogoShortText': { 'fbr': 'BS', 'lgs': 'LGS' }, 'language': { 'en': 'English', 'de': 'Deutsch', 'nl': 'Nederlandse' }, 'user': { 'settings': 'Einstellungen', 'changePassword': 'Kennwort ändern', 'logout': 'Abmelden', 'appProfile': 'Applikationsprofil', 'clearLocalStorage': 'Profil löschen', 'restoreLocalStorage': 'Profil wiederherstellen', 'saveLocalStorage': 'Profil speichern' }, 'menuOptions': { 'dashboard': 'Dashboard', 'portalCommand': 'Portal-Befehl', 'maps': 'Karten', 'map': 'Karte', 'reports': 'Berichte', 'telephone': 'Telefon', 'driverDashboard': 'Fahrer Dashboard', 'mapsSubMenu': { 'lastLocation': 'Letzte Position', 'vehicleMap': 'Einzelne Fahrzeuge', 'groupMap': 'Flottenübersicht', 'sosEmergencyMap': 'SOS/Alarm', 'freeDeviceMap': 'Freie Fahrzeuge', 'busyDeviceMap': 'Disponierte Fahrzeuge' }, 'reportsSubMenu': { 'vehicleDetails': 'Einzelne Fahrzeuge', 'groupDetails': 'Fahrzeuggruppe Details', 'groupSummary': 'Gerätegruppen', 'performance': 'Fahrleistung' } } }, 'sidebar': { 'betotrack': { 'dashboard': 'Dashboard', 'map': 'Karte', 'driver': 'Fahrer Dashboard', 'driverDashbordMenu': 'Fahrer Dashboard', 'tachoHistoryDashboardMenu': 'Fahrer Historie', 'portalcommand': 'Portal Befehle', 'fms': 'FMS Dashboard', 'tachoDashboardMenu': 'Tacho Dashboard', 'tachoDownloadStatusDashboardMenu': 'Download Status', 'mapitems': { 'lastlocation': 'Letzte Position', 'vehiclemap': 'Einzelne Fahrzeuge', 'groupmap': 'Fahrzeuggruppen', 'sosmap': 'SOS/ Hilfe', 'alert': 'Alarm', 'freedevicesmap': 'Freie Fahrzeuge', 'busydevicesmap': 'Disponierte Fahrzeuge' }, 'reports': 'Berichte', 'reportitems': { 'vehicledetail': 'Einzelne Fahrzeuge', 'groupdetail': 'Fahrzeuggruppe Detail', 'groupsummary': 'Fahrzeuggruppe Gesamt', 'performance': 'Fahrleistung' }, 'admin': 'Administration', 'adminitems': { 'contactmgmt': 'Kontaktliste', 'bookmgmt': 'Telefonbücher' }, 'telephone': 'Telefon' } }, 'foot': { 'application': 'Anwendung', 'database': 'Datenbank', 'gtse': 'GTSE', 'dataprivacy': 'Datenschutzerklärung', 'imprint': 'Impressum' }, 'login': { 'placeHolder': { 'Account': 'Account ID', 'username': 'Benutzername', 'password': 'Kennwort', 'email': 'E-Mail', 'forgotPassword': 'Passwort vergessen' }, 'error': { 'timeout': 'Server Timeout', 'unauthorized': 'User unauthorized!' }, 'tittle': { 'fbr': 'BetoTrack Login', 'lgs': 'BetoTrack-LGS Login' } }, 'passwordChange': { 'placeHolder': { 'oldPassword': 'Altes Passwort', 'newPassword': 'Neues Passwort', 'confirmPassword': 'Passwort bestätigen' }, 'success': 'Passwort erfolgreich geändert', 'successForgotPassword': 'Neues Passwort wurde per E-Mail verschickt', 'mismatch': 'Passwörter nicht übereinstimmend', 'accountmismatch': 'Account nicht übereinstimmend', 'oldpasswordwrong': 'Aktuelles Passwort ist falsch', 'requiredField': 'Bitte Pflichtfelder ausfüllen', 'save': 'Speichern', 'close': 'Schließen', 'submit': 'Absenden' }, 'forgotPassword': { 'title': 'Um sich das Passwort zuschicken zu lassen, geben Sie bitte Ihre Anmelde-Informationen und Ihre E-Mail-Adresse ein (muss mit gespeicherter E-Mail-Adresse übereinstimmen)' }, 'home': { 'welcome': 'Willkommen bei BetoSys', 'modules': { 'vis': { 'name': 'BetoVIS', 'desc': 'Vertrieb und Verkauf' }, 'plan': { 'name': 'BetonPlan', 'desc': 'Planung und Disposition' }, 'fakt': { 'name': 'BetoFakt', 'desc': 'Abrechung' }, 'track': { 'name': 'BetoTrack', 'desc': 'Fleet Management' } } }, 'print': { 'printing': 'Drucken', 'print': 'Drucken', 'exportXml': 'Export nach XML', 'exportExcel': 'Export nach Excel' }, 'moreFunction': { '5003': 'Data has already been deleted', 'button': { 'function': 'Weitere Funktionen' }, 'functionList': { 'delete': 'Löschen', 'download': 'Herunterladen', 'fileImport': 'Datei importieren', 'contactPosition': 'Reihenfolge ändern' } }, 'filter': { 'default': 'Default', 'clearFilter': 'Lösche Filter', 'resize': 'Größe ändern', 'settings': 'die Einstellungen', 'showDate': 'Datumsfilter anzeigen', 'hideDate': 'Datumsfilter verstecken' }, 'contextMenu': { 'customer': {}, 'buildingSite': {}, 'plant': {} }, 'settings': { 'name': 'Benutzername', 'userSetting': 'Benutzereinstellungen', 'gridPreference': { 'setting': 'Tabelleneinstellung', 'reset': 'Wiederherstellen', 'grid': 'Tabelle: ', 'backgroundColor': 'Hintergrundfarbe:', 'showingColumns': 'Spalten anzeigen: ', 'pinnedColumn': 'Anzahl fixierte Spalten' }, 'generalAccordion': { 'title': 'Allgemein', 'countryId': 'Länderkennung', 'company': 'Firma' }, 'planAccordion': { 'title': 'BetoTrack', 'workstation': 'Arbeitsplatz' } }, 'serverMessage': { '5001': 'Daten wurden von <{{AENDUSER}}> um {{AENDDATE}} geändert', '5002': 'Nummer {{id}} existiert bereits !', '5004': 'Datensatz mit Nummer  <[{{number}}]> wurde bereits durch <[{{AENDUSER}}]> angelegt.', 'login': { 'badCredential': 'Benutzername oder Passwort stimmt nicht.', 'GTSE_503': 'Dienst nicht verfügbar (GTSE)!', 'AU0010': 'Anmeldung fehlgeschlagen', 'US0020': 'Benutzer inaktiv', 'US0030': 'Benutzer abgelaufen' }, 'updatePassword': { '6003': 'Update Failed' }, 'internalServerError': 'Internal Server Error' }, 'confirmOnExit': { 'title': 'Änderungen verwerfen ?', 'content': 'Der aktuelle Datensatz wurde geändert, wollen Sie die Änderungen verwerfen?', 'exit': 'Ja', 'cancel': 'Abbrechen' }, 'responseErrorDilaog': { 'ok': 'Ok', 'cancel': 'Abbrechen', 'yes': 'Ja', 'no': 'Nein' }, 'button': { 'cancel': 'Abbrechen', 'save': 'Speichern' }, 'form': { 'save': { 'success': 'Erfolgreich gespeichert !' }, 'requiredFiled': 'Sie müssen Werte für alle Mussfelder eingeben!' }, 'error': { 'unAuthorizedMessage': 'Eingeschränkter Zugriff!' }, 'betoTrackMapping': { 'free': 'Freie Fahrzeuge', 'busy': 'Disponierte Fahrzeuge', 'group': 'Flottenübersicht', 'vehicle': 'Einzelne Fahrzeuge', 'lastlocation': 'Letzte Position', 'sos': 'SOS/Notfall Karte', 'alert': 'Alarmkarte' }, 'trackReporting': { 'performance': 'Fahrleistung', 'performanceReport': { 'eventSpeedOption': 'Geschwindigkeit über', 'eventExcessSpeed': 'Überhöhte Geschwindigkeit', 'driverReport': 'Fahrerbericht', 'driverExpiringLicense': 'Abgelaufene Führerscheine', 'driverWorkingHours': 'Fahrer Arbeitszeiten', 'customExport': 'Export DATEV', 'customExportDialog': { 'title': 'Fahrer Arbeitszeiten / DATEV', 'driver': 'Fahrer', 'export': 'Export', 'cancel': 'Abbrechen', 'exportSuccess': 'Export erfolgreich durchgeführt ! ' }, 'reportComboboxOptions': { 'eventSpeedOption': { '45mph': '30 km/h', '50mph': '50 km/h', '55mph': '60 km/h', '60mph': '70 km/h', '65mph': '90 km/h', '70mph': '100 km/h', '75mph': '120 km/h' }, 'driverExpiringLicense': { 'expired': 'Abgelaufen', '1week': 'In 1 Woche', '2weeks': 'In 2 Wochen', '1month': 'In 3 Wochen', '6months': 'In 6 Monaten' } } }, 'groupSummary': 'Fahrzeuggruppen', 'groupsummaryReport': { 'monthlyVehicleFuelUse': 'Monatsbericht Fahrzeuge Verbrauch', 'eventSummary': 'Letzte bekannte Fahrzeugposition', 'firstEventSummary': 'Erstes Fahrzeugereignis', 'excessiveLastCheckIn': 'Letzter Check-in', 'deviceLastCheckIn': 'Fahrzeug Check-In Bericht', 'deviceNeverCheckIn': 'Fahrzeug Kein Check-In Bericht', 'eventCount': 'Anzahl empfangene Fahrzeugereignisse', 'eventSessionStatus': 'Sitzungsverbindungsbericht', 'periodicServiceOdom': 'Wartungsbericht nach Kilometerstand', 'periodicServiceHours': 'Wartungsbericht nach Betriebsstunden', 'distanceTraveled': 'Zurückgelegte Strecke', 'ignitionSummaryReport': 'Zündungsbericht Zusammenfassung', 'digitalInputSummaryReport': 'Digitale Eingänge Zusammenfassung', 'fleetMotion': 'Fahrzeiten Zusammenfassung', 'fleetIdle': 'Leerlaufzeiten Zusammenfasung', 'fuelSummaryReport': 'Kraftstoffverbrauch Zusammenfassung', 'statusSummaryCount': 'Tagesereignisse Zusammenfassung', 'userLogin': 'Benutzeranmeldungen', 'geozoneNearbyDevices': 'Fahrzeuge in Nähe einer Geozone', 'geozoneHotspotReport': 'Geozone Hotspot Report', 'reportComboboxOptions': { 'eventSummary': { 'all': 'Alle Ereignisse', 'free': 'Freie Fahrzeuge', 'busy': 'Disponierte Fahrzeuge', 'login': 'Angemeldete Fahrzeuge', 'logout': 'Abgemeldete Fahrzeuge', 'pause': 'Fahrer in Pause', 'service': 'Fahrzeug in Werkstatt' }, 'firstEventSummary': { 'all': 'Zündung an', 'motion': 'In Bewegung' }, 'excessiveLastCheckIn': { '1day': 'Mehr als 1 Tag', '2days': 'Mehr als  2 Tage', '3days': 'Mehr als  3 Tage', '7days': 'Mehr als  7 Tage', '30days': 'Mehr als  30 Tage', '100days': 'Mehr als  100 Tage' }, 'eventCount': { 'all': 'All', 'initialization': '\'Initialisierung\'', 'inmotion': '\'In Bewegung\'' }, 'digitalInputSummaryReport': { 'input0': 'Eingang #0', 'input1': 'Eingang #1', 'input2': 'Eingang #2', 'input3': 'Eingang #3', 'input4': 'Eingang #4', 'input5': 'Eingang #5', 'input6': 'Eingang #6', 'input7': 'Eingang #7' }, 'fleetMotion': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'fleetIdle': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' } }, 'reportedRefuel': 'Betankungsbericht pro Tag', 'refuelMileage': 'Betankungsprotokoll CarPC' }, 'groupDetail': 'Fahrzeuggruppe Detail', 'groupDetailReport': { 'eventDetail_Group': 'Ereignisse Details', 'eventDetailOBDLight_Group': 'Ereignis OBD Details', 'tripReport_Group': 'Fahrtbericht Details', 'motionSummary_Group': 'Fahrzeiten/Stoppzeiten Zusammenfassung', 'geozoneReport_Group': 'Geozonenbericht', 'geozoneDriving_Group': 'Geozonen Ankunftsbericht', 'eventSpeedOption_Group': 'Geschwindigkeit über', 'eventExcessSpeed_Group': 'Fahrzeugübergeschwindigkeit', 'eventSpeedPosted_Group': 'Übertretung Höchstgeschwindigkeit', 'eventIdle_Group': 'Leerlauf', 'eventExcessiveIdle_Group': 'Exzessiver Leerlauf', 'digitalInputDetailReport_Group': 'Digitale Eingänge Details', 'notifyQueueDetail_Group': 'Alarm Details', 'reportComboboxOptions': { 'tripReport': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'workorder': 'Basierend auf Auftragsbeginn/Ankunft Werk', 'loginlogout': 'Basierend auf Anmeldung/Abmeldung', 'motion0': 'Basierend auf 0 Minuten Stop (Min)', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'motionSummary': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'eventSpeedOption': { '45mph': '30 km/h', '50mph': '50 km/h', '55mph': '60 km/h', '60mph': '70 km/h', '65mph': '90 km/h', '70mph': '100 km/h', '75mph': '120 km/h' }, 'eventSpeedPosted': { 'default': 'über Limit', '5mph': '8km/h über Limit', '10mph': '16km/h über Limit' }, 'digitalInputDetailReport': { 'input0': 'Eingang #0', 'input1': 'Eingang #1', 'input2': 'Eingang #2', 'input3': 'Eingang #3', 'input4': 'Eingang #4', 'input5': 'Eingang #5', 'input6': 'Eingang #6', 'input7': 'Eingang #7' } } }, 'vehicleDetail': 'Einzelne Fahrzeuge', 'vehicleDetailReport': { 'fuelTracker': 'Betankungsbericht', 'eventDetail': 'Ereignisse Details', 'tripReport': 'Fahrtbericht Details', 'motionSummary': 'Fahrzeiten/Stoppzeiten Zusammenfassung', 'deviceWorkOrders': 'Auftragsbericht', 'geozoneReport': 'Geozone Tankstelle', 'geozoneDriving': 'Geozone Ankunftsbericht', 'jobReport': 'Geozone Auftrag', 'ignitionDetailReport': 'Zündungsbericht Details', 'digitalInputDetailReport': 'Digitale Eingänge Details', 'eventCountByDay': 'Empfangene Ereignisse pro Tag', 'eventIdle': 'Leerlauf', 'eventExcessiveIdle': 'Exzessiver Leerlauf', 'driverMessageDetail': 'Fahrernachrichten Details', 'eventDetailOBDLight': 'OBD Light Ereignis Details', 'eventDetailAll': 'Ereignisse Details (FMS, Tacho)', 'eventRuleSpeeding': 'Übertretung Höchstgeschwindigkeit Details', 'fuelRegisterDetail': 'Kraftstoff Betankung/Entleerung Details', 'dailyDistanceDetail': 'Zurückgelegte Tagesstrecke', 'deviceNearbyDevices': 'Fahrzeuge in Nähe einer Geozone', 'eventDetailCargoQuality': 'Ereignisse Details (Qualität Ladung)', 'notifyQueueDetail': 'Fahrzeug Alert Detail', 'reportComboboxOptions': { 'tripReport': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'workorder': 'Basierend auf Auftragsbeginn/Ankunft Werk', 'loginlogout': 'Basierend auf Anmeldung/Abmeldung', 'motion0': 'Basierend auf 0 Minuten Stop (Min)', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'motionSummary': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min)', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'eventCountByDay': { 'all': 'All', 'initialization': '\'Initialisierung\'', 'inmotion': 'In Bewegung' }, 'deviceNearbyDevices': { '500_feet': 'Innerhalb 150 Meter', '1_mile': 'Innerhalb 1,5 Km', '2_miles': 'Innerhalb 3 Km', '3_miles': 'Innerhalb 5 Km', '5_miles': 'Innerhalb 8 Km', '10_miles': 'Innerhalb 16 Km', '20_miles': 'Innerhalb 32 Km' }, 'digitalInputDetailReport': { 'input0': 'Eingang #0', 'input1': 'Eingang #1', 'input2': 'Eingang #2', 'input3': 'Eingang #3', 'input4': 'Eingang #4', 'input5': 'Eingang #5', 'input6': 'Eingang #6', 'input7': 'Eingang #7' } } }, 'group': 'Gruppe :', 'export': 'Export :', 'getReport': 'Bericht anfordern', 'emailInfo': 'Der Bericht wird an die folgenden, per Komma getrennten, Empfänger gesendet: ', 'exportEmailsendBtn': 'Senden', 'vehicle': 'Fahrzeug :', 'reportOption': 'Bericht Optionen', 'report': 'Bericht', 'reportExportSuccess': 'Bericht erfolgreich exportiert.', 'reportExportFailed': 'Bericht-Export fehlgeschlagen.', 'emailSendingFailed': 'Senden der E-Mail fehlgeschlagen.', 'emailSendSuccessfully': 'E-Mail erfolgreich versendet.' }, 'vehicleStatus': { 'moduleName': 'Fahrzeugstatus', 'order': 'Auftrag', 'operationSuccess': 'Erfolgreich gespeichert', 'dialog': { 'startTime': 'Startzeit', 'duration': 'Dauer / Min', 'save': 'Speichern', 'cancel': 'Abbrechen' }, 'button': { 'setvehicleState': 'Status Setzen', 'order': 'Auftrag', 'retour': 'Rückmenge', 'changePlant': 'Anderes Werk', 'pauseBegin': 'Pause Beginn', 'pauseEnd': 'Pause Ende', 'maintenanceBegin': 'Wartung Beginn', 'maintenanceEnd': 'Wartung Ende', 'login': 'Anmelden', 'logout': 'Abmelden' } }, 'digitalOutput': { 'output1': 'Digitaler Ausgang #1', 'output2': 'Digitaler Ausgang #2', 'output3': 'Digitaler Ausgang #3', 'output4': 'Digitaler Ausgang #4', 'timeout': 'Auszeit/s' }, 'telephonesList': { 'moduleName': 'Telefonnummern', 'button': { 'new': 'Neu', 'copy': 'Kopieren', 'edit': 'Bearbeiten' }, 'telephoneImport': { 'dialogTitle': 'Telefondatei importieren', 'successAlert': 'Datei erfolgreich importiert !', 'importBtn': 'Import' } }, 'telephoneNew': { 'new': 'Neu', 'copy': 'Kopieren', 'edit': 'Bearbeiten', 'save': 'Speichern', 'cancel': 'Abbrechen', 'saveNew': 'Speichern und Neu', 'firstName': 'Name', 'lastName': 'Familienname', 'fullName': 'vollständiger Name', 'telephone': 'Telefon' }, 'booksList': { 'moduleName': 'Telefonbücher', 'saveError': 'Telefonbuch konnte nicht gespeichert werden', 'saveSuccess': 'Telefonbuch erfolgreich gespeichert', 'allocationList': 'Kontakt Zuweisung' }, 'contactsList': { 'moduleName': 'Kontaktliste', 'importDiagTitle': 'Kontakt Datei-Import', 'importIntoBook': 'Kontake zu neuem Telefonbuch hinzufügen', 'importBookName': 'Telefonbuch Name:', 'importErrorBookDuplicate': 'Telefonbuch existiert bereits', 'importErrorBookBlank': 'Telefonbuch Name darf nicht leer sein', 'successAlert': 'Datei erfolgreich importiert.', 'importBtn': 'Import', 'saveSuccess': 'Kontakte erfolgreich gespeichert', 'saveError': 'Kontakt konnte nicht gespeichert werden.' }, 'contactNew': { 'new': 'Neu', 'copy': 'Kopieren', 'edit': 'Bearbeiten', 'view': 'Ansicht', 'save': 'Speichern', 'cancel': 'Abbrechen', 'saveNew': 'Speichern und Neu', 'firstName': 'Name', 'landline': 'Festnetz', 'mobile': 'Mobil', 'posUp': 'Herauf', 'posDown': 'Herunter', 'posSave': 'Reihenfolge speichern', 'posCancel': 'Stornieren' }, 'download': { 'title': 'Telefondaten herunterladen', 'vehicleGroup': 'Fahrzeuggruppe', 'vehicleName': 'Fahrzeug', 'selectAll': 'Auswählen alle', 'deselectAll': 'Abwählen alle', 'ok': 'Ok', 'cancel': 'Abbrechen', 'success': 'Herunterladen erfolgreich!' }, 'bookDownload': { 'title': 'Telefonbuch Download', 'vehicleGroup': 'Fahrzeuggruppe', 'vehicleName': 'Fahrzeug', 'bookName': 'Telefonbücher', 'selectAll': 'Auswählen alle', 'deselectAll': 'Abwählen alle', 'ok': 'OK', 'cancel': 'Abbrechen' }, 'deviceMessaging': { 'vehicle': 'Fahrzeug :', 'messageID': 'Nachricht-Id : ', 'sendBtn': 'Senden', 'radioText': 'Text', 'radioOk': 'Ok', 'radioYes-No': 'Ja/Nein', 'readAllNewMessages': 'Lese alle neuen Nachrichten', 'noMessages': 'Keine Nachrichten !', 'youGOt': 'Sie haben ', 'newMessages': ' neue Nachrichten !', 'newMessage': ' neue Nachricht !', 'newMessagesBetween': 'neue Nachrichten zwischen', 'sendMessage': 'Sende Nachricht', 'sending': 'Sende..', 'ok': 'OK', 'yes': 'Ja', 'no': 'Nein', 'characterLimitReached': 'Zeichenlimit (300) erreicht', 'drivers': 'Fahrer', 'groupChats': 'Gruppenchats', 'groupMembers': 'Gruppenmitglieder', 'membersCount': '{{count}} Mitglieder', 'members': 'Mitglieder' }, 'deviceCommands': { 'command': 'Befehl :', 'sendSuccess': 'Befehl erfolgreich eingeleitet' }, 'truckmixerList': { 'modelDialog': { 'vehicleState': 'Status', 'retour': 'Rückmenge', 'plant': 'Anderes Werk', 'pauseBegin': 'Pause Beginn', 'orderDate': 'Datum', 'vehicle': 'Fahrzeug :', 'currentStatus': 'Aktueller Status', 'newStatus': 'Neuer Status', 'concreteType': 'Sorte', 'currentPlant': 'Aktuelles Werk', 'newPlant': 'Neues Werk', 'time': 'Dauer [min]' } }, 'dateRangePicker': { 'locale': { 'applyLabel': 'Anwenden', 'cancelLabel': 'Abbrechen', 'clearLabel': 'Löschen', 'fromLabel': 'Von', 'toLabel': 'Bis', 'customRangeLabel': 'Benutzerdefiniert', 'weekLabel': 'W', 'daysOfWeek': { 'Sunday': 'So', 'Monday': 'Mo', 'Tuesday': 'Di', 'Wednesday': 'Mi', 'Thursday': 'Do', 'Friday': 'Fr', 'Saturday': 'Sa' }, 'monthNames': { 'January': 'Januar', 'February': 'Februar', 'March': 'März', 'April': 'April', 'May': 'Mai', 'June': 'Juni', 'July': 'Juli', 'August': 'August', 'September': 'September', 'October': 'Oktober', 'November': 'November', 'December': 'Dezember' } }, 'ranges': { 'Standard': 'Standard', 'Today': 'Heute', 'Yesterday': 'Gestern', 'Last_7_days': 'Letzte 7 Tage', 'Last_30_days': 'Letzte 30 Tage', 'This_month': 'Diesen Monat', 'Last_Month': 'Letzten Monat', 'Last_hour': 'Letzte Stunde', 'Last_2_hours': 'Letzte 2 Stunden', 'Last_4_hours': 'Letzte 4 Stunden', 'Last_8_hours': 'Letzte 8 Stunden', 'Last_24_hours': 'Letzte 24 Stunden', 'Last_2_days': 'Letzte 2 Tage' } }, 'additionalTranslation': { 'comboboxOptionALL': 'Alle', 'serverPath': 'Server Pfad : ' }, 'deleteConfirm': { 'delete_title': 'Jetzt Löschen ?', 'delete_button': 'Löschen', 'cancel_button': 'Abbrechen', 'delete_body': 'Wollen Sie den Datensatz löschen?' }, 'userRight': { 'notAuthorized': 'Keine Zugriffsrechte vorhanden', 'notAvailable': 'Keine Daten verfügbar' }, 'listView': { 'datePickerPopup': { 'currentText': 'Heute', 'clearText': 'Löschen', 'closeText': 'Fertig' }, 'common': { 'filters': {}, 'localization': { 'gotopagestring': 'Gehe zu:', 'showrowsstring': 'Zeige Zeile:', 'rangestring': ' von ', 'nextbuttonstring': 'voriger', 'previousbuttonstring': 'nächster', 'sortascendingstring': 'Sortiere aufsteigend', 'sortdescendingstring': 'Sortiere absteigend', 'sortremovestring': 'Sortierung entfernen', 'filterselectstring': 'Filter auswählen', 'filterselectallstring': '(Alle)', 'loadtext': 'Wird geladen...', 'validationstring': 'Der eingegebene Wert ist ungültig', 'emptydatastring': 'Keine Daten verfügbar' } }, 'cDayDriverWorkingHours': { 'headers': { 'workingTimeToday': 'Arbeitszeit heute', 'drivingTimeToday': 'Lenkzeit heute', 'breakTimeToday': 'Pausenzeit heute', 'standByTimeToday': 'Bereitschaftszeit heute' } }, 'fmsVehicle': { 'headerColumnfilters': { 'vehiclestatus': { 'Blue': 'Blau', 'Yellow': 'Gelb', 'Red': 'Rot' } } }, 'pendingCommands': { 'headers': { 'accountID': 'Account', 'deviceID': 'Geräte-ID', 'queueTime': 'Anstehend seid', 'commandType': 'Kommandotyp', 'commandID': 'Kommando-ID', 'sendState': 'Sende Zustand', 'commandArgs': 'Kommando Arg.', 'sendTime': 'Sendezeit', 'deleteAfter': 'Löschen Nach', 'ackTime': 'Ack Zeit', 'ackResponse': 'Ack Anzwort', 'lastUpdateTime': 'Letzte Änderung', 'creationTime': 'Angelegt am' } }, 'telephones': { 'headers': { 'name': 'Name', 'telephoneNumber': 'Telefon' } } }, 'dashBoard': { 'title': 'Fleet Management Dashboard', 'lastLocationDashboardTitle': 'Last Location Dashboard', 'driverDashboardTitle': 'Driver Dashboard', 'portalCommandsDashboardTitle': 'Portal Command', 'fmsDashboardTitle': 'FMS Dashboard', 'tachoHistoryDashboardTitle': 'Driver History', 'tachoDownloadStatusTitle': 'Download Status', 'fleetManagement': { 'title': 'Fleet Management Dashboard', 'news': { 'title': 'News', 'url': 'http://www.dsa.de/index.php?type=100&L=1' }, 'weather': { 'title': 'Wetter', 'location': 'Aachen' }, 'introduction': { 'title': 'Übersicht', 'description': '![betosys logo](assets/images/betosys.png)\n\n* Fleet management for concrete, mortar and pumps\n\n* Centralized and decentralized planning for one plant or several plants in a group' }, 'calendar': { 'title': 'Kalender', 'chooseCulture': 'Format', 'description': 'Kalender anzeigen ' }, 'vehicleList': { '404': 'Keine Daten vorhanden !', 'vehicleListTitle': 'Fahrzeugliste', 'description': 'Aktuelle Fahrzeuginformationen anzeigen', 'vehicleGroup': 'Fahrzeugruppe:', 'statusCode': 'Status:', 'nextRefreshIn': 'Aktualisierung in :', 'startAutoUpdate': 'AutoUpdate starten', 'stopAutoUpdate': 'AutoUpdate stoppen : ', 'vehicleGroupValidation': 'Bitte eine Fahrzeuggruppe angeben !', 'lastLocation': 'Letzte Position', 'noOfGridRows': 'Anzahl Listenzeilen :', 'frameHeight': 'Rahmenhöhe (Pixel) :', 'moreFunction': { 'command': 'Befehl', 'sendMsg': 'Nachricht senden', 'sendCommand': 'Befehl senden', 'showReports': 'Bericht anzeigen', 'showDashboard': 'Dashboard', 'showDriverDashboard': 'Fahrer Dashboard', 'showPortalCommand': 'Portal Befehle', 'showFmsDashboard': 'FMS Dashboard', 'copyLocationToClipboard': 'Koordinaten kopieren' }, 'ordersTab': { 'orders': 'Aufträge', 'showReport': 'Bericht anzeigen' }, 'vehicleDetailsTab': { 'vehicleDetails': 'Fahrzeugereignisse' }, 'cargoQualityTab': { 'cargoQuality': 'Qualitätsdaten Ladung' } }, 'vehicleDetails': { '404': 'Keine Daten vorhanden !', 'vehicleDetailsTitle': 'Fahrzeugdetails', 'description': 'Detaillierter Fahrzeugdatensatz (GPS, FMS, ...) anzeigen', 'dateRange': 'Datumsbereich :', 'name': 'Name', 'value': 'Wert' }, 'fleetMap': { '404': 'Keine Daten vorhanden !', 'fleetMapTitle': 'Flottenkarte', 'description': 'Flottenkarte anzeigen', 'showInfoBalloon': 'Fahrzeuginfo automatisch anzeigen' }, 'deviceMap': { '404': 'Keine Daten vorhanden !', 'deviceMapTitle': 'Fahrzeugkarte', 'description': 'Fahrzeugkarte anzeigen' }, 'driverWorkingHours': { 'driverWrkHoursList': 'Fahrerliste Tacho', 'description': 'Fahrer Arbeitszeiten anzeigen', 'workingHoursType': { 'totalWorkingTimeToday': 'Gesamt Arbeitszeit Heute', 'totalDrivingTimeToday': 'Gesamt Lenkzeit Heute', 'totalBreakTimeToday': 'Gesamt Pausenzeit Heute', 'totalStandByTimeToday': 'Gesamt Bereitschaftszeit Heute', 'workingTimeBetweenBreaks': 'Arbeitszeit zwischen den Pausen', 'drivingTimeBetweenBreaks': 'Lenkzeit zwischen den Pausen', 'currentBreakTime': 'Pausenzeit Aktuell', 'standByTimeBetweenBreaks': 'Bereitschaftszeit zwischen den Pausen', 'dailyBreakTime': 'tägliche Ruhezeiten' }, 'tachoDetailHistoryTabTitle': 'Tacho Historie' }, 'driverWhrkHrsSVG': { 'title': 'Fahrer Arbeitsstatus', 'description': 'Fahrer Arbeitsstatus anzeigen (Grafik)', 'remWrkHrsLabel': 'Restarbeitszeit', 'workingTimeLabel': 'Arbeitszeit (Max 10h 00m)', 'drivingTimeLabel10h': 'Lenkzeit (Max 10h 00m)', 'drivingTimeLabel9h': 'Lenkzeit (Max 09h 00m)', 'breakTimeLabel': 'Pausenzeit', 'standBytimeLabel': 'Bereitschaftszeit', 'workingBetweenBreakLabel': 'Arbeitszeit zw. Pausen (Max 06h 00m)', 'drivingBetweenBreakLabel': 'Lenkzeit zw. Pausen (Max 04h 30m)', 'workingTimeRemainingLabel': 'Arbeitszeit', 'drivingTimeRemainingLabel': 'Lenkzeit', 'workingBetweenBreakRemainingLabel': 'Arbeitszeit zwischen den Pausen', 'drivingBetweenBreakRemainingLabel': 'Lenkzeit zwischen den Pausen', 'totalTimeRadio': 'Gesamtzeit', 'remainingTimeRadio': 'Restzeit', 'hour': 'h', 'minute': 'm', 'details': 'Tageszeiten', 'daily': 'Tag', 'weekly': 'Woche', 'svgColumnHeader': 'SVG', 'nextPauseDurationLabel': 'Dauer nächste Pause', 'nextShiftStartsBeforeLabel': 'Nächster Arbeitsbeginn nicht vor', 'lastWeeklyRestTime': 'Letzte wöchentliche Ruhezeiten', 'weeklyDetails': { 'weeklyDetailsLabel': 'Wochenzeiten', 'workTimeTotalLabel': 'Arbeitszeit(Max 60h)', 'workTimeTotalAvg16weekLabel': 'Ø 16 Wochen', 'driveTimeTotalLabel': 'Lenkzeit (Max 56h 00m)', 'driveTimeTotal2WeekLabel': 'Doppelwochenlenkzeit(Max 90h 00m)', 'driveTimeTotalRemainingLabel': 'Lenkzeit', 'workTimeTotalRemainingLabel': 'Arbeitszeit', 'driveTimeTotal2WeekRemainingLabel': 'Doppelwochenlenkzeit' } }, 'driverDigitalTachoStatus': { 'driverDigitalTachoStatusTitle': 'Digitaler Tacho Status', 'description': 'Fahrer Tachozeiten anzeigen', 'driver': 'Fahrer', 'login': 'Beginn', 'logout': 'Ende', 'duration': 'Dauer', 'odoStart': 'Beginn KM', 'odoStop': 'Ende KM', 'breakMoreThan15Min': 'Pause > 15 min', 'breakAll': 'Pause Gesamt', 'availability': 'Bereit', 'work': 'Arbeit', 'driving': 'Fahrt', 'breakOrRest': 'Pause', 'time': 'Zeit', 'minutes': 'Minuten', 'type': 'Typ', 'count': 'Anzahl', 'currentStatus': 'Akt. Status', 'fmsNotAvailable': 'FMS-Zeit nicht verfügbar. Werte können abweichen.' }, 'temperatureDetail': { 'summary': { 'title': 'Übersicht', 'deviceInfo': 'Geräte-Info', 'vehicleInfo': 'Fahrzeug Info', 'odometer': 'Kilometerstand', 'vcgInfo': 'VCG Info', 'vehicleState': 'Letzter Fahrzeugstatus', 'currentJob': 'Aktueller Auftrag', 'maintenance': 'Wartung', 'vehiclevin': 'Fahrgestellnr.', 'firmwarevers': 'Firmware Version', 'vehicleexp': 'Vehicle Expiration', 'vehicleimei': 'IMEI/ESN Nummer', 'vehicleserial': 'Seriennummer', 'vehiclemake': 'Marke', 'vehiclemodel': 'Modell', 'vehiclesim': 'SIM', 'vehiclesimid': 'SIM-ID', 'vehicleplate': 'Kennzeichen', 'vehicletype': 'Fahrzeugtyp', 'nocurrentjob': 'Kein Auftrag in Bearbeitung', 'jobdate': 'Auftrags-Datum', 'jobno': 'Auftrags-Nr.', 'joblocation': 'Adresse', 'jobplannedtime': 'Geplante Fahrzeit', 'jobplannedcirctime': 'Geplante Umlaufzeit', 'conretetype': 'Sorte', 'jobref': 'Lieferschein', 'jobstatus': 'Status', 'jobqty': 'Menge', 'jobstarttime': 'Start-Zeit', 'jobdeparttime': 'Abfahrt Werk', 'jobarrivaltime': 'Ankunft Baustelle', 'jobdiscstarttime': 'Entladung Beginn', 'jobdiscstoptime': 'Entladung Ende', 'jobreturntime': 'Abfahrt Baustelle', 'jobremainingquantity': 'Restmenge', 'ignitionon': 'Letztes Zündung an', 'ignitionoff': 'Letztes Zündung aus', 'ignitionstate': 'Aktueller Zündungsstatus', 'laststarttime': 'Letzter Motorstart', 'laststoptime': 'Letzter Motorstop', 'lastmalflamp': 'Warnlampe', 'lasteventtime': 'Zeit des letzten Events', 'lasttachodown': 'Letzter manueller Tacho-Download', 'telltaleStatus': 'Kontrollleuchten Status', 'mainodometer0km': 'Kilometerstand #1 Wartung (km)', 'mainodometer1km': 'Kilometerstand #2 Wartung (km)', 'mainenginehrs': 'Wartungsintervall (Stunden)', 'operationhrs': 'Betriebsstunden', 'repodometer': 'Kilometerstand', 'enginehrs': 'Betriebsstunden (Motor)', 'mainnotes': 'Wartungs-Hinweise' }, 'input': { 'title': 'Eingänge' }, 'temperature': { 'title': 'Temperaturen' }, 'weight': { 'title': 'Gewicht', 'chartHeading': 'Fahrzeuggewicht Historie', 'xAxisHeader': 'Zeit', 'valueLabel1': 'Gesamtgewicht', 'valueLabel2': 'Achsgewicht' }, 'fuel': { 'title': 'Kraftstoff', 'chartHeading': 'Kraftstoff Historie', 'xAxisHeader': 'Zeit', 'valueLabel1': 'Verbrauch Insgesamt', 'valueLabel2': 'Verbrauch seit Motorstart', 'valueLabel3': 'Geschwindigkeit', 'valueLabel4': 'Tankfüllstand', 'trip': 'Reisekraftstoff verwendet' }, 'consistency': { 'title': 'Konsistenz', 'chartHeading': 'Konsistenzverlauf', 'xAxisHeader': 'Zeit', 'valueLabel1': 'Hydrauliköldruck (mV)', 'valueLabel2': 'Trommeldrehzahl', 'valueLabel3': 'Motordrehzahl', 'valueLabel4': 'Umgebungstemperatur', 'consistencyAutoRefreshLabel': 'Auto-Aktualisierung ', 'valueLabel5': 'Hydrauliköldruck (bar)', 'valueLabel6': 'Wasserdurchfluss (mV)', 'valueLabel7': 'Wasserdurchfluss (L/min)', 'consistencyChartWaterAccodionLabel': 'Wasserdurchfluss', 'valueLabel8': 'Hydrauliköltemperatur', 'millivolt': 'Millivolt' } }, 'tempMonitoringWidget': { 'doorStatusChartTitle': 'Historie Dig. Eingang', 'temperatureHistoryTitle': 'Historie Temperatur', 'fuelHistoryTitle': 'Historie Kraftstoff', 'weightHistoryTitle': 'Historie Gewicht', 'doorStatusChartY': 'Dig. Eingang an/aus', 'maxHours': 'Max Stunden', 'max': 'Max', 'min': 'Min', 'IsOdd': 'Bitte geradzahligen Wert eingeben !', 'temperatureUnit': 'Temperatur Einheit', 'temperatureHistoryYAxis': 'Temperaturen', 'title': 'Fahrzeug Details', 'description': 'Zeigt Fahrzeug-Details an', 'thermo1': 'Temp#1', 'thermo2': 'Temp#2', 'thermo3': 'Temp#3', 'thermo4': 'Temp#4', 'thermo5': 'Temp#5', 'thermo6': 'Temp#6', 'thermo7': 'Temp#7', 'thermo8': 'Temp#8', 'doorStatusYMinValue': 'Eingang Aus', 'doorStatusYMaxValue': 'Eingang An', 'time': 'Zeit', 'din1': 'Eingang #1', 'doorOpen': 'An', 'doorClose': 'Aus', 'open': 'An', 'closed': 'Aus' }, 'vehiclesListWidget': { 'title': 'Fahrzeugliste Befehle', 'description': 'Fahrzeugliste für Portal-Befehle anzeigen' }, 'vehicleStatusWidget': { 'title': 'Fahrzeugstatus Setzen', 'description': 'Fahrzeugstatus über Portal-Befehl setzen' }, 'digitalOutputsWidget': { 'title': 'Digitale Ausgänge', 'description': 'Digitale Ausgänge des Fahrzeugs setzen' }, 'pendingCommandsWidget': { 'title': 'Ausstehende Portal-Befehle', 'description': 'Kommandos ans Fahrzeug absetzen/anzeigen' }, 'fmsVehicle': { 'vehicleList': 'Fahrzeugliste FMS', 'description': 'Detaillierte Fahrzeugdaten anzeigen', 'vehicleAllDetailsTab': { 'vehicleAllDetails': 'Fahrzeugereignisse Gesamt' }, 'vehicleTellTalesTab': { 'vehicleTellTales': 'Kontrollleuchten' } }, 'tachoEventDetail': { 'tachoEventDetailTitle': 'Zeiterfassungs-Ereignisse', 'description': 'Tachoereignisse und Zeitstrahl', 'tachoGraphicsListTabTitle': 'Tacho-Ereignisse', 'tachoDetaiGrpahicTabTitle': 'Zeitstrahl', 'tachoStampingTimesTitle': 'Stempelzeiten', 'graphicsTab': { 'breakLabel': 'Pause', 'wrokLabel': 'Arbeit', 'avialableLabel': 'Bereit', 'driveLabel': 'Fahrt', 'pasueLabel': 'Pause' } }, 'tachoHistory': { 'ttachoHistoryTitle': 'Tacho Historie', 'description': 'Tacho Historie' }, 'tachoDownloadStatus': { 'title': 'Download Status', 'description': 'Zeigt den Status von Tacho- und Fahrerkarten-Downloads' } } }, 'errorCodes': { 'timeout': 'Timeout beim Laden der Daten', 'restAPI': { '52000': { 'message': 'Applikationsprofil löschen ?', 'format': '1', 'type': 'W' }, '52001': { 'message': 'Möchten Sie das Applikationsprofil wiederherstellen?', 'format': '1', 'type': 'W' }, '52002': { 'message': 'Fehler beim Speichern des Applikationsprofil !', 'format': '0', 'type': 'E' }, '52003': { 'message': 'Fehler beim Wiederherstellen des Applikationsprofil !', 'format': '0', 'type': 'E' }, '52050': { 'message': 'Fehler beim Einlesen der Datei', 'format': '0', 'type': 'E' }, '52051': { 'message': 'Datei nicht im Format - \'Telefonnummer;Name\'', 'format': '0', 'type': 'E' }, '52052': { 'message': 'Befehl für dieses Gerät steht noch aus', 'format': '0', 'type': 'E' }, '52053': { 'message': 'Befehl konnte nicht ausgelöst werden', 'format': '0', 'type': 'E' }, '52504': { 'message': 'Request Timed Out !', 'format': '0', 'type': 'M' } }, 'track': { '57000': { 'message': 'Koordinaten kopiert !', 'format': '0', 'type': 'M' } } } },

  en: { 'modal': { 'customer': 'Customers', 'buildingSite': 'BuildingSites' }, 'nav': { 'productName': 'BetoSys', 'productLogoText': { 'fbr': 'BetoTrack', 'lgs': 'BetoTrack-LGS' }, 'productLogoShortText': { 'fbr': 'BS', 'lgs': 'LGS' }, 'language': { 'en': 'English', 'de': 'Deutsch', 'nl': 'Nederlandse' }, 'user': { 'settings': 'Settings', 'changePassword': 'Change Password', 'logout': 'Logout', 'appProfile': 'App Profile', 'clearLocalStorage': 'Clear Local Storage', 'restoreLocalStorage': 'Restore Local Storage', 'saveLocalStorage': 'Save Local Storage' }, 'menuOptions': { 'dashboard': 'Dashboard', 'portalCommand': 'Portal Command', 'driverDashboard': 'Driver Dashboard', 'maps': 'Maps', 'map': 'Map', 'reports': 'Reports', 'telephone': 'Telephone', 'mapsSubMenu': { 'lastLocation': 'Last Location', 'vehicleMap': 'Vehicle Map', 'groupMap': 'Group Map', 'sosEmergencyMap': 'SOS/ Emergency Map', 'freeDeviceMap': 'Free Devices Map', 'busyDeviceMap': 'Busy Devices Map' }, 'reportsSubMenu': { 'vehicleDetails': 'Vehicle Details', 'groupDetails': 'Group Detail', 'groupSummary': 'Group Summary', 'performance': 'Performance' } } }, 'sidebar': { 'betotrack': { 'dashboard': 'Dashboard', 'map': 'Map', 'driver': 'Driver Dashboard', 'driverDashbordMenu': 'Driver Dashboard', 'tachoHistoryDashboardMenu': 'Driver History', 'portalcommand': 'Portal Command', 'fms': 'FMS Dashboard', 'tachoDashboardMenu': 'Tacho Dashboard', 'tachoDownloadStatusDashboardMenu': 'Download Status', 'mapitems': { 'lastlocation': 'Last Location', 'vehiclemap': 'Vehicle', 'groupmap': 'Vehicle Group', 'sosmap': 'SOS/Emergency', 'alert': 'Alert', 'freedevicesmap': 'Free Vehicles', 'busydevicesmap': 'Busy Vehicles' }, 'reports': 'Reports', 'reportitems': { 'vehicledetail': 'Vehicle Details', 'groupdetail': 'Group Detail', 'groupsummary': 'Group Summary', 'performance': 'Performance' }, 'admin': 'Admin', 'adminitems': { 'contactmgmt': 'Contact Management', 'bookmgmt': 'Book Management' }, 'telephone': 'Telephone' } }, 'foot': { 'application': 'Application', 'database': 'Database', 'gtse': 'GTSE', 'dataprivacy': 'Data Privacy', 'imprint': 'Imprint' }, 'login': { 'placeHolder': { 'Account': 'Account ID', 'username': 'User Name', 'password': 'Password', 'email': 'E-Mail', 'forgotPassword': 'Forgot Password' }, 'error': { 'timeout': 'Server Timeout', 'unauthorized': 'User unauthorized!' }, 'tittle': { 'fbr': 'BetoTrack Login', 'lgs': 'BetoTrack-LGS Login' } }, 'passwordChange': { 'placeHolder': { 'oldPassword': 'Old Password', 'newPassword': 'New Password', 'confirmPassword': 'Confirm Password' }, 'success': 'Password has been changed successfully', 'successForgotPassword': 'New password was send by mail', 'mismatch': 'Password mismatch', 'accountmismatch': 'Account mismatch', 'oldpasswordwrong': 'Current password is wrong', 'requiredField': 'Please fill the required fields', 'save': 'Save', 'close': 'Close', 'submit': 'Submit' }, 'forgotPassword': { 'title': 'To have your password sent to you, please enter your Login information and Contact Email Address (must match email address on file)' }, 'home': { 'welcome': 'Welcome to BetoSys', 'modules': { 'vis': { 'name': 'BetoVIS', 'desc': 'Marketing and sales' }, 'plan': { 'name': 'BetonPlan', 'desc': 'Planning and scheduling' }, 'fakt': { 'name': 'BetoFakt', 'desc': 'Billing' }, 'track': { 'name': 'BetoTrack', 'desc': 'Fleet Management' } } }, 'print': { 'printing': 'Printing', 'print': 'Print', 'exportXml': 'Export to XML', 'exportExcel': 'Export to Excel' }, 'moreFunction': { '5003': 'Data has already been deleted', 'button': { 'function': 'More Functions' }, 'functionList': { 'delete': 'Delete', 'download': 'Download', 'productionProtocol': 'Show production protocol', 'sendAgainDeliveryNote': 'GSM-Funk-Wiederholung', 'fileImport': 'File Import', 'contactPosition': 'Show Positioning Options' } }, 'filter': { 'default': 'Default', 'clearFilter': 'Clear Filter', 'resize': 'Resize', 'settings': 'Settings', 'showDate': 'Show Date Filter', 'hideDate': 'Hide Date Filter' }, 'contextMenu': { 'customer': {}, 'buildingSite': {}, 'plant': {} }, 'settings': { 'name': 'User Name ', 'userSetting': 'User Setting', 'gridPreference': { 'setting': 'Grid Setting', 'reset': 'Restore Defaults', 'grid': 'Grid: ', 'backgroundColor': 'Background color:', 'showingColumns': 'Showing columns: ', 'pinnedColumn': 'No. of frozen Columns' }, 'generalAccordion': { 'title': 'General', 'countryId': 'Country', 'company': 'Company' }, 'planAccordion': { 'title': 'BetoTrack', 'workstation': 'Workstation' } }, 'serverMessage': { '5001': 'Data record has been update from <{{AENDUSER}}> at {{AENDDATE}}', '5002': 'Id - {{id}} already exsits !', '5004': 'Data with id <[{{number}}]> has already been inserted from <[{{AENDUSER}}]>', 'login': { 'badCredential': 'User name or password you entered is incorrect.', 'GTSE_503': 'Service not available (GTSE)!', 'AU0010': 'Authorization failed', 'US0020': 'User inactive', 'US0030': 'User expired' }, 'updatePassword': { '6003': 'Update Failed' }, 'internalServerError': 'Internal Server Error' }, 'confirmOnExit': { 'title': 'Discard Changes?', 'content': 'The record has not been saved, do you want to discard the changes?', 'exit': 'Yes', 'cancel': 'No' }, 'responseErrorDilaog': { 'ok': 'Ok', 'cancel': 'Cancel', 'yes': 'Yes', 'no': 'No' }, 'button': { 'cancel': 'Cancel', 'save': 'Save' }, 'form': { 'save': { 'success': 'Saved Successfully!' }, 'requiredFiled': 'Please input all required fields!' }, 'error': { 'unAuthorizedMessage': 'Access Restricted!' }, 'betoTrackMapping': { 'free': 'Free Vehicles', 'busy': 'Busy Vehicle', 'group': 'Vehicle Group', 'vehicle': 'Vehicle', 'lastlocation': 'Last Location', 'sos': 'SOS/Emergency', 'alert': 'Alert' }, 'trackReporting': { 'performance': 'Performance', 'performanceReport': { 'eventSpeedOption': 'Speeds over', 'eventExcessSpeed': 'Vehicle Excess Speed', 'driverReport': 'Driver Report', 'driverExpiringLicense': 'Expiring Driver License Report', 'driverWorkingHours': 'Driver Working Hours', 'customExport': 'Export DATEV', 'customExportDialog': { 'title': 'Driver Working Hours / DATEV', 'driver': 'Driver', 'export': 'Export', 'cancel': 'Cancel', 'exportSuccess': 'Report Exported successfully ! ' }, 'reportComboboxOptions': { 'eventSpeedOption': { '45mph': '45 mph', '50mph': '50 mph', '55mph': '55 mph', '60mph': '60 mph', '65mph': '65 mph', '70mph': '70 mph', '75mph': '75 mph' }, 'driverExpiringLicense': { 'expired': 'Expired Now', '1week': 'Within 1 Week', '2weeks': 'Within 2 Weeks', '1month': 'Within 1 Month', '6months': 'WWithin 6 Months' } } }, 'groupSummary': 'Group Summary', 'groupsummaryReport': { 'monthlyVehicleFuelUse': 'Monthly Vehicle Fuel Use', 'eventSummary': 'Last Known Vehicle Location', 'firstEventSummary': 'First Event Vehicle Location', 'excessiveLastCheckIn': 'Excessive Last Check-in', 'deviceLastCheckIn': 'Device Last Check-In Report', 'deviceNeverCheckIn': 'Device Never Check-In Report', 'eventCount': 'Received Event Counts', 'eventSessionStatus': 'Session Connection Status', 'periodicServiceOdom': 'Odometer Periodic Service Report', 'periodicServiceHours': 'Engine Hours Periodic Service Report', 'distanceTraveled': 'Distance Traveled Report', 'ignitionSummaryReport': 'Ignition Summary Report', 'digitalInputSummaryReport': 'digital Input Summary Report', 'fleetMotion': 'Driving Time Fleet Summary', 'fleetIdle': 'Fleet Idle Time Summary', 'fuelSummaryReport': 'Fuel Summary Report', 'statusSummaryCount': 'Status Summary Count', 'userLogin': 'User Login Report', 'geozoneNearbyDevices': 'Vehicles Near Geozone', 'geozoneHotspotReport': 'Geozone Hotspot Report', 'reportComboboxOptions': { 'eventSummary': { 'all': 'All Events', 'free': 'Free Vehicles', 'busy': 'Busy Vehicles', 'login': 'Logged in Vehicles', 'logout': 'Logged out Vehicles', 'pause': 'Driver in pause', 'service': 'Vehicles in Service' }, 'firstEventSummary': { 'all': 'Ignition On', 'motion': 'Moving' }, 'excessiveLastCheckIn': { '1day': 'More than 1 day', '2days': 'More than 2 days', '3days': 'More than 3 days', '7days': 'More than 7 days', '30days': 'More than 30 days', '100days': 'More than 100 days' }, 'eventCount': { 'all': 'All', 'initialization': '\'Initialization\'', 'inmotion': '\'In-Motion\'' }, 'digitalInputSummaryReport': { 'input0': 'Input #0', 'input1': 'Input #1', 'input2': 'Input #2', 'input3': 'Input #3', 'input4': 'Input #4', 'input5': 'Input #5', 'input6': 'Input #6', 'input7': 'Input #7' }, 'fleetMotion': { 'ignition': 'Based on Ignition On/Off Status Codes', 'engine': 'Based on Engine Start/Stop Status Codes', 'motion0': 'Based on 0 Minute Minimum Stop', 'motion5': 'Based on 5 Minute Minimum Stop', 'motion10': 'Based on 10 Minute Minimum Stop', 'motion20': 'Based on 20 Minute Minimum Stop', 'motion30': 'Based on 30 Minute Minimum Stop' }, 'fleetIdle': { 'ignition': 'Based on Ignition On/Off Status Codes', 'engine': 'Based on Engine Start/Stop Status Codes', 'motion0': 'Based on 0 Minute Minimum Stop', 'motion5': 'Based on 5 Minute Minimum Stop', 'motion10': 'Based on 10 Minute Minimum Stop', 'motion20': 'Based on 20 Minute Minimum Stop', 'motion30': 'Based on 30 Minute Minimum Stop' } }, 'reportedRefuel': 'Refuel Report per Day', 'refuelMileage': 'Refuel Protocol CarPC' }, 'groupDetail': 'Group Detail', 'groupDetailReport': { 'eventDetail_Group': 'Event Detail', 'eventDetailOBDLight_Group': 'Event OBD Detail', 'tripReport_Group': 'Trip Report Detail', 'motionSummary_Group': 'Driving/Stopped Time Summary', 'geozoneReport_Group': 'Geozone Report', 'geozoneDriving_Group': 'Geozone Arrival Report', 'eventSpeedOption_Group': 'Speeds over', 'eventExcessSpeed_Group': 'Vehicle Excess Speed', 'eventSpeedPosted_Group': 'Exceeding Posted Speed', 'eventIdle_Group': 'Idle', 'eventExcessiveIdle_Group': 'Excessive Idle', 'digitalInputDetailReport_Group': 'Digital Input Detail Report', 'notifyQueueDetail_Group': 'Vehicle Alert Detail', 'reportComboboxOptions': { 'tripReport': { 'ignition': 'Based on Ignition On/Off Status Codes', 'engine': 'Based on Engine Start/Stop Status Codes', 'workorder': 'Based on Job Start/Job Back Status Codes', 'loginlogout': 'Based on Login/Logout Status Codes', 'motion0': 'Based on 0 Minute Minimum Stop', 'motion5': 'Based on 5 Minute Minimum Stop', 'motion10': 'Based on 10 Minute Minimum Stop', 'motion20': 'Based on 20 Minute Minimum Stop', 'motion30': 'Based on 30 Minute Minimum Stop' }, 'motionSummary': { 'ignition': 'Based on Ignition On/Off Status Codes', 'engine': 'Based on Engine Start/Stop Status Codes', 'motion0': 'Based on 0 Minute Minimum Stop', 'motion5': 'Based on 5 Minute Minimum Stop', 'motion10': 'Based on 10 Minute Minimum Stop', 'motion20': 'Based on 20 Minute Minimum Stop', 'motion30': 'Based on 30 Minute Minimum Stop' }, 'eventSpeedOption': { '45mph': '30 kph', '50mph': '50 kph', '55mph': '60 kph', '60mph': '70 kph', '65mph': '90 kph', '70mph': '100 kph', '75mph': '120 kph' }, 'eventSpeedPosted': { 'default': 'over limit', '5mph': '8kph over limit', '10mph': '16kph over limit' }, 'digitalInputDetailReport': { 'input0': 'Input #0', 'input1': 'Input #1', 'input2': 'Input #2', 'input3': 'Input #3', 'input4': 'Input #4', 'input5': 'Input #5', 'input6': 'Input #6', 'input7': 'Input #7' } } }, 'vehicleDetail': 'Vehicle Detail', 'vehicleDetailReport': { 'fuelTracker': 'Fuel Tracker Report', 'eventDetail': 'Event Detail', 'tripReport': 'Trip Report Detail', 'motionSummary': 'Driving/Stopped Time Summary', 'deviceWorkOrders': 'Work Order Report', 'geozoneReport': 'Geozone Gas Station', 'geozoneDriving': 'Geozone Arrival', 'jobReport': 'Geozone Job', 'ignitionDetailReport': 'Ignition Detail Report', 'digitalInputDetailReport': 'Digital Input Detail Report', 'eventCountByDay': 'Received Event Counts by Day', 'eventIdle': 'Idle', 'eventExcessiveIdle': 'Excessive Idle', 'driverMessageDetail': 'Driver Message Detail', 'eventDetailOBDLight': 'OBD Light Truck Event Detail', 'eventDetailAll': 'Event Detail (All fields)', 'eventRuleSpeeding': 'Event Detail Speeding Events', 'fuelRegisterDetail': 'Fuel Register Detail', 'dailyDistanceDetail': 'Daily Distance Driven', 'deviceNearbyDevices': 'Vehicles Near Vehicle', 'eventDetailCargoQuality': 'Event Detail Cargo Quality', 'notifyQueueDetail': 'Vehicle Alert Detail', 'fuelTrackerReport': 'Fuel Tracker Report', 'reportComboboxOptions': { 'tripReport': { 'ignition': 'Based on Ignition On/Off Status Codes', 'engine': 'Based on Engine Start/Stop Status Codes', 'workorder': 'Based on Job Start/Job Back Status Codes', 'loginlogout': 'Based on Login/Logout Status Codes', 'motion0': 'Based on 0 Minute Minimum Stop', 'motion5': 'Based on 5 Minute Minimum Stop', 'motion10': 'Based on 10 Minute Minimum Stop', 'motion20': 'Based on 20 Minute Minimum Stop', 'motion30': 'Based on 30 Minute Minimum Stop' }, 'motionSummary': { 'ignition': 'Based on Ignition On/Off Status Codes', 'engine': 'Based on Engine Start/Stop Status Codes', 'motion0': 'Based on 0 Minute Minimum Stop', 'motion5': 'Based on 5 Minute Minimum Stop', 'motion10': 'Based on 10 Minute Minimum Stop', 'motion20': 'Based on 20 Minute Minimum Stop', 'motion30': 'Based on 30 Minute Minimum Stop' }, 'eventCountByDay': { 'all': 'All', 'initialization': '\'Initialization\'', 'inmotion': '\'In-Motion\'' }, 'deviceNearbyDevices': { '500_feet': 'Within 150 Meters', '1_mile': 'Within 1,5 Km', '2_miles': 'Within 3 Km', '3_miles': 'Within 5 Km', '5_miles': 'Within 8 Km', '10_miles': 'Within 16 Km', '20_miles': 'Within 32 Km' }, 'digitalInputDetailReport': { 'input0': 'Input #0', 'input1': 'Input #1', 'input2': 'Input #2', 'input3': 'Input #3', 'input4': 'Input #4', 'input5': 'Input #5', 'input6': 'Input #6', 'input7': 'Input #7' } } }, 'group': 'Group :', 'export': 'Export :', 'getReport': 'Get Report', 'emailInfo': 'Report will be emailed to the following list of comma-separated email address(es): ', 'exportEmailsendBtn': 'Send', 'vehicle': 'Vehicle :', 'reportOption': 'Report Options', 'report': 'Report', 'reportExportSuccess': 'Report Exported successfully! ', 'reportExportFailed': 'Report Export Failed! ', 'emailSendingFailed': 'Email Sending Failed! ', 'emailSendSuccessfully': 'Email Send successfully! ' }, 'vehicleStatus': { 'moduleName': 'Vehicle Status', 'order': 'Order', 'operationSuccess': 'Operation Success!', 'dialog': { 'startTime': 'Start Time', 'duration': 'Duration / Min', 'save': 'Save', 'cancel': 'Cancel' }, 'button': { 'setvehicleState': 'Vehicle State', 'order': 'Order', 'retour': 'Retour', 'changePlant': 'Change Plant', 'pauseBegin': 'Pause Begin', 'pauseEnd': 'Pause End', 'maintenanceBegin': 'Maintenance Begin', 'maintenanceEnd': 'Maintenance End', 'login': 'Login', 'logout': 'Logout' } }, 'digitalOutput': { 'output1': 'Digital Output #1', 'output2': 'Digital Output #2', 'output3': 'Digital Output #3', 'output4': 'Digital Output #4', 'timeout': 'Timeout/s' }, 'telephonesList': { 'moduleName': 'Telephone Index', 'button': { 'new': 'New', 'copy': 'Copy', 'edit': 'Edit' }, 'telephoneImport': { 'dialogTitle': 'Telephone file import', 'successAlert': 'File Imported successfully !', 'importBtn': 'Import' } }, 'telephoneNew': { 'new': 'New', 'copy': 'Copy', 'edit': 'Edit', 'save': 'Save', 'cancel': 'Cancel', 'saveNew': 'Save and New', 'firstName': 'Name', 'lastName': 'Last Name', 'fullName': 'Full Name', 'telephone': 'Telephone' }, 'contactsList': { 'moduleName': 'Contacts Index', 'importDiagTitle': 'Contact file import', 'importIntoBook': 'Import Contacts into new book', 'importBookName': 'Book Name :', 'importErrorBookDuplicate': 'Book Display Name already exists', 'importErrorBookBlank': 'Book Name can not be blank', 'successAlert': 'File Imported successfully !', 'importBtn': 'Import', 'saveSuccess': 'Contact successfully saved', 'saveError': 'Unable to save Contact' }, 'booksList': { 'moduleName': 'Contact Book List', 'saveError': 'Unable to save Book', 'saveSuccess': 'Book successfully saved', 'allocationList': 'Contact Allocations' }, 'contactNew': { 'new': 'New', 'copy': 'Copy', 'edit': 'Edit', 'view': 'View', 'save': 'Save', 'cancel': 'Cancel', 'saveNew': 'Save and New', 'firstName': 'Display Name', 'landline': 'Landline', 'mobile': 'Mobile', 'posUp': 'Move Up', 'posDown': 'Move Down', 'posSave': 'Save Positioning', 'posCancel': 'Cancel' }, 'download': { 'title': 'Telephone Index Download', 'vehicleGroup': 'Vehicle Group', 'vehicleName': 'Vehicle', 'selectAll': 'Select All', 'deselectAll': 'Deselect All', 'ok': 'OK', 'cancel': 'Cancel', 'success': 'Download successful!' }, 'bookDownload': { 'title': 'Book List Download', 'vehicleGroup': 'Vehicle Group', 'vehicleName': 'Vehicle', 'bookName': 'Book List', 'selectAll': 'Select All', 'deselectAll': 'Deselect All', 'ok': 'OK', 'cancel': 'Cancel' }, 'deviceMessaging': { 'vehicle': 'Vehicle :', 'messageID': 'Message Id : ', 'sendBtn': 'Send', 'radioText': 'Text', 'radioOk': 'Ok', 'radioYes-No': 'Yes/No', 'readAllNewMessages': 'Read All New Messages', 'noMessages': 'No messages !', 'youGOt': 'You got ', 'newMessages': ' new messages !', 'newMessage': ' new message !', 'newMessagesBetween': 'new messages between', 'sendMessage': 'Send Message', 'sending': '\'sending..', 'ok': 'OK', 'yes': 'Yes', 'no': 'No', 'characterLimitReached': 'Character limit (300) reached', 'drivers': 'Drivers', 'groupChats': 'Group Chats', 'groupMembers': 'Group Members', 'membersCount': '{{count}} Members', 'members': 'Members' }, 'deviceCommands': { 'command': 'Command :', 'sendSuccess': 'Command triggered successfully' }, 'truckmixerList': { 'modelDialog': { 'vehicleState': 'Status', 'retour': 'Return Qty', 'plant': 'Change Plant', 'pauseBegin': 'Pause Begin', 'orderDate': 'Date', 'vehicle': 'Vehicle :', 'currentStatus': 'Current Status', 'newStatus': 'New Status', 'concreteType': 'Concrete', 'currentPlant': 'Current Plant', 'newPlant': 'New Plant', 'time': 'Duration [min]' } }, 'dateRangePicker': { 'locale': { 'applyLabel': 'Apply', 'cancelLabel': 'Cancel', 'clearLabel': 'Clear', 'fromLabel': 'From', 'toLabel': 'To', 'customRangeLabel': 'Custom', 'weekLabel': 'W', 'daysOfWeek': { 'Sunday': 'Su', 'Monday': 'Mo', 'Tuesday': 'Tu', 'Wednesday': 'We', 'Thursday': 'Th', 'Friday': 'Fr', 'Saturday': 'Sa' }, 'monthNames': { 'January': 'January', 'February': 'February', 'March': 'March', 'April': 'April', 'May': 'May', 'June': 'June', 'July': 'July', 'August': 'August', 'September': 'September', 'October': 'October', 'November': 'November', 'December': 'December' } }, 'ranges': { 'Standard': 'Standard', 'Today': 'Today', 'Yesterday': 'Yesterday', 'Last_7_days': 'Last 7 days', 'Last_30_days': 'Last 30 days', 'This_month': 'This month', 'Last_Month': 'Last Month', 'Last_hour': 'Last hour', 'Last_2_hours': 'Last 2 hours', 'Last_4_hours': 'Last 4 hours', 'Last_8_hours': 'Last 8 hours', 'Last_24_hours': 'Last 24 hours', 'Last_2_days': 'Last 2 days' } }, 'additionalTranslation': { 'comboboxOptionALL': 'All', 'serverPath': 'Server Path :' }, 'deleteConfirm': { 'delete_title': 'Delete Now?', 'delete_button': 'Delete', 'cancel_button': 'Cancel', 'delete_body': 'Do you want to delete the record?' }, 'userRight': { 'notAuthorized': 'Report not authorized', 'notAvailable': 'Data not available' }, 'listView': { 'datePickerPopup': { 'currentText': 'Today', 'clearText': 'Clear', 'closeText': 'Done' }, 'common': { 'filters': {}, 'localization': { 'gotopagestring': 'Go to page:', 'showrowsstring': 'Show rows:', 'rangestring': ' of ', 'nextbuttonstring': 'next', 'previousbuttonstring': 'previous', 'sortascendingstring': 'Sort Ascending', 'sortdescendingstring': 'Sort Descending', 'sortremovestring': 'Remove Sort', 'filterselectstring': 'Select Filter', 'filterselectallstring': '(Select All)', 'loadtext': 'Loading...', 'validationstring': 'Entered value is not valid', 'emptydatastring': 'No data to display' } }, 'cDayDriverWorkingHours': { 'headers': { 'workingTimeToday': 'Working time today', 'drivingTimeToday': 'Driving time today', 'breakTimeToday': 'Break time today', 'standByTimeToday': 'Standby time today' } }, 'fmsVehicle': { 'headerColumnfilters': { 'vehiclestatus': { 'Blue': 'Blue', 'Yellow': 'Yellow', 'Red': 'Red' } } }, 'pendingCommands': { 'headers': { 'accountID': 'Account ID', 'deviceID': 'Device ID', 'queueTime': 'Queue Time', 'commandType': 'Command Type', 'commandID': 'Command ID', 'sendState': 'Send State', 'commandArgs': 'Command Args', 'sendTime': 'Send Time', 'deleteAfter': 'Delete After', 'ackTime': 'Ack Time', 'ackResponse': 'Ack Response', 'lastUpdateTime': 'Last Update Time', 'creationTime': 'Creation Time' } }, 'telephones': { 'headers': { 'name': 'Name', 'telephoneNumber': 'Telephone' } } }, 'dashBoard': { 'title': 'Fleet Management Dashboard', 'lastLocationDashboardTitle': 'Fleet Management Dashboard', 'driverDashboardTitle': 'Driver Dashboard', 'portalCommandsDashboardTitle': 'Portal Command', 'fmsDashboardTitle': 'FMS Dashboard', 'tachoHistoryDashboardTitle': 'Tacho History', 'tachoDownloadStatusTitle': 'Download Status', 'fleetManagement': { 'title': 'Fleet Management Dashboard', 'news': { 'title': 'News', 'url': 'http://www.dsa.de/index.php?type=100&L=1' }, 'weather': { 'title': 'Weather', 'location': 'Aachen' }, 'introduction': { 'title': 'Introduction', 'description': '![betosys logo](assets/images/betosys.png)\n\n* Fleet management for concrete, mortar and pumps\n\n* Centralized and decentralized planning for one plant or several plants in a group' }, 'calendar': { 'title': 'Calendar', 'chooseCulture': 'Choose Culture', 'description': 'Kalender anzeigen ' }, 'vehicleList': { '404': 'Data not available !', 'vehicleListTitle': 'Vehicle List', 'description': 'Displays Last Vehicle Locations', 'vehicleGroup': 'Vehicle Group:', 'statusCode': 'Status Code:', 'nextRefreshIn': 'Next refresh in :', 'startAutoUpdate': 'start auto update', 'stopAutoUpdate': 'stop auto update : ', 'vehicleGroupValidation': 'please select a vehicle group !', 'lastLocation': 'Vehicle List', 'noOfGridRows': 'No of Grid Rows :', 'frameHeight': 'Frame Height :', 'moreFunction': { 'command': 'Command', 'sendMsg': 'Send Message', 'sendCommand': 'Send Command', 'showReports': 'Reports', 'showDashboard': 'Dashboard', 'showDriverDashboard': 'Driver Dashboard', 'showPortalCommand': 'Portal Command', 'showFmsDashboard': 'FMS Dashboard', 'copyLocationToClipboard': 'Copy Location' }, 'ordersTab': { 'orders': 'Orders', 'showReport': 'Show Report' }, 'vehicleDetailsTab': { 'vehicleDetails': 'Vehicle Details' }, 'cargoQualityTab': { 'cargoQuality': 'Cargo Quality' } }, 'vehicleDetails': { '404': 'Data not available !', 'vehicleDetailsTitle': 'Vehicle Event Data', 'description': 'Displays Last Vehicle Event Data', 'dateRange': 'Date range :', 'name': 'Name', 'value': 'Value' }, 'fleetMap': { '404': 'Data not available !', 'fleetMapTitle': 'Fleet Map', 'description': 'Displays Fleet Map', 'showInfoBalloon': 'Display info-balloon on vehicle selection' }, 'deviceMap': { '404': 'Data not available !', 'deviceMapTitle': 'Vehicle Map', 'description': 'Displays Vehicle Map' }, 'driverWorkingHours': { 'driverWrkHoursList': 'Driver List Digital Tacho', 'description': 'Displays Driver Hours Of Service Details', 'workingHoursType': { 'totalWorkingTimeToday': 'Total working time today', 'totalDrivingTimeToday': 'Total driving time today', 'totalBreakTimeToday': 'Total break time today', 'totalStandByTimeToday': 'Total standby time today', 'workingTimeBetweenBreaks': 'Working time between breaks', 'drivingTimeBetweenBreaks': 'Driving time between breaks', 'currentBreakTime': 'Current break time', 'standByTimeBetweenBreaks': 'Standby time between breaks', 'dailyBreakTime': 'Daily break time' }, 'tachoDetailHistoryTabTitle': 'Tacho History' }, 'driverWhrkHrsSVG': { 'title': 'Driver Working Status', 'description': 'Displays Working Status (Graphic)', 'remWrkHrsLabel': 'Remaing Hours', 'workingTimeLabel': 'Work Time Total (max 10h 00m)', 'drivingTimeLabel10h': 'Drive Time Total (max 10h 00m)', 'drivingTimeLabel9h': 'Drive Time Total (max 09h 00m)', 'breakTimeLabel': 'Break Time', 'standBytimeLabel': 'Standby Time', 'workingBetweenBreakLabel': 'Work Time Between Pause (max 06h 00m)', 'drivingBetweenBreakLabel': 'Drive Time Between Pause (max 04h 30m)', 'workingTimeRemainingLabel': 'Work Time Remaining', 'drivingTimeRemainingLabel': 'Drive Time Remaining', 'workingBetweenBreakRemainingLabel': 'Work Time Between Pause Remaining', 'drivingBetweenBreakRemainingLabel': 'Drive Time Between Pause Remaining', 'totalTimeRadio': 'Total', 'remainingTimeRadio': 'Remaining', 'hour': 'h', 'minute': 'm', 'details': 'Daily Details', 'daily': 'Daily', 'weekly': 'Weekly', 'svgColumnHeader': 'SVG', 'nextPauseDurationLabel': 'Next Pause Duration', 'nextShiftStartsBeforeLabel': 'Next Shift Starts NOT Before', 'lastWeeklyRestTime': 'Last Weekly Rest Times', 'weeklyDetails': { 'weeklyDetailsLabel': 'Weekly Details', 'workTimeTotalLabel': 'Work Time (Max 60h)', 'workTimeTotalAvg16weekLabel': 'Avg. last 16 weeks', 'driveTimeTotalLabel': 'Drive Time (Max 56h 00m)', 'driveTimeTotal2WeekLabel': '2 Weeks Drive Time (Max 90h 00m)', 'driveTimeTotalRemainingLabel': 'Drive Time', 'workTimeTotalRemainingLabel': 'Work Time', 'driveTimeTotal2WeekRemainingLabel': '2 Weeks Drive Time' } }, 'driverDigitalTachoStatus': { 'driverDigitalTachoStatusTitle': 'Digital Tacho Status', 'description': 'Displays Drivers Digital Tacho Status Information !', 'driver': 'Driver', 'login': 'Begin', 'logout': 'End', 'duration': 'Duration', 'odoStart': 'KM Start', 'odoStop': 'KM Stop', 'breakMoreThan15Min': 'Break > 15 min', 'breakAll': 'Break all', 'availability': 'Availability', 'work': 'Work', 'driving': 'Driving', 'breakOrRest': 'Break/Rest', 'time': 'Time', 'minutes': 'Minutes', 'type': 'Type', 'count': 'Count', 'currentStatus': 'Current Status', 'fmsNotAvailable': 'FMS time not available. Values might deviate.' }, 'temperatureDetail': { 'summary': { 'title': 'Summary', 'deviceInfo': 'Device Info', 'vehicleInfo': 'Vehicle Info', 'odometer': 'Odometer', 'vcgInfo': 'VCG Info', 'vehicleState': 'Last Vehicle State', 'currentJob': 'Current Job', 'maintenance': 'Maintenance', 'vehiclevin': 'VIN', 'firmwarevers': 'Firmware Version', 'vehicleexp': 'Vehicle Expiration', 'vehicleimei': 'IMEI/ESN Number', 'vehicleserial': 'Serial Number', 'vehiclemake': 'Make', 'vehiclemodel': 'Model', 'vehiclesim': 'SIM', 'vehiclesimid': 'SIM-ID', 'vehicleplate': 'License Plate', 'vehicletype': 'Vehicle Type', 'nocurrentjob': 'No job in progress', 'jobdate': 'Job Date', 'jobno': 'Job No', 'joblocation': 'Job Location', 'jobplannedtime': 'Planned Drive Time', 'jobplannedcirctime': 'Planned Trip Time', 'conretetype': 'Concrete Type', 'jobref': 'Reference', 'jobstatus': 'Status', 'jobqty': 'Quantity', 'jobstarttime': 'Job Start Time', 'jobdeparttime': 'Job Departure Time', 'jobarrivaltime': 'Job Arrival Time', 'jobdiscstarttime': 'Job Discharge Start time', 'jobdiscstoptime': 'Job Discharge Stop time', 'jobreturntime': 'Job Return time', 'jobremainingquantity': 'Job Remaining Quantity', 'ignitionon': 'Last Ignition ON', 'ignitionoff': 'Last Ignition OFF', 'ignitionstate': 'Current Ignition State', 'laststarttime': 'Last Engine Start', 'laststoptime': 'Last Engine Stop', 'lastmalflamp': 'Malfunction Lamp', 'lasteventtime': 'Last Event Time', 'lasttachodown': 'Last manual Tacho Download', 'telltaleStatus': 'TellTale Status', 'mainodometer0km': 'Odometer #1 Maintenance in (km)', 'mainodometer1km': 'Odometer #2 Maintenance in (km)', 'mainenginehrs': 'Engine Maintenance in (hours)', 'operationhrs': 'Operation Hours', 'repodometer': 'Reported Odometer', 'enginehrs': 'Reported Engine Hours', 'mainnotes': 'Maintenance Notes' }, 'input': { 'title': 'Input' }, 'temperature': { 'title': 'Temperature' }, 'weight': { 'title': 'Weight', 'chartHeading': 'Vehicle Weight History', 'xAxisHeader': 'Time', 'valueLabel1': 'Total Weight', 'valueLabel2': 'Axle Weight' }, 'fuel': { 'title': 'Fuel', 'chartHeading': 'Vehicle Fuel History', 'xAxisHeader': 'Time', 'valueLabel1': 'Fuel Econ Total', 'valueLabel2': 'Fuel Econ since engine on', 'valueLabel3': 'Speed', 'valueLabel4': 'Fuel Level', 'trip': 'Trip Fuel Used' }, 'consistency': { 'title': 'Consistency', 'chartHeading': 'Consistency History', 'xAxisHeader': 'Time', 'valueLabel1': 'Hydraulic oil pressure (mV)', 'valueLabel2': 'Drum RPM', 'valueLabel3': 'Engine RPM', 'valueLabel4': 'Ambient temperature', 'consistencyAutoRefreshLabel': 'Auto-Refresh ', 'valueLabel5': 'Hydraulic oil pressure (bar)', 'valueLabel6': 'Water Flow (mV)', 'valueLabel7': 'Water Flow (L/min)', 'consistencyChartWaterAccodionLabel': 'Water flow', 'valueLabel8': 'Hydraulic oil temperature', 'millivolt': 'Millivolt' } }, 'tempMonitoringWidget': { 'doorStatusChartTitle': 'Input State History', 'temperatureHistoryTitle': 'Temperature History', 'fuelHistoryTitle': 'Fuel History', 'weightHistoryTitle': 'Weight History', 'title': 'Vehicle Details', 'description': 'Displays Vehicle Details', 'doorStatusChartY': 'Input on/off status', 'maxHours': 'Max hours', 'max': 'Max', 'min': 'Min', 'isOdd': 'Please enter an even value', 'temperatureUnit': 'Temperature Unit', 'temperatureHistoryYAxis': 'Temperatures', 'thermo1': 'Temp#1', 'thermo2': 'Temp#2', 'thermo3': 'Temp#3', 'thermo4': 'Temp#4', 'thermo5': 'Temp#5', 'thermo6': 'Temp#6', 'thermo7': 'Temp#7', 'thermo8': 'Temp#8', 'doorStatusYMinValue': 'Input Off', 'doorStatusYMaxValue': 'Input On', 'time': 'Time', 'din1': 'Input #1', 'doorOpen': 'On', 'doorClose': 'Off', 'open': 'On', 'closed': 'Off' }, 'vehiclesListWidget': { 'title': 'Vehicle List Commands', 'description': 'Displays Vehicle List for Portal Commands' }, 'vehicleStatusWidget': { 'title': 'Work Order Commands', 'description': 'Change Vehicle Work Order Status' }, 'digitalOutputsWidget': { 'title': 'Digit Outputs', 'description': 'Set Digital Outputs via Portal Commands' }, 'pendingCommandsWidget': { 'title': 'Pending Commands', 'description': 'Displays Pending Commands' }, 'fmsVehicle': { 'vehicleList': 'Vehicle List FMS', 'description': 'Displays FMS Vehicle Details', 'vehicleAllDetailsTab': { 'vehicleAllDetails': 'Event Details All' }, 'vehicleTellTalesTab': { 'vehicleTellTales': 'Indication Lamps' } }, 'tachoEventDetail': { 'tachoEventDetailTitle': 'Time Recording Events', 'description': 'Tacho Events Graphic', 'tachoGraphicsListTabTitle': 'Tacho Events', 'tachoDetaiGrpahicTabTitle': 'Graphic', 'tachoStampingTimesTitle': 'Stamping Times', 'graphicsTab': { 'breakLabel': 'Break', 'wrokLabel': 'Work', 'avialableLabel': 'Availability', 'driveLabel': 'Driving', 'pasueLabel': 'Pause' } }, 'tachoHistory': { 'ttachoHistoryTitle': 'Tacho History', 'description': 'Tacho History' }, 'tachoDownloadStatus': { 'title': 'Download Status', 'description': 'shows download status driver card and tacho' } } }, 'errorCodes': { 'timeout': 'Load Data Timeout', 'restAPI': { '52000': { 'message': 'Do you want to clear local storage ?', 'format': '1', 'type': 'W' }, '52001': { 'message': 'Do you want to restore local storage ?', 'format': '1', 'type': 'W' }, '52002': { 'message': 'Local Storage save Failed !', 'format': '0', 'type': 'E' }, '52003': { 'message': 'Local Storage restore Failed !', 'format': '0', 'type': 'E' }, '52050': { 'message': 'Fail to Read the selected file', 'format': '0', 'type': 'E' }, '52051': { 'message': 'Telephone Entry not in the format - \'Number;Name\'', 'format': '0', 'type': 'E' }, '52052': { 'message': 'Command still pending for this device', 'format': '0', 'type': 'E' }, '52053': { 'message': 'Command could not be triggered', 'format': '0', 'type': 'E' }, '52504': { 'message': 'Request Timed Out !', 'format': '0', 'type': 'M' } }, 'track': { '57000': { 'message': 'Location Copied !', 'format': '0', 'type': 'M' } } } },

  nl: { 'modal': { 'customer': 'Kunden', 'buildingSite': 'Baustellen' }, 'nav': { 'productName': 'BetoSys', 'productLogoText': { 'fbr': 'BetoTrack', 'lgs': 'BetoTrack2' }, 'productLogoShortText': { 'fbr': 'BS', 'lgs': 'BS2' }, 'language': { 'en': 'English', 'de': 'Deutsch', 'nl': 'Nederlandse' }, 'user': { 'settings': 'Einstellungen', 'changePassword': 'Kennwort ändern', 'logout': 'Abmelden', 'appProfile': 'Applikationsprofil', 'clearLocalStorage': 'Profil löschen', 'restoreLocalStorage': 'Profil wiederherstellen', 'saveLocalStorage': 'Profil speichern' }, 'menuOptions': { 'dashboard': 'Dashboard', 'portalCommand': 'Portal-Befehl', 'maps': 'Karten', 'map': 'Karte', 'reports': 'Berichte', 'telephone': 'Telefon', 'driverDashboard': 'Fahrer Dashboard', 'mapsSubMenu': { 'lastLocation': 'Letzte Position', 'vehicleMap': 'Einzelne Fahrzeuge', 'groupMap': 'Flottenübersicht', 'sosEmergencyMap': 'SOS/Alarm', 'freeDeviceMap': 'Freie Fahrzeuge', 'busyDeviceMap': 'Disponierte Fahrzeuge' }, 'reportsSubMenu': { 'vehicleDetails': 'Einzelne Fahrzeuge', 'groupDetails': 'Fahrzeuggruppe Details', 'groupSummary': 'Gerätegruppen', 'performance': 'Fahrleistung' } } }, 'sidebar': { 'betotrack': { 'dashboard': 'Dashboard', 'map': 'Karte', 'driver': 'Fahrer Dashboard', 'driverDashbordMenu': 'Fahrer Dashboard', 'tachoHistoryDashboardMenu': 'Driver History', 'portalcommand': 'Portal Befehle', 'fms': 'FMS Dashboard', 'tachoDashboardMenu': 'Tacho Dashboard', 'tachoDownloadStatusDashboardMenu': 'Download Status', 'mapitems': { 'lastlocation': 'Letzte Position', 'vehiclemap': 'Einzelne Fahrzeuge', 'groupmap': 'Fahrzeuggruppen', 'sosmap': 'SOS/ Hilfe', 'alert': 'Alarm', 'freedevicesmap': 'Freie Fahrzeuge', 'busydevicesmap': 'Disponierte Fahrzeuge' }, 'reports': 'Berichte', 'reportitems': { 'vehicledetail': 'Einzelne Fahrzeuge', 'groupdetail': 'Fahrzeuggruppe Detail', 'groupsummary': 'Fahrzeuggruppe Gesamt', 'performance': 'Fahrleistung' }, 'admin': 'Admin', 'adminitems': { 'contactmgmt': 'Contact Management', 'bookmgmt': 'Book Management' }, 'telephone': 'Telefon' } }, 'foot': { 'application': 'Anwendung', 'database': 'Datenbank', 'gtse': 'GTSE', 'dataprivacy': 'Datenschutzerklärung', 'imprint': 'Impressum' }, 'login': { 'placeHolder': { 'Account': 'Account ID', 'username': 'Benutzername', 'password': 'Kennwort', 'email': 'email', 'forgotPassword': 'Wachtwoord vergeten' }, 'error': { 'timeout': 'Server Timeout', 'unauthorized': 'User unauthorized!' }, 'tittle': { 'fbr': 'BetoTrack Login', 'lgs': 'BetoTrack2 Login' } }, 'passwordChange': { 'placeHolder': { 'oldPassword': 'Altes Passwort', 'newPassword': 'Neues Passwort', 'confirmPassword': 'Passwort bestätigen' }, 'success': 'Passwort erfolgreich geändert', 'successForgotPassword': 'Nieuw wachtwoord is per mail verzonden', 'mismatch': 'Passwörter nicht übereinstimmend', 'accountmismatch': 'Account nicht übereinstimmend', 'oldpasswordwrong': 'Aktuelles Passwort ist falsch', 'requiredField': 'Bitte Pflichtfelder ausfüllen', 'save': 'Speichern', 'close': 'Schließen', 'submit': 'Indienen' }, 'forgotPassword': { 'title': 'To have your password sent to you, please enter your Login information and Contact Email Address (must match email address on file)' }, 'home': { 'welcome': 'Willkommen bei BetoSys', 'modules': { 'vis': { 'name': 'BetoVIS', 'desc': 'Vertrieb und Verkauf' }, 'plan': { 'name': 'BetonPlan', 'desc': 'Planung und Disposition' }, 'fakt': { 'name': 'BetoFakt', 'desc': 'Abrechung' }, 'track': { 'name': 'BetoTrack', 'desc': 'Fleet Management' } } }, 'print': { 'printing': 'Drucken', 'print': 'Drucken', 'exportXml': 'Export nach XML', 'exportExcel': 'Export nach Excel' }, 'moreFunction': { '5003': 'Data has already been deleted', 'button': { 'function': 'Weitere Funktionen' }, 'functionList': { 'delete': 'Löschen', 'download': 'Herunterladen', 'fileImport': 'Datei importieren', 'contactPosition': 'Show Positioning Options' } }, 'filter': { 'default': 'Default', 'clearFilter': 'Lösche Filter', 'resize': 'Größe ändern', 'settings': 'die Einstellungen', 'showDate': 'Datumsfilter anzeigen', 'hideDate': 'Datumsfilter verstecken' }, 'contextMenu': { 'customer': {}, 'buildingSite': {}, 'plant': {} }, 'settings': { 'name': 'Benutzername', 'userSetting': 'Benutzereinstellungen', 'gridPreference': { 'setting': 'Tabelleneinstellung', 'reset': 'Wiederherstellen', 'grid': 'Tabelle: ', 'backgroundColor': 'Hintergrundfarbe:', 'showingColumns': 'Spalten anzeigen: ', 'pinnedColumn': 'Anzahl fixierte Spalten' }, 'generalAccordion': { 'title': 'Allgemein', 'countryId': 'Länderkennung', 'company': 'Firma' }, 'planAccordion': { 'title': 'BetoTrack', 'workstation': 'Arbeitsplatz' } }, 'serverMessage': { '5001': 'Daten wurden von <{{AENDUSER}}> um {{AENDDATE}} geändert', '5002': 'Nummer {{id}} existiert bereits !', '5004': 'Datensatz mit Nummer  <[{{number}}]> wurde bereits durch <[{{AENDUSER}}]> angelegt.', 'login': { 'badCredential': 'Benutzername oder Passwort stimmt nicht.', 'GTSE_503': 'Dienst nicht verfügbar (GTSE)!', 'AU0010': 'Anmeldung fehlgeschlagen', 'US0020': 'Benutzer inaktiv', 'US0030': 'Benutzer abgelaufen' }, 'updatePassword': { '6003': 'Update Failed' }, 'internalServerError': 'Internal Server Error' }, 'confirmOnExit': { 'title': 'Änderungen verwerfen ?', 'content': 'Der aktuelle Datensatz wurde geändert, wollen Sie die Änderungen verwerfen?', 'exit': 'Ja', 'cancel': 'Abbrechen' }, 'responseErrorDilaog': { 'ok': 'Ok', 'cancel': 'Abbrechen', 'yes': 'Ja', 'no': 'Nein' }, 'button': { 'cancel': 'Abbrechen', 'save': 'Speichern' }, 'form': { 'save': { 'success': 'Erfolgreich gespeichert !' }, 'requiredFiled': 'Sie müssen Werte für alle Mußfelder eingeben!' }, 'error': { 'unAuthorizedMessage': 'Eingeschränkter Zugriff!' }, 'betoTrackMapping': { 'free': 'Freie Fahrzeuge', 'busy': 'Disponierte Fahrzeuge', 'group': 'Flottenübersicht', 'vehicle': 'Einzelne Fahrzeuge', 'lastlocation': 'Letzte Position', 'sos': 'SOS/Notfall Karte', 'alert': 'Alarmkarte' }, 'trackReporting': { 'performance': 'Fahrleistung', 'performanceReport': { 'eventSpeedOption': 'Geschwindigkeit über', 'eventExcessSpeed': 'Überhöhte Geschwindigkeit', 'driverReport': 'Fahrerbericht', 'driverExpiringLicense': 'Abgelaufene Führerscheine', 'driverWorkingHours': 'Fahrer Arbeitszeiten', 'customExport': 'Export DATEV', 'customExportDialog': { 'title': 'Fahrer Arbeitszeiten / DATEV', 'driver': 'Fahrer', 'export': 'Export', 'cancel': 'Abbrechen', 'exportSuccess': 'Export erfolgreich durchgeführt ! ' }, 'reportComboboxOptions': { 'eventSpeedOption': { '45mph': '30 km/h', '50mph': '50 km/h', '55mph': '60 km/h', '60mph': '70 km/h', '65mph': '90 km/h', '70mph': '100 km/h', '75mph': '120 km/h' }, 'driverExpiringLicense': { 'expired': 'Abgelaufen', '1week': 'In 1 Woche', '2weeks': 'In 2 Wochen', '1month': 'In 3 Wochen', '6months': 'In 6 Monaten' } } }, 'groupSummary': 'Fahrzeuggruppen', 'groupsummaryReport': { 'monthlyVehicleFuelUse': 'Maandelijks voertuig verbruik', 'eventSummary': 'Letzte bekannte Fahrzeugposition', 'firstEventSummary': 'Erstes Fahrzeugereignis', 'excessiveLastCheckIn': 'Letzter Check-in', 'deviceLastCheckIn': 'Fahrzeug Check-In Bericht', 'deviceNeverCheckIn': 'Fahrzeug Kein Check-In Bericht', 'eventCount': 'Anzahl empfangene Fahrzeugereignisse', 'eventSessionStatus': 'Sitzungsverbindungsbericht', 'periodicServiceOdom': 'Wartungsbericht nach Kilometerstand', 'periodicServiceHours': 'Wartungsberict nach Betriebsstunden', 'distanceTraveled': 'Zurückgelegte Strecke', 'ignitionSummaryReport': 'Zündungsbericht Zusammenfassung', 'digitalInputSummaryReport': 'Digitale Eingänge Zusammenfassung', 'fleetMotion': 'Fahrzeiten Zusammenfassung', 'fleetIdle': 'Leerlaufzeiten Zusammenfasung', 'fuelSummaryReport': 'Kraftstoffverbrauch Zusammenfassung', 'statusSummaryCount': 'Status Summary Count', 'userLogin': 'Benutzeranmeldungen', 'geozoneNearbyDevices': 'Fahrzeuge in Nähe einer Geozone', 'geozoneHotspotReport': 'Geozone Hotspot Report', 'reportComboboxOptions': { 'eventSummary': { 'all': 'Alle Ereignisse', 'free': 'Freie Fahrzeuge', 'busy': 'Disponierte Fahrzeuge', 'login': 'Angemeldete Fahrzeuge', 'logout': 'Abgemeldete Fahrzeuge', 'pause': 'Fahrer in Pause', 'service': 'Fahrzeug in Werkstatt' }, 'firstEventSummary': { 'all': 'Zündung an', 'motion': 'In Bewegung' }, 'excessiveLastCheckIn': { '1day': 'Mehr als 1 Tag', '2days': 'Mehr als  2 Tage', '3days': 'Mehr als  3 Tage', '7days': 'Mehr als  7 Tage', '30days': 'Mehr als  30 Tage', '100days': 'Mehr als  100 Tage' }, 'eventCount': { 'all': 'All', 'initialization': '\'Initialisierung\'', 'inmotion': '\'In Bewegung\'' }, 'digitalInputSummaryReport': { 'input0': 'Eingang #0', 'input1': 'Eingang #1', 'input2': 'Eingang #2', 'input3': 'Eingang #3', 'input4': 'Eingang #4', 'input5': 'Eingang #5', 'input6': 'Eingang #6', 'input7': 'Eingang #7' }, 'fleetMotion': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'fleetIdle': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' } }, 'reportedRefuel': 'Refuel Report Per Day', 'refuelMileage': 'Refuel Protocol CarPC' }, 'groupDetail': 'Fahrzeuggruppe Detail', 'groupDetailReport': { 'eventDetail_Group': 'Ereignisse Details', 'eventDetailOBDLight_Group': 'Ereignis OBD Details', 'tripReport_Group': 'Fahrtbericht Details', 'motionSummary_Group': 'Fahrzeiten/Stoppzeiten Zusammenfassung', 'geozoneReport_Group': 'Geozonenbericht', 'geozoneDriving_Group': 'Geozonen Ankunftsbericht', 'eventSpeedOption_Group': 'Geschwindigkeit über', 'eventExcessSpeed_Group': 'Fahrzeugübergeschwindigkeit', 'eventSpeedPosted_Group': 'Übertretung Höchstgeschwindigkeit', 'eventIdle_Group': 'Leerlauf', 'eventExcessiveIdle_Group': 'Exzessiver Leerlauf', 'digitalInputDetailReport_Group': 'Digitale Eingänge Details', 'notifyQueueDetail_Group': 'Alarm Details', 'reportComboboxOptions': { 'tripReport': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'workorder': 'Basierend auf Auftragsbeginn/Ankunft Werk', 'loginlogout': 'Basierend auf Anmeldung/Abmeldung', 'motion0': 'Basierend auf 0 Minuten Stop (Min)', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'motionSummary': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'eventSpeedOption': { '45mph': '30 km/h', '50mph': '50 km/h', '55mph': '60 km/h', '60mph': '70 km/h', '65mph': '90 km/h', '70mph': '100 km/h', '75mph': '120 km/h' }, 'eventSpeedPosted': { 'default': 'über Limit', '5mph': '8km/h über Limit', '10mph': '16km/h über Limit' }, 'digitalInputDetailReport': { 'input0': 'Eingang #0', 'input1': 'Eingang #1', 'input2': 'Eingang #2', 'input3': 'Eingang #3', 'input4': 'Eingang #4', 'input5': 'Eingang #5', 'input6': 'Eingang #6', 'input7': 'Eingang #7' } } }, 'vehicleDetail': 'Einzelne Fahrzeuge', 'vehicleDetailReport': { 'fuelTracker': 'Fuel Tracker Report', 'eventDetail': 'Ereignisse Details', 'tripReport': 'Fahrtbericht Details', 'motionSummary': 'Fahrzeiten/Stoppzeiten Zusammenfassung', 'deviceWorkOrders': 'Auftragsbericht', 'geozoneReport': 'Geozone Tankstelle', 'geozoneDriving': 'Geozone Ankunftsbericht', 'jobReport': 'Geozone Auftrag', 'ignitionDetailReport': 'Zündungsbericht Details', 'digitalInputDetailReport': 'Digitale Eingänge Details', 'eventCountByDay': 'Empfangene Ereignisse pro Tag', 'eventIdle': 'Leerlauf', 'eventExcessiveIdle': 'Exzessiver Leerlauf', 'driverMessageDetail': 'Fahrernachrichten Details', 'eventDetailOBDLight': 'OBD Light Ereignis Details', 'eventDetailAll': 'Ereignisse Details (FMS, Tacho)', 'eventRuleSpeeding': 'Übertretung Höchstgeschwindigkeit Details', 'fuelRegisterDetail': 'Kraftstoff Betankung/Entleerung Details', 'dailyDistanceDetail': 'Daily Distance Driven', 'deviceNearbyDevices': 'Fahrzeuge in Nähe einer Geozone', 'eventDetailCargoQuality': 'Event Detail Cargo Quality', 'reportComboboxOptions': { 'tripReport': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'workorder': 'Basierend auf Auftragsbeginn/Ankunft Werk', 'loginlogout': 'Basierend auf Anmeldung/Abmeldung', 'motion0': 'Basierend auf 0 Minuten Stop (Min)', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'motionSummary': { 'ignition': 'Basierend auf Zündung An/Aus', 'engine': 'Basierend auf Motor An/Aus', 'motion0': 'Basierend auf 0 Minuten Stop (Min)', 'motion5': 'Basierend auf 5 Minuten Stop (Min)', 'motion10': 'Basierend auf 10 Minuten Stop (Min)', 'motion20': 'Basierend auf 20 Minuten Stop (Min)', 'motion30': 'Basierend auf 30 Minuten Stop (Min)' }, 'eventCountByDay': { 'all': 'All', 'initialization': '\'Initialisierung\'', 'inmotion': 'In Bewegung' }, 'deviceNearbyDevices': { '500_feet': 'Innerhalb 150 Meter', '1_mile': 'Innerhalb 1,5 Km', '2_miles': 'Innerhalb 3 Km', '3_miles': 'Innerhalb 5 Km', '5_miles': 'Innerhalb 8 Km', '10_miles': 'Innerhalb 16 Km', '20_miles': 'Innerhalb 32 Km' }, 'digitalInputDetailReport': { 'input0': 'Eingang #0', 'input1': 'Eingang #1', 'input2': 'Eingang #2', 'input3': 'Eingang #3', 'input4': 'Eingang #4', 'input5': 'Eingang #5', 'input6': 'Eingang #6', 'input7': 'Eingang #7' } } }, 'group': 'Gruppe :', 'export': 'Export :', 'getReport': 'Bericht anfordern', 'emailInfo': 'Report will be emailed to the following list of comma-separated email address(es): ', 'exportEmailsendBtn': 'Senden', 'vehicle': 'Fahrzeug :', 'reportOption': 'Bericht Optionen', 'report': 'Bericht', 'reportExportSuccess': 'Report Exported successfully! ', 'reportExportFailed': 'Report Export Failed! ', 'emailSendingFailed': 'Email Sending Failed! ', 'emailSendSuccessfully': 'Email Send successfully! ' }, 'vehicleStatus': { 'moduleName': 'Fahrzeugstatus', 'order': 'Auftrag', 'operationSuccess': 'Erfolgreich gespeichert', 'dialog': { 'startTime': 'Startzeit', 'duration': 'Dauer / Min', 'save': 'Speichern', 'cancel': 'Abbrechen' }, 'button': { 'setvehicleState': 'Status Setzen', 'order': 'Auftrag', 'retour': 'Rückmenge', 'changePlant': 'Anderes Werk', 'pauseBegin': 'Pause Beginn', 'pauseEnd': 'Pause Ende', 'maintenanceBegin': 'Wartung Beginn', 'maintenanceEnd': 'Wartung Ende', 'login': 'Anmelden', 'logout': 'Abmelden' } }, 'digitalOutput': { 'output1': 'Digitaler Ausgang #1', 'output2': 'Digitaler Ausgang #2', 'output3': 'Digitaler Ausgang #3', 'output4': 'Digitaler Ausgang #4', 'timeout': 'Auszeit/s' }, 'telephonesList': { 'moduleName': 'Telefonnummern', 'button': { 'new': 'Neu', 'copy': 'Kopieren', 'edit': 'Bearbeiten' }, 'telephoneImport': { 'dialogTitle': 'Telefondatei importieren', 'successAlert': 'Datei erfolgreich importiert !', 'importBtn': 'Import' } }, 'telephoneNew': { 'new': 'Neu', 'copy': 'Kopieren', 'edit': 'Bearbeiten', 'save': 'Speichern', 'cancel': 'Abbrechen', 'saveNew': 'Speichern und Neu', 'firstName': 'Name', 'lastName': 'Familienname', 'fullName': 'vollständiger Name', 'telephone': 'Telefon' }, 'booksList': { 'moduleName': 'Contact Book List', 'saveError': 'Unable to save Book', 'saveSuccess': 'Book successfully saved', 'allocationList': 'Contact Allocations' }, 'contactsList': { 'moduleName': 'Contacts Index', 'importDiagTitle': 'Contact file import', 'importIntoBook': 'Import Contacts into new book', 'importBookName': 'Book Name :', 'importErrorBookDuplicate': 'Book Display Name already exists', 'importErrorBookBlank': 'Book Name can not be blank', 'successAlert': 'Datei erfolgreich importiert !', 'importBtn': 'Import', 'saveSuccess': 'Contact successfully saved', 'saveError': 'Unable to save Contact' }, 'contactNew': { 'new': 'Neu', 'copy': 'Kopieren', 'edit': 'Bearbeiten', 'view': 'View', 'save': 'Speichern', 'cancel': 'Abbrechen', 'saveNew': 'Speichern und Neu', 'firstName': 'Name', 'landline': 'Landline', 'mobile': 'Mobile', 'posUp': 'Move Up', 'posDown': 'Move Down', 'posSave': 'Save Positioning', 'posCancel': 'Cancel' }, 'download': { 'title': 'Telefondaten herunterladen', 'vehicleGroup': 'Fahrzeuggruppe', 'vehicleName': 'Fahrzeug', 'selectAll': 'Auswählen alle', 'deselectAll': 'Abwählen alle', 'ok': 'Ok', 'cancel': 'Abbrechen', 'success': 'Herunterladen erfolgreich!' }, 'bookDownload': { 'title': 'Book List Download', 'vehicleGroup': 'Fahrzeuggruppe', 'vehicleName': 'Fahrzeug', 'bookName': 'Book List', 'selectAll': 'Auswählen alle', 'deselectAll': 'Abwählen alle', 'ok': 'Ok', 'cancel': 'Abbrechen' }, 'deviceMessaging': { 'vehicle': 'Fahrzeug :', 'messageID': 'Nachricht-Id : ', 'sendBtn': 'Senden', 'radioText': 'Text', 'radioOk': 'Ok', 'radioYes-No': 'Ja/Nein', 'readAllNewMessages': 'Lese alle neuen Nachrichten', 'noMessages': 'Keine Nachrichten !', 'youGOt': 'Sie haben ', 'newMessages': ' neue Nachrichten !', 'newMessage': ' neue Nachricht !', 'newMessagesBetween': 'neue Nachrichten zwischen', 'sendMessage': 'Sende Nachricht', 'sending': 'Sende..', 'ok': 'OK', 'yes': 'Ja', 'no': 'Nein', 'characterLimitReached': 'Zeichenlimit (300) erreicht', 'drivers': 'Chauffeurs', 'groupChats': 'Groepschats', 'groupMembers': 'Groepsleden', 'membersCount': '{{count}} Leden', 'members': 'Leden' }, 'deviceCommands': { 'command': 'Befehl :', 'sendSuccess': 'Befehl erfolgreich eingeleitet' }, 'truckmixerList': { 'modelDialog': { 'vehicleState': 'Status', 'retour': 'Rückmenge', 'plant': 'Anderes Werk', 'pauseBegin': 'Pause Beginn', 'orderDate': 'Datum', 'vehicle': 'Fahrzeug :', 'currentStatus': 'Aktueller Status', 'newStatus': 'Neuer Status', 'concreteType': 'Sorte', 'currentPlant': 'Aktuelles Werk', 'newPlant': 'Neues Werk', 'time': 'Dauer [min]' } }, 'dateRangePicker': { 'locale': { 'applyLabel': 'Anwenden', 'cancelLabel': 'Abbrechen', 'clearLabel': 'Löschen', 'fromLabel': 'Von', 'toLabel': 'Bis', 'customRangeLabel': 'Benutzerdefiniert', 'weekLabel': 'W', 'daysOfWeek': { 'Sunday': 'So', 'Monday': 'Mo', 'Tuesday': 'Di', 'Wednesday': 'Mi', 'Thursday': 'Do', 'Friday': 'Fr', 'Saturday': 'Sa' }, 'monthNames': { 'January': 'Januar', 'February': 'Februar', 'March': 'März', 'April': 'April', 'May': 'Mai', 'June': 'Juni', 'July': 'Juli', 'August': 'August', 'September': 'September', 'October': 'Oktober', 'November': 'November', 'December': 'Dezember' } }, 'ranges': { 'Standard': 'Standard', 'Today': 'Heute', 'Yesterday': 'Gestern', 'Last_7_days': 'Letzten 7 Tage', 'Last_30_days': 'Letzten 30 Tage', 'This_month': 'Diesen Monat', 'Last_Month': 'Letzten Monat', 'Last_hour': 'Letzten hour', 'Last_2_hours': 'Letzten 2 hours', 'Last_4_hours': 'Letzten 4 hours', 'Last_8_hours': 'Letzten 8 hours', 'Last_24_hours': 'Letzten 24 hours', 'Last_2_days': 'Letzten 2 Tage' } }, 'additionalTranslation': { 'comboboxOptionALL': 'Alle', 'serverPath': 'Server Pfad : ' }, 'deleteConfirm': { 'delete_title': 'Jetzt Löschen ?', 'delete_button': 'Löschen', 'cancel_button': 'Abbrechen', 'delete_body': 'Wollen Sie den Datensatz löschen?' }, 'userRight': { 'notAuthorized': 'Keine Zugriffsrechte vorhanden', 'notAvailable': 'Keine Daten verfügbar' }, 'listView': { 'datePickerPopup': { 'currentText': 'Heute', 'clearText': 'Löschen', 'closeText': 'Fertig' }, 'common': { 'filters': {}, 'localization': { 'gotopagestring': 'Gehe zu:', 'showrowsstring': 'Zeige Zeile:', 'rangestring': ' von ', 'nextbuttonstring': 'voriger', 'previousbuttonstring': 'nächster', 'sortascendingstring': 'Sortiere aufsteigend', 'sortdescendingstring': 'Sortiere absteigend', 'sortremovestring': 'Entferne Sortierung', 'filterselectstring': 'Select Filter', 'filterselectallstring': '(Select All)', 'loadtext': 'Loading...', 'validationstring': 'Entered value is not valid', 'emptydatastring': 'No data to display' } }, 'cDayDriverWorkingHours': { 'headers': { 'workingTimeToday': 'Arbeitszeit heute', 'drivingTimeToday': 'Lenkzeit heute', 'breakTimeToday': 'Pausenzeit heute', 'standByTimeToday': 'Bereitschaftszeit heute' } }, 'fmsVehicle': { 'headerColumnfilters': { 'vehiclestatus': { 'Blue': 'Blue', 'Yellow': 'Yellow', 'Red': 'Red' } } }, 'pendingCommands': { 'headers': { 'accountID': 'Account', 'deviceID': 'Geräte-ID', 'queueTime': 'Anstehend seid', 'commandType': 'Kommandotyp', 'commandID': 'Kommando-ID', 'sendState': 'Sende Zustand', 'commandArgs': 'Kommando Arg.', 'sendTime': 'Sendezeit', 'deleteAfter': 'Löschen Nach', 'ackTime': 'Ack Zeit', 'ackResponse': 'Ack Anzwort', 'lastUpdateTime': 'Letzte Änderung', 'creationTime': 'Angelegt am' } }, 'telephones': { 'headers': { 'name': 'Name', 'telephoneNumber': 'Telefon' } } }, 'dashBoard': { 'title': 'Fleet Management Dashboard', 'lastLocationDashboardTitle': 'Last Location Dashboard', 'driverDashboardTitle': 'Driver Dashboard', 'portalCommandsDashboardTitle': 'Portal Command', 'fmsDashboardTitle': 'FMS Dashboard', 'tachoHistoryDashboardTitle': 'Driver History', 'tachoDownloadStatusTitle': 'Download Status', 'fleetManagement': { 'title': 'Fleet Management Dashboard', 'news': { 'title': 'News', 'url': 'http://www.dsa.de/index.php?type=100&L=1' }, 'weather': { 'title': 'Wetter', 'location': 'Aachen' }, 'introduction': { 'title': 'Übersicht', 'description': '![betosys logo](assets/images/betosys.png)\n\n* Fleet management for concrete, mortar and pumps\n\n* Centralized and decentralized planning for one plant or several plants in a group' }, 'calendar': { 'title': 'Kalender', 'chooseCulture': 'Format', 'description': 'Kalender anzeigen ' }, 'vehicleList': { '404': 'Keine Daten vorhanden !', 'vehicleListTitle': 'Fahrzeugliste', 'description': 'Aktuelle Fahrzeuginformationen anzeigen', 'vehicleGroup': 'Fahrzeugruppe:', 'statusCode': 'Status:', 'nextRefreshIn': 'Aktualisierung in :', 'startAutoUpdate': 'AutoUpdate starten', 'stopAutoUpdate': 'AutoUpdate stoppen : ', 'vehicleGroupValidation': 'Bitte eine Fahrzeuggruppe angeben !', 'lastLocation': 'Letzte Position', 'noOfGridRows': 'Anzahl Listenzeilen :', 'frameHeight': 'Rahmenhöhe (Pixel) :', 'moreFunction': { 'command': 'Befehl', 'sendMsg': 'Nachricht senden', 'sendCommand': 'Befehl senden', 'showReports': 'Bericht anzeigen', 'showDashboard': 'Dashboard', 'showDriverDashboard': 'Fahrer Dashboard', 'showPortalCommand': 'Portal Befehle', 'showFmsDashboard': 'FMS Dashboard', 'copyLocationToClipboard': 'Koordinaten kopieren' }, 'ordersTab': { 'orders': 'Aufträge', 'showReport': 'Bericht anzeigen' }, 'vehicleDetailsTab': { 'vehicleDetails': 'Fahrzeugereignisse' }, 'cargoQualityTab': { 'cargoQuality': 'Qualitätsdaten Ladung' } }, 'vehicleDetails': { '404': 'Keine Daten vorhanden !', 'vehicleDetailsTitle': 'Fahrzeugdetails', 'description': 'Detaillierter Fahrzeugdatensatz (GPS, FMS, ...) anzeigen', 'dateRange': 'Datumsbereich :', 'name': 'Name', 'value': 'Wert' }, 'fleetMap': { '404': 'Keine Daten vorhanden !', 'fleetMapTitle': 'Flottenkarte', 'description': 'Flottenkarte anzeigen', 'showInfoBalloon': 'Fahrzeuginfo automatisch anzeigen' }, 'deviceMap': { '404': 'Keine Daten vorhanden !', 'deviceMapTitle': 'Fahrzeugkarte', 'description': 'Fahrzeugkarte anzeigen' }, 'driverWorkingHours': { 'driverWrkHoursList': 'Fahrerliste Tacho', 'description': 'Fahrer Arbeitszeiten anzeigen', 'workingHoursType': { 'totalWorkingTimeToday': 'Gesamt Arbeitszeit Heute', 'totalDrivingTimeToday': 'Gesamt Lenkzeit Heute', 'totalBreakTimeToday': 'Gesamt Pausenzeit Heute', 'totalStandByTimeToday': 'Gesamt Bereitschaftszeit Heute', 'workingTimeBetweenBreaks': 'Arbeitszeit zwischen den Pausen', 'drivingTimeBetweenBreaks': 'Lenkzeit zwischen den Pausen', 'currentBreakTime': 'Pausenzeit Aktuell', 'standByTimeBetweenBreaks': 'Bereitschaftszeit zwischen den Pausen', 'dailyBreakTime': 'tägliche Ruhezeiten' }, 'tachoDetailHistoryTabTitle': 'Tacho History' }, 'driverWhrkHrsSVG': { 'title': 'Fahrer Arbeitsstatus', 'description': 'Fahrer Arbeitsstatus anzeigen (Grafik)', 'remWrkHrsLabel': 'Restarbeitszeit', 'workingTimeLabel': 'Arbeitszeit (Max 10h 00m)', 'drivingTimeLabel10h': 'Lenkzeit (Max 10h 00m)', 'drivingTimeLabel9h': 'Lenkzeit (Max 09h 00m)', 'breakTimeLabel': 'Pausenzeit', 'standBytimeLabel': 'Bereitschaftszeit', 'workingBetweenBreakLabel': 'Arbeitszeit zw. Pausen (Max 06h 00m)', 'drivingBetweenBreakLabel': 'Lenkzeit zw. Pausen (Max 04h 30m)', 'workingTimeRemainingLabel': 'Arbeitszeit', 'drivingTimeRemainingLabel': 'Lenkzeit', 'workingBetweenBreakRemainingLabel': 'Arbeitszeit zwischen den Pausen', 'drivingBetweenBreakRemainingLabel': 'Lenkzeit zwischen den Pausen', 'totalTimeRadio': 'Gesamtzeit', 'remainingTimeRadio': 'Restzeit', 'hour': 'h', 'minute': 'm', 'details': 'Tageszeiten', 'svgColumnHeader': 'SVG', 'nextPauseDurationLabel': 'Dauer nächste Pause', 'nextShiftStartsBeforeLabel': 'Nächster Arbeitsbeginn nicht vor', 'lastWeeklyRestTime': 'Letzte wöchentliche Ruhezeiten', 'weeklyDetails': { 'weeklyDetailsLabel': 'Wochenzeiten', 'workTimeTotalLabel': 'Arbeitszeit(Max 60h 00m)', 'workTimeTotalAvg16weekLabel': 'Ø 16 Wochen', 'driveTimeTotalLabel': 'Lenkzeit (Max 56h 00m)', 'driveTimeTotal2WeekLabel': 'Doppelwochenlenkzeit(Max 90h 00m)', 'driveTimeTotalRemainingLabel': 'Lenkzeit', 'workTimeTotalRemainingLabel': 'Arbeitszeit', 'driveTimeTotal2WeekRemainingLabel': 'Doppelwochenlenkzeit' } }, 'driverDigitalTachoStatus': { 'driverDigitalTachoStatusTitle': 'Digitaler Tacho Status', 'description': 'Fahrer Tachozeiten anzeigen', 'driver': 'Fahrer', 'login': 'Beginn', 'logout': 'Ende', 'duration': 'Dauer', 'odoStart': 'Beginn KM', 'odoStop': 'Ende KM', 'breakMoreThan15Min': 'Pause > 15 min', 'breakAll': 'Pause Gesamt', 'availability': 'Bereit', 'work': 'Arbeit', 'driving': 'Fahrt', 'breakOrRest': 'Pause', 'time': 'Zeit', 'minutes': 'Minuten', 'type': 'Typ', 'count': 'Anzahl', 'currentStatus': 'Akt. Status', 'fmsNotAvailable': 'FMS-Zeit nicht verfügbar. Werte können abweichen.' }, 'temperatureDetail': { 'summary': { 'title': 'Summary', 'deviceInfo': 'Device Info', 'vehicleInfo': 'Vehicle Info', 'odometer': 'Odometer', 'vcgInfo': 'VCG Info', 'vehicleState': 'Last Vehicle State', 'currentJob': 'Current Job', 'maintenance': 'Maintenance', 'vehiclevin': 'VIN', 'firmwarevers': 'Firmware Version', 'vehicleexp': 'Vehicle Expiration', 'vehicleimei': 'IMEI/ESN Number', 'vehicleserial': 'Serial Number', 'vehiclemake': 'Make', 'vehiclemodel': 'Model', 'vehiclesim': 'SIM', 'vehiclesimid': 'SIM-ID', 'vehicleplate': 'License Plate', 'vehicletype': 'Vehicle Type', 'nocurrentjob': 'No job in progress', 'jobdate': 'Job Date', 'jobno': 'Job No', 'joblocation': 'Job Location', 'jobplannedtime': 'Planned Drive Time', 'jobplannedcirctime': 'Planned Trip Time', 'conretetype': 'Concrete Type', 'jobref': 'Reference', 'jobstatus': 'Status', 'jobqty': 'Quantity', 'jobstarttime': 'Job Start Time', 'jobdeparttime': 'Job Departure Time', 'jobarrivaltime': 'Job Arrival Time', 'jobdiscstarttime': 'Job Discharge Start time', 'jobdiscstoptime': 'Job Discharge Stop time', 'jobreturntime': 'Job Return time', 'jobremainingquantity': 'Job Remaining Quantity', 'ignitionon': 'Last Ignition ON', 'ignitionoff': 'Last Ignition OFF', 'ignitionstate': 'Current Ignition State', 'laststarttime': 'Last Engine Start', 'laststoptime': 'Last Engine Stop', 'lastmalflamp': 'Malfunction Lamp', 'lasteventtime': 'Last Event Time', 'lasttachodown': 'Last manual Tacho Download', 'telltaleStatus': 'TellTale Status', 'mainodometer0km': 'Odometer #1 Maintenance (km)', 'mainodometer1km': 'Odometer #2 Maintenance (km)', 'mainenginehrs': 'Engine Maintenance (hours)', 'operationhrs': 'Operation Hours', 'repodometer': 'Reported Odometer', 'enginehrs': 'Reported Engine Hours', 'mainnotes': 'Maintenance Notes' }, 'input': { 'title': 'Input' }, 'temperature': { 'title': 'Temperature' }, 'weight': { 'title': 'Weight', 'chartHeading': 'Vehicle Weight History', 'xAxisHeader': 'Time', 'valueLabel1': 'Total Weight', 'valueLabel2': 'Axle Weight' }, 'fuel': { 'title': 'Fuel', 'chartHeading': 'Vehicle Fuel History', 'xAxisHeader': 'Time', 'valueLabel1': 'Fuel Econ Total', 'valueLabel2': 'Fuel Econ since engine on', 'valueLabel3': 'Speed', 'valueLabel4': 'Fuel Level', 'trip': 'Trip Fuel Used' }, 'consistency': { 'title': 'Consistency', 'chartHeading': 'Consistency History', 'xAxisHeader': 'Time', 'valueLabel1': 'Hydraulic oil pressure (mV)', 'valueLabel2': 'Drum RPM', 'valueLabel3': 'Vehicle RPM', 'valueLabel4': 'Ambient temperature', 'consistencyAutoRefreshLabel': 'Auto-Aktualisierung ', 'valueLabel5': 'Hydraulic oil pressure (bar)', 'valueLabel6': 'Water Flow (mV)', 'valueLabel7': 'Water Flow (L/min)', 'consistencyChartWaterAccodionLabel': 'Wasserdurchfluss', 'valueLabel8': 'Hydrauliköltemperatur', 'millivolt': 'Millivolt' } }, 'tempMonitoringWidget': { 'doorStatusChartTitle': 'Historie Dig. Eingang', 'temperatureHistoryTitle': 'Historie Temperatur', 'fuelHistoryTitle': 'Fuel History', 'weightHistoryTitle': 'Weight History', 'doorStatusChartY': 'Dig. Eingang an/aus', 'maxHours': 'Max Stunden', 'max': 'Max', 'min': 'Min', 'IsOdd': 'Bitte geradzahligen Wert eingeben !', 'temperatureUnit': 'Temperatur Einheit', 'temperatureHistoryYAxis': 'Temperaturen', 'title': 'Fahrzeug Details', 'description': 'Zeigt Fahrzeug-Details an', 'thermo1': 'Temp#1', 'thermo2': 'Temp#2', 'thermo3': 'Temp#3', 'thermo4': 'Temp#4', 'thermo5': 'Temp#5', 'thermo6': 'Temp#6', 'thermo7': 'Temp#7', 'thermo8': 'Temp#8', 'doorStatusYMinValue': 'Eingang Aus', 'doorStatusYMaxValue': 'Eingang An', 'time': 'Zeit', 'din1': 'Eingang #1', 'doorOpen': 'An', 'doorClose': 'Aus', 'open': 'An', 'closed': 'Aus' }, 'vehiclesListWidget': { 'title': 'Fahrzeugliste Befehle', 'description': 'Fahrzeugliste für Portal-Befehle anzeigen' }, 'vehicleStatusWidget': { 'title': 'Fahrzeugstatus Setzen', 'description': 'Fahrzeugstatus über Portal-Befehl setzen' }, 'digitalOutputsWidget': { 'title': 'Digitale Ausgänge', 'description': 'Digitale Ausgänge des Fahrzeugs setzen' }, 'pendingCommandsWidget': { 'title': 'Ausstehende Portal-Befehle', 'description': 'Kommandos ans Fahrzeug absetzen/anzeigen' }, 'fmsVehicle': { 'vehicleList': 'Fahrzeugliste FMS', 'description': 'Detaillierte Fahrzeugdaten anzeigen', 'vehicleAllDetailsTab': { 'vehicleAllDetails': 'Fahrzeugereignisse Gesamt' }, 'vehicleTellTalesTab': { 'vehicleTellTales': 'Voertuigstatus' } }, 'tachoEventDetail': { 'tachoEventDetailTitle': 'Time Recording Events', 'description': 'Tacho Events Graphic', 'tachoGraphicsListTabTitle': 'Tacho Events', 'tachoDetaiGrpahicTabTitle': 'Graphic', 'tachoStampingTimesTitle': 'Stamping Times', 'graphicsTab': { 'breakLabel': 'Break', 'wrokLabel': 'Work', 'avialableLabel': 'Availability', 'driveLabel': 'Driving', 'pasueLabel': 'Pause' } }, 'tachoHistory': { 'ttachoHistoryTitle': 'Tacho Historie', 'description': 'Tacho Historie' }, 'tachoDownloadStatus': { 'title': 'Download Status', 'description': 'Zeigt den Status von Tacho- und Fahrerkarten-Downloads' } } }, 'errorCodes': { 'timeout': 'Timeout beim Laden der Daten', 'restAPI': { '52000': { 'message': 'Applikationsprofil löschen ?', 'format': '1', 'type': 'W' }, '52001': { 'message': 'Do you want to restore local storage ?', 'format': '1', 'type': 'W' }, '52002': { 'message': 'Local Storage save Failed !', 'format': '0', 'type': 'E' }, '52003': { 'message': 'Local Storage restore Failed !', 'format': '0', 'type': 'E' }, '52050': { 'message': 'Fehler beim Einlesen der Datei', 'format': '0', 'type': 'E' }, '52051': { 'message': 'Datei nicht im Format - \'Telefonnummer;Name\'', 'format': '0', 'type': 'E' }, '52052': { 'message': 'Befehl für dieses Gerät steht noch aus', 'format': '0', 'type': 'E' }, '52053': { 'message': 'Befehl konnte nicht ausgelöst werden', 'format': '0', 'type': 'E' }, '52504': { 'message': 'Request Timed Out !', 'format': '0', 'type': 'M' } }, 'track': { '57000': { 'message': 'Location Copied !', 'format': '0', 'type': 'M' } } }

    //endinject
  } });

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.constants', []).constant('version', '1.32.1').constant('customerName', 'fbr');

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by linli on 7/13/2015.
 */


/**
 *   rewrote by rak , place the clear icon right after input box of jqx on mouseover , hide clear selection on mouseout,
 *   icon gets click event for clearing the content and can respond with event after clearing if specified as mentioned below.
 *
 *  directive attribute can have a object  clear-input= '{"responseType":1}' , can assign an object of this json format too .
 *
 *  if value responseType 1. return a event 'combobox-clear-selection-evt' broadcast on rootscope  , after clear icon clicked
 *  can be caught and do required function call on directive or in controller .
 *
 *  it can have 3 different types of classed based on component it defined
 *  1. searchclear -  for the normal combobox
 *  2. searchclear-multiselect - for overview multiselect
 *  3. searchclear-jqxinputselect - for jqx input used under basic data input directive.
 *
 * rewrote due to Bug 79654 - Rendering of overview search box not O.k for smaller resolutions
 * and other issues on some screens click is not responding with the combobox dropdown.
 *
 */

angular.module('betosyswebapp').directive('clearInput', ['$parse', '$rootScope', function ($parse, $rootScope) {
  return {
    link: function link($scope, elm, attr) {
      // register mouseover , mouseout event listenrs
      elm.bind('mouseover', mouseOverHandler);
      elm.bind('mouseout', mouseOutHandler);
      var afterClearResponseType = null;
      if (attr.clearInput.length > 0) {
        if (typeof attr.clearInput === 'string') {
          afterClearResponseType = JSON.parse(attr.clearInput);
        } else {
          afterClearResponseType = attr.clearInput;
        }
      }

      function mouseOverHandler() {
        var removeCircleElement = $(elm).find('.glyphicon-remove-circle');
        var inputElement = $(elm).find('.jqx-combobox-content input');
        var customCssClass = getCustomClass(1);
        if (inputElement.length === 0) {
          inputElement = $(elm);
          customCssClass = getCustomClass(3); // jqx-input from basicDataInputField.js
          if (inputElement.length === 0) {
            return;
          }
        }

        // find is it a multi select combobox , if so need 10px top ,
        var isMultiSelect = $(elm).find('.jqx-combobox-content a').length > 0;
        if (isMultiSelect) {
          customCssClass = getCustomClass(2);
        }
        if (removeCircleElement.length === 0) {
          removeCircleElement = $(elm).next('div .glyphicon-remove-circle');
        }

        // clear icon div is already added if length > 0
        if (removeCircleElement.length === 0 && !hasDisabledClass(elm)) {
          var isNeedNgHide = 'ng-hide ';
          if (inputElement.val() || $(elm).find('.jqx-combobox-content a').length > 0) {
            isNeedNgHide = ' ';
          }

          var clearIcon = '<div id=' + Math.round(Math.random() * 1000000000) + ' class="' + isNeedNgHide + ' ' + customCssClass + ' ' + 'glyphicon glyphicon-remove-circle "></div>';
          clearIcon = angular.element(clearIcon);

          inputElement.after(clearIcon);

          clearIcon.on('click', clearIconClickHandler);
        } else if (!hasDisabledClass(elm)) {
          if (removeCircleElement.hasClass('ng-hide') && inputElement.val() || $(elm).find('.jqx-combobox-content a').length > 0) {
            removeCircleElement.removeClass('ng-hide');
          }
        }
      }

      var hasDisabledClass = function hasDisabledClass(element) {
        var disabledClasses = ['jqx-combobox-content-disabled', 'disabled', 'ng-disabled', 'jqx-fill-state-disabled', 'jqx-fill-state-disabled-bootstrap', 'jqx-combobox-state-disabled'];
        var isDisabled = false;
        for (var i in disabledClasses) {
          if (disabledClasses.hasOwnProperty(i) && $(element).hasClass(disabledClasses[i])) {
            isDisabled = true;
          }
        }
        if ($(element).attr('disabled') === 'disabled') {
          isDisabled = true;
        }

        return isDisabled;
      };

      function mouseOutHandler() {
        var removeCircleElement = $(elm).find('.glyphicon-remove-circle');
        if (removeCircleElement.length === 0) {
          return;
          /* removeCircleElement = $(elm).next('div .glyphicon-remove-circle'); // getting a loop when used under jqxInput
           if (removeCircleElement.length === 0) {
             return;
           }*/
        }
        removeCircleElement.addClass('ng-hide');
      }

      function getCustomClass(customClassSelectorValue) {
        switch (customClassSelectorValue) {
          case 1:
            return ' searchclear ';
          case 2:
            return ' searchclear-multiselect ';
          case 3:
            return ' searchclear-jqxinputselect ';
        }
      }

      function clearIconClickHandler() {
        var clearIcon = $(elm).find('.glyphicon-remove-circle');
        var isFromBasicInputDirective = false;
        if (clearIcon.length === 0) {
          clearIcon = $(elm).next('div .glyphicon-remove-circle');
          if (clearIcon.length > 0) {
            isFromBasicInputDirective = true;
          }
        }
        if (!isFromBasicInputDirective) {
          // will be handled in respective BasicInput directive
          if ($scope.$parent && $scope.$parent.$parent && $scope.$parent.$parent.$parent && $scope.$parent.$parent.$parent.isDirty) {
            $scope.$parent.$parent.$parent.isDirty = true;
          }
          try {
            $parse(attr.ngModel).assign($scope, null);
            $scope.$apply();
          } catch (error) {
            console.log(error);
          }
        }
        clearIcon.addClass('ng-hide');

        //todo(ejt) differntiate here and dont run all selectors
        //todo(ejt) hide on disabled and dont delete then!!
        var input = $(elm).find('input');
        input.select();

        if ($('#' + elm[0].id).jqxInput) {
          $('#' + elm[0].id).jqxInput('val', null);
        }

        $('#' + elm[0].id).jqxComboBox('clearSelection');
        $('#' + elm[0].id).jqxComboBox('searchString', '');
        $('#' + elm[0].id).jqxComboBox('focus');

        // after clear response as event
        if (afterClearResponseType && afterClearResponseType.responseType === 1) {
          $rootScope.$broadcast('combobox-clear-selection-evt', { id: attr.id });
        }
      }

      // destroy handlers
      $scope.$on('$destroy', function () {
        // unbind the click event from clear icon
        var removeCircleElement = $(elm).find('.glyphicon-remove-circle');
        if (removeCircleElement.length === 0) {
          removeCircleElement = $(elm).next('div .glyphicon-remove-circle');
        }
        removeCircleElement.unbind('click', clearIconClickHandler);
        elm.unbind('mouseover', mouseOverHandler);
        elm.unbind('mouseout', mouseOutHandler);
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 4/2/2016.
 */


angular.module('betosyswebapp').directive('contextmenu', function () {
  return {
    link: function link(elem) {
      $(elem).on('contextmenu', function (e) {
        e.preventDefault();
        return false;
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 4/28/2017.
 */



angular.module('betosyswebapp').directive('jqxDeleteDirective', function () {
  return {
    restrict: 'A',
    priority: 1000,
    scope: {
      jqxDeleteDirective: '@',
      type: '@'
    },
    link: function link(scope, element) {
      var isWidgetIsinfullScreen = $(element).closest('.widget-fullscreen').length > 0 ? true : false;
      element.on('$destroy', function () {
        if (scope.type && scope.jqxDeleteDirective && !isWidgetIsinfullScreen) {
          var tmp;
          switch (scope.type) {
            // try catch necessary for not interrupting element destruction on error.
            // its possible jqx destroy may throw error when destroy called if  JQX-create attribute is false by default or the element inside a tab.
            case 'grid':
              if ($('body.modal-open').length - 1) {
                try {
                  tmp = $('#' + scope.jqxDeleteDirective);
                  if (tmp.length > 0) {
                    tmp.jqxGrid('destroy');
                  }
                } catch (err) {
                  console.log(err);
                }
              }

              break;
            case 'comboBox':
              try {
                tmp = $('#' + scope.jqxDeleteDirective);
                if (tmp.length > 0) {
                  tmp.jqxComboBox('destroy');
                }
              } catch (err) {
                console.log(err);
              }
              break;
            case 'dropDownList':
              try {
                tmp = $('#' + scope.jqxDeleteDirective);
                if (tmp.length > 0) {
                  tmp.jqxDropDownList('destroy');
                }
              } catch (err) {
                console.log(err);
              }
              break;
            case 'chart':
              try {
                tmp = $('#' + scope.jqxDeleteDirective);
                if (tmp.length > 0) {
                  tmp.jqxChart('destroy');
                }
              } catch (err) {
                console.log(err);
              }
              break;
            case 'rangeSelector':
              try {
                tmp = $('#' + scope.jqxDeleteDirective);
                if (tmp.length > 0) {
                  tmp.jqxRangeSelector('destroy');
                }
              } catch (err) {
                console.log(err);
              }
              break;
          }
        }
      });
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 8/24/2016.
 */


angular.module('betosyswebapp').directive('driverWrkHrsSvgInterpreter', ["$translate", "$timeout", "commonTrackService", "AuthenticationService", "localStorageService", "$window", "tachoHistoryService", "DriverWrkHrsWidgetService", "$rootScope", "stateManagerService", "DriverWrkHrsSVGWidgetService", function ($translate, $timeout, commonTrackService, AuthenticationService, localStorageService, $window, tachoHistoryService, DriverWrkHrsWidgetService, $rootScope, stateManagerService, DriverWrkHrsSVGWidgetService) {
  return {
    restrict: 'E',
    replace: true,
    template: '<object id="wrkHrsSvg" data="assets/images/driverWorkingHours.svg" width="100%" type="image/svg+xml" ng-show="hasValidDriver"></object>',
    link: function link(scope, element) {
      scope.hasValidDriver = true;
      scope.isNotAuthorized = false;
      scope.isDataNotAvailable = false;
      scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
      scope.isWidgetPostInitFinished = false;

      var loginid = AuthenticationService.GetLoginID();
      var localstorageWorkingHoursType = localStorageService.get('selectedWorkingHourType.' + loginid.Account + '.' + loginid.username);
      scope.timeRadio = {
        type: localstorageWorkingHoursType && localstorageWorkingHoursType.workingHourType ? localstorageWorkingHoursType.workingHourType : 'totalTime',
        svgRadioType: localstorageWorkingHoursType && localstorageWorkingHoursType.svgRadioType ? localstorageWorkingHoursType.svgRadioType : 'workTime',
        viewType: {
          dailyView: localstorageWorkingHoursType && localstorageWorkingHoursType.viewType && localstorageWorkingHoursType.viewType.dailyView ? localstorageWorkingHoursType.viewType.dailyView : true,
          weeklyView: localstorageWorkingHoursType && localstorageWorkingHoursType.viewType && localstorageWorkingHoursType.viewType.weeklyView ? localstorageWorkingHoursType.viewType.weeklyView : false
        }

      };

      var isWidgetUnderDialog = element.parents('.modal-body').length || 0;

      if (isWidgetUnderDialog) {
        element.width('500px');
      }

      var _7_30_M = 450;
      var _10_M = 600;
      var _8_0_M = 8 * 60;
      var _8_30_M = 510;
      var _4_M = 240;
      var _4_30_M = 270;
      var _5_30_M = 330;
      var _6_0_M = 360;
      var _9_0_M = 540;
      var _48_0_M = 48 * 60;
      var _60_0_M = 60 * 60;
      var _56_0_M = 56 * 60;
      var _80_0_M = 80 * 60;
      var _90_0_M = 90 * 60;
      var _2_30_M = 2 * 60 + 30;
      var _1_30_M = 90;
      var _12_0_M = 12 * 60;
      var TIME_STRING_FORMAT = {
        _1: '0d 00h 00m', // if days are present  time display in '12d 12h 12m' else '00h 12m'
        _2: '00h 00m' // if hours presnt '12h 12m' else '00h 12m'
      };

      scope.max = 100;
      scope.driverWorkHours = restProgressBarDetails();

      function restProgressBarDetails() {
        return {
          workTimeTotal: { type: 'info', value: 0, actualValue: '' },
          driveTimeTotal: { type: 'info', value: 0, actualValue: '' },
          workTimePause: { type: 'info', value: 0, actualValue: '' },
          driveTimePause: { type: 'info', value: 0, actualValue: '' },
          weekWorkTimeTotal: { type: 'info', value: 0, actualValue: '' },
          weekDriveTimeTotal: { type: 'info', value: 0, actualValue: '' },
          weekDriveTimeTotal2we: { type: 'info', value: 0, actualValue: '' }
        };
      }

      var totalCircle = 360;
      var totalBar = 100;
      var totlWrkHrsLimtMinutes = 600; // 10 hours normal worktime
      var totlExtraWrkHrsLimitMinutes = 240; //  maximum Extra work time Limit 4 hours.

      var workTimeMaxLimitMinutes = 600; // 10 hours normal worktime
      var driveTimeTotalMaxLimitMinutes = 600; // 10 hours normal drive time
      /*    var pauseTimeTotalMaxLimitMinutes = 45; // 45 min normal break time
       var standbyTimeTotalMaxLimitMinutes = 60; // 1 hour normal stand by time ?*/
      var workTimeBetweenPauseMaxLimitMinutes = 360; // 4 hour normal beak time between pause
      var driveTimeBetweenPauseMaxLimitMinutes = 270; // 4 hour normal drive time between pause

      var weeklyDetailWorkTimeTotalMaxLimitMinuts = 60 * 60;
      var weeklyDetailDriveTimeTotalMaxLimitMinuts = 56 * 60;
      var weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts = 90 * 60;

      var wrkHrsCircleId = 'group_ue_rpb_normal';
      var wrkHrsOverAllPercentId = 'ue_label_overal_percentage';
      var driverDescId = 'group_ue_overal_driver_status';
      var remaingWrktimeLabel = 'ue_label_rem_workingtime';
      var remWrkHrsLabel = 'ue_label_descr';

      var driverDesTemplate = '<text xmlns="http://www.w3.org/2000/svg" id="label_driver_desc" transform="matrix(0.9986 0 0 1 90 22.7041)" style="text-anchor: middle;" font-family="Roboto,Calibri"';
      var dirverStateTemplate = '<text xmlns="http://www.w3.org/2000/svg" id="label_driver_state" transform="matrix(0.9986 0 0 1 90 32.7041)" style="text-anchor: middle;" font-family="Roboto,Calibri" font-size="10">';
      var extrWrkHrsCircleId = 'group_ue_rpb_overtime';

      var _tmp = 0;
      var greenWrkHrsCircleArry = [];
      var redWrkHrsCircleArry = [];
      scope.isDataFromHistoryList = false;

      var h = $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.hour');
      var m = $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.minute');

      function getSvgDocument() {
        return document.getElementById('wrkHrsSvg').contentDocument;
      }

      var init = function init() {
        var _isIntialized = false;
        $timeout(function () {
          $rootScope.$broadcast('reqDataUpdate');
        }, 0);

        function _handleRowSlectEvnt(data) {
          scope.isDataNotAvailable = false;
          if (data.selectedRow) {
            updateSvg(data);
          } else {
            scope.hasValidDriver = false;
          }
        }

        function _refreshSvgBasedOnLastSelectedData() {
          var _rowData = null;
          if ($window.location.href.indexOf('tachohistorydashboard') > -1) {
            _rowData = tachoHistoryService.getLastSelectedHstoryRowData();
            scope.isDataFromHistoryList = true;
          } else {
            _rowData = commonTrackService.getDriverDashboardLastSelectedRowData();
          }

          if (_rowData && _rowData !== null && _rowData.selectedRow) {

            scope.isDataNotAvailable = false;
            updateSvg(_rowData);
            _isIntialized = true;
          }
        }

        if (isWidgetUnderDialog && !_isIntialized || !_isIntialized) {
          _refreshSvgBasedOnLastSelectedData();
        }

        function updateSvg(data) {
          var _defaltTransStringPath = 'dashBoard.fleetManagement.driverWhrkHrsSVG.';

          scope.workTimeTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'workingTimeLabel') : $translate.instant(_defaltTransStringPath + 'workingTimeRemainingLabel');
          scope.workTimeBetTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'workingBetweenBreakLabel') : $translate.instant(_defaltTransStringPath + 'workingBetweenBreakRemainingLabel');

          //Set the max for the progress bar to drivetimelimit once we have the data
          //And set the text for the progress bar once we have the data
          if (data.selectedRow.drivetimelimit === undefined || data.selectedRow.drivetimelimit === null) {
            data.selectedRow.drivetimelimit = 10;
          }
          driveTimeTotalMaxLimitMinutes = data.selectedRow.drivetimelimit * 60;
          var _defaultDrivingTimeLimit = 'drivingTimeLabel10h';
          if (data.selectedRow.drivetimelimit === '9') {
            _defaultDrivingTimeLimit = 'drivingTimeLabel9h';
          }
          scope.driveTimeTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + _defaultDrivingTimeLimit) : $translate.instant(_defaltTransStringPath + 'drivingTimeRemainingLabel');

          scope.driveTimeBetTotalOrRemaingLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'drivingBetweenBreakLabel') : $translate.instant(_defaltTransStringPath + 'drivingBetweenBreakRemainingLabel');
          scope.totalTimeRadio = $translate.instant(_defaltTransStringPath + 'totalTimeRadio');
          scope.remainingTimeRadio = $translate.instant(_defaltTransStringPath + 'remainingTimeRadio');

          scope.weeklyWorkTimeTotalLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'weeklyDetails.workTimeTotalLabel') : $translate.instant(_defaltTransStringPath + 'weeklyDetails.workTimeTotalRemainingLabel');
          scope.weeklyDriveTimeTotalLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotalLabel') : $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotalRemainingLabel');
          scope.weekly2WeeksDriveTimeTotalLabel = scope.timeRadio.type !== 'remainingTime' ? $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotal2WeekLabel') : $translate.instant(_defaltTransStringPath + 'weeklyDetails.driveTimeTotal2WeekRemainingLabel');
          scope.weeklyWorkTime16WeekAvgLabel = $translate.instant(_defaltTransStringPath + 'weeklyDetails.workTimeTotalAvg16weekLabel');

          //data.selectedRow.driverdesc = data.selectedRow.driverdesc && data.selectedRow.driverdesc !== '' ? data.selectedRow.driverdesc : '---';
          if (data.selectedRow.driverdesc && data.selectedRow.driverdesc !== '') {
            scope.hasValidDriver = true;
            scope.isDataNotAvailable = false;
          } else {
            scope.hasValidDriver = false;
            scope.isDataNotAvailable = true;
          }
          scope.driverWorkHours = restProgressBarDetails();
          scope.driverWorkHours.avg16WeekWorkTime = {
            actualValue: '',
            value: ''
          };

          $timeout(function () {

            var _workTimeTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.worktimetotal);

            var _driveTimeTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.drivetimetotal);
            var _workTimeBetweenPauseTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.worktimebetweenpause);
            var _driveTimeBetweenPauseTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.drivetimebetweenpause);

            var _pauseTimeTotal = _convertGtsTimeStringToMinutes(data.selectedRow.pausetimetotal);

            var _weekWorkTimeTotalMinutes = _convertGtsTimeStringToMinutes(data.selectedRow.weekworktimetotal, true);
            var _weekDriveTimeTotal = _convertGtsTimeStringToMinutes(data.selectedRow.weekdrivetimetotal, true);
            var _weekDriveTimeTotal2we = _convertGtsTimeStringToMinutes(data.selectedRow.weekdrivetimetotal2we, true);
            var _avg16WeekWorkTime = _convertGtsTimeStringToMinutes(data.selectedRow.worktimeavg16we, true);

            var wrkHrsCircleElement = getSvgElementByID(wrkHrsCircleId);
            var wrkHrsOverAllPercentElement = getSvgElementByID(wrkHrsOverAllPercentId);
            var extrWrkHrsCircleElement = getSvgElementByID(extrWrkHrsCircleId);
            var driverDescriptionElement = getSvgElementByID(driverDescId);

            driverDescriptionElement.children().last().remove();

            if (_tmp === 0) {
              var _wrkHrschildren = wrkHrsCircleElement.children();
              var _extraWrkHrsChildren = extrWrkHrsCircleElement.children();

              greenWrkHrsCircleArry = _loopAndGetElements(_wrkHrschildren, greenWrkHrsCircleArry);
              redWrkHrsCircleArry = _loopAndGetElements(_extraWrkHrsChildren, redWrkHrsCircleArry);

              //wrkHrs = Math.floor(Math.random() * 600) + 1; // used to test circle generation with random numbers.
            }
            wrkHrsCircleElement.empty();
            extrWrkHrsCircleElement.empty();

            ++_tmp;
            getSvgElementByID(remWrkHrsLabel).html('');

            var fontStyles = ' font-size="21">';

            if (data.selectedRow.driverdesc.length > 20) {
              //set font to 12
              fontStyles = ' font-size="12">';
            }

            if (data.selectedRow.driver1workingstate) {
              driverDescriptionElement.html(driverDesTemplate + fontStyles + data.selectedRow.driverdesc + '</text>' + dirverStateTemplate + '(' + data.selectedRow.driver1workingstate + ')</text>');
            } else {
              driverDescriptionElement.html(driverDesTemplate + fontStyles + data.selectedRow.driverdesc + '</text>');
            }

            switch (scope.timeRadio.svgRadioType) {
              case 'workTime':
                updateSvgCircle(_workTimeTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, totlWrkHrsLimtMinutes);
                break;
              case 'workTimeBetweenPause':
                updateSvgCircle(_workTimeBetweenPauseTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, workTimeBetweenPauseMaxLimitMinutes);
                break;
              case 'driveTime':
                updateSvgCircle(_driveTimeTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, driveTimeTotalMaxLimitMinutes);
                break;
              case 'driveTimeBetweenPause':
                updateSvgCircle(_driveTimeBetweenPauseTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, driveTimeBetweenPauseMaxLimitMinutes);
                break;
              case 'weekWorkTimeTotal':
                updateSvgCircle(_weekWorkTimeTotalMinutes, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, weeklyDetailWorkTimeTotalMaxLimitMinuts);
                break;
              case 'weekDriveTimeTotal':
                updateSvgCircle(_weekDriveTimeTotal, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, weeklyDetailDriveTimeTotalMaxLimitMinuts);
                break;
              case 'weekDriveTimeTotal2we':
                updateSvgCircle(_weekDriveTimeTotal2we, wrkHrsCircleElement, wrkHrsOverAllPercentElement, extrWrkHrsCircleElement, weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts);
                break;

            }

            scope.driverWorkHours.avg16WeekWorkTime.actualValue = commonTrackService.getTimeStringFromMinutes(_avg16WeekWorkTime, TIME_STRING_FORMAT._2); //getHourMinTranslatedString(data.selectedRow.worktimeavg16we);
            scope.driverWorkHours.avg16WeekWorkTime.value = _avg16WeekWorkTime;
            scope.driverWorkHours.workTimeTotal.type = getProgressBarType('workTimeTotal', _workTimeTotalMinutes);
            scope.driverWorkHours.workTimeTotal.value = getProgressPercentatge(_workTimeTotalMinutes, workTimeMaxLimitMinutes);
            scope.driverWorkHours.workTimeTotal.value = scope.driverWorkHours.workTimeTotal.value >= 0 ? scope.driverWorkHours.workTimeTotal.value : totalBar;
            scope.driverWorkHours.workTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.worktimetotal) : commonTrackService.getTimeStringFromMinutes(workTimeMaxLimitMinutes - _workTimeTotalMinutes);

            scope.driverWorkHours.driveTimeTotal.type = getProgressBarType('drivingTimeTotal', _driveTimeTotalMinutes);
            scope.driverWorkHours.driveTimeTotal.value = getProgressPercentatge(_driveTimeTotalMinutes, driveTimeTotalMaxLimitMinutes);
            scope.driverWorkHours.driveTimeTotal.value = scope.driverWorkHours.driveTimeTotal.value >= 0 ? scope.driverWorkHours.driveTimeTotal.value : totalBar;
            scope.driverWorkHours.driveTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.drivetimetotal) : commonTrackService.getTimeStringFromMinutes(driveTimeTotalMaxLimitMinutes - _driveTimeTotalMinutes);

            scope.driverWorkHours.driveTimePause.type = getProgressBarType('driveTimeBetweenPause', _driveTimeBetweenPauseTotalMinutes);
            scope.driverWorkHours.driveTimePause.value = getProgressPercentatge(_driveTimeBetweenPauseTotalMinutes, driveTimeBetweenPauseMaxLimitMinutes);
            scope.driverWorkHours.driveTimePause.value = scope.driverWorkHours.driveTimePause.value >= 0 ? scope.driverWorkHours.driveTimePause.value : totalBar;
            scope.driverWorkHours.driveTimePause.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.drivetimebetweenpause) : commonTrackService.getTimeStringFromMinutes(driveTimeBetweenPauseMaxLimitMinutes - _driveTimeBetweenPauseTotalMinutes);
            scope.driverWorkHours.workTimePause.type = getProgressBarType('workTimeBetweenPause', _workTimeBetweenPauseTotalMinutes);
            scope.driverWorkHours.workTimePause.value = getProgressPercentatge(_workTimeBetweenPauseTotalMinutes, workTimeBetweenPauseMaxLimitMinutes);
            scope.driverWorkHours.workTimePause.value = scope.driverWorkHours.workTimePause.value >= 0 ? scope.driverWorkHours.workTimePause.value : totalBar;
            scope.driverWorkHours.workTimePause.actualValue = scope.timeRadio.type !== 'remainingTime' ? getHourMinTranslatedString(data.selectedRow.worktimebetweenpause) : commonTrackService.getTimeStringFromMinutes(workTimeBetweenPauseMaxLimitMinutes - _workTimeBetweenPauseTotalMinutes);

            // weekly details
            scope.driverWorkHours.weekWorkTimeTotal.type = getProgressBarType('weekWorkTimeTotal', _weekWorkTimeTotalMinutes);
            scope.driverWorkHours.weekWorkTimeTotal.value = getProgressPercentatge(_weekWorkTimeTotalMinutes, weeklyDetailWorkTimeTotalMaxLimitMinuts);
            scope.driverWorkHours.weekWorkTimeTotal.value = scope.driverWorkHours.weekWorkTimeTotal.value >= 0 ? scope.driverWorkHours.weekWorkTimeTotal.value : totalBar;
            scope.driverWorkHours.weekWorkTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? commonTrackService.getTimeStringFromMinutes(_weekWorkTimeTotalMinutes, TIME_STRING_FORMAT._2) : commonTrackService.getTimeStringFromMinutes(weeklyDetailWorkTimeTotalMaxLimitMinuts - _weekWorkTimeTotalMinutes, TIME_STRING_FORMAT._2);
            scope.driverWorkHours.weekDriveTimeTotal.type = getProgressBarType('weekDriveTimeTotal', _weekDriveTimeTotal);
            scope.driverWorkHours.weekDriveTimeTotal.value = getProgressPercentatge(_weekDriveTimeTotal, weeklyDetailDriveTimeTotalMaxLimitMinuts);
            scope.driverWorkHours.weekDriveTimeTotal.value = scope.driverWorkHours.weekDriveTimeTotal.value >= 0 ? scope.driverWorkHours.weekDriveTimeTotal.value : totalBar;
            scope.driverWorkHours.weekDriveTimeTotal.actualValue = scope.timeRadio.type !== 'remainingTime' ? commonTrackService.getTimeStringFromMinutes(_weekDriveTimeTotal, TIME_STRING_FORMAT._2) : commonTrackService.getTimeStringFromMinutes(weeklyDetailDriveTimeTotalMaxLimitMinuts - _weekDriveTimeTotal, TIME_STRING_FORMAT._2);
            scope.driverWorkHours.weekDriveTimeTotal2we.type = getProgressBarType('weekDriveTimeTotal2we', _weekDriveTimeTotal2we);
            scope.driverWorkHours.weekDriveTimeTotal2we.value = getProgressPercentatge(_weekDriveTimeTotal2we, weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts);
            scope.driverWorkHours.weekDriveTimeTotal2we.value = scope.driverWorkHours.weekDriveTimeTotal2we.value >= 0 ? scope.driverWorkHours.weekDriveTimeTotal2we.value : totalBar;
            scope.driverWorkHours.weekDriveTimeTotal2we.actualValue = scope.timeRadio.type !== 'remainingTime' ? commonTrackService.getTimeStringFromMinutes(_weekDriveTimeTotal2we, TIME_STRING_FORMAT._2) : commonTrackService.getTimeStringFromMinutes(weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts - _weekDriveTimeTotal2we, TIME_STRING_FORMAT._2);

            scope.hasWeeklyRestData = false;
            scope.weeklyRestTimeDisplayColor = '';
            scope.weeklyRestTime1 = data.selectedRow.weeklyresttime1;
            scope.weeklyRestTime2 = data.selectedRow.weeklyresttime2;
            scope.weeklyRestTimeDisplayColor1 = '#555560'; // Black
            scope.weeklyRestTimeDisplayColor2 = '#555560'; // Black
            if (data.selectedRow.weeklyresttime1 !== undefined && data.selectedRow.weeklyresttime1 !== null && data.selectedRow.weeklyresttime1 !== '') {
              scope.hasWeeklyRestData = true;
            }
            if (data.selectedRow.weeklyresttimecolor1 === 'red') {
              scope.weeklyRestTimeDisplayColor1 = '#EF4136'; // Red
            }
            if (data.selectedRow.weeklyresttimecolor2 === 'red') {
              scope.weeklyRestTimeDisplayColor2 = '#EF4136'; // Red
            }

            scope.nextShiftStartsBeforeLabel = data.selectedRow.nextshiftstartdetail;
            scope.nextPauseDuriationDisplayColor = '';

            /**
             * next pause duration calculation , duration time and color details are calculated as per driver related data.
             */
            if (_pauseTimeTotal === 0 && _driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes >= _4_30_M) {
              scope.nextPauseDuration = '45m';
              scope.nextPauseDuriationDisplayColor = '#EF4136'; // Red
            } else if (_pauseTimeTotal === 0 && _driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M) {
              scope.nextPauseDuration = '15m/30m/45m';
            } else if (_pauseTimeTotal > 0 && _pauseTimeTotal < 30 && _driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M) {
              scope.nextPauseDuration = '30m';
            } else if (_pauseTimeTotal > 0 && _pauseTimeTotal >= 30 && _driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M) {
              scope.nextPauseDuration = '30m/45m';
            } else if (_pauseTimeTotal > 0 && _pauseTimeTotal >= 45 && _driveTimeTotalMinutes > 0 && _driveTimeBetweenPauseTotalMinutes < _4_30_M) {
              scope.nextPauseDuration = '---';
            } else if (_pauseTimeTotal === 0 && _driveTimeTotalMinutes === 0 && _workTimeBetweenPauseTotalMinutes > _6_0_M && _workTimeBetweenPauseTotalMinutes <= _9_0_M) {
              scope.nextPauseDuration = '30m';
              scope.nextPauseDuriationDisplayColor = '#EF4136'; // Red
            } else if (_pauseTimeTotal === 0 && _driveTimeTotalMinutes === 0 && _workTimeBetweenPauseTotalMinutes > _9_0_M) {
              scope.nextPauseDuration = '45m';
              scope.nextPauseDuriationDisplayColor = '#EF4136'; // Red
            } else {
              scope.nextPauseDuration = '---';
            }
            scope.dataLoadingFinished = true;
          }, 1000);
        }

        function getProgressPercentatge(totalTimeInMinutes, timeMaxLimitInMinutes) {
          if (scope.timeRadio.type === 'remainingTime') {
            totalTimeInMinutes = timeMaxLimitInMinutes - totalTimeInMinutes;
          }
          var wrkHrsPercentage = totalTimeInMinutes / timeMaxLimitInMinutes * 100;
          wrkHrsPercentage = wrkHrsPercentage > 0 ? wrkHrsPercentage : 0;
          return wrkHrsPercentage > 100 ? wrkHrsPercentage : wrkHrsPercentage;
        }

        /**
         * Base on the Case Selected the progress bar colour is calculated by their depending time.
         *
         * Each case value uses its own function to better  handling logic and Readability.
         *
         * @param workingType
         * @param time
         * @return String
         */
        function getProgressBarType(workingType, time) {
          switch (workingType) {
            case 'workTimeTotal':
              return _getWorkTimeTotalOrRemainingTimeProgressType(time);
            case 'drivingTimeTotal':
              return _getDriveTimeTotalOrRemainingTimeProgressType(time);
            case 'driveTimeBetweenPause':
              return _getDriveTimeBetweenPauseOrRemainingTimeProgressType(time);
            case 'workTimeBetweenPause':
              return _getWorkTimeBetweenPauseOrRemainingTimeProgressType(time);
            case 'weekWorkTimeTotal':
              return _getWeekWorkTimeTotalOrRemainingTimeProgressType(time);
            case 'weekDriveTimeTotal':
              return _getWeeDriveTimeTotalOrRemainingTimeProgressType(time);
            case 'weekDriveTimeTotal2we':
              return _getWeeDrive2TimeTotalOrRemainingTimeProgressType(time);
          }
        }

        /**
         *  returns progress bar type for the Total or Remaining  time of WORK TIME TOTAL.
         * @param time
         * @return string
         * @private
         */
        function _getWorkTimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWrkTime = workTimeMaxLimitMinutes - time;

            if (_remainingWrkTime > _2_30_M && _remainingWrkTime <= _10_M) {
              return 'success';
            }
            if (_remainingWrkTime <= _2_30_M && _remainingWrkTime > 0) {
              return 'warning';
            }
            return 'white';
          } else if (scope.timeRadio.type === 'totalTime') {

            if (time < _7_30_M) {
              return 'success';
            }
            if (time > _7_30_M && time < _10_M) {
              return 'warning';
            }
            if (time > _10_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of DRIVE TIME TOTAL.
         * @param time
         * @return string
         * @private
         */
        function _getDriveTimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingDrvTime = driveTimeTotalMaxLimitMinutes - time;

            if (_remainingDrvTime > _1_30_M && _remainingDrvTime <= _10_M) {
              return 'success';
            }
            if (_remainingDrvTime <= _1_30_M && _remainingDrvTime > 0) {
              return 'warning';
            }
            return 'white';
          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _8_30_M) {
              return 'success';
            }
            if (time >= _8_30_M && time < _10_M) {
              return 'warning';
            }
            if (time >= _10_M) {
              return 'danger';
            }
          }
        }

        /**
         *  returns progress bar type for the Total or Remaining  time of DRIVE TIME BETWEEN PAUSE.
         * @param time
         * @private
         * @return string
         */
        function _getDriveTimeBetweenPauseOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingDrvTimeBetPause = driveTimeBetweenPauseMaxLimitMinutes - time;

            if (_remainingDrvTimeBetPause > 30 && _remainingDrvTimeBetPause <= _4_30_M) {
              return 'success';
            }
            if (_remainingDrvTimeBetPause <= 30 && _remainingDrvTimeBetPause > 0) {
              return 'warning';
            }
            return 'white';
          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _4_M) {
              return 'success';
            }
            if (time >= _4_M && time < _4_30_M) {
              return 'warning';
            }
            if (time >= _4_30_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of WORK TIME BETWEEN PAUSE.
         * @param time
         * @private
         * @return string
         */
        function _getWorkTimeBetweenPauseOrRemainingTimeProgressType(time) {

          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWrkTimeBetPause = workTimeBetweenPauseMaxLimitMinutes - time;
            if (_remainingWrkTimeBetPause > 30 && _remainingWrkTimeBetPause <= _6_0_M) {
              return 'success';
            }
            if (_remainingWrkTimeBetPause <= 30 && _remainingWrkTimeBetPause > 0) {
              return 'warning';
            }
            return 'white';
          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _5_30_M) {
              return 'success';
            }
            if (time >= _5_30_M && time < _6_0_M) {
              return 'warning';
            }
            if (time >= _6_0_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of  WEEKLY WORK TIME.
         * @param time
         * @return string
         * @private
         */
        function _getWeekWorkTimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWeekWrkTimeTotal = weeklyDetailWorkTimeTotalMaxLimitMinuts - time;
            if (_remainingWeekWrkTimeTotal > _12_0_M && _remainingWeekWrkTimeTotal <= _60_0_M) {
              return 'success';
            }
            if (_remainingWeekWrkTimeTotal <= _12_0_M && _remainingWeekWrkTimeTotal > 0) {
              return 'warning';
            }
            return 'white';
          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _48_0_M) {
              return 'success';
            }
            if (time >= _48_0_M && time < _60_0_M) {
              return 'warning';
            }
            if (time >= _60_0_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of  WEEKLY DRIVE TIME.
         * @param time
         * @return string
         * @private
         */
        function _getWeeDriveTimeTotalOrRemainingTimeProgressType(time) {

          if (scope.timeRadio.type === 'remainingTime') {
            var _remainingWeekDrvTimeTotal = weeklyDetailDriveTimeTotalMaxLimitMinuts - time;
            if (_remainingWeekDrvTimeTotal > _8_0_M && _remainingWeekDrvTimeTotal <= _56_0_M) {
              return 'success';
            }
            if (_remainingWeekDrvTimeTotal <= _8_0_M && _remainingWeekDrvTimeTotal > 0) {
              return 'warning';
            }
            return 'white';
          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _48_0_M) {
              return 'success';
            }
            if (time >= _48_0_M && time < _56_0_M) {
              return 'warning';
            }
            if (time >= _56_0_M) {
              return 'danger';
            }
          }
        }

        /**
         * returns progress bar type for the Total or Remaining  time of  2 WEEK DRIVE TIME.
         * @param time
         * @return String
         * @private
         */
        function _getWeeDrive2TimeTotalOrRemainingTimeProgressType(time) {
          if (scope.timeRadio.type === 'remainingTime') {
            var _remaining2WeekDrvTimeTotal = weeklyDetail2WeeekDriveTimeTotalMaxLimitMinuts - time;
            if (_remaining2WeekDrvTimeTotal > _10_M && _remaining2WeekDrvTimeTotal <= _90_0_M) {
              return 'success';
            }
            if (_remaining2WeekDrvTimeTotal <= _10_M && _remaining2WeekDrvTimeTotal > 0) {
              return 'warning';
            }
            return 'white';
          } else if (scope.timeRadio.type === 'totalTime') {
            if (time < _80_0_M) {
              return 'success';
            }
            if (time >= _80_0_M && time < _90_0_M) {
              return 'warning';
            }
            if (time >= _90_0_M) {
              return 'danger';
            }
          }
        }

        function _convertGtsTimeStringToMinutes(timeString, skipMaximumdayLimit) {
          var _days = timeString.indexOf('d') !== -1 && timeString.split('d')[0] || 0;
          _days = Number(_days) > 1 && !skipMaximumdayLimit ? 1 : _days;
          timeString = timeString.length > 0 && timeString.indexOf('d') !== -1 ? timeString.split('d')[1] : timeString;
          var _sampleWrkhrsString = timeString.length > 0 ? timeString : '0h  0m';
          if (_days && _sampleWrkhrsString.beginsWith(' ')) {
            _sampleWrkhrsString = _sampleWrkhrsString.substr(1, _sampleWrkhrsString.length);
          }
          var _sampleWrkhrsStringArry = _sampleWrkhrsString.replace(' ', '.').replace(' ', '').replace(/h|m/g, '').split('.');
          return _sampleWrkhrsStringArry.length === 2 ? _days * 24 * 60 + Number(_sampleWrkhrsStringArry[0] * 60) + Number(_sampleWrkhrsStringArry[1]) : 0;
        }

        function _loopAndGetElements(sourcceElementArray, destinationArray) {
          for (var j = 0; j < sourcceElementArray.length; j++) {
            destinationArray.push(sourcceElementArray[j].outerHTML.replace('display="none"', ''));
          }
          return destinationArray;
        }

        function getHourMinTranslatedString(value) {
          return value.length > 0 ? value.replace('h', h).replace('m', m) : 0 + h + ' ' + 0 + m;
        }

        function getSvgElementByID(id) {
          return angular.element(getSvgDocument().getElementById(id));
        }

        /**
         * Used to update the SVG Circle both GREEN and RED based on the given type of working minutes .
         *
         *
         * @param workingOrDrivingMinutes
         * @param greenCircleElement
         * @param overAllPercentElement
         * @param redCircleElement
         */
        function updateSvgCircle(workingOrDrivingMinutes, greenCircleElement, overAllPercentElement, redCircleElement, totalMinutsLimit) {

          if (scope.timeRadio.type === 'remainingTime') {
            workingOrDrivingMinutes = totalMinutsLimit - workingOrDrivingMinutes > 0 ? totalMinutsLimit - workingOrDrivingMinutes : 0;
          }

          var _extraWrkHrs = workingOrDrivingMinutes > totalMinutsLimit ? workingOrDrivingMinutes - totalMinutsLimit : 0;

          workingOrDrivingMinutes = workingOrDrivingMinutes > totalMinutsLimit ? totalMinutsLimit : workingOrDrivingMinutes;
          var wrkHrsPercentage = workingOrDrivingMinutes / totalMinutsLimit * 100;
          var noOfCircleLinesToRemove = totalCircle - Math.round(Math.round(wrkHrsPercentage) / 100 * totalCircle);

          wrkHrsPercentage = Number()._isFloat(wrkHrsPercentage) && Number()._isFloat(wrkHrsPercentage.toFixed(2)) ? wrkHrsPercentage.toFixed(2) : Math.round(wrkHrsPercentage);

          // update overall percentage and remaining time
          overAllPercentElement.html(wrkHrsPercentage + '%');

          var _totalOrRemainngHours = parseInt(workingOrDrivingMinutes / 60);
          _totalOrRemainngHours = _totalOrRemainngHours.toString().length === 2 ? _totalOrRemainngHours : '0' + _totalOrRemainngHours;
          var _convertedMinutes = workingOrDrivingMinutes % 60;
          _convertedMinutes = _convertedMinutes.toString().length === 2 ? _convertedMinutes : '0' + _convertedMinutes;
          updateCircleOrBar(greenCircleElement, noOfCircleLinesToRemove, greenWrkHrsCircleArry);

          if (_extraWrkHrs > 0) {
            updateExtraWrksHrs(_extraWrkHrs, redCircleElement);
          }
          //Bugfix 103799 - ensure _extraWrkHrs is in hours format here - to 1 decimal place
          _extraWrkHrs = (_extraWrkHrs / 60).toFixed(1);
          _extraWrkHrs = _extraWrkHrs > 4 ? 4 : _extraWrkHrs;
          var remaingHourTextSvg = _extraWrkHrs > 0 ? '<tspan x="15" dy="0.8em" fill="#E85D10"> +' + _extraWrkHrs + '</tspan>' : '';
          getSvgElementByID(remaingWrktimeLabel).html(_totalOrRemainngHours + 'h' + ' ' + _convertedMinutes + 'm' + remaingHourTextSvg);
        }

        function updateExtraWrksHrs(extraWrkHrsMinutes, extrWrkHrsCircleElement) {
          extraWrkHrsMinutes = extraWrkHrsMinutes > totlExtraWrkHrsLimitMinutes ? totlExtraWrkHrsLimitMinutes : extraWrkHrsMinutes;
          var extrsWrkHrsPercentage = extraWrkHrsMinutes / totlExtraWrkHrsLimitMinutes * 100;
          var noOfCircleLinesToRemove = totalCircle - Math.round(Math.round(extrsWrkHrsPercentage) / 100 * totalCircle);
          updateCircleOrBar(extrWrkHrsCircleElement, noOfCircleLinesToRemove, redWrkHrsCircleArry);
        }

        function updateCircleOrBar(element, noOfCircleLinesOrBarToRemove, elementArray) {
          $timeout(function () {
            for (var j = totalCircle; j >= noOfCircleLinesOrBarToRemove; j--) {
              element.append(elementArray[j]).hide().show('slow');
            }
          }, 0);
        }

        // Modification for the Loading Imporvement

        var loadDependentDataFromServer = function loadDependentDataFromServer(deviceID) {
          scope.isDataNotAvailable = false;
          DriverWrkHrsWidgetService.getDriverWorkingHoursListForDevice(deviceID).then(function (result) {
            scope.dataLoadingFinished = true;

            if (result.dataList && result.dataList.length === 1) {
              scope.isDataFromHistoryList = false;
              DriverWrkHrsSVGWidgetService.setLastReadDeviceWorkingHours(result.dataList[0]);
              _handleRowSlectEvnt({ selectedRow: result.dataList[0] });
            } else {
              scope.isDataNotAvailable = true;
            }
          });
        };
        var getSetData = function getSetData(widget) {
          var loginID = AuthenticationService.GetLoginID();
          widget = loginID.Account + '_' + loginID.username + '_' + widget;
          var stateData = stateManagerService.getStateData();
          var set = stateData && stateData[widget] ? stateData[widget] : {};
          return set;
        };
        var maxGetInitialDataRetries = 30;
        var currentParentRowResEvent = scope.$on('resDataUpdate', function (event, data) {
          if (maxGetInitialDataRetries < 0 || scope.isWidgetPostInitFinished) {
            currentParentRowResEvent();
            return;
          }
          console.info(' Driver Working Status Widget Requesting Parent for Data ..');
          --maxGetInitialDataRetries;
          var set = getSetData(data.widget);
          var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];

          // parents First tab must always retrun a  valid selected row
          if (data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value) || data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues)) {
            scope.isWidgetPreInitFinished = true;
            scope.isWidgetPostInitFinished = true;
            _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);
          } else {
            // Repeatedly try to get the data from parent .
            if (maxGetInitialDataRetries > 0) {
              $timeout(function () {
                if (!scope.isWidgetPostInitFinished) {
                  $rootScope.$broadcast('reqDataUpdate');
                }
              }, 100);
            } else {
              console.error('Max Retries exceeded to get the current Parent data for Driver Working Status Widget..');
              scope.isWidgetPreInitFinished = true;
              scope.isWidgetPostInitFinished = true;
              scope.isDataNotAvailable = true;
              currentParentRowResEvent();
            }
          }
        });

        var dataStateUpdateListener = scope.$on('dataStateUpdate', function (event, data) {
          if (scope.isWidgetPostInitFinished) {
            var set = getSetData(data.widget);
            _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
          } else {
            //console.log('Ignoring dataState update from widget: ' + data.widget);
          }
        });

        /*     var tachoHistoryWidgteDateEvent = scope.$on('tacho_detail_widget_event', function (event, data) {
              if (data.eventType === 'date_change') {
                var set = getSetData('tachoHistoryWidget');
                _handleDataUpdate('dashboard.tachohistory', 0, set['tab_' + 0 + '_selectedRow'].value, 'tachoHistoryWidget');
              } else {
                //console.log('Ignoring dataState update from widget: ' + data.widget);
              }
             }); */

        function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName) {
          var set;

          switch (dashboardName) {
            case 'dashboard.driverWrkHrsDashboard': // contains only tab 0
            case 'dashboard.tachohistory':
              switch (tabNumber) {
                case 0:
                  if (!_.isEmpty(rowData)) {
                    _handleRowSlectEvnt({ selectedRow: rowData });
                  } else {
                    scope.isDataNotAvailable = true;
                  }

                  break;
              }
              break;
            case 'dashboard.fmsDashboard':
            case 'dashboard.vehicleList':
              switch (tabNumber) {
                case 0:
                  // first tab use device id to  load data from server
                  set = getSetData(widgetName);
                  rowData = set['tab_' + 0 + '_selectedRow'];
                  if (!_.isEmpty(rowData.value)) {
                    loadDependentDataFromServer(rowData.value.deviceid);
                  } else {
                    scope.isDataNotAvailable = true;
                  }
                  break;
                case 1: // use the Service stored Data
                case 2:
                case 3:
                  rowData = DriverWrkHrsSVGWidgetService.getLastReadDeviceWorkingHours();
                  if (!_.isEmpty(rowData)) {
                    _handleRowSlectEvnt({ selectedRow: rowData });
                  } else {
                    rowData = set['tab_' + 0 + '_selectedRow'];
                    if (!_.isEmpty(rowData.value)) {
                      loadDependentDataFromServer(rowData.value.deviceid);
                    } else {
                      scope.isDataNotAvailable = true;
                    }
                  }
                  break;
              }
              break;

          }
        }

        scope.$on('$destroy', function () {

          dataStateUpdateListener();
          currentParentRowResEvent();
          //tachoHistoryWidgteDateEvent();
        });

        scope.timeRadioTypeChange = function () {
          localStorageService.set('selectedWorkingHourType.' + loginid.Account + '.' + loginid.username, {
            workingHourType: scope.timeRadio.type,
            svgRadioType: scope.timeRadio.svgRadioType,
            viewType: {
              dailyView: scope.timeRadio.viewType.dailyView,
              weeklyView: scope.timeRadio.viewType.weeklyView
            }
          });
          _refreshSvgBasedOnLastSelectedData();
        };

        scope.svgRadioTypeChange = function () {
          localStorageService.set('selectedWorkingHourType.' + loginid.Account + '.' + loginid.username, {
            workingHourType: scope.timeRadio.type,
            svgRadioType: scope.timeRadio.svgRadioType,
            viewType: {
              dailyView: scope.timeRadio.viewType.dailyView,
              weeklyView: scope.timeRadio.viewType.weeklyView
            }
          });
          _refreshSvgBasedOnLastSelectedData();
        };
        scope.expandPane = function () {
          scope.isPaneExpanded = !scope.isPaneExpanded;
          if (scope.isPaneExpanded) {
            $('#collapse1').hide();
          } else {
            _refreshSvgBasedOnLastSelectedData();
            $('#collapse1').delay(100).show(0);
          }
        };
        scope.dataLoadingFinished = true;
      };

      if (getSvgDocument()) {
        init();
      } else {
        element.on('load', init);
      }
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  'use strict';

  HeaderNavController.$inject = ["$scope", "$translate", "$uibModal", "AuthenticationService", "languageService", "$state", "tmhDynamicLocale", "$rootScope", "$locale", "commonTrackService", "$interval", "$filter", "messageService", "toastService", "AdmStatusService", "PubSubService", "localStorageService", "$window", "errorHandlingService", "userPreferenceService", "widgetSettingsCreatorService"];
  angular.module('betosyswebapp').directive('headerNav', HeaderNavComponent);

  /* @ngInject */
  function HeaderNavComponent() {
    var directive = {
      bindToController: {
        //user:'='
      },
      controller: HeaderNavController,
      controllerAs: 'vm',
      restrict: 'E',
      templateUrl: 'components/common/directives/header/header-nav.component.tpl.html',
      replace: true
    };
    return directive;
  }

  //HeaderUserController.$inject = ['$scope', 'AuthenticationService', '$state', '$uibModal'];

  /** @ngInject */
  function HeaderNavController($scope, $translate, $uibModal, AuthenticationService, languageService, $state, tmhDynamicLocale, $rootScope, $locale, commonTrackService, $interval, $filter, messageService, toastService, AdmStatusService, PubSubService, localStorageService, $window, errorHandlingService, userPreferenceService, widgetSettingsCreatorService) {
    $scope.isLogin = AuthenticationService.IsLogin();
    $scope.currentLanguage = languageService.getLanguageSettings().language;
    var msgDeviceChangedEvent, msgNewEvent, msgEvent, commandNewEvent;
    $translate.use($scope.currentLanguage);
    $scope.currState = $state;
    $scope.isDefaultNav = true;
    var intervalObj;
    var messageIntervalObj;
    $scope.messageList = [];
    $scope.notifictionList = [];
    $scope.glued = true;
    $scope.notoficationCount = 0;
    $scope.showChatWindowToggle = false;
    $scope.groupMessages = [];
    $scope.selectedGroup = null;
    $scope.showGroupChat = false;
    $scope.groupMsgRadio = { ackMsg: 'Ok' };
    $scope.availableGroups = [];
    $scope.filteredGroups = [];
    var groupMsgEvent, groupMsgNewEvent, groupMsgReadEvent;
    $scope.pendingGroupMessages = {};
    $scope.isGroup = false;
    $scope.groupUnreadCount = 0;
    $scope.totalUnreadCount = 0;
    $scope.deviceCache = {};
    $scope.seenGroupMessages = {};
    $scope.locallyReadGroups = {};
    $scope.groupCache = {};
    $scope.groupMessagesCache = {};

    $scope.getDeviceInfo = function (deviceIdOrObject) {
      var deviceId;
      if ((typeof deviceIdOrObject === 'undefined' ? 'undefined' : _typeof(deviceIdOrObject)) === 'object' && deviceIdOrObject !== null) {
        deviceId = deviceIdOrObject.deviceId || deviceIdOrObject.deviceID;
      } else {
        deviceId = deviceIdOrObject;
      }

      if (!deviceId) {
        return null;
      }

      if ($scope.deviceCache[deviceId]) {
        return $scope.deviceCache[deviceId];
      }

      var device = null;

      if ($scope.messageList && $scope.messageList.length > 0) {
        device = $scope.messageList.find(function (msg) {
          return msg.deviceID === deviceId;
        });
      }

      if (!device && $scope.msgVehicleSettings && $scope.msgVehicleSettings.source) {
        var vehicleDevice = $scope.msgVehicleSettings.source.find(function (vehicle) {
          return vehicle.deviceID === deviceId;
        });
        if (vehicleDevice) {
          device = {
            deviceID: vehicleDevice.deviceID,
            deviceDesc: vehicleDevice.description || vehicleDevice.deviceDesc,
            driverDesc: vehicleDevice.driverDesc || vehicleDevice.description,
            deviceAvailableStatusColor: vehicleDevice.deviceAvailableStatusColor || vehicleDevice.deviceAvilableStatusColor || '#ccc',
            latestJobStatusDesc: vehicleDevice.latestJobStatusDesc || '?'
          };
        }
      }

      if (device) {
        $scope.deviceCache[deviceId] = device;
      }

      return device;
    };

    $scope.getDeviceIdFromMember = function (member) {
      if ((typeof member === 'undefined' ? 'undefined' : _typeof(member)) === 'object' && member !== null) {
        // Return deviceId if available, otherwise return userId
        return member.deviceId || member.deviceID || member.userId;
      }
      return member;
    };

    $scope.getMemberDescription = function (member) {
      if ((typeof member === 'undefined' ? 'undefined' : _typeof(member)) === 'object' && member !== null) {
        return member.description || '';
      }
      return '';
    };

    $scope.getDispatcherName = function (member) {
      if (!member || !member.userId || member.userId.trim() === '') {
        return 'Unknown Dispatcher';
      }
      if (member.userId === $scope.userName) {
        return $scope.messagemodel && $scope.messagemodel.userDesc ? $scope.messagemodel.userDesc : member.userId;
      }
      return member.userId;
    };

    $scope.syncGroupData = function () {
      $scope.groupCache = {}; // Clear cache
      return loadavailablegroups().then(function () {
        // Update selected group with latest data if it exists
        if ($scope.selectedGroup && $scope.availableGroups) {
          var updatedGroup = $scope.availableGroups.find(function (g) {
            return g.groupId === $scope.selectedGroup.groupId;
          });
          if (updatedGroup) {
            var wasShowingMembers = $scope.showGroupMembers;
            $scope.selectedGroup = updatedGroup;
            $scope.showGroupMembers = wasShowingMembers;
          }
        }
      });
    };

    $scope.selctedDeviceMessage = _restMessageHolder();
    $scope.chatparticipant = {
      filterTxt: ''
    };
    $scope.chat = {
      messageText: null
    };
    $scope.deviceCache = {};
    $scope.chatContainer = {
      alignDirection: 0, // 0 right
      isChatWindowclosed: 1
    };
    $scope.msgRadio = {
      ackMsg: 'Ok'
    };
    function _restMessageHolder() {
      return {
        deviceId: null,
        message: null,
        isNew: false,
        currentlySelectedIndex: null
      };
    }
    $scope.$watch(function () {
      return AuthenticationService.IsLogin();
    }, function (data) {
      $scope.isLogin = data;
      if (data) {
        var localstorageSettings = commonTrackService.getGtsLocalStorageSettings();
        if (localstorageSettings && localstorageSettings.SideBarStatus && localstorageSettings.SideBarStatus.isCollapsed || !localstorageSettings || !localstorageSettings.SideBarStatus) {
          var sideBarStatus = AdmStatusService.getSideBarStatus();
          if (!sideBarStatus.isCollapsed) {
            AdmStatusService.toggleSidebar();
          }
        }
        _initListeners();
        $scope.isDefaultNav = false;
        $scope.userName = AuthenticationService.GetLoginUserName();
        saveLanguage();
        commonTrackService.initAuthdata();
        var loginID = AuthenticationService.GetLoginID();

        commonTrackService.saveGeneralSettings({
          login: {
            accountID: loginID.Account
          }
        });
        commonTrackService.updateGtsAccountSettings().then(function () {
          return commonTrackService.updateGtsUserSettings();
        }).then(function () {
          commonTrackService.setFleetServerDetails().then(function (fleetServerDetails) {
            loaddevice();
            loadavailablegroups();
            messageService.initialize();
            _getMessages();
            if (!fleetServerDetails.instantMessageEnabled) {
              _startMessageRefreshInterval(1000 * 60);
            }
          }).finally(function () {
            var portViewName = commonTrackService.getViewPortName();
            if (portViewName === 'XS' || portViewName === 'SM' || portViewName === 'MD') {
              if ($state.previous.name === 'login') {
                $state.go('trackMap');
              }
            }
            var notificationProperties = commonTrackService.getNotifications();
            $scope.notifictionList = notificationProperties.notificationList;
            if (intervalObj) {
              $interval.cancel(intervalObj);
            }
            notifyQueueDetailList();
            _startNotificationRefreshInterval();
          });
        });
      } else {
        destroyInstance();
      }
    }, true);

    $scope.userName = AuthenticationService.GetLoginUserName();

    var loaddevice = function loaddevice() {
      return commonTrackService.getDeviceComboList().then(function (vehicleList) {
        $scope.msgVehicleSettings.source = vehicleList;
      });
    };

    $scope.setLang = function (langKey) {
      // You can change the language during runtime
      $translate.use(langKey);
      $scope.currentLanguage = langKey;
      $rootScope.model = { selectedLocale: langKey };
      tmhDynamicLocale.set(langKey);
      $rootScope.$locale = $locale;
      $scope.locale = $locale;
      saveLanguage();
    };

    var saveLanguage = function saveLanguage() {
      if (languageService.getLanguageSettings().language !== '' && languageService.getLanguageSettings().language === $scope.currentLanguage) {
        $translate.use(languageService.getLanguageSettings().language);
      } else {
        var currentLanguageSettings = languageService.getLanguageSettings();
        currentLanguageSettings.language = $rootScope.model.selectedLocale;
        languageService.saveLanguageSettings(currentLanguageSettings);
        $translate.use(languageService.getLanguageSettings().language);
      }
      commonTrackService.init();
    };

    $scope.open = function (size) {
      $uibModal.open({
        templateUrl: 'components/login/pswdChange.tpl.html',
        controller: 'passwordController',
        size: size,
        resolve: {
          errorCode: function errorCode() {
            return '';
          }
        }
      });
    };

    $scope.clickHide = function () {
      if ($scope.isLogin) {
        $('.sideMenu').toggleClass('sideMenuHide');
        $('.mainContent').toggleClass('mainContentFullWidth');
        if (angular.element('.listViewGrid').length > 0) {
          //judge whether the grid is initialized.
          $('.listViewGrid').jqxGrid('refresh');
        }
        if (angular.element('.listViewFilter').length > 0) {
          $('.listViewFilter').jqxComboBox('refresh');
        }
      }
    };

    $scope.logout = function () {
      _closeAllWindows();
      $state.go('logout', { reload: false });
    };

    function _closeAllWindows() {
      $scope.closeChatWindow(true);
      $scope.showChatWindowToggle = false;
      $scope.showGroupChat = false;
      $scope.selectedGroup = null;

      if (intervalObj) {
        $interval.cancel(intervalObj);
      }
      cancelExistingMessageInterval();
      intervalObj = undefined;
      messageIntervalObj = undefined;
      $scope.messageList = [];
      $scope.msgUnseenCount = 0;
      $scope.groupUnreadCount = 0;
      $scope.totalUnreadCount = 0;
      $scope.deviceCache = {};
      $scope.groupCache = {};
      $scope.groupMessagesCache = {};
      $scope.locallyReadGroups = {};
      $scope.seenGroupMessages = {};
      $scope.pendingGroupMessages = {};
      messageService.deInitialize();
      $scope.chatContainer.isChatWindowclosed = 1;
      $scope.selctedDeviceMessage = _restMessageHolder();

      // Close any open modals/dialogs
      var backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      var modals = document.querySelectorAll('.modal');
      modals.forEach(function (modal) {
        modal.style.display = 'none';
      });
    }

    $scope.$watch('currState.current.name', function (newValue) {
      if (newValue) {
        $scope.isDefaultNav = newValue === 'home' || newValue === 'login' ? true : false;
      }
    }, true);

    $scope.messagemodel = {};
    /**
     *  Get the message for initial loading and also when auto refresh.
     */
    function _getMessages() {
      loadavailablegroups();
      loaddevice();

      if ($scope.showGroupChat && $scope.selectedGroup) {
        _getGroupMessages();
        return;
      }

      if ($scope.showGroupChat) {
        return;
      }

      commonTrackService.getDriverMessages($scope.messageList, !$scope.chatContainer.isChatWindowclosed && $scope.selctedDeviceMessage.message ? $scope.selctedDeviceMessage.message.deviceID : null).then(function (driverMessageProperties) {
        $scope.messagemodel = driverMessageProperties;
        $scope.msgUnseenCount = driverMessageProperties.totalUnreadMessages || 0;

        if (!$scope.chatContainer.isChatWindowclosed && $scope.selctedDeviceMessage.message) {
          $scope.messageList = driverMessageProperties.driverDevices;
          var chatDeviceMessagesFromServer = driverMessageProperties.driverDevices[_getDeviceMessageIndexByDeviceId($scope.selctedDeviceMessage.message.deviceID)].messages;
          if (chatDeviceMessagesFromServer && chatDeviceMessagesFromServer.length > 0) {
            _generateMsgHistoryView(chatDeviceMessagesFromServer.slice($scope.msgProperties.messages.length + $scope.msgProperties.ackmessages.length), false);
          }
        } else {
          $scope.messageList = driverMessageProperties.driverDevices;
        }

        $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);

        if ($scope.totalUnreadCount > 0 && $scope.chatContainer.isChatWindowclosed) {
          toastService.showErrorToast({
            type: 'I',
            message: $translate.instant('deviceMessaging.youGOt') + $scope.totalUnreadCount + $translate.instant('deviceMessaging.newMessages')
          });
        }
      }).catch(function (error) {
        // Only log if it's not an abort or network issue
        if (error && error.status !== -1 && error.xhrStatus !== 'abort') {
          console.error('Error loading driver messages:', error);
        }
      }).finally(function () {
        // Apply the appropriate filter based on current tab
        if ($scope.showGroupChat) {
          $scope.onMessageGroupFilter();
        } else {
          $scope.onMessageDeviceFilter();
        }
      });
    }

    $scope.openCommandDialog = function (type, msg) {
      var modelDialogData = {
        type: type,
        msg: msg
      };
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'components/navbar/commands.tpl.html',
        controller: 'CommandController',
        resolve: {
          messages: function messages() {
            return modelDialogData;
          }
        }
      });

      modalInstance.result.then(function () {}, function () {
        //$log.info('Modal dismissed at: ' + new Date());
      });
    };

    $scope.notificationClick = function (index) {
      $scope.notifictionList[index]._isNotificationRead = true;
      commonTrackService.setReadNotification($scope.notifictionList[index].timestamp);
      if ($scope.notifictionList[index]._notificationType === 'status') {
        $state.go('reports.vehicleDetail', {
          'reportName': 'NotifyQueueDetail',
          'vehicleId': $scope.notifictionList[index].deviceid,
          'dateFrom': commonTrackService.getDateTime('startOfDay', 'yyyy-MM-ddTHH:mm:ss'),
          'dateTo': commonTrackService.getDateTime('present', 'yyyy-MM-ddTHH:mm:ss')
        });
      }
      $scope.notoficationCount--;
    };

    /**
     *   event listners are not initialized after login ( only initialized after page refresh ),
     *   method will  be called to initialize the event listeners  after the login
     * @private
     */
    function _initListeners() {
      msgDeviceChangedEvent = $scope.$on('msg-device-changed', function () /* event, data */{
        // _filterDeviceSpecificMsg(data);
      });

      msgNewEvent = $scope.$on('newMsgEvent', function () {
        var LstLocationSectedData = commonTrackService.getsetLastLocatioWidgetData();
        if (LstLocationSectedData && LstLocationSectedData.selectedRow && LstLocationSectedData.selectedRow.deviceid) {
          $scope.showChatWindowToggle = true; // show the chat participant window
          // find and load the chat history for the related message
          $scope.deviceMessageClick(_getDeviceMessageIndexByDeviceId(LstLocationSectedData.selectedRow.deviceid));
          $scope.deviceMessage.deviceID = LstLocationSectedData.selectedRow.deviceid;
        }
      });

      commandNewEvent = $scope.$on('newCommandEvent', function () {
        $scope.openCommandDialog('new');
      });

      msgEvent = $scope.$on('msg-event', function (event, data) {
        data.drivermessage = data.msg;
        data.messagetimestamp = data.datetime;
        var _tmpMsgHistory = [data];
        _getMessages(_tmpMsgHistory, true);
      });

      groupMsgEvent = $scope.$on('group-msg-event', function (event, data) {
        if ($scope.showGroupChat && $scope.selectedGroup && data.groupId === $scope.selectedGroup.groupId && !$scope.chatContainer.isChatWindowclosed) {
          data._msgType = data.senderId === $scope.userName ? 'sent' : 'received';
          data._timeShortDes = $filter('date')(new Date(Number(data.messagetimestamp) * 1000), 'EEE HH:mm');

          if (data._msgType === 'sent') {
            data._messageProgress = 'sentCompleted';
          }

          $scope.groupMessages.push(data);
          // Update the cached messages for this group
          if ($scope.groupMessagesCache[data.groupId]) {
            $scope.groupMessagesCache[data.groupId].messages.push(data);
            $scope.groupMessagesCache[data.groupId].timestamp = Date.now(); // Refresh cache timestamp
          }

          // Ensure unread count is 0 for open group
          for (var j = 0; j < $scope.availableGroups.length; j++) {
            if ($scope.availableGroups[j].groupId === data.groupId) {
              $scope.availableGroups[j].unreadMessageCount = 0;
              break;
            }
          }

          $scope.$apply();
        } else {
          if (data.groupId && data.senderId !== $scope.userName) {
            delete $scope.groupMessagesCache[data.groupId];

            for (var i = 0; i < $scope.availableGroups.length; i++) {
              if ($scope.availableGroups[i].groupId === data.groupId) {
                $scope.availableGroups[i].unreadMessageCount = ($scope.availableGroups[i].unreadMessageCount || 0) + 1;
                break;
              }
            }

            var totalUnreadInEvent = 0;
            for (var g = 0; g < $scope.availableGroups.length; g++) {
              totalUnreadInEvent += $scope.availableGroups[g].unreadMessageCount || 0;
            }
            $scope.groupUnreadCount = totalUnreadInEvent;
            $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);
          }
        }
      });

      groupMsgNewEvent = $scope.$on('newGroupMsgEvent', function (event, data) {
        if (data && data.groupId) {
          $scope.showChatWindowToggle = true;
          for (var i = 0; i < $scope.availableGroups.length; i++) {
            if ($scope.availableGroups[i].groupId === data.groupId) {
              $scope.selectGroup($scope.availableGroups[i]);
              break;
            }
          }
        }
      });

      var chatMessageWatch = $scope.$watch('selctedDeviceMessage.message', function (hasChatMessage) {

        if (hasChatMessage !== null || hasChatMessage === true) {
          //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
          // send event to stop the auto refresh when chat window is opened
          $rootScope.$broadcast('chat-window-open-evt');
        }
      }, true);

      var chatWindowOpenWatch = $scope.$watch('chatContainer.isChatWindowclosed', function (isClosed) {
        cancelExistingMessageInterval();
        // chat window is open cance existing refreh interval and start new one with 5000 mili
        if (isClosed) {
          messageIntervalObj = $interval(function () {
            _getMessages();
          }, 1000 * 60);
        } else if (isClosed === 0) {
          messageIntervalObj = $interval(function () {
            _getMessages();
          }, 1000 * 5);
        }
      }, true);

      $scope.$on('$destroy', function () {
        destroyInstance();
        chatWindowOpenWatch();
        chatMessageWatch();
      });
    }

    var notifyQueueDetailList = function notifyQueueDetailList() {
      commonTrackService.getNotificationListCurentDay().then(function (data) {
        var _ntqTmp = data.dataList;
        for (var i = 0; i < _ntqTmp.length; i++) {
          var _isFound = false;
          _ntqTmp[i]._notificationType = 'status';
          _ntqTmp[i]._dateTimeDescription = $filter('date')(new Date(), 'EEE') + _ntqTmp[i].datetime.substring(10, 16);
          for (var j = $scope.notifictionList.length - 1; j >= 0; j--) {
            if ($scope.notifictionList[j]._notificationType === 'status' && $scope.notifictionList[j].deviceid === _ntqTmp[i].deviceid && $scope.notifictionList[j].timestamp === _ntqTmp[i].timestamp) {
              _isFound = true;
              break;
            }
          }
          if (!_isFound) {
            var readNotification = commonTrackService.getFleetSettings().readNotification || [];
            var _isalreadyRead = false;
            for (var k = 0; k < readNotification.length; k++) {
              if (_ntqTmp[i].timestamp === readNotification[k]) {
                _isalreadyRead = true;
                break;
              }
            }
            if (!_isalreadyRead) {
              $scope.notifictionList.unshift(_ntqTmp[i]);
              $scope.notoficationCount++;
            }
          }
        }
      });
    };

    function _startNotificationRefreshInterval() {
      intervalObj = $interval(function () {
        notifyQueueDetailList();
      }, 1000 * 60);
    }

    function _startMessageRefreshInterval(interval) {
      cancelExistingMessageInterval();

      messageIntervalObj = $interval(function () {
        _getMessages();
      }, interval);
    }

    function destroyInstance() {
      _closeAllWindows();

      if (msgEvent) {
        msgEvent();
        msgEvent = null;
      }
      if (msgNewEvent) {
        msgNewEvent();
        msgNewEvent = null;
      }
      if (commandNewEvent) {
        commandNewEvent();
        commandNewEvent = null;
      }
      if (msgDeviceChangedEvent) {
        msgDeviceChangedEvent();
        msgDeviceChangedEvent = null;
      }
      if (groupMsgEvent) {
        groupMsgEvent();
        groupMsgEvent = null;
      }
      if (groupMsgNewEvent) {
        groupMsgNewEvent();
        groupMsgNewEvent = null;
      }
      if (groupMsgReadEvent) {
        groupMsgReadEvent();
        groupMsgReadEvent = null;
      }
      if (intervalObj) {
        $interval.cancel(intervalObj);
      }

      cancelExistingMessageInterval();

      intervalObj = undefined;
      messageIntervalObj = undefined;
      messageService.deInitialize();
    }

    PubSubService.subscribe('_TOGGLE_SIDEBAR_', function () {
      var localstorageSettings = commonTrackService.getGtsLocalStorageSettings();
      if (localstorageSettings) {
        localstorageSettings.SideBarStatus = AdmStatusService.getSideBarStatus();
        var loginID = AuthenticationService.GetLoginID();
        localStorageService.set('userSettings.' + loginID.Account + '.' + loginID.username, localstorageSettings);
      }
    }, $scope);

    $scope.clearLocalStroageAndCookies = function () {
      errorHandlingService.handleForErrorNumber(52000);
    };

    /**
     *  Saves User Local Storage values to DB ,
     *  if isOnLogOut is specified it will not show if automated saving returned success .
     *  errors are shown when automated local storage saves are failed .
     * @param isOnLogOut
     */
    $scope.saveLocalStorage = function (isOnLogOut) {
      userPreferenceService.saveLocalStorage().then(function () {
        if (!isOnLogOut) {
          toastService.showSuccessToast($translate.instant('form.save.' + 'success'));
        }
      }, function (result) {
        console.log(result.data);
        errorHandlingService.handleForErrorNumber(52002);
      });
    };
    $scope.msgVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'deviceID'
    });
    $scope.restoreLocalStorage = function () {
      errorHandlingService.handleForErrorNumber(52001);
    };

    $scope.$on('errorEvent', function (event, data) {
      if (data.errorNumber === 52000 && data.type === 'yes') {
        userPreferenceService.clearLocalStroageAndCookies().then(function () {
          $window.location.reload();
        });
      }
      if (data.errorNumber === 52001 && data.type === 'yes') {
        userPreferenceService.restoreLocalStorage().then(function () {
          $window.location.reload();
        }, function (result) {
          console.log(result.data);
          errorHandlingService.handleForErrorNumber(52003);
        });
      }
    });

    $scope.msgProperties = {
      messages: []
    };

    /**
     * Executed whhen a message entry is selected fromt the chat participant window.
     * isSlected is of the pervious sleected should be set to fasle , and the new message shouls be true
     * $scope.selctedDeviceMessage should be update ( reset pervious object , populate with the selected message)
     *
     * @param {*} clickedDeviceMessageIndex
     */
    $scope.deviceMessageClick = function (clickedDeviceMessageIndex) {

      if (clickedDeviceMessageIndex !== null) {
        if ($scope.selctedDeviceMessage && $scope.selctedDeviceMessage.currentlySelectedIndex !== null) {
          $scope.messageList[$scope.selctedDeviceMessage.currentlySelectedIndex].isSlected = false;
        }
        $scope.messageList[clickedDeviceMessageIndex].isSlected = true;

        $scope.selctedDeviceMessage = _restMessageHolder();
        $scope.selctedDeviceMessage.message = $scope.messageList[clickedDeviceMessageIndex];
        $scope.selctedDeviceMessage.currentlySelectedIndex = clickedDeviceMessageIndex;
        $scope.msgProperties.messages = []; // reset previous message history data
        $scope.msgProperties.ackmessages = [];
        $scope.chatContainer.isChatWindowclosed = 0;

        if ($scope.msgUnseenCount > 0) {
          $scope.msgUnseenCount = 0;
          $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);
        }

        _getMessages();
        _startMessageRefreshInterval(5000);

        setTimeout(function () {
          $('#send-message-input').focus();
        }, 100);
      }
    };

    $scope.applyFilter = function (filterType) {
      // Apply filter based on the tab
      if (filterType === 'device') {
        if ($scope.chatparticipant.deviceFilterTxt && $scope.chatparticipant.deviceFilterTxt !== '') {
          $scope.messageList = $scope.messagemodel.driverDevices.filter(function (message) {
            return message.driverDesc.toLowerCase().indexOf($scope.chatparticipant.deviceFilterTxt.toLowerCase()) > -1 || message.deviceDesc.toLowerCase().indexOf($scope.chatparticipant.deviceFilterTxt.toLowerCase()) > -1;
          });
        } else {
          $scope.messageList = $scope.messagemodel.driverDevices;
        }
      } else if (filterType === 'group') {
        if ($scope.chatparticipant.groupFilterTxt && $scope.chatparticipant.groupFilterTxt !== '') {
          $scope.filteredGroups = $scope.availableGroups.filter(function (group) {
            var groupName = (group.groupName || '').toLowerCase();
            var groupId = (group.groupId || '').toLowerCase();
            var filterText = $scope.chatparticipant.groupFilterTxt.toLowerCase();
            return groupName.indexOf(filterText) > -1 || groupId.indexOf(filterText) > -1;
          });
        } else {
          $scope.filteredGroups = $scope.availableGroups;
        }
      }
    };

    $scope.onMessageDeviceFilter = function () {
      $scope.applyFilter('device');
    };

    $scope.onMessageGroupFilter = function () {
      $scope.applyFilter('group');
    };

    $scope.onFilterChange = function () {
      if ($scope.showGroupChat) {
        $scope.chatparticipant.groupFilterTxt = $scope.chatparticipant.filterTxt || '';
        $scope.applyFilter('group');
      } else {
        $scope.chatparticipant.deviceFilterTxt = $scope.chatparticipant.filterTxt || '';
        $scope.applyFilter('device');
      }
    };

    /**
     * returns related index of the message based on the device id .
     *
     * @param {*} deviceID
     * @returns
     */
    function _getDeviceMessageIndexByDeviceId(deviceID) {

      for (var i = 0; i < $scope.messagemodel.driverDevices.length; i++) {
        if ($scope.messagemodel.driverDevices[i].deviceID === deviceID) {
          return i;
        }
      }
      return 0; // only for testing . should be replaced with -1 or null ;
    }

    // SCL-11320: Helper to get the byte size of a message string (UTF-8 encoded)
    function getMessageByteSize(str) {
      return encodeURIComponent(str).replace(/%[A-F\d]{2}/g, 'X').length;
    }

    // SCL-11320: Max message byte size that fits in the server storage after encryption
    var MAX_MESSAGE_SIZE = 319;

    /**
     * Send message to a Carpc , POST API is called and the response is used to update the overvall message count and the related chat history
     */
    $scope.sendMsg = function () {
      if ($scope.chat.messageText !== null && $scope.chat.messageText !== '') {
        if (getMessageByteSize($scope.chat.messageText) > MAX_MESSAGE_SIZE) {
          $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
          return;
        }
        // should call POST API, and the response should be used to update the message count, and chat window messages

        // mock value should be replaced
        var tmpMessage = {
          drivermessage: $scope.chat.messageText,
          _msgType: 'sent',
          messagetimestamp: moment().unix(),
          _messageProgress: 'sentFailed'
        };

        $scope.isGroup = false;

        commonTrackService.saveDriverMessage($scope.selctedDeviceMessage.message.deviceID, $scope.chat.messageText, $scope.msgRadio.ackMsg, $scope.isGroup).then(function () {
          tmpMessage._messageProgress = 'sentCompleted';
        }, function () {
          tmpMessage._messageProgress = 'sentFailed';
        }).finally(function () {
          $scope.msgProperties.messages.push(tmpMessage);
        });
      }
      $scope.chat.messageText = '';
    };

    $scope.messageChanged = function () {
      var inputId = $scope.showGroupChat ? '#send-group-message-input' : '#send-message-input';
      var messageText = $(inputId).val();
      var messageLength = messageText.length;
      if (messageLength === 300) {
        $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
      } else if (messageLength > 0 && getMessageByteSize(messageText) > MAX_MESSAGE_SIZE) {
        $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
      }
    };

    // SCL-9873 Group messaging functions
    $scope.sendGroupMsg = function () {
      if ($scope.chat.messageText !== null && $scope.chat.messageText !== '' && $scope.selectedGroup) {
        if (getMessageByteSize($scope.chat.messageText) > MAX_MESSAGE_SIZE) {
          $window.alert($translate.instant('deviceMessaging.characterLimitReached'));
          return;
        }
        var tempId = Date.now() + '_' + Math.random();
        var tmpMessage = {
          drivermessage: $scope.chat.messageText,
          _msgType: 'sent',
          messagetimestamp: moment().unix(),
          _messageProgress: 'sentCompleted',
          _tempId: tempId,
          _timeShortDes: $filter('date')(new Date(), 'EEE HH:mm'),
          senderId: $scope.userName,
          senderDesc: $scope.messagemodel.userDesc || $scope.userName,
          _hasAckMessage: false
        };

        $scope.pendingGroupMessages[tempId] = tmpMessage;
        $scope.groupMessages.push(tmpMessage);

        if ($scope.groupMessagesCache[$scope.selectedGroup.groupId]) {
          $scope.groupMessagesCache[$scope.selectedGroup.groupId].messages.push(tmpMessage);
          $scope.groupMessagesCache[$scope.selectedGroup.groupId].timestamp = Date.now();
        }

        $scope.isGroup = true;

        commonTrackService.saveDriverMessage($scope.selectedGroup.groupId, $scope.chat.messageText, $scope.groupMsgRadio.ackMsg, $scope.isGroup).then(function () {
          tmpMessage._messageProgress = 'sentCompleted';
          var removeTimer = $interval(function () {
            delete $scope.pendingGroupMessages[tempId];
            $interval.cancel(removeTimer);
          }, 5000, 1);
        }, function () {
          tmpMessage._messageProgress = 'sentFailed';
        }).finally(function () {
          $scope.groupMessages.push(tmpMessage);
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        });
      }
      $scope.chat.messageText = '';
    };
    $scope.selectGroup = function (group) {
      $scope.closeChatWindow(true);
      $scope.selectedGroup = group;
      $scope.showGroupChat = true;
      $scope.chatContainer.isChatWindowclosed = 0;
      $scope.groupMessages = [];

      if (group.unreadMessageCount > 0) {
        $scope.locallyReadGroups[group.groupId] = true;

        // Update the group's unread count in the available groups list
        for (var i = 0; i < $scope.availableGroups.length; i++) {
          if ($scope.availableGroups[i].groupId === group.groupId) {
            $scope.availableGroups[i].unreadMessageCount = 0;
            break;
          }
        }

        var totalUnreadInSelect = 0;
        for (var g = 0; g < $scope.availableGroups.length; g++) {
          totalUnreadInSelect += $scope.availableGroups[g].unreadMessageCount || 0;
        }
        $scope.groupUnreadCount = totalUnreadInSelect;
        $scope.totalUnreadCount = ($scope.msgUnseenCount || 0) + ($scope.groupUnreadCount || 0) + ($scope.notoficationCount || 0);
      }

      _getGroupMessages();
      _startMessageRefreshInterval(5000);

      setTimeout(function () {
        $('#send-group-message-input').focus();
      }, 100);
    };

    $scope.switchTab = function (tabType) {
      if (tabType === 'drivers') {
        $scope.showGroupChat = false;
        $scope.selectedGroup = null;
        $scope.groupMessages = [];
        $scope.pendingGroupMessages = {};

        $scope.chatparticipant.filterTxt = $scope.chatparticipant.deviceFilterTxt || '';
        $scope.onMessageDeviceFilter();

        if (!$scope.chatContainer.isChatWindowclosed) {
          _startMessageRefreshInterval(5000);
        }
      } else if (tabType === 'groups') {
        $scope.showGroupChat = true;

        $scope.chatparticipant.filterTxt = $scope.chatparticipant.groupFilterTxt || '';
        $scope.onMessageGroupFilter();

        if ($scope.selctedDeviceMessage && $scope.selctedDeviceMessage.message) {
          $scope.closeChatWindow(true);
        }

        if ($scope.selectedGroup && !$scope.chatContainer.isChatWindowclosed) {
          _startMessageRefreshInterval(5000);
        }
      }
    };

    $scope.switchToDriversTab = function () {
      $scope.switchTab('drivers');
    };

    $scope.switchToGroupsTab = function () {
      $scope.switchTab('groups');
    };

    function loadavailablegroups() {
      if ($scope.groupCache.data && $scope.groupCache.timestamp) {
        var cacheAge = Date.now() - $scope.groupCache.timestamp;
        // Use cache if it's less than 30 seconds old
        if (cacheAge < 30000) {
          var cachedGroups = $scope.groupCache.data;
          var adjustedUnreadCount = $scope.groupCache.totalUnreadMessages || 0;

          cachedGroups.forEach(function (group) {
            if ($scope.locallyReadGroups[group.groupId]) {
              if (group.unreadMessageCount > 0) {
                adjustedUnreadCount -= group.unreadMessageCount;
                group.unreadMessageCount = 0;
              }
            }
          });

          $scope.availableGroups = cachedGroups;
          $scope.groupUnreadCount = Math.max(0, adjustedUnreadCount);

          cachedGroups.forEach(function (group) {
            if (group.unreadMessageCount === 0 && $scope.locallyReadGroups[group.groupId]) {
              delete $scope.locallyReadGroups[group.groupId];
            }
          });

          $scope.onMessageGroupFilter();
          return Promise.resolve();
        }
      }

      return commonTrackService.getAvailableGroups().then(function (response) {
        var serverGroups = response && response.groups ? response.groups : response || [];

        // Cache the server response
        $scope.groupCache = {
          data: serverGroups.slice(),
          totalUnreadMessages: response.totalUnreadMessages || 0,
          timestamp: Date.now()
        };

        var adjustedUnreadCount = response.totalUnreadMessages || 0;

        serverGroups.forEach(function (group) {
          // If this group is currently open, force unread count to 0
          if ($scope.showGroupChat && $scope.selectedGroup && group.groupId === $scope.selectedGroup.groupId && !$scope.chatContainer.isChatWindowclosed) {
            if (group.unreadMessageCount > 0) {
              adjustedUnreadCount -= group.unreadMessageCount;
              group.unreadMessageCount = 0;
            }
          } else if ($scope.locallyReadGroups[group.groupId]) {
            if (group.unreadMessageCount > 0) {
              adjustedUnreadCount -= group.unreadMessageCount;
              group.unreadMessageCount = 0;
            }
          }
        });

        $scope.availableGroups = serverGroups;
        $scope.groupUnreadCount = Math.max(0, adjustedUnreadCount);

        serverGroups.forEach(function (group) {
          if (group.unreadMessageCount === 0 && $scope.locallyReadGroups[group.groupId]) {
            delete $scope.locallyReadGroups[group.groupId];
          }
        });

        $scope.onMessageGroupFilter();
      }, function (error) {
        console.error('Error loading available groups:', error);
        $scope.availableGroups = [];
        $scope.filteredGroups = [];
        $scope.groupUnreadCount = 0;
      });
    }

    function _getGroupMessages() {
      if ($scope.selectedGroup) {
        var groupId = $scope.selectedGroup.groupId;

        if ($scope.groupMessagesCache[groupId] && $scope.groupMessagesCache[groupId].timestamp) {
          var cacheAge = Date.now() - $scope.groupMessagesCache[groupId].timestamp;
          // Use cache if it's less than 15 seconds old
          if (cacheAge < 15000) {
            var cachedMessages = $scope.groupMessagesCache[groupId].messages;

            if (!$scope.chatContainer.isChatWindowclosed && $scope.selectedGroup) {
              // Save pending messages
              var pendingMsgs = [];
              for (var i = 0; i < $scope.groupMessages.length; i++) {
                if ($scope.groupMessages[i]._tempId && $scope.pendingGroupMessages[$scope.groupMessages[i]._tempId]) {
                  pendingMsgs.push($scope.groupMessages[i]);
                }
              }

              $scope.groupMessages = [];
              _generateGroupMsgHistoryView(cachedMessages);

              // Re-add pending messages that haven't been confirmed by server
              for (var p = 0; p < pendingMsgs.length; p++) {
                var foundInServer = false;
                for (var m = 0; m < $scope.groupMessages.length; m++) {
                  if (!$scope.groupMessages[m]._tempId && $scope.groupMessages[m].drivermessage === pendingMsgs[p].drivermessage && $scope.groupMessages[m]._msgType === 'sent' && Math.abs($scope.groupMessages[m].messagetimestamp - pendingMsgs[p].messagetimestamp) < 10) {
                    foundInServer = true;
                    break;
                  }
                }
                if (!foundInServer) {
                  $scope.groupMessages.push(pendingMsgs[p]);
                }
              }
            }
            // Still sync group data even when using cache
            $scope.syncGroupData();
            return;
          }
        }

        // Fetch fresh messages and sync group data
        commonTrackService.getGroupMessages($scope.groupMessages, groupId).then(function (response) {
          var newMessages = [];

          if (response && response.groupConversations) {
            newMessages = response.groupConversations;
          } else if (response && Array.isArray(response)) {
            newMessages = response;
          } else {
            return;
          }

          // Sort the new messages by creationTime before processing
          newMessages.sort(function (a, b) {
            var timestampA = a.creationTime || a.messagetimestamp || 0;
            var timestampB = b.creationTime || b.messagetimestamp || 0;
            return timestampA - timestampB;
          });

          $scope.groupMessagesCache[groupId] = {
            messages: newMessages.slice(),
            timestamp: Date.now()
          };

          if (!$scope.chatContainer.isChatWindowclosed && $scope.selectedGroup) {
            // Save pending messages
            var pendingMsgs = [];
            for (var i = 0; i < $scope.groupMessages.length; i++) {
              if ($scope.groupMessages[i]._tempId && $scope.pendingGroupMessages[$scope.groupMessages[i]._tempId]) {
                pendingMsgs.push($scope.groupMessages[i]);
              }
            }

            $scope.groupMessages = [];
            _generateGroupMsgHistoryView(newMessages);

            for (var p = 0; p < pendingMsgs.length; p++) {
              var foundInServer = false;
              for (var m = 0; m < $scope.groupMessages.length; m++) {
                if (!$scope.groupMessages[m]._tempId && $scope.groupMessages[m].drivermessage === pendingMsgs[p].drivermessage && $scope.groupMessages[m]._msgType === 'sent' && Math.abs($scope.groupMessages[m].messagetimestamp - pendingMsgs[p].messagetimestamp) < 10) {
                  foundInServer = true;
                  break;
                }
              }
              if (!foundInServer) {
                $scope.groupMessages.push(pendingMsgs[p]);
              }
            }
          }

          // Sync group data after getting messages
          $scope.syncGroupData();
        }).catch(function (error) {
          console.error('Error loading group messages:', error);
        });
      }
    }

    function _generateGroupMsgHistoryView(messageHistory) {
      if (messageHistory.length > 0) {
        messageHistory.sort(function (a, b) {
          var timestampA = a.creationTime || a.messagetimestamp || 0;
          var timestampB = b.creationTime || b.messagetimestamp || 0;
          return timestampA - timestampB;
        });

        for (var i = 0; i < messageHistory.length; i++) {
          var msg = messageHistory[i];

          msg.drivermessage = msg.message || msg.drivermessage;
          msg.messagetimestamp = msg.creationTime || msg.sentTimestamp || msg.messagetimestamp || 0;

          msg.statuscode = msg.statuscode === 57777 ? '0xE1B1' : msg.statuscode;

          if (msg.statuscode === '0xE1B1' && msg.drivermessage.beginsWith('{')) {
            continue;
          }

          msg.senderId = msg.messageSender || msg.senderId || msg.deviceID;

          // Check if sender is a dispatcher (no deviceID)
          if (msg.messageSender && !msg.deviceID) {
            msg.senderDesc = msg.messageSender + ' (Dispatcher)'; // Add "(Dispatcher)" label
          } else {
            var deviceInfo = $scope.getDeviceInfo(msg.deviceID);
            if (deviceInfo) {
              msg.senderDesc = deviceInfo.driverDesc || deviceInfo.deviceDesc || msg.messageSender;
            } else {
              msg.senderDesc = msg.messageSender || 'Device ' + msg.deviceID;
            }
          }

          msg._msgType = msg.senderId === $scope.userName ? 'sent' : 'received';
          msg._timeShortDes = $filter('date')(new Date(Number(msg.messagetimestamp) * 1000), 'EEE HH:mm');

          if (msg._msgType === 'sent') {
            var isPending = false;
            for (var tempId in $scope.pendingGroupMessages) {
              var pendingMsg = $scope.pendingGroupMessages[tempId];
              if (pendingMsg.drivermessage === msg.drivermessage && Math.abs(pendingMsg.messagetimestamp - msg.messagetimestamp) < 10) {
                msg._messageProgress = 'sentCompleted';
                delete $scope.pendingGroupMessages[tempId];
                isPending = true;
                break;
              }
            }

            if (!isPending) {
              msg._messageProgress = 'sentCompleted';
            }
          }

          msg._responses = [];

          if (msg.responses && Array.isArray(msg.responses)) {
            msg.responses.sort(function (a, b) {
              var timestampA = a.creationTime || a.messagetimestamp || 0;
              var timestampB = b.creationTime || b.messagetimestamp || 0;
              return timestampA - timestampB;
            });

            for (var r = 0; r < msg.responses.length; r++) {
              var resp = msg.responses[r];
              resp.drivermessage = resp.message || resp.drivermessage;
              resp.messagetimestamp = resp.creationTime || resp.sentTimestamp || resp.messagetimestamp || 0;

              if (resp.drivermessage.beginsWith('{read}')) {
                continue;
              }

              if (resp.messageSender && !resp.deviceID) {
                resp.senderDesc = resp.messageSender + ' (Dispatcher)'; // Add "(Dispatcher)" label
              } else {
                var respDeviceInfo = $scope.getDeviceInfo(resp.deviceID);
                if (respDeviceInfo) {
                  resp.senderDesc = respDeviceInfo.driverDesc || respDeviceInfo.deviceDesc || resp.messageSender;
                } else {
                  resp.senderDesc = resp.messageSender || 'Device ' + resp.deviceID;
                }
              }

              var ackType = 'Ok';
              if (resp.drivermessage.beginsWith('{')) {
                var splitedAckMessage = resp.drivermessage.split('}');
                var rawAckType = splitedAckMessage[0].replace('{', '').toLowerCase();

                switch (rawAckType) {
                  case 'ok':
                    ackType = 'OK';
                    break;
                  case 'yes':
                    ackType = 'Yes';
                    break;
                  case 'no':
                    ackType = 'No';
                    break;
                  default:
                    ackType = rawAckType;
                }
              }

              msg._responses.push({
                ackType: ackType,
                senderDesc: resp.senderDesc,
                timestamp: resp.messagetimestamp,
                timeShortDes: $filter('date')(new Date(Number(resp.messagetimestamp) * 1000), 'EEE HH:mm')
              });
            }
          }

          $scope.groupMessages.push(msg);
          if ($scope.selectedGroup) {
            var messageId = $scope.selectedGroup.groupId + '_' + msg.messagetimestamp + '_' + msg.senderId;
            $scope.seenGroupMessages[messageId] = true;
          }
        }
      }

      if ($scope.selectedGroup && messageHistory.length > 0) {
        for (var g = 0; g < $scope.availableGroups.length; g++) {
          if ($scope.availableGroups[g].groupId === $scope.selectedGroup.groupId) {
            $scope.availableGroups[g].unreadMessageCount = 0;
            break;
          }
        }
      }
    }

    /* Toggle the chat container left or right .
    */
    $scope.toggleChatContainerAlign = function () {
      $scope.chatContainer.alignDirection = !$scope.chatContainer.alignDirection;
    };

    $scope.refreshChatMessages = function () {
      loadavailablegroups();
      if ($scope.showGroupChat && $scope.selectedGroup) {
        _getGroupMessages();
      } else if (!$scope.showGroupChat) {
        _getMessages();
      }
    };

    /* Toggle the chat container left or right .
    */
    $scope.toggleChatParticipantWindow = function () {
      $scope.showChatWindowToggle = !$scope.showChatWindowToggle;
      if ($scope.showChatWindowToggle) {
        $scope.showGroupChat = false;
      }
      if (!$scope.showChatWindowToggle) {
        $scope.closeChatWindow();
        if ($scope.selctedDeviceMessage && ($scope.selctedDeviceMessage.message !== null || $scope.selctedDeviceMessage.message === true)) {
          //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
          // send event to stop the auto refresh when chat window is opened
          $rootScope.$broadcast('chat-window-close-evt');
        }
      } else if ($scope.selctedDeviceMessage) {
        $scope.chatContainer.isChatWindowclosed = 0;
        if ($scope.selctedDeviceMessage.message !== null || $scope.selctedDeviceMessage.message === true) {
          //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
          // send event to stop the auto refresh when chat window is opened
          $rootScope.$broadcast('chat-window-open-evt');
        }
      }
    };
    /* close the ChatWindow.
    */
    $scope.closeChatWindow = function (clearSelectedChat) {

      if (clearSelectedChat) {
        //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
        // send event to restart the auto refresh when chat window is closed
        $rootScope.$broadcast('chat-window-close-evt');
        $scope.selctedDeviceMessage = null;
      }

      $scope.chatContainer.isChatWindowclosed = 1;
    };

    function _setAckMessage(messageHistory, updateIndex, newMessage, ackMsg) {
      messageHistory[updateIndex]._hasAckMessage = true;
      messageHistory[updateIndex]._ackMessage = ackMsg !== 'read' ? $translate.instant('deviceMessaging.' + ackMsg) : ackMsg;
      messageHistory[updateIndex]._ackMsgSender = newMessage.senderDesc;
      messageHistory[updateIndex]._ackMasgTimeShortDes = $filter('date')(new Date(Number(newMessage.messagetimestamp) * 1000), 'EEE  HH:mm');
    }

    var index = 0;
    var _pushedNewMshIndex;
    /**
     * Prepares the serve message for the UI Rendering ,
     * 1. set message type
     * 2. if ACK message move that message to the related send message block
     * @param {*} messageHistory
     * @param {*} isRefresh
     */
    function _generateMsgHistoryView(messageHistory, isRefresh) {
      if (messageHistory.length > 0) {
        for (var i = 0; i < messageHistory.length; i++) {
          messageHistory[i].statuscode = messageHistory[i].statuscode === 57777 ? '0xE1B1' : messageHistory[i].statuscode;
          if (messageHistory[i].statuscode === '0xE1B1') {

            messageHistory[i]._msgType = 'recieved';
            messageHistory[i]._timeShortDes = $filter('date')(new Date(Number(messageHistory[i].messagetimestamp) * 1000), 'EEE  HH:mm');
            if (messageHistory[i].drivermessage.beginsWith('{')) {
              var _tmpIsfound = false;
              var splitedAckMessage = messageHistory[i].drivermessage.split('}');
              if (isRefresh) {
                var _tmpSourceArray = $scope.msgProperties.messages;
                for (var k = _tmpSourceArray.length - 1; k >= 0; k--) {
                  if (_tmpSourceArray[k].statuscode !== '0xE1B1' && _tmpSourceArray[k].drivermessage === splitedAckMessage[1] && !_tmpSourceArray[k]._ackMessage) {
                    //log ack driver message
                    //console.log('Matched ack messgae "' + _tmpSourceArray[k].drivermessage + '" Status Code "' + _tmpSourceArray[k].statuscode + '"');
                    _tmpIsfound = true;
                    break;
                  }
                }
                if (_tmpIsfound) {
                  _setAckMessage(_tmpSourceArray, k, messageHistory[i], splitedAckMessage[0].replace('{', ''));
                  $scope.msgProperties.ackmessages.push(messageHistory[i]);
                } else {
                  $scope.msgProperties.ackmessages.push(messageHistory[i]); // push to ack to mark it already read and not to consider on next refresh
                }
              } else {
                for (var j = $scope.msgProperties.messages.length - 1; j >= 0; j--) {
                  if ($scope.msgProperties.messages[j].statuscode !== '0xE1B1' && $scope.msgProperties.messages[j].drivermessage === splitedAckMessage[1] && !$scope.msgProperties.messages[j]._ackMessage) {
                    //log ack driver message
                    //console.log('Matched ack messgae "' + messageHistory[j].drivermessage + '" Status Code "' + messageHistory[j].statuscode + '"');
                    _tmpIsfound = true;
                    break;
                  }
                }
                if (_tmpIsfound) {
                  _setAckMessage($scope.msgProperties.messages, j, messageHistory[i], splitedAckMessage[0].replace('{', ''));
                  $scope.msgProperties.ackmessages.push(messageHistory[i]);
                } else {
                  $scope.msgProperties.ackmessages.push(messageHistory[i]); // push to ack to mark it already read and not to consider on next refresh
                }
              }
            } else {
              messageHistory[i]._hasAckMessage = false;
              $scope.msgProperties.messages.push(messageHistory[i]);
              index++;
            }
          }
          if (messageHistory[i].statuscode !== '0xE1B1') {

            var hasMessagealreadyinSentList = false;
            for (var s = 0; s < $scope.msgProperties.messages.length; s++) {
              if ($scope.msgProperties.messages[s]._msgType === 'sent' && $scope.msgProperties.messages[s].drivermessage === messageHistory[i].drivermessage && $scope.msgProperties.messages[s].messageid === messageHistory[i].messageid) {
                hasMessagealreadyinSentList = true;
                break;
              }
            }
            if (!hasMessagealreadyinSentList) {
              messageHistory[i]._msgType = 'sent';
              messageHistory[i]._timeShortDes = $filter('date')(new Date(Number(messageHistory[i].messagetimestamp) * 1000), 'EEE  HH:mm');
              messageHistory[i]._messageProgress = 'sentCompleted';
              if (isRefresh && _pushedNewMshIndex) {
                if ($scope.msgProperties.messages[_pushedNewMshIndex].drivermessage !== messageHistory[i].drivermessage) {
                  $scope.msgProperties.messages.push(messageHistory[i]);
                  index++;
                }
              } else {
                $scope.msgProperties.messages.push(messageHistory[i]);
                index++;
              }
            }
          }
        }
      } else {
        if ($scope.msgProperties & $scope.msgProperties.msg && $scope.msgProperties.msg.deviceid && $scope.msgProperties.msg.deviceid === $scope.deviceMessage.deviceID && !isRefresh) {
          $scope.msgProperties.messages.push($scope.selctedDeviceMessage.message);
          index++;
        }
      }
    }

    function cancelExistingMessageInterval() {
      if (messageIntervalObj) {
        try {
          $interval.cancel(messageIntervalObj);
        } catch (err) {
          console.log(err);
        }
      }
    }
  }
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/common/directives/header/header-nav.component.tpl.html', '<div class="container-fluid"><div ng-show="!isDefaultNav"><div id="navbar2" class=""><ul id="sideSystemMenu2" class="nav navbar-nav navbar-right" style="cursor: pointer"><li class="dropdown" ng-show="isLogin"><a data-toggle="dropdown"><i class="fa fa-bell"></i><span class="badge badge-orange" style="background-color:#f0934e;" ng-if="notoficationCount>0" ng-bind="notoficationCount"></span></a><ul class="dropdown-menu messaging-dropdown"><li class="animate-repeat" ng-repeat="notification in notifictionList track by $index" style="border-bottom: 1px solid rgba(0,0,0,.15);"><a ng-click="notificationClick($index)" ng-class="{active:!notification._isNotificationRead}"><div ng-if="notification._notificationType==\'msg\'"><div class="row"><div class="col-sm-10 col-xs-10 col-md-10"><h5 class="media-heading"><strong>{{notification._notificationMessage}}</strong></h5></div></div></div><div ng-if="notification._notificationType==\'status\'"><div class="row"><div class="col-sm-12 col-xs-12 col-md-12"><h5 class="media-heading"><strong>{{notification.devicedesc}}</strong></h5><div style="color: {{notification.statuscodeColor}};background-color: {{notification.statuscodeBgColor}};">{{notification.statusdesc}}</div><div>{{notification.subject}}</div></div></div></div><div class="row"><div class="col-md-10"><div ng-if="notification._notificationType==\'msg\'"><p class="small text-muted"><i class="fa fa-clock-o"></i> {{notification._dateTimeBwnDescription}}</p></div><div ng-if="notification._notificationType==\'status\'"><p class="small text-muted" style="padding: 2.5px;"><i class="fa fa-clock-o"></i> {{notification._dateTimeDescription}}</p></div></div><div class="col-md-1"><i class="fa fa-circle-thin" ng-if="notification._isNotificationRead"></i> <i class="fa fa-circle" ng-if="!notification._isNotificationRead"></i></div></div></a></li></ul></li><li class="dropdown" ng-show="isLogin" ng-click="toggleChatParticipantWindow()"><a data-toggle="dropdown"><i class="fa fa-envelope"></i> <span class="badge badge-danger" style="background-color: #e75a5a;" ng-if="(msgUnseenCount + groupUnreadCount) > 0">{{msgUnseenCount + groupUnreadCount}}</span></a></li><li class="dropdown" ng-show="isLogin"><a class="dropdown-toggle" data-toggle="dropdown"><i class="glyphicon glyphicon-user"></i> {{userName}}<span class="caret"></span></a><ul class="dropdown-menu" role="menu"><li class="divider"></li><li class="dropdown-submenu"><a><span translate="nav.user.appProfile"></span></a></li><li style="padding-left: 7px;"><a ng-click="clearLocalStroageAndCookies()" id="clearLocalStorage" translate="nav.user.clearLocalStorage"></a></li><li style="padding-left: 7px;"><a id="saveLocalStorage" ng-click="saveLocalStorage()" translate="nav.user.saveLocalStorage"></a></li><li style="padding-left: 7px;"><a id="restoreLocalStorage" ng-click="restoreLocalStorage()" translate="nav.user.restoreLocalStorage"></a></li><li class="divider"></li><li><a translate="nav.user.changePassword" ng-click="open(\'md\')"></a></li><li><a ng-click="logout()" translate="nav.user.logout"></a></li></ul></li></ul></div></div><div ng-show="isDefaultNav"><div id="navbar" class="navbar-collapse collapse" style="background-color:#484848"><ul id="sideSystemMenu" class="nav navbar-nav navbar-right"><li class="dropdown" ng-show="isLogin"><a class="dropdown-toggle" data-toggle="dropdown"><i class="glyphicon glyphicon-user"></i> {{userName}}<span class="caret"></span></a><ul class="dropdown-menu" role="menu"><li><a translate="nav.user.changePassword" ng-click="open(\'sm\')"></a></li><li><a ng-click="logout()" translate="nav.user.logout"></a></li></ul></li></ul></div></div><div class="chat-participants-container" ng-show="showChatWindowToggle" ng-class="{\'right\': !chatContainer.alignDirection, \'left\': chatContainer.alignDirection}"><header><div class="filler"><input id="filter-device" placeholder="&#xF002;" autocomplete="off" ng-model="chatparticipant.filterTxt" focus-blur="" ng-change="onFilterChange()"></div><button class="switch" ng-click="toggleChatContainerAlign()"><span class="glyphicon glyphicon-transfer"></span></button> <button class="switch" ng-click="refreshChatMessages()"><span class="glyphicon glyphicon-refresh"></span></button> <button ng-click="toggleChatParticipantWindow()"><span class="glyphicon glyphicon-remove"></span></button></header><div class="chat-tabs"><button class="chat-tab" ng-class="{\'active\': !showGroupChat}" ng-click="switchTab(\'drivers\')"><span translate="deviceMessaging.drivers">Drivers</span> <span class="badge badge-danger" style="background-color: #e75a5a; margin-left: 5px;" ng-if="msgUnseenCount > 0">{{msgUnseenCount}}</span></button> <button class="chat-tab" ng-class="{\'active\': showGroupChat}" ng-click="switchTab(\'groups\')"><span translate="deviceMessaging.groupChats">Group Chats</span> <span class="badge badge-danger" style="background-color: #e75a5a; margin-left: 5px;" ng-if="groupUnreadCount > 0">{{groupUnreadCount}}</span></button></div><div class="chat-participants-window" ng-show="!showGroupChat"><ul class="messaging-dropdown"><li class="animate-repeat" ng-repeat="message in messageList track by $index" style="border-bottom: 1px solid rgba(0,0,0,.15);cursor: pointer;" ng-click="deviceMessageClick($index)" ng-class="{\'selected-device-message\': message.isSlected}"><div><div class="chat-participant-row"><div class="row" style="padding: 2.5px; margin: 0px;"><div class="col-md-8" style="padding: 2px;"><div style="display: inline-flex;"><div class="chat-window-available-circle" ng-style="{\'background-color\':message.deviceAvilableStatusColor}">{{message.latestJobStatusDesc}}</div><div><div class="chat-window-device-desc"><span class="media-heading">{{message.deviceDesc}}</span></div><div class="chat-window-driver-desc"><span><i class="fa digital-tachograph"></i></span> <span class="media-heading">{{message.driverDesc}}</span></div></div></div></div><div class="col-md-4" style="padding: 2px; text-align: right;"><div><div ng-if="message.lastMessageTimeStamp >0" class="message-time-desc">{{message.lastMessageTimeStamp * 1000 | date:\'dd.MM.yy HH:mm\'}}</div><div ng-if="message.unreadMessageCount >0"><span class="badge badge-danger" style="background-color: #e75a5a;">{{message.unreadMessageCount}}</span></div></div></div></div><div style="text-align: center;font-size: 12px;"><span class="ellipsis">{{message.latestMessageShortDesc}} ...</span></div></div></div></li></ul></div><div class="chat-participants-window" ng-show="showGroupChat"><ul class="messaging-dropdown"><li class="animate-repeat" ng-repeat="group in filteredGroups track by $index" style="border-bottom: 1px solid rgba(0,0,0,.15);cursor: pointer;" ng-click="selectGroup(group)" ng-class="{\'selected-device-message\': selectedGroup && selectedGroup.groupId === group.groupId}"><div><div class="chat-participant-row"><div class="row" style="padding: 2.5px; margin: 0px;"><div class="col-md-8" style="padding: 2px;"><div style="display: inline-flex;"><div class="chat-window-available-circle" style="background-color: #95D41F;"></div><div><div class="chat-window-device-desc"><span class="media-heading">{{group.groupName}}</span></div><div class="chat-window-driver-desc"><span><i class="fa fa-users"></i></span> <span class="media-heading" translate="deviceMessaging.membersCount" translate-values="{ count: group.groupMembers.length }"></span></div></div></div></div><div class="col-md-4" style="padding: 2px; text-align: right;"><div><div ng-if="group.unreadMessageCount > 0"><span class="badge badge-danger" style="background-color: #e75a5a;">{{group.unreadMessageCount}}</span></div></div></div></div><div ng-if="group.latestMessagePreview" style="text-align: left; font-size: 12px; padding-left: 8px;"><span>{{group.latestMessagePreview}}</span></div><div ng-if="!group.latestMessagePreview" style="text-align: center; font-size: 12px;"><span class="ellipsis">...</span></div></div></div></li></ul></div></div><div class="chat-window-container" ng-if="!chatContainer.isChatWindowclosed && selctedDeviceMessage.message != null || selctedDeviceMessage.isNew == true" ng-class="{\'right\': !chatContainer.alignDirection, \'left\': chatContainer.alignDirection}"><header><div class="filler"><div style="display: inline-flex;float: left; padding: 1px 0px 1px 5px;"><div class="chat-window-available-circle" ng-style="{\'background-color\':selctedDeviceMessage.message.deviceAvilableStatusColor}">{{selctedDeviceMessage.message.latestJobStatusDesc}}</div><div><div class="chat-window-device-desc"><span class="media-heading">{{selctedDeviceMessage.message.deviceDesc}}</span></div><div class="chat-window-driver-desc"><span class="media-heading">{{selctedDeviceMessage.message.driverDesc}}</span></div></div></div><div class="message-window-header-user-last-seen"><div ng-if="selctedDeviceMessage.message.tabletLastCheckIn > 0"><div class="message-time-desc">{{selctedDeviceMessage.message.tabletLastCheckIn * 1000 | date:\'dd.MM.yy HH:mm\'}}</div></div></div></div><button ng-click="closeChatWindow(true)"><span class="glyphicon glyphicon-remove"></span></button></header><div class="chat-window-body" scroll-glue="glued"><div class="row" ng-repeat="item in msgProperties.messages"><div class="col-md-6" style="padding-right: 0px;margin-right: 0px;"><div class="alert track-alert-info" style="margin-bottom:4px; padding-bottom: 2.5px;" ng-if="item._msgType===\'sent\'"><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" ng-if="item._messageProgress===\'sending..\'" align="right">{{item._messageProgress}}</div><div ng-if="item._messageProgress===\'sentCompleted\'" style="padding: 0px;margin: 0px; color: #58be75;" align="right"><i class="fa fa-paper-plane"></i> <i ng-if="item._hasAckMessage && item._ackMessage===\'read\'" class="fa fa-check-circle"></i></div><div ng-if="item._messageProgress===\'sentFailed\'" style="padding: 0px;margin: 0px; color: #e75a5a;" align="right"><i class="fa fa-times-circle"></i></div><p style="word-wrap:break-word;"><strong>{{messagemodel.userDesc}} :</strong> {{item.drivermessage}}</p><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" align="right">{{item.messagetimestamp * 1000 | date:\'EEE HH:mm\'}}</div><div class="alert alert-warning" ng-if="item._hasAckMessage && item._ackMessage!==\'read\'" style="padding-left: 4px;border: 1px dashed #c9c9c9"><p style="word-wrap:break-word;" class="ng-binding"><strong class="ng-binding">{{item._ackMsgSender}} :</strong> {{item._ackMessage}}</p><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" align="right" class="ng-binding">{{item._ackMasgTimeShortDes}}</div></div></div></div><div class="col-md-6" ng-if="item._msgType===\'recieved\'"><div class="alert alert-warning" style="margin-bottom:4px;"><p style="word-wrap:break-word;"><strong>{{item.senderDesc}} :</strong>{{item.drivermessage}}</p><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" align="right">{{item.messagetimestamp * 1000 | date:\'EEE HH:mm\'}}</div></div></div></div></div><div class="chat-window-footer"><div class="row" style="margin: 0px;padding: 0px;"><div class="col-md-12" style="margin: 0px;padding: 0px;"><fieldset style="border:none;padding: 0px;"><form name="myForm" autocomplete="off"><div class="chat-window-footer-radio-container"><div class="chat-window-footer-radio"><input id="msgOkRadio" type="radio" ng-model="msgRadio.ackMsg" value="Ok" style="vertical-align:sub;"> <label for="msgOkRadio" translate="deviceMessaging.radioOk"></label></div><div class="chat-window-footer-radio"><input id="msgYesRadio" type="radio" ng-model="msgRadio.ackMsg" value="Yes/No" style="vertical-align:sub;"> <label for="msgYesRadio" translate="deviceMessaging.radioYes-No"></label></div><div class="chat-window-footer-radio"><input id="msgTextRadio" type="radio" ng-model="msgRadio.ackMsg" value="Text" style="vertical-align:sub;"> <label for="msgTextRadio" translate="deviceMessaging.radioText"></label></div></div><div class="input-group input-group-lg send-msg-container"><input type="text" name="messageSend" id="send-message-input" focus-on="!selctedDeviceMessage.isNew" ng-disabled="isHistoryLoaded==false" class="form-control" ng-model="chat.messageText" maxlength="300" ng-change="messageChanged()"> <span class="input-group-btn"><button class="btn btn-info" type="button" id="msgSendBtn" ng-click="sendMsg()" ng-disabled="!deviceMessage.deviceID&& msgProperties.type===\'new\'"><i class="glyphicon glyphicon-send"></i></button></span></div></form></fieldset></div></div></div></div><div class="chat-window-container" ng-if="!chatContainer.isChatWindowclosed && selectedGroup != null" ng-class="{\'right\': !chatContainer.alignDirection, \'left\': chatContainer.alignDirection}"><header><div class="filler"><div style="display: inline-flex;float: left; padding: 1px 0px 1px 5px;"><div class="chat-window-available-circle" style="background-color: #95D41F;"></div><div><div class="chat-window-device-desc"><span class="media-heading">{{selectedGroup.groupName}}</span></div><div class="chat-window-driver-desc"><span class="media-heading" translate="deviceMessaging.membersCount" translate-values="{ count: selectedGroup.groupMembers.length }"></span></div></div></div></div><button class="switch" ng-click="showGroupMembers = !showGroupMembers"><span class="fa fa-users"></span></button> <button ng-click="closeChatWindow(true); selectedGroup = null; showGroupChat = false;"><span class="glyphicon glyphicon-remove"></span></button></header><div ng-show="showGroupMembers" style="background: #f9f9f9; border-bottom: 1px solid #ddd; padding: 15px;"><div style="padding-bottom: 8px; border-bottom: 1px solid #ddd; margin-bottom: 12px;"><strong translate="deviceMessaging.groupMembers">Group Members:</strong></div><div ng-repeat="member in selectedGroup.groupMembers" style="padding: 8px 0;"><div ng-if="getDeviceInfo(getDeviceIdFromMember(member)) && member.deviceId" style="display: inline-flex; align-items: center;"><div class="chat-window-available-circle" ng-style="{\'background-color\': getDeviceInfo(getDeviceIdFromMember(member)).deviceAvilableStatusColor}" style="width: 35px; height: 35px; font-size: 12px; margin-right: 12px;">{{getDeviceInfo(getDeviceIdFromMember(member)).latestJobStatusDesc}}</div><div><div class="chat-window-device-desc" style="font-size: 12px;"><span>{{getDeviceInfo(getDeviceIdFromMember(member)).deviceDesc}}</span></div><div class="chat-window-driver-desc" style="font-size: 11px;"><span><i class="fa digital-tachograph"></i></span> <span>{{getDeviceInfo(getDeviceIdFromMember(member)).driverDesc}}</span></div></div></div><div ng-if="member.userId && !member.deviceId" style="display: inline-flex; align-items: center;"><div class="chat-window-available-circle" style="background-color: #95D41F; width: 35px; height: 35px; font-size: 12px; margin-right: 12px;"></div><div><div class="chat-window-device-desc" style="font-size: 12px;"><span>Dispatcher</span></div><div class="chat-window-driver-desc" style="font-size: 11px;"><span>{{getDispatcherName(member)}}</span></div></div></div><div ng-if="!getDeviceInfo(getDeviceIdFromMember(member)) && member.deviceId && !member.userId" style="padding: 4px; color: #999;"><div style="display: inline-flex; align-items: center;"><div class="chat-window-available-circle" style="background-color: #ccc; width: 35px; height: 35px; font-size: 12px; margin-right: 12px;"><i class="fa fa-question" style="line-height: 35px;"></i></div><div><div style="font-size: 12px;">Device {{getDeviceIdFromMember(member)}} <span ng-if="getMemberDescription(member)">- {{getMemberDescription(member)}}</span></div><div style="font-size: 11px; color: #999;">Not currently available</div></div></div></div></div></div><div class="chat-window-body" scroll-glue="glued"><div class="row" ng-repeat="item in groupMessages"><div class="col-md-6" style="padding-right: 0px;margin-right: 0px;"><div class="alert track-alert-info" style="margin-bottom:4px; padding-bottom: 2.5px;" ng-if="item._msgType===\'sent\'"><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" ng-if="item._messageProgress===\'sending..\'" align="right">{{item._messageProgress}}</div><div ng-if="item._messageProgress===\'sentCompleted\'" style="padding: 0px;margin: 0px; color: #58be75;" align="right"><i class="fa fa-paper-plane"></i> <i ng-if="item._responses && item._responses.length > 0" class="fa fa-check-circle"></i></div><div ng-if="item._messageProgress===\'sentFailed\'" style="padding: 0px;margin: 0px; color: #e75a5a;" align="right"><i class="fa fa-times-circle"></i></div><p style="word-wrap:break-word;"><strong>{{messagemodel.userDesc}} :</strong> {{item.drivermessage}}</p><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" align="right">{{item.messagetimestamp * 1000 | date:\'EEE HH:mm\'}}</div><div ng-if="item._responses && item._responses.length > 0" style="margin-top: 8px;"><div class="alert alert-warning" ng-repeat="response in item._responses" style="padding: 4px 8px; margin-bottom: 4px; border: 1px dashed #c9c9c9"><p style="word-wrap:break-word; margin-bottom: 2px;" class="ng-binding"><strong class="ng-binding">{{response.senderDesc}} :</strong> <span style="color: #8a6d3b;">{{response.ackType}}</span></p><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" align="right" class="ng-binding">{{response.timeShortDes}}</div></div></div></div></div><div class="col-md-6" ng-if="item._msgType===\'received\'"><div class="alert alert-warning" style="margin-bottom:4px;"><p style="word-wrap:break-word;"><strong>{{item.senderDesc}} :</strong> {{item.drivermessage}}</p><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" align="right">{{item.messagetimestamp * 1000 | date:\'EEE HH:mm\'}}</div><div ng-if="item._responses && item._responses.length > 0" style="margin-top: 8px;"><div class="alert-response" ng-repeat="response in item._responses" style="padding: 4px 8px; margin-bottom: 4px; border-radius: 3px; border: 1px solid #8a6d3b3b; background-color: #FCF8E3;"><p style="word-wrap:break-word; margin-bottom: 2px;" class="ng-binding"><strong class="ng-binding" style="color: #8A6D3B;">{{response.senderDesc}} :</strong> <span style="color: #8A6D3B;">{{response.ackType}}</span></p><div style="padding: 0px;margin: 0px; color: grey;font-style: italic;font-size:11px;" align="right" class="ng-binding">{{response.timeShortDes}}</div></div></div></div></div></div></div><footer class="chat-window-footer"><div class="chat-window-footer-radio-container"><div class="chat-window-footer-radio"><input type="radio" ng-model="groupMsgRadio.ackMsg" value="Ok" id="okRadioGroupChat"> <label for="okRadioGroupChat" translate="deviceMessaging.radioOk">Ok</label></div><div class="chat-window-footer-radio"><input type="radio" ng-model="groupMsgRadio.ackMsg" value="Yes/No" id="yesNoRadioGroupChat"> <label for="yesNoRadioGroupChat" translate="deviceMessaging.radioYes-No">Yes/No</label></div><div class="chat-window-footer-radio"><input type="radio" ng-model="groupMsgRadio.ackMsg" value="Text" id="textRadioGroupChat"> <label for="textRadioGroupChat" translate="deviceMessaging.radioText">Text</label></div></div><div class="send-msg-container input-group input-group-lg"><input type="text" id="send-group-message-input" class="form-control" ng-model="chat.messageText" ng-change="messageChanged()" maxlength="300"> <span class="input-group-btn"><button id="messageSend" class="btn btn-primary" type="button" ng-click="sendGroupMsg()"><span class="glyphicon glyphicon-send"></span></button></span></div></footer></div></div>');
  }]);
})();

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 4/28/2017.
 */



angular.module('betosyswebapp').directive('ngOnload', function () {
  return {
    restrict: 'A',
    scope: {
      callback: '&ngOnload'
    },
    link: function link(scope, element) {
      element.on('load', function (event) {
        return scope.callback({ event: event });
      });
    }
  };
});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/16/2016.
 */


angular.module('betosyswebapp').directive('fitIframeHeight', ["$window", "$document", "$timeout", function ($window, $document, $timeout) {
  return {
    restrict: 'A',
    scope: {
      divIdNames: '=divid'
    },
    link: function link(scope, element) {
      scope.docHeight = $document.height();
      var setHeight = function setHeight() {
        $timeout(function () {
          var divIdNames = scope.divIdNames.split(',');
          var _tmpHeight = $('header').height();
          for (var i = 0; i < divIdNames.length; i++) {
            _tmpHeight += $('#' + divIdNames[i]).height();
          }
          _tmpHeight += $('footer').height();

          element.css('min-height', $(window).height() - (_tmpHeight + 30) + 'px');
        }, 500);
      };

      scope.$watch('docHeight', function (newVal) {
        setHeight(newVal);
      });

      scope.$on('globalStyles:changed:layoutHorizontal', function (event, newVal) {
        setHeight(newVal);
      });

      $(window).on('resize', function () {
        setHeight();
      });
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by fky on 23/03/2017.
 */


angular.module('betosyswebapp').directive('inputNumberValidate', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attr) {
      if (attr.inputNumberValidate === 'integer') {
        $(element).on('keypress', function (event) {
          return event.charCode >= 48 && event.charCode <= 57 || event.keyCode === 8 || event.keyCode === 9;
        });
      } else {
        $(element).on('keypress', function (event) {
          return event.charCode >= 48 && event.charCode <= 57 || event.charCode === 46 || event.keyCode === 8 || event.keyCode === 9;
        });
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by rak on 7/06/2019.
 */
(function () {
  'use strict';

  angular.module('betosyswebapp').directive('loadingAnimation', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/common/directives/loadingAnimationDirective.tpl.html',
      replace: true
    };
  });
})();

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/common/directives/loadingAnimationDirective.tpl.html', '<div class="loading-animation-dsa"><div class="loading-bar-dsa"></div><div class="loading-bar-dsa"></div><div class="loading-bar-dsa"></div><div class="loading-bar-dsa"></div></div>');
  }]);
})();

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/common/directives/noAuthorize.tpl.html', '<div class="alerts"><div class="alert-message error"><p translate="userRight.notAuthorized"></p></div><style>\n' + '    .alerts {\n' + '      margin: 20px;\n' + '    }\n' + '\n' + '    .alerts p {\n' + '      /* quick and dirty hack added by me, you may remove it if not needed */\n' + '      margin: 0;\n' + '      padding: 0;\n' + '    }\n' + '\n' + '    .alert-message.danger, .alert-message.danger:hover, .alert-message.error, .alert-message.error:hover, .alert-message.success, alert-message.success:hover, .alert-message.info, .alert-message.info:hover {\n' + '      color: #ffffff;\n' + '    }\n' + '\n' + '    .alert-message .close {\n' + '      \n' + '      line-height: 18px;\n' + '    }\n' + '\n' + '    .alert-message.danger, .alert-message.error {\n' + '      background-color: #b5000d;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#ef4136), to(#b5000d));\n' + '      background-image: -moz-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: -ms-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #ef4136), color-stop(100%, #b5000d));\n' + '      background-image: -webkit-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: -o-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: linear-gradient(top, #ef4136, #b5000d);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#ef4136\', endColorstr=\'#b5000d\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #ef4136 #ef4136 #b5000d;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '    }\n' + '\n' + '    .alert-message.success {\n' + '      background-color: #57a957;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#62c462), to(#57a957));\n' + '      background-image: -moz-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: -ms-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #62c462), color-stop(100%, #57a957));\n' + '      background-image: -webkit-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: -o-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: linear-gradient(top, #62c462, #57a957);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#62c462\', endColorstr=\'#57a957\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #57a957 #57a957 #3d773d;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '    }\n' + '\n' + '    .alert-message.info {\n' + '      background-color: #339bb9;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#5bc0de), to(#339bb9));\n' + '      background-image: -moz-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: -ms-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #5bc0de), color-stop(100%, #339bb9));\n' + '      background-image: -webkit-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: -o-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: linear-gradient(top, #5bc0de, #339bb9);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#5bc0de\', endColorstr=\'#339bb9\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #339bb9 #339bb9 #22697d;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '    }\n' + '\n' + '    :root .alert-message {\n' + '      border-radius: 0 \\0;\n' + '    }\n' + '\n' + '    .close {\n' + '      float: right;\n' + '      color: #000000;\n' + '      font-size: 20px;\n' + '      font-weight: bold;\n' + '      line-height: 13.5px;\n' + '      text-shadow: 0 1px 0 #ffffff;\n' + '      filter: alpha(opacity=25);\n' + '      -khtml-opacity: 0.25;\n' + '      -moz-opacity: 0.25;\n' + '      opacity: 0.25;\n' + '    }\n' + '\n' + '    .close:hover {\n' + '      color: #000000;\n' + '      text-decoration: none;\n' + '      filter: alpha(opacity=40);\n' + '      -khtml-opacity: 0.4;\n' + '      -moz-opacity: 0.4;\n' + '      opacity: 0.4;\n' + '    }\n' + '\n' + '    .alert-message {\n' + '     \n' + '      font-size: 13px;\n' + '\n' + '      position: relative;\n' + '      padding: 7px 15px;\n' + '      margin-bottom: 18px;\n' + '      color: #404040;\n' + '\n' + '      background-color: #eedc94;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#fceec1), to(#eedc94));\n' + '      background-image: -moz-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: -ms-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fceec1), color-stop(100%, #eedc94));\n' + '      background-image: -webkit-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: -o-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: linear-gradient(top, #fceec1, #eedc94);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#fceec1\', endColorstr=\'#eedc94\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #eedc94 #eedc94 #e4c652;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n' + '      border-width: 1px;\n' + '      border-style: solid;\n' + '\n' + '      -webkit-border-radius: 4px;\n' + '      -moz-border-radius: 4px;\n' + '      border-radius: 4px;\n' + '\n' + '      -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' + '      -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' + '      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' + '    }\n' + '\n' + '    .alert-message .close {\n' + '      margin-top: 0;\n' + '    }\n' + '\n' + '    .alert-message a {\n' + '      font-weight: bold;\n' + '      color: #404040;\n' + '      text-decoration: none;\n' + '    }\n' + '\n' + '    .alert-message.danger p a, .alert-message.error p a, .alert-message.success p a, .alert-message.info p a {\n' + '      color: #ffffff;\n' + '    }\n' + '\n' + '    .alert-message p a:hover {\n' + '      text-decoration: underline;\n' + '    }\n' + '\n' + '    .alert-message p {\n' + '      margin-bottom: 0;\n' + '    }\n' + '  </style></div>');
  }]);
})();

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by fky on 3/13/2017.
 */
(function () {
  'use strict';

  angular.module('betosyswebapp').directive('noAuthorize', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/common/directives/noAuthorize.tpl.html',
      replace: true,
      link: function link(scope) {
        scope.$parent.isWidgetPreInitFinished = true; // disable the PreInit animation;
      }
    };
  });
})();

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/common/directives/noDataAvailable.tpl.html', '<div class="alerts"><div class="alert-message error"><p translate="userRight.notAvailable"></p></div><style>\n' + '    .alerts {\n' + '      margin: 20px;\n' + '    }\n' + '\n' + '    .alerts p {\n' + '      /* quick and dirty hack added by me, you may remove it if not needed */\n' + '      margin: 0;\n' + '      padding: 0;\n' + '    }\n' + '\n' + '    .alert-message.danger, .alert-message.danger:hover, .alert-message.error, .alert-message.error:hover, .alert-message.success, alert-message.success:hover, .alert-message.info, .alert-message.info:hover {\n' + '      color: #ffffff;\n' + '    }\n' + '\n' + '    .alert-message .close {\n' + '     \n' + '      line-height: 18px;\n' + '    }\n' + '\n' + '    .alert-message.danger, .alert-message.error {\n' + '      background-color: #b5000d;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#ef4136), to(#b5000d));\n' + '      background-image: -moz-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: -ms-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #ef4136), color-stop(100%, #b5000d));\n' + '      background-image: -webkit-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: -o-linear-gradient(top, #ef4136, #b5000d);\n' + '      background-image: linear-gradient(top, #ef4136, #b5000d);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#ef4136\', endColorstr=\'#b5000d\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #ef4136 #ef4136 #b5000d;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '    }\n' + '\n' + '    .alert-message.success {\n' + '      background-color: #57a957;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#62c462), to(#57a957));\n' + '      background-image: -moz-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: -ms-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #62c462), color-stop(100%, #57a957));\n' + '      background-image: -webkit-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: -o-linear-gradient(top, #62c462, #57a957);\n' + '      background-image: linear-gradient(top, #62c462, #57a957);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#62c462\', endColorstr=\'#57a957\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #57a957 #57a957 #3d773d;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '    }\n' + '\n' + '    .alert-message.info {\n' + '      background-color: #339bb9;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#5bc0de), to(#339bb9));\n' + '      background-image: -moz-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: -ms-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #5bc0de), color-stop(100%, #339bb9));\n' + '      background-image: -webkit-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: -o-linear-gradient(top, #5bc0de, #339bb9);\n' + '      background-image: linear-gradient(top, #5bc0de, #339bb9);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#5bc0de\', endColorstr=\'#339bb9\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #339bb9 #339bb9 #22697d;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '    }\n' + '\n' + '    :root .alert-message {\n' + '      border-radius: 0 \\0;\n' + '    }\n' + '\n' + '    .close {\n' + '      float: right;\n' + '      color: #000000;\n' + '      font-size: 20px;\n' + '      font-weight: bold;\n' + '      line-height: 13.5px;\n' + '      text-shadow: 0 1px 0 #ffffff;\n' + '      filter: alpha(opacity=25);\n' + '      -khtml-opacity: 0.25;\n' + '      -moz-opacity: 0.25;\n' + '      opacity: 0.25;\n' + '    }\n' + '\n' + '    .close:hover {\n' + '      color: #000000;\n' + '      text-decoration: none;\n' + '      filter: alpha(opacity=40);\n' + '      -khtml-opacity: 0.4;\n' + '      -moz-opacity: 0.4;\n' + '      opacity: 0.4;\n' + '    }\n' + '\n' + '    .alert-message {\n' + '      \n' + '      font-size: 13px;\n' + '\n' + '      position: relative;\n' + '      padding: 7px 15px;\n' + '      margin-bottom: 18px;\n' + '      color: #404040;\n' + '\n' + '      background-color: #eedc94;\n' + '      background-repeat: repeat-x;\n' + '\n' + '      background-image: -khtml-gradient(linear, left top, left bottom, from(#fceec1), to(#eedc94));\n' + '      background-image: -moz-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: -ms-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #fceec1), color-stop(100%, #eedc94));\n' + '      background-image: -webkit-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: -o-linear-gradient(top, #fceec1, #eedc94);\n' + '      background-image: linear-gradient(top, #fceec1, #eedc94);\n' + '      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\'#fceec1\', endColorstr=\'#eedc94\', GradientType=0);\n' + '\n' + '      text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n' + '      border-color: #eedc94 #eedc94 #e4c652;\n' + '      border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n' + '      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n' + '      border-width: 1px;\n' + '      border-style: solid;\n' + '\n' + '      -webkit-border-radius: 4px;\n' + '      -moz-border-radius: 4px;\n' + '      border-radius: 4px;\n' + '\n' + '      -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' + '      -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' + '      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);\n' + '    }\n' + '\n' + '    .alert-message .close {\n' + '      margin-top: 0;\n' + '    }\n' + '\n' + '    .alert-message a {\n' + '      font-weight: bold;\n' + '      color: #404040;\n' + '      text-decoration: none;\n' + '    }\n' + '\n' + '    .alert-message.danger p a, .alert-message.error p a, .alert-message.success p a, .alert-message.info p a {\n' + '      color: #ffffff;\n' + '    }\n' + '\n' + '    .alert-message p a:hover {\n' + '      text-decoration: underline;\n' + '    }\n' + '\n' + '    .alert-message p {\n' + '      margin-bottom: 0;\n' + '    }\n' + '  </style></div>');
  }]);
})();

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by fky on 3/23/2017.
 */
(function () {
  'use strict';

  angular.module('betosyswebapp').directive('noDataAvailable', function () {
    return {
      restrict: 'E',
      templateUrl: 'components/common/directives/noDataAvailable.tpl.html',
      replace: true,
      link: function link(scope) {
        scope.$parent.isWidgetPreInitFinished = true; // disable the PreInit animation;
      }
    };
  });
})();

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by fky on 2/23/2017.
 */


angular.module('betosyswebapp').directive('phoneInput', ["$filter", "$browser", function ($filter, $browser) {
  return {
    require: 'ngModel',
    link: function link($scope, $element, $attrs, ngModelCtrl) {
      var listener = function listener() {
        var value = $element.val().replace(/[^0-9]/g, '');
        $element.val($filter('tel')(value, false));
      };

      ngModelCtrl.$parsers.push(function (viewValue) {
        return viewValue.replace(/[^0-9]/g, '').slice(0, 20);
      });

      ngModelCtrl.$render = function () {
        $element.val($filter('tel')(ngModelCtrl.$viewValue, false));
      };

      $element.bind('change', listener);
      $element.bind('keydown', function (event) {
        var key = event.keyCode;
        if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) {
          return;
        }
        $browser.defer(listener);
      });

      $element.bind('paste cut', function () {
        $browser.defer(listener);
      });
    }

  };
}]);

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 *
 */


angular.module('betosyswebapp').directive('shortcut', function () {
  return {
    restrict: 'E',
    transclude: true,
    link: function link(scope) {
      var ctrlDown = false,
          ctrlKey = 17,
          cmdKey = 91,
          cKey = 67;
      scope.$on('$destroy', function () {

        $(document).unbind('click', documentClickEventHandler);
      });
      /**
       * client event handler which listens to document click .
       *
       * currently it listens the regions of telephone columns using the class names 'telephnoe-overview-btn' , 'overview-popup-telephn-input'
       *
       * @param {*} event
       */
      function documentClickEventHandler(event) {
        //console.log('click')
        if (!$(event.target).hasClass('overview-popup-telephn-input') && !$(event.target).hasClass('telephnoe-overview-btn') || $(event.target).hasClass('overview-popup-telephn-input')) {
          removeTelephonePopupElement();
        } else if ($(event.target).hasClass('telephnoe-overview-btn')) {

          var elHtml = '<div id="overview-telephn-popup-container" class="overview-telephn-popup-container">' + '<input id="overview-telephn-popup-input" class="overview-popup-telephn-input" type="text"  value="' + convertToPopupFormat($(event.target).val()) + '" readonly>' + '</input>' + '</div>';
          removeTelephonePopupElement();
          $(event.target).after(elHtml);
          $('#overview-telephn-popup-input').keydown(function (e) {
            if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
              ctrlDown = true;
            }
            if (ctrlDown && e.keyCode === cKey) {
              e.preventDefault();
              e.stopPropagation();
              $('#overview-telephn-popup-input').select();
              document.execCommand('copy');
              //console.log('Ctrl+c');
            }
          }).keyup(function (e) {
            if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
              ctrlDown = false;
            }
          });
          setTimeout(function () {
            $('#overview-telephn-popup-input').select();
          }, 10);
        }
      }

      $(document).on('click', documentClickEventHandler);

      /**
       * removed unwanted characters from phone number text .
       * replace '+' with '00' prefix.
       *
       * @param {*} phoneNumber
       */
      function convertToPopupFormat(phoneNumber) {
        //ignore if null
        if (phoneNumber === undefined || phoneNumber === null || phoneNumber === '') {
          return '';
        }
        var temp = phoneNumber;
        temp = temp.replace(/\+/g, '00'); // replace '+' with '00'
        return temp;
      }
      /**
       * Removes the dynamically added dom elements for telephone formatting pop up.
       */
      function removeTelephonePopupElement() {
        $('overview-telephn-popup-input').unbind();
        $('.overview-telephn-popup-container').unbind();
        $('.overview-telephn-popup-container').remove();
      }
    }
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 7/26/2018.
 */


angular.module('betosyswebapp').directive('tachoEventGraphic', ["$parse", "$window", "commonTrackService", "$translate", function ($parse, $window, commonTrackService, $translate) {
  return {
    restrict: 'EA',
    link: function link(scope, element) {
      var d3 = $window.d3;
      // var rawSvg = element.find('svg');
      // var svg = d3.select(rawSvg[0]);
      // X axix properties time format , and  other necessary values
      var xAxis, yScale, xScale;
      var isWidgetUnderDialog = element.parents('.modal-body').length || 0;

      var margin = {
        top: 10,
        right: 10,
        bottom: 25,
        left: isWidgetUnderDialog ? 80 : 10
      },
          width = isWidgetUnderDialog ? 1500 : 600,
          height = 300;

      //var paddingWidthDiffernce = isWidgetUnderDialog ? 4 : 2;


      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var todayMillis = today.getTime();
      var initialData = [{
        'tachoeventbegin': new Date(),
        'tachoeventend': new Date(),
        'tachoeventduration': 0,
        'workingState': '',
        'driverworkinstatevalue': 0
      }];

      scope.chartInitialData = initialData;

      var tachoDetailWidgtEvet = scope.$on('tacho_event_history_init_graphic', function (event, data) {
        if (data.eventType === 'tacho_event_history_table_row_select') {
          redrawChart(initialData);
          scope.chartInitialData = [];

          if (data.dataList.length > 0) {

            scope.chartInitialData = data.dataList;

            if (typeof scope.chartInitialData[0].tachoeventbegin === 'string') {
              scope.chartInitialData.forEach(function (d) {
                var parts = d.tachoeventbegin.split(/:/);
                var timePeriodMillis = parseInt(parts[0], 10) * 60 * 60 * 1000 + parseInt(parts[1], 10) * 60 * 1000;
                d.tachoeventbegin = new Date();
                d.tachoeventbegin.setTime(todayMillis + timePeriodMillis);

                var endParts = d.tachoeventend.split(/:/);
                var timeEndPeriodMillis = parseInt(endParts[0], 10) * 60 * 60 * 1000 + parseInt(endParts[1], 10) * 60 * 1000;
                d.tachoeventend = new Date();
                d.tachoeventend.setTime(todayMillis + timeEndPeriodMillis);
                d.tachoeventend.setTime(todayMillis + timeEndPeriodMillis);

                var hoursStringArray = d.tachoeventduration.split(':');
                var min = 0;
                min += Number(hoursStringArray[0] * 60);
                min = min + Number(hoursStringArray[1]);
                d.tachoeventduration = min / 60;
              });
              var start = moment().startOf('day');
              var end = moment(scope.chartInitialData[0].tachoeventbegin);
              var durationOfBeginPause = end.diff(start, 'minutes') / 60;

              var endOfDay = moment().endOf('day');
              var beggingOfEnd = moment(scope.chartInitialData[scope.chartInitialData.length - 1].tachoeventend);
              var durationOfEndPause = endOfDay.diff(beggingOfEnd, 'minutes') / 60;
              //console.log('start duration' + duration);

              scope.chartInitialData.unshift({
                tachoeventbegin: start.toDate(),
                tachoeventend: end.toDate(),
                tachoeventduration: durationOfBeginPause,
                driverworkinstatevalue: 0,
                driver1workingstate: $translate.instant('dashBoard.fleetManagement.tachoEventDetail.graphicsTab.pasueLabel')
              });
              scope.chartInitialData.push({
                tachoeventbegin: beggingOfEnd.toDate(),
                tachoeventend: endOfDay.toDate(),
                tachoeventduration: durationOfEndPause,
                driverworkinstatevalue: 0,
                driver1workingstate: $translate.instant('dashBoard.fleetManagement.tachoEventDetail.graphicsTab.pasueLabel')
              });
            }

            redrawChart(scope.chartInitialData);
          }
        }
      });
      var totalDelay = 500;
      var oneByOne = function oneByOne(d, i) {
        return totalDelay * i / scope.chartInitialData.length;
      };

      //  var tooltip = d3.select('#tooltip');


      // Define the div for the tooltipl
      var tooltip = d3.select(element[0]).append('div').attr('class', 'tooltip').style('opacity', 0);

      var svg = d3.select(element[0]).append('svg').attr('class', 'chart').attr('width', width).attr('height', height).append('g').attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');

      function getWorkStateColor(state) {
        switch (state) {
          case 0:
            //return 'black';
            return 'black';
          case 1:
            //return 'blue';
            return '#2e75bf';
          case 2:
            //return 'gray';
            return '#c9c9c9';
          case 3:
            //return 'red';
            return '#ef4136';
        }
      }

      function showTip(x) {
        tooltip.transition().duration(200).style('opacity', 100);
        tooltip.html(x.driver1workingstate + ' : ' + commonTrackService.getTimeStringFromMinutes(x.tachoeventduration * 60, '00h 00m')).style({
          left: d3.event.offsetX + 'px',
          top: d3.event.offsetY - 40 + 'px',
          background: getWorkStateColor(x.driverworkinstatevalue),
          color: '#fff',
          padding: '8px',
          transition: 'all 0.5s',
          'font-size': '11pt'
        });
      }

      function hideTip() {
        tooltip.transition().duration(500).style('opacity', 0);
      }

      function getDurationHour(dataObj) {
        var diffMinutes = (dataObj.tachoeventend.getTime() - dataObj.tachoeventbegin.getTime()) / (1000 * 60).toFixed(0);
        return diffMinutes / 60;
      }

      scope.$on('$destroy', function () {
        tachoDetailWidgtEvet();
      });

      function drawChartLine() {
        setChartParameters(initialData);
        svg.append('g').attr('transform', 'translate(' + margin.left + ', ' + margin.top + ')');

        updateChartData(initialData);

        svg.append('g').attr('class', 'x axis').attr('transform', 'translate(0, ' + (height - margin.top - margin.bottom) + ')').call(xAxis);
      }

      function getYAxisHeight(workingStateValue) {
        switch (workingStateValue) {
          case 0:
            return 1.5;
          case 1:
            return 2.5;
          case 2:
            return 3.5;
          case 3:
            return 5;
        }
      }

      function updateChartData(dataList) {
        svg.selectAll('rect').remove();

        svg.selectAll('.chart').data(dataList).enter().append('rect').attr('class', 'bar').attr('x', function (d) {
          return xScale(d.tachoeventbegin);
        }).attr('y', function (d) {
          return height - margin.top - margin.bottom - (height - margin.top - margin.bottom - yScale(getYAxisHeight(d.driverworkinstatevalue)));
        }).on('mouseenter', showTip).on('mouseleave', hideTip).attr('width', function (d) {

          // calculate width :?  ( completed untill step 5 )
          /**
           Widh Calculation formula
           1. calculate 1 unit width based on total width
           2. TotalWidth / total unit ==  800 /25 which is equal to 32
           3.  calculate tachoeventduration hours : from date object get time milliseconds convert to minutes than hours ,
           4.  1 unit width multiply by  calulated duaraion hour : width for particular section ( relative to the        whole section)
           5.  width for particlualr section - padding ( which is currently 2 px)
           6.  for every bar width needs to be subracted from the previous bar wdth
           7 .  total width - previous bar widths - current bar width :  exact width of the current bar.
           **/

          var durationHours = getDurationHour(d);
          //console.log('duration hours -' + durationHours);

          var testCal = 0;
          // subtract duration from  begginHours to remove previous bar width ;
          //var paddingWidth = paddingWidthDiffernce * durationHours;
          testCal = width / 25 * durationHours + 29 / 100 * durationHours;
          //console.log('Final calculation -' + testCal);
          return testCal;
        }).attr('height', function (d) {
          return height - margin.top - margin.bottom - yScale(getYAxisHeight(d.driverworkinstatevalue));
        }).transition().duration(1500).delay(oneByOne).ease('elastic').style('fill', function (d) {
          return getWorkStateColor(d.driverworkinstatevalue);
        });
      }

      function setChartParameters(dataList) {
        // define x axix time scale . initialize it with begin time from data .
        xScale = d3.time.scale().domain(d3.extent(dataList, function (d) {
          return d.tachoeventbegin;
        })).nice(d3.time.day, 1).rangeRound([0, width - margin.left - margin.right]);

        yScale = d3.scale.linear().domain([0, 5]).range([height - margin.top - margin.bottom, 0]);

        xAxis = d3.svg.axis().scale(xScale).orient('bottom').ticks(d3.time.hours, 1).tickFormat(d3.time.format('%H')).tickSize(0).tickPadding(4);
      }

      function redrawChart(dataList) {
        setChartParameters(dataList);
        updateChartData(dataList);
      }

      drawChartLine();
    }
  };
}]);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by ejt on 04.10.2016.
 */



angular.module('betosyswebapp').controller('ToastErrorCtrl', ['$scope', '$mdToast', 'msg', 'type', '$rootScope', '$document', '$timeout', function ($scope, $mdToast, msg, type, $rootScope, $document, $timeout) {
  // //, $mdToast, $mdDialog) {
  $scope.errorAlert = {};

  $scope.errorAlert.message = msg;
  $scope.errorAlert.type = type;

  $scope.closeToast = function () {

    $mdToast.hide('Ok', { closeAll: true });

    //wait for animation if everything goes right
    $timeout(function () {
      //somehow toasts are not removed reliably sometimes - reason unknown
      //remove all toast elements after $mdToast.hide(..)
      var elements = $('md-toast');
      //elements is empty if everything works fine
      for (var index in elements) {
        if (elements.hasOwnProperty(index)) {
          try {
            if (elements[index] && elements[index].parentNode) {
              elements[index].parentNode.removeChild(elements[index]);
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    }, 300);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/common/directives/toastErrorTemplate.tpl.html', '<md-toast style="z-index:2147483000; height:100px; margin-top:60px;"><i ng-if="errorAlert.type === \'warning\'" class="glyphicon glyphicon-warning-sign" style="font-size:30px;color:yellow;"></i> <i ng-if="errorAlert.type === \'info\'" class="glyphicon glyphicon-info-sign" style="font-size:30px;color:white;"></i> <i ng-if="errorAlert.type === \'danger\'" class="glyphicon glyphicon-alert" style="font-size:30px;color:red;"></i> <i ng-if="errorAlert.type === \'success\'" class="glyphicon glyphicon-ok" style="font-size:30px;color:green;"></i> <span style="margin-left:20px;" class="md-toast-text" ng-bind="errorAlert.message" flex=""></span><md-button ng-click="closeToast()" translate="responseErrorDilaog.ok" aria-label="Ok"></md-button></md-toast>');
  }]);
})();

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cxh on 12/2/2015.
 */

angular.module('betosyswebapp').filter('trustAsResourceUrl', ['$sce', function ($sce) {
  return function (val) {
    return $sce.trustAsResourceUrl(val);
  };
}]);

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cxh on 8/11/2016.
 */
(function () {
  'use strict';

  AdmFramworkService.$inject = ["accountConfig"];
  angular.module('betosyswebapp').service('AdmFramworkService', AdmFramworkService);

  /* @ngInject */
  function AdmFramworkService(accountConfig) {
    this.createMenuItem = createMenuItem;
    this.createParentMenuItem = createParentMenuItem;
    this.createChildMenuItem = createChildMenuItem;
    this.createLogoItem = createLogoItem;
    this.createPlaceholderItem = createPlaceholderItem;
    this.mobileAndTabletcheck = mobileAndTabletcheck;
    this.getBrowserUUID = getBrowserUUID;
    ////////////////

    function createMenuItem(text, href, userRights, iconClass) {

      var icon = iconClass === undefined ? 'fa-circle-o' : iconClass;

      var item = {
        type: 'treeview',
        active: false,
        leftClass: 'fa ' + icon,
        text: text,
        failures: 0,
        href: href
      };

      if (userRights) {
        checkRights(item, userRights);
      }

      return item;
    }

    function createParentMenuItem(text, childItems, iconClass) {

      var icon = iconClass === undefined ? 'fa-th' : iconClass;

      var parentItem = {
        type: 'treeview',
        active: false,
        leftClass: 'fa ' + icon,
        rightClass: 'fa fa-angle-left pull-right',
        rightActiveClass: 'fa fa-angle-down pull-right',
        text: text,
        childs: childItems
      };

      return parentItem;
    }

    function createChildMenuItem(text, href, userRights, iconclassName) {
      var iconclass = iconclassName ? iconclassName : 'fa fa-circle-o';
      var childItem = {
        type: 'tree-view-item',
        active: false,
        leftClass: iconclass,
        text: text,
        href: href
      };
      if (userRights) {
        checkRights(childItem, userRights);
      }
      return childItem;
    }

    function createLogoItem() {
      var logoClass = 'dsa-logo';
      var accountID = window.location.hostname.split('.')[0];
      if (accountID in accountConfig.imprintUrls) {
        logoClass = accountID + '-logo';
      }

      var childItem = {
        type: 'tree-view-item sidebar-logo',
        active: false,
        leftClass: logoClass,
        text: '',
        href: 'http://www.dsa.de/de/'
      };
      return childItem;
    }

    function createPlaceholderItem(height) {

      var childItem = {
        style:  true ? height : '80px',
        type: 'tree-view-item sidebar-placeholder',
        active: false,
        leftClass: '',
        text: '',
        href: ''
      };

      return childItem;
    }

    function checkRights(item, userRights) {
      // do nothing
      console.log(item);
      console.log(userRights);
    }

    function mobileAndTabletcheck() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }

    function getBrowserUUID() {
      var navigatorInfo = window.navigator;
      var screenInfo = window.screen;
      var uid = navigatorInfo.mimeTypes.length;
      uid += navigatorInfo.userAgent.replace(/\D+/g, '');
      uid += navigatorInfo.plugins.length;
      // uid += screenInfo.height || '';
      // uid += screenInfo.width || '';
      uid += screenInfo.pixelDepth || '';
      return uid;
    }
  }
})();

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 11/27/2017.
 */


angular.module('betosyswebapp').service('customerService', ["AdmFramworkService", "$translate", "customerName", "crudService", function (AdmFramworkService, $translate, customerName, crudService) {

  /**
   * build system sets the customer name while building , set the customer you need to defaultCustomer variable under build js .
   * @type {string}
   */
  // var customerName = 'fbr';
  var customerSideBar = {
    'fbr': [AdmFramworkService.createMenuItem('sidebar.betotrack.dashboard', 'betotrack.dashboard', '', 'fa fa-map-marker'), AdmFramworkService.createParentMenuItem('sidebar.betotrack.driver', [AdmFramworkService.createChildMenuItem('sidebar.betotrack.driverDashbordMenu', 'driverdashboard', ''), AdmFramworkService.createChildMenuItem('sidebar.betotrack.tachoHistoryDashboardMenu', 'tachohistorydashboard', '')], 'fa fa-clock-o'),

    /* AdmFramworkService.createMenuItem('sidebar.betotrack.portalcommand', 'portalcommand', '', 'fa fa-pencil-square-o'),*/
    AdmFramworkService.createMenuItem('sidebar.betotrack.fms', 'fmsdashboard', '', 'fa fa-tachometer'), AdmFramworkService.createParentMenuItem('sidebar.betotrack.tachoDashboardMenu', [AdmFramworkService.createChildMenuItem('sidebar.betotrack.tachoDownloadStatusDashboardMenu', 'tachodownloaddashboard', '', 'fa fa-download')], 'digital-tachograph'), AdmFramworkService.createMenuItem('sidebar.betotrack.map', 'trackMap', '', 'fa fa-globe'), AdmFramworkService.createParentMenuItem('sidebar.betotrack.reports', [AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.vehicledetail', 'reports.vehicleDetail', ''),
    /* AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupdetail', 'reports.groupDetail', ''), */ // disabled based on feed back by @ds :  BetoTrack / Reporting :  9/8/2018 3:23 PM,
    AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupsummary', 'reports.groupSummary', ''), AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.performance', 'reports.performance', '')], 'fa fa-list-alt'), AdmFramworkService.createParentMenuItem('sidebar.betotrack.admin', [AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.contactmgmt', 'contacts.list', ''), AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.bookmgmt', 'books.list', '')], 'fa fa-cog'),
    // AdmFramworkService.createMenuItem('sidebar.betotrack.telephone', 'telephones.list', '', 'fa fa-phone'),
    AdmFramworkService.createLogoItem()],
    'lgs': [AdmFramworkService.createMenuItem('sidebar.betotrack.dashboard', 'betotrack.dashboard', '', 'fa fa-map-marker'), AdmFramworkService.createParentMenuItem('sidebar.betotrack.driver', [AdmFramworkService.createChildMenuItem('sidebar.betotrack.driver', 'driverdashboard', ''), AdmFramworkService.createChildMenuItem('sidebar.betotrack.tachoHistoryDashboardMenu', 'tachohistorydashboard', '')], 'fa fa-clock-o'), AdmFramworkService.createMenuItem('sidebar.betotrack.map', 'trackMap', '', 'fa fa-globe'), AdmFramworkService.createParentMenuItem('sidebar.betotrack.reports', [AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.vehicledetail', 'reports.vehicleDetail', ''),
    /*AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupdetail', 'reports.groupDetail', ''), */ // disabled based on feed back by @ds :  BetoTrack / Reporting :  9/8/2018
    AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.groupsummary', 'reports.groupSummary', ''), AdmFramworkService.createChildMenuItem('sidebar.betotrack.reportitems.performance', 'reports.performance', '')], 'fa fa-list-alt'), AdmFramworkService.createParentMenuItem('sidebar.betotrack.admin', [AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.contactmgmt', 'contacts.list', ''), AdmFramworkService.createChildMenuItem('sidebar.betotrack.adminitems.bookmgmt', 'books.list', '')], 'fa fa-cog'),
    // AdmFramworkService.createMenuItem('sidebar.betotrack.telephone', 'telephones.list', '', 'fa fa-phone'),
    AdmFramworkService.createLogoItem()]

  };

  var customerDashbord = {
    'fbr': {
      lastLocationDashboard: {
        XS: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }, {
                'type': 'TempMonitoringWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                'config': {
                  'height': 450,
                  'maxHours': 2,
                  'temperatureUnit': '',
                  'max': null,
                  'min': null
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 5
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }, {
                'type': 'TempMonitoringWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                'config': {
                  'height': 450,
                  'maxHours': 2,
                  'temperatureUnit': '',
                  'max': null,
                  'min': null
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-6 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'vehicleListWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 8
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }, {
                    'type': 'TempMonitoringWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                    'config': {
                      'height': 450,
                      'maxHours': 2,
                      'temperatureUnit': '',
                      'max': null,
                      'min': null
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 8
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'vehicleListWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }, {
                    'type': 'TempMonitoringWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                    'config': {
                      'height': 450,
                      'maxHours': 2,
                      'temperatureUnit': '',
                      'max': null,
                      'min': null
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      driverDashboard: {
        XS: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 8
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'type': 'DriverWrkHrsSVGWidget',
              'fullScreen': true,
              'modalSize': 'lg',
              'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
              'config': {
                'mapURL': null,
                'height': 450
              }
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      portalCommandsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 8
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 },*/{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 10
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 },*/{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      fmsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 8
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'styleClass': 'col-md-9',
            'rows': [{
              'columns': [{
                'styleClass': 'col-md-12',
                'widgets': [{
                  'type': 'FMSVehicleWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                  'config': {
                    'vehicleGroup': null,
                    'noOfGridRows': 20
                  }
                }]
              }]
            }]
          }, {
            'columns': [{
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'FMSVehicleWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 20
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      tachoHistoryDashboard: {
        XS: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        }
      },
      tachoDownloadStatus: {
        XS: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'tachoDownloadStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                'config': {
                  'noOfGridRows': 20,
                  vehicleGroup: null
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'tachoDownloadStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                'config': {
                  'noOfGridRows': 20,
                  vehicleGroup: null
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoDownloadStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                    'config': {
                      'noOfGridRows': 20,
                      vehicleGroup: null
                    }
                  }]
                }]
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.tachoDownloadStatusTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoDownloadStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoDownloadStatus.title'),
                    'config': {
                      'noOfGridRows': 20,
                      vehicleGroup: null
                    }
                  }]
                }]
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }

      }

    },
    'lgs': {
      lastLocationDashboard: {
        XS: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 4
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')
              }, {
                'type': 'TempMonitoringWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                'config': {
                  'height': 450,
                  'maxHours': 2,
                  'temperatureUnit': '',
                  'max': null,
                  'min': null
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehicleListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 5
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'styleClass': 'col-md-9',
            'rows': [{
              'columns': [{
                'styleClass': 'col-md-12',
                'widgets': [{
                  'type': 'vehicleListWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                  'config': {
                    'vehicleGroup': null,
                    'noOfGridRows': 8
                  }
                }, {
                  'type': 'fleetMapWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'config': {
                    'mapURL': null,
                    'height': 600
                  },
                  'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                }, {
                  'type': 'TempMonitoringWidget',
                  'fullScreen': true,
                  'modalSize': 'lg',
                  'title': $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.title'),
                  'config': {
                    'height': 450,
                    'maxHours': 2,
                    'temperatureUnit': '',
                    'max': null,
                    'min': null
                  }
                }]
              }]
            }]
          }, {
            'columns': [{
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.lastLocationDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'vehicleListWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleListTitle'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      driverDashboard: {
        XS: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'DriverWrkHrsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'fleetMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'config': {
                  'mapURL': null,
                  'height': 600
                },
                'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 8
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {

                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.driverDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'DriverWrkHrsWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 10
                    }
                  }, {
                    'type': 'fleetMapWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'config': {
                      'mapURL': null,
                      'height': 600
                    },
                    'title': $translate.instant('dashBoard.fleetManagement.fleetMap.fleetMapTitle')

                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'DriverDigitalTachoStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                'config': {}
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      portalCommandsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{ // disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 }, */{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 8
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 },*/{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.portalCommandsDashboardTitle'),
          structure: '7-5 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-7',
              'widgets': [{
                'type': 'vehiclesListWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': 10
                }
              }]
            }, {
              'styleClass': 'col-md-5',
              'widgets': [{
                'type': 'vehicleStatusWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleStatusWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': ''
                }
              }, /*{// disabled due to FBR Testing.
                 'type': 'digitalOutputsWidget',
                 'fullScreen': true,
                 'modalSize': 'lg',
                 'title': $translate.instant('dashBoard.fleetManagement.digitalOutputsWidget.title'),
                 'config': {
                 'statusCodeList': [],
                 'vehicleList': [],
                 'vehicleGroup': null,
                 'vehicleGroupList': [],
                 'statusCode': null,
                 'noOfGridRows': ''
                 }
                 },*/{
                'type': 'pendingCommandsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title'),
                'config': {
                  'statusCodeList': [],
                  'vehicleList': [],
                  'vehicleGroup': null,
                  'vehicleGroupList': [],
                  'statusCode': null,
                  'noOfGridRows': '',
                  'height': 300
                }
              }]
            }, {
              'columns': [{ 'styleClass': 'col-md-6', 'widgets': [] }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      fmsDashboard: {
        XS: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 4
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '12/6-6',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-12',
              'widgets': [{
                'type': 'FMSVehicleWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                'config': {
                  'vehicleGroup': null,
                  'noOfGridRows': 5
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              columns: [{
                styleClass: 'col-md-6'
              }, {
                styleClass: 'col-md-6'
              }]
            }]
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'FMSVehicleWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 20
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.fmsDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'FMSVehicleWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList'),
                    'config': {
                      'vehicleGroup': null,
                      'noOfGridRows': 20
                    }
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleDetailsWidget',
                'title': $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'),
                'config': {
                  'selectedRowDetails': {
                    'deviceId': null,
                    'startDate': null,
                    'endDate': null
                  },
                  'noOfGridRows': 10
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        }
      },
      tachoHistoryDashboard: {
        XS: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, { 'styleClass': 'col-md-6', 'widgets': [] }]
            }], 'widgets': []
          }]
        },
        SM: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        MD: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        },
        LG: {
          title: $translate.instant('dashBoard.tachoHistoryDashboardTitle'),
          structure: '9-3 (12/6-6)',
          'rows': [{
            'columns': [{
              'styleClass': 'col-md-9',
              'rows': [{
                'columns': [{
                  'styleClass': 'col-md-12',
                  'widgets': [{
                    'type': 'tachoHistoryWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle'),
                    'config': {
                      'noOfGridRows': 8
                    }
                  }]
                }]
              }, {
                'columns': [{
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'tachoEventDetailWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'),
                    'config': {}
                  }]
                }, {
                  'styleClass': 'col-md-6',
                  'widgets': [{
                    'type': 'DriverDigitalTachoStatusWidget',
                    'fullScreen': true,
                    'modalSize': 'lg',
                    'title': $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'),
                    'config': {}
                  }]
                }]
              }]
            }, {
              'styleClass': 'col-md-3',
              'widgets': [{
                'type': 'DriverWrkHrsSVGWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.driverWhrkHrsSVG.title'),
                'config': {
                  'mapURL': null,
                  'height': 450
                }
              }, {
                'type': 'vehicleMapWidget',
                'fullScreen': true,
                'modalSize': 'lg',
                'title': $translate.instant('dashBoard.fleetManagement.deviceMap.deviceMapTitle'),
                'config': {
                  'mapURL': null,
                  'height': 395
                }
              }]
            }, {
              'columns': [{
                'styleClass': 'col-md-6', 'widgets': []
              }, {
                'styleClass': 'col-md-6', 'widgets': []
              }]
            }], 'widgets': []
          }]
        }
      }

    }
  };

  this.getVehicleFailuresCount = function () {
    var requestParam = {
      reportName: 'TellTaleAlertCount'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'vehicleeventdetailcount', param);
  };

  this.getCustomerSideBarMenu = function () {
    return customerSideBar[customerName];
  };
  this.getLoginWindowText = function () {
    return $translate.instant('login.tittle.' + customerName);
  };
  this.getProductLogText = function () {
    return $translate.instant('nav.productLogoText.' + customerName);
  };
  this.getProductLogoShortText = function () {
    return $translate.instant('nav.productLogoShortText.' + customerName);
  };
  this.getLastLocationDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].lastLocationDashboard[viewPortName];
  };

  this.getDriverDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].driverDashboard[viewPortName];
  };
  this.getPortalCommandDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].portalCommandsDashboard[viewPortName];
  };
  this.getFmsDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].fmsDashboard[viewPortName];
  };

  this.getTachoHistoryDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].tachoHistoryDashboard[viewPortName];
  };
  this.getTachoDownloadStatusDashboardConfig = function (viewPortName) {
    return customerDashbord[customerName].tachoDownloadStatus[viewPortName];
  };
}]);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by fky on 3/16/2017.
 */


angular.module('betosyswebapp').service('errorHandlingService', ["$uibModal", "$timeout", "$q", "$translate", "toastService", function ($uibModal, $timeout, $q, $translate, toastService) {
  var modelInstance;

  this.hasJqxNotificationCreated = false;
  /**
   * Use if rest status code 400 is returned
   *
   * @param response
   */
  this.errorForNoAuthorized = function (response) {
    var errCode = 0;
    try {
      errCode = response.data.errors[0].code;
      /*jshint unused:true */
    } catch (e) {
      //intentionally do nothing
    }
    if (checkIsAuthorizedErrorCode(errCode)) {
      return true;
    }
    this.handleForCommonResponse(response);
    return false;
  };

  this.handleForCommonResponse = function (rejection) {

    // Request Timed out
    if (rejection.status === 504) {
      toastService.showErrorToast({
        type: 'F',
        message: $translate.instant('errorCodes.restAPI.52504.message')
      });
      return $q.reject(rejection);
    }

    var content = '';
    if (rejection.data && rejection.data.length > 0 && rejection.status !== 401) {
      content = rejection.data[0].message;
    } else {
      if (rejection.data && rejection.data.errors && rejection.data.errors.length > 0) {
        //console.log($translate.instant('errorCodes.' + rejection.data.errors[0].code));
        if (!rejection.data.errors[0].code.match(/^[0-9]+$/)) {
          // check for GTS Type of error code
          content = rejection.data.message;
        } else {
          // non GTS Type of messages
          content = $translate.instant('errorCodes.' + rejection.data.errors[0].code);
          content = content !== 'errorCodes.' + rejection.data.errors[0].code ? content : rejection.data.message;
        }
      } else {
        if (rejection.data && rejection.data.message) {
          content = rejection.data.message;
        }
      }
    }
    if (content && content !== '') {
      showMessage('danger', content);
    }
    return $q.reject(rejection);
  };

  //timeout
  this.handleForUnknowResponse = function () {
    showMessage('danger', $translate.instant('errorCodes.timeout'));
  };

  this.handleForErrorNumber = function (errorNumber) {
    openModelDialog(getErrorObjectFromErrorNumber(errorNumber));
  };
  function getErrorObjectFromErrorNumber(errorNumber) {
    var _errorObj = {};
    _errorObj.errorNumber = errorNumber;
    if ($translate.instant('errorCodes.restAPI.' + errorNumber + '.message') !== 'errorCodes.restAPI.' + errorNumber + '.message') {
      _errorObj.message = $translate.instant('errorCodes.restAPI.' + errorNumber + '.message');
    }
    if ($translate.instant('errorCodes.restAPI.' + errorNumber + '.type') !== 'errorCodes.restAPI.' + errorNumber + '.type') {
      _errorObj.type = $translate.instant('errorCodes.restAPI.' + errorNumber + '.type');
    }
    if ($translate.instant('errorCodes.restAPI.' + errorNumber + '.format') !== 'errorCodes.restAPI.' + errorNumber + '.format') {
      _errorObj.format = Number($translate.instant('errorCodes.restAPI.' + errorNumber + '.format'));
    }
    return _errorObj;
  }

  /**
   * @param type message type. eg 'danger'
   * @param message
   */
  function showMessage(type, message) {
    openModelDialog({ type: type, message: message });
  }

  function checkIsAuthorizedErrorCode(errorCode) {
    if (errorCode !== undefined) {
      //
      var authorizeCode = ['CM0010', 'CM0011', 'CM0015', 'CM0020', 'AU0010', 'AC0020', 'AC0030', 'AC0040', 'AC0042', 'AC0046', 'US0020'];
      for (var i = 0; i < authorizeCode.length; i++) {
        if (errorCode === authorizeCode[i]) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   *
   * @param errorObject = {message: '', type: '', format; ''}
   * @returns {string}
   */
  function createTemplate(errorObject) {
    errorObject.format = errorObject.format || 0;

    return '<div class="modal-header">' + '<h4 class="modal-title"><i class="glyphicon ' + getMessageType(errorObject.type) + ' style="font-size: 50px;"></i> BetoTrack </h4>' + '</div>' + '<div class="modal-body">' + '<div>' + errorObject.message + '</div>' + '</div>' + '<div class="modal-footer">' + getButtons(errorObject.format) + '</div>';
  }

  function getMessageType(type) {
    switch (type) {
      case 'M':
        return 'glyphicon-info-sign';
      case 'W':
        return 'glyphicon-warning-sign';
      case 'F':
        return 'glyphicon-alert';
      default:
        return 'glyphicon-alert';
    }
  }

  function getButtons(format) {
    switch (format) {
      case 0:
        return '<button  class="btn btn-primary" ng-click="ok()" focus-on="true" translate="responseErrorDilaog.ok">';
      case 1:
        return '<button  class="btn btn-primary" ng-click="yes()" translate="responseErrorDilaog.yes">' + '<button type="button" class="btn btn-warning" ng-click="no()" translate="responseErrorDilaog.no"></button>';
      case 3:
        return '<button  class="btn btn-primary" ng-click="yes()" translate="responseErrorDilaog.yes">' + '<button type="button" class="btn btn-warning" ng-click="no()" translate="responseErrorDilaog.no"></button>' + '<button type="button" class="btn btn-warning" ng-click="cancel()" translate="responseErrorDilaog.cancel"></button>';
      default:
        return '<button  class="btn btn-primary" ng-click="ok()" translate="responseErrorDilaog.ok">';
    }
  }

  /* INTERNAL FUNCTIONS */
  /**
   *
   * @param errorObject = {message: '', type: '', format; ''}
   */

  function openModelDialog(errorObject) {
    var template = createTemplate(errorObject);
    modelInstance = $uibModal.open({
      template: template,
      controller: ["$scope", "$rootScope", function controller($scope, $rootScope) {

        $scope.ok = function () {
          if (errorObject.errorNumber) {
            $rootScope.$broadcast('errorEvent', {
              errorNumber: errorObject.errorNumber,
              type: 'ok'
            });
          }

          $scope.$close();
        };

        $scope.yes = function () {
          if (errorObject.errorNumber) {
            $rootScope.$broadcast('errorEvent', {
              errorNumber: errorObject.errorNumber,
              type: 'yes'
            });
          }

          $scope.$close();
        };
        $scope.no = function () {
          if (errorObject.errorNumber) {
            $rootScope.$broadcast('errorEvent', {
              errorNumber: errorObject.errorNumber,
              type: 'no'
            });
          }
          $scope.$dismiss();
        };

        $scope.cancel = function () {
          if (errorObject.errorNumber) {
            $rootScope.$broadcast('errorEvent', {
              errorNumber: errorObject.errorNumber,
              type: 'cancel'
            });
          }
          $scope.$dismiss();
        };
      }]
    });

    if (errorObject.format === 5) {
      setTimeout(function () {
        modelInstance.dismiss('time out');
      }, 2000);
    }
  }

  var that = this;
  this.showJqxNotificationInfo = function (notificationContent) {
    that.createJqxNitification();
    $('#jqx_notification_content').html(notificationContent);
    $('#jqx_notification').jqxNotification('open');
  };
  this.createJqxNitification = function () {
    if (!this.hasJqxNotificationCreated) {
      $('#jqx_notification').jqxNotification({
        animationCloseDelay: 100,
        opacity: 1,
        width: 325,
        autoOpen: false,
        autoClose: false,
        appendContainer: '#jqx_notification_container',
        template: 'info'
      });
      this.hasJqxNotificationCreated = true;
    }
  };
  this.closeJqxNotificationInfo = function () {
    // close all exsisting notification related to the view when ever localcation changes. 
    try {
      $('#jqx_notification').jqxNotification('closeAll');
    } catch (err) {
      console.log(err);
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by cxh on 10/29/2016.
 */


angular.module('betosyswebapp').service('messageService', ["AuthenticationService", "webSocketService", "$rootScope", "commonTrackService", "AdmFramworkService", function (AuthenticationService, webSocketService, $rootScope, commonTrackService, AdmFramworkService) {
  var messageCallback;

  this.initialize = function () {
    var loginID = AuthenticationService.GetLoginID();
    if (loginID) {
      var subscribeID = '/topic/' + loginID.Account;
      var uuid = AdmFramworkService.getBrowserUUID();
      var clientID = loginID.Account + '-' + loginID.username + '-' + uuid;
      var fleetServerDetails;
      commonTrackService.getFleetServerDetails().then(function (fleetDetails) {
        fleetServerDetails = fleetDetails;
        if (fleetServerDetails.instantMessageEnabled || fleetServerDetails.instantJobEvntEnabled) {
          webSocketService.connect(clientID);
          webSocketService.subscribe(subscribeID, clientID);
        }
      }).then(function () {
        if (!messageCallback) {
          messageCallback = function messageCallback(data) {
            var headers = data.headers;
            var message = JSON.parse(data.body);
            console.log(headers);
            console.log(message);
            if (message.instanceResponseType === 'instant_message' && fleetServerDetails.instantMessageEnabled) {
              $rootScope.$broadcast('msg-event', message);
            }
            if (message.instanceResponseType === 'instant_jobEvent' && fleetServerDetails.instantJobEvntEnabled) {
              $rootScope.$broadcast('job-event', message);
            }
          };

          webSocketService.receive().then(null, null, messageCallback);
        }
      });
    }
  };

  this.deInitialize = function () {
    webSocketService.unsubscribe();
    webSocketService.disconnect();
  };
}]);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



angular.module('betosyswebapp').service('stateManagerService', ["$log", "AuthenticationService", function ($log, AuthenticationService) {

    var stateData = {};

    this.updateDeviceID = function (widgetName, value, updateGlobal) {

        this.updateValue(widgetName, 'deviceID', value, updateGlobal);
    };

    this.updateStartDate = function (widgetName, value, updateGlobal) {

        this.updateValue(widgetName, 'startDate', value, updateGlobal);
    };

    this.updateEndDate = function (widgetName, value, updateGlobal) {

        this.updateValue(widgetName, 'endDate', value, updateGlobal);
    };

    this.updateGlobalValue = function (valueType, value) {
        var date = new Date().getTime();

        if (!stateData.global) {
            stateData.global = {};
        }

        stateData.global[valueType] = {
            value: value,
            timestamp: date
        };

        stateData.global.timestamp = date;
    };

    this.updateValue = function (widgetName, valueType, value, updateGlobal) {
        var loginID = AuthenticationService.GetLoginID();
        widgetName = loginID.Account + '_' + loginID.username + '_' + widgetName;
        if (!stateData[widgetName]) {
            stateData[widgetName] = {};
        }

        var date = new Date().getTime();

        stateData[widgetName][valueType] = {
            value: value,
            timestamp: date
        };

        stateData[widgetName].timestamp = date;

        if (updateGlobal === true) {
            if (!stateData.global) {
                stateData.global = {};
            }
            stateData.global[valueType] = {
                value: value,
                timestamp: date
            };
            stateData.global.timestamp = date;
        }
    };

    this.log = function (data) {
        $log.info(data);
    };

    this.getStateData = function () {
        return stateData;
    };

    this.getGlobalStateData = function () {

        if (!stateData.global) {
            stateData.global = {};
        }
        return stateData.global;
    };
}]);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by ejt on 04.10.2016.
 */


angular.module('betosyswebapp').service('toastService', ["$filter", "$mdToast", function ($filter, $mdToast) {

  this.showWarningToast = function (msg) {
    $mdToast.show({
      hideDelay: 10000,
      position: 'top right',
      controller: 'ToastErrorCtrl',
      locals: {
        type: 'warning',
        msg: msg
      },
      templateUrl: 'components/common/directives/toastErrorTemplate.tpl.html'
    });
  };

  this.showErrorToast = function (errorAlert) {
    $mdToast.show({
      hideDelay: 10000,
      position: 'top right',
      controller: 'ToastErrorCtrl',
      locals: {
        type: getMessageType(errorAlert.type),
        msg: errorAlert.message
      },
      templateUrl: 'components/common/directives/toastErrorTemplate.tpl.html'
    });
  };

  this.showSuccessToast = function (successMessage) {
    $mdToast.show({
      hideDelay: 5000,
      position: 'top right',
      controller: 'ToastErrorCtrl',
      locals: {
        type: 'success',
        msg: successMessage
      },
      templateUrl: 'components/common/directives/toastErrorTemplate.tpl.html'
    });
  };

  function getMessageType(type) {
    switch (type) {
      case 'M':
        return 'warning';
      case 'W':
        return 'warning';
      case 'F':
        return 'danger';
      default:
        return 'info';
    }
  }
}]);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/15/2016.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('betosyswebapp').service('commonTrackService', ["serverBaseUrl", "crudService", "$q", "AuthenticationService", "base64", "$rootScope", "$window", "$http", "languageService", "$timeout", "$filter", "localStorageService", "$translate", "dataContainerService", "$uibModal", "errorHandlingService", "widgetSettingsCreatorService", "dashboardService", "localStoragePrefix", function (serverBaseUrl, crudService, $q, AuthenticationService, base64, $rootScope, $window, $http, languageService, $timeout, $filter, localStorageService, $translate, dataContainerService, $uibModal, errorHandlingService, widgetSettingsCreatorService, dashboardService, localStoragePrefix) {

  var gtsServerSettings = {};
  var gtsDatePickerSettings = {};
  var loginID = '';
  var mainUrlDetails = '';
  var _lastLocationWidgetData = {};
  var _driverDashboardWidgetData = {};
  var _lastSelectedGroup = {};
  var _summaryCheckColumn = [];
  var that = this;
  var _dateRangePickerInitializedDate = null;
  this.dateRange = {
    LONG: 'LONG',
    MID: 'MID',
    SHORT: 'SHORT'
  };

  var driverMessageProperties = {
    driverMessageList: [],
    unreadMessages: 0,
    _tmpRefreshCheck: undefined
  };
  var notificationProperties = {
    notificationList: [],
    unreadNotification: 0
  };

  var accountSettings = {
    speedUnits: null,
    distanceUnits: null,
    volumeUnits: null,
    pressureUnits: null,
    economyUnits: null,
    temperatureUnits: null,
    timeZone: '',
    currencyUnits: null
  };
  var userSettings = {
    preferredDeviceID: null,
    authorizedGroupId: null,
    gridsSetting: {},
    SideBarStatus: {
      isCollapsed: true
    }
  };
  var gerneralSettings = {
    login: {
      accountID: ''
    }
  };

  this.initAuthdata = function () {
    loginID = AuthenticationService.GetLoginID();
    if (mainUrlDetails !== '') {
      mainUrlDetails = '';
    }
    mainUrlDetails = '?account=' + loginID.Account + '&faout=' + encodeURIComponent($rootScope.globals.currentUser.authdata);
  };

  this.getFleetServerDetails = function () {
    if (Object.getOwnPropertyNames(gtsServerSettings).length > 0) {
      var deferred = $q.defer();
      deferred.resolve(gtsServerSettings);
      return deferred.promise;
    } else {
      return this.setFleetServerDetails().then(function () {
        return gtsServerSettings;
      });
    }
  };

  this.getDatePickerDetails = function () {
    if (Object.getOwnPropertyNames(gtsDatePickerSettings).length > 0) {
      var deferred = $q.defer();
      deferred.resolve(gtsDatePickerSettings);
      return deferred.promise;
    } else {
      return this.setDatePickerDetails().then(function () {
        return gtsDatePickerSettings;
      });
    }
  };

  // SCL-1340
  // this.getTeletaleGroupComboList = function(isUserSettingsApplied, isWithAll){

  //   var telltaleGroupList = [
  //     {
  //       telltaleID : 'info',
  //       description : 'Info'
  //     },
  //     {
  //       telltaleID : 'yellow',
  //       description : 'Yellow'
  //     },
  //     {
  //       telltaleID : 'red',
  //       description : 'Red'
  //     },
  //   ];

  //   // return crudService.get('overview/devicegroup').then(function (telltaleGroupList) {
  //     if (isUserSettingsApplied) {
  //       var _authorisedGroup = userSettings.authorizedGroupId;
  //       var _tmpSource = [];
  //       if (_authorisedGroup !== null) {
  //         for (var i = 0; i < telltaleGroupList.length; i++) {
  //           if (telltaleGroupList[i].groupID === _authorisedGroup) {
  //             _tmpSource[0] = telltaleGroupList[i];
  //             break;
  //           }
  //         }
  //       }
  //       telltaleGroupList = _tmpSource.length > 0 ? _tmpSource : telltaleGroupList;
  //     }
  //     if (isWithAll) {
  //       if (telltaleGroupList.length > 0) {
  //         if (telltaleGroupList[0].telltaleID !== 'all') {
  //           telltaleGroupList.unshift({
  //             description: $translate.instant('additionalTranslation.comboboxOptionALL'),
  //             telltaleID: 'all'
  //           });
  //         }
  //       }
  //     }
  //     return $q.resolve(telltaleGroupList);

  //   // });
  // };


  this.getVehicleGroupComboList = function () {

    // includeGroupOptionAll is by default true , if user authorized to see all the groups then the server will return
    // 'all' group as part of response , description for 'all' must be added manually after the response
    return crudService.get('overview/devicegroup?includeGroupOptionAll=true').then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {

        if (vechileGroupList[0].groupID === 'all') {
          // server sends option all without translation
          vechileGroupList[0].description = $translate.instant('additionalTranslation.comboboxOptionALL');
        }
      }

      return vechileGroupList;
    });
  };

  this.setFleetServerDetails = function () {
    return crudService.get('overview/fleetserver').then(function (getsServerDetails) {
      gtsServerSettings = getsServerDetails;
      return gtsServerSettings;
    });
  };

  this.setDatePickerDetails = function () {
    return crudService.get('viewsettings/daterangepickersettings').then(function (getsPickerDetails) {
      gtsDatePickerSettings = getsPickerDetails;
      return gtsDatePickerSettings;
    });
  };

  this.updateGtsAccountSettings = function () {
    return crudService.get('user/accountsettings').then(function (gtsAccountSettings) {

      if (!gtsAccountSettings) {
        gtsAccountSettings = {};
      }
      accountSettings.speedUnits = gtsAccountSettings.speedUnits !== undefined ? gtsAccountSettings.speedUnits : null;
      accountSettings.distanceUnits = gtsAccountSettings.distanceUnits !== undefined ? gtsAccountSettings.distanceUnits : null;
      accountSettings.volumeUnits = gtsAccountSettings.volumeUnits !== undefined ? gtsAccountSettings.volumeUnits : null;
      accountSettings.pressureUnits = gtsAccountSettings.pressureUnits !== undefined ? gtsAccountSettings.pressureUnits : null;
      accountSettings.economyUnits = gtsAccountSettings.economyUnits !== undefined ? gtsAccountSettings.economyUnits : null;
      accountSettings.temperatureUnits = gtsAccountSettings.temperatureUnits !== undefined ? gtsAccountSettings.temperatureUnits : null;
      accountSettings.timeZone = gtsAccountSettings.timeZone !== undefined ? gtsAccountSettings.timeZone : '';
      accountSettings.currencyUnits = gtsAccountSettings.currencyUnits !== undefined ? gtsAccountSettings.currencyUnits : null;
      loginID = AuthenticationService.GetLoginID();
      if (loginID) {
        localStorageService.set('accountSettings.' + loginID.Account + '.' + loginID.username, accountSettings);
      }
      return accountSettings;
    });
  };

  /**
   * if isLatest set true will get the latest settings from server , ( have problem due to local storage instant changes under the
   * Track Application not reflected here in betotrack.
   *
   * @param isLatest
   */
  this.getGtsAccountSettings = function (isLatest) {
    loginID = AuthenticationService.GetLoginID();
    var localStorageAccountSettings = localStorageService.get('accountSettings.' + loginID.Account + '.' + loginID.username);
    if (!isLatest && localStorageAccountSettings) {
      accountSettings = localStorageAccountSettings;
      var deferred = $q.defer();
      deferred.resolve(accountSettings);
      return deferred.promise;
    } else {
      return that.updateGtsAccountSettings();
    }
  };

  this.updateGtsUserSettings = function () {
    return crudService.get('user/usersettings').then(function (gtsUserSettings) {
      userSettings.authorizedGroupId = gtsUserSettings !== undefined ? gtsUserSettings.authorizedGroupId : null;
      userSettings.preferredDeviceID = gtsUserSettings !== undefined ? gtsUserSettings.preferredDeviceID : null;
      loginID = AuthenticationService.GetLoginID();
      var localstorageSettings = that.getGtsLocalStorageSettings() || {};
      userSettings.gridsSetting = localstorageSettings.gridsSetting || {};
      localStorageService.set('userSettings.' + loginID.Account + '.' + loginID.username, userSettings);
      return userSettings;
    });
  };
  this.getGtsUserSettings = function (isLatest) {
    loginID = AuthenticationService.GetLoginID();
    var localStorageUserSettings = localStorageService.get('userSettings.' + loginID.Account + '.' + loginID.username);
    if (!isLatest && localStorageUserSettings) {
      userSettings = localStorageUserSettings;
      var deferred = $q.defer();
      deferred.resolve(userSettings);
      return deferred.promise;
    } else {
      return that.updateGtsUserSettings();
    }
  };
  this.getGtsLocalStorageSettings = function () {
    if (AuthenticationService.GetLoginID()) {
      loginID = AuthenticationService.GetLoginID();
      return localStorageService.get('userSettings.' + loginID.Account + '.' + loginID.username);
    }
    return null;
  };

  this.saveGtsUserSettings = function (userSettings) {
    loginID = AuthenticationService.GetLoginID();
    localStorageService.set('userSettings.' + loginID.Account + '.' + loginID.username, userSettings);
  };
  this.getDeviceComboList = function (isWithAll) {
    return crudService.get('overview/devicelist').then(function (devices) {

      devices = devices.sort(function (a, b) {
        return _sortCompare(a.description, b.description, true);
      });

      if (isWithAll) {
        if (devices.length > 0) {
          if (devices[0].deviceID !== 'all') {
            devices.unshift({
              description: $translate.instant('additionalTranslation.comboboxOptionALL'),
              deviceID: 'all'
            });
          }
        }
      }
      return devices;
    });
  };

  this._functionUpdateMapUrl = function (serverUrl, value, frameId) {

    var mapURL = serverUrl + mainUrlDetails + value + '&locale=' + languageService.getLanguageSettings().language;
    if (frameId) {
      mapURL += '&frameId=' + frameId;
    }
    return mapURL + '&required_session=false';
  };

  this.getSelectRowIndexByCache = function (rows) {
    var selectedIndex = -1;
    var loginid = AuthenticationService.GetLoginID();
    var lastCacheMap = localStorageService.get('selected_vehicle.' + loginid.Account + '.' + loginid.username);
    if (!rows) {
      return selectedIndex;
    }
    if (rows.length !== 0) {
      selectedIndex = 0;
    }
    if (!lastCacheMap) {
      return selectedIndex;
    }
    for (var j = 0; j < rows.length; j++) {
      if (rows[j].deviceid !== undefined && rows[j].deviceid === lastCacheMap.deviceid) {

        if (rows[j].dataindex) {
          return rows[j].dataindex;
        }
        return j;
      }
    }
    //console.log('seelcted row index cache ' + selectedIndex);
    return selectedIndex;
  };

  // bug 89759
  this.getLocalization = function () {
    var translationObj = {
      gotopagestring: $translate.instant('listView.common.localization.gotopagestring'),
      showrowsstring: $translate.instant('listView.common.localization.showrowsstring'),
      rangestring: $translate.instant('listView.common.localization.rangestring'),
      nextbuttonstring: $translate.instant('listView.common.localization.nextbuttonstring'),
      previousbuttonstring: $translate.instant('listView.common.localization.previousbuttonstring'),
      sortascendingstring: $translate.instant('listView.common.localization.sortascendingstring'),
      sortdescendingstring: $translate.instant('listView.common.localization.sortdescendingstring'),
      sortremovestring: $translate.instant('listView.common.localization.sortremovestring'),
      filterselectstring: $translate.instant('listView.common.localization.filterselectstring'),
      filterselectallstring: $translate.instant('listView.common.localization.filterselectallstring'),
      loadtext: $translate.instant('listView.common.localization.loadtext'),
      emptydatastring: $translate.instant('listView.common.localization.emptydatastring'),
      validationstring: $translate.instant('listView.common.localization.validationstring')
    };
    return translationObj;
  };

  this.getGridSettings = function (modelName, customGridProperties, rowIndex, additionalProperties) {
    var currentScope = this;
    var gridName = that.getOverviewGridPrefix() + modelName + 'List';

    var jqxGridList = $window.localStorage['jqxGrid' + that.getOverviewGridPrefix() + modelName + 'List'];

    currentScope.gridSettingId = '';
    currentScope.gridStorage = null;
    currentScope.localStorageRowIndex = 0;
    currentScope.gridSettingId = that.getOverviewGridPrefix() + modelName + 'List';
    currentScope.userSettings = that.getGtsLocalStorageSettings();
    if (jqxGridList !== undefined) {
      currentScope.gridStorage = JSON.parse(jqxGridList);
      currentScope.localStorageRowIndex = currentScope.gridStorage ? currentScope.gridStorage.selectedrowindex : 0;
      currentScope.gridStorage.selectedrowindex = -1; // row select comes t
      currentScope.gridStorage.height = customGridProperties && customGridProperties.height ? customGridProperties.height : currentScope.gridStorage.height;

      if (customGridProperties.columns) {
        for (var i = 0; i < customGridProperties.columns.length; i++) {
          if (!currentScope.gridStorage.columns[customGridProperties.columns[i].datafield]) {
            continue;
          }

          if (currentScope.userSettings && currentScope.userSettings.gridsSetting[currentScope.gridSettingId] && currentScope.userSettings.gridsSetting[currentScope.gridSettingId].frozenColumns) {
            var temp;
            for (var pinnedIndex in currentScope.userSettings.gridsSetting[currentScope.gridSettingId].frozenColumns) {
              temp = currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders[pinnedIndex].name;
              if (customGridProperties.columns[i].datafield === temp) {
                currentScope.gridStorage.columns[customGridProperties.columns[i].datafield].pinned = true;
                break;
              }
              // $('#' + gridName).jqxGrid('pincolumn', temp);
            }
          }

          currentScope.gridStorage.columns[customGridProperties.columns[i].datafield].text = customGridProperties.columns[i].text;
          currentScope.gridStorage.columns[customGridProperties.columns[i].datafield].hidden = customGridProperties.columns[i].hidden;
        }
      }

      if (currentScope.userSettings && currentScope.userSettings.gridsSetting[currentScope.gridSettingId] && currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders) {
        //set column order
        for (var showIndex in currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders) {

          var fieldName = currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders[showIndex].name;
          if (currentScope.gridStorage.columns[fieldName]) {
            currentScope.gridStorage.columns[fieldName].index = parseInt(showIndex);
          }
        }
      }

      //console.log(currentScope);
      $window.localStorage.setItem('jqxGrid' + that.getOverviewGridPrefix() + modelName + 'List', JSON.stringify(currentScope.gridStorage));
    }

    var settings = {
      source: [],
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      width: '100%',
      height: 300,
      columnsheight: 45,
      rowsheight: that.getJqxGridRowHeight(),
      columnsresize: true,
      columnsreorder: true,
      showfilterrow: true,
      filterable: true,
      altrows: true,
      autoheight: false,
      autoloadstate: true,
      autosavestate: true,
      enabletooltips: true,
      pageable: true,
      editable: false,
      pagesizeoptions: ['5', '10', '15', '25'],
      pagesize: 5,
      // bug 89759
      localization: that.getLocalization(),
      ready: function ready() {
        //console.log( gridName + ' Grid ready() start At : '+ moment().format('HH:mm:ss.SSS'));
        if ($('#' + gridName).length !== 0) {
          var rows = $('#' + gridName).jqxGrid('getrows');

          rowIndex = that.getSelectRowIndexByCache(rows);
          if (currentScope.gridStorage) {
            currentScope.gridStorage.selectedrowindex = rowIndex >= 0 ? rowIndex : currentScope.gridStorage.selectedrowindex;
          } else if (rowIndex > 0) {
            currentScope.localStorageRowIndex = rowIndex; // override localstorage index with cached index
          }
          try {
            // non sort grid ( sorted grid do row selection after sort
            if (currentScope.gridStorage && !currentScope.gridStorage.sortcolumn || !currentScope.gridStorage) {
              var rowToSelect = currentScope.gridStorage && currentScope.gridStorage.selectedrowindex !== undefined ? currentScope.gridStorage.selectedrowindex : currentScope.localStorageRowIndex;
              $timeout(function () {
                //  console.log('Reday row select ' + rowToSelect);
                $('#' + gridName).jqxGrid('selectrow', rowToSelect);
                //console.log( gridName + ' ready()->row select  At : '+ moment().format('HH:mm:ss.SSS'));
              }, 0);
            }
          } catch (error) {
            console.log(error);
          }

          var filterinfo = $('#' + gridName).jqxGrid('getfilterinformation');
          if (filterinfo && filterinfo.length === 0 && $('#' + gridName + 'FilterBtn').length !== 0) {
            $('#' + gridName + 'FilterBtn').jqxButton({
              disabled: true
            });
          }

          // Grid listeners
          $('#' + gridName).on('filter', function (event) {
            if (event.args.filters.length > 0) {
              $('#' + gridName + 'FilterBtn').jqxButton({
                disabled: false
              });
            } else {
              $('#' + gridName + 'FilterBtn').jqxButton({
                disabled: true
              });
            }
          });

          if (additionalProperties && additionalProperties.isDynamicGrid) {
            var gridSettingId = additionalProperties.dynamicModuleName + '-' + that.getOverviewGridPrefix() + modelName + 'List';
          }

          $('#' + gridName).on('columnreordered', function (event) {
            var userSettings = that.getUserSettings();
            userSettings = widgetSettingsCreatorService.rebuildDragColumnsOrder(userSettings, gridSettingId, event.args);
            if (userSettings) {
              that.saveUserSettings(userSettings);
            }
          });
        }
        //console.log(gridName +  ' Grid ready() Finished At : '+ moment().format('HH:mm:ss.SSS'));
        // $('#' + gridName).on('bindingcomplete', function () {
        //   //console.log( gridName + ' Binding is completed/ Rendering Start  At :'+ moment(new Date()).format('HH:mm:ss.SSS'));
        // });

        $('#' + gridName).on('sort', function () {
          var selectedRowIndex = that.getSelectRowIndexByCache($('#' + gridName).jqxGrid('getrows'));

          //BUg 108544#c6
          // When grid is sorted and filtered ( selection of row needs some , else the 'selectrow' is not considered.)
          setTimeout(function () {
            $('#' + gridName).jqxGrid('selectrow', selectedRowIndex);
          }, 0);
        });

        // SCL-4719 : Auto resize column for smaller devices which helps better reading of column header and values.
        setTimeout(function () {
          switch (that.getViewPortName()) {
            case 'XS':
            case 'SM':
              $('#' + gridName).jqxGrid('autoresizecolumns');
          }
        }, 0);
      },
      sortable: true,
      columns: []
    };

    if (customGridProperties) {
      settings = _.extend(settings, customGridProperties);
    }
    settings.showtoolbar = true;
    settings.rendertoolbar = function (statusbar) {
      var showfilterrow = settings.showfilterrow;
      showfilterrow = showfilterrow === undefined ? true : showfilterrow;
      var container = $('<div style="overflow: hidden; position: relative; margin: 5px;"></div>');
      var _coloringBtnBtnName = gridName + 'ColouringBtn';
      var addButton = $('<div id="' + _coloringBtnBtnName + '" style="float: left;" title="' + $translate.instant('filter.settings') + '"><span class="glyphicon glyphicon-wrench"></span></div>');
      var _filterBtnName = gridName + 'FilterBtn';
      var showFilterRowButton = $('<div style="float: left; margin-left:5px;" id="' + _filterBtnName + '" title="' + $translate.instant('filter.clearFilter') + '"><span class="glyphicon glyphicon-filter glyphicon-remove-circle" ></span></div>');
      var _resizeBtnName = gridName + 'ResizeBtn';
      var showResizeRowButton = $('<div style="float: left; margin-left:5px;" id="' + _resizeBtnName + '" title="' + $translate.instant('filter.resize') + '"><span class="glyphicon glyphicon-resize-horizontal" ></span></div>');

      container.append(addButton);
      if (showfilterrow) {
        container.append(showFilterRowButton);
        container.append(showResizeRowButton);
        showFilterRowButton.jqxButton({});
        showResizeRowButton.jqxButton({});
      }
      statusbar.append(container);
      addButton.jqxButton({});
      $('#' + _coloringBtnBtnName).unbind('click');
      $('#' + _coloringBtnBtnName).bind('click', function () {
        var modelName = additionalProperties && additionalProperties.isDynamicGrid ? additionalProperties.dynamicModuleName : modelName;
        widgetSettingsCreatorService.openGridSettingDialog(modelName, gridName, that, {
          columns: settings.columns,
          additionalCustomProperties: additionalProperties || {}
        });
      });

      if (gridName) {
        showFilterRowButton.click(function () {
          $('#' + gridName).jqxGrid('clearfilters');
          $(this).jqxButton({
            disabled: true
          });
          $(this).removeClass('jqx-fill-state-hover');
        });
        showResizeRowButton.click(function () {
          $('#' + gridName).jqxGrid('autoresizecolumns');
        });
      }
    };
    //console.log( gridName +' Settings created At : '+ moment().format('HH:mm:ss.SSS'));
    return settings;
  };

  this.createColumn = function (columnProperty, transalationMap, comboBoxAdaptor, gridTransalationModuleName) {
    var headerName = columnProperty.name;
    var obj = {};
    if (Object.keys(transalationMap).length === 0 && transalationMap) {
      obj.text = $translate.instant('listView.' + gridTransalationModuleName.moduleName + '.headers.' + headerName);
    } else {
      obj.text = transalationMap !== undefined && transalationMap[columnProperty.name] !== undefined ? transalationMap[columnProperty.name] : columnProperty.name;
    }

    //default styling

    if (!columnProperty.isCheckBox && !columnProperty.isProgressBar) {
      obj.cellsrenderer = function (index, datafield, value) {
        return '<span class="dataCell">' + value + '</span>';
      };
    }

    if (columnProperty.type === 'STRING') {
      obj.type = 'string';
    } else if (columnProperty.type === 'INT') {
      obj.type = 'number';
    } else if (columnProperty.type === 'TIMESTAMP') {
      obj.cellsrenderer = function (index, datafield, value) {
        if (!isNaN(value)) {
          return '<span class="dataCell">' + $filter('date')(new Date(value * 1000), 'dd/MM/yyyy HH:mm:ss') + '</span>';
        }
        return '<div>' + value + '</div>';
      };
      obj.cellsalign = 'right';
      obj.type = 'datetime';
    } else if (columnProperty.type === 'DATE') {
      obj.type = 'date';
      obj.cellsrenderer = function (index, datafield, value) {
        if (!value.match(/^\d{2}[./.]\d{2}[./.]\d{4}$/)) {
          // check if the value in the format of dd.MM.YYYY or dd/MM/YYYY
          return '<span class="dataCell">' + $filter('date')(value, 'dd/MM/yyyy') + '</span>';
        }
        return '<div>' + value + '</div>'; // already a date value with dd.MM.YYYY
      };
    } else if (columnProperty.type === 'FLOAT') {
      obj.type = 'float';
      obj.cellsrenderer = function (index, datafield, value) {
        var LocaleIdentification = 1.01;
        var displayValue;
        if (columnProperty.floatingDecimalPoint) {
          displayValue = value.toFixed(Number(columnProperty.floatingDecimalPoint));
        } else {
          displayValue = value;
        }
        if (LocaleIdentification.toLocaleString().indexOf('.') > -1) {
          return '<span class="dataCell">' + displayValue + '</span>';
        } else {
          return '<span class="dataCell">' + displayValue.toString().replace('.', ',') + '</span>';
        }
      };
    } else if (columnProperty.type === 'BUTTON') {
      obj.cellsrenderer = function () {

        return '<div  style="margin: 4px; float: left;" ><input type="button" onClick="buttonclick(event)" class="gridButton btn-info" id="btn"  value="' + columnProperty.name + '"/></div>';
      };
    }

    if (columnProperty.isProgressBar) {
      //obj.columntype = 'progressbar';
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        if (value < 0) {
          return '<progress class="jqx-progress-negative" max="' + Math.abs(rowdata.drumrotationmax) + '" value="' + Math.abs(value) + '"></progress>';
        } else {
          return '<progress class="jqx-progress-positive" max="' + Math.abs(rowdata.drumrotationmax) + '" value="' + Math.abs(value) + '"></progress>';
        }
      };
    }
    if (columnProperty.isComboBox) {
      obj.displayfield = obj.text;
      obj.columntype = 'combobox';
      obj.createeditor = function (row, column, editor) {
        editor.jqxComboBox({
          source: comboBoxAdaptor,
          autoDropDownHeight: false,
          displayMember: comboBoxAdaptor._source.datafields[0].name,
          valueMember: comboBoxAdaptor._source.datafields[1].name
        });
      };
    }
    if (columnProperty.isHidden) {
      obj.hidden = 'true';
    }

    if (columnProperty.hasBgColor && columnProperty.hasColor) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        //return defaultvalue.split('">')[0] + 'color:' + rowdata[columnProperty.name + 'Color'] + ';background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';" class="dataCell" >' + value + '</div>';
        return '<div class="dataCell" style="color:' + rowdata[columnProperty.name + 'Color'] + '; background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';">' + value + '</div>';
      };
    } else if (columnProperty.hasColor) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        return '<div class="dataCell" style="color:' + rowdata[columnProperty.name + 'Color'] + ';">' + value + '</div>';
      };
    } else if (columnProperty.hasBgColor) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        //console.log(defaultvalue);
        return '<div class="dataCell" style="background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';">' + value + '</div>';
      };
    } else if (columnProperty.hasFontStyle) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        //console.log(defaultvalue);
        return '<div class="dataCell" style="font-style:' + rowdata[columnProperty.name + 'FontStyle'] + ';">' + value + '</div>';
      };
    }
    // Icon Logic
    if (columnProperty.hasIcon && columnProperty.hasIcon === true) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        var style = 'height: 100%;';
        var icon = rowdata[columnProperty.name + 'Icon'];
        // display type options ['icon_only','both','none' (no icon)]
        var displayType = rowdata[columnProperty.name + 'IconDisplayType'];
        var tempValue = value; // Didnt want to ovewrite value
        var additionClasses = '';

        if (icon === 'NONE') {
          return;
        }

        if (!icon) {
          additionClasses = 'dataCell';
        } else {
          additionClasses += ' dataIconCell';
        }
        if (displayType === 'ICON_ONLY') {
          // Icon only - remove tempvalue
          // TODO: look at the possibility of using hover to display value
          tempValue = '';
          additionClasses += ' text-center';
        }

        if (displayType === 'ICON_ONLY' || displayType === 'BOTH' || displayType === 'COMBINATION') {
          // include icon tag
          var iconHtml = '';
          var iconBackground = '';
          if (icon.indexOf(',') > -1 || columnProperty.isMultiIconColumn === true) {
            additionClasses += ' dataIconCell';
            var iconList = icon.split(',');

            for (var j = 0; j < iconList.length; j++) {

              iconBackground = '';
              if (iconList[j] !== '' && iconList[j] !== ' ') {
                iconBackground = ' dsa-icon-background';
              }

              iconHtml += '<div class="multi-icon-dsa ' + iconList[j] + iconBackground + '"> </div>';
            }
          } else {
            // iconHtml += '<i class="' + icon + '"></i> &nbsp';
            if (icon !== '' && icon !== ' ') {
              iconBackground = ' dsa-icon-background';
            }

            iconHtml += '<div class="multi-icon-dsa ' + icon + iconBackground + '"> </div>';
          }

          if (displayType === 'COMBINATION') {
            tempValue = iconHtml;
          } else {
            tempValue = iconHtml + ' &nbsp' + tempValue;
          }
        }

        if (columnProperty.hasBgColor) {
          style += 'background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';';
        }

        if (columnProperty.hasColor) {
          style += 'color:' + rowdata[columnProperty.name + 'Color'] + '';
        }

        if (columnProperty.hasFontStyle) {
          style += ';font-style:' + rowdata[columnProperty.name + 'FontStyle'] + '';
        }

        if (displayType === 'COMBINATION') {
          //style the divs
          var newDefault = $(defaultvalue);
          newDefault[0].classList = newDefault[0].classList + ' text-with-icon-textdiv';
          var newTemp = $(tempValue);
          newTemp[0].classList = newTemp[0].classList + ' text-with-icon-icondiv';
          return newDefault[0].outerHTML.concat(newTemp[0].outerHTML);
        } else {
          return '<div class="' + additionClasses + '" style="' + style + '">' + tempValue + '</div>';
        }
      };
    }
    if (columnProperty.isFormattableTelephoneField) {
      obj.cellsrenderer = function (row, column, value, defaultHtml) {
        if (value && defaultHtml) {
          return '<input class="telephnoe-overview-btn"  value = "' + value + '" > </input > ';
        }
      };
    }

    obj.datafield = headerName;
    obj.width = columnProperty.width;

    if (columnProperty.isCheckBox) {
      obj.columntype = 'checkbox';
      obj.type = 'bool';
    }

    if (columnProperty.isProgressBar) {
      //obj.columntype = 'progressbar';
      obj.type = 'number';
    }

    if (columnProperty.isReadOnly) {
      obj.editable = false;
    }

    // SCL-1340
    if (columnProperty.customFilterCheckBoxList) {
      obj.filtertype = 'checkedlist';
      obj.filteritems = columnProperty.customCheckBoxFilterOptions;
      for (var fi = 0; fi < obj.filteritems.length; fi++) {
        obj.filteritems[fi].value = $translate.instant('listView.' + gridTransalationModuleName.moduleName + '.headerColumnfilters.' + headerName + '.' + obj.filteritems[fi].value);
        obj.filteritems[fi].text = obj.filteritems[fi].value;
      }

      // loop through items and provide teansalations
      //$translate.instant('listView.' + gridTransalationModuleName.moduleName + '.$translate.instant('listView.' + gridTransalationModuleName.moduleName + '.headers.filters.' + headerName+".loppedfiltervalue").' + headerName)
      obj.createfilterwidget = function (column, columnElement, widget) {
        if (!widget.hasClass(gridSettingId + '-' + headerName + '-custom-filter')) {
          widget.jqxDropDownList({
            displayMember: 'value', valueMember: 'text',
            dropDownHeight: 500, dropDownWidth: '450px'
          });
          widget.on('close', function () {

            if ($('#wrapper' + gridSettingId + ' .jqx-grid-load').is(':visible')) {
              return;
            }
            if (this._selectionChanged) {
              var checkedItems = widget.jqxDropDownList('getCheckedItems');

              setTimeout(function () {
                var filtergroup = new $.jqx.filter();
                var checkedIndexed = [];
                var gridName = '#' + gridSettingId;
                for (var i = 0; i < checkedItems.length; i++) {
                  // add checked values to the filter
                  // note: first one could be a select all option and filter will be added to check for that,
                  // but this wont filter any of the results
                  var filtervalue = checkedItems[i].value; // test
                  var filtercondition = 'contains';
                  var filter1 = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
                  filtergroup.addfilter(1, filter1);
                  checkedIndexed.push(checkedItems[i].index);
                }
                // add the filters.
                $(gridName).jqxGrid('addfilter', headerName, filtergroup);
                // apply the filters.
                // check again since 'addfilter' removes the filter by default
                setTimeout(function () {
                  for (var i = 0; i < checkedIndexed.length; i++) {
                    widget.jqxDropDownList('checkIndex', checkedIndexed[i]);
                  }
                }, 100);
                $(gridName).jqxGrid('applyfilters');
                //console.log('Custom filters applied');
              }, 0);
            }
          });

          // bug 90013
          setTimeout(function () {
            widget.jqxDropDownList('uncheckAll');
            var listitems = widget.jqxDropDownList('getItems');
            var filterInfo = $('#' + gridSettingId).jqxGrid('getfilterinformation');
            for (var j = 0; j < filterInfo.length; j++) {
              var filter = filterInfo[j];
              // grid has filters for that specific column
              if (filter.datafield === headerName) {
                var filterObjs = filter.filter.getfilters();
                // filter values being applied
                for (var q = 0; q < filterObjs.length; q++) {
                  // iterate through dropdown list to select filters again
                  for (var x = 0; x < listitems.length; x++) {
                    if (listitems[x].value === filterObjs[q].value) {
                      widget.jqxDropDownList('checkIndex', x);
                      break;
                    }
                  }
                }
              }
            }
          }, 0);
        }
      };
    }

    if (!columnProperty.isCheckBox) {
      obj.renderer = function (text) {
        return '<div style=" padding:4px; ">' + text.replace(/\\n/gm, '<br>') + '</div>';
      };
    }

    if (columnProperty.columnGroup) {
      obj.columngroup = columnProperty.columnGroup;
    }

    if (columnProperty.isSummaryCheck) {
      _summaryCheckColumn.push(columnProperty.name);
    }
    obj.cellclassname = this.cellClassName;

    var gridSettingId = that.getGridId(gridTransalationModuleName);

    // do viewport related column width setting / disabling if not defined
    switch (that.getViewPortName()) {
      case 'XS':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthXS', gridSettingId);
        break;
      case 'SM':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthSM', gridSettingId);
        break;
      case 'MD':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthMD', gridSettingId);
        break;
      case 'LG':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthLG', gridSettingId);
        break;
    }

    var userSettings = that.getGtsLocalStorageSettings();
    return widgetSettingsCreatorService.applyGridSettingToGrid(gridSettingId, userSettings, obj, headerName);
  };

  this.getGridId = function (gridTransalationModuleName) {
    var gridSettingId = gridTransalationModuleName && gridTransalationModuleName.moduleName ? gridTransalationModuleName.moduleName : '';
    gridSettingId = that.getOverviewGridPrefix() + gridSettingId + 'List';

    if (gridTransalationModuleName && gridTransalationModuleName.reportModel) {
      //report grid
      gridSettingId = gridTransalationModuleName.moduleName + '-' + that.getOverviewGridPrefix() + gridTransalationModuleName.reportModel + 'List';
    } else {
      gridSettingId = gridTransalationModuleName && gridTransalationModuleName.moduleName ? gridTransalationModuleName.moduleName : '';
      gridSettingId = that.getOverviewGridPrefix() + gridSettingId + 'List';
    }
    return gridSettingId;
  };
  /**
   *
   * Used in the co ntext of createColumn() , to set width of specified view port or else if  width is empty make that column hidden.
   *
   * @param viewporWidth  - object which contains the view port Width values ( widthMD , widthLG .. etc )
   * @param columnOBJ -  column obj  which is filed in the createColumn()
   * @param viewPortWidthKey -  with key to get value from viewporWidth object .
   * @returns {columnOBJ}
   * @private
   */
  function _setViewPortWidth(viewporWidth, columnOBJ, viewPortWidthKey, gridSettingId) {
    var jqxGridList = $window.localStorage['jqxGrid' + gridSettingId];
    var gridStorage;

    if (viewporWidth && viewporWidth[viewPortWidthKey] !== null && viewporWidth[viewPortWidthKey] !== undefined) {
      // viewporWidth[viewPortWidthKey]  can be '' so if condition may fail NULL && undefined check is necessary
      if (jqxGridList) {
        gridStorage = JSON.parse(jqxGridList);
      }

      if (viewporWidth[viewPortWidthKey] !== '') {
        columnOBJ.width = viewporWidth[viewPortWidthKey];
        if (gridStorage) {
          // not already hidden by settings widget
          if (gridStorage.columns[columnOBJ.datafield] && gridStorage.columns[columnOBJ.datafield].hidden !== true) {
            gridStorage.columns[columnOBJ.datafield].hidden = false;
          }
        }
      } else {
        columnOBJ.hidden = 'true';
        if (gridStorage) {
          gridStorage.columns[columnOBJ.datafield].hidden = true;
        }
      }
      if (gridStorage) {
        $window.localStorage.setItem('jqxGrid' + gridSettingId, JSON.stringify(gridStorage));
      }
    }
    return columnOBJ;
  }

  this.cellClassName = function (row, column, value, data) {
    var result = false;
    for (var i = 0; i < _summaryCheckColumn.length; i++) {
      result = result || data[_summaryCheckColumn[i]];
      if (result) {
        break;
      }
    }
    if (!result && _summaryCheckColumn.length > 0) {
      return 'gridsummaryclass';
    }
  };

  this.createColumnGroups = function (groupList, gridName) {
    var _tmpArry = [];
    for (var i = 0; i < groupList.length; i++) {
      _tmpArry[i] = this.getColumnGroup(groupList[i], gridName);
    }
    return _tmpArry;
  };

  this.getColumnGroup = function (groupProperty, gridName) {
    var _tmpObj = {};
    _tmpObj.text = $translate.instant('listView.' + gridName + '.headers.' + groupProperty);
    _tmpObj.name = groupProperty;
    _tmpObj.align = 'center';
    return _tmpObj;
  };
  this.rebuildDataSource = function (columnPropertiesList, translationMap, dataSource) {
    for (var i = 0; i < columnPropertiesList.length; i++) {
      var columnProperty = columnPropertiesList[i];
      if (columnProperty.hasMultiValued) {
        var multiValueName = columnProperty.name;
        var multiValueStr = translationMap[multiValueName];
        var multiValueStrArray = multiValueStr.split(';');
        for (var j = 0; j < dataSource.length; j++) {
          var item = dataSource[j];
          var multiValueList = item[multiValueName];

          for (var k = 0; k < multiValueList.length; k++) {
            item[multiValueStrArray[k]] = multiValueList[k];
          }
        }
      }
    }
  };

  var parseMultiValueColumnProperty = function parseMultiValueColumnProperty(columnPropertiesList, transalationMap, multiValueTranslationMap, multiValueColumnPropertiesList) {
    var multiValuedList = [];
    for (var j = 0; j < columnPropertiesList.length; j++) {
      var columnProperty = columnPropertiesList[j];
      if (columnProperty.hasMultiValued) {
        columnProperty.isHidden = true;
        multiValuedList.push(columnProperty);
      }
    }
    for (var m = 0; m < multiValuedList.length; m++) {
      var multiValueColumnProperty = multiValuedList[m];
      var multiValueStr = transalationMap[multiValueColumnProperty.name];
      if (multiValueStr) {
        var multiValueStrArray = multiValueStr.split(';');
        for (var n = 0; n < multiValueStrArray.length; n++) {
          var multiValue = multiValueStrArray[n];
          var multiValueColumnPropertyCopy = _.assign({}, multiValueColumnProperty);
          multiValueColumnPropertyCopy.name = multiValue;
          multiValueColumnPropertyCopy.isHidden = false;
          multiValueColumnPropertiesList.push(multiValueColumnPropertyCopy);
          multiValueTranslationMap[multiValue] = multiValue;
        }
      }
    }
  };

  this.getColumnProperties = function (columnPropertiesList, transalationMap, gridTransalationModuleName) {
    var multiValueTranslationMap = {};
    var multiValueColumnPropertiesList = [];
    parseMultiValueColumnProperty(columnPropertiesList, transalationMap, multiValueTranslationMap, multiValueColumnPropertiesList);
    var newColumnPropertiesList = columnPropertiesList.concat(multiValueColumnPropertiesList);
    var newTranslationMap = _.assign(transalationMap, multiValueTranslationMap);
    var column = [];
    _summaryCheckColumn = []; // clear, rebuild the check in below loop
    //var portName = that.getViewPortName();

    //var gridLocalStroage = $window.localStorage['jqxGrid' + that.getGridId (gridTransalationModuleName)];
    for (var k = 0; k < newColumnPropertiesList.length; k++) {
      column[k] = this.createColumn(newColumnPropertiesList[k], newTranslationMap, undefined, gridTransalationModuleName);

      // if(columnPropertiesList[k].isCheckBox){
      //   var checkBoxDataFields = {
      //     name: $scope['columns' + column[k]].datafield,
      //     type: 'bool'
      // };
      // }
      /* switch (portName) {
        case 'XS':
        case 'SM':
          if (k >= 14 &&  !gridLocalStroage) {
            column[k].hidden = true;
          }
      }*/
    }
    return _.sortBy(column, 'index');
  };

  var baseUrl = serverBaseUrl + '/';
  this.getOverviewListSettings = function (modelName) {
    var dataLoader = {
      load: function load() {
        return $http({ url: baseUrl + 'viewsettings/' + modelName + '/overviewsetting', method: 'GET' });
      }
    };
    return dataContainerService.getData(modelName + 'OverviewListSettings', dataLoader, false);
  };

  /**
   *  this method will update the grid data using JQX bound data and call the sort method on JQX to keep the sorting after data refresh.
   *  while calling update bound data call sort , update bound data will remove the filter and sorting .
   * @param gridName
   */
  this.updateBoundData = function (gridName) {
    if ($('#' + gridName).length !== 0) {
      $('#' + gridName).jqxGrid('updatebounddata', 'data');
      var sortinformation = $('#' + gridName).jqxGrid('getsortinformation');
      if (sortinformation && sortinformation.sortcolumn && sortinformation.sortdirection) {
        // need to send sort manually because JQX does not consider sort if data source changes.( auto refresh)
        if (sortinformation.sortdirection.ascending) {
          $('#' + gridName).jqxGrid('sortby', sortinformation.sortcolumn, 'ascending');
        }

        if (sortinformation.sortdirection.descending) {
          $('#' + gridName).jqxGrid('sortby', sortinformation.sortcolumn, 'descending');
        }
      }
    }
  };
  /**
   * common Method for initiating right click menu window.
   * @param event
   * @param contextMenu
   */
  this.initGridRightClickContextMenu = function (event, contextMenu) {
    if (event && contextMenu) {
      var scrollTop = $(window).scrollTop();
      var scrollLeft = $(window).scrollLeft();
      $('#' + event.currentTarget.id).jqxGrid('selectrow', event.args.rowindex);
      contextMenu.jqxMenu('open', parseInt(event.args.originalEvent.clientX) + 5 + scrollLeft, parseInt(event.args.originalEvent.clientY) + 5 + scrollTop);
    }
  };
  /**
   * common Method for executing a function for the context option .
   * @param event
   * @param ctxSourceName
   * @param contextSourceObj
   */
  this.executeContextMenuClick = function (event, ctxSourceName, contextSourceObj) {
    var contextMenuSource = contextSourceObj[ctxSourceName];
    for (var i = 0; i < contextMenuSource.length; i++) {
      if (contextMenuSource[i].label === event.args.innerText) {
        contextMenuSource[i].execute(contextMenuSource[i].reportName);
      }
    }
  };
  this.formatReportDateTime = function (_date, _time, formatType) {
    var splitedTime = _time.split(':');
    if (_date.indexOf('T') !== -1) {
      return $filter('date')(new Date(_date), 'yyyy/MM/dd/') + splitedTime[0] + ':' + splitedTime[1] + ':' + splitedTime[2];
    }

    var splitedDate = _date.split('/');
    splitedTime[2] = splitedTime[2] ? splitedTime[2] : '00';
    if (formatType) {
      return splitedDate[2] + formatType + splitedDate[1] + formatType + splitedDate[0] + 'T' + splitedTime[0] + ':' + splitedTime[1] + ':' + splitedTime[2];
    }
    return splitedDate[2] + '/' + splitedDate[1] + '/' + splitedDate[0] + '/' + splitedTime[0] + ':' + splitedTime[1] + ':' + splitedTime[2];
  };

  this.getExportURL = function (reportName, exportOption, type, selectedID, reportOption, dateFrom, dateTo, emailList, reportSettings) {
    var baseurl = '';
    var additionalReportOptions = {
      _reportOptionFor: '',
      _reportOtptionSqlType: '',
      _reportOptions: ''
    };

    var isMutioptionReportFound = false;
    if (reportSettings) {
      for (var i in reportSettings) {
        if (reportSettings[i]._reportName === reportName) {
          if (reportSettings[i]._isReportOptionMultiSelect) {
            isMutioptionReportFound = true;
            additionalReportOptions._reportOptionFor = reportSettings[i]._multiSelectPropertyName;
            var multiSelectedComboboxOption = [];
            if (reportName === 'DriverWorkingHours') {
              multiSelectedComboboxOption = $('#' + reportSettings[i]._comboID).jqxComboBox('getCheckedItems');
              if (multiSelectedComboboxOption.length > 0 && multiSelectedComboboxOption[0].value === 'selectAll') {
                multiSelectedComboboxOption.shift();
              }
            } else {
              multiSelectedComboboxOption = $('#' + reportSettings[i]._comboID).jqxComboBox('getSelectedItems');
            }

            var optionsArray = [];
            for (var j in multiSelectedComboboxOption) {
              optionsArray.push(multiSelectedComboboxOption[j].value);
            }
            if (multiSelectedComboboxOption.length > 1) {
              additionalReportOptions._reportOtptionSqlType = 'in';
            } else {
              additionalReportOptions._reportOtptionSqlType = 'where';
            }
            additionalReportOptions._reportOptions = optionsArray;
            //console.log(additionalReportOptions);
          }
          break;
        }
      }
    }

    switch (exportOption) {
      case 'CSV':
        baseurl += '&page=report.show&page_cmd=rptsel&' + type + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&' + 'date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&r_format=csv' + '&locale=' + languageService.getLanguageSettings().language;
        break;
      case 'XLS':
        // bug 88893 - added locale param to xls reports
        baseurl += '&page=report.show&page_cmd=rptsel&' + type + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&' + 'date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&r_format=xls' + '&locale=' + languageService.getLanguageSettings().language;
        break;
      case 'EMail':
        baseurl += '&page=report.show&page_cmd=rptsel&' + type + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&' + 'date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&r_format=ehtml&r_emailAddr=' + emailList + '&locale=' + languageService.getLanguageSettings().language;
        break;
    }
    if (isMutioptionReportFound) {
      baseurl += '&_reportOptionFor=' + additionalReportOptions._reportOptionFor + '&_reportOtptionSqlType=' + additionalReportOptions._reportOtptionSqlType + '&_reportOptions=' + additionalReportOptions._reportOptions;
    }
    return baseurl;
  };

  this.getReportMap = function (baseurl, reportName, type, selectedID, reportOption, dateFrom, dateTo) {
    return baseurl + mainUrlDetails + '&page=report.show&page_cmd=rptsel&' + type.toLoawerCaseAt(0) + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&fmt=map&required_session=false&geoZoneAccount=true';
  };

  this.getVehicleListFilterByGroupId = function (groupId) {
    return crudService.get('overview/vehiclelist', groupId).then(function (vehicleList) {

      return vehicleList.sort(function (a, b) {
        return _sortCompare(a.description, b.description, true);
      });
    });
  };

  this.setLastLocatioWidgetData = function (latstLocationSelection) {
    _lastLocationWidgetData = latstLocationSelection;
  };
  this.getDriverDashboardLastSelectedRowData = function () {
    return _driverDashboardWidgetData;
  };
  this.setDriverDashboardLastSelectedRowData = function (rowData) {
    _driverDashboardWidgetData = rowData;
  };
  this.getsetLastLocatioWidgetData = function () {
    return _lastLocationWidgetData;
  };

  this.getLastSelectedGroup = function () {
    return _lastSelectedGroup;
  };

  this.setLastSelectedGroup = function (group) {
    _lastSelectedGroup = group;
  };

  this.init = function () {
    $http.defaults.headers.common['X-BetoTrack-Locale'] = languageService.getLanguageSettings().language;
  };

  this.getFleetSettings = function () {
    var fleetSettings = {
      messageUpdatedTime: '',
      msgTimeStamp: [],
      readMessages: [],
      readNotification: []
    };
    var fleetSettingsInStore = localStorageService.get('fleetSettings.' + loginID.Account + '.' + loginID.username);
    if (fleetSettingsInStore !== null) {
      return fleetSettingsInStore;
    }
    return fleetSettings;
  };

  this.setMessageLocalStorgaeProp = function (mesageUpdatedTime, messageTimestampList) {
    var fleetSettingsInStore = this.getFleetSettings();
    fleetSettingsInStore.messageUpdatedTime = mesageUpdatedTime;
    fleetSettingsInStore.msgTimeStamp = messageTimestampList;
    this.saveFleetSettings(fleetSettingsInStore);
  };
  this.setReadMessagesToLocalStorage = function (readMessagesList) {
    var fleetSettingsInStore = this.getFleetSettings();
    fleetSettingsInStore.readMessages = readMessagesList;
    this.saveFleetSettings(fleetSettingsInStore);
  };
  this.setReadNotification = function (notificaionTimeStamp) {
    var fleetSettingsInStore = this.getFleetSettings();
    fleetSettingsInStore.readNotification.push(notificaionTimeStamp);
    fleetSettingsInStore.readNotification = removeNotificationOlderThanCrrentDay(fleetSettingsInStore.readNotification);
    this.saveFleetSettings(fleetSettingsInStore);
  };
  this.getReadMessageFromLocalStorage = function () {
    var fleetSettingsInStore = this.getFleetSettings();
    return fleetSettingsInStore.readMessages || [];
  };
  this.saveFleetSettings = function (newFleetSettings) {
    newFleetSettings.msgTimeStamp = removeOlderThan3ayTimestamps(newFleetSettings.msgTimeStamp);
    newFleetSettings.readMessages = removeOlderThan3ayTimestamps(newFleetSettings.readMessages);
    localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username, newFleetSettings);
  };

  function removeOlderThan3ayTimestamps(timeStampArray) {
    return _removeOlderTimeStampValues(timeStampArray, 3);
  }

  function removeNotificationOlderThanCrrentDay(readNotificationTimeStampArray) {
    return _removeOlderTimeStampValues(readNotificationTimeStampArray, 1);
  }

  function _removeOlderTimeStampValues(timeStampArray, noOfDays) {
    var _tmpTimeStampArry = [];
    if (timeStampArray && timeStampArray.length > 0) {
      for (var i = 0; i < timeStampArray.length; i++) {
        var _tmpTstampDate = new Date(Number(timeStampArray[i]) * 1000);
        var _tmpCompareDate = new Date();
        _tmpCompareDate.setDate(_tmpCompareDate.getDate() - noOfDays);
        if (_tmpTstampDate >= _tmpCompareDate) {
          _tmpTimeStampArry.push(timeStampArray[i]);
        }
      }
    }
    return _tmpTimeStampArry;
  }

  this.getNotifications = function () {
    return notificationProperties;
  };

  this.saveDriverMessage = function (deviceID, message, messageTypdescription, isGroup) {
    var _msgType = getMessageTypeNumber(messageTypdescription);
    var deviceMessage = {
      deviceID: deviceID,
      message: message,
      messageType: _msgType
    };

    var url = '/messaging?isGroupMessage=' + (isGroup ? 'true' : 'false');
    return crudService.post(url, deviceMessage);
  };

  this.getDriverMessages = function (exsistingList, chatDeriveId) {
    var _tmpfrmDate = new Date();
    _tmpfrmDate.setDate(_tmpfrmDate.getDate() - 3);
    var fleetLocalStorageSettings = this.getFleetSettings();
    var timeFrom = fleetLocalStorageSettings.messageUpdatedTime ? $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00' : $filter('date')(_tmpfrmDate, 'yyyy/MM/dd/') + '00:00:00';
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');
    var requestParam = {
      statusCode: '',
      deviceid: chatDeriveId,
      dataRefresh: false,
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'DriverMessageDetail'
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('messaging', 'devicemessages', param).then(function (messageList) {
      return _filterMessage(messageList, exsistingList);
    }, function (response) {
      errorHandlingService.handleForCommonResponse(response);
    });
  };

  this.getGroupMessages = function (existingGroupMessages, chatGroupId) {
    var _tmpfrmDate = new Date();
    _tmpfrmDate.setDate(_tmpfrmDate.getDate() - 3);
    var fleetLocalStorageSettings = this.getFleetSettings();
    var timeFrom = fleetLocalStorageSettings.messageUpdatedTime ? $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00' : $filter('date')(_tmpfrmDate, 'yyyy/MM/dd/') + '00:00:00';
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');

    var requestParam = {
      statusCode: '',
      groupId: chatGroupId,
      dataRefresh: false,
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'GroupMessageDetail'
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return crudService.customGET('messaging', 'groupmessages/' + chatGroupId, param).then(function (response) {
      if (response && response.groupConversations) {
        return response;
      } else if (response && Array.isArray(response)) {
        return { groupConversations: response };
      } else {
        console.log('Group messages response:', response);
        return { groupConversations: [] };
      }
    }, function (response) {
      console.error('Error fetching group messages:', response);
      errorHandlingService.handleForCommonResponse(response);
      return { groupConversations: [] };
    });
  };

  // This api should be used under Instant messaging
  this.getInstantDriverMessages = function (exsistingList, exsitingNotificationList, mqMessage, isFromMq) {
    var fleetLocalStorageSettings = this.getFleetSettings();
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');

    var _filteredData = _filterMessgae(mqMessage, fleetLocalStorageSettings, timeTo, exsistingList, exsitingNotificationList, isFromMq);
    var _filteredGroupData = _filterGroupMessage(mqMessage, exsitingNotificationList);
    var deferred = $q.defer();
    deferred.resolve(_filteredData);
    deferred.resolve(_filteredGroupData);
    return deferred.promise;
  };

  function _filterMessage(messageList, exsistingList) {
    //Check which messages are unread
    var messages = messageList.driverDevices;
    var isAckMessage = false;
    var mesgUnreadCount = 0;

    if (exsistingList !== undefined) {
      for (var i = 0; i < messages.length; i++) {
        // check if exsiting  list already contains this new message
        var _isExsistingListAlreadyContainsMsg = false;
        for (var l = 0; l < exsistingList.length; l++) {
          if (exsistingList[l].deviceID === messages[i].deviceID && exsistingList[l].lastMessageTimeStamp === messages[i].lastMessageTimeStamp) {
            _isExsistingListAlreadyContainsMsg = true;
            break;
          }
        }
        if (!_isExsistingListAlreadyContainsMsg) {
          isAckMessage = messages[i].lastMessage.beginsWith('{');
          if (!isAckMessage) {
            mesgUnreadCount++;
          }
        }
      }
    }
    //Bugfix 104164: Ensure New Message notification does not always popup on refresh
    //This is the total unread messages since the last page refresh / data refresh
    //Not the same as the total unread messages received from fleetapi backend
    messageList.unreadMessages = mesgUnreadCount;
    return messageList;
  }

  function _filterGroupMessage(messageList, existingGroupList) {
    var groups = messageList.driverDevices || [];
    var msgUnreadCount = 0;
    if (existingGroupList !== undefined && existingGroupList.length > 0) {
      for (var i = 0; i < groups.length; i++) {
        var groupFound = false;
        for (var j = 0; j < existingGroupList.length; j++) {
          if (existingGroupList[j].groupId === groups[i].deviceID) {
            groupFound = true;
            existingGroupList[j].unreadCount = groups[i].unreadMessageCount || 0;
            if (groups[i].messages && groups[i].messages.length > 0) {
              existingGroupList[j].latestMessagePreview = groups[i].messages[0].drivermessage || '';
            }
            break;
          }
        }
        if (!groupFound && groups[i].unreadMessageCount > 0) {
          msgUnreadCount += groups[i].unreadMessageCount;
        }
      }
    } else {
      for (var k = 0; k < groups.length; k++) {
        if (groups[k].unreadMessageCount > 0) {
          msgUnreadCount += groups[k].unreadMessageCount;
        }
      }
    }
    messageList.unreadMessages = msgUnreadCount;
    messageList.totalUnreadMessages = msgUnreadCount;
    return messageList;
  }

  function _filterMessgae(messageList, fleetLocalStorageSettings, timeTo, exsistingList, exsitingNotificationList, isFromMq) {
    var messages = messageList ? messageList.reverse() : messageList;
    var driverMessageList = [];
    var messageTimeStampArray = fleetLocalStorageSettings.msgTimeStamp;
    var _tmpMessageTimeStampArry = [];
    var _tmpFlag = false;
    var isAckMessage = false;
    var mesgUnreadCount = 0;
    for (var i = 0; i < messages.length; i++) {
      messages[i].statuscode = messages[i].statuscode === 57777 ? '0xE1B1' : messages[i].statuscode;
      if (messages[i].statuscode === '0xE1B1') {
        if (messageTimeStampArray.length > 0 && !isFromMq) {
          for (var j = 0; j < messageTimeStampArray.length; j++) {
            if (messageTimeStampArray[j] === messages[i].messagetimestamp) {
              _tmpFlag = true;
            }
          }
        }
        var readLocalStorageMessages = that.getReadMessageFromLocalStorage();
        var isRead = false;
        for (var k = 0; k < readLocalStorageMessages.length; k++) {
          if (messages[i].messagetimestamp === readLocalStorageMessages[k]) {
            isRead = true;
            break;
          }
        }

        if (!_tmpFlag && !isRead || _tmpFlag && !isRead) {
          messages[i]._dateTimeDescription = ' ' + $filter('date')(new Date(Number(messages[i].messagetimestamp) * 1000), 'dd.MM.yy HH:mm');
          messages[i]._timeShortDes = ' ' + $filter('date')(new Date(Number(messages[i].messagetimestamp) * 1000), 'EEE  HH:mm');
          messages[i]._isMsgRead = isRead;
          // check if exsiting  list already contains this new message
          var _isExsistingListAlreadyContainsMsg = false;
          for (var l = 0; l < exsistingList.length; l++) {
            if (exsistingList[l].messagetimestamp === messages[i].messagetimestamp) {
              _isExsistingListAlreadyContainsMsg = true;
              break;
            }
          }
          if (!_isExsistingListAlreadyContainsMsg) {
            isAckMessage = messages[i].drivermessage.beginsWith('{');
            if (!isAckMessage) {
              mesgUnreadCount++;
            }
            driverMessageList.push(messages[i]);
          }
          if (!_tmpFlag) {
            _tmpMessageTimeStampArry.push(messages[i].messagetimestamp);
          }
        }
      }
    }
    driverMessageProperties.unreadMessages = mesgUnreadCount;
    driverMessageProperties.driverMessageList = driverMessageList.concat(exsistingList);
    for (var m = 0; m < _tmpMessageTimeStampArry.length; m++) {
      messageTimeStampArray.push(_tmpMessageTimeStampArry[m]);
    }
    that.setMessageLocalStorgaeProp(timeTo, messageTimeStampArray);
    driverMessageProperties._tmpRefreshCheck = false;
    return driverMessageProperties;
  }

  this.getMessageHistoryByDevice = function (deviceID, timeFrom, timeTo) {
    var requestParam = {
      dataRefresh: false,
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'DriverMessageDetail'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('messaging', 'devicemessages/' + deviceID, param);
  };

  function getMessageTypeNumber(typeDescription) {
    switch (typeDescription) {
      case 'Yes/No':
        return 2;
      case 'Ok':
        return 1;
      case 'Text':
        return 3;
    }
  }

  this.getAvailableGroups = function () {
    return crudService.get('messaging/groups/availableGroups').then(function (availableGroups) {
      if (availableGroups && Array.isArray(availableGroups)) {
        availableGroups.forEach(function (group) {
          if (group.groupMembers && Array.isArray(group.groupMembers)) {
            group.groupMembers = group.groupMembers.map(function (member) {
              // If member is already an object with deviceId, keep it
              if ((typeof member === 'undefined' ? 'undefined' : _typeof(member)) === 'object' && member !== null && (member.deviceId || member.deviceID)) {
                return member;
              }
              // If member is a string (deviceId), keep it as is
              return member;
            });
          }
        });
      }
      return availableGroups;
    }, function (response) {
      console.error('Error fetching available groups:', response);
      errorHandlingService.handleForCommonResponse(response);
      return [];
    });
  };

  this.getGeneralSettings = function () {
    var _generalSettings = localStorageService.get('fleetSettings.generalSettings');
    if (_generalSettings) {
      return _generalSettings;
    }
    return gerneralSettings;
  };
  this.saveGeneralSettings = function (generalSettings) {
    localStorageService.set('fleetSettings.generalSettings', generalSettings);
  };

  /**
   * Method returns vehicle based dashboard widget names used in Appending Vehicle ID to the widget title.
   * @returns {string[]}
   */
  this.getVehicleBasedWidgetNameArray = function () {
    return [{
      name: 'vehicleMapWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.deviceMap.deviceMapTitle'
    }, {
      name: 'vehicleDetailsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'
    }, {
      name: 'vehicleListWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehicleList.vehicleListTitle'
    }, {
      name: 'TempMonitoringWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.tempMonitoringWidget.title'
    }, {
      name: 'DriverWrkHrsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'
    }, {
      name: 'DriverWrkHrsSVGWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.driverWhrkHrsSVG.title'
    }, {
      name: 'vehiclesListWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehiclesListWidget.title'
    }, {
      name: 'vehicleStatusWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehicleStatusWidget.title'
    }, {
      name: 'digitalOutputsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.digitalOutputsWidget.title'
    }, {
      name: 'pendingCommandsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.pendingCommandsWidget.title'
    }, {
      name: 'FMSVehicleWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.fmsVehicle.vehicleList'
    }, {
      name: 'DriverDigitalTachoStatusWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'
    }, {
      name: 'tachoDownloadStatusWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.tachoDownloadStatus.title'
    }];
  };

  /**
   * Method returns Fleet based dashboard widget names used in Appending Vehicle ID to the widget title.
   * @returns {string[]}
   */
  this.getFleetBasedWidgetNameArray = function () {
    return [{
      name: 'fleetMapWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.fleetMap.fleetMapTitle'
    }];
  };

  this._loopWidgetsInDashboard = function (dashBoardModel, titleAppendTypeArray, selectedID) {

    for (var a = 0; a < titleAppendTypeArray.length; a++) {
      var _widget = dashboardService.getDashboardWidget(dashBoardModel, titleAppendTypeArray[a].name);
      var locales = ['en', 'de', 'nl'];
      var isFound = false;

      if (_widget) {
        var titleSplitArray = _widget.title.split('/')[0].trim();
        for (var index in locales) {
          if (titleSplitArray === $translate.instant(titleAppendTypeArray[a].titleTranslationKey, null, null, locales[index])) {
            isFound = true;
            break;
          }
        }
        if (isFound) {
          // is default translation  found
          _widget.title = $translate.instant(titleAppendTypeArray[a].titleTranslationKey);
        } else {
          _widget.title = titleSplitArray;
        }
      }
      if (_widget && selectedID !== null) {
        _widget.title += ' / ' + selectedID;
      }
    }
  };

  this.getNotificationListCurentDay = function () {
    var timeFrom = $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00';
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');
    var requestParam = {
      vehicleGroup: 'all',
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'NotifyQueueDetail_Group'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('notifications', '', param);
  };

  this.getJqxLineChartSettings = function () {
    var settings = {
      title: '',
      description: '',
      enableAnimations: true,
      enableCrosshairs: true,
      crosshairsDashStyle: '1,1',
      crosshairsColor: '#0000FF',
      showLegend: true,
      padding: { left: 15, top: 5, right: 30, bottom: 5 },
      titlePadding: { left: 90, top: 0, right: 0, bottom: 10 },
      source: [],
      xAxis: {},
      colorScheme: 'scheme01',
      seriesGroups: []
    };

    return settings;
  };
  /**
   * Util Method for executing an Iframe document method .
   * @param method
   * @param iframeName
   */
  this.iframePostMessage = function (method, iframeName) {
    if (document.getElementById(iframeName) !== null) {
      var receiver = document.getElementById(iframeName).contentWindow;
      var postMessageObj = { method: 'window.' + method, messageOrigin: $window.location.origin };
      try {
        receiver.postMessage(postMessageObj, gtsServerSettings.qualifiedServerURL);
      } catch (err) {
        console.log(err.message); // could throw an exception if iframe not initiazed or takes too much time
      }
    }
  };
  /**
    * Util method for Start and stop auto refresh functionality.
   * if 'hasVehicleMap' start/stop iframe map auto update.
   * if 'hasFleetMap' tart/stop iframe map auto update.
   * @param $scope
   * @param hasVehicleMap
   * @param hasFleetMap
   * @param customFunction
   * @param arg1, arg2, arg3 : customFunction arguments arg1 - arg/combobox  arg2- data refresh,  arg3 arg/combobox
   * @returns {Function}
   */
  this.getRefreshStartStopfunction = function ($scope, hasVehicleMap, hasFleetMap, customFunction, arg1, arg2, arg3, event) {
    return function () {
      if (!$scope.isTimerStated) {
        if (event) {
          $scope.isStopedByUser = false;
        }
        $scope.counter = 60;
        var _tmpArg1 = '';
        var _tmpArg3 = '';
        if (arg1 && typeof arg1 === 'string' && arg1.indexOf('ComboBox') !== -1) {
          _tmpArg1 = $('#' + arg1).jqxComboBox('getSelectedItem').value || '';
        } else {
          _tmpArg1 = arg1;
        }
        if (arg3 && typeof arg3 === 'string' && arg3.indexOf('ComboBox') !== -1) {
          _tmpArg3 = $('#' + arg3).jqxComboBox('getSelectedItem').value || '';
        } else {
          _tmpArg3 = arg3;
        }
        customFunction(_tmpArg1, arg2, _tmpArg3);
        // only send autoUpdate of map if the chatWindow is not opened
        if ($('.chat-window-container').length === 0) {

          if (hasVehicleMap) {
            that.iframePostMessage('startAutoUpdateMapTimer()', 'vehicleMap');
          }
          if (hasFleetMap) {
            that.iframePostMessage('startAutoUpdateMapTimer()', 'fleetMap');
          }
        }
      } else {
        $scope.stop();
        if (event) {
          $scope.isStopedByUser = true;
        }
        $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.startAutoUpdate');
        $scope.isTimerStated = !$scope.isTimerStated;
        if (hasVehicleMap) {
          that.iframePostMessage('stopAutoUpdateMapTimer()', 'vehicleMap');
        }
        if (hasFleetMap) {
          that.iframePostMessage('stopAutoUpdateMapTimer()', 'fleetMap');
        }
      }
    };
  };
  /*
   * Most of the Utility functions used in BetoTrack can be found below.
   *
   * */

  this.getDateRangePickerSettings = function (customEvent) {
    var dateRangeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dateRange.LONG;

    var options = {
      showDropdowns: true,
      showWeekNumbers: true,
      timePicker: true,
      timePickerIncrement: 1,
      autoUpdateInput: true,
      timePicker24Hour: true,
      autoApply: true,
      linkedCalendars: false,
      dateLimit: {},
      clearLabel: $translate.instant('dateRangePicker.locale.clearLabel'),
      locale: {
        format: 'YYYY/MM/DD HH:mm:ss',
        applyLabel: $translate.instant('dateRangePicker.locale.applyLabel'),
        cancelLabel: $translate.instant('dateRangePicker.locale.cancelLabel'),
        fromLabel: $translate.instant('dateRangePicker.locale.fromLabel'),
        toLabel: $translate.instant('dateRangePicker.locale.toLabel'),
        customRangeLabel: $translate.instant('dateRangePicker.locale.customRangeLabel'),
        weekLabel: $translate.instant('dateRangePicker.locale.weekLabel'),
        firstDay: 1,
        daysOfWeek: [$translate.instant('dateRangePicker.locale.daysOfWeek.Sunday'), $translate.instant('dateRangePicker.locale.daysOfWeek.Monday'), $translate.instant('dateRangePicker.locale.daysOfWeek.Tuesday'), $translate.instant('dateRangePicker.locale.daysOfWeek.Wednesday'), $translate.instant('dateRangePicker.locale.daysOfWeek.Thursday'), $translate.instant('dateRangePicker.locale.daysOfWeek.Friday'), $translate.instant('dateRangePicker.locale.daysOfWeek.Saturday')],
        monthNames: [$translate.instant('dateRangePicker.locale.monthNames.January'), $translate.instant('dateRangePicker.locale.monthNames.February'), $translate.instant('dateRangePicker.locale.monthNames.March'), $translate.instant('dateRangePicker.locale.monthNames.April'), $translate.instant('dateRangePicker.locale.monthNames.May'), $translate.instant('dateRangePicker.locale.monthNames.June'), $translate.instant('dateRangePicker.locale.monthNames.July'), $translate.instant('dateRangePicker.locale.monthNames.August'), $translate.instant('dateRangePicker.locale.monthNames.September'), $translate.instant('dateRangePicker.locale.monthNames.October'), $translate.instant('dateRangePicker.locale.monthNames.November'), $translate.instant('dateRangePicker.locale.monthNames.December')]
      },
      ranges: {}
    };

    that.setDateRangePickerCustomOptions(options, dateRangeType);

    options.eventHandlers = {
      'show.daterangepicker': function showDaterangepicker() {
        if (that.getDateRangePickerInitializedDate().isBefore(moment(), 'minute')) {
          $rootScope.$broadcast('date-range-internalDate-old', {});
        }
      }
    };
    if (customEvent) {
      options.eventHandlers = _.extend(options.eventHandlers, customEvent.eventHandlers);
    }
    return options;
  };

  this.setDateRangePickerInitializedDate = function (momentDate) {
    _dateRangePickerInitializedDate = momentDate;
  };
  this.getDateRangePickerInitializedDate = function () {
    return _dateRangePickerInitializedDate ? _dateRangePickerInitializedDate : moment();
  };
  this.getDateRangePickerRange = function (settings, reportName) {
    return this.dateRange[settings[reportName]];
  };

  this.setDateRangePickerCustomOptions = function (options) {
    var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dateRange.LONG;

    if (options === undefined) {
      return;
    }

    that.setDateRangePickerInitializedDate(moment());
    options.ranges = {};
    options.dateLimit = {};

    if (range === this.dateRange.SHORT) {
      options.ranges[$translate.instant('dateRangePicker.ranges.Standard')] = [moment().subtract(2, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Today')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Yesterday')] = [moment().subtract(1, 'days').clone().startOf('day'), moment().subtract(1, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_hour')] = [moment().subtract(1, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_2_hours')] = [moment().subtract(2, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_4_hours')] = [moment().subtract(4, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_8_hours')] = [moment().subtract(8, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_24_hours')] = [moment().subtract(24, 'hours').clone(), moment().clone()];

      options.dateLimit.hours = 24;
    } else if (range === this.dateRange.MID) {
      options.ranges[$translate.instant('dateRangePicker.ranges.Standard')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Today')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Yesterday')] = [moment().subtract(1, 'days').clone().startOf('day'), moment().subtract(1, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_2_days')] = [moment().subtract(2, 'days').clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_7_days')] = [moment().subtract(7, 'days').clone().startOf('day'), moment().clone().endOf('day')];

      options.dateLimit.days = 7;
    } else {
      options.ranges[$translate.instant('dateRangePicker.ranges.Standard')] = [moment().subtract(7, 'days').clone().startOf('day'), moment().add(7, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Today')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Yesterday')] = [moment().subtract(1, 'days').clone().startOf('day'), moment().subtract(1, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_7_days')] = [moment().subtract(7, 'days').clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_30_days')] = [moment().subtract(30, 'days').clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.This_month')] = [moment().startOf('month').clone().startOf('day'), moment().endOf('month').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_Month')] = [moment().subtract(1, 'months').startOf('month').clone().startOf('day'), moment().subtract(1, 'months').endOf('month').clone().endOf('day')];

      options.dateLimit = false;
    }

    return options.ranges;
  };

  this.getDateTime = function (type, format) {
    if (type === 'present' && format === 'yyyy/MM/dd/HH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');
    }

    if (type === 'startOfDay' && format === 'yyyy/MM/dd/HH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00';
    }
    if (type === 'present' && format === 'yyyy-MM-ddTHH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy-MM-ddTHH:mm:ss');
    }
    if (type === 'startOfDay' && format === 'yyyy-MM-ddTHH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy-MM-dd') + 'T00:00:00';
    }
  };

  Number.prototype._isInt = function (n) {
    return n % 1 === 0;
  };
  Number.prototype._isFloat = function (n) {
    return Number(n) === n && n % 1 !== 0;
  };

  String.prototype._appendBefore = function (padString, length) {
    var str = this;
    while (str.length < length) {
      str = padString + str;
    }
    return str;
  };

  String.prototype.beginsWith = function (string) {
    return this.indexOf(string) === 0;
  };

  String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
  };

  String.prototype.replaceAt = function (index, character) {
    return this.substr(0, index) + character + this.substr(index + character.length);
  };

  String.prototype.toLoawerCaseAt = function (index) {
    return this.charAt(index).toLocaleLowerCase() + this.slice(1);
  };

  /**
   *  get cache vehicle value.
   * @param vehicleList
   * @returns {string}
   */
  this.getCachedVehicleGroup = function (vehicleList) {
    var loginid = AuthenticationService.GetLoginID();
    var cachedGroup = localStorageService.get('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username);
    //check whether the cached group is in list
    var isExist = false;
    for (var i = 0; i < vehicleList.length; i++) {
      if (cachedGroup === vehicleList[i].groupID) {
        isExist = true;
        break;
      }
    }
    if (cachedGroup && isExist) {
      return cachedGroup;
    } else {
      localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, vehicleList[0].groupID);
      return vehicleList[0].groupID;
    }
  };

  this.setDataToLocalStorage = function (key, value) {
    var loginid = AuthenticationService.GetLoginID();
    localStorageService.set(key + '.' + loginid.Account + '.' + loginid.username, value);
  };

  this.getDataFromLocalStorage = function (key) {
    var loginid = AuthenticationService.GetLoginID();
    return localStorageService.get(key + '.' + loginid.Account + '.' + loginid.username);
  };

  // method for gridSettings
  this.getUserSettings = function () {
    return that.getGtsLocalStorageSettings();
  };

  this.saveUserSettings = function (settings) {
    return that.saveGtsUserSettings(settings);
  };

  this.removeGridStateStorage = function (gridSettingId) {
    $window.localStorage.removeItem('jqxGrid' + gridSettingId);
  };

  //end gridSettings

  this.copyToClipboard = function (text) {
    var body = angular.element($window.document.body);
    var textarea = angular.element('<textarea>/');
    textarea.css({
      position: 'fixed',
      opacity: '0'
    });
    textarea.val(text);
    body.append(textarea);
    textarea[0].select();

    try {
      var successful = document.execCommand('copy');
      if (!successful) {
        throw successful;
      }
    } catch (err) {
      console.log('failed to copy', text);
    }
    textarea.remove();
  };
  this.getCustomSortFunction = function (gridName, source) {
    return function (column, direction) {
      var sortdata = [];

      if (direction === 'ascending' || direction === 'asc' || direction && direction.ascending) {
        direction = true;
      }
      if (direction === 'descending' || direction === 'desc' || direction && direction.descending) {
        direction = false;
      }

      if (direction !== null) {
        for (var i = 0; i < source.localdata.length; i++) {
          sortdata.push(source.localdata[i]);
        }
      } else {
        sortdata = source.localdata;
      }

      var tmpToString = Object.prototype.toString;
      Object.prototype.toString = typeof column === 'function' ? column : function () {
        return this[column];
      };

      var result;
      if (source.datafields && column) {
        result = source.datafields.find(function (o) {
          return o.name === column;
        });
      }

      if (column === 'devicedesc' && direction !== null) {
        sortdata.sort(compareVehicleDescription(direction));
      } else if (column === 'drumrotation' && direction !== null) {
        sortdata.sort(comparePercent(direction));
      } else if (result && result.type === 'number' && direction !== null) {
        sortdata.sort(compareFloat(direction));
      } else if (direction !== null) {
        sortdata.sort(compare(direction));
      }

      source.localdata = sortdata;
      $('#' + gridName).jqxGrid('updatebounddata', 'sort');
      Object.prototype.toString = tmpToString;
    };
  };

  //SCL-10332 Sort vehicle description by numbers, special characters and then alphabetically
  var compareVehicleDescription = function compareVehicleDescription(direction) {
    return function (value1, value2) {
      return _sortCompareVehicleDesc(value1.devicedesc, value2.devicedesc, direction);
    };
  };

  function _sortCompareVehicleDesc(value1, value2, direction) {
    value1 = String(value1).toLowerCase();
    value2 = String(value2).toLowerCase();
    var timeEmptyStringformat = '---';

    if (value1 === '' || timeEmptyStringformat === value1.trim()) {
      return 1;
    } else if (value2 === '' || timeEmptyStringformat === value2.trim()) {
      return -1;
    }

    var startsWithDigit1 = /^\d/.test(value1);
    var startsWithDigit2 = /^\d/.test(value2);
    var startsWithSpecial1 = /^[!@#$%^&*]/.test(value1);
    var startsWithSpecial2 = /^[!@#$%^&*]/.test(value2);

    var priority1 = startsWithDigit1 ? 1 : startsWithSpecial1 ? 2 : 3;
    var priority2 = startsWithDigit2 ? 1 : startsWithSpecial2 ? 2 : 3;

    // Groups always maintain priority order (1,2,3), only reverse within groups
    if (priority1 !== priority2) {
      return priority1 - priority2;
    }

    if (priority1 === 1 || priority2 === 1) {
      var num1 = parseInt(value1.match(/^\d+/)[0], 10);
      var num2 = parseInt(value2.match(/^\d+/)[0], 10);
      if (num1 !== num2) {
        return direction ? num1 - num2 : num2 - num1;
      }
      return direction ? value1 > value2 ? 1 : -1 : value1 > value2 ? -1 : 1;
    }

    if (priority1 === 2 || priority2 === 2) {
      var num1Match = value1.match(/\d+/);
      var num2Match = value2.match(/\d+/);

      if (num1Match && num2Match) {
        var numA = parseInt(num1Match[0], 10);
        var numB = parseInt(num2Match[0], 10);
        if (numA !== numB) {
          return direction ? numA - numB : numB - numA;
        }
      }
      return direction ? value1 > value2 ? 1 : -1 : value1 > value2 ? -1 : 1;
    }
    return _sortCompare(value1, value2, direction);
  }

  this.getCustomReportSortFunction = function (gridName, source) {
    return function (column, direction) {
      var sortdata = [];
      var nonsortdata = [];

      if (direction === 'ascending' || direction === 'asc' || direction && direction.ascending) {
        direction = true;
      }
      if (direction === 'descending' || direction === 'desc' || direction && direction.descending) {
        direction = false;
      }

      if (direction !== null) {
        for (var i = 0; i < source.localdata.length; i++) {
          var item = source.localdata[i];
          var c = that.cellClassName(null, null, null, item);
          if (c === 'gridsummaryclass') {
            nonsortdata.push(item);
          } else {
            sortdata.push(source.localdata[i]);
          }
        }
      } else {
        sortdata = source.localdata;
      }

      var tmpToString = Object.prototype.toString;
      Object.prototype.toString = typeof column === 'function' ? column : function () {
        return this[column];
      };

      var result;
      if (source.datafields && column) {
        result = source.datafields.find(function (o) {
          return o.name === column;
        });
      }

      if (column === 'drumrotation' && direction !== null) {
        sortdata.sort(comparePercent(direction));
      } else if (result && result.type === 'number' && direction !== null) {
        sortdata.sort(compareFloat(direction));
      } else if (direction !== null) {
        sortdata.sort(compare(direction));
      }

      //Now add the non sort data
      for (var x = 0; x < nonsortdata.length; x++) {
        sortdata.push(nonsortdata[x]);
      }
      source.localdata = sortdata;
      $('#' + gridName).jqxGrid('updatebounddata', 'sort');
      Object.prototype.toString = tmpToString;
    };
  };

  var comparePercent = function comparePercent(direction) {
    return function (value1, value2) {
      var value1Percent = value1.drumrotation / value1.drumrotationmax;
      var value2Percent = value2.drumrotation / value2.drumrotationmax;
      if (value1Percent === value2Percent) {
        return 0;
      }
      if (direction === true || direction.valueOf() === true) {
        return value1Percent >= value2Percent ? 1 : -1;
      } else if (direction === false || direction.valueOf() === false) {
        return value1Percent <= value2Percent ? 1 : -1;
      }
    };
  };

  var compareFloat = function compareFloat(direction) {
    return function (value1, value2) {
      if (value1 === value2) {
        return 0;
      }
      if (direction === true || direction.valueOf() === true) {
        return value1 >= value2 ? 1 : -1;
      } else if (direction === false || direction.valueOf() === false) {
        return value1 <= value2 ? 1 : -1;
      }
    };
  };

  /**
   * This compare functon used under the JQX Grid custom Sorting ( JQX does not properly sort alpha numerical values which is type of (beton 07, beton 09, beton 43),
   * Bug 72967 - When sorting the grid by column Device Name with 0 are not sorted correct
   * @param value1
   * @param value2
   * @returns {number}
   */

  var compare = function compare(direction) {
    return function (value1, value2) {
      return _sortCompare(value1, value2, direction);
    };
  };

  function _sortCompare(value1, value2, direction) {
    value1 = String(value1).toLowerCase();
    value2 = String(value2).toLowerCase();
    var timeEmptyStringformat = '---';
    if (value1 === '' || timeEmptyStringformat === value1.trim()) {
      return 1;
    } else if (value2 === '' || timeEmptyStringformat === value2.trim()) {
      return -1;
    }

    var dateFormat = getDateFormat(value1) || getDateFormat(value2); // check any of the given value is  date
    // date format identified use moment to  comare
    if (dateFormat) {
      if (direction) {
        return moment(value1, dateFormat) - moment(value2, dateFormat);
      } else {
        return moment(value2, dateFormat) - moment(value1, dateFormat);
      }
    }

    var reA = /[^a-zA-Z]/g; // only characters
    var reN = /[^0-9]/g; // only numbers
    var regExForCharsAfterNumber = /\d*(.+[^a-zA-Z]+)/;
    var isval1HascharAfterNumber = value1.replace(regExForCharsAfterNumber, ''); // select characters after number
    var isval2HascharAfterNumber = value2.replace(regExForCharsAfterNumber, '');
    value1 = isval1HascharAfterNumber.length > 0 ? value1.replace(/(\d)\D+$/g, '$1') : value1; // replace character after number
    value2 = isval2HascharAfterNumber.length > 0 ? value2.replace(/(\d)\D+$/g, '$1') : value2; //replace character after number

    var aA = value1.replace(reA, '');
    var bA = value2.replace(reA, '');
    if (aA === bA) {
      var aN = parseInt(value1.replace(reN, ''), 10);
      var bN = parseInt(value2.replace(reN, ''), 10);
      if (direction) {
        if (aN === bN) {
          if (isval1HascharAfterNumber !== isval2HascharAfterNumber) {
            return isval1HascharAfterNumber > isval2HascharAfterNumber ? 1 : -1;
          }
          return 0;
        }
        return aN > bN ? 1 : -1;
      } else {
        if (aN === bN) {
          if (isval1HascharAfterNumber !== isval2HascharAfterNumber) {
            return isval1HascharAfterNumber > isval2HascharAfterNumber ? -1 : 1;
          }
          return 0;
        }
        return aN > bN ? -1 : 1;
      }
    } else {
      if (direction) {
        return aA > bA ? 1 : -1;
      } else {
        return aA > bA ? -1 : 1;
      }
    }
  }

  this.getOverviewGridPrefix = function () {
    return '_' + localStoragePrefix + '_';
  };

  /**
   * Checks viewport size and returns the Bootstrap  viewport equivalent name.
   *
   * @returns {string} returns the View Port String value
   */
  this.getViewPortName = function () {
    if ($(window).width() < 768) {
      return 'XS';
    } else if ($(window).width() >= 768 && $(window).width() <= 992) {
      return 'SM';
    } else if ($(window).width() > 992 && $(window).width() <= 1200) {
      return 'MD';
    } else {
      return 'LG';
    }
  };

  /**
   * Based on view port height the row  height is determined ( values are mock real height values  need to be finalized ).
   *
   * @returns {number}
   */
  this.getJqxGridRowHeight = function () {

    switch (that.getViewPortName()) {
      case 'XS':
        return 45;
      case 'SM':
        return 40;
      case 'MD':
        return 35;
      case 'LG':
        return 28;
      default:
        return 28;
    }
  };

  var TIME_STRING_FORMAT = {
    _1: '0d 00h 00m', // if days are present  time display in '12d 12h 12m' else '00h 12m'
    _2: '00h 00m' // if hours presnt '12h 12m' else '00h 12m'
  };

  this.getTimeStringFromMinutes = function getTimeStringFromMinutes(timeMinutes, format) {
    var hour, min;
    var resultString = '';
    if (format === TIME_STRING_FORMAT._1 || !format) {
      var day = Math.trunc(timeMinutes / 24 / 60);
      hour = Math.trunc(timeMinutes / 60 % 24);
      min = Math.trunc(timeMinutes % 60);

      if (day > 1 || day < 0 || day >= 1 && hour > 0) {
        day = day > 1 && day.toString().length === 1 ? '0' + day : day;
        resultString += day + 'd ';
      }
    } else if (format === TIME_STRING_FORMAT._2) {
      hour = Math.trunc(timeMinutes / 60);
      min = Math.trunc(timeMinutes % 60);
    }

    if (hour > 1 || hour < 0 || hour >= 1 && min > 0) {
      hour = hour > 1 && hour.toString().length === 1 ? '0' + hour : hour;
      resultString += hour + 'h ';
    } else {
      resultString += '00h ';
    }

    if (min > 1 || min < 0) {
      min = min > 1 && min.toString().length === 1 ? '0' + min : min;
      resultString += min + 'm';
    } else {
      resultString += '00m';
    }
    return resultString;
  };

  this.isLocalOrconfigVehicleGroupValid = function (vehicleGroupList, currentGroupId) {
    for (var i = 0; i < vehicleGroupList.length; i++) {
      if (vehicleGroupList[i].groupID === currentGroupId) {
        return true;
      }
    }
    return false;
  };

  this.getVehicleGridCommandList = function (deviceID) {
    return crudService.get('portalcommands/commandslist/' + deviceID);
  };

  this.sendCommand = function (deviceID, commandType, commandID) {
    var postObj = {
      deviceID: deviceID,
      deviceIds: [deviceID],
      commandType: commandType,
      commandID: commandID
    };
    return crudService.post('portalcommands/sendcommand', postObj);
  };
  /**
   * Checkes  given value and return identified Momoent date format .
   * Supported formates , code must be adopted for new formats
   * 'DD.MM.YYYY'
   * 'DD/MM/YYYY'
   * 'DD.MM.YYYY HH:mm:ss'
   * 'HH:mm:ss'
   * @param {*} value
   * @returns
   */

  function getDateFormat(value) {
    if (value.length === 10 && value.match(/(^\d{2}\.\d{2}\.\d{4}$)/g)) {
      return 'DD.MM.YYYY';
    }
    if (value.length === 10 && value.match(/(^\d{2}\/\d{2}\/\d{4}$)/g)) {
      return 'DD/MM/YYYY';
    }
    if (value.length === 19 && value.match(/^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})$/)) {
      return 'DD.MM.YYYY HH:mm:ss';
    }
    if (value.length === 19 && value.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/)) {
      return 'DD/MM/YYYY HH:mm:ss';
    }
    if (value.length === 8 && value.match(/^(\d{2}):(\d{2}):(\d{2})$/)) {
      return 'HH:mm:ss';
    }
  }
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by linli on 1/21/2016.
 */



angular.module('betosyswebapp').service('updaterService', ["$q", "$http", "localStorageService", "$window", "version", function ($q, $http, localStorageService, $window, version) {

  this.doUpdate = function () {
    var versionInLocalStorage = localStorageService.get('version');
    if (!versionInLocalStorage || versionInLocalStorage !== version) {
      localStorageService.set('version', version);
    }
  };
}]);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by cxh on 3/12/2015.
 */


angular.module('dashboard', ['adf', 'structures', 'dashboard.vehicleList', 'dashboard.vehicleDetails', 'dashboard.vehicleMap', 'dashboard.fleetMap', 'dashboard.driverWrkHrsDashboard', 'dashboard.driverWrkHrsSVG', 'dashboard.deviceSummary', 'dashboard.fmsDashboard', 'dashboard.driverDigitalTachoStatus', 'dashboard.tachoEventDetail', 'dashboard.tachoHistory', 'dashboard.tachoDownloadDashboard']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.addLocale('de-DE', {
    ADF_COMMON_CLOSE: 'Schließen',
    ADF_COMMON_DELETE: 'Löschen',
    ADF_COMMON_TITLE: 'Titel',
    ADF_COMMON_CANCEL: 'Abbrechen',
    ADF_COMMON_APPLY: 'Anwenden',
    ADF_COMMON_EDIT_DASHBOARD: 'Dashboard bearbeiten',
    ADF_EDIT_DASHBOARD_STRUCTURE_LABEL: 'Struktur',
    ADF_DASHBOARD_TITLE_TOOLTIP_ADD: 'Neues Widget hinzufügen',
    ADF_DASHBOARD_TITLE_TOOLTIP_SAVE: 'Änderungen speichern',
    ADF_DASHBOARD_TITLE_TOOLTIP_EDIT_MODE: 'Editiermodus aktivieren',
    ADF_DASHBOARD_TITLE_TOOLTIP_UNDO: 'Änderungen verwerfen',
    ADF_WIDGET_ADD_HEADER: 'Neues Widget hinzufügen',
    ADF_WIDGET_DELETE_CONFIRM_MESSAGE: 'Sind Sie sicher, dass Sie dieses Widget löschen möchten ?',
    ADF_WIDGET_TOOLTIP_REFRESH: 'Inhalt aktualisieren',
    ADF_WIDGET_TOOLTIP_MOVE: 'Position ändern',
    ADF_WIDGET_TOOLTIP_COLLAPSE: 'Zusammenklappen',
    ADF_WIDGET_TOOLTIP_EXPAND: 'Vergrößern',
    ADF_WIDGET_TOOLTIP_EDIT: 'Einstellungen bearbeiten',
    ADF_WIDGET_TOOLTIP_FULLSCREEN: 'Vollbildanzeige',
    ADF_WIDGET_TOOLTIP_REMOVE: 'Löschen'
  });
  dashboardProvider.addLocale('en-EN', {
    ADF_COMMON_CLOSE: 'Close',
    ADF_COMMON_DELETE: 'Delete',
    ADF_COMMON_TITLE: 'Title',
    ADF_COMMON_CANCEL: 'Cancel',
    ADF_COMMON_APPLY: 'Apply',
    ADF_COMMON_EDIT_DASHBOARD: 'Edit dashboard',
    ADF_EDIT_DASHBOARD_STRUCTURE_LABEL: 'Structure',
    ADF_DASHBOARD_TITLE_TOOLTIP_ADD: 'Add new widget',
    ADF_DASHBOARD_TITLE_TOOLTIP_SAVE: 'Save changes',
    ADF_DASHBOARD_TITLE_TOOLTIP_EDIT_MODE: 'Enable edit mode',
    ADF_DASHBOARD_TITLE_TOOLTIP_UNDO: 'Undo changes',
    ADF_WIDGET_ADD_HEADER: 'Add new widget',
    ADF_WIDGET_DELETE_CONFIRM_MESSAGE: 'Are you sure you want to delete this widget ?',
    ADF_WIDGET_TOOLTIP_REFRESH: 'Reload Widget Content',
    ADF_WIDGET_TOOLTIP_MOVE: 'Change widget location',
    ADF_WIDGET_TOOLTIP_COLLAPSE: 'Collapse widget',
    ADF_WIDGET_TOOLTIP_EXPAND: 'Expand widget',
    ADF_WIDGET_TOOLTIP_EDIT: 'Edit widget configuration',
    ADF_WIDGET_TOOLTIP_FULLSCREEN: 'Fullscreen widget',
    ADF_WIDGET_TOOLTIP_REMOVE: 'Remove widget'
  });
  dashboardProvider.addLocale('nl-NL', {
    ADF_COMMON_CLOSE: 'Sluiten',
    ADF_COMMON_DELETE: 'Wissen',
    ADF_COMMON_TITLE: 'Titel',
    ADF_COMMON_CANCEL: 'Annuleren',
    ADF_COMMON_APPLY: 'Toepassen',
    ADF_COMMON_EDIT_DASHBOARD: 'Bewerk dashboard',
    ADF_EDIT_DASHBOARD_STRUCTURE_LABEL: 'Structuur',
    ADF_DASHBOARD_TITLE_TOOLTIP_ADD: 'Nieuwe wdget toevoegen',
    ADF_DASHBOARD_TITLE_TOOLTIP_SAVE: 'Opslaan',
    ADF_DASHBOARD_TITLE_TOOLTIP_EDIT_MODE: 'Bewerkingsmodus activeren',
    ADF_DASHBOARD_TITLE_TOOLTIP_UNDO: 'Ongedaan maken',
    ADF_WIDGET_ADD_HEADER: 'Nieuwe wdget toevoegen',
    ADF_WIDGET_DELETE_CONFIRM_MESSAGE: 'Weet u zeker dat u deze widget wilt verwijderen ?',
    ADF_WIDGET_TOOLTIP_REFRESH: 'Inhoud bijwerken',
    ADF_WIDGET_TOOLTIP_MOVE: 'Verander positie',
    ADF_WIDGET_TOOLTIP_COLLAPSE: 'Folden',
    ADF_WIDGET_TOOLTIP_EXPAND: 'Vergroten',
    ADF_WIDGET_TOOLTIP_EDIT: 'Instellingen bewerken',
    ADF_WIDGET_TOOLTIP_FULLSCREEN: 'Volledig scherm',
    ADF_WIDGET_TOOLTIP_REMOVE: 'Wissen'
  });
}]);

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/deviceSummary/deviceSummaryEdit.tpl.html', '<label translate="dashBoard.fleetManagement.tempMonitoringWidget.maxHours"></label> <input type="text" ng-model="tempMonitor.maxHours" class="form-control" font-weight="bolder" maxlength="2"> <label translate="dashBoard.fleetManagement.tempMonitoringWidget.temperatureUnit"></label> <input type="text" ng-model="tempMonitor.temperatureUnit" class="form-control" font-weight="bolder" maxlength="2" disabled="true"> <label translate="dashBoard.fleetManagement.tempMonitoringWidget.max"></label> <input type="text" ng-model="tempMonitor.max" class="form-control" font-weight="bolder" maxlength="3"><div ng-show="maxIsOdd" style="color: red;" translate="dashBoard.fleetManagement.tempMonitoringWidget.isOdd"></div><label translate="dashBoard.fleetManagement.tempMonitoringWidget.min"></label> <input type="text" ng-model="tempMonitor.min" class="form-control" font-weight="bolder" maxlength="3"><div ng-show="minIsOdd" style="color: red;" translate="dashBoard.fleetManagement.tempMonitoringWidget.isOdd"></div>');
  }]);
})();

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 8/26/2016.
 */


angular.module('dashboard.deviceSummary', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('TempMonitoringWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.tempMonitoringWidget.title';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.tempMonitoringWidget.description';
      }
    },
    controller: 'TempMonitoringCtrl',
    templateUrl: 'components/dashboard/deviceSummary/deviceSummaryWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      height: 450,
      maxHours: 2,
      temperatureUnit: '',
      max: null,
      min: null
    },
    edit: {
      templateUrl: 'components/dashboard/deviceSummary/deviceSummaryWidgetEdit.tpl.html',
      reload: true,
      controller: 'TempMonitoringEditCtrl',
      apply: function apply(config, TempMonitoringService) {
        TempMonitoringService.saveTemperatureConfiguration(config);
      }
    }
  });
}]).service('TempMonitoringService', ["crudService", "localStorageService", "AuthenticationService", function (crudService, localStorageService, AuthenticationService) {

  var _hasRowEventRecieved = false;
  this.getThermoEventDatalList = function (deviceId, startDate, endDate, loadConsistencyData) {
    var requestParam = {
      timeTo: endDate,
      timeFrom: startDate,
      reportName: loadConsistencyData ? 'EventSummaryConsistencyCharts' : 'EventSummaryCharts'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };

    if (loadConsistencyData) {
      return crudService.customGET('overview', 'devicesummaryconsistencycharts/' + deviceId, param);
    }
    return crudService.customGET('overview', 'devicesummarycharts/' + deviceId, param);
  };

  this.getFuelHistory = function (deviceId, startDate, endDate) {
    if (!deviceId || !endDate) {
      console.log('Cannot get fuel history without device ID and end date');
      return;
    }

    var requestParam = {
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'DailyDistanceDetail',
      deviceid: deviceId
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('vehicledetailsreport', 'dailydistancedetail', param);
  };

  this.getSummaryDetails = function (deviceId) {
    var requestParam = {
      reportName: 'EventThermo'
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return crudService.customGET('vehicledetailsreport', 'devicesummary/' + deviceId, param);
  };

  this.saveChartState = function (chartSeries) {
    var loginID = AuthenticationService.GetLoginID();
    localStorageService.set('fleetSettings.tempChartSeries.' + loginID.Account + '.' + loginID.username, chartSeries);
  };

  this.getChartState = function () {
    var loginID = AuthenticationService.GetLoginID();
    var chartSeries = localStorageService.get('fleetSettings.tempChartSeries.' + loginID.Account + '.' + loginID.username);
    if (chartSeries !== null) {
      return chartSeries;
    }
    return chartSeries;
  };

  this.saveTempRangeValues = function (range, unit) {
    var loginID = AuthenticationService.GetLoginID();
    var tmpRange = this.getTemperatureRangeValue() || {};
    if (unit === 1) {
      tmpRange.c = {
        to: range.to,
        from: range.from
      };
    } else {
      tmpRange.f = {
        to: range.to,
        from: range.from
      };
    }
    localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username + '.tempRange', tmpRange);
  };
  this.getTemperatureRangeValue = function () {
    var loginID = AuthenticationService.GetLoginID();
    var rangeValue = localStorageService.get('fleetSettings.' + loginID.Account + '.' + loginID.username + '.tempRange');
    if (rangeValue !== null) {
      return rangeValue;
    }
    return null;
  };

  this.saveTemperatureConfiguration = function (configObj) {
    var loginID = AuthenticationService.GetLoginID();
    localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username + '.configuration', configObj);
  };

  this.getTemperatureConfiguration = function () {
    var loginID = AuthenticationService.GetLoginID();
    return localStorageService.get('fleetSettings.' + loginID.Account + '.' + loginID.username + '.configuration');
  };

  this.saveIntialTmparatueRangeValues = function (unit) {
    var loginID = AuthenticationService.GetLoginID();
    var range = {
      c: {},
      f: {}
    };

    if (unit === 1) {
      range.c = {
        to: 10,
        from: -12
      };
    } else {
      range.f = {
        to: 50,
        from: 10
      };
    }
    localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username + '.tempRange', range);
  };

  this.setRowEventStatus = function (status) {
    _hasRowEventRecieved = status;
  };
  this.getRowEventStatus = function () {
    return _hasRowEventRecieved;
  };
  this.isFullScreen = function () {};
}]).controller('TempMonitoringCtrl', ["$scope", "$q", "TempMonitoringService", "stateManagerService", "config", "commonTrackService", "$translate", "$timeout", "$state", "errorHandlingService", "$rootScope", "AuthenticationService", "$interval", function ($scope, $q, TempMonitoringService, stateManagerService, config, commonTrackService, $translate, $timeout, $state, errorHandlingService, $rootScope, AuthenticationService, $interval) {
  $scope.temperatureDetail = {
    date: {
      startDate: new Date().setHours(0, 0, 0, 0),
      endDate: new Date()
    }
  };

  $scope.doorStatusChartSettings = {};
  $scope.tempratursChartHistory = {};

  $scope.parentWidgetData = {};
  $scope.summaryData = { isStartTime: true };

  var getSpeedUnitString = function getSpeedUnitString() {
    switch ($scope.accountSettings.speedUnits) {
      case 0:
        return 'mph';
      case 1:
        return 'km/h';
      case 2:
        return 'knots';
      default:
        return $scope.accountSettings.speedUnits;
    }
  };

  var getEconomyUnitString = function getEconomyUnitString(economyUnit) {

    switch (economyUnit) {
      case 0:
        return 'mpg';
      case 1:
        return 'km/L';
      case 2:
        return 'kpg';
      case 3:
        return 'L/100km';
      default:
        return economyUnit;
    }
  };

  var loadGtsAccountSettings = function loadGtsAccountSettings() {
    commonTrackService.getGtsAccountSettings(true).then(function (data) {
      $scope.accountSettings = data;

      var fueleconomyUnit = getEconomyUnitString($scope.accountSettings.economyUnits);
      var speedUnit = getSpeedUnitString();

      $scope.fuelChartSettings = {
        title: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.chartHeading'),
        description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
        padding: { left: 15, top: 5, right: 30, bottom: 5 },
        enableAnimations: true,
        showLegend: true,
        source: [],
        xAxis: {
          dataField: 'time',

          displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.xAxisHeader'),
          valuesOnTicks: true
        },
        colorScheme: 'scheme04',

        seriesGroups: [{
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            minValue: 0,
            title: { text: fueleconomyUnit }
          },
          series: [{ dataField: 'fueleconomytotal', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel1') + ' - ' + fueleconomyUnit }, { dataField: 'fueleconomyengineon', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel2') + ' - ' + fueleconomyUnit }]
        }, {
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            maxValue: 100,
            gridLines: { visible: false },
            minValue: 0,
            title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel4') + ' %' }
          },
          series: [{ dataField: 'fuellevel', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel4'), color: '#0366fc' }]
        }, {
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'right',
            axisSize: 'auto',
            minValue: 0,
            gridLines: { visible: false },
            title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel3') + ' - ' + speedUnit }
          },
          series: [{ dataField: 'speed', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel3') + ' - ' + speedUnit }]
        }]
      };

      $scope.fuelChart2Settings = {
        title: $translate.instant('trackReporting.vehicleDetailReport.dailyDistanceDetail'),
        description: '',
        showLegend: true,
        enableAnimations: true,
        padding: { left: 5, top: 5, right: 5, bottom: 5 },
        titlePadding: { left: 90, top: 0, right: 0, bottom: 10 },
        source: [],
        xAxis: {
          dataField: 'date',
          formatFunction: function formatFunction(value) {
            return moment(value).format('DD/MM/YYYY');
          },
          type: 'date',
          baseUnit: 'day',
          gridLines: { visible: true },
          valuesOnTicks: false
        },
        colorScheme: 'scheme01',
        columnSeriesOverlap: false,
        seriesGroups: [{
          type: 'column',
          columnsGapPercent: 50,
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            minValue: 0,
            title: { text: 'km' }
          },
          series: [{ dataField: 'odomdelta', displayText: $translate.instant('trackReporting.vehicleDetailReport.dailyDistanceDetail') + ' - km', color: 'lightblue' }]
        }, {
          type: 'column',
          columnsGapPercent: 50,
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            minValue: 0,
            title: { text: 'L' }
          },
          series: [{ dataField: 'fueltrip', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.trip') + ' - L', color: 'blue' }]
        }, {
          type: 'column',
          columnsGapPercent: 50,
          valueAxis: {
            visible: true,
            position: 'right',
            axisSize: 'auto',
            minValue: 0,
            title: { text: 'L/100km' }
          },
          series: [{ dataField: 'fueleconomytotal', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel1') + ' - L/100km', color: 'darkblue' }]
        }]
      };

      $scope.$on('jqxChartCreated', function () {
        $('#jqxFuelChart').jqxChart('hideSerie', 1, 0);
      });

      $scope.weightChartSettings = {
        title: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.chartHeading'),
        description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
        padding: { left: 15, top: 5, right: 30, bottom: 5 },

        enableAnimations: true,
        showLegend: true,
        source: [],
        xAxis: {
          dataField: 'time',
          displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.xAxisHeader'),
          valuesOnTicks: true
        },
        colorScheme: 'scheme04',
        valueAxis: {
          visible: true,
          title: { text: 'kg' }
        },
        seriesGroups: [{
          type: 'spline',
          series: [{ dataField: 'combinedweight', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.valueLabel1') }, { dataField: 'axleweight', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.valueLabel2') }]
        }]
      };

      $scope.consistencyDataSource = [];

      var consistencyXAxisDescription = {
        dataField: 'timeindex',
        displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.xAxisHeader'),
        valuesOnTicks: true,
        formatFunction: function formatFunction(value) {
          if (!$scope.consistencyDataSource || $scope.consistencyDataSource.length <= value) {
            return '';
          }
          return $scope.consistencyDataSource[value].time;
        }
      };

      $scope.consistencyChart1Settings = {
        title: '',
        description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
        padding: { left: 34, top: 5, right: 72, bottom: 5 },

        enableAnimations: true,
        showLegend: true,
        source: [],
        xAxis: consistencyXAxisDescription,
        seriesGroups: [{
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            title: { text: 'bar' }
          },
          series: [{ dataField: 'oilinputconverted', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel5'), emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'green';
            } }]
        }, {
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'right',
            axisSize: 'auto',
            title: { text: 'Millivolt' }
          },
          series: [{ dataField: 'oilinputraw', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel1'), emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'pink';
            } }]
        }]

      };

      $scope.consistencyChartWaterSettings = {
        title: '',
        description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
        padding: { left: 34, top: 5, right: 72, bottom: 5 },

        enableAnimations: true,
        showLegend: true,
        source: [],
        xAxis: consistencyXAxisDescription,
        seriesGroups: [{
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            title: { text: 'litres' }
          },
          series: [{ dataField: 'waterinputconverted', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel7'), emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'green';
            } }]
        }, {
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'right',
            axisSize: 'auto',
            title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.millivolt') }
          },
          series: [{ dataField: 'waterinputraw', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel6'), emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'pink';
            } }]
        }]

      };

      $scope.consistencyChartTemperatureSettings = {
        title: '',
        description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
        padding: { left: 34, top: 5, right: 72, bottom: 5 },

        enableAnimations: true,
        showLegend: true,
        source: [],
        xAxis: consistencyXAxisDescription,
        seriesGroups: [{
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            title: { text: String('\xB0') + 'C' }
          },
          series: [{ dataField: 'hydraulicoiltemperatureinputconverted', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel8') + ' (' + String('\xB0') + 'C' + ')', emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'green';
            } }]
        }, {
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'right',
            axisSize: 'auto',
            title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.millivolt') }
          },
          series: [{ dataField: 'hydraulicoiltemperatureinputraw', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel8') + ' (mv)', emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'pink';
            } }]
        }]

      };

      $scope.consistencyChart2Settings = {
        title: '',
        description: '',
        padding: { left: 15, top: 5, right: 30, bottom: 5 },

        enableAnimations: true,
        showLegend: true,
        source: [],
        xAxis: consistencyXAxisDescription,
        seriesGroups: [{
          type: 'stepline',
          valueAxis: {
            visible: true,
            position: 'left',
            axisSize: 'auto',
            title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel2') }
          },
          series: [{ dataField: 'cargorotation', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel2'), emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'green';
            } }]
        }, {
          type: 'spline',
          valueAxis: {
            visible: true,
            position: 'right',
            axisSize: 'auto',
            title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel3') }
          },
          series: [{ dataField: 'enginerpm', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel3'), emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'pink';
            } }]
        }]
      };

      $scope.consistencyChart3Settings = {
        title: '',
        description: '',
        padding: { left: 31, top: 5, right: 68, bottom: 5 },

        enableAnimations: true,
        showLegend: true,
        source: [],
        xAxis: consistencyXAxisDescription,
        valueAxis: {
          visible: true,
          title: { text: String('\xB0') + 'C' }
        },
        seriesGroups: [{
          type: 'spline',
          series: [{ dataField: 'ambienttemp', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel4'), emptyPointsDisplay: 'connect',
            colorFunction: function colorFunction() {
              return 'red';
            } }]
        }]
      };
    });
  };

  loadGtsAccountSettings();

  $scope.isNotSummaryChartsAuthorized = false;
  $scope.isDataNotAvailable = false;
  $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
  $scope.isWidgetPostInitFinished = false;
  $scope.reloadChartData = true;
  $scope.reloadConsistencyChartData = true;
  $scope.thermoDataLoading = true;
  $scope.reloadFuelHistory = true;

  $scope.summaryCardData = {
    showMaintenanceContent: true,
    showCurrentJobContent: true,
    showVehicleStateContent: true,
    showVehicleInfoContent: true,
    isloading: true
  };

  $scope.rangeSelection = {
    from: 0,
    to: 0
  };

  var _serverTimeFormat = {};
  var _accountSettings = null;
  var _temperatureUnit = '';

  // model properties for new auto refresh checkbox in constancy tab
  // model proeprties for the new accordion for each chart under consitancy tab
  $scope.consitancytab = {
    hasAutoRefresh: 0,
    isAmbientTempChartOpen: true,
    ambientTempChartHeight: '300px',
    isConsistancyChartOpen: true,
    consistancyChartHeight: '300px',
    isDrumRpmChartOpen: true,
    drumRpmChartHeight: '300px',
    isConsistencyChartWaterOpen: true,
    consistencyChartWaterHeight: '300px',
    isConsistencyChartTemperatureOpen: true,
    consistencyChartTemperatureHeight: '300px',
    consitancyTabAutoRefreshLabel: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.consistencyAutoRefreshLabel')

  };

  commonTrackService.getGtsAccountSettings(true).then(function (accountSettings) {
    _accountSettings = accountSettings;
  }).finally(function () {
    if (_accountSettings) {
      _temperatureUnit = _accountSettings.temperatureUnits === 0 ? '\xB0' + 'F' : '\xB0' + 'C';
      if (config.temperatureUnit === '') {
        config.temperatureUnit = _temperatureUnit;
      }

      if (config.max === null && config.min === null) {
        config.max = _accountSettings.temperatureUnits === 1 ? 10 : 50;
        config.min = _accountSettings.temperatureUnits === 1 ? -12 : 10;
      }
      if (TempMonitoringService.getTemperatureRangeValue() === null) {
        TempMonitoringService.saveIntialTmparatueRangeValues(_accountSettings.temperatureUnits);
      }

      var configurationCache = TempMonitoringService.getTemperatureConfiguration();
      if (configurationCache) {
        config.max = configurationCache.max;
        config.min = configurationCache.min;
      }

      //_initTempratureSetings();
    }
    $timeout(function () {
      $rootScope.$broadcast('reqDataUpdate');
    }, 0);
  });

  var consistencyTab = 5;

  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        $scope.temperatureDetail.date.startDate = moment($scope.temperatureDetail.date.startDate);
        $scope.temperatureDetail.date.endDate = moment($scope.temperatureDetail.date.endDate);
        config.startDate = $scope.temperatureDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
        config.endDate = $scope.temperatureDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
        _serverTimeFormat._tmpStartDate = config.startDate;
        _serverTimeFormat._tmpEndDate = config.endDate;
        if (config.deviceId) {
          $scope.reloadChartData = true;
          $scope.reloadFuelHistory = true;
          $scope.reloadConsistencyChartData = true;
          var loadConsistencyData = $scope.activeTab === consistencyTab;
          loadThermoOrConsistencyData(config.deviceId, config.startDate, config.endDate, loadConsistencyData);
          loadFuelHistory(config.deviceId, config.startDate);
        }
      }
    }
  };

  loadGtsAccountSettings();

  $scope.fuelTabInitialized = false;
  $scope.weightTabInitialized = false;
  $scope.consistencyTabClickInitialized = false;

  $scope.fuelTabClick = function () {
    _resetConstancyAutoRefresh(); // stop if any existing
    $timeout(function () {
      if ($scope.fuelTabInitialized === false) {
        $scope.fuelTabInitialized = true;
        // Initialize date range picker settings
        commonTrackService.getDatePickerDetails().then(function (settings) {
          $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
        });
      }

      // load the widget with correct data from the parent widget (current selected parent tab)
      // same behaviour like row click event ,
      if ($scope.parentWidgetData && $scope.parentWidgetData.widget) {
        $scope.reloadFuelHistory = false;
        var set = getSetData($scope.parentWidgetData.widget);
        _handleDataUpdate($scope.parentWidgetData.dashboardName, $scope.parentWidgetData.activeTab, set['tab_' + $scope.parentWidgetData.activeTab + '_selectedRow'].value, $scope.parentWidgetData.widget, $scope.activeTab);
      } else {
        // load the data based on gobal row ( first row of parent widget) // fall back , mostly not used .
        var loadDate = $scope.getDateState(); // gives global ( first row details of the parent widget) , which is wrong when differnt tabs are used in the parent tab
        if (loadDate) {
          loadFuelHistory($scope.getDeviceID(), loadDate.startDate);
        } else {
          loadFuelHistory($scope.getDeviceID(), _serverTimeFormat._tmpStartDate);
        }

        if ($scope.reloadChartData === true) {
          $scope.reloadChartData = false;

          var dateO = $scope.getDateState();
          if (dateO) {
            loadThermoData($scope.getDeviceID(), dateO.startDate, dateO.endDate);
          } else {
            loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
          }
        } else {
          $('#jqxFuelChart').jqxChart($scope.fuelChartSettings);
          $('#jqxFuelChart').jqxChart('refresh');
        }
      }
    }, 100);
  };

  $scope.weightTabClick = function () {
    _resetConstancyAutoRefresh(); // stop if any existing
    // console.log('reloadChartData: ' + $scope.reloadChartData + ' id:' + $scope.getDeviceID());
    $timeout(function () {
      if ($scope.weightTabInitialized === false) {
        $scope.weightTabInitialized = true;
        // Initialize date range picker settings
        commonTrackService.getDatePickerDetails().then(function (settings) {
          $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
        });
      }
      if ($scope.reloadChartData === true) {
        var dateO = $scope.getDateState();
        if (dateO) {
          loadThermoData($scope.getDeviceID(), dateO.startDate, dateO.endDate);
        } else {
          loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
        }
        $scope.reloadChartData = false;
        $('#jqxWeightChart').jqxChart($scope.weightChartSettings);
        $('#jqxWeightChart').jqxChart('refresh');
      }
    }, 100);
  };

  $scope.consistencyTabClick = function () {
    if ($scope.consistencyTabClickInitialized === false) {
      $scope.consistencyTabClickInitialized = true;
      // Initialize date range picker settings
      commonTrackService.getDatePickerDetails().then(function (settings) {
        $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
      });
    }
    $timeout(function () {

      // load the widget with correct data from the parent widget (current selected parent tab)
      // same behaviour like row click event ,
      if ($scope.parentWidgetData && $scope.parentWidgetData.widget) {
        $scope.reloadConsistencyChartData = false;
        var set = getSetData($scope.parentWidgetData.widget);
        _handleDataUpdate($scope.parentWidgetData.dashboardName, $scope.parentWidgetData.activeTab, set['tab_' + $scope.parentWidgetData.activeTab + '_selectedRow'].value, $scope.parentWidgetData.widget, $scope.activeTab);
      } else {
        // fall back ,  mostly not used
        if (!_serverTimeFormat._tmpStartDate || !_serverTimeFormat._tmpEndDate) {
          var currentState = stateManagerService.getGlobalStateData();
          var _tmpMomentDate = moment(currentState.endDate.value);
          _tmpMomentDate = _tmpMomentDate.subtract({ hours: config.maxHours ? config.maxHours : 2 });
          _serverTimeFormat._tmpStartDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
          _serverTimeFormat._tmpEndDate = currentState.endDate.value;
          $scope.temperatureDetail.date.startDate = moment(_serverTimeFormat._tmpStartDate);
          $scope.temperatureDetail.date.endDate = moment(_serverTimeFormat._tmpEndDate);
        }
        loadThermoOrConsistencyData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, true);
        $('#jqxConsistencyChart1').jqxChart($scope.consistencyChart1Settings);
        $('#jqxConsistencyChart1').jqxChart('hideSerie', 1, 0, NaN);
        $('#jqxConsistencyChart1').jqxChart('refresh');
        $('#jqxConsistencyChartWater').jqxChart($scope.consistencyChartWaterSettings);
        $('#jqxConsistencyChartWater').jqxChart('hideSerie', 1, 0, NaN);
        $('#jqxConsistencyChartWater').jqxChart('refresh');
        $('#jqxConsistencyChartTemperature').jqxChart($scope.consistencyChartTemperatureSettings);
        $('#jqxConsistencyChartTemperature').jqxChart('hideSerie', 1, 0, NaN);
        $('#jqxConsistencyChartTemperature').jqxChart('refresh');
        $('#jqxConsistencyChart2').jqxChart($scope.consistencyChart2Settings);
        $('#jqxConsistencyChart2').jqxChart('hideSerie', 1, 0, NaN);
        $('#jqxConsistencyChart2').jqxChart('refresh');
        $('#jqxConsistencyChart3').jqxChart($scope.consistencyChart3Settings);
        $('#jqxConsistencyChart3').jqxChart('refresh');
      }
    }, 100);
  };

  $scope.inputTabClick = function () {
    _resetConstancyAutoRefresh(); // stop if any existing
    if ($scope.reloadChartData === true) {
      $scope.reloadChartData = false;
      if (!_serverTimeFormat._tmpStartDate || !_serverTimeFormat._tmpEndDate) {
        var currentState = stateManagerService.getGlobalStateData();
        var _tmpMomentDate = moment(currentState.endDate.value);
        _tmpMomentDate = _tmpMomentDate.subtract({ hours: config.maxHours ? config.maxHours : 2 });
        _serverTimeFormat._tmpStartDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
        _serverTimeFormat._tmpEndDate = currentState.endDate.value;
        $scope.temperatureDetail.date.startDate = moment(_serverTimeFormat._tmpStartDate);
        $scope.temperatureDetail.date.endDate = moment(_serverTimeFormat._tmpEndDate);
      }
      loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
    }
    $scope.initInputTab();
  };

  $scope.tempTabClick = function () {
    _resetConstancyAutoRefresh(); // stop if any existing
    if ($scope.reloadChartData === true) {
      $scope.reloadChartData = false;
      if (!_serverTimeFormat._tmpStartDate || !_serverTimeFormat._tmpEndDate) {
        var currentState = stateManagerService.getGlobalStateData();
        var _tmpMomentDate = moment(currentState.endDate.value);
        _tmpMomentDate = _tmpMomentDate.subtract({ hours: config.maxHours ? config.maxHours : 2 });
        _serverTimeFormat._tmpStartDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
        _serverTimeFormat._tmpEndDate = currentState.endDate.value;
        $scope.temperatureDetail.date.startDate = moment(_serverTimeFormat._tmpStartDate);
        $scope.temperatureDetail.date.endDate = moment(_serverTimeFormat._tmpEndDate);
      }
      loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
    }
    if (!$scope.tempRangeInit) {
      $timeout(function () {
        $scope.initTempTab();
        $('#tempRangeselctor').jqxRangeSelector('refresh');
        $scope.tempRangeInit = true;
      }, 0);
    } else {
      $scope.initTempTab();
    }

    $timeout(function () {
      window.$('#temperatureChartContainer').jqxChart('refresh');
    }, 50);
  };

  $scope.$watch('temperatureDetail.date', function () {
    var loadConsistencyData = $scope.activeTab === consistencyTab;
    var initialLoadDone = loadConsistencyData && $scope.consistencyDataLoaded || !loadConsistencyData && $scope.thermoDataLoaded;
    if (initialLoadDone && !$scope.ignoreDateWatch) {
      // trigger the call only after initial loading is done , not before
      $scope.reloadChartData = true;
      $scope.reloadFuelHistory = true;
      $scope.reloadConsistencyChartData = true;
      $scope.temperatureDetail.date.startDate = moment($scope.temperatureDetail.date.startDate);
      $scope.temperatureDetail.date.endDate = moment($scope.temperatureDetail.date.endDate);
      loadThermoOrConsistencyData($scope.getDeviceID(), $scope.temperatureDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss'), $scope.temperatureDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss'), loadConsistencyData);
      loadFuelHistory(config.deviceId, $scope.temperatureDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss'));
    }

    $scope.ignoreDateWatch = false;
  });

  $scope.getDeviceID = function () {

    var currentState = stateManagerService.getGlobalStateData();
    if (currentState && currentState.deviceID) {
      var deviceID = currentState.deviceID.value;
      if (deviceID) {
        //return deviceID;
        $scope.parentWidgetData.deviceID = deviceID;
      }
    }
    //return null;
    if ($scope.parentWidgetData.deviceID) {
      return $scope.parentWidgetData.deviceID;
    } else {
      return null;
    }
  };

  $scope.getDateState = function () {
    var dateO = {};

    var currentState = stateManagerService.getGlobalStateData();

    if (currentState) {
      //dateO.startDate = currentState.startDate.value;
      dateO.endDate = currentState.endDate.value;
      var _tmpMomentDate = moment(currentState.endDate.value);
      _tmpMomentDate = _tmpMomentDate.subtract({ hours: config.maxHours ? config.maxHours : 2 });
      dateO.startDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
    } else {
      return null;
    }

    return dateO;
  };

  $scope.initInputTab = function () {
    $timeout(function () {

      // Initialize date range picker settings
      commonTrackService.getDatePickerDetails().then(function (settings) {
        $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
      });

      // prepare jqxChart settings
      var source = $scope.doorStatusChartSettings.source;
      $scope.doorStatusChartSettings = commonTrackService.getJqxLineChartSettings();
      $scope.doorStatusChartSettings.title = $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusChartTitle');
      $scope.doorStatusChartSettings.xAxis = {
        valuesOnTicks: true,
        dataField: 'time',
        tickMarks: { visilbe: true }
      };
      $scope.doorStatusChartSettings.seriesGroups = [{
        type: 'stepline',
        valueAxis: {
          flip: false,
          title: { text: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusChartY') },
          unitInterval: 1,
          formatFunction: function formatFunction(value) {
            if (value === 0) {
              return $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusYMinValue');
            }
            if (value === 1) {
              return $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusYMaxValue');
            }
          },
          labels: { horizontalAlignment: 'right' }
        },
        series: [{
          dataField: 'din1',
          displayText: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.din1'),
          lineWidth: 1,
          symbolSize: 6,
          toolTipFormatFunction: function toolTipFormatFunction(value, index, valueData, functionObj, xVlaue) {
            var _time = '<div>' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.time') + ':' + ' ' + xVlaue + '</div>';
            if (value === 0) {
              return _time + '<div>' + valueData.displayText + ':' + ' ' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.closed') + '</div>';
            }
            if (value === 1) {
              return _time + '<div>' + valueData.displayText + ':' + ' ' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.open') + '</div>';
            }
          }
        }]
      }];
      $scope.doorStatusChartSettings.source = source;
      //window.$('#doorChartContainer').jqxChart('refresh');
      window.$('#doorChartContainer').jqxChart($scope.doorStatusChartSettings);
      window.$('#doorChartContainer').jqxChart('refresh');
      $scope.inputInit = true;
    }, 0);
  };

  $scope.toggleContent = function (section) {
    switch (section) {
      case 'VehicleInfo':
        $scope.summaryCardData.showVehicleInfoContent = !$scope.summaryCardData.showVehicleInfoContent;
        break;
      case 'VehicleState':
        $scope.summaryCardData.showVehicleStateContent = !$scope.summaryCardData.showVehicleStateContent;
        break;
      case 'CurrentJob':
        $scope.summaryCardData.showCurrentJobContent = !$scope.summaryCardData.showCurrentJobContent;
        break;
      case 'Maintenance':
        $scope.summaryCardData.showMaintenanceContent = !$scope.summaryCardData.showMaintenanceContent;
        break;
    }
  };

  $scope.initSummaryTab = function () {
    _resetConstancyAutoRefresh(); // stop if any existing

    var currentState = stateManagerService.getGlobalStateData();
    if (currentState && currentState.deviceID) {

      var deviceID = currentState.deviceID.value;
      if (!currentState.deviceID.value) {
        var tabHackString = 'tab_0_selectedRow';
        var rowData = currentState[tabHackString];
        if (rowData) {
          deviceID = rowData.value.deviceid;
        }
      }
      $scope.summaryCardData.isloading = true;

      if (deviceID) {
        TempMonitoringService.getSummaryDetails(deviceID).then(function (data) {
          // setup bindings
          $scope.isSummaryAuthed = true;
          if (data.dataList) {
            $scope.summaryData = data.dataList[0];
            $scope.summaryData.isStartTime = $scope.summaryData.starttimestamp > $scope.summaryData.stoptimestamp;

            $scope.summaryCardData.hasCurrentJob = $scope.summaryData.orderid !== '';

            if ($scope.summaryData.datetime === '') {
              $scope.summaryData.datetime = '---';
            }

            if ($scope.summaryData.lasttachodownloadtime === '') {
              $scope.summaryData.lasttachodownloadtime = '---';
            }

            if ($scope.summaryData.workorderstarttime === '') {
              $scope.summaryData.workorderstarttime = '---';
            }

            if ($scope.summaryData.workorderdeparturetime === '') {
              $scope.summaryData.workorderdeparturetime = '---';
            }

            if ($scope.summaryData.workorderarrivaltime === '') {
              $scope.summaryData.workorderarrivaltime = '---';
            }

            if ($scope.summaryData.workorderdischargestarttime === '') {
              $scope.summaryData.workorderdischargestarttime = '---';
            }

            if ($scope.summaryData.workorderdischargeendtime === '') {
              $scope.summaryData.workorderdischargeendtime = '---';
            }

            if ($scope.summaryData.workorderreturntime === '') {
              $scope.summaryData.workorderreturntime = '---';
            }
          }
        }, function () {
          $scope.isSummaryAuthed = false;
        }).finally(function () {
          $scope.summaryCardData.isloading = false;
        });
      }
    }
  };

  $scope.initTempTab = function () {
    _resetConstancyAutoRefresh(); // stop if any existing

    commonTrackService.getDatePickerDetails().then(function (settings) {
      $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
    });
    var _tmpMaxRange = _accountSettings.temperatureUnits === 0 ? 50 : 12;
    var _tmpMinRange = _accountSettings.temperatureUnits === 0 ? 10 : -12.0;
    $scope.rangeSelectorSettings = {
      height: 4,
      min: config.min && config.temperatureUnit === _temperatureUnit ? Number(config.min) : _tmpMinRange,
      max: config.max && config.temperatureUnit === _temperatureUnit ? Number(config.max) : _tmpMaxRange,
      range: $scope.rangeSelection,
      labelsFormatFunction: function labelsFormatFunction(value) {
        return value + _temperatureUnit;
      },

      majorTicksInterval: 2,
      minorTicksInterval: 2,
      markersFormatFunction: function markersFormatFunction(value) {
        return value + _temperatureUnit;
      }
    };

    var source = $scope.tempratursChartHistory.source;
    $scope.tempratursChartHistory = commonTrackService.getJqxLineChartSettings();
    $scope.tempratursChartHistory.title = $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.temperatureHistoryTitle');
    $scope.tempratursChartHistory.xAxis = {
      valuesOnTicks: true,
      dataField: 'time',
      tickMarks: { visilbe: true }
    };
    $scope.tempratursChartHistory.seriesGroups = $scope.tempSeriesGroups;
    $scope.tempratursChartHistory.source = source;

    $timeout(function () {
      window.$('#tempRangeselctor').jqxRangeSelector('refresh');
      window.$('#temperatureChartContainer').jqxChart('refresh');
    }, 100);
    $scope.tempInit = true;
    $scope.tempDataLoadingFinished = true;
  };

  var getLastWeekRange = function getLastWeekRange(endDate) {
    var startDate = moment(endDate, 'YYYY/MM/DD/HH:mm:ss').subtract(6, 'd');
    startDate = startDate.startOf('day').format('YYYY/MM/DD/HH:mm:ss');
    endDate = moment(endDate, 'YYYY/MM/DD/HH:mm:ss').endOf('day').format('YYYY/MM/DD/HH:mm:ss');

    var range = {
      startDate: startDate,
      endDate: endDate
    };
    return range;
  };

  $scope.showDailyDistanceReport = function () {
    var deviceID = $scope.getDeviceID();
    var dateO = $scope.getDateState();
    var endDate = dateO ? dateO.endDate : _serverTimeFormat._tmpEndDate;
    // Get fuel history for the last 7 days (including today)
    var range = getLastWeekRange(endDate);

    $state.go('reports.vehicleDetail', {
      'reportName': 'DailyDistanceDetail',
      'vehicleId': deviceID,
      'dateFrom': range.startDate,
      'dateTo': range.endDate,
      'hasCustomDateRange': true
    });
  };

  var dataStateUpdateListener = $scope.$on('dataStateUpdate', function (event, data) {

    // summary tab open
    var set;
    // save the parent widget details in order to user it latter when switcing the tab .
    $scope.parentWidgetData.dashboardName = data.dashboardName;
    $scope.parentWidgetData.widget = data.widget;
    $scope.parentWidgetData.activeTab = data.activeTab;

    if ($scope.activeTab === 0) {
      $scope.initSummaryTab();
      $scope.reloadChartData = true;
      $scope.reloadFuelHistory = true;
      $scope.reloadConsistencyChartData = true;
    } else if ($scope.activeTab === 5) {

      // if the auto refresh running and no user row cick detected skip those evenets from the vehicleList grid
      if ($scope.consitancytab.hasAutoRefresh && !data.rowSelectOriginalEvent) {
        return;
      }
      // if row select is from the user then reset he checkbox and refresh count
      _resetConstancyAutoRefresh();

      if ($scope.isWidgetPostInitFinished) {
        set = getSetData(data.widget);
        _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
      }
    } else {
      if ($scope.isWidgetPostInitFinished) {
        set = getSetData(data.widget);
        _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
      } else {
        //console.log('Ignoring dataState update from widget: ' + data.widget);
      }
    }
  });

  // Uncheck the auto Refresh check box and stop any running auto refresh
  function _resetConstancyAutoRefresh() {
    $scope.consitancytab.hasAutoRefresh = 0;
    $scope.stopConsistancyAutoRefresh();
    $scope.consistancyConter = consistancyRefreshIntervalValue;
  }

  var getSetData = function getSetData(widget) {
    var loginID = AuthenticationService.GetLoginID();
    widget = loginID.Account + '_' + loginID.username + '_' + widget;
    var stateData = stateManagerService.getStateData();
    var set = stateData && stateData[widget] ? stateData[widget] : {};
    return set;
  };

  function _intRequestData(event, data, currentActiveTab) {

    if (data.selectedRow !== null && data.selectedRow !== undefined || event && event.name && event.name === 'ordersRowSelected') {
      var _tmpMomentDate;
      if (data.selectedRow && !data.startDate && !data.endDate) {
        var _tmpTimeArray = data.selectedRow.time.split(':');
        if (data.selectedRow.date.indexOf('/') > -1) {
          _tmpMomentDate = moment(data.selectedRow.date, 'DD/MM/YYYY');
        } else {
          _tmpMomentDate = moment(data.selectedRow.date);
        }
        _tmpMomentDate.set({
          hour: Number(_tmpTimeArray[0]),
          minute: Number(_tmpTimeArray[1]),
          second: Number(_tmpTimeArray[2])
        });
        _tmpMomentDate.subtract({ hours: config.maxHours });
      }

      _serverTimeFormat._tmpEndDate = event && event.name && event.name === 'ordersRowSelected' && data.endDate ? data.endDate : commonTrackService.formatReportDateTime(data.selectedRow.date, data.selectedRow.time);
      _serverTimeFormat._tmpStartDate = event && event.name && event.name === 'ordersRowSelected' && data.startDate ? data.startDate : _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
      $scope.doorStatusChartSettings.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
      $scope.tempratursChartHistory.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
      //$scope.consistencyChart1Settings.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
      //$scope.consistencyChartWaterSettings.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
      if (data.selectedRow && data.selectedRow.deviceid || event && event.name && event.name === 'ordersRowSelected' && data.repoVehicle) {
        config.deviceId = event && event.name && event.name === 'ordersRowSelected' && data.repoVehicle ? data.repoVehicle : data.selectedRow.deviceid;
        $scope.parentWidgetData.deviceID = config.deviceId;
        $scope.temperatureDetail = {
          date: {
            startDate: new Date(_serverTimeFormat._tmpStartDate),
            endDate: new Date(_serverTimeFormat._tmpEndDate)
          }
        };
        if (currentActiveTab !== undefined) {
          switch (currentActiveTab) {
            case 4:
              loadFuelHistory(config.deviceId, _serverTimeFormat._tmpStartDate);
              loadThermoOrConsistencyData(config.deviceId, _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, $scope.activeTab === consistencyTab);
              break;
            case 5:
              loadThermoOrConsistencyData(config.deviceId, _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, $scope.activeTab === consistencyTab);
              break;
          }
        } else {
          loadThermoOrConsistencyData(config.deviceId, _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, $scope.activeTab === consistencyTab);
          loadFuelHistory(config.deviceId, _serverTimeFormat._tmpStartDate);
        }
      }
    }
  }

  function tempratureToolTipfomat(value, index, valueData, functionObj, xVlaue) {
    var _time = '<div>' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.time') + ':' + ' ' + xVlaue + '</div>';
    return _time + '<div>' + valueData.displayText + ':' + ' ' + value + _temperatureUnit + '</div>';
  }

  var loadThermoData = function loadThermoData(deviceId, startDate, endDate) {
    loadThermoOrConsistencyData(deviceId, startDate, endDate, false);
  };

  var colorWhiteHex1 = '#ffffff';
  var colorWhiteHex2 = '#FFFFFF';

  var loadThermoOrConsistencyData = function loadThermoOrConsistencyData(deviceId, startDate, endDate, loadConsistencyData) {
    $scope.isDataNotAvailable = false;
    $scope.isNotSummaryChartsAuthorized = false;
    $scope.thermoDataLoading = true;
    $scope.thermoDataLoaded = false;
    $scope.consistencyDataLoaded = false;
    if (deviceId) {
      TempMonitoringService.getThermoEventDatalList(deviceId, startDate, endDate, loadConsistencyData).then(function (data) {
        var _tmpData = data.dataList;
        if (loadConsistencyData) {
          $('#jqxConsistencyLegend').empty();
          $scope.consistencyDataLoaded = true;
        } else {
          $scope.thermoDataLoaded = true;
        }
        var series = [];
        // SCL-4331: handle job status transitions
        var previousJobStatus = '';
        var timeBands = [];
        var bandLegends = new Map();
        // LOADING_START, DISCHARGE_START, DISCHARGE_STOP, JOB_RETURN, JOB_BACK, MIXERDRUM_TURNRIGHT
        // JOB_BS_DRIVE, JOB_START, JOB_ARRIVE, JOB_DEPART, INPUT_ON_00, INPUT_OFF_00
        var allowedStatusCodeLegends = new Array(4097, 4101, 4102, 4103, 4104, 4112, 4113, 61831, 61973, 62005, 62496, 62528);

        // jqx chart data accepts only nmbers so change 'On|Off' to '1|0' && Thermo values to float .
        for (var i = 0; i < _tmpData.length; i++) {
          _tmpData[i].timeindex = i;
          if (_tmpData[i].din1 === 'Aus' || _tmpData[i].din1 === 'Off' || _tmpData[i].din1 === $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorClose')) {
            _tmpData[i].din1 = 0;
          }
          if (_tmpData[i].din1 === 'An' || _tmpData[i].din1 === 'On' || _tmpData[i].din1 === $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorOpen')) {
            _tmpData[i].din1 = 1;
          }

          if (!loadConsistencyData) {
            for (var j = 1; j <= 8; j++) {

              if (_tmpData[i]['thermo' + j].indexOf('F') !== -1) {
                _tmpData[i]['thermo' + j] = _tmpData[i]['thermo' + j].replace('F', '');
              }
              if (_tmpData[i]['thermo' + j].indexOf('C') !== -1) {
                _tmpData[i]['thermo' + j] = _tmpData[i]['thermo' + j].replace('C', '');
              }
              if (_tmpData[i]['thermo' + j] === '--') {
                _tmpData[i]['thermo' + j] = null;
              }
            }
          }

          if (loadConsistencyData && _tmpData[i].jobstatusdesc) {
            if (_tmpData[i].jobstatusdesc !== previousJobStatus && allowedStatusCodeLegends.includes(_tmpData[i].jobstatuscode)) {
              var linecolor = 'black';
              // Use the background or foreground color if it is not white (colorWhiteHex1 or colorWhiteHex2)
              if (_tmpData[i].jobstatusdescBgColor && _tmpData[i].jobstatusdescBgColor !== colorWhiteHex1 && _tmpData[i].jobstatusdescBgColor !== colorWhiteHex2) {
                linecolor = _tmpData[i].jobstatusdescBgColor;
              } else if (_tmpData[i].jobstatusdescColor && _tmpData[i].jobstatusdescColor !== colorWhiteHex1 && _tmpData[i].jobstatusdescColor !== colorWhiteHex2) {
                linecolor = _tmpData[i].jobstatusdescColor;
              }
              timeBands.push({ minValue: _tmpData[i].timeindex, maxValue: _tmpData[i].timeindex + 0.1, fillColor: linecolor, lineWidth: 2, opacity: 1 });
              bandLegends.set(_tmpData[i].jobstatusdesc, linecolor);
              previousJobStatus = _tmpData[i].jobstatusdesc;
            }
          }
        }

        for (var noOfSeries = 1; noOfSeries <= 8; noOfSeries++) {
          series.push({
            dataField: 'thermo' + noOfSeries,
            displayText: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.thermo' + noOfSeries),
            lineWidth: 1,
            symbolSize: 6,
            toolTipFormatFunction: tempratureToolTipfomat
          });
        }
        //_temperatureUnit = '\xB0F'; //  used fot testing below values .
        var _localStorageTempRange = TempMonitoringService.getTemperatureRangeValue();
        _localStorageTempRange = _accountSettings.temperatureUnits === 0 ? _localStorageTempRange.f : _localStorageTempRange.c;

        var tempMinRange = _accountSettings && _accountSettings.temperatureUnits === 0 ? 10 : -12.0;
        var tempMaxRange = _accountSettings && _accountSettings.temperatureUnits === 0 ? 50 : 10.0;
        var unitInterval = _accountSettings && _accountSettings.temperatureUnits === 0 ? 5 : 2;

        if (config.max && !_localStorageTempRange || _localStorageTempRange && _localStorageTempRange.to && config.max !== _localStorageTempRange.to || config.min && !_localStorageTempRange || _localStorageTempRange && _localStorageTempRange.from && config.min !== _localStorageTempRange.from) {
          var _from = _localStorageTempRange && _localStorageTempRange.from >= Number(config.min) ? _localStorageTempRange.from : Number(config.min);
          var _to = _localStorageTempRange && _localStorageTempRange.to <= Number(config.max) ? _localStorageTempRange.to : Number(config.max);
          if (_from < _to) {
            $scope.rangeSelection.from = _from;
            $scope.rangeSelection.to = _to;
          } else {
            $scope.rangeSelection.from = tempMinRange;
            $scope.rangeSelection.to = tempMaxRange;
          }
        } else {
          $scope.rangeSelection.from = _localStorageTempRange ? _localStorageTempRange.from : tempMinRange;
          $scope.rangeSelection.to = _localStorageTempRange ? _localStorageTempRange.to : tempMaxRange;
        }

        var rangeValue = TempMonitoringService.getTemperatureRangeValue();
        if (rangeValue) {
          if (rangeValue.c) {
            tempMinRange = rangeValue.c.from;
            tempMaxRange = rangeValue.c.to;
          } else if (rangeValue.f) {
            tempMinRange = rangeValue.f.from;
            tempMaxRange = rangeValue.f.to;
          }
          //
          if (tempMinRange < Number(config.min)) {
            tempMinRange = Number(config.min);
          }

          if (tempMaxRange > Number(config.max)) {
            tempMaxRange = Number(config.max);
          }
        }
        $scope.tempratursChartHistory.title = $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.temperatureHistoryTitle');
        $scope.tempratursChartHistory.seriesGroups = [{
          type: 'line',
          valueAxis: {
            flip: false,
            title: { text: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.temperatureHistoryYAxis') },
            unitInterval: unitInterval,
            minValue: config.min && config.temperatureUnit === _temperatureUnit && !rangeValue ? Number(config.min) : tempMinRange, // if temperature unit  is 'F'  min range  value 10 | 12.2
            maxValue: config.max && config.temperatureUnit === _temperatureUnit && !rangeValue ? Number(config.max) : tempMaxRange, // if temperature unit is 'F' max range value 50 |10.0
            formatFunction: function formatFunction(value) {
              return value + _temperatureUnit;
            },
            labels: {
              horizontalAlignment: 'right'
            }
          },
          series: series
        }];

        if (loadConsistencyData) {
          [$scope.consistencyChart1Settings, $scope.consistencyChartWaterSettings, $scope.consistencyChartTemperatureSettings, $scope.consistencyChart2Settings, $scope.consistencyChart3Settings].forEach(function (settings) {
            settings.source = _tmpData;
            settings.xAxis.bands = timeBands;
          });
          $scope.consistencyDataSource = _tmpData;

          // SCL-4331: render job-status legends
          bandLegends.forEach(function (statusColour, statusText) {
            var legendItem = '<div style ="float: left;padding-left:10px;"><span style="background-color:' + statusColour + ';width:1.0rem;height:1.0rem;display: inline-block;"></span><span class="jqx-chart-legend-text" style ="padding-left:5px;">' + statusText + '</span></div>';
            $('#jqxConsistencyLegend').append(legendItem);
          });

          //Bugfix 106911/109006/108934
          //Set the min and the max for Water flow chart axes (both axis on the left and the right)
          var minWaterinputconverted = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.waterinputconverted;
          }));
          var maxWaterinputconverted = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.waterinputconverted;
          }));
          var waterInputconvertedPercent = (maxWaterinputconverted - minWaterinputconverted) * (5 / 100);
          if (minWaterinputconverted === maxWaterinputconverted && maxWaterinputconverted !== 0) {
            if (maxWaterinputconverted > 0) {
              waterInputconvertedPercent = maxWaterinputconverted * 0.5;
            } else {
              waterInputconvertedPercent = maxWaterinputconverted * -0.5;
            }
          }
          $scope.consistencyChartWaterSettings.seriesGroups[0].valueAxis.minValue = minWaterinputconverted - waterInputconvertedPercent;
          $scope.consistencyChartWaterSettings.seriesGroups[0].valueAxis.maxValue = maxWaterinputconverted + waterInputconvertedPercent;

          var minWaterinputraw = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.waterinputraw;
          }));
          var maxWaterinputraw = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.waterinputraw;
          }));
          var waterInputrawPercent = (maxWaterinputraw - minWaterinputraw) * (5 / 100);
          if (minWaterinputraw === maxWaterinputraw && maxWaterinputraw !== 0) {
            if (maxWaterinputraw > 0) {
              waterInputrawPercent = maxWaterinputraw * 0.5;
            } else {
              waterInputrawPercent = maxWaterinputraw * -0.5;
            }
          }
          $scope.consistencyChartWaterSettings.seriesGroups[1].valueAxis.minValue = minWaterinputraw - waterInputrawPercent;
          $scope.consistencyChartWaterSettings.seriesGroups[1].valueAxis.maxValue = maxWaterinputraw + waterInputrawPercent;

          //Set the min and the max for drum chart axes (both axis on the left and the right)
          var minCargoRotation = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.cargorotation;
          }));
          var maxCargoRotation = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.cargorotation;
          }));
          var cargoRotationPercent = (maxCargoRotation - minCargoRotation) * (5 / 100);
          if (minCargoRotation === maxCargoRotation && maxCargoRotation !== 0) {
            if (maxCargoRotation > 0) {
              cargoRotationPercent = maxCargoRotation * 0.5;
            } else {
              cargoRotationPercent = maxCargoRotation * -0.5;
            }
          }
          $scope.consistencyChart2Settings.seriesGroups[0].valueAxis.minValue = minCargoRotation - cargoRotationPercent;
          $scope.consistencyChart2Settings.seriesGroups[0].valueAxis.maxValue = maxCargoRotation + cargoRotationPercent;

          var minEnginerpm = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.enginerpm;
          }));
          var maxEnginerpm = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.enginerpm;
          }));
          var engineRpmPercent = (maxEnginerpm - minEnginerpm) * (5 / 100);
          if (minEnginerpm === maxEnginerpm && maxEnginerpm !== 0) {
            if (maxEnginerpm > 0) {
              engineRpmPercent = maxEnginerpm * 0.5;
            } else {
              engineRpmPercent = maxEnginerpm * -0.5;
            }
          }
          $scope.consistencyChart2Settings.seriesGroups[1].valueAxis.minValue = minEnginerpm - engineRpmPercent;
          $scope.consistencyChart2Settings.seriesGroups[1].valueAxis.maxValue = maxEnginerpm + engineRpmPercent;

          //Set the min and the max for oil input axes (both axis on the left and the right)
          var minOilinputconverted = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.oilinputconverted;
          }));
          var maxOilinputconverted = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.oilinputconverted;
          }));
          var oilInputConvertedPercent = (maxOilinputconverted - minOilinputconverted) * (5 / 100);
          if (maxOilinputconverted === minOilinputconverted && maxOilinputconverted !== 0) {
            if (maxOilinputconverted > 0) {
              oilInputConvertedPercent = maxOilinputconverted * 0.5;
            } else {
              oilInputConvertedPercent = maxOilinputconverted * -0.5;
            }
          }
          $scope.consistencyChart1Settings.seriesGroups[0].valueAxis.minValue = minOilinputconverted - oilInputConvertedPercent;
          $scope.consistencyChart1Settings.seriesGroups[0].valueAxis.maxValue = maxOilinputconverted + oilInputConvertedPercent;

          var minOilinputraw = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.oilinputraw;
          }));
          var maxOilinputraw = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.oilinputraw;
          }));
          var oilInputRawPercent = (maxOilinputraw - minOilinputraw) * (5 / 100);
          if (maxOilinputraw === minOilinputraw && maxOilinputraw !== 0) {
            if (maxOilinputraw > 0) {
              oilInputRawPercent = maxOilinputraw * 0.5;
            } else {
              oilInputRawPercent = maxOilinputraw * -0.5;
            }
          }
          $scope.consistencyChart1Settings.seriesGroups[1].valueAxis.minValue = minOilinputraw - oilInputRawPercent;
          $scope.consistencyChart1Settings.seriesGroups[1].valueAxis.maxValue = maxOilinputraw + oilInputRawPercent;

          //Set the min and the max for hydraulic oil temperature input axes (both axis on the left and the right)
          var minHydraulicTemperatureconverted = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.hydraulicoiltemperatureinputconverted;
          }));
          var maxHydraulicTemperatureconverted = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.hydraulicoiltemperatureinputconverted;
          }));
          var hydraulicTemperatureconvertedPercent = (maxHydraulicTemperatureconverted - minHydraulicTemperatureconverted) * (5 / 100);
          if (minHydraulicTemperatureconverted === maxHydraulicTemperatureconverted && maxHydraulicTemperatureconverted !== 0) {
            if (maxHydraulicTemperatureconverted > 0) {
              hydraulicTemperatureconvertedPercent = maxHydraulicTemperatureconverted * 0.5;
            } else {
              hydraulicTemperatureconvertedPercent = maxHydraulicTemperatureconverted * -0.5;
            }
          }
          $scope.consistencyChartTemperatureSettings.seriesGroups[0].valueAxis.minValue = minHydraulicTemperatureconverted - hydraulicTemperatureconvertedPercent;
          $scope.consistencyChartTemperatureSettings.seriesGroups[0].valueAxis.maxValue = maxHydraulicTemperatureconverted + hydraulicTemperatureconvertedPercent;

          var minHydraulicTemperatureRaw = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.hydraulicoiltemperatureinputraw;
          }));
          var maxHydraulicTemperatureRaw = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.hydraulicoiltemperatureinputraw;
          }));
          var hydraulicTemperaturePercent = (maxHydraulicTemperatureRaw - minHydraulicTemperatureRaw) * (5 / 100);
          if (minHydraulicTemperatureRaw === maxHydraulicTemperatureRaw && maxHydraulicTemperatureRaw !== 0) {
            if (maxHydraulicTemperatureRaw > 0) {
              hydraulicTemperaturePercent = maxHydraulicTemperatureRaw * 0.5;
            } else {
              hydraulicTemperaturePercent = maxHydraulicTemperatureRaw * -0.5;
            }
          }
          $scope.consistencyChartTemperatureSettings.seriesGroups[1].valueAxis.minValue = minHydraulicTemperatureRaw - hydraulicTemperaturePercent;
          $scope.consistencyChartTemperatureSettings.seriesGroups[1].valueAxis.maxValue = maxHydraulicTemperatureRaw + hydraulicTemperaturePercent;

          //Set the min and the max for ambient temp axes (both axis on the left and the right)
          var minAmbienttemp = Math.min.apply(Math, _tmpData.map(function (o) {
            return o.ambienttemp ? o.ambienttemp.replace(/[A-Za-z]/g, '') : Infinity;
          }));
          var maxAmbienttemp = Math.max.apply(Math, _tmpData.map(function (o) {
            return o.ambienttemp ? o.ambienttemp.replace(/[A-Za-z]/g, '') : -Infinity;
          }));
          if (minAmbienttemp !== Infinity && maxAmbienttemp !== -Infinity) {
            var ambientTempPercent = (maxAmbienttemp - minAmbienttemp) * (5 / 100);
            if (minAmbienttemp === maxAmbienttemp && maxAmbienttemp !== 0) {
              if (maxAmbienttemp > 0) {
                ambientTempPercent = maxAmbienttemp * 0.5;
              } else {
                ambientTempPercent = maxAmbienttemp * -0.5;
              }
            }
            $scope.consistencyChart3Settings.valueAxis.minValue = minAmbienttemp - ambientTempPercent;
            $scope.consistencyChart3Settings.valueAxis.maxValue = maxAmbienttemp + ambientTempPercent;
          }
        } else {
          $scope.tempSeriesGroups = $scope.tempratursChartHistory.seriesGroups;
          $scope.thermoDataSource = _tmpData;
          $scope.doorStatusChartSettings.source = _tmpData;
          $scope.tempratursChartHistory.source = _tmpData;
          $scope.weightChartSettings.source = _tmpData;
          $scope.fuelChartSettings.source = _tmpData;

          if (!$scope.thermoDataAdapter) {
            $scope.thermoDataAdapter = new $.jqx.dataAdapter($scope.thermoDataSource, { autoBind: true });
          }
        }
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isNotSummaryChartsAuthorized = true;
        }
      }).finally(function () {
        $scope.thermoDataLoading = false;
        $scope.dataLoadingFinished = true;
        $scope.tempDataLoadingFinished = true;
        $timeout(function () {

          $scope.ignoreDateWatch = true;
          $scope.temperatureDetail.date = {
            startDate: moment(startDate),
            endDate: moment(endDate)
          };
          var description = moment(startDate).format('YYYY/MM/DD/HH:mm:ss') + ' - ' + moment(endDate).format('YYYY/MM/DD/HH:mm:ss');

          if (loadConsistencyData) {
            $scope.consistencyChart1Settings.description = description;
            $scope.consistencyChartWaterSettings.description = description;
            $scope.consistencyChartTemperatureSettings.description = description;
            $('#jqxConsistencyChart1').jqxChart($scope.consistencyChart1Settings);
            $('#jqxConsistencyChartWater').jqxChart($scope.consistencyChartWaterSettings);
            $('#jqxConsistencyChartTemperature').jqxChart($scope.consistencyChartTemperatureSettings);
            $('#jqxConsistencyChart2').jqxChart($scope.consistencyChart2Settings);
            $('#jqxConsistencyChart3').jqxChart($scope.consistencyChart3Settings);
          } else {
            $scope.weightChartSettings.description = description;
            $scope.fuelChartSettings.description = description;
            $('#jqxWeightChart').jqxChart($scope.weightChartSettings);
            $('#jqxFuelChart').jqxChart($scope.fuelChartSettings);

            if ($scope.inputInit) {
              $('#doorChartContainer').jqxChart({ description: description });
              $('#doorChartContainer').jqxChart('refresh');
            }

            if ($scope.tempInit) {
              $('#temperatureChartContainer').jqxChart({ description: description });
              $('#temperatureChartContainer').jqxChart($scope.tempratursChartHistory);
            }
          }
        }, 0, false);
      });
    }
  };

  var loadFuelHistory = function loadFuelHistory(deviceId, endDate) {
    $scope.isFuelHistoryNotAvailable = false;
    $scope.isNotFuelSummaryAuthorized = false;
    $scope.fuelHistoryLoading = true;
    $scope.fuelHistoryLoaded = false;
    if (deviceId) {
      // Get fuel history for the last 7 days (including today)
      var range = getLastWeekRange(endDate);

      TempMonitoringService.getFuelHistory(deviceId, range.startDate, range.endDate).then(function (data) {
        var _tmpData = data.dataList;
        if (_tmpData && _tmpData.length > 7) {
          // Remove row with total values
          _tmpData = _tmpData.slice(0, 7);

          // Bug 106396 fix: ensure that all values are set
          for (var i = 0; i < _tmpData.length; i++) {
            _tmpData[i].date = moment(_tmpData[i].date, 'DD/MM/YYYY').format('YYYY-MM-DD');
          }
        }
        $scope.fuelHistoryLoaded = true;

        var description = moment(range.startDate).format('YYYY/MM/DD') + ' - ' + moment(range.endDate).format('YYYY/MM/DD');
        $scope.fuelChart2Settings.source = _tmpData;
        $scope.fuelChart2Settings.description = description;
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isNotFuelSummaryAuthorized = true;
        }
      }).finally(function () {
        $scope.fuelHistoryLoading = false;
        $('#jqxFuelChart2').jqxChart($scope.fuelChart2Settings);
        $('#jqxFuelChart2').jqxChart('refresh');
      });
    }
  };

  $timeout(function () {
    if (TempMonitoringService.getRowEventStatus()) {
      if ($scope.doorStatusChartSettings.seriesGroups.length === 0 || $scope.tempratursChartHistory.seriesGroups.length === 0) {
        var _vehilceLastLocationData = commonTrackService.getsetLastLocatioWidgetData();

        if (_vehilceLastLocationData && _vehilceLastLocationData.selectedRow && _vehilceLastLocationData.selectedRow.deviceid) {
          _intRequestData(undefined, _vehilceLastLocationData);
        }
      }
    }
  }, 100);

  $timeout(function () {
    $scope.$on('tempRangeChange', function () {
      if ($scope.tempDataLoadingFinished && $scope.tempratursChartHistory.seriesGroups) {
        var rangeValue = $('#tempRangeselctor').jqxRangeSelector('getRange');
        $scope.tempratursChartHistory.seriesGroups[0].valueAxis.minValue = rangeValue.from;
        $scope.tempratursChartHistory.seriesGroups[0].valueAxis.maxValue = rangeValue.to;
        TempMonitoringService.saveTempRangeValues(rangeValue, _accountSettings.temperatureUnits);
        $('#temperatureChartContainer').jqxChart('refresh');
      }
    });
  }, 50);

  var maxGetInitialDataRetries = 30;
  var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
    if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
      currentParentRowResEvent();
      return;
    }
    //console.info('Temperature Widget Requesting Parent for Data ..');
    --maxGetInitialDataRetries;
    var set = getSetData(data.widget);
    var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];

    // parents First tab must always retrun a  valid selected row
    if (data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value) || data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues)) {
      $scope.isWidgetPreInitFinished = true;
      $scope.isWidgetPostInitFinished = true;

      // save the parent widget details in order to user it latter when switcing the tab .
      $scope.parentWidgetData.dashboardName = data.dashboardName;
      $scope.parentWidgetData.widget = data.widget;
      $scope.parentWidgetData.activeTab = data.activeTab;

      _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);
    } else {
      // Repeatedly try to get the data from parent .
      if (maxGetInitialDataRetries > 0) {
        $timeout(function () {
          if (!$scope.isWidgetPostInitFinished) {
            $rootScope.$broadcast('reqDataUpdate');
          }
        }, 100);
      } else {
        console.warn('Max Retries exceeded to get the current Parent data for Temperature Monitoring Widget..');
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;
        $scope.isDataNotAvailable = true;
        currentParentRowResEvent();
      }
    }
  });

  function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName, currentActiveTab) {
    // if tab clicked same method is called with currect active tab numer
    var set;

    switch (dashboardName) {
      case 'dashboard.vehicleList':
      case 'dashboard.driverWrkHrsDashboard': // contains only tab 0
      case 'dashboard.tachohistory':
        // contains only tab 0
        switch (tabNumber) {
          case 1:
            if (!_.isEmpty(rowData)) {
              _intRequestData({ name: 'ordersRowSelected' }, {
                selectedRow: rowData, 'startDate': commonTrackService.formatReportDateTime(rowData.workorderstartdate, rowData.workorderstarttime, false),
                'endDate': commonTrackService.formatReportDateTime(rowData.workorderenddate, rowData.workorderendtime, false)
              }, currentActiveTab);
            } else {
              $scope.isDataNotAvailable = true;
            }
            break;
          case 0: // all tabs uses first tab master data to load the Temperature Values
          case 2:
          case 3:
            set = getSetData(widgetName);
            if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
              rowData = set['tab_' + 0 + '_selectedRow'].value;
              _intRequestData({}, { selectedRow: rowData }, currentActiveTab);
            }
            break;
        }
        break;
      case 'dashboard.fmsDashboard':
        switch (tabNumber) {
          case 0:
          case 1:
            _intRequestData({}, { selectedRow: rowData }, currentActiveTab);
            break;
          case 2:
            set = getSetData(widgetName);
            if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
              rowData = set['tab_' + 0 + '_selectedRow'].value;
              _intRequestData({}, { selectedRow: rowData }, currentActiveTab);
            }
            break;
        }
        break;
    }
  }

  $timeout(function () {
    $scope.initSummaryTab();
  }, 0);

  // consistancy Auto Refresh

  var consitancyCounteInterval = null;
  var consistancyRefreshIntervalValue = 10; // 10s
  // counter to display in UI
  $scope.consistancyConter = consistancyRefreshIntervalValue; // initialize the counter

  // staart constancy auto refresh
  $scope.startConsistancyAutoRefresh = function () {

    $scope.stopConsistancyAutoRefresh();

    if ($scope.consistancyConter - 1 >= 1) {
      $scope.consistancyConter--;
      consitancyCounteInterval = $interval($scope.startConsistancyAutoRefresh, 1000);
    } else {
      // reached 10s stop any auto refresh and call the data from server
      $scope.stopConsistancyAutoRefresh();
      _reloadConsitancyChartForAutoRefresh();
      // start the next 10s refresh cycle
      $scope.consistancyConter = consistancyRefreshIntervalValue;
      consitancyCounteInterval = $interval($scope.startConsistancyAutoRefresh, 1000);
    }
  };

  // call constancy reports for last fifteen minutes and start the refresh cycle again
  function _reloadConsitancyChartForAutoRefresh() {
    var currentTime = new Date();
    var accountTimeZone = $scope.accountSettings && $scope.accountSettings.timeZone ? $scope.accountSettings.timeZone : 'Europe/Berlin';
    var accountTimeString = currentTime.toLocaleString('en-US', { timeZone: accountTimeZone });
    var accountDate = new Date(accountTimeString);

    var currentMoment = moment(accountDate);
    $scope.temperatureDetail.date.endDate = currentMoment.clone().format('YYYY/MM/DD/HH:mm:ss');
    $scope.temperatureDetail.date.startDate = currentMoment.clone().subtract(15, 'minutes').format('YYYY/MM/DD/HH:mm:ss');

    if (config.deviceId || $scope.parentWidgetData.deviceID) {
      $scope.reloadChartData = true;
      $scope.reloadConsistencyChartData = true;
      var loadConsistencyData = $scope.activeTab === consistencyTab;
      loadThermoOrConsistencyData(config.deviceId || $scope.parentWidgetData.deviceID, $scope.temperatureDetail.date.startDate, $scope.temperatureDetail.date.endDate, loadConsistencyData);
    }
  }

  // stop auto refresh cancel any refrency of exiting intervals
  $scope.stopConsistancyAutoRefresh = function () {
    $interval.cancel(consitancyCounteInterval);
  };

  // when user modifies the checkbox , method will be executed
  $scope.consistanceAutoUpdateCheckBoxChange = function (isAutoRefreshChecked) {

    // if checked start the auto refresh , else stop any existing
    if (isAutoRefreshChecked) {
      _reloadConsitancyChartForAutoRefresh(); // for intial loading
      $scope.consistancyConter = consistancyRefreshIntervalValue;
      $scope.startConsistancyAutoRefresh();
    } else {
      $scope.consistancyConter = consistancyRefreshIntervalValue;
      $scope.stopConsistancyAutoRefresh();
    }
  };

  // watch the accodion open /close state
  $scope.$watch('consitancytab.isAmbientTempChartOpen', function () {
    if (!$scope.thermoDataLoading) {
      accordionStateChanged();
    }
  });
  // watch the accodion open /close state
  $scope.$watch('consitancytab.isConsistancyChartOpen', function () {
    if (!$scope.thermoDataLoading) {
      accordionStateChanged();
    }
  });
  // watch the accodion open /close state
  $scope.$watch('consitancytab.isDrumRpmChartOpen', function () {
    if (!$scope.thermoDataLoading) {
      accordionStateChanged();
    }
  });
  // watch the accodion open /close state
  $scope.$watch('consitancytab.isConsistencyChartWaterOpen', function () {
    if (!$scope.thermoDataLoading) {
      accordionStateChanged();
    }
  });
  // watch the accodion open /close state
  $scope.$watch('consitancytab.isConsistencyChartTemperatureOpen', function () {
    if (!$scope.thermoDataLoading) {
      accordionStateChanged();
    }
  });

  /**
   * determines the no of open and closed accordions ,
   *
   * calculates heights for each chart based on no of open accordions.
   *
   */
  function accordionStateChanged() {

    var noOdAccordionOpen = 0;
    var defaultHeight = 300;
    var totalHeightOfallAccordion = 1200;
    var heightForEachOpenedAccordion;
    var openedAccordionHeightExpression = [];
    var existingAccordionHeightExpress = ['ambientTempChartHeight', 'consistancyChartHeight', 'drumRpmChartHeight', 'consistencyChartWaterHeight', 'consistencyChartTemperatureHeight'];

    // find the nof open accordions
    if ($scope.consitancytab.isAmbientTempChartOpen) {
      noOdAccordionOpen++;
      openedAccordionHeightExpression.push('ambientTempChartHeight');
    }
    if ($scope.consitancytab.isConsistancyChartOpen) {
      noOdAccordionOpen++;
      openedAccordionHeightExpression.push('consistancyChartHeight');
    }
    if ($scope.consitancytab.isDrumRpmChartOpen) {
      noOdAccordionOpen++;
      openedAccordionHeightExpression.push('drumRpmChartHeight');
    }
    if ($scope.consitancytab.isConsistencyChartWaterOpen) {
      noOdAccordionOpen++;
      openedAccordionHeightExpression.push('consistencyChartWaterHeight');
    }
    if ($scope.consitancytab.isConsistencyChartTemperatureOpen) {
      noOdAccordionOpen++;
      openedAccordionHeightExpression.push('consistencyChartTemperatureHeight');
    }

    // calculate height for each opned accordion charts
    if (noOdAccordionOpen > 0) {
      heightForEachOpenedAccordion = totalHeightOfallAccordion / noOdAccordionOpen;
      // default to max allowed value to  600 px
      heightForEachOpenedAccordion = heightForEachOpenedAccordion > 600 ? 600 : heightForEachOpenedAccordion;
    }

    if (openedAccordionHeightExpression.length > 0) {

      var closedAccordions = existingAccordionHeightExpress.filter(function (e) {
        return !openedAccordionHeightExpression.includes(e);
      });

      // set default height for the closed accordions
      for (var closedTmp = 0; closedTmp < closedAccordions.length; closedTmp++) {
        $scope.consitancytab[closedAccordions[closedTmp]] = defaultHeight + 'px';
      }

      // adopt the height of opened accordions
      for (var tmpi = 0; tmpi < openedAccordionHeightExpression.length; tmpi++) {
        switch (openedAccordionHeightExpression[tmpi]) {
          case 'ambientTempChartHeight':
            $scope.consitancytab.ambientTempChartHeight = heightForEachOpenedAccordion + 'px';
            _refreshChartDomAfterSettingHeight('jqxConsistencyChart3');
            break;
          case 'consistancyChartHeight':
            $scope.consitancytab.consistancyChartHeight = heightForEachOpenedAccordion + 'px';
            _refreshChartDomAfterSettingHeight('jqxConsistencyChart1');
            break;
          case 'drumRpmChartHeight':
            $scope.consitancytab.drumRpmChartHeight = heightForEachOpenedAccordion + 'px';
            _refreshChartDomAfterSettingHeight('jqxConsistencyChart2');
            break;
          case 'consistencyChartWaterHeight':
            $scope.consitancytab.consistencyChartWaterHeight = heightForEachOpenedAccordion + 'px';
            _refreshChartDomAfterSettingHeight('jqxConsistencyChartWater');
            break;
          case 'consistencyChartTemperatureHeight':
            $scope.consitancytab.consistencyChartTemperatureHeight = heightForEachOpenedAccordion + 'px';
            _refreshChartDomAfterSettingHeight('jqxConsistencyChartTemperature');
            break;
        }
      }
    }
    // console.log($scope.consitancytab);
  }
  // when dynamic height is set refresh call on chart is must to adopt the chart height
  function _refreshChartDomAfterSettingHeight(chartDomId) {
    setTimeout(function () {
      $('#' + chartDomId).jqxChart('refresh');
    }, 0);
  }
  $scope.$on('$destroy', function () {
    if ($state.current.name !== 'dashboard' && $state.current.name !== 'betotrack.dashboard') {
      TempMonitoringService.setRowEventStatus(false);
    }
    if ($scope.doorStatusChartSettings && $scope.doorStatusChartSettings.source) {
      delete $scope.doorStatusChartSettings.source;
    }
    if ($scope.tempratursChartHistory && $scope.tempratursChartHistory.source) {
      delete $scope.tempratursChartHistory.source;
    }
    if ($scope.rangeSelectorSettings) {
      delete $scope.rangeSelectorSettings;
    }
    [$scope.consistencyChart1Settings, $scope.consistencyChartWaterSettings, $scope.consistencyChartTemperatureSettings, $scope.consistencyChart2Settings, $scope.consistencyChart3Settings].forEach(function (settings) {
      if (settings && settings.source) {
        delete settings.source;
      }
    });
    currentParentRowResEvent();
    dataStateUpdateListener();
    // remove any listener if any
    $interval.cancel(consitancyCounteInterval);
  });
}]).controller('TempMonitoringEditCtrl', ["$scope", "config", function ($scope, config) {
  $scope.tempMonitor = {};
  $scope.tempMonitor = {
    maxHours: config.maxHours,
    temperatureUnit: config.temperatureUnit,
    max: config.max,
    min: config.min
  };

  $scope.maxIsOdd = false;
  $scope.minIsOdd = false;

  $scope.$watch('tempMonitor.maxHours', function (maxHours) {
    if (maxHours) {
      config.maxHours = maxHours;
    }
  });
  $scope.$watch('tempMonitor.max', function (max) {
    if (max % 2 !== 0) {
      $scope.maxIsOdd = true;
    } else {
      $scope.maxIsOdd = false;
      config.max = max;
    }
  });

  $scope.$watch('tempMonitor.min', function (min) {
    if (min % 2 !== 0) {
      $scope.minIsOdd = true;
    } else {
      $scope.minIsOdd = false;
      config.min = min;
    }
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/deviceSummary/deviceSummaryWidget.tpl.html', '<form><div class=""><div class=""><uib-tabset style="" active="activeTab" class="track-tab-dsa"><uib-tab ng-click="initSummaryTab()" id="summaryTab" index="0"><uib-tab-heading translate="dashBoard.fleetManagement.temperatureDetail.summary.title"></uib-tab-heading><div ng-if="!isSummaryAuthed && !summaryCardData.isloading"><no-authorize></no-authorize></div><div ng-if="summaryCardData.isloading"><loading-animation></loading-animation></div><md-content ng-if="isSummaryAuthed && !summaryCardData.isloading" class="track-tab-dsa md-padding _md layout-xs-column layout-row" layout-xs="column" layout="row"><div flex-xs="" flex-gt-xs="50" class="layout-column flex-xs flex-gt-xs-50"><md-card class="_md"><div ng-click="toggleContent(\'VehicleInfo\')"><md-card-header class="dsa-header" style="background-image: url(assets/images/truckinfowidget_vehicleinfo.jpg);"><md-card-header-text><span class="md-headline dsa-header-span" translate="dashBoard.fleetManagement.temperatureDetail.summary.vehicleInfo"></span></md-card-header-text></md-card-header></div><fieldset class="custom-legend" style="height: 0px;"><legend class="custom-legend-header ng-scope"></legend></fieldset><md-card-content ng-if="summaryCardData.showVehicleInfoContent"><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehiclevin"></label><label>&nbsp;:&nbsp;</label><span ng-bind="summaryData.devicevehicleid"></span></div><div ng-if="summaryData.codeversion !== \'\'"><label translate="dashBoard.fleetManagement.temperatureDetail.summary.firmwarevers"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.codeversion"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehicleimei"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.deviceimei"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehiclesim"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.devicesim"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehiclesimid"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.devicesimid"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehicleserial"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.deviceserialnumber"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehiclemake"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.vehiclemake"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehiclemodel"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.vehiclemodel"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.vehicleplate"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.licenseplate"></span></div></md-card-content></md-card><md-card class="_md"><div ng-click="toggleContent(\'CurrentJob\')"><md-card-header class="dsa-header" style="background-image: url(assets/images/truckinfowidget_currentjob.jpg);"><md-card-header-text><span class="md-headline dsa-header-span" translate="dashBoard.fleetManagement.temperatureDetail.summary.currentJob"></span></md-card-header-text></md-card-header></div><fieldset class="custom-legend" style="height: 0px;"><legend class="custom-legend-header ng-scope"></legend></fieldset><md-card-content ng-if="summaryCardData.showCurrentJobContent"><div ng-show="!summaryCardData.hasCurrentJob"><label translate="dashBoard.fleetManagement.temperatureDetail.summary.nocurrentjob"></label></div><div ng-show="summaryCardData.hasCurrentJob"><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobdate"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderjobdate"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobno"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderjobnumber"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.joblocation"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderjoblocation"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobplannedtime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.planneddrivetime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobplannedcirctime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.plannedcirctime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.conretetype"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderconcretetype"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobref"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderreferenceid"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobstatus"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.jobstatusdesc"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobqty"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderquantity"></span></div><fieldset class="custom-legend"><legend class="custom-legend-header ng-scope"></legend><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobstarttime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderstarttime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobdeparttime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderdeparturetime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobarrivaltime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderarrivaltime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobdiscstarttime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderdischargestarttime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobdiscstoptime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderdischargeendtime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobreturntime"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderreturntime"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.jobremainingquantity"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.workorderreportedremainingquantity" style="color: {{summaryData.workorderreportedremainingquantityColor}};"></span></div></fieldset></div></md-card-content></md-card></div><div flex-xs="" flex-gt-xs="50" class="layout-column flex-xs flex-gt-xs-50"><md-card class="_md"><div ng-click="toggleContent(\'VehicleState\')"><md-card-header class="dsa-header" style="background-image: url(assets/images/truckinfowidget_vehiclestate.jpg);"><md-card-header-text><span class="md-headline dsa-header-span" translate="dashBoard.fleetManagement.temperatureDetail.summary.vehicleState"></span></md-card-header-text></md-card-header></div><fieldset class="custom-legend" style="height: 0px;"><legend class="custom-legend-header ng-scope"></legend></fieldset><md-card-content ng-if="summaryCardData.showVehicleStateContent"><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.ignitionon"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.lastignitionstateon"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.ignitionoff"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.lastignitionstateoff"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.ignitionstate"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.ignitionstate"></span></div><div><label ng-if="summaryData.isStartTime" translate="dashBoard.fleetManagement.temperatureDetail.summary.laststarttime"></label> <label ng-if="!summaryData.isStartTime" translate="dashBoard.fleetManagement.temperatureDetail.summary.laststoptime"></label> <label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.startstoptimestamp"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.lastmalflamp"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.malfunctionlamp"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.lasttachodown"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.lasttachodownloadtime"></span></div></md-card-content></md-card><md-card class="_md"><div ng-click="toggleContent(\'Maintenance\')"><md-card-header class="dsa-header" style="background-image: url(assets/images/truckinfowidget_maintenance.jpg);"><md-card-header-text><span class="md-headline dsa-header-span" translate="dashBoard.fleetManagement.temperatureDetail.summary.maintenance"></span></md-card-header-text></md-card-header></div><fieldset class="custom-legend" style="height: 0px;"><legend class="custom-legend-header ng-scope"></legend></fieldset><md-card-content ng-if="summaryCardData.showMaintenanceContent"><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.telltaleStatus"></label><label>&nbsp;:&nbsp;</label><div ng-if="summaryData.telltalestatuserror === \'true\'" class="multi-icon-dsa icon-dsa-telltale-danger dsa-icon-background"></div><div ng-if="summaryData.telltalestatuswarning === \'true\'" class="multi-icon-dsa icon-dsa-telltale-warning dsa-icon-background"></div><div ng-if="summaryData.telltalestatusinfo === \'true\'" class="multi-icon-dsa icon-dsa-telltale-info dsa-icon-background"></div></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.mainodometer0km"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.serviceremainingdist0"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.mainodometer1km"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.serviceremainingdist1"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.mainenginehrs"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.servicenexthr0"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.repodometer"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.odometer"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.enginehrs"></label><label>&nbsp;:&nbsp;</label> <span ng-bind="summaryData.enginehours"></span></div><div><label translate="dashBoard.fleetManagement.temperatureDetail.summary.mainnotes"></label><label>&nbsp;:&nbsp;</label><p ng-bind="summaryData.servicenotes"></p></div></md-card-content></md-card></div></md-content></uib-tab><uib-tab ng-click="inputTabClick()" id="inputTab" index="1"><uib-tab-heading translate="dashBoard.fleetManagement.temperatureDetail.input.title"></uib-tab-heading><div ng-if="isNotSummaryChartsAuthorized && !thermoDataLoading"><no-authorize></no-authorize></div><div ng-if="thermoDataLoading"><loading-animation></loading-animation></div><md-content ng-show="!isNotSummaryChartsAuthorized && !thermoDataLoading" class="track-tab-dsa md-padding _md layout-xs-column layout-row" layout-xs="column" layout="row"><div flex-xs="" flex-gt-xs="100" class="layout-column flex-xs flex-gt-xs-100"><md-card class="_md"><md-card-content style="padding-top: 0px;"><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><div ng-if="isWidgetPreInitFinished"><div class="col-md-5 col-sm-12 col-xs-12" style="margin-top:5px;margin-bottom: 5px;"><input date-range-picker="" id="doorchart-daterange" name="doorchartDaterange" class="form-control date-picker" type="text" ng-model="temperatureDetail.date" clearable="true" options="options" required=""></div><fieldset class="custom-legend col-xs-12 col-sm-12 col-md-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div jqx-delete-directive="doorChartContainer" type="chart"><jqx-chart id="doorChartContainer" jqx-settings="doorStatusChartSettings" jqx-create="dataLoadingFinished" style="min-height:235px"></jqx-chart></div></div></div></fieldset></div></md-card-content></md-card></div></md-content></uib-tab><uib-tab ng-click="tempTabClick()" id="temperatureTab" index="2"><uib-tab-heading translate="dashBoard.fleetManagement.temperatureDetail.temperature.title"></uib-tab-heading><div ng-if="isNotSummaryChartsAuthorized && !thermoDataLoading"><no-authorize></no-authorize></div><div ng-if="thermoDataLoading"><loading-animation></loading-animation></div><md-content ng-show="!isNotSummaryChartsAuthorized && !thermoDataLoading" class="track-tab-dsa md-padding _md layout-xs-column layout-row" layout-xs="column" layout="row"><div flex-xs="" flex-gt-xs="100" class="layout-column flex-xs flex-gt-xs-100"><md-card class="_md no-card-header"><md-card-content style="padding-top: 0px;"><loading-animation ng-if="!tempDataLoadingFinished"></loading-animation><div ng-if="tempDataLoadingFinished"><div class="col-md-5 col-sm-12 col-xs-12" style="margin-top: 5px;"><input date-range-picker="" id="temperature-daterange" name="temperatureDaterange" class="form-control date-picker" type="text" ng-model="temperatureDetail.date" clearable="true" options="options" required=""></div><div jqx-delete-directive="tempRangeselctor" type="rangeSelector" style="margin-left:8px; padding-top: 35px;"><jqx-range-selector id="tempRangeselctor" jqx-settings="rangeSelectorSettings" ng-model="rangeSelection" jqx-create="dataLoadingFinished" jqx-on-change="tempRangeChange"></jqx-range-selector></div><fieldset class="custom-legend col-xs-12 col-sm-12 col-md-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div jqx-delete-directive="temperatureChartContainer" type="chart"><jqx-chart id="temperatureChartContainer" jqx-settings="tempratursChartHistory" jqx-create="dataLoadingFinished" style="min-height:280px" jqx-watch="[tempratursChartHistory.seriesGroups]"></jqx-chart></div></div></div></fieldset></div></md-card-content></md-card></div></md-content></uib-tab><uib-tab ng-click="weightTabClick()" id="weightTab" index="3"><uib-tab-heading translate="dashBoard.fleetManagement.temperatureDetail.weight.title"></uib-tab-heading><div ng-if="isNotSummaryChartsAuthorized && !thermoDataLoading"><no-authorize></no-authorize></div><div ng-if="thermoDataLoading"><loading-animation></loading-animation></div><md-content ng-show="!isNotSummaryChartsAuthorized && !thermoDataLoading" class="track-tab-dsa md-padding _md layout-xs-column layout-row" layout-xs="column" layout="row"><div flex-xs="" flex-gt-xs="100" class="layout-column flex-xs flex-gt-xs-100"><md-card class="_md"><md-card-content style="padding-top: 0px;"><div class="col-md-5 col-sm-12 col-xs-12" style="margin-top:5px; margin-bottom: 5px;"><input date-range-picker="" id="weight-daterange" name="weightDaterange" class="form-control date-picker" type="text" ng-model="temperatureDetail.date" clearable="true" options="options" required=""></div><div class="col-md-12 col-sm-12 col-xs-12"><div style="margin: 0 auto;"><div id="jqxWeightChart" style="width:100%; min-height: 400px;"></div></div></div></md-card-content></md-card></div></md-content></uib-tab><uib-tab ng-click="fuelTabClick()" id="fuelTab" index="4"><uib-tab-heading translate="dashBoard.fleetManagement.temperatureDetail.fuel.title"></uib-tab-heading><div ng-if="isNotSummaryChartsAuthorized && !thermoDataLoading"><no-authorize></no-authorize></div><div ng-if="thermoDataLoading"><loading-animation></loading-animation></div><md-content ng-show="!isNotSummaryChartsAuthorized" class="track-tab-dsa md-padding _md layout-xs-column layout-row" layout-xs="column" layout="row"><div flex-xs="" flex-gt-xs="100" class="layout-column flex-xs flex-gt-xs-100"><md-card class="_md"><md-card-content style="padding-top: 0px;"><div class="col-md-5 col-sm-12 col-xs-12" style="margin-top:5px; margin-bottom: 5px;"><input date-range-picker="" id="fuelchart-daterange" name="fuelchartDaterange" class="form-control date-picker" type="text" ng-model="temperatureDetail.date" clearable="true" options="options" required=""></div><div class="col-md-12 col-sm-12 col-xs-12"><div style="margin: 0 auto;"><div id="jqxFuelChart" style="width:100%; min-height: 400px; height: 100%;"></div><div id="jqxFuelChart2" style="width:100%; min-height: 400px; height: 100%;"></div><div style="width:100%;text-align: center;" class="col-md-2 col-sm-12 col-xs-12 get-report-btn"><button type="button" class="btn btn-info" ng-click="showDailyDistanceReport()" translate="trackReporting.getReport"></button></div></div></div></md-card-content></md-card></div></md-content></uib-tab><uib-tab ng-click="consistencyTabClick()" id="consistencyTab" index="5"><uib-tab-heading translate="dashBoard.fleetManagement.temperatureDetail.consistency.title"></uib-tab-heading><div ng-if="isNotSummaryChartsAuthorized"><no-authorize></no-authorize></div><div style="position: absolute; z-index: 100; left: 50%;" ng-if="thermoDataLoading"><loading-animation></loading-animation></div><md-content ng-show="!isNotSummaryChartsAuthorized" class="track-tab-dsa md-padding _md layout-xs-column layout-row" layout-xs="column" layout="row"><div flex-xs="" flex-gt-xs="100" class="layout-column flex-xs flex-gt-xs-100"><md-card class="_md"><md-card-content><div class="col-md-5 col-sm-10 col-xs-10"><input date-range-picker="" id="consistencychart-daterange" name="consistencychartDaterange" class="form-control date-picker" type="text" ng-model="temperatureDetail.date" clearable="true" options="options" required=""></div><div class="col-sm-4 col-sm-10 col-md-4"><input type="checkbox" name="my-checkbox" ng-change="consistanceAutoUpdateCheckBoxChange(consitancytab.hasAutoRefresh)" style="min-width: 18px; min-height: 18px;" ng-model="consitancytab.hasAutoRefresh"> <label for="infoBaloonDiaplayCheckbox" style="position: relative; top: -5px; padding-left: 5px;">{{consitancytab.consitancyTabAutoRefreshLabel}}({{consistancyConter}}s)</label></div><div class="col-md-12 col-sm-12 col-xs-12 consistancy-chart-content"><uib-accordion close-others="false"><div uib-accordion-group="" is-open="consitancytab.isConsistancyChartOpen"><uib-accordion-heading><label translate="dashBoard.fleetManagement.temperatureDetail.consistency.chartHeading" class="accordion-title"></label> <i class="pull-right glyphicon" ng-class="{\'glyphicon glyphicon-minus\': consitancytab.isConsistancyChartOpen, \'glyphicon glyphicon-plus\': !consitancytab.isConsistancyChartOpen}"></i></uib-accordion-heading><div style="margin: 0 auto;"><div id="jqxConsistencyChart1" style="width:100%; height: 100%;" ng-style="{\'min-height\': consitancytab.consistancyChartHeight}"></div></div></div></uib-accordion></div><div class="col-md-12 col-sm-12 col-xs-12 consistancy-chart-content"><uib-accordion close-others="false"><div uib-accordion-group="" is-open="consitancytab.isConsistencyChartWaterOpen"><uib-accordion-heading><label translate="dashBoard.fleetManagement.temperatureDetail.consistency.consistencyChartWaterAccodionLabel" class="accordion-title"></label> <i class="pull-right glyphicon" ng-class="{\'glyphicon glyphicon-minus\': consitancytab.isConsistencyChartWaterOpen, \'glyphicon glyphicon-plus\': !consitancytab.isConsistencyChartWaterOpen}"></i></uib-accordion-heading><div style="margin: 0 auto;"><div id="jqxConsistencyChartWater" style="width:100%; height: 100%;" ng-style="{\'min-height\': consitancytab.consistencyChartWaterHeight}"></div></div></div></uib-accordion></div><div class="col-md-12 col-sm-12 col-xs-12 consistancy-chart-content"><uib-accordion close-others="false"><div uib-accordion-group="" is-open="consitancytab.isConsistencyChartTemperatureOpen"><uib-accordion-heading><label translate="dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel8" class="accordion-title"></label> <i class="pull-right glyphicon" ng-class="{\'glyphicon glyphicon-minus\': consitancytab.isConsistencyChartTemperatureOpen, \'glyphicon glyphicon-plus\': !consitancytab.isConsistencyChartTemperatureOpen}"></i></uib-accordion-heading><div style="margin: 0 auto;"><div id="jqxConsistencyChartTemperature" style="width:100%; height: 100%;" ng-style="{\'min-height\': consitancytab.consistencyChartTemperatureHeight}"></div></div></div></uib-accordion></div><div class="col-md-12 col-sm-12 col-xs-12 consistancy-chart-content"><uib-accordion close-others="false"><div uib-accordion-group="" is-open="consitancytab.isDrumRpmChartOpen"><uib-accordion-heading><label translate="dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel2" class="accordion-title"></label> <i class="pull-right glyphicon" ng-class="{\'glyphicon glyphicon-minus\': consitancytab.isDrumRpmChartOpen, \'glyphicon glyphicon-plus\': !consitancytab.isDrumRpmChartOpen}"></i></uib-accordion-heading><div style="margin: 0 auto;"><div id="jqxConsistencyChart2" style="width:100%; height: 100%;" ng-style="{\'min-height\': consitancytab.drumRpmChartHeight}"></div></div></div></uib-accordion></div><div class="col-md-12 col-sm-12 col-xs-12 consistancy-chart-content"><uib-accordion close-others="false"><div uib-accordion-group="" is-open="consitancytab.isAmbientTempChartOpen"><uib-accordion-heading><label translate="dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel4" class="accordion-title"></label> <i class="pull-right glyphicon" ng-class="{\'glyphicon glyphicon-minus\': consitancytab.isAmbientTempChartOpen, \'glyphicon glyphicon-plus\': !consitancytab.isAmbientTempChartOpen}"></i></uib-accordion-heading><div style="margin: 0 auto;"><div id="jqxConsistencyChart3" style="width:100%; height: 100%;" ng-style="{\'min-height\': consitancytab.ambientTempChartHeight}"></div></div></div></uib-accordion></div><div class="col-md-12 col-sm-12 col-xs-12 consistancy-chart-content"><div style="width:100%;text-align:center;"><div id="jqxConsistencyLegend" style="display: inline-block;"></div></div></div><div><div class="col-md-12 col-sm-12 col-xs-12"><div style="margin: 0 auto;"></div></div></div></md-card-content></md-card></div></md-content></uib-tab></uib-tabset></div><div class="hidden"><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><no-authorize ng-if="isNotAuthorized=== true"></no-authorize><no-data-available ng-if="isNotAuthorized=== false && isDataNotAvailable === true"></no-data-available><div ng-if="isDataNotAvailable === false && dataLoadingFinished === true && isNotAuthorized === false"><div class="row"><div class="col-md-5 col-sm-12 col-xs-12" style="margin-top:5px;"><div><input date-range-picker="" id="daterange5" name="daterange5" class="form-control date-picker" type="text" ng-model="temperatureDetail.date" clearable="true" options="options" required=""></div></div><div class="col-md-5" style="margin-top:0px;"><div jqx-delete-directive="tempRangeselctor" type="rangeSelector"><jqx-range-selector id="tempRangeselctor" jqx-settings="rangeSelectorSettings" ng-model="rangeSelection" jqx-create="dataLoadingFinished" jqx-on-change="tempRangeChange"></jqx-range-selector></div></div></div><fieldset class="custom-legend"><legend class="custom-legend-header" translate="dashBoard.fleetManagement.tempMonitoringWidget.doorStatusChartTitle"></legend><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div jqx-delete-directive="doorChartContainer" type="chart"><jqx-chart id="doorChartContainer" jqx-settings="doorStatusChartSettings" jqx-create="dataLoadingFinished" style="min-width:700px; min-height:235px"></jqx-chart></div></div></div></fieldset><fieldset class="custom-legend"><legend class="custom-legend-header" translate="dashBoard.fleetManagement.tempMonitoringWidget.temperatureHistoryTitle"></legend><div class="row" style="margin-top: 2.5px;"><div class="col-xs-12 col-sm-12 col-md-12"><div jqx-delete-directive="temperatureChartContainer" type="chart"><jqx-chart id="temperatureChartContainer" jqx-settings="tempratursChartHistory" jqx-create="dataLoadingFinished" style="min-width:700px; min-height:280px" jqx-watch="[tempratursChartHistory.seriesGroups]"></jqx-chart></div></div></div></fieldset></div></div></div></form>');
  }]);
})();

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/25/2016.
 */


angular.module('dashboard.digitalOutputs', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('digitalOutputsWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.driverWhrkHrsSVG.title';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.driverWhrkHrsSVG.description';
      }
    },
    controller: 'digitalOutputsCtrl',
    templateUrl: 'components/dashboard/digitalOutputs/digitalOutputsWidget.tpl.html',
    isSingleInstance: true,
    config: {
      statusCodeList: [],
      vehicleList: [],
      vehicleGroup: null,
      vehicleGroupList: [],
      statusCode: null,
      noOfGridRows: ''
    }
  });
}]).service('digitalOutputsService', ["crudService", function (crudService) {
  this.saveDigitalOutPut = function (param) {
    return crudService.post('portalcommands/digitaloutput', param);
  };
}]).controller('digitalOutputsCtrl', ["$scope", "digitalOutputsService", "$rootScope", "toastService", function ($scope, digitalOutputsService, $rootScope, toastService) {
  $scope.flag1 = true;
  $scope.flag2 = true;
  $scope.flag3 = true;
  $scope.flag4 = true;

  $scope.digitalOutputsDetail = {
    deviceID: '',
    firstCheck: false,
    secondCheck: false,
    thirdCheck: false,
    fourthCheck: false,
    switchStatus1: false,
    switchStatus2: false,
    switchStatus3: false,
    switchStatus4: false,
    timeout1: null,
    timeout2: null,
    timeout3: null,
    timeout4: null
  };

  $scope.checkboxChange = function (index, value) {
    switch (index) {
      case 1:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus1 = false;
          $scope.digitalOutputsDetail.timeout1 = null;
        }
        $scope.flag1 = !value;
        break;
      case 2:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus2 = false;
          $scope.digitalOutputsDetail.timeout2 = null;
        }
        $scope.flag2 = !value;
        break;
      case 3:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus3 = false;
          $scope.digitalOutputsDetail.timeout3 = null;
        }
        $scope.flag3 = !value;
        break;
      case 4:
        if (!value) {
          $scope.digitalOutputsDetail.switchStatus4 = false;
          $scope.digitalOutputsDetail.timeout4 = null;
        }
        $scope.flag4 = !value;
        break;
    }
  };

  $scope.switchChange = function (index, value) {
    if (!value) {
      switch (index) {
        case 1:
          $scope.digitalOutputsDetail.timeout1 = null;
          break;
        case 2:
          $scope.digitalOutputsDetail.timeout2 = null;
          break;
        case 3:
          $scope.digitalOutputsDetail.timeout3 = null;
          break;
        case 4:
          $scope.digitalOutputsDetail.timeout4 = null;
          break;
      }
    }
  };

  $scope.$on('vehiclesListRowSelected', function (event, args) {
    if (args) {
      var broadcastEventData = args;
      var selectedRow = broadcastEventData.selectedRow;
      if (!selectedRow) {
        $scope.isDataAvailable = false;
        return;
      }
      $scope.isDataAvailable = true;
      $scope.digitalOutputsDetail.deviceID = selectedRow.deviceid;
      $scope.digitalOutputsDetail.firstCheck = false;
      $scope.digitalOutputsDetail.secondCheck = false;
      $scope.digitalOutputsDetail.thirdCheck = false;
      $scope.digitalOutputsDetail.fourthCheck = false;
      $scope.digitalOutputsDetail.switchStatus1 = selectedRow.outputbit[0].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.switchStatus2 = selectedRow.outputbit[1].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.switchStatus3 = selectedRow.outputbit[2].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.switchStatus4 = selectedRow.outputbit[3].toLowerCase() === 'off' ? false : true;
      $scope.digitalOutputsDetail.timeout1 = null;
      $scope.digitalOutputsDetail.timeout2 = null;
      $scope.digitalOutputsDetail.timeout3 = null;
      $scope.digitalOutputsDetail.timeout4 = null;
      $scope.flag1 = true;
      $scope.flag2 = true;
      $scope.flag3 = true;
      $scope.flag4 = true;
    } else {
      $scope.isDataAvailable = false;
    }
  });

  $scope.save = function () {
    var digitalOutPutParams = {
      deviceID: $scope.digitalOutputsDetail.deviceID,
      commandType: 'GTSDO',
      sendState: 0,
      commandArgs: ''
    };
    var object = {
      DO: {}
    };
    if ($scope.digitalOutputsDetail.firstCheck) {
      object.DO[1] = {
        value: $scope.digitalOutputsDetail.switchStatus1 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout1
      };
    }
    if ($scope.digitalOutputsDetail.secondCheck) {
      object.DO[2] = {
        value: $scope.digitalOutputsDetail.switchStatus2 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout2
      };
    }
    if ($scope.digitalOutputsDetail.thirdCheck) {
      object.DO[3] = {
        value: $scope.digitalOutputsDetail.switchStatus3 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout3
      };
    }
    if ($scope.digitalOutputsDetail.fourthCheck) {
      object.DO[4] = {
        value: $scope.digitalOutputsDetail.switchStatus4 === true ? 1 : 0,
        timeout: $scope.digitalOutputsDetail.timeout4
      };
    }
    digitalOutPutParams.commandArgs = JSON.stringify(object);

    return digitalOutputsService.saveDigitalOutPut(digitalOutPutParams).then(function () {
      $rootScope.$broadcast('portalCommandSaved');
      toastService.showSuccessToast('Save Successfully!');
    }, function (response) {
      var errorAlert = { type: 'F', message: response.data.message };
      toastService.showErrorToast(errorAlert);
    });
  };
}]);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/digitalOutputs/digitalOutputsWidget.tpl.html', '<div class="row" style="padding: 2.5px;"><div class="col-sm-12 col-md-12" style="padding: 2px"><div ng-show="isDataAvailable"><div class="col-sm-1 col-md-1"><input type="checkbox" name="checkbox1" ng-model="digitalOutputsDetail.firstCheck" ng-change="checkboxChange(1,digitalOutputsDetail.firstCheck)"></div><div class="col-sm-3 col-md-3"><label translate="digitalOutput.output1"></label></div><div class="col-sm-3 col-md-3"><toggle-switch ng-model="digitalOutputsDetail.switchStatus1" ng-change="switchChange(1,digitalOutputsDetail.switchStatus1)" ng-disabled="flag1"></toggle-switch></div><div class="col-sm-2 col-md-2"><label translate="digitalOutput.timeout"></label></div><div class="col-sm-3 col-md-3"><input type="text" class="form-control" ng-model="digitalOutputsDetail.timeout1" ng-disabled="flag1"></div><div class="col-sm-12 col-md-12" style="padding: 2px"><div class="col-sm-1 col-md-1"><input type="checkbox" name="my-checkbox" ng-model="digitalOutputsDetail.secondCheck" ng-change="checkboxChange(2,digitalOutputsDetail.secondCheck)"></div><div class="col-sm-3 col-md-3"><label translate="digitalOutput.output2"></label></div><div class="col-sm-3 col-md-3"><toggle-switch ng-model="digitalOutputsDetail.switchStatus2" ng-change="switchChange(2,digitalOutputsDetail.switchStatus2)" ng-disabled="flag2"></toggle-switch></div><div class="col-sm-2 col-md-2"><label translate="digitalOutput.timeout"></label></div><div class="col-sm-3 col-md-3"><input type="text" class="form-control" ng-model="digitalOutputsDetail.timeout2" ng-disabled="flag2"></div></div><div class="col-sm-12 col-md-12" style="padding: 2px"><div class="col-sm-1 col-md-1"><input type="checkbox" name="my-checkbox" ng-model="digitalOutputsDetail.thirdCheck" ng-change="checkboxChange(3,digitalOutputsDetail.thirdCheck)"></div><div class="col-sm-3 col-md-3"><label translate="digitalOutput.output3"></label></div><div class="col-sm-3 col-md-3"><toggle-switch ng-model="digitalOutputsDetail.switchStatus3" ng-change="switchChange(3,digitalOutputsDetail.switchStatus3)" ng-disabled="flag3"></toggle-switch></div><div class="col-sm-2 col-md-2"><label translate="digitalOutput.timeout"></label></div><div class="col-sm-3 col-md-3"><input type="text" class="form-control" ng-model="digitalOutputsDetail.timeout3" ng-disabled="flag3"></div></div><div class="col-sm-12 col-md-12" style="padding: 2px"><div class="col-sm-1 col-md-1"><input type="checkbox" name="my-checkbox" ng-model="digitalOutputsDetail.fourthCheck" ng-change="checkboxChange(4,digitalOutputsDetail.fourthCheck)"></div><div class="col-sm-3 col-md-3"><label translate="digitalOutput.output4"></label></div><div class="col-sm-3 col-md-3"><toggle-switch ng-model="digitalOutputsDetail.switchStatus4" ng-change="switchChange(4,digitalOutputsDetail.switchStatus4)" ng-disabled="flag4"></toggle-switch></div><div class="col-sm-2 col-md-2"><label translate="digitalOutput.timeout"></label></div><div class="col-sm-3 col-md-3"><input type="number" class="form-control" ng-model="digitalOutputsDetail.timeout4" ng-disabled="flag4"></div></div><div class="col-sm-12 col-md-12" style="padding: 2px"><button type="button" class="btn btn-default unified-btn" ng-click="save()"><span class="glyphicon glyphicon-save"></span><span class="span-btn-font">Save</span></button></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></div></div>');
  }]);
})();

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 30/06/2016.
 */


angular.module('driverDashboard', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('driverdashboard', {
    parent: 'betotrack',
    url: '/driverdashboard',
    ncyBreadcrumb: {
      label: 'Track'
    },
    views: {
      'content@app': {
        templateUrl: 'components/dashboard/driverDashboard/driverDashboard.tpl.html',
        controller: 'DriverDashboardCtrl'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Fleet Management Dashboard';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    }
  });
}]);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/driverDashboard/driverDashboard.tpl.html', '<div class="container-fluid mainContent"><div class="row"><div class="col-sm-12"><adf-dashboard name="{{dashBoardName}}" collapsible="{{collapsible}}" maximizable="{{maximizable}}" structure="7-5 (12/6-6)" adf-model="dashBoardModel" adf-widget-filter="widgetFilter"></adf-dashboard></div></div></div>');
  }]);
})();

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 3/24/2016.
 */


angular.module('betosyswebapp').controller('DriverDashboardCtrl', ["$rootScope", "$scope", "AuthenticationService", "base64", "localStorageService", "$translate", "commonTrackService", "dashboardService", "customerService", function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
  $scope.pageHeader = 'Driver Dashboard';

  var loginID = AuthenticationService.GetLoginID();

  //dash board
  $scope.username = loginID.username;
  $scope.dashBoardName = 'dashBoard.DriverDashboard.' + $scope.username;
  var model = localStorageService.get($scope.dashBoardName);

  if (!model) {
    model = customerService.getDriverDashboardConfig(commonTrackService.getViewPortName());
  }

  $scope.dashBoardModel = model;
  $scope.collapsible = true;
  $scope.maximizable = true;

  $scope.widgetFilter = function (widget, type) {
    if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
      return type;
    }
  };

  function notExist(type) {
    return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
  }

  var isExculdedParentWidgetArr = ['vehicleListWidget', 'tachoHistoryWidget', 'FMSVehicleWidget', 'tachoDownloadStatusWidget'];

  function isExculdedParentWidget(type) {
    for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
      if (type === isExculdedParentWidgetArr[j]) {
        return true;
      }
    }
    return false;
  }
  var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
    localStorageService.set(name, model);
  });

  var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
    if (data.selectedRow) {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
    } else {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
    }
  });

  var vehicleGroupChangedEvnt = $scope.$on('vehicleGroupChanged', function (event, data) {
    commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getFleetBasedWidgetNameArray(), data.selectedVehicleGroupLabel);
  });

  var widgetDataFromServer = $scope.$on('init-widget-data-from-server', function (event, data) {
    if (data.selectedRow) {

      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
        name: 'tachoEventDetailWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
      }], data.selectedRow.date.replace('/', '.'));
    }
  });

  $scope.$on('$destroy', function () {
    rowSelectedEvnt();
    adfDashboardChangedEvnt();
    vehicleGroupChangedEvnt();
    widgetDataFromServer();
  });
}]);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 05-Apr-17.
 */


angular.module('dashboard.driverDigitalTachoStatus', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('DriverDigitalTachoStatusWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.driverDigitalTachoStatus.description';
      }
    },
    controller: 'DriverDigitalTachoStatusCtrl',
    templateUrl: 'components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      mapURL: null,
      height: 450
    },
    edit: {
      templateUrl: 'components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidgetEdit.tpl.html',
      reload: false,
      controller: 'DriverDigitalTachoStatusEditCtrl'
    }
  });
}]).service('DriverDigitalTachoStatusWidgetService', function () {
  var _lastSelctedWrkHrsRow = null;
  this.setLastSelectedWorkingHoursRow = function (rowdata) {
    _lastSelctedWrkHrsRow = rowdata;
  };
  this.getLastSelectedWorkingHoursRow = function () {
    return _lastSelctedWrkHrsRow;
  };
}).controller('DriverDigitalTachoStatusCtrl', ["$scope", "DriverDigitalTachoStatusWidgetService", "$timeout", "$translate", "widgetSettingsCreatorService", "DriverWrkHrsWidgetService", "stateManagerService", "$rootScope", "AuthenticationService", function ($scope, DriverDigitalTachoStatusWidgetService, $timeout, $translate, widgetSettingsCreatorService, DriverWrkHrsWidgetService, stateManagerService, $rootScope, AuthenticationService) {
  $scope.digitailTachoStatusDetails = {};

  $scope.isNotAuthorized = false;
  $scope.isDataNotAvailable = false;
  $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
  $scope.isWidgetPostInitFinished = false;

  // var otherStyles =  widgetSettingsCreatorService.fetchCustomerWidgetStyleSettings();
  $scope.digitailTachoStatusDetails.otherStyles = widgetSettingsCreatorService.fetchCustomerWidgetStyleSettings();

  $timeout(function () {
    $rootScope.$broadcast('reqDataUpdate');
  }, 0);

  function handleRowSelect(data) {
    $scope.isDataNotAvailable = false;
    $scope.isNotAuthorized = false;

    if (data.selectedRow) {
      $scope.isOneMinuteRuleSet = data.selectedRow.tachotimecalculationstrategy === '1';
      $scope.isFMSTimestampSet = data.selectedRow.lastfmstimestamp !== '0' && data.selectedRow.lastfmstimestamp !== '---';
      data.selectedRow = Object.assign({}, data.selectedRow);
      data.selectedRow.driverdesc = data.selectedRow.driverdesc.length > 0 ? data.selectedRow.driverdesc : '---';
      $scope.digitailTachoStatusDetails = data.selectedRow;
      $scope.digitailTachoStatusDetails.currentStatus = $translate.instant('dashBoard.fleetManagement.driverDigitalTachoStatus.currentStatus');
      DriverDigitalTachoStatusWidgetService.setLastSelectedWorkingHoursRow(data.selectedRow);
    } else {
      $scope.isDataNotAvailable = true;
    }
    $scope.dataLoadingFinished = true;
  }

  var loadDependentDataFromServer = function loadDependentDataFromServer(deviceID) {
    $scope.isDataNotAvailable = false;
    $scope.isNotAuthorized = false;
    DriverWrkHrsWidgetService.getDriverWorkingHoursListForDevice(deviceID).then(function (result) {
      if (result.dataList && result.dataList.length === 1) {
        handleRowSelect({ selectedRow: result.dataList[0] });
      } else {
        $scope.isDataNotAvailable = true;
      }
    });
  };

  // Modification for the Loading Imporvement
  var getSetData = function getSetData(widget) {
    var loginID = AuthenticationService.GetLoginID();
    widget = loginID.Account + '_' + loginID.username + '_' + widget;
    var stateData = stateManagerService.getStateData();
    var set = stateData && stateData[widget] ? stateData[widget] : {};
    return set;
  };
  var maxGetInitialDataRetries = 30;
  var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
    if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
      currentParentRowResEvent();
      return;
    }
    //  console.info(' Digital Tacho Status Widget Requesting Parent for Data ..');
    --maxGetInitialDataRetries;
    var set = getSetData(data.widget);
    var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];

    // parents First tab must always retrun a  valid selected row
    if (data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value) || data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues)) {
      $scope.isWidgetPreInitFinished = true;
      $scope.isWidgetPostInitFinished = true;
      _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);
    } else {
      // Repeatedly try to get the data from parent .
      if (maxGetInitialDataRetries > 0) {
        $timeout(function () {
          if (!$scope.isWidgetPostInitFinished) {
            $rootScope.$broadcast('reqDataUpdate');
          }
        }, 100);
      } else {
        console.warn('Max Retries exceeded to get the current Parent data for Digital Tacho Status Widget..');
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;
        $scope.isDataNotAvailable = true;
        currentParentRowResEvent();
      }
    }
  });

  var dataStateUpdateListener = $scope.$on('dataStateUpdate', function (event, data) {
    if ($scope.isWidgetPostInitFinished) {
      var set = getSetData(data.widget);
      _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
    } else {
      //console.log('Ignoring dataState update from widget: ' + data.widget);
    }
  });

  function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName) {
    var set;

    switch (dashboardName) {
      case 'dashboard.driverWrkHrsDashboard':
        // contains only tab 0
        switch (tabNumber) {
          case 0:
            handleRowSelect({ selectedRow: rowData });
            break;
        }
        break;
      case 'dashboard.tachohistory':
        // contains only tab 0
        switch (tabNumber) {
          case 0:
            if (!_.isEmpty(rowData)) {
              $scope.isDataNotAvailable = false;
              $scope.isNotAuthorized = false;
              $scope.digitailTachoStatusDetails = rowData;
              $scope.isOneMinuteRuleSet = $scope.digitailTachoStatusDetails.tachotimecalculationstrategy === '1';
              $scope.isFMSTimestampSet = $scope.digitailTachoStatusDetails.lastfmstimestamp !== '0' && $scope.digitailTachoStatusDetails.lastfmstimestamp !== '---';
              if ($scope.digitailTachoStatusDetails && $scope.digitailTachoStatusDetails.workinghours) {
                $scope.digitailTachoStatusDetails.driverworkhours = $scope.digitailTachoStatusDetails.workinghours;
              } else {
                $scope.isDataNotAvailable = true;
              }
              $scope.dataLoadingFinished = true;
            } else {
              $scope.isDataNotAvailable = true;
            }

            break;

        }
        break;
      case 'dashboard.fmsDashboard':
      case 'dashboard.vehicleList':
        switch (tabNumber) {
          case 0:
            // first tab use device id to  load data from server
            set = getSetData(widgetName);
            rowData = set['tab_' + 0 + '_selectedRow'];
            if (!_.isEmpty(rowData.value)) {
              loadDependentDataFromServer(rowData.value.deviceid);
            } else {
              $scope.isDataNotAvailable = true;
            }
            break;
          case 1: // use the Service stored Data
          case 2:
          case 3:
            rowData = DriverDigitalTachoStatusWidgetService.getLastSelectedWorkingHoursRow();
            if (!_.isEmpty(rowData)) {
              handleRowSelect({ selectedRow: rowData });
            } else {
              $scope.isDataNotAvailable = true;
            }
            break;
        }
        break;

    }
  }
  $scope.$on('$destroy', function () {
    dataStateUpdateListener();
    currentParentRowResEvent();
  });
}]).controller('DriverDigitalTachoStatusEditCtrl', function () {});

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidget.tpl.html', '<style type="text/css">\n' + '  .customRow {\n' + '    padding-left: 10px;\n' + '    min-height: 25px;\n' + '  }\n' + '  .tachoStatusInlineRow {\n' + '    border: 1px solid #AAAAAA;\n' + '  }\n' + '</style><div class=""><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><no-authorize ng-if="isNotAuthorized=== true"></no-authorize><no-data-available ng-if="isNotAuthorized=== false && isDataNotAvailable === true"></no-data-available><div style="padding: 7px;min-height: 512px;" ng-if="isDataNotAvailable === false && dataLoadingFinished === true"><div class="row" style="padding-left: 7px;padding-bottom: 7px; padding-top: 7px;" ng-if="isOneMinuteRuleSet === true && isFMSTimestampSet === false"><div class="col-sm-6 col-md-6 col-xs-6" style="width: 100%;height: 100%;"><div style="height: 30px;"><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.fmsNotAvailable" style="float:center;background-color: #f8c814;border-radius: 25px;height: 100%;text-align: center;vertical-align: middle;line-height: 30px;font-weight: bold;"></div></div></div></div><div class="row" style="padding-left: 7px;"><div class="col-sm-6 col-md-6 col-xs-6" style="width: 28%"><div><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.driver" style="float:left;"></div><div>:</div></div></div><div class="col-sm-6 col-md-6 col-xs-6"><label id="label_driverdesc">{{digitailTachoStatusDetails.driverdesc}}</label></div></div><div class="row" style="padding-left: 7px;"><div class="col-sm-6 col-md-6 col-xs-6" style="width: 28%"><div><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.login" style="float:left;"></div><div>:</div></div></div><div class="col-sm-6 col-md-6 col-xs-6"><label id="label_driverlogin">{{digitailTachoStatusDetails.driverlogin}}</label></div></div><div class="row" style="padding-left: 7px;"><div class="col-sm-6 col-md-6 col-xs-6" style="width: 28%"><div><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.logout" style="float:left;"></div><div>:</div></div></div><div class="col-sm-6 col-md-6 col-xs-6"><label id="label_driverlogout">{{digitailTachoStatusDetails.driverlogout}}</label></div></div><div class="row" style="padding-left: 7px;"><div class="col-sm-6 col-md-6 col-xs-6" style="width: 28%"><div><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.duration" style="float:left;"></div><div>:</div></div></div><div class="col-sm-6 col-md-6 col-xs-6"><label id="label_driverloginduration">{{digitailTachoStatusDetails.driverloginduration}}</label></div></div><div class="row" style="padding-left: 7px;"><div class="col-sm-6 col-md-6 col-xs-6" style="width: 28%"><div><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.odoStart" style="float:left;"></div><div>:</div></div></div><div class="col-sm-6 col-md-6 col-xs-6"><label id="label_odocardpresent">{{digitailTachoStatusDetails.odocardpresent}}</label></div></div><div class="row" style="padding-left: 7px;"><div class="col-sm-6 col-md-6 col-xs-6" style="width: 28%"><div><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.odoStop" style="float:left;"></div><div>:</div></div></div><div class="col-sm-6 col-md-6 col-xs-6"><label id="label_odocardnotpresent">{{digitailTachoStatusDetails.odocardnotpresent}}</label></div></div><div class="row" style="padding-left: 7px; padding-right: 7px; padding-top: 9px;"><div class="col-sm-12 col-md-12 col-xs-12"><table width="100%" class="{{digitailTachoStatusDetails.otherStyles.row.class}}"><tr class="{{digitailTachoStatusDetails.otherStyles.header.class}}"><th width="60%" style="text-align:center" class="tachoStatusInlineRow" translate="dashBoard.fleetManagement.driverDigitalTachoStatus.type"></th><th width="20%" style="text-align:center" class="tachoStatusInlineRow" translate="dashBoard.fleetManagement.driverDigitalTachoStatus.count"></th><th width="20%" style="text-align:center" class="tachoStatusInlineRow" translate="dashBoard.fleetManagement.driverDigitalTachoStatus.duration"></th></tr><tr><td class="tachoStatusInlineRow"><div class="row customRow"><div class="col-sm-10 col-md-10 col-xs-10"><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.breakMoreThan15Min"></div></div><div class="col-sm-2 col-md-2 col-xs-2" style="padding: 0px;"><div style="text-align: right;display:inline;"></div><img src="assets/images/driver_rest.png" alt="" style="width:25px;height:25px;"></div></div></td><td align="center" class="tachoStatusInlineRow" id="label_breakmorethan15mincount">{{digitailTachoStatusDetails.breakmorethan15mincount}}</td><td align="center" class="tachoStatusInlineRow" id="label_pausehours">{{digitailTachoStatusDetails.pausehours}}</td></tr><tr><td class="tachoStatusInlineRow"><div class="row customRow"><div class="col-sm-10 col-md-10 col-xs-10"><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.breakAll"></div></div><div class="col-sm-2 col-md-2 col-xs-2" style="padding: 0px;"><div style="text-align: right;display:inline;"></div></div></div></td><td align="center" class="tachoStatusInlineRow" id="label_pausecount">{{digitailTachoStatusDetails.pausecount}}</td><td align="center" class="tachoStatusInlineRow" id="label_pausehoursall">{{digitailTachoStatusDetails.pausehoursall}}</td></tr><tr><td class="tachoStatusInlineRow"><div class="row customRow"><div class="col-sm-10 col-md-10 col-xs-10"><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.availability"></div></div><div class="col-sm-2 col-md-2 col-xs-2" style="padding: 0px;"><div style="text-align: right;display:inline;"></div><img src="assets/images/driver_poa.png" alt="" style="width:25px;height:25px;"></div></div></td><td align="center" class="tachoStatusInlineRow" id="label_availablecount">{{digitailTachoStatusDetails.availablecount}}</td><td align="center" class="tachoStatusInlineRow" id="label_availablehours">{{digitailTachoStatusDetails.availablehours}}</td></tr><tr><td class="tachoStatusInlineRow"><div class="row customRow"><div class="col-sm-10 col-md-10 col-xs-10"><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.work"></div></div><div class="col-sm-2 col-md-2 col-xs-2" style="padding: 0px;"><div style="text-align: right;display:inline;"></div><img src="assets/images/driver_other_work.png" alt="" style="width:25px;height:25px;"></div></div></td><td align="center" class="tachoStatusInlineRow" id="label_workcount">{{digitailTachoStatusDetails.workcount}}</td><td align="center" class="tachoStatusInlineRow" id="label_driverworkhours">{{digitailTachoStatusDetails.driverworkhours}}</td></tr><tr><td class="tachoStatusInlineRow"><div class="row customRow"><div class="col-sm-10 col-md-10 col-xs-10"><div translate="dashBoard.fleetManagement.driverDigitalTachoStatus.driving"></div></div><div class="col-sm-2 col-md-2 col-xs-2" style="padding: 0px;"><div style="text-align: right;display:inline;"></div><img src="assets/images/driver_driving_mode.png" alt="" style="width:25px;height:25px;"></div></div></td><td align="center" class="tachoStatusInlineRow" id="label_drivecount">{{digitailTachoStatusDetails.drivecount}}</td><td align="center" class="tachoStatusInlineRow" id="label_drivehours">{{digitailTachoStatusDetails.drivehours}}</td></tr><tr ng-if="digitailTachoStatusDetails.driverloginduration !=\'---\'"><td class="tachoStatusInlineRow"><div class="row customRow"><div class="col-sm-10 col-md-10 col-xs-10"><div id="label_driver1workingstate">{{digitailTachoStatusDetails.currentStatus}} ( <b>{{digitailTachoStatusDetails.driver1workingstate}}</b> )</div><div style="display:inline;"></div></div><div class="col-sm-2 col-md-2 col-xs-2" style="padding: 0px;"><div style="text-align: right;display:inline;"></div></div></div></td><td align="center" class="tachoStatusInlineRow" id="label_currentstauscount">{{digitailTachoStatusDetails.currentstauscount}}</td><td align="center" class="tachoStatusInlineRow" id="label_driver1workingstatetime">{{digitailTachoStatusDetails.driver1workingstatetime}}</td></tr></table></div></div><div class="row" style="padding-left: 7px;padding-right: 7px;padding-top:9px;"><div class="col-sm-12 col-md-12 col-xs-12" style="padding-top:10px;"><table width="100%" class="{{digitailTachoStatusDetails.otherStyles.row.class}} tachoStatusInlineTable"><tr class="{{digitailTachoStatusDetails.otherStyles.header.class}}"><th width="20%" style="text-align:center" class="tachoStatusInlineRow"><label translate="dashBoard.fleetManagement.driverDigitalTachoStatus.breakOrRest"></label></th><th width="60%" style="text-align:center" class="tachoStatusInlineRow"><label translate="dashBoard.fleetManagement.driverDigitalTachoStatus.time"></label></th><th width="20%" style="text-align:center" class="tachoStatusInlineRow"><label translate="dashBoard.fleetManagement.driverDigitalTachoStatus.duration"></label></th></tr><tr><td align="center" class="tachoStatusInlineRow">1</td><td align="center" class="tachoStatusInlineRow" id="label_break1time" style="color: {{digitailTachoStatusDetails.break1timeColor}}">{{digitailTachoStatusDetails.break1time}}</td><td align="center" id="label_break1min" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break1min}}</td></tr><tr><td align="center" class="tachoStatusInlineRow">2</td><td align="center" id="label_break2time" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break2timeColor}}">{{digitailTachoStatusDetails.break2time}}</td><td align="center" id="label_break2min" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break2min}}</td></tr><tr><td align="center" class="tachoStatusInlineRow">3</td><td align="center" id="label_break3time" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break3timeColor}}">{{digitailTachoStatusDetails.break3time}}</td><td align="center" id="label_break3min" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break3min}}</td></tr><tr ng-show="digitailTachoStatusDetails.break4time !== \'--- / ---\'"><td align="center" class="tachoStatusInlineRow">4</td><td align="center" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break4timeColor}}">{{digitailTachoStatusDetails.break4time}}</td><td align="center" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break4min}}</td></tr><tr ng-show="digitailTachoStatusDetails.break5time !== \'--- / ---\'"><td align="center" class="tachoStatusInlineRow">5</td><td align="center" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break5timeColor}}">{{digitailTachoStatusDetails.break5time}}</td><td align="center" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break5min}}</td></tr><tr ng-show="digitailTachoStatusDetails.break6time !== \'--- / ---\'"><td align="center" class="tachoStatusInlineRow">6</td><td align="center" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break6timeColor}}">{{digitailTachoStatusDetails.break6time}}</td><td align="center" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break6min}}</td></tr><tr ng-show="digitailTachoStatusDetails.break7time !== \'--- / ---\'"><td align="center" class="tachoStatusInlineRow">7</td><td align="center" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break7timeColor}}">{{digitailTachoStatusDetails.break7time}}</td><td align="center" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break7min}}</td></tr><tr ng-show="digitailTachoStatusDetails.break8time !== \'--- / ---\'"><td align="center" class="tachoStatusInlineRow">8</td><td align="center" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break8timeColor}}">{{digitailTachoStatusDetails.break8time}}</td><td align="center" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break8min}}</td></tr><tr ng-show="digitailTachoStatusDetails.break9time !== \'--- / ---\'"><td align="center" class="tachoStatusInlineRow">9</td><td align="center" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break9timeColor}}">{{digitailTachoStatusDetails.break9time}}</td><td align="center" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break9min}}</td></tr><tr ng-show="digitailTachoStatusDetails.break10time !== \'--- / ---\'"><td align="center" class="tachoStatusInlineRow">10</td><td align="center" class="tachoStatusInlineRow" style="color: {{digitailTachoStatusDetails.break10timeColor}}">{{digitailTachoStatusDetails.break10time}}</td><td align="center" class="tachoStatusInlineRow">{{digitailTachoStatusDetails.break10min}}</td></tr></table></div></div></div></div>');
  }]);
})();

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/driverDigitalTachoStatus/driverDigitalTachoStatusWidgetEdit.tpl.html', '<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><title>Title</title></head><body></body></html>');
  }]);
})();

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 19/23/2016.
 */


angular.module('dashboard.driverWrkHrsSVG', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('DriverWrkHrsSVGWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.driverWhrkHrsSVG.title';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.driverWhrkHrsSVG.description';
      }
    },
    controller: 'DriverWrkHrsSVGCtrl',
    templateUrl: 'components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      mapURL: null,
      height: 450
    },
    edit: {
      templateUrl: 'components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidgetEdit.tpl.html',
      reload: false,
      controller: 'DriverWrkHrsSVGEditCtrl'
    }
  });
}]).service('DriverWrkHrsSVGWidgetService', function () {

  var _lastReadDeviceWorkingHours = null;
  this.setLastReadDeviceWorkingHours = function (rowdata) {
    _lastReadDeviceWorkingHours = rowdata;
  };
  this.getLastReadDeviceWorkingHours = function () {
    return _lastReadDeviceWorkingHours;
  };
}).controller('DriverWrkHrsSVGCtrl', ["$scope", "widgetSettingsCreatorService", function ($scope, widgetSettingsCreatorService) {
  $scope.driverWrkHrsSVGDetails = {};
  $scope.isReady = true;
  var otherStyles = widgetSettingsCreatorService.fetchCustomerWidgetStyleSettings();
  $scope.driverWrkHrsSVGDetails.otherStyles = otherStyles;
}]).controller('DriverWrkHrsEditCtrl', function () {});

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidget.tpl.html', '<style type="text/css">\n' + '  .customRow {\n' + '    padding-left: 10px;\n' + '    min-height: 25px;\n' + '  }\n' + '</style><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><no-authorize ng-if="isNotAuthorized=== true"></no-authorize><no-data-available ng-if="isNotAuthorized=== false && isDataNotAvailable === true"></no-data-available><div ng-show="hasValidDriver && isDataNotAvailable === false && dataLoadingFinished === true" class="driver-dashboard"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div class="panel" style="box-shadow: none; margin-bottom: 0px; border: none;"><div class="panel-heading" data-toggle="collapse" style="padding: 0px;background-color: white;outline: none !important;box-shadow: none;" ng-click="expandPane()"><i class="pull-right glyphicon" style="font-size: 16px;" ng-class="{\'glyphicon-plus\': isPaneExpanded, \'glyphicon-minus\': !isPaneExpanded}"></i></div><div id="collapse1" style="user-select: none;"><div class="panel-body"><div style="text-align: center"><driver-wrk-hrs-svg-interpreter></driver-wrk-hrs-svg-interpreter></div></div></div></div></div></div><div class="row" style="padding: 2.5px;"><div class="col-xs-12 col-sm-5 col-md-5"><div class="btn-group"><label class="btn btn-default" ng-model="timeRadio.viewType.dailyView" uib-btn-checkbox="" translate="dashBoard.fleetManagement.driverWhrkHrsSVG.daily"></label> <label class="btn btn-default" ng-model="timeRadio.viewType.weeklyView" uib-btn-checkbox="" translate="dashBoard.fleetManagement.driverWhrkHrsSVG.weekly"></label></div></div><div class="col-xs-12 col-sm-7 col-md-7" style="text-align: right"><label><input type="radio" ng-model="timeRadio.type" value="totalTime" ng-change="timeRadioTypeChange()"> {{totalTimeRadio}}</label> <label style="margin-left: 20px;"><input type="radio" ng-model="timeRadio.type" value="remainingTime" ng-change="timeRadioTypeChange()"> {{remainingTimeRadio}}</label></div></div><table border="1" width="100%" ng-show="timeRadio.viewType.dailyView" class="{{driverWrkHrsSVGDetails.otherStyles.row.class}}"><tr class="{{driverWrkHrsSVGDetails.otherStyles.header.class}}"><th width="90%" style="text-align:center" translate="dashBoard.fleetManagement.driverWhrkHrsSVG.details"></th><th width="10%" style="text-align:center" translate="dashBoard.fleetManagement.driverWhrkHrsSVG.svgColumnHeader"></th></tr><tr><td><div style="padding-left: 2.5px;" ng-style="timeRadio.type ===\'remainingTime\' && driverWorkHours.workTimeTotal.actualValue.includes(\'-\')&& {\'color\':\'red\'}">{{workTimeTotalOrRemaingLabel}}</div><uib-progressbar max="max" value="driverWorkHours.workTimeTotal.value" type="{{driverWorkHours.workTimeTotal.type}}" style="margin: 2.5px;"><span style="color:black; white-space:nowrap;">{{driverWorkHours.workTimeTotal.actualValue}}</span></uib-progressbar></td><td align="center"><input type="radio" ng-model="timeRadio.svgRadioType" value="workTime" ng-change="svgRadioTypeChange()"></td></tr><tr ng-show="!isDataFromHistoryList"><td><div style="padding-left: 2.5px;" ng-style="timeRadio.type ===\'remainingTime\' && driverWorkHours.workTimePause.actualValue.includes(\'-\') && {\'color\':\'red\'}">{{workTimeBetTotalOrRemaingLabel}}</div><uib-progressbar max="max" value="driverWorkHours.workTimePause.value" type="{{driverWorkHours.workTimePause.type}}" style="margin: 2.5px;"><span style="color:black; white-space:nowrap;">{{driverWorkHours.workTimePause.actualValue}}</span></uib-progressbar></td><td align="center"><input type="radio" ng-model="timeRadio.svgRadioType" value="workTimeBetweenPause" ng-change="svgRadioTypeChange()"></td></tr><tr><td><div style="padding-left: 2.5px;" ng-style="timeRadio.type ===\'remainingTime\' && driverWorkHours.driveTimeTotal.actualValue.includes(\'-\') && {\'color\':\'red\'}">{{driveTimeTotalOrRemaingLabel}}</div><uib-progressbar max="max" value="driverWorkHours.driveTimeTotal.value" type="{{driverWorkHours.driveTimeTotal.type}}" style="margin: 2.5px;"><span style="color:black; white-space:nowrap;">{{driverWorkHours.driveTimeTotal.actualValue}}</span></uib-progressbar></td><td align="center"><input type="radio" ng-model="timeRadio.svgRadioType" value="driveTime" ng-change="svgRadioTypeChange()"></td></tr><tr ng-show="!isDataFromHistoryList"><td><div style="padding-left: 2.5px;" ng-style="timeRadio.type ===\'remainingTime\' && driverWorkHours.driveTimePause.actualValue.includes(\'-\') && {\'color\':\'red\'}">{{driveTimeBetTotalOrRemaingLabel}}</div><uib-progressbar max="max" value="driverWorkHours.driveTimePause.value" type="{{driverWorkHours.driveTimePause.type}}" style="margin: 2.5px;"><span style="color:black; white-space:nowrap;">{{driverWorkHours.driveTimePause.actualValue}}</span></uib-progressbar></td><td align="center"><input type="radio" ng-model="timeRadio.svgRadioType" value="driveTimeBetweenPause" ng-change="svgRadioTypeChange()"></td></tr><tr ng-show="!isDataFromHistoryList"><td colspan="2"><div translate="dashBoard.fleetManagement.driverWhrkHrsSVG.nextPauseDurationLabel" style="padding: 2.5px;"></div><label style="padding: 2.5px; margin-left: 3px;" ng-style="{\'background-color\':nextPauseDuriationDisplayColor}">{{nextPauseDuration}}</label></td></tr><tr ng-show="!isDataFromHistoryList"><td colspan="2"><div translate="dashBoard.fleetManagement.driverWhrkHrsSVG.nextShiftStartsBeforeLabel" style="padding: 2.5px;"></div><label style="padding: 2.5px;">{{nextShiftStartsBeforeLabel}}</label></td></tr></table><table border="1" width="100%" ng-show="timeRadio.viewType.weeklyView" class="{{driverWrkHrsSVGDetails.otherStyles.row.class}}"><tr class="{{driverWrkHrsSVGDetails.otherStyles.header.class}}"><th width="90%" style="text-align:center" translate="dashBoard.fleetManagement.driverWhrkHrsSVG.weeklyDetails.weeklyDetailsLabel"></th><th width="10%" style="text-align:center" translate="dashBoard.fleetManagement.driverWhrkHrsSVG.svgColumnHeader"></th></tr><tr><td><div class="row"><div class="col-xs-6 col-sm-6 col-md-6">{{weeklyWorkTimeTotalLabel}}</div><div class="col-xs-6 col-sm-6 col-md-6">{{weeklyWorkTime16WeekAvgLabel}}<div ng-style="driverWorkHours.avg16WeekWorkTime.value >=2880 ? {\'color\':\'red\'} : {\'color\':\'red\'}">{{driverWorkHours.avg16WeekWorkTime.actualValue}}</div></div></div><uib-progressbar max="max" value="driverWorkHours.weekWorkTimeTotal.value" type="{{driverWorkHours.weekWorkTimeTotal.type}}" style="margin: 2.5px;"><span style="color:black; white-space:nowrap;">{{driverWorkHours.weekWorkTimeTotal.actualValue}}</span></uib-progressbar></td><td align="center"><input type="radio" ng-model="timeRadio.svgRadioType" value="weekWorkTimeTotal" ng-change="svgRadioTypeChange()"></td></tr><tr><td><div style="padding-left: 2.5px;" ng-style="timeRadio.type ===\'remainingTime\' && driverWorkHours.weekDriveTimeTotal.actualValue.includes(\'-\') && {\'color\':\'red\'}">{{weeklyDriveTimeTotalLabel}}</div><uib-progressbar max="max" value="driverWorkHours.weekDriveTimeTotal.value" type="{{driverWorkHours.weekDriveTimeTotal.type}}" style="margin: 2.5px;"><span style="color:black; white-space:nowrap;">{{driverWorkHours.weekDriveTimeTotal.actualValue}}</span></uib-progressbar></td><td align="center"><input type="radio" ng-model="timeRadio.svgRadioType" value="weekDriveTimeTotal" ng-change="svgRadioTypeChange()"></td></tr><tr><td><div style="padding-left: 2.5px;" ng-style="timeRadio.type ===\'remainingTime\' && driverWorkHours.weekDriveTimeTotal2we.actualValue.includes(\'-\') && {\'color\':\'red\'}">{{weekly2WeeksDriveTimeTotalLabel}}</div><uib-progressbar max="max" value="driverWorkHours.weekDriveTimeTotal2we.value" type="{{driverWorkHours.weekDriveTimeTotal2we.type}}" style="margin: 2.5px;"><span style="color:black; white-space:nowrap;">{{driverWorkHours.weekDriveTimeTotal2we.actualValue}}</span></uib-progressbar></td><td align="center"><input type="radio" ng-model="timeRadio.svgRadioType" value="weekDriveTimeTotal2we" ng-change="svgRadioTypeChange()"></td></tr><tr ng-show="hasWeeklyRestData"><td colspan="2"><div translate="dashBoard.fleetManagement.driverWhrkHrsSVG.lastWeeklyRestTime" style="padding: 2.5px;"></div><label style="padding: 2.5px;" ng-style="{\'color\':weeklyRestTimeDisplayColor1}">{{weeklyRestTime1}}</label> <label style="padding: 2.5px;" ng-style="{\'color\':weeklyRestTimeDisplayColor2}">{{weeklyRestTime2}}</label></td></tr></table></div>');
  }]);
})();

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/driverWokingHoursSVG/driverWrkHrsSVGWidgetEdit.tpl.html', '<!DOCTYPE html><html><head lang="en"><meta charset="UTF-8"><title></title></head><body></body></html>');
  }]);
})();

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 30/06/2016.
 */



angular.module('dashboard.driverWrkHrsDashboard', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('DriverWrkHrsWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.driverWorkingHours.description';
      }
    },
    controller: 'DriverWrkHrsListCtrl',
    templateUrl: 'components/dashboard/driverWorkingHours/driverWorkingHoursWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      vehicleGroup: null,
      noOfGridRows: ''
    },
    edit: {
      templateUrl: 'components/dashboard/driverWorkingHours/driverWorkingHoursWidgetEdit.tpl.html',
      reload: false,
      controller: 'DriverWorkingHoursEditCtrl'
    }
  });
}]).service('DriverWrkHrsWidgetService', ["crudService", function (crudService) {

  this.getDriverWorkingHrsList = function (vechileGroup, isDataRefresh, reportOption) {
    var requestParam = {
      statusCode: 'all',
      vehicleGroup: vechileGroup,
      reportOption: reportOption || '',
      dataRefresh: isDataRefresh,
      timeTo: '-0d',
      timeFrom: ''
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('driverdashboard', '', param);
  };
  this.getDriverWorkingHoursListForDevice = function (deviceId) {
    var requestParam = {
      deviceid: deviceId,
      dataRefresh: false,
      timeTo: '-0d',
      timeFrom: ''
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('driverdashboard/' + deviceId, '', param);
  };

  this.getCurrentDriverWorkingHoursRepOptions = function () {
    return crudService.get('vehicledetailsreport/options/currentdaydriverworkinghours');
  };
}]).controller('DriverWrkHrsListCtrl', ["$scope", "config", "widgetSettingsCreatorService", "stateManagerService", "vehicleListWidgetService", "DriverWrkHrsWidgetService", "$rootScope", "$timeout", "$q", "$translate", "commonTrackService", "$filter", "AuthenticationService", "localStorageService", "$state", "errorHandlingService", "$interval", function ($scope, config, widgetSettingsCreatorService, stateManagerService, vehicleListWidgetService, DriverWrkHrsWidgetService, $rootScope, $timeout, $q, $translate, commonTrackService, $filter, AuthenticationService, localStorageService, $state, errorHandlingService, $interval) {
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.selectedFunction = '';
  $scope.isDataAvailable = true;
  $scope.planReportList = [1, 2];
  var _lastRefreshTimeS = null;
  //var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
  var counterSeconds = 60;
  var counterTimeout;
  var rowSize = vehicleListWidgetService.getRowSize();
  var workingHoursListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };
  var dvrWrkhrsContextMenu = {};
  var isdvrWrkhrsCtxInitialized = false;

  /**
   *  temporay private variable  to store some global values , created to avoid using config object .
   *  dont use config which will be stored to localstorage and may cuase issues when reused from localstorage
   */
  var _tmpConfig = {};

  $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
    //theme: 'material' use default theme instead
  });

  $scope.cDayDriverWorkHoursRepOptions = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.customGridProperties = {
    vehicleLastLocation: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] - 15 : 455,
      pageable: false,
      columns: []
    }
  };

  $scope.moreFuctionSetting = vehicleListWidgetService.getMoreFunctionSettings();
  $scope.uuidForElement = $scope.$id;

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {
        $scope.vehicleGroupSettings.source = vechileGroupList;
        var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

        if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) {
          // validate the local storage group is still valid ( group can change based on login )
          $scope.vehicleGroup = config.vehicleGroup;
        }

        if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {
            // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = cachedGroup;
            config.vehicleGroup = cachedGroup;
          }
        }
        if (!$scope.vehicleGroup) {
          $scope.vehicleGroup = vechileGroupList[0].groupID;
        }
      }
    });
  };
  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
    });
  };

  var loadWorkingHours = function loadWorkingHours(vehicleGroup, dataRefresh, reportOption, isAutorefresh) {
    $scope.stop();
    return DriverWrkHrsWidgetService.getDriverWorkingHrsList(vehicleGroup, dataRefresh, reportOption).then(function (workingHoursList) {
      if (workingHoursList.dataList) {
        $scope.isDataAvailable = true;
        if (dataRefresh) {
          $scope.customGridProperties.vehicleLastLocation.columns = commonTrackService.getColumnProperties(workingHoursList.gridSettings.overviewListGrids[0].columnProperties, workingHoursList.columnTranslation, { moduleName: 'cDayDriverWorkingHoursDB' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList') };
          $scope.cDayDrvrWrkHoursGridSettings = commonTrackService.getGridSettings('cDayDriverWorkingHoursDB', $scope.customGridProperties.vehicleLastLocation, null, _additionalProperties);
          $scope.cDayDrvrWrkHoursGridSettings.columngroups = commonTrackService.createColumnGroups(workingHoursList.gridSettings.overviewListGrids[0].columnGroupProperties, 'cDayDriverWorkingHours');
          workingHoursListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList', workingHoursListSource);
          workingHoursListSource.localdata = workingHoursList.dataList;
          _lastRefreshTimeS = workingHoursList.dataCreationTimeSeconds;
          $scope.workingHoursListdataAdapter = new $.jqx.dataAdapter(workingHoursListSource);
          $scope.cDayDrvrWrkHoursGridSettings.source = $scope.workingHoursListdataAdapter;
        } else {
          workingHoursListSource.localdata = workingHoursList.dataList;
          _lastRefreshTimeS = workingHoursList.dataCreationTimeSeconds;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList');
        }
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $rootScope.$broadcast('rest-error-event', response);
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      $scope.counter = counterSeconds;
      if ($scope.isDataAvailable && !counterTimeout || $scope.isDataAvailable && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled') {
        $scope.startCounter();
      } else {
        $scope.stop();
      }

      if (isAutorefresh && _lastWrhrsSelectedRowIndex || !dataRefresh && _lastWrhrsSelectedRowIndex || _lastWrhrsSelectedRowIndex === 0) {
        $timeout(function () {
          var rows = $('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('getrows');
          _lastWrhrsSelectedRowIndex = commonTrackService.getSelectRowIndexByCache(rows);
          if (_lastWrhrsSelectedRowIndex < 0) {
            broadcastEventData.selectedRow = null;
            broadcastEventData.dashboardName = 'dashboard.driverWrkHrsDashboard';
            broadcastEventData.isDataFromTab = true;
            broadcastEventData.tabNumber = 0;
            broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
            $rootScope.$broadcast('rowSelected', broadcastEventData);
            return;
          }
          $('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('selectrow', _lastWrhrsSelectedRowIndex);
        }, 0);
      }
      $scope.createCdayDrvrWrkHours = true;
    });
  };

  var loadDashboardReportOption = function loadDashboardReportOption() {
    return DriverWrkHrsWidgetService.getCurrentDriverWorkingHoursRepOptions().then(function (repOptons) {
      for (var i = 0; i < repOptons.length; i++) {
        repOptons[i].displayName = $translate.instant('dashBoard.fleetManagement.driverWorkingHours.workingHoursType.' + repOptons[i].key);
      }
      $scope.cDayDriverWorkHoursRepOptions.source = repOptons;
      var loginid = AuthenticationService.GetLoginID();
      var reportOpt = localStorageService.get('driverWorkingHour.reportOption.' + loginid.Account + '.' + loginid.username);
      if (reportOpt) {
        $scope.dwrkHrsRepOption = reportOpt;
        _tmpConfig.lastSelectedOption = reportOpt;
      } else {
        $scope.dwrkHrsRepOption = repOptons[0].key;
        _tmpConfig.lastSelectedOption = repOptons[0].key;
      }
    });
  };

  function createMessageEvent() {
    $rootScope.$broadcast('newMsgEvent', {});
  }

  function createCommandEvent() {
    $rootScope.$broadcast('newCommandEvent', {});
  }

  function showDashboard() {
    $state.go('betotrack.dashboard');
  }

  /*function showPortalCommand() {
    $state.go('portalcommand');
  }
  */
  function showFmsDashboard() {
    $state.go('fmsdashboard');
  }

  var _commonFunction = {
    'createMessageEvent': createMessageEvent,
    'createCommandEvent': createCommandEvent
  };

  var _contextSourceObj = {
    dvrWrkhrsCtxSource: [{
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
      execute: createMessageEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
      execute: createCommandEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
      execute: showDashboard
    }, /*{
       label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
       execute: showPortalCommand
       },*/
    {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
      execute: showFmsDashboard
    }]
  };

  $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(110);
  $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
    source: _contextSourceObj.dvrWrkhrsCtxSource, popupZIndex: 999999
  });
  loadVehicleGroup().then(function () {
    return loadDashboardReportOption();
  }).then(function () {
    return loadFleetServerDetails();
  }).finally(function () {
    $scope.dataLoadingFinished = true;
    if ($scope.vehicleGroup) {
      loadWorkingHours($scope.vehicleGroup, true, $scope.dwrkHrsRepOption);
    }
  });

  var broadcastEventData = {
    selectedRow: {},
    selectedVehicleGroup: '',
    selectedVehicleGroupLabel: '',
    eventSource: ''
  };

  var _lastWrhrsSelectedRowIndex = null;

  $scope.vehicleGroupComboChange = function (event) {
    var vehicleGroup = event.args.item;
    // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
    if (config.vehicleGroup !== vehicleGroup.value && $scope.cDayDrvrWrkHoursGridSettings && $scope.cDayDrvrWrkHoursGridSettings.columns) {
      loadWorkingHours(vehicleGroup.value, $scope.cDayDrvrWrkHoursGridSettings.columns.length > 0 ? false : true, $scope.dwrkHrsRepOption);
      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, vehicleGroup.value);
    }
    if (vehicleGroup) {
      commonTrackService.setLastSelectedGroup(vehicleGroup);
      config.vehicleGroup = vehicleGroup.value;
      broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
      broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
      broadcastEventData.dashboardName = 'dashboard.driverWrkHrsDashboard';
      broadcastEventData.isDataFromTab = true;
      broadcastEventData.tabNumber = 0;
      $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
    }
  };
  // update vehicle map widget  based on selected vechile id
  $scope.cDayDriverWorkingHoursSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      _lastWrhrsSelectedRowIndex = event.args.rowindex;
      broadcastEventData.selectedRow = event.args.row;
      commonTrackService.setLastLocatioWidgetData(broadcastEventData);
      var pushPinIndex = event.args.row.index - 1;
      $rootScope.$broadcast('fleet-map-update', { pushPinIndex: pushPinIndex, deviceId: event.args.row.deviceid });
      commonTrackService.setDriverDashboardLastSelectedRowData(broadcastEventData);
      $rootScope.$broadcast('init-widget-data-from-server', { deviceID: event.args.row.deviceid, selectedRow: event.args.row });

      broadcastEventData.dashboardName = 'dashboard.driverWrkHrsDashboard';
      broadcastEventData.isDataFromTab = true;
      broadcastEventData.tabNumber = 0;
      broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
      $rootScope.$broadcast('rowSelected', broadcastEventData);

      stateManagerService.updateValue('driverWrkHrsWidget', 'deviceID', broadcastEventData.selectedRow.deviceid, true);
      stateManagerService.updateValue('driverWrkHrsWidget', 'driverID', broadcastEventData.selectedRow.driverid, true);
      stateManagerService.updateValue('driverWrkHrsWidget', 'rowData', broadcastEventData.selectedRow, false); // OUT dated ?
      if (!_.isEmpty(broadcastEventData.selectedRow)) {
        stateManagerService.updateValue('driverWrkHrsWidget', 'tab_0_selectedRow', broadcastEventData.selectedRow, true);
      }
      $rootScope.$broadcast('dataStateUpdate', {
        widget: 'driverWrkHrsWidget', activeTab: 0,
        dashboardName: 'dashboard.driverWrkHrsDashboard'
      });

      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
        'deviceid': broadcastEventData.selectedRow.deviceid,
        'driverid': broadcastEventData.selectedRow.driverid
      });
    }
  };

  $scope.gridRowClickHandler = function (event) {
    if (event.args.rightclick) {
      if (!isdvrWrkhrsCtxInitialized) {
        dvrWrkhrsContextMenu = $('#' + $scope.uuidForElement + '_betoTrack_cDayDriverWorkingHoursDBCtx').jqxMenu($scope.ctxMenuSettings);
        $('#' + $scope.uuidForElement + '_betoTrack_cDayDriverWorkingHoursDBCtx').on('itemclick', dvrWrkhrsContextHandler);
        isdvrWrkhrsCtxInitialized = true;
      }
      commonTrackService.initGridRightClickContextMenu(event, dvrWrkhrsContextMenu);
    }
  };

  function dvrWrkhrsContextHandler(event) {
    commonTrackService.executeContextMenuClick(event, 'dvrWrkhrsCtxSource', _contextSourceObj);
  }

  $scope.startCounter = function () {
    $scope.stop();
    $scope.isTimerStated = true;
    $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
    if ($scope.counter - 1 >= 1) {
      $scope.counter--;
      counterTimeout = $interval($scope.startCounter, 1000);
    } else {
      loadWorkingHours(config.vehicleGroup, false, $scope.dwrkHrsRepOption, true);
    }
  };

  $scope.stop = function () {
    $interval.cancel(counterTimeout);
  };

  $scope.moreFunctionsOnChange = function (event) {
    if (event.args.item.value === 'showReport') {
      var _objNameParam = event.args.item.originalItem.execute.split('-');
      _commonFunction[_objNameParam[0]](_objNameParam[1]);
    } else {
      if (event.args.item.originalItem.execute) {
        _commonFunction[event.args.item.originalItem.execute]();
      }
    }
    $('#moreFunDropDown').jqxDropDownList('clearSelection');
    $('#ordersMoreFunction').jqxDropDownList('clearSelection');
  };
  $scope.driverWrksListComboChange = function (event) {
    if (!event.args) {
      return;
    }
    var reportOption = event.args.item;

    var loginid = AuthenticationService.GetLoginID();
    localStorageService.set('driverWorkingHour.reportOption.' + loginid.Account + '.' + loginid.username, reportOption.value);

    if (reportOption && _tmpConfig.lastSelectedOption !== reportOption.value) {
      _tmpConfig.lastSelectedOption = reportOption.value;
      $scope.dwrkHrsRepOption = reportOption.value;
      loadWorkingHours(config.vehicleGroup, false, reportOption.value);
    }
  };

  $scope.stopAutoRefresh = commonTrackService.getRefreshStartStopfunction($scope, true, true, loadWorkingHours, 'vehicleGroupComboBox', false, 'cDayDriverWorkHoursRepOptionsComboBox');

  //job-vent listener
  var jobEvent = $scope.$on('job-event', function (event, data) {
    var _eventDateTime = new Date(data.eventTimeStamp * 1000);
    var _gridRefreshDateTime = new Date(_lastRefreshTimeS * 1000);
    //console.log('data.eventTimeStamp - ' + _eventDateTime);
    //console.log('grid refresh time - ' + _gridRefreshDateTime);
    // console.log(_eventDateTime > _gridRefreshDateTime);
    if (_eventDateTime > _gridRefreshDateTime) {
      var _tmpGridsource = workingHoursListSource.localdata;
      for (var i = 0; i < _tmpGridsource.length; i++) {
        if (_tmpGridsource[i].deviceid === data.dev) {
          _tmpGridsource[i].lastjobstatusdesc = data.statusdescription;
          _tmpGridsource[i].lastjobstatusdescColor = data.statusdescFgColor;
          _tmpGridsource[i].lastjobstatusdescBgColor = data.statusdescBgColor;
          _tmpGridsource[i].driverdesc = data.driverdesc !== null ? data.driverdesc : '';
          _tmpGridsource[i].date = $filter('date')(_eventDateTime, 'dd/MM/yyyy');
          _tmpGridsource[i].time = $filter('date')(_eventDateTime, 'HH:mm:ss');
          $scope.cDayDrvrWrkHoursGridSettings.source = _tmpGridsource;
          $('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('updatebounddata', 'data');
          break;
        }
      }
    }
  });

  $scope._iniDriverWorkHrsTab = function () {
    if (counterTimeout.$$state.value === 'canceled') {
      $scope.stop();
      $scope.stopAutoRefresh(null, 'start');
    }
  };

  var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
    $rootScope.$broadcast('vehicleMap_res_current_context', {
      dashboardName: 'dashboard.driverWrkHrsDashboard',
      isDataFromTab: true,
      tabNumber: 0,
      currentWidgetContextData: broadcastEventData,
      dataLoadingFinished: $scope.dataLoadingFinished,
      isDataAvailable: $scope.isDataAvailable
    });
  });

  var currentSelectedGroupEvent = $scope.$on('fleetMap_req_current_context', function () {
    $rootScope.$broadcast('fleetMap_res_current_context', {
      dashboardName: 'dashboard.driverWrkHrsDashboard',
      vehicleGroup: config.vehicleGroup
    });
  });
  // stateManagerService
  // Used when unkown dependant (child) widget requests data.
  // Since this is a global request for data, widget needs to check if the,
  // requested fields is anything it can provide before updating.
  // Will call the dataStateUpdate event if it updates data.
  var updateRequest = $scope.$on('reqDataUpdate', function () {
    var selectedRowData = {};
    var selectIndex = -1;

    selectIndex = window.$('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('getselectedrowindex');
    if (selectIndex > -1) {
      selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'cDayDriverWorkingHoursDBList').jqxGrid('getrowdata', selectIndex);
    }
    // push the changes to stateManagerService
    stateManagerService.updateValue('driverWrkHrsWidget', 'deviceID', selectedRowData.deviceid, true);
    stateManagerService.updateValue('driverWrkHrsWidget', 'driverID', selectedRowData.driverid, true);

    stateManagerService.updateValue('driverWrkHrsWidget', 'tab_0_selectedRow', selectedRowData, true);

    $rootScope.$broadcast('resDataUpdate', {
      widget: 'driverWrkHrsWidget',
      activeTab: 0,
      dashboardName: 'dashboard.driverWrkHrsDashboard',
      timespan: new Date().getTime()
    });
  });

  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  // Google maps takes focus if the auto refresh enabled
  // Auto refresh must be stoped if the chat window is open to solve focus switching
  var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
    $scope.stopAutoRefresh(null, 'stop');
  });
  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  //  restart the auto refresh is the chat window is closed
  var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
    $scope.stopAutoRefresh(null, 'start');
  });

  $scope.$on('$destroy', function () {
    if (chatWindowOpenEvent) {
      chatWindowOpenEvent();
    }
    if (chatWindowCloseEvent) {
      chatWindowCloseEvent();
    }
    $scope.stop();
    jobEvent();
    updateRequest();
    if ($scope.ctxMenuSettings && $scope.ctxMenuSettings.source) {
      delete $scope.ctxMenuSettings.source;
    }
    delete _contextSourceObj.dvrWrkhrsCtxSource;
    if ($scope.workingHoursListdataAdapter) {
      delete $scope.workingHoursListdataAdapter;
    }
    if ($scope.vehicleGroupSettings && $scope.vehicleGroupSettings.source) {
      delete $scope.vehicleGroupSettings.source;
    }
    if ($scope.cDayDrvrWrkHoursGridSettings && $scope.cDayDrvrWrkHoursGridSettings.source) {
      delete $scope.cDayDrvrWrkHoursGridSettings.source;
    }
    currentSelectedRowReqEvent();
    currentSelectedGroupEvent();
    destroyLastLocationCtxMenu();
  });

  function destroyLastLocationCtxMenu() {
    $('#' + $scope.uuidForElement + '_betoTrack_cDayDriverWorkingHoursDBCtx').unbind('itemclick', dvrWrkhrsContextHandler);
    $('#' + $scope.uuidForElement + '_betoTrack_cDayDriverWorkingHoursDBCtx').jqxMenu('destroy');
  }
}]).controller('DriverWorkingHoursEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {
  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '25', '50', '75', '100'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //material, // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/driverWorkingHours/driverWorkingHoursWidget.tpl.html', '<div class="row"><div ng-if="!dataLoadingFinished"><loading-animation></loading-animation></div><div class="col-xs-12 col-sm-12 col-md-12"><uib-tabset style="" class="track-tab-dsa"><uib-tab ng-click="_iniDriverWorkHrsTab()"><uib-tab-heading translate="dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList"></uib-tab-heading><div class="row" style="margin-top: 5px;"><div class="vehicle-list-widget-ctrl" style="padding:2px;"><div class="col-md-5 col-sm-12 col-xs-12"><div jqx-delete-directive="vehicleGroupComboBox" type="comboBox"><jqx-combo-box id="vehicleGroupComboBox" jqx-settings="vehicleGroupSettings" class="jqx-combo-box-dsa required" jqx-create="dataLoadingFinished" jqx-on-change="vehicleGroupComboChange(event)" ng-model="vehicleGroup" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-5 col-sm-12 col-xs-12"><div jqx-delete-directive="cDayDriverWorkHoursRepOptionsComboBox" type="comboBox"><jqx-combo-box id="cDayDriverWorkHoursRepOptionsComboBox" jqx-settings="cDayDriverWorkHoursRepOptions" class="jqx-combo-box-dsa required" jqx-create="dataLoadingFinished" jqx-on-change="driverWrksListComboChange(event)" ng-model="dwrkHrsRepOption" clear-input="" focus-blur=""></jqx-combo-box></div></div><div id="refreshBtn" class="col-md-2 col-sm-12 col-xs-12" ng-if="timerDesc"><button ng-click="stopAutoRefresh($event)" type="button" style="float: right; margin-right: 2.5px;" id="autoRefreshButton" class="btn btn-default"><span class="badge" ng-show="isTimerStated">{{counter}}</span><i ng-show="!isTimerStated" class="fa fa-play" aria-hidden="true"></i></button></div></div></div><div class="row" style="padding-top: 5px;" ng-show="isDataAvailable"><div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 2.5px;"><div contextmenu=""><div jqx-delete-directive="{{overviewGridPrefix}}cDayDriverWorkingHoursDBList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}cDayDriverWorkingHoursDBList" jqx-settings="cDayDrvrWrkHoursGridSettings" jqx-on-rowselect="cDayDriverWorkingHoursSelectHandler(event)" jqx-on-rowclick="gridRowClickHandler(event)" jqx-create="createCdayDrvrWrkHours" class="custom-header"></jqx-grid></div><div id="{{uuidForElement}}_betoTrack_cDayDriverWorkingHoursDBCtx"></div></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></uib-tab></uib-tabset></div></div>');
  }]);
})();

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/driverWorkingHours/driverWorkingHoursWidgetEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/fleetMap/fleetMapEdit.tpl.html', '<label translate="dashBoard.fleetManagement.vehicleList.frameHeight"></label> <input type="text" ng-model="fleetMap.height" class="form-control" font-weight="bolder" maxlength="4">');
  }]);
})();

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 4/28/2015.
 */



angular.module('dashboard.fleetMap', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('fleetMapWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.fleetMap.fleetMapTitle';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.fleetMap.description';
      }
    },
    controller: 'fleetMapCtrl',
    templateUrl: 'components/dashboard/fleetMap/fleetMapWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      height: 600
    },
    edit: {
      templateUrl: 'components/dashboard/fleetMap/fleetMapEdit.tpl.html',
      reload: false,
      controller: 'fleetMapEditCtrl'
    }
  });
}]).service('fleetMapWidgetService', function () {
  var _isWidgetInitialized = false;
  this.isWigetInitialized = function () {
    return _isWidgetInitialized;
  };
  this.setWigetInitialized = function (value) {
    _isWidgetInitialized = value;
  };
}).controller('fleetMapCtrl', ["$scope", "AuthenticationService", "$rootScope", "$timeout", "commonTrackService", "config", "fleetMapWidgetService", "vehicleMapWidgetService", "$window", "localStorageService", function ($scope, AuthenticationService, $rootScope, $timeout, commonTrackService, config, fleetMapWidgetService, vehicleMapWidgetService, $window, localStorageService) {

  $scope.height = config.height;
  $scope.isWidgetPreInitFinished = false;
  $scope.isWidgetPostInitFinished = false;
  $scope.currentGroupId = vehicleMapWidgetService.getGroupId() || '';

  var loginid = AuthenticationService.GetLoginID();
  var localStroageInfoBalloonState = localStorageService.get('fleetMapInfoBalloonState.' + loginid.Account + '.' + loginid.username);
  $scope.fleetMap = {
    showDisplayBalloon: localStroageInfoBalloonState !== undefined && localStroageInfoBalloonState !== null ? localStroageInfoBalloonState : 1
  };
  $scope.height = fleetMapWidgetService.isWigetInitialized() ? $window.innerHeight - 200 : config.height;
  $scope.mapUrl = '';

  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
    });
  };
  loadFleetServerDetails().then(function () {
    fleetMapWidgetService.setWigetInitialized(true);
  }).finally(function () {
    // Request for the current Parent Widget data , Selected Row details etc ..  Desigined to be be called only at the initial Loading .
    $timeout(function () {
      $rootScope.$broadcast('fleetMap_req_current_context');
    }, 0, false);
  });

  // Event from the source widget vehicleGroup DropDown/Combobox
  var vehcileGroupChangedEvt = $scope.$on('vehicleGroupChanged', function (event, data) {
    if ($scope.isWidgetPostInitFinished) {
      var groupId = data.selectedVehicleGroup;
      if (!groupId) {
        groupId = vehicleMapWidgetService.getGroupId();
      }
      $scope.currentGroupId = groupId || '';

      if (groupId) {
        vehicleMapWidgetService.setGroupId(groupId);
      }

      if (groupId && groupId !== '' && $scope.fleetServerUrl) {
        $timeout(function () {
          $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, '&page=map.fleet.full&buildingSiteLocationBtn=true&group=' + groupId, 'fleetMap');
        }, 0);
      } else {
        $scope.mapUrl = 'components/dashboard/vehicleMap/404.html';
      }
    }
  });

  var restResponseErrorEvt = $scope.$on('rest-error-event', function (event, response) {
    if (response.data && response.data.errors && response.data.errors.length > 0 && response.data.errors[0].code) {
      if (response.data.errors[0].code === 'CM0020') {
        $scope.mapUrl = 'components/dashboard/vehicleMap/404.html';
      }
    }
  });

  // update events from some of the Parent Widgets
  $scope.$on('fleet-map-update', function (event, data) {
    if ($('.chat-window-container').length === 0) {
      commonTrackService.iframePostMessage('jsmShowDetailPushpin(' + data.pushPinIndex + ', 0 ,' + '"' + data.deviceId + '"' + ' ,' + $scope.fleetMap.showDisplayBalloon + ')', 'fleetMap');
    }
  });

  $scope.showInfoBalloonCheckBoxChange = function () {
    if ($('.chat-window-container').length === 0) {
      commonTrackService.iframePostMessage('jsmShowDetailPushpin(' + -1 + ', 0 ,' + '"' + null + '"' + ' ,' + $scope.fleetMap.showDisplayBalloon + ')', 'fleetMap');
      localStorageService.set('fleetMapInfoBalloonState.' + loginid.Account + '.' + loginid.username, $scope.fleetMap.showDisplayBalloon);
    }
  };

  // Response from current Parent Widget for the request event 'leetMap_req_current_context'
  /**
   * Try to get the parent selected  row / related  data if not avilable will try 20 times in the interval of 50 milli seconds each
   */
  var maxGetInitialDataRetries = 20;
  var currentSelectedGroupEvent = $scope.$on('fleetMap_res_current_context', function (event, data) {
    --maxGetInitialDataRetries;
    var serviceGroupId = vehicleMapWidgetService.getGroupId();
    var contextGroupId = data.vehicleGroup;
    var groupId = serviceGroupId || contextGroupId;

    $scope.currentGroupId = groupId || '';

    if (groupId && groupId !== '') {
      $scope.isWidgetPostInitFinished = true;
      $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, '&page=map.fleet.full&buildingSiteLocationBtn=true&group=' + groupId, 'fleetMap');
    } else {
      if (maxGetInitialDataRetries > 0) {
        $timeout(function () {
          $rootScope.$broadcast('fleetMap_req_current_context');
        }, 50);
      } else {
        console.warn('Max Retries exceeded to get the current Parent data for FleetMap widget');
        $scope.mapUrl = 'components/dashboard/vehicleMap/404.html';
        $scope.isWidgetPostInitFinished = true;
        currentSelectedGroupEvent();
      }
      // Repeatedly try to get the data from parent .
    }
  });

  $scope.$on('$destroy', function () {
    vehcileGroupChangedEvt();
    restResponseErrorEvt();
    currentSelectedGroupEvent();
  });

  $scope.fleetMapLoadEvent = function () {
    $scope.isWidgetPreInitFinished = true; // Pre init animation must disaaper
    //console.log('iframe "#fleetMap" loaded ....');
  };
}]).controller('fleetMapEditCtrl', ["$scope", "config", function ($scope, config) {
  $scope.fleetMap = {
    height: config.height
  };
  $scope.$watch('fleetMap.height', function (height) {
    if (height) {
      config.height = height;
    }
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/fleetMap/fleetMapWidget.tpl.html', '<div class="row" style="min-height: 100px"><div ng-if="!isWidgetPreInitFinished || isWidgetPreInitFinished === false"><loading-animation></loading-animation></div><div ng-if="mapUrl.indexOf(\'404.html\') > -1"><no-data-available></no-data-available></div><div class="col-sm-12 col-md-12"><div ng-if="!(mapUrl.indexOf(\'404.html\') > -1)"><iframe id="fleetMap" ng-onload="fleetMapLoadEvent()" ng-src="{{mapUrl | trustAsResourceUrl}}" style="height : {{height}}px; width : 100%;border: 0; overflow: hidden;"></iframe><div class="row"><div class="col-lg-12 col-xs-12 col-md-12" style="height: 12px; margin-bottom: 8px; padding-left: 18px;"><form><input id="infoBaloonDiaplayCheckbox" type="checkbox" ng-model="fleetMap.showDisplayBalloon" ng-true-value="1" ng-false-value="0" ng-checked="fleetMap.showDisplayBalloon === 1" style="width: 17px;height: 20px;padding: 0px;margin: 0px;" ng-change="showInfoBalloonCheckBoxChange()"> <label for="infoBaloonDiaplayCheckbox" translate="dashBoard.fleetManagement.fleetMap.showInfoBalloon" style="position: relative; top: -5px;"></label></form></div></div></div></div></div>');
  }]);
})();

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by fky on 3/2/2017.
 */



angular.module('fmsDashboard', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('fmsdashboard', {
    parent: 'betotrack',
    url: '/fmsdashboard',
    ncyBreadcrumb: {
      label: 'Track'
    },
    views: {
      'content@app': {
        templateUrl: 'components/dashboard/fmsDashboard/fmsDashboard.tpl.html',
        controller: 'FmsDashboardCtrl'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Fleet Management Dashboard';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    }
  });
}]);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/fmsDashboard/fmsDashboard.tpl.html', '<div class="container-fluid mainContent"><div class="row"><div class="col-sm-12"><adf-dashboard name="{{dashBoardName}}" collapsible="{{collapsible}}" maximizable="{{maximizable}}" structure="3-9 (12/6-6)" adf-model="dashBoardModel" adf-widget-filter="widgetFilter"></adf-dashboard></div></div></div>');
  }]);
})();

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by fky on 3/2/2017.
 */



angular.module('betosyswebapp').controller('FmsDashboardCtrl', ["$rootScope", "$scope", "AuthenticationService", "base64", "localStorageService", "$translate", "commonTrackService", "dashboardService", "customerService", function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
  $scope.pageHeader = 'FMS Dashboard';

  var loginID = AuthenticationService.GetLoginID();

  //dash board
  $scope.username = loginID.username;
  $scope.dashBoardName = 'dashBoard.FmsDashboard.' + $scope.username;
  var model = localStorageService.get($scope.dashBoardName);

  if (!model) {
    model = customerService.getFmsDashboardConfig(commonTrackService.getViewPortName());
  }

  $scope.dashBoardModel = model;
  $scope.collapsible = true;
  $scope.maximizable = true;

  $scope.widgetFilter = function (widget, type) {
    if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
      return type;
    }
  };

  function notExist(type) {
    return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
  }
  var isExculdedParentWidgetArr = ['vehicleListWidget', 'tachoHistoryWidget', 'DriverWrkHrsWidget', 'tachoDownloadStatusWidget'];

  function isExculdedParentWidget(type) {
    for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
      if (type === isExculdedParentWidgetArr[j]) {
        return true;
      }
    }
    return false;
  }

  var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
    localStorageService.set(name, model);
  });

  var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
    if (data.updateWidgetTitle) {
      if (data.selectedRow) {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
      } else {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
      }
    }
  });

  var widgetDataFromServer = $scope.$on('init-widget-data-from-server', function (event, data) {
    if (data.selectedRow) {

      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
        name: 'tachoEventDetailWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
      }], data.selectedRow.date.replace('/', '.'));
    }
  });

  var vehicleGroupChangedEvnt = $scope.$on('vehicleGroupChanged', function (event, data) {
    commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getFleetBasedWidgetNameArray(), data.selectedVehicleGroupLabel);
  });

  $scope.$on('$destroy', function () {
    rowSelectedEvnt();
    adfDashboardChangedEvnt();
    vehicleGroupChangedEvnt();
    widgetDataFromServer();
  });
}]);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by fky on 3/3/2017.
 */


angular.module('dashboard.fmsDashboard', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('FMSVehicleWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.fmsVehicle.vehicleList';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.fmsVehicle.description';
      }
    },
    controller: 'FMSVehicleListCtrl',
    templateUrl: 'components/dashboard/fmsVehicle/fmsVehicleWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      vehicleGroup: null,
      noOfGridRows: ''
    },
    edit: {
      templateUrl: 'components/dashboard/fmsVehicle/fmsVehicleWidgetEdit.tpl.html',
      reload: false,
      controller: 'FMSVehicleEditCtrl'
    }
  });
}]).service('FMSVehicleWidgetService', ["crudService", function (crudService) {

  this.getEventDetailAllSummaryList = function (vechileGroup, isDataRefresh) {
    var requestParam = {
      statusCode: 'all',
      vehicleGroup: vechileGroup,
      dataRefresh: isDataRefresh,
      timeTo: '-0d',
      timeFrom: ''
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };
    var data = crudService.customGET('overview', 'eventdetailallsummary', param);
    //console.log('Data fetch completed');
    return data;
  };

  this.getVehicleEventDetailAllList = function (deviceId, isDataRefresh, startDate, endDate) {
    var requestParam = {
      statusCode: '',
      vehicleGroup: '',
      dataRefresh: isDataRefresh,
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'EventDetailAll'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'vehicleeventdetailfms/' + deviceId, param);
  };

  this.getVehicleTellTalesList = function (deviceId, isDataRefresh, startDate, endDate) {
    var requestParam = {
      statusCode: '',
      vehicleGroup: '',
      dataRefresh: isDataRefresh,
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'DeviceTellTaleDetails'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'vehicleeventdetailtelt/' + deviceId, param);
  };
}]).controller('FMSVehicleListCtrl', ["$scope", "config", "widgetSettingsCreatorService", "vehicleListWidgetService", "stateManagerService", "$rootScope", "$timeout", "$translate", "commonTrackService", "$filter", "AuthenticationService", "localStorageService", "$state", "FMSVehicleWidgetService", "errorHandlingService", "toastService", "$interval", function ($scope, config, widgetSettingsCreatorService, vehicleListWidgetService, stateManagerService, $rootScope, $timeout, $translate, commonTrackService, $filter, AuthenticationService, localStorageService, $state, FMSVehicleWidgetService, errorHandlingService, toastService, $interval) {
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.selectedFunction = '';
  $scope.isDataAvailable = true;
  $scope.activeTab = 0;
  $scope.uuidForElement = $scope.$id;
  $scope.vehicleAllDetailTab = {
    disable: true
  };

  $scope.dataSet = {
    deviceID: null,
    driverID: null,
    lastUpdateRequest: 0
  };

  $scope.vehicleAllDetail = {
    date: {
      startDate: new Date().setHours(0, 0, 0, 0),
      endDate: new Date()
    }
  };
  var _lastRefreshTimeS = null;
  //var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
  var counterSeconds = 60;
  var counterTimeout;
  var gtsUserSettings = null;
  var dateRangePickerSettings = {};
  var rowSize = vehicleListWidgetService.getRowSize();
  var vehicleListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };
  $scope.vehicleListdataAdapter = new $.jqx.dataAdapter(vehicleListSource);
  var fmsContextMenu = {};

  var isFmsCtxInitialized = false;

  $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
  });

  $scope.telltaleComboBoxSetting = widgetSettingsCreatorService.createComboxSettings({
    source: ['Blue', 'Yellow', 'Red'],
    multiSelect: true,
    placeHolder: 'Select TellTale Filter'
  });

  $scope.customGridProperties = {
    fmsVehicle: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
      pageable: false,
      columns: []
    },
    vehicleAllDetails: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
      pageable: false,
      columns: []
    },
    vehicleTelltaleDetails: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
      pageable: false,
      columns: []
    }
  };

  var moreFunctionSource = [{
    name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
    execute: 'createMessageEvent',
    value: 'sendMsg'
  }, {
    name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
    execute: 'createCommandEvent',
    value: 'sendCommand'
  }, {
    name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
    value: 'showDashboard',
    execute: 'showDashboard'
  }, {
    name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
    value: 'showDriverDashboard',
    execute: 'showDriverDashboard' /*, {
                                   name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
                                   value: 'showPortalCommand',
                                   execute: 'showPortalCommand'
                                   }*/
  }];

  $scope.moreFuctionSetting = vehicleListWidgetService.getMoreFunctionSettings();

  $scope.moreFuctionSetting.source = moreFunctionSource;

  /**
  *  temporay private variable  to store some global values , created to avoid using config object .
  *  dont use config which will be stored to localstorage and may cuase issues when reused from localstorage
  */
  var _tmpConfig = {};

  $scope.moreFunctionsOnChange = function (event) {
    if (event.args.item.originalItem.execute) {
      _commonFunction[event.args.item.originalItem.execute]();
    }
    $('#moreFunDropDown').jqxDropDownList('clearSelection');
  };

  function createMessageEvent() {
    $rootScope.$broadcast('newMsgEvent', {});
  }

  function createCommandEvent() {
    $rootScope.$broadcast('newCommandEvent', {});
  }

  function showDriverDashboard() {
    $state.go('driverdashboard');
  }

  function showDashboard() {
    $state.go('betotrack.dashboard');
  }

  function showPortalCommand() {
    $state.go('portalcommand');
  }

  var _commonFunction = {
    'createMessageEvent': createMessageEvent,
    'createCommandEvent': createCommandEvent,
    'showDashboard': showDashboard,
    'showDriverDashboard': showDriverDashboard,
    'showPortalCommand': showPortalCommand
  };

  var _contextSourceObj = {
    fmsCtxSource: [{
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
      execute: createMessageEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
      execute: createCommandEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
      execute: showDashboard
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
      execute: showDriverDashboard /*, {
                                   label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
                                   execute: showPortalCommand
                                   }*/
    }]
  };

  $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(110);
  $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
    source: _contextSourceObj.fmsCtxSource, popupZIndex: 999999
  });
  var loadGtsUserSettings = function loadGtsUserSettings() {
    return commonTrackService.getGtsUserSettings(false).then(function (userSettings) {
      gtsUserSettings = userSettings;
    });
  };

  var loadGtsAccountSettings = function loadGtsAccountSettings() {
    return commonTrackService.getGtsAccountSettings(true);
  };
  loadGtsAccountSettings();
  loadGtsUserSettings();

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {
        $scope.vehicleGroupSettings.source = vechileGroupList;
        var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

        if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) {
          // validate the local storage group is still valid ( group can change based on login )
          $scope.vehicleGroup = config.vehicleGroup;
        }

        if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {
            // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = cachedGroup;
            config.vehicleGroup = cachedGroup;
          }
        }

        if (!$scope.vehicleGroup) {
          $scope.vehicleGroup = vechileGroupList[0].groupID;
        }
      }
    });
  };
  loadVehicleGroup().finally(function () {
    $scope.dataLoadingFinished = true;
    if ($scope.vehicleGroup) {
      loadEventDetailAllSummaryList($scope.vehicleGroup, true);
    }
  });

  var loadEventDetailAllSummaryList = function loadEventDetailAllSummaryList(vehicleGroup, dataRefresh, isAutorefresh) {
    //console.log( 'loadEventDetailAllSummaryList() : - Request to Server At :'+ moment().format('HH:mm:ss.SSS'));

    $scope.stop();
    //statusCode = statusCode !== undefined && statusCode !== null ? statusCode : 'all';
    return FMSVehicleWidgetService.getEventDetailAllSummaryList(vehicleGroup, dataRefresh).then(function (vehicleResult) {
      //console.log( 'loadEventDetailAllSummaryList() : Data Returned from server - At : '+ moment().format('HH:mm:ss.SSS'));

      // if(!vehicleResult.dataList || vehicleResult.dataList.length === 0){
      //   //Looking into cause of no result being returned
      //   console.log(vehicleResult);
      // }

      if (vehicleResult.dataList) {
        $scope.isDataAvailable = true;

        if (dataRefresh) {
          $scope.customGridProperties.fmsVehicle.columns = commonTrackService.getColumnProperties(vehicleResult.gridSettings.overviewListGrids[0].columnProperties, vehicleResult.columnTranslation, { moduleName: 'fmsVehicle' });

          vehicleListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'fmsVehicleList', vehicleListSource);

          vehicleListSource.localdata = vehicleResult.dataList;
          _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
          var _preferedDeviceId = gtsUserSettings.preferredDeviceID;
          var _preferedVehicleRowIndex = null;
          // users preferred vehicle selection from user settings.
          if (_preferedDeviceId && dataRefresh && $state.previous.name === 'login') {
            for (var i = 0; i < vehicleListSource.localdata.length; i++) {
              if (_preferedDeviceId === vehicleListSource.localdata[i].deviceid) {
                _preferedVehicleRowIndex = i;
                break;
              }
            }
          }
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleList') };
          $scope.fmsVehicleListGridSettings = commonTrackService.getGridSettings('fmsVehicle', $scope.customGridProperties.fmsVehicle, _preferedVehicleRowIndex, _additionalProperties);

          $scope.fmsVehicleListGridSettings.source = $scope.vehicleListdataAdapter;
          //console.log( 'loadEventDetailAllSummaryList() : - Source adaptor attached to grid  At :  '+ moment().format('HH:mm:ss.SSS'));

          $scope.createFmsVehicleList = true;
        } else {
          vehicleListSource.localdata = vehicleResult.dataList;
          _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'fmsVehicleList');
          //console.log( 'loadEventDetailAllSummaryList() : - Source update Bound Data At :  '+ moment().format('HH:mm:ss.SSS'));
        }
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {

      $scope.counter = counterSeconds;
      $scope.createFmsVehicleList = true;

      if ($scope.isDataAvailable && !counterTimeout || $scope.isDataAvailable && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled') {
        $scope.startCounter();
      } else {
        $scope.stop();
      }

      // send row select event after evey request to update the broadcastEventData[selected grid row details].

      // send row select event after evey request to update the broadcastEventData[selected grid row details].

      var rows = $('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrows');
      var _lastSelectedRowIndex = commonTrackService.getSelectRowIndexByCache(rows);
      if (_lastSelectedRowIndex < 0) {
        broadcastEventData.selectedRow = null;
        broadcastEventData.dashboardName = 'dashboard.fmsDashboard';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = $scope.activeTab;
        broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
        $rootScope.$broadcast('rowSelected', broadcastEventData);

        return;
      }
      if (isAutorefresh && _lastSelectedRowIndex || !dataRefresh && _lastSelectedRowIndex || _lastSelectedRowIndex === 0) {
        broadcastEventData.isRefreshStarted = true;
        $('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('selectrow', _lastSelectedRowIndex);
      }
      //console.log( 'loadEventDetailAllSummaryList() : Request finalization method finished At : '+ moment().format('HH:mm:ss.SSS'));
    });
  };

  var broadcastEventData = {
    selectedRow: {},
    selectedVehicleGroup: '',
    selectedVehicleGroupLabel: '',
    eventSource: ''
  };

  $scope.vehicleGroupComboChange = function (event) {
    var vehicleGroup = event.args.item;
    // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
    if (config.vehicleGroup !== vehicleGroup.value) {
      if ($scope.fmsVehicleListGridSettings) {
        loadEventDetailAllSummaryList(vehicleGroup.value, $scope.fmsVehicleListGridSettings.columns.length > 0 ? false : true);
      }
    }
    if (vehicleGroup) {
      broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
      broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
      config.vehicleGroup = vehicleGroup.value;
      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, config.vehicleGroup);
      commonTrackService.setLastSelectedGroup(vehicleGroup);
      broadcastEventData.dashboardName = 'dashboard.fmsDashboard';
      broadcastEventData.isDataFromTab = true;
      broadcastEventData.tabNumber = $scope.activeTab;
      $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
    }
  };

  $scope.gridRowClickHandler = function (event) {
    if (event.args.rightclick) {
      if (!isFmsCtxInitialized) {
        fmsContextMenu = $('#' + $scope.uuidForElement + '_betoTrack_fmsVehicleCtx').jqxMenu($scope.ctxMenuSettings);
        $('#' + $scope.uuidForElement + '_betoTrack_fmsVehicleCtx').on('itemclick', fmsVehicleListContextHandler);
        isFmsCtxInitialized = true;
      }
      commonTrackService.initGridRightClickContextMenu(event, fmsContextMenu);
    }
  };

  function fmsVehicleListContextHandler(event) {
    commonTrackService.executeContextMenuClick(event, 'fmsCtxSource', _contextSourceObj);
  }

  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        if ($scope.activeTab === 1) {
          $scope.vehicleAllDetail.date.startDate = moment($scope.vehicleAllDetail.date.startDate);
          $scope.vehicleAllDetail.date.endDate = moment($scope.vehicleAllDetail.date.endDate);

          _tmpConfig.startDate = $scope.vehicleAllDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
          _tmpConfig.endDate = $scope.vehicleAllDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
          loadVechileEventDetailList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate);
        }
      }
    }
  };

  commonTrackService.getDatePickerDetails().then(function (settings) {
    var tab = $scope.activeTab === 1 ? 'EventDetailAll' : undefined;
    $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, tab));
    dateRangePickerSettings = settings;
  });

  function _initRequestData(dateRangeScopeName, formatType) {
    var _typeOfGridRow = 'selectedRow';
    if (broadcastEventData[_typeOfGridRow].deviceid) {
      _tmpConfig.deviceId = broadcastEventData[_typeOfGridRow].deviceid;
      var _serverTimeFormat = {};
      _serverTimeFormat._tmpEndDate = commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, broadcastEventData[_typeOfGridRow].time, formatType);
      _serverTimeFormat._tmpStartDate = commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, '00:00:00', formatType);

      $scope[dateRangeScopeName] = {
        date: {
          startDate: new Date(_serverTimeFormat._tmpStartDate.replaceAt(10, ' ')),
          endDate: new Date(_serverTimeFormat._tmpEndDate.replaceAt(10, ' '))
        }
      };

      return _serverTimeFormat;
    } else {
      return null;
    }
  }

  $scope.stopAutoRefresh = function (event, type) {
    if (event) {
      commonTrackService.getRefreshStartStopfunction($scope, true, true, loadEventDetailAllSummaryList, 'vehicleGroupComboBox', false, true, event)();
    } else {
      if (type === 'start') {
        $scope.isTimerStated = false;
      } else {
        $scope.isTimerStated = true;
      }
      commonTrackService.getRefreshStartStopfunction($scope, true, true, loadEventDetailAllSummaryList, 'vehicleGroupComboBox', false, true)();
    }
  };

  $scope._initFMSVehicleTab = function () {
    commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));

    $rootScope.$broadcast('tabEvent', {
      'tabName': 'FMSVehicle',
      dashboardName: 'dashboard.fmsDashboard',
      isDataFromTab: true,
      tabNumber: 0,
      deviceId: _tmpConfig.deviceId
    });
    if (!$scope.isStopedByUser) {
      $scope.stop();
      $scope.stopAutoRefresh(null, 'start');
    }
    broadcastEventData.lastTabName = 'FMSVehicle';
  };

  $scope._initVehicleAllDetailTab = function () {
    commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, 'EventDetailAll'));

    $scope.stopAutoRefresh(null, 'stop');
    var timeFormat = _initRequestData('vehicleAllDetail');
    if (timeFormat) {
      var tmpFromDate = moment(timeFormat._tmpEndDate, 'YYYY/MM/DD/HH:mm:ss');
      tmpFromDate.subtract({ hours: 2 });
      timeFormat._tmpStartDate = tmpFromDate.format('YYYY/MM/DD/HH:mm:ss');
      $scope.vehicleAllDetail.date.startDate = timeFormat._tmpStartDate;
      loadVechileEventDetailList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleAllDetails.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate);
    }
  };

  $scope._initVehicleTellTaleTab = function () {
    commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));

    $scope.stopAutoRefresh(null, 'stop');
    var timeFormat = _initRequestData('vehicleTellTale');
    if (timeFormat) {
      $scope.vehicleTellTale.date.startDate = timeFormat._tmpStartDate;
      loadvehicleTellTaleList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleTelltaleDetails.columns.length > 0 ? false : true, timeFormat._tmpEndDate, timeFormat._tmpEndDate);
    }
  };

  // vehicle details tab functions
  var loadVechileEventDetailList = function loadVechileEventDetailList(deviceId, dataRefresh, startDate, endDate) {
    return FMSVehicleWidgetService.getVehicleEventDetailAllList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleEventDetailResult) {
      if (vehicleEventDetailResult.dataList) {
        if (dataRefresh) {
          $scope.customGridProperties.vehicleAllDetails.columns = commonTrackService.getColumnProperties(vehicleEventDetailResult.gridSettings.overviewListGrids[0].columnProperties, vehicleEventDetailResult.columnTranslation, { moduleName: 'vehicleAllDetails' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleAllDetailsTab.vehicleAllDetails') };
          $scope.vehicleAllDetailsGridSettings = commonTrackService.getGridSettings('vehicleAllDetails', $scope.customGridProperties.vehicleAllDetails, null, _additionalProperties);
          $scope.vehicleAllDetailsGridSettings.source = vehicleEventDetailResult.dataList;
        } else {
          $scope.vehicleAllDetailsGridSettings.source = vehicleEventDetailResult.dataList;
        }
        if ($scope.activeTab === 1) {
          $rootScope.$broadcast('tabEvent', {
            'tabName': 'vechileEventDetail',
            'repoVehicle': deviceId,
            'startDate': startDate,
            'endDate': endDate,
            dashboardName: 'dashboard.fmsDashboard',
            isDataFromTab: true,
            tabNumber: 1
          });
        }

        // expecting map to be ready after 4 seconds and send row select which will update map for pushpin
        $timeout(function () {
          var rowindex = $('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('getselectedrowindex');
          if (rowindex > vehicleEventDetailResult.dataList.length - 1 || rowindex < 0) {
            rowindex = 0;
          }
          $('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('selectrow', rowindex);
        }, 3000);
      }
    }).finally(function () {
      $scope.createVehicleAllDetilListGrid = true;
      broadcastEventData.lastTabName = 'vehicleAllDetails';
    });
  };

  $scope.isTelltaleAvailable = false;

  // vehicle telltake tab function
  var loadvehicleTellTaleList = function loadvehicleTellTaleList(deviceId, dataRefresh, startDate, endDate) {
    return FMSVehicleWidgetService.getVehicleTellTalesList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleTellTaleResult) {
      if (vehicleTellTaleResult.dataList) {
        $scope.isTelltaleAvailable = true;
        if (dataRefresh) {
          $scope.customGridProperties.vehicleTelltaleDetails.columns = commonTrackService.getColumnProperties(vehicleTellTaleResult.gridSettings.overviewListGrids[0].columnProperties, vehicleTellTaleResult.columnTranslation, { moduleName: 'vehicleTellTales' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.fmsVehicle.vehicleTellTalesTab.vehicleTellTales') };
          $scope.vehicleTellTalesGridSettings = commonTrackService.getGridSettings('vehicleTellTales', $scope.customGridProperties.vehicleTelltaleDetails, null, _additionalProperties);
          $scope.vehicleTellTalesGridSettings.source = vehicleTellTaleResult.dataList;
        } else {
          $scope.vehicleTellTalesGridSettings.source = vehicleTellTaleResult.dataList;
        }

        if ($scope.activeTab === 2) {
          // SCL-1340
          $rootScope.$broadcast('telltaleDataUpdate', {
            'tabName': 'vehicleTellTale',
            deviceId: _tmpConfig.deviceId,
            dashboardName: 'dashboard.fmsDashboard',
            isDataFromTab: true,
            date: $scope.telltaleData.date,
            dateTimespan: $scope.telltaleData.timestamp,
            tabNumber: 2
          });

          var selectIndex = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getselectedrowindex');
          var selectedFmsDashboardRow = {};
          if (selectIndex > -1) {
            selectedFmsDashboardRow = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrowdata', selectIndex);
          }

          var tellTaleRowData = {};

          stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 0 + '_selectedRow', selectedFmsDashboardRow, true);
          stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 2 + '_selectedRow', tellTaleRowData, true);

          $rootScope.$broadcast('dataStateUpdate', {
            widget: 'fmsVehicleWidget', activeTab: $scope.activeTab,
            dashboardName: 'dashboard.fmsDashboard'
          });
        }

        // expecting map to be ready after 4 seconds and send row select which will update map for pushpin
        $timeout(function () {
          var rowindex = $('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getselectedrowindex');
          if (rowindex > vehicleTellTaleResult.dataList.length - 1 || rowindex < 0) {
            rowindex = 0;
          }
          $('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('selectrow', rowindex);
          tellTaleRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getrowdata', rowindex);
          stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 2 + '_selectedRow', tellTaleRowData, true);
        }, 3000, false);
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isTelltaleAvailable = false;
      }
    }).finally(function () {
      $scope.createTellTaleListGrid = true;
      broadcastEventData.lastTabName = 'vehicleTellTales';
    });
  };

  $scope.rowSelectHandler = function (event) {
    var _vehicleDetailRow = {};
    _vehicleDetailRow.selectedRow = event.args.row;
    _vehicleDetailRow.selectedRow.deviceid = broadcastEventData.selectedRow.deviceid;

    _vehicleDetailRow.gridName = 'vehicleAllDetail';
    _vehicleDetailRow.updateMapUrl = false;
    _vehicleDetailRow.updateWidgetTitle = false;
    _vehicleDetailRow.isTermoWidgetDependent = true; // SCL-1496
    if ($scope.activeTab === 1) {
      _vehicleDetailRow.dashboardName = 'dashboard.fmsDashboard';
      _vehicleDetailRow.isDataFromTab = true;
      _vehicleDetailRow.gridName = 'vehicleDetail'; // event detail widget is triggered by this gridName
      _vehicleDetailRow.tabNumber = $scope.activeTab;
      _vehicleDetailRow.eventType = 'fms_vehicle_list_row_select';
      $rootScope.$broadcast('rowSelected', _vehicleDetailRow);
      if (event.type === 'rowselect') {
        commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'vehicleMap');
      }
    } else if ($scope.activeTab === 2) {
      _vehicleDetailRow.dashboardName = 'dashboard.fmsDashboard';
      _vehicleDetailRow.isDataFromTab = true;
      _vehicleDetailRow.tabNumber = $scope.activeTab;
      $rootScope.$broadcast('rowSelected', _vehicleDetailRow);
    }

    var row = event.args.row;
    $scope.dataSet.deviceID = row.deviceid;
    $scope.dataSet.driverID = row.driverid;

    //var reportDatetime = commonTrackService.formatReportDateTime(row.date, row.time);

    stateManagerService.updateValue('fmsVehicleWidget', 'deviceID', $scope.dataSet.deviceID, true);
    stateManagerService.updateValue('fmsVehicleWidget', 'driverID', $scope.dataSet.driverID, true);
    // stateManagerService.updateValue('fmsVehicleWidget', 'startDate', reportDatetime, true);
    // stateManagerService.updateValue('fmsVehicleWidget', 'endDate', reportDatetime, true);
    stateManagerService.updateValue('fmsVehicleWidget', 'rowData', _vehicleDetailRow, false);
    stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, true);

    $rootScope.$broadcast('dataStateUpdate', {
      widget: 'fmsVehicleWidget', activeTab: $scope.activeTab,
      dashboardName: 'dashboard.fmsDashboard'
    });
  };

  $scope.startCounter = function () {
    $scope.stop();
    $scope.isTimerStated = true;
    $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
    if ($scope.counter - 1 >= 1) {
      $scope.counter--;
      counterTimeout = $interval($scope.startCounter, 1000);
    } else {
      var _vehicleGroup = $('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');
      if (_vehicleGroup && _vehicleGroup.value) {
        loadEventDetailAllSummaryList(_vehicleGroup.value, false, true);
      } else {
        var errorObj = {
          type: 'F',
          message: $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleGroupValidation')
        };
        toastService.showErrorToast(errorObj);
        $scope.stop();
      }
    }
  };

  $scope.stop = function () {
    $interval.cancel(counterTimeout);
  };
  var _lastSelectedRowIndex = -1;
  // update vehicle map widget  based on selected vechile id
  $scope.fmsVehicleListSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      _lastSelectedRowIndex = event.args.rowindex;
      broadcastEventData.selectedRow = event.args.row;
      broadcastEventData.updateMapUrl = broadcastEventData.lastTabName === 'vehicleAllDetails' ? false : true;
      broadcastEventData.updateWidgetTitle = true;
      broadcastEventData.eventType = 'fms_vehicle_list_row_select';
      if ($scope.activeTab === 0) {
        broadcastEventData.dashboardName = 'dashboard.fmsDashboard';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = $scope.activeTab;
        broadcastEventData.isTermoWidgetDependent = true; // SCL-1496
        $rootScope.$broadcast('rowSelected', broadcastEventData);
        $rootScope.$broadcast('init-widget-data-from-server', { deviceID: event.args.row.deviceid, selectedRow: event.args.row });
      }
      commonTrackService.setLastLocatioWidgetData(broadcastEventData);
      var pushPinIndex = event.args.row.index - 1;
      $rootScope.$broadcast('fleet-map-update', { pushPinIndex: pushPinIndex, deviceId: event.args.row.deviceid });
      $scope.vehicleAllDetailTab.disable = false;

      //
      $scope.telltaleData = {};
      $scope.telltaleData.timestamp = event.args.row.telltaletimestamp;
      $scope.telltaleData.hasdate = $scope.telltaleData.timestamp > 0;
      $scope.telltaleData.date = ($scope.telltaleData.hasdate ? moment.unix($scope.telltaleData.timestamp) : moment(0)).format('YYYY/MM/DD/HH:mm:ss');
      // $scope.vehicleTellTaleTab.disable = false;
      //save
      var loginid = AuthenticationService.GetLoginID();

      $scope.dataSet.deviceID = broadcastEventData.selectedRow.deviceid;
      $scope.dataSet.driverID = broadcastEventData.selectedRow.driverid;

      // var reportDatetime = commonTrackService.formatReportDateTime(broadcastEventData.selectedRow.date, broadcastEventData.selectedRow.time);

      stateManagerService.updateValue('fmsVehicleWidget', 'deviceID', $scope.dataSet.deviceID, true);
      stateManagerService.updateValue('fmsVehicleWidget', 'driverID', $scope.dataSet.driverID, true);
      stateManagerService.updateValue('fmsVehicleWidget', 'rowData', broadcastEventData, false);
      stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + $scope.activeTab + '_selectedRow', broadcastEventData.selectedRow, true);

      $rootScope.$broadcast('dataStateUpdate', {
        widget: 'fmsVehicleWidget', activeTab: $scope.activeTab,
        dashboardName: 'dashboard.fmsDashboard'
      });

      localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
        'deviceid': broadcastEventData.selectedRow.deviceid,
        'driverid': broadcastEventData.selectedRow.driverid
      });
    }
  };

  //job-vent listener
  var jobEvent = $scope.$on('job-event', function (event, data) {
    var _eventDateTime = new Date(data.eventTimeStamp * 1000);
    var _gridRefreshDateTime = new Date(_lastRefreshTimeS * 1000);
    // console.log('data.eventTimeStamp - ' + _eventDateTime);
    // console.log('grid refresh time - ' + _gridRefreshDateTime);
    // console.log(_eventDateTime > _gridRefreshDateTime);
    if (_eventDateTime > _gridRefreshDateTime) {
      var _tmpGridsource = vehicleListSource.localdata;
      for (var i = 0; i < _tmpGridsource.length; i++) {
        if (_tmpGridsource[i].deviceid === data.dev) {
          _tmpGridsource[i].lastjobstatusdesc = data.statusdescription;
          _tmpGridsource[i].lastjobstatusdescColor = data.statusdescFgColor;
          _tmpGridsource[i].lastjobstatusdescBgColor = data.statusdescBgColor;
          _tmpGridsource[i].driverdesc = data.driverdesc !== null ? data.driverdesc : '';
          _tmpGridsource[i].date = $filter('date')(_eventDateTime, 'dd/MM/yyyy');
          _tmpGridsource[i].time = $filter('date')(_eventDateTime, 'HH:mm:ss');
          $scope.fmsVehicleListGridSettings.source = _tmpGridsource;
          $('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('updatebounddata', 'data');
          break;
        }
      }
    }
  });
  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    var tab = $scope.activeTab === 1 ? 'EventDetailAll' : undefined;
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, tab));
  });

  var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
    $rootScope.$broadcast('vehicleMap_res_current_context', {
      dashboardName: 'dashboard.fmsDashboard',
      isDataFromTab: true,
      tabNumber: $scope.activeTab,
      currentWidgetContextData: broadcastEventData,
      dataLoadingFinished: $scope.dataLoadingFinished,
      isDataAvailable: $scope.isDataAvailable
    });
  });
  var currentSelectedGroupEvent = $scope.$on('fleetMap_req_current_context', function () {
    $rootScope.$broadcast('fleetMap_res_current_context', {
      dashboardName: 'dashboard.fmsDashboard',
      vehicleGroup: config.vehicleGroup
    });
  });

  // stateManagerService
  // Used when unkown dependant (child) widget requests data.
  // Since this is a global request for data, widget needs to check if the,
  // requested fields is anything it can provide before updating.
  // Will call the dataStateUpdate event if it updates data.
  var updateRequest = $scope.$on('reqDataUpdate', function () {
    var selectedRowData = {};
    var selectIndex = -1;
    var selectedFmsDashboardRow = {};

    switch ($scope.activeTab) {
      case 0:
        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedFmsDashboardRow = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrowdata', selectIndex);
        }
        break;
      case 1:
        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleAllDetailsList').jqxGrid('getrowdata', selectIndex);
        }
        break;
      case 2:
        //uses same row select Logic
        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleTellTalesList').jqxGrid('getrowdata', selectIndex);
        }

        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedFmsDashboardRow = window.$('#' + $scope.overviewGridPrefix + 'fmsVehicleList').jqxGrid('getrowdata', selectIndex);
        }

        break;
    }

    // push the changes to stateManagerService

    if ($scope.activeTab > 0) {
      stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + $scope.activeTab + '_selectedRow', selectedRowData, true);
      stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 0 + '_selectedRow', selectedFmsDashboardRow, true);
    } else if (!_.isEmpty(selectedFmsDashboardRow)) {
      // first tab must always return a valid selected values
      stateManagerService.updateValue('fmsVehicleWidget', 'tab_' + 0 + '_selectedRow', selectedFmsDashboardRow, true);
    }
    $rootScope.$broadcast('resDataUpdate', {
      widget: 'fmsVehicleWidget',
      activeTab: $scope.activeTab,
      dashboardName: 'dashboard.fmsDashboard',
      timespan: new Date().getTime()
    });
  });

  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  // Google maps takes focus if the auto refresh enabled
  // Auto refresh must be stoped if the chat window is open to solve focus switching
  var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
    // stop the auto refresh only if an existing timer is detected under the last location tab
    // bug 105133
    if ($scope.isTimerStated && $scope.activeTab === 0) {
      // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
      $scope.stopAutoRefresh(null, 'stop');
    }
  });
  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  //  restart the auto refresh is the chat window is closed
  var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
    // bug 105133
    if (!$scope.isTimerStated && $scope.activeTab === 0) {
      // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
      $scope.stopAutoRefresh(null, 'start');
    }
  });

  $scope.$on('$destroy', function () {

    if (chatWindowOpenEvent) {
      chatWindowOpenEvent();
    }
    if (chatWindowCloseEvent) {
      chatWindowCloseEvent();
    }

    updateDateRangeInternalDateEvent();

    if ($scope.vehicleListdataAdapter) {
      delete $scope.vehicleListdataAdapter;
    }
    if ($scope.fmsVehicleListGridSettings && $scope.fmsVehicleListGridSettings.source) {
      delete $scope.fmsVehicleListGridSettings.source;
    }
    $scope.stop();
    jobEvent();
    currentSelectedRowReqEvent();
    currentSelectedGroupEvent();
    try {
      destroyLastLocationCtxMenu();
    } catch (err) {
      console.log(err);
    }

    updateRequest();
  });

  function destroyLastLocationCtxMenu() {
    $('#' + $scope.uuidForElement + '_betoTrack_fmsVehicleCtx').unbind('itemclick', fmsVehicleListContextHandler);
    $('#' + $scope.uuidForElement + '_betoTrack_fmsVehicleCtx').jqxMenu('destroy');
  }
}]).controller('FMSVehicleEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {
  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '20', '25', '50', '75', '100'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/fmsVehicle/fmsVehicleWidget.tpl.html', '<div class="row"><div ng-if="!dataLoadingFinished"><loading-animation></loading-animation></div><div class="col-xs-12 col-sm-12 col-md-12"><uib-tabset style="" active="activeTab" class="track-tab-dsa"><uib-tab ng-click="_initFMSVehicleTab()" id="fMSVehicleTab" index="0"><uib-tab-heading translate="dashBoard.fleetManagement.fmsVehicle.vehicleList"></uib-tab-heading><div class="row" style="margin-top: 5px;"><div class="vehicle-list-widget-ctrl" style="padding:2px;"><div class="col-md-5 col-sm-12 col-xs-12"><div jqx-delete-directive="vehicleGroupComboBox" type="comboBox"><jqx-combo-box id="vehicleGroupComboBox" jqx-settings="vehicleGroupSettings" class="jqx-combo-box-dsa required" jqx-create="dataLoadingFinished" jqx-on-change="vehicleGroupComboChange(event)" ng-model="vehicleGroup" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-5 col-sm-12 col-xs-12"><div jqx-delete-directive="moreFunDropDown" type="dropDownList"><jqx-drop-down-list id="moreFunDropDown" ng-model="selectedFunction" jqx-ng-model="" jqx-settings="moreFuctionSetting" jqx-on-change="moreFunctionsOnChange(event)" jqx-create="createFmsVehicleList" ignore-dirty=""></jqx-drop-down-list></div></div><div id="refreshBtn" class="col-md-2 col-sm-12 col-xs-12" ng-if="timerDesc"><button ng-click="stopAutoRefresh($event)" type="button" style="float: right;margin-right: 2.5px;" id="autoRefreshButton" class="btn btn-default"><span class="badge" ng-show="isTimerStated">{{counter}}</span><i ng-show="!isTimerStated" class="fa fa-play" aria-hidden="true"></i></button></div></div></div><div class="row" style="padding-top: 5px;" ng-show="isDataAvailable"><div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 2.5px;"><div contextmenu=""><div jqx-delete-directive="{{overviewGridPrefix}}fmsVehicleList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}fmsVehicleList" jqx-settings="fmsVehicleListGridSettings" jqx-on-rowselect="fmsVehicleListSelectHandler(event)" jqx-on-rowclick="gridRowClickHandler(event)" jqx-create="createFmsVehicleList" class="custom-header"></jqx-grid></div><div id="{{uuidForElement}}_betoTrack_fmsVehicleCtx"></div></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></uib-tab><uib-tab disable="vehicleAllDetailTab.disable" id="vehicleAllDetailsTab" ng-click="_initVehicleAllDetailTab()" index="1"><uib-tab-heading translate="dashBoard.fleetManagement.fmsVehicle.vehicleAllDetailsTab.vehicleAllDetails"></uib-tab-heading><div class="row" style="margin-top: 5px;"><div class="col-md-5 col-sm-10 col-xs-10" style="margin-bottom: 2.5px;padding-left:18px;"><div ng-show="!vehicleAllDetailTab.disable"><input date-range-picker="" id="daterange4" name="daterange4" class="form-control date-picker" type="text" ng-model="vehicleAllDetail.date" clearable="true" options="options" required=""></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12" style=""><div jqx-delete-directive="{{overviewGridPrefix}}vehicleAllDetailsList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}vehicleAllDetailsList" jqx-settings="vehicleAllDetailsGridSettings" jqx-on-rowselect="rowSelectHandler(event)" jqx-create="createVehicleAllDetilListGrid" class="custom-header"></jqx-grid></div></div></div><div class="row"><uib-alert ng-show="error" type="danger" close="closeAlert()" style="margin-bottom: 0px;padding-top:5px;padding-bottom:5px;"><div>{{error}}</div></uib-alert></div></uib-tab><uib-tab disable="vehicleAllDetailTab.disable" id="vehicleTellTalesTab" ng-click="_initVehicleTellTaleTab()" index="2"><uib-tab-heading translate="dashBoard.fleetManagement.fmsVehicle.vehicleTellTalesTab.vehicleTellTales"></uib-tab-heading><div ng-if="isTelltaleAvailable"><div class="row" style="margin-top: 5px;"><div class="col-md-5 col-sm-10 col-xs-10" style="margin-bottom: 2.5px;padding-left:18px;"><div ng-show="telltaleData.hasdate"><input date-picker="" id="teltEventDate" name="teltEventDate" class="form-control date-picker" type="text" ng-model="telltaleData.date" clearable="true" options="options" disabled=""></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12" style=""><div jqx-delete-directive="{{overviewGridPrefix}}vehicleTellTalesList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}vehicleTellTalesList" jqx-settings="vehicleTellTalesGridSettings" jqx-create="createTellTaleListGrid" class="custom-header"></jqx-grid></div></div></div><div class="row"><uib-alert ng-show="error" type="danger" close="closeAlert()" style="margin-bottom: 0px;padding-top:5px;padding-bottom:5px;"><div>{{error}}</div></uib-alert></div></div><div ng-show="!isTelltaleAvailable"><no-authorize></no-authorize></div></uib-tab></uib-tabset></div></div>');
  }]);
})();

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/fmsVehicle/fmsVehicleWidgetEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)" style="overflow: hidden!important;"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/25/2016.
 */


angular.module('dashboard.pendingCommands', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('pendingCommandsWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.digitalOutputsWidget.title';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.digitalOutputsWidget.description';
      }
    },
    title: 'Pending Commands',
    description: 'Displays Pending Commands',
    controller: 'pendingCommandsCtrl',
    templateUrl: 'components/dashboard/pendingCommands/pendingCommandsWidget.tpl.html',
    isSingleInstance: true,
    config: {
      statusCodeList: [],
      vehicleList: [],
      vehicleGroup: null,
      vehicleGroupList: [],
      statusCode: null,
      noOfGridRows: '',
      height: 300
    }
  });
}]).service('pendingCommandsService', ["crudService", function (crudService) {
  this.getPendingCommandsList = function (statusCode, deviceId) {
    return crudService.customGET('portalcommands', 'pendingcommandslist/' + statusCode + '/' + deviceId);
  };
}]).controller('pendingCommandsCtrl', ["$scope", "widgetSettingsCreatorService", "pendingCommandsService", "commonTrackService", "$translate", "errorHandlingService", function ($scope, widgetSettingsCreatorService, pendingCommandsService, commonTrackService, $translate, errorHandlingService) {
  var _deviceID = null;
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.pendingCommandComboBoxSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'status',
    selectedIndex: 0,
    change: function change(event) {
      var args = event.args;
      if (args) {
        var statusCode = args.item.originalItem.status;
        if (statusCode && _deviceID) {
          loadPendingCommandsList(statusCode, _deviceID, false);
        }
      }
    },
    source: [{
      description: 'Pending',
      status: 0
    }]
  });

  $scope.customGridProperties = {
    height: '200px',
    pageable: false,
    columns: []
  };

  var loadPendingCommandsList = function loadPendingCommandsList(statusCode, deviceid, dataRefresh) {
    return pendingCommandsService.getPendingCommandsList(statusCode, deviceid).then(function (result) {
      if (result) {
        var dataSource;
        if (dataRefresh) {
          $scope.columnPropertiesList = result.gridSettings.overviewListGrids[0].columnProperties;
          $scope.customGridProperties.columns = commonTrackService.getColumnProperties(result.gridSettings.overviewListGrids[0].columnProperties, {}, { moduleName: 'pendingCommands' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.pendingCommandsWidget.title') };
          $scope.pendingCommandsListGridSettings = commonTrackService.getGridSettings('pendingCommands', $scope.customGridProperties, null, _additionalProperties);
        }
        dataSource = result.dataList;
        $scope.pendingCommandsListGridSettings.source = dataSource;
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      $scope.dataLoadingFinished = true;
    });
  };
  $scope.pendingCommandState = 0;
  $scope.$on('vehiclesListRowSelected', function (event, data) {
    if (!data) {
      $scope.isDataAvailable = false;
      return;
    }
    if (data.selectedRow) {
      $scope.isDataAvailable = true;
      loadPendingCommandsList($scope.pendingCommandState, data.selectedRow.deviceid, true);
      _deviceID = data.selectedRow.deviceid;
    } else {
      $scope.isDataAvailable = false;
    }
  });

  $scope.$on('pendingDashboardVehiclesRefreshed', function () {
    loadPendingCommandsList($scope.pendingCommandState, _deviceID, true);
  });

  $scope.$on('portalCommandSaved', function () {
    loadPendingCommandsList($scope.pendingCommandState, _deviceID, true);
  });
  $scope.$on('$destroy', function () {
    if ($scope.pendingCommandsListGridSettings && $scope.pendingCommandsListGridSettings.source) {
      delete $scope.pendingCommandsListGridSettings.source;
    }
  });
}]);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/pendingCommands/pendingCommandsWidget.tpl.html', '<div class="row" style="padding: 2.5px;"><div ng-if="isDataAvailable"><div class="row" style="padding: 2.5px;"><div class="col-sm-4 col-md-4 col-xs-4"><div jqx-delete-directive="pendingCommandComboBox" type="comboBox"><jqx-combo-box id="pendingCommandComboBox" focus-blur="" ng-model="pendingCommandState" jqx-settings="pendingCommandComboBoxSettings" clear-inpu="" ng-create="dataLoadingFinished"></jqx-combo-box></div></div></div><div class="row" style="padding: 2.5px;"><div class="col-sm-12 col-md-12 col-xs-12"><div jqx-delete-directive="{{overviewGridPrefix}}pendingCommandsList" type="grid"><jqx-grid id="{{overviewGridPrefix}}pendingCommandsList" jqx-settings="pendingCommandsListGridSettings" jqx-create="dataLoadingFinished"></jqx-grid></div></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></div>');
  }]);
})();

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/25/2016.
 */


angular.module('portalCommand', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('portalCommand', {
    url: '/portalcommand',
    templateUrl: 'components/dashboard/portalCommand/portalCommand.tpl.html',
    controller: 'PortalCommandCtrl',
    resolve: {
      $title: function $title() {
        return 'BetoTrack';
      }
    }
  });

  $stateProvider.state('portalcommand', {
    parent: 'betotrack',
    url: '/portalcommand',
    ncyBreadcrumb: {
      label: 'Track'
    },
    views: {
      'content@app': {
        templateUrl: 'components/dashboard/portalCommand/portalCommand.tpl.html',
        controller: 'PortalCommandCtrl'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Fleet Management Dashboard';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    }
  });
}]);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/portalCommand/portalCommand.tpl.html', '<div class="container-fluid mainContent"><div class="row"><div class="col-sm-12"><adf-dashboard name="{{dashBoardName}}" collapsible="{{collapsible}}" maximizable="{{maximizable}}" structure="7-5 (12/6-6)" adf-model="dashBoardModel" adf-widget-filter="widgetFilter"></adf-dashboard></div></div></div>');
  }]);
})();

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/24/2016.
 */


angular.module('betosyswebapp').controller('PortalCommandCtrl', ["$rootScope", "$scope", "AuthenticationService", "base64", "localStorageService", "$translate", "commonTrackService", "dashboardService", "customerService", function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
  $scope.pageHeader = 'PortalCommand Dashboard';

  var loginID = AuthenticationService.GetLoginID();

  //dash board
  $scope.username = loginID.username;
  $scope.dashBoardName = 'dashBoard.PortalCommand.' + $scope.username;
  var model = localStorageService.get($scope.dashBoardName);

  if (!model) {
    model = customerService.getPortalCommandDashboardConfig(commonTrackService.getViewPortName());
  }

  $scope.dashBoardModel = model;
  $scope.collapsible = true;
  $scope.maximizable = true;

  $scope.widgetFilter = function (widget, type) {
    if (widget.isSingleInstance === undefined || notExist(type)) {
      return type;
    }
  };

  function notExist(type) {
    return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
  }

  var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
    localStorageService.set(name, model);
  });

  var rowSelectedEvnt = $scope.$on('vehiclesListRowSelected', function (event, data) {
    if (data.selectedRow) {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
    } else {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
    }
  });

  $scope.$on('$destroy', function () {
    rowSelectedEvnt();
    adfDashboardChangedEvnt();
  });
}]);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('tachoDownloadDashboard', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('tachodownloaddashboard', {
    parent: 'betotrack',
    url: '/tachodownloaddashboard',
    ncyBreadcrumb: {
      label: 'Track'
    },
    views: {
      'content@app': {
        templateUrl: 'components/dashboard/tachoDownloadDashboard/tachoDownloadDashboard.tpl.html',
        controller: 'TachoDownloadDashboardCtrl'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Download Status Dashboard';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    }
  });
}]);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoDownloadDashboard/tachoDownloadDashboard.tpl.html', '<div class="container-fluid mainContent"><div class="row"><div class="col-sm-12"><adf-dashboard name="{{dashBoardName}}" collapsible="{{collapsible}}" maximizable="{{maximizable}}" structure="3-9 (12/6-6)" adf-model="dashBoardModel" adf-widget-filter="widgetFilter"></adf-dashboard></div></div></div>');
  }]);
})();

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('betosyswebapp').controller('TachoDownloadDashboardCtrl', ["$scope", "AuthenticationService", "base64", "localStorageService", "commonTrackService", "dashboardService", "customerService", function ($scope, AuthenticationService, base64, localStorageService, commonTrackService, dashboardService, customerService) {
  $scope.pageHeader = 'Tacho Download Dashboard';

  var loginID = AuthenticationService.GetLoginID();

  //dash board
  $scope.username = loginID.username;
  $scope.dashBoardName = 'dashBoard.TachoDownloadDashboard.' + $scope.username;
  var model = localStorageService.get($scope.dashBoardName);

  if (!model) {
    model = customerService.getTachoDownloadStatusDashboardConfig(commonTrackService.getViewPortName());
  }

  $scope.dashBoardModel = model;
  $scope.collapsible = true;
  $scope.maximizable = true;

  $scope.widgetFilter = function (widget, type) {
    if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
      return type;
    }
  };

  function notExist(type) {
    return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
  }
  var isExculdedParentWidgetArr = ['vehicleListWidget', 'DriverWrkHrsWidget', 'tachoHistoryWidget', 'FMSVehicleWidget', 'fleetMapWidget', 'tachoEventDetailWidget'];

  function isExculdedParentWidget(type) {
    for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
      if (type === isExculdedParentWidgetArr[j]) {
        return true;
      }
    }
    return false;
  }

  var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
    localStorageService.set(name, model);
  });

  var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
    if (data.updateWidgetTitle) {
      if (data.selectedRow) {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
      } else {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
      }
    }
  });

  var widgetDataFromServer = $scope.$on('init-widget-data-from-server', function (event, data) {
    if (data.selectedRow) {

      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
        name: 'tachoEventDetailWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
      }], data.selectedRow.date.replace('/', '.'));
    }
  });

  $scope.$on('$destroy', function () {
    rowSelectedEvnt();
    adfDashboardChangedEvnt();
    widgetDataFromServer();
  });
}]);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

angular.module('dashboard.tachoDownloadDashboard', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('tachoDownloadStatusWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.tachoDownloadStatus.title';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.tachoDownloadStatus.description';
      }
    },
    controller: 'tachoDownloadStatusCtrl',
    templateUrl: 'components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      vehicleGroup: null,
      noOfGridRows: ''
    },
    edit: {
      templateUrl: 'components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidgetEdit.tpl.html',
      reload: false,
      controller: 'tachoDownloadStatusEditCtrl'
    }
  });
}]).service('tachoDownloadStatusService', ["crudService", function (crudService) {

  this.getTachoDataDownloadList = function (vechileGroup) {
    var requestParam = {
      dataRefresh: true,
      reportName: 'TachoDownloadStatus',
      vehicleGroup: vechileGroup,
      timeTo: '-0d'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('tachodownloaddashboard', 'tachodownloadstatus', param);
  };
}]).controller('tachoDownloadStatusCtrl', ["$scope", "config", "commonTrackService", "widgetSettingsCreatorService", "vehicleListWidgetService", "tachoDownloadStatusService", "$translate", "errorHandlingService", "$state", "$interval", "$rootScope", "stateManagerService", function ($scope, config, commonTrackService, widgetSettingsCreatorService, vehicleListWidgetService, tachoDownloadStatusService, $translate, errorHandlingService, $state, $interval, $rootScope, stateManagerService) {

  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.isReady = false;
  $scope.datePicker = widgetSettingsCreatorService.createDatePickerInstance('dd.MM.yyyy');
  $scope.dateFilter = {
    date: new Date()
  };
  var rowSize = vehicleListWidgetService.getRowSize();

  $scope.customGridProperties = {
    tachoDownloadStatus: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
      pageable: false,
      columns: []
    }
  };
  var tachoDownloadCtxInitialized = false;
  var counterSeconds = 60;
  var counterTimeout;
  $scope.uuidForElement = $scope.$id;
  var tachoDownloadStatusListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };
  var contextMenu = {};
  var broadcastEventData = {
    selectedRow: {},
    selectedVehicleGroup: '',
    selectedStatusCode: '',
    selectedVehicleGroupLabel: '',
    eventSource: '',
    selectedOrderRow: {},
    isRefreshStarted: false,
    lastTabName: '',
    dashboardName: 'dashboard.tachoDownloadStatusList',
    isDataFromTab: true
  };

  function showDashboard() {
    $state.go('betotrack.dashboard');
  }

  function showDriverDashboard() {
    $state.go('driverdashboard');
  }

  function showFmsDashboard() {
    $state.go('fmsdashboard');
  }

  var _contextSourceObj = {
    tachoDownloadStatusCtxSource: [{
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
      execute: showDashboard
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
      execute: showDriverDashboard
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
      execute: showFmsDashboard
    }]
  };
  $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(100);
  $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
    source: _contextSourceObj.tachoDownloadStatusCtxSource, popupZIndex: 999999
  });
  $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
  });

  var loadTachoDownloadStatusList = function loadTachoDownloadStatusList(vechileGroup, isDataRefresh) {
    $scope.stop();
    return tachoDownloadStatusService.getTachoDataDownloadList(vechileGroup).then(function (downloadStatusList) {
      if (downloadStatusList) {

        if (isDataRefresh) {
          $scope.customGridProperties.tachoDownloadStatus.columns = commonTrackService.getColumnProperties(downloadStatusList.gridSettings.overviewListGrids[0].columnProperties, downloadStatusList.columnTranslation, { moduleName: 'tachoDownloadStatus' });
          tachoDownloadStatusListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'tachoDownloadStatusList', tachoDownloadStatusListSource);
          tachoDownloadStatusListSource.localdata = downloadStatusList.dataList;

          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.lastLocation') };
          $scope.tachoDownloadStatusSettings = commonTrackService.getGridSettings('tachoDownloadStatus', $scope.customGridProperties.tachoDownloadStatus, null, _additionalProperties);
          $scope.tachoDownloadStatusListAdapter = new window.$.jqx.dataAdapter(tachoDownloadStatusListSource);
          $scope.tachoDownloadStatusSettings.source = $scope.tachoDownloadStatusListAdapter;

          $scope.isDataAvailable = true;
        } else {
          tachoDownloadStatusListSource.localdata = downloadStatusList.dataList;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoDownloadStatusList');
        }
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {

      $scope.counter = counterSeconds;
      if ($scope.isDataAvailable && !counterTimeout || counterTimeout && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled' && $scope.isDataAvailable) {
        $scope.startCounter();
      } else {
        $scope.stop();
      }
      $scope.dataLoadingFinished = true;
      $scope.createTachoDownloadStatusGrid = true;
    });
  };

  $scope.stopAutoRefresh = function (event, type) {
    if (event) {
      commonTrackService.getRefreshStartStopfunction($scope, true, false, loadTachoDownloadStatusList, 'vehicleGroupComboBox', false, true, event)();
    } else {
      if (type === 'start') {
        $scope.isTimerStated = false;
      } else {
        $scope.isTimerStated = true;
      }
      commonTrackService.getRefreshStartStopfunction($scope, true, false, loadTachoDownloadStatusList, 'vehicleGroupComboBox', false, true)();
    }
  };

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {
        $scope.vehicleGroupSettings.source = vechileGroupList;
        var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

        if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) {
          // validate the local storage group is still valid ( group can change based on login )
          $scope.vehicleGroup = config.vehicleGroup;
        }

        if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {
            // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = cachedGroup;
            config.vehicleGroup = cachedGroup;
          }
        }

        if (!$scope.vehicleGroup) {
          $scope.vehicleGroup = vechileGroupList[0].groupID;
        }
      }
    });
  };
  loadVehicleGroup().finally(function () {

    if ($scope.vehicleGroup) {
      loadTachoDownloadStatusList($scope.vehicleGroup, true);
    }
  });

  $scope.gridRowClickHandler = function (event) {
    if (event.args.rightclick) {
      if (!tachoDownloadCtxInitialized) {
        contextMenu = $('#' + $scope.uuidForElement + '_betoTrack_tachoDownloadCtx').jqxMenu($scope.ctxMenuSettings);
        $('#' + $scope.uuidForElement + '_betoTrack_tachoDownloadCtx').on('itemclick', tachoDownloadContextHandler);
        tachoDownloadCtxInitialized = true;
      }
      commonTrackService.initGridRightClickContextMenu(event, contextMenu);
    }
  };
  function tachoDownloadContextHandler(event) {
    commonTrackService.executeContextMenuClick(event, 'tachoDownloadStatusCtxSource', _contextSourceObj);
  }

  $scope.stop = function () {
    $interval.cancel(counterTimeout);
  };

  $scope.startCounter = function () {
    $scope.stop();
    $scope.isTimerStated = true;
    $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
    if ($scope.counter - 1 >= 1) {
      $scope.counter--;
      counterTimeout = $interval($scope.startCounter, 1000);
    } else {
      loadTachoDownloadStatusList($scope.vehicleGroup, true);
    }
  };

  var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
    $rootScope.$broadcast('vehicleMap_res_current_context', {
      dashboardName: 'dashboard.tachoDownloadStatusList',
      isDataFromTab: false,
      tabNumber: 0,
      currentWidgetContextData: broadcastEventData,
      dataLoadingFinished: $scope.dataLoadingFinished,
      isDataAvailable: $scope.isDataAvailable
    });
  });

  // stateManagerService
  // Used when unkown dependant (child) widget requests data.
  // Since this is a global request for data, widget needs to check if the,
  // requested fields is anything it can provide before updating.
  // Will call the dataStateUpdate event if it updates data.
  var updateRequest = $scope.$on('reqDataUpdate', function () {
    var selectedRowData = {};
    var selectIndex = -1;
    if ($('#' + $scope.overviewGridPrefix + 'tachoDownloadStatusList').length > 0) {
      selectIndex = window.$('#' + $scope.overviewGridPrefix + 'tachoDownloadStatusList').jqxGrid('getselectedrowindex');
      if (selectIndex > -1) {
        selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'tachoDownloadStatusList').jqxGrid('getrowdata', selectIndex);
        stateManagerService.updateValue('tachoDownloadStatusWidget', 'tab_' + 0 + '_selectedRow', selectedRowData, true);
      }
    }
    $rootScope.$broadcast('resDataUpdate', {
      widget: 'tachoDownloadStatusWidget',
      activeTab: 0,
      dashboardName: 'dashboard.tachoDownloadStatusList',
      timespan: new Date().getTime()
    });
  });
  $scope.rowSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {

      broadcastEventData.gridName = 'tachoDownloadStatus';
      broadcastEventData.selectedRow = event.args.row;
      broadcastEventData.updateWidgetTitle = true;
      broadcastEventData.repoVehicle = event.args.row.deviceid;

      if (event.args.row.tacholasteventtimestamp && event.args.row.tacholasteventtimestamp !== '') {
        var lastEventMoment = moment(event.args.row.tacholasteventtimestamp * 1000);
        broadcastEventData.startDate = lastEventMoment.format('YYYY/MM/DD/HH:mm:ss');
        broadcastEventData.endDate = lastEventMoment.format('YYYY/MM/DD/HH:mm:ss');
      } else {
        broadcastEventData.startDate = '';
        broadcastEventData.endDate = '';
      }
      broadcastEventData.deviceId = event.args.row.deviceid;
      broadcastEventData.dashboardName = 'dashboard.tachoDownloadStatusList';
      broadcastEventData.isDataFromTab = false;
      broadcastEventData.tabNumber = 0;
      broadcastEventData.updateMapUrl = false;
      broadcastEventData.showPushpins = true;

      $rootScope.$broadcast('rowSelected', broadcastEventData);
      $rootScope.$broadcast('eventReportMapUpdate', broadcastEventData);

      stateManagerService.updateValue('tachoDownloadStatusWidget', 'tab_' + 0 + '_selectedRow', broadcastEventData.selectedRow, true);

      $rootScope.$broadcast('dataStateUpdate', {
        widget: 'tachoDownloadStatusWidget',
        activeTab: 0,
        dashboardName: 'dashboard.tachoDownloadStatusList'
      });
    }
  };
  $scope.vehicleGroupComboChange = function (event) {
    var vehicleGroup = event.args.item;
    // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
    if (config.vehicleGroup !== vehicleGroup.value) {
      if ($scope.tachoDownloadStatusSettings) {
        loadTachoDownloadStatusList(vehicleGroup.value, $scope.tachoDownloadStatusSettings.columns.length > 0 ? false : true);
      }
    }
    if (vehicleGroup) {
      broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
      broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
      config.vehicleGroup = vehicleGroup.value;

      broadcastEventData.dashboardName = 'dashboard.tachoDownloadStatusList';
      broadcastEventData.isDataFromTab = true;
      broadcastEventData.tabNumber = 0;
      $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
    }
  };

  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  // Google maps takes focus if the auto refresh enabled
  // Auto refresh must be stoped if the chat window is open to solve focus switching
  var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
    $scope.stopAutoRefresh(null, 'stop');
  });
  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  //  restart the auto refresh is the chat window is closed
  var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
    $scope.stopAutoRefresh(null, 'start');
  });

  $scope.$on('$destroy', function () {
    if (chatWindowOpenEvent) {
      chatWindowOpenEvent();
    }
    if (chatWindowCloseEvent) {
      chatWindowCloseEvent();
    }
    $scope.stop();
    currentSelectedRowReqEvent();
    updateRequest();
    if ($scope.tachoDownloadStatusSettings && $scope.tachoDownloadStatusSettings.source) {
      delete $scope.tachoDownloadStatusSettings.source;
    }
    if ($scope.tachoDownloadStatusListAdapter) {
      delete $scope.tachoDownloadStatusListAdapter;
    }
  });
}]).controller('tachoDownloadStatusEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {

  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '20', '25', '50', '75', '100'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,

    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidget.tpl.html', '<div class="row" style=""><div ng-if="!dataLoadingFinished"><loading-animation></loading-animation></div><div class="col-sm-12 col-md-12" ng-if="isDataAvailable"><div class="row" style="margin-top: 5px;"><div class="col-md-5 col-sm-5 col-xs-5" style="padding-left:18px;"><div jqx-delete-directive="vehicleGroupComboBox" type="comboBox"><jqx-combo-box id="vehicleGroupComboBox" jqx-settings="vehicleGroupSettings" class="jqx-combo-box-dsa required" jqx-create="dataLoadingFinished" jqx-on-change="vehicleGroupComboChange(event)" ng-model="vehicleGroup" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-5 col-sm-5 col-xs-5"></div><div class="col-md-2 col-sm-2 col-xs-2" ng-if="timerDesc"><button ng-click="stopAutoRefresh($event)" type="button" style="float: right;margin-right: 2.5px;" id="autoRefreshButton" class="btn btn-default"><span class="badge" ng-show="isTimerStated">{{counter}}</span><i ng-show="!isTimerStated" class="fa fa-play" aria-hidden="true"></i></button></div></div><div class="row" style="margin-top: 5px;" ng-if="isDataAvailable"><div class="col-sm-12 col-md-12"><div contextmenu=""><div jqx-delete-directive="{{overviewGridPrefix}}tachoDownloadStatusList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}tachoDownloadStatusList" jqx-settings="tachoDownloadStatusSettings" jqx-on-rowselect="rowSelectHandler(event)" jqx-on-rowclick="gridRowClickHandler(event)" jqx-create="createTachoDownloadStatusGrid" class="custom-header"></jqx-grid></div><div id="{{uuidForElement}}_betoTrack_tachoDownloadCtx"></div></div></div></div></div><div ng-show="!isDataAvailable && dataLoadingFinished"><no-authorize></no-authorize></div></div>');
  }]);
})();

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoDownloadStatus/tachoDownloadStatusWidgetEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)" style="overflow: hidden!important;"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 7/26/2018.
 */


angular.module('dashboard.tachoEventDetail', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('tachoEventDetailWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.tachoEventDetail.description';
      }
    },
    controller: 'tachoEventDetailCtrl',
    templateUrl: 'components/dashboard/tachoEventDetails/tachoEventDetailWidget.tpl.html',
    isSingleInstance: true,
    edit: {
      templateUrl: 'components/dashboard/tachoEventDetails/tachoEventDetailWidgetEdit.tpl.html',
      reload: false,
      controller: 'tachoEventDetailEditCtrl'
    }
  });
}]).service('tachoEventDetailWidgetService', ["crudService", "$filter", function (crudService, $filter) {

  var lastSelectedHistoryRow = null;
  var cachedGrpahicsDataList = null;
  this.getTachoeventGraphicsList = function (dateFrom, driverId, isDataRefresh) {
    var requestParam = {
      dataRefresh: isDataRefresh,
      timeTo: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '23:59:59',
      timeFrom: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '00:00:00',
      reportOptions: { driverID: [driverId] }
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('driverdashboard/tachoeventgraphic', '', param);
  };

  this.getTachoStampingTimesList = function (dateFrom, driverId, isDataRefresh) {
    var requestParam = {
      dataRefresh: isDataRefresh,
      timeTo: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '23:59:59',
      timeFrom: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '00:00:00',
      reportOptions: { driverID: [driverId] },
      reportOption: driverId
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('driverdashboard/costcenterevents', '', param);
  };

  this.getLastSelectedHistoryRow = function () {
    return lastSelectedHistoryRow;
  };
  this.setLastSelectedHistoryRow = function (rodData) {
    lastSelectedHistoryRow = rodData;
  };

  this.setGrpahicsCachedList = function (dataList) {

    cachedGrpahicsDataList = dataList;
  };

  this.getGrpahicsCachedList = function () {

    return cachedGrpahicsDataList;
  };
}]).controller('tachoEventDetailCtrl', ["$scope", "config", "tachoEventDetailWidgetService", "commonTrackService", "vehicleListWidgetService", "errorHandlingService", "$rootScope", "$timeout", "stateManagerService", "AuthenticationService", function ($scope, config, tachoEventDetailWidgetService, commonTrackService, vehicleListWidgetService, errorHandlingService, $rootScope, $timeout, stateManagerService, AuthenticationService) {
  var isWidgetIsinfullScreen = $('body.modal-open').length > 0 ? true : false;

  $scope.isNotAuthorized = false;
  $scope.isDataNotAvailable = false;
  $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
  $scope.isWidgetPostInitFinished = false;

  $scope.driverEventDetailTab = 0;
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();

  var tachoGraphicGridListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };

  var rowSize = vehicleListWidgetService.getRowSize();
  $scope.customGridProperties = {
    tachoGraphicDetail: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
      pageable: false,
      columns: []
    },
    tachoStampingEventDetail: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
      pageable: false,
      columns: []
    }
  };
  $scope.dataLoadingFinished = false;
  $scope.dataStampingLoadingFinished = false;
  $scope.lastEventTime = 0;
  $scope.gridDataList = [];

  $scope.widgetData = {};

  var tachoStampingEventListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };

  var loadtachoStampingTimesGrid = function loadtachoStampingTimesGrid(date, driverID, isForceRefresh) {
    $scope.isStampingNotAuth = false;
    tachoEventDetailWidgetService.getTachoStampingTimesList(date, driverID, isForceRefresh).then(function (tachoStampingList) {
      if (!$scope.tachoStampingEventListdataAdapter) {
        $scope.customGridProperties.tachoStampingEventDetail.columns = commonTrackService.getColumnProperties(tachoStampingList.gridSettings.overviewListGrids[0].columnProperties, tachoStampingList.columnTranslation, { moduleName: 'tachoStampingTimesGrid' });
        $scope.tachoStampingTimesGridSettings = commonTrackService.getGridSettings('tachoStampingTimesGrid', $scope.customGridProperties.tachoStampingEventDetail, null);
        tachoStampingEventListSource.localdata = tachoStampingList.dataList;
        $scope.tachoStampingEventListdataAdapter = new $.jqx.dataAdapter(tachoStampingEventListSource);
        $scope.tachoStampingTimesGridSettings.source = $scope.tachoStampingEventListdataAdapter;
      } else {
        tachoStampingEventListSource.localdata = tachoStampingList.dataList;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoStampingTimesGridList');
      }
    }, function (error) {
      // do something with error response
      console.log(error);
      $scope.isStampingNotAuth = true;
    }).finally(function () {
      if (!$scope.dataStampingLoadingFinished) {
        $scope.dataStampingLoadingFinished = true;
      }
    });
  };

  $scope.tachoStampingTimeRowSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      var eventRow = event.args.row;
      commonTrackService.iframePostMessage('jsmDrawPushpinAtPoint(' + eventRow.latitude + ',' + eventRow.longitude + ',2)', 'vehicleMap');
    }
  };

  $scope.stampingEventsTabSelect = function () {
    var rowData = tachoEventDetailWidgetService.getLastSelectedHistoryRow();

    // this is based since there is a difference between the selected Row and what the grid can display.
    // ie. if you select a row then change the date, that row is still selected even if it is no longer shown.
    // this links back to how widgets should interact with one another. See BUG 89998.
    if (rowData && rowData.date === $scope.widgetData.date) {
      loadStampingEventDetails(rowData);
    } else {
      loadStampingEventDetails($scope.widgetData);
    }
  };

  var loadStampingEventDetails = function loadStampingEventDetails(rowData) {
    var driverID = '';
    if (rowData) {

      if (rowData.selectedRow) {
        driverID = rowData.selectedRow.driverid;
      } else {
        driverID = rowData.driverid;
      }
      loadtachoStampingTimesGrid(rowData.date, driverID, !$scope.tachoStampingTimesGridSettings || !$scope.tachoStampingEventListdataAdapter ? true : false);
    } else {
      loadtachoStampingTimesGrid(new Date(), driverID, true);
    }
  };

  var setWidgetData = function setWidgetData(date, selectedRow) {
    if (!$scope.widgetData) {
      $scope.widgetData = {};
    }

    $scope.widgetData.date = date;
    $scope.widgetData.selectedRow = selectedRow;

    if ($scope.driverEventDetailTab === 2) {
      loadtachoStampingTimesGrid(date, selectedRow.driverid, true);
    }
  };

  var loadTachoGraphicsGrid = function loadTachoGraphicsGrid(date, driverID, isForceRefresh) {
    $scope.isDataNotAvailable = false;
    $scope.isNotAuthorized = false;
    tachoGraphicGridListSource.localdata = [];
    tachoEventDetailWidgetService.getTachoeventGraphicsList(date, driverID, isForceRefresh).then(function (tachoGraphicsList) {
      _handleGrphicsdataList(tachoGraphicsList, false);
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $rootScope.$broadcast('rest-error-event', response);
        $scope.isNotAuthorized = true;
      }
    }).finally(function () {
      $rootScope.$broadcast('tacho_event_history_init_graphic', {
        dataList: $scope.gridDataList,
        eventType: 'tacho_event_history_table_row_select'
      });
      if (!$scope.dataLoadingFinished) {
        $scope.dataLoadingFinished = true;
      }
      $scope.createTachoGraphicsGrid = true;
    });
  };

  function _handleGrphicsdataList(tachoGraphicsList, isFromCahe) {

    if (tachoGraphicsList.dataList) {
      $scope.gridDataList = $.extend(true, [], tachoGraphicsList.dataList);
      tachoEventDetailWidgetService.setGrpahicsCachedList(tachoGraphicsList);
    }

    if (!$scope.tachoGraphicsDetailsListdataAdapter) {
      $scope.customGridProperties.tachoGraphicDetail.columns = commonTrackService.getColumnProperties(tachoGraphicsList.gridSettings.overviewListGrids[0].columnProperties, tachoGraphicsList.columnTranslation, { moduleName: 'tachoGraphicsDetailsGrid' });
      $scope.tachoGraphicsDetailsGridSettings = commonTrackService.getGridSettings('tachoGraphicsDetailsGrid', $scope.customGridProperties.tachoGraphicDetail, null);
      tachoGraphicGridListSource.localdata = tachoGraphicsList.dataList;
      $scope.tachoGraphicsDetailsListdataAdapter = new $.jqx.dataAdapter(tachoGraphicGridListSource);
      $scope.tachoGraphicsDetailsGridSettings.source = $scope.tachoGraphicsDetailsListdataAdapter;
    } else {
      tachoGraphicGridListSource.localdata = tachoGraphicsList.dataList;
      commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoGraphicsDetailsGridList');
    }
    $scope.isDataNotAvailable = tachoGraphicsList.dataList.length === 0 ? true : false;
    if (isFromCahe) {
      $scope.dataLoadingFinished = true;
      $scope.createTachoGraphicsGrid = true;
      $rootScope.$broadcast('tacho_event_history_init_graphic', {
        dataList: $scope.gridDataList,
        eventType: 'tacho_event_history_table_row_select'
      });
    }
  }
  $scope.initTachoDetailsGraphic = function () {};
  $timeout(function () {
    $rootScope.$broadcast('reqDataUpdate');
  }, 0);

  var dataStateUpdateListener = $scope.$on('dataStateUpdate', function (event, data) {
    if ($scope.isWidgetPostInitFinished) {
      var set = getSetData(data.widget);
      _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
    } else {
      //console.log('Ignoring dataState update from widget: ' + data.widget);
    }
  });

  // Modification for the Loading Imporvement
  var getSetData = function getSetData(widget) {
    var loginID = AuthenticationService.GetLoginID();
    widget = loginID.Account + '_' + loginID.username + '_' + widget;
    var stateData = stateManagerService.getStateData();
    var set = stateData && stateData[widget] ? stateData[widget] : {};
    return set;
  };

  var loadDependentDataFromServer = function loadDependentDataFromServer(data) {
    loadTachoGraphicsGrid(data.selectedRow.date, data.selectedRow.driverid, true);
  };

  var maxGetInitialDataRetries = 30;
  var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
    if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
      currentParentRowResEvent();
      return;
    }
    // console.info(' Tacho Event Details Widget Requesting Parent for Data ..');

    --maxGetInitialDataRetries;
    var set = getSetData(data.widget);
    var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];

    // parents First tab must always retrun a  valid selected row
    if (data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value) || data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues)) {
      $scope.isWidgetPreInitFinished = true;
      $scope.isWidgetPostInitFinished = true;
      _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);
    } else {
      // Repeatedly try to get the data from parent .
      if (maxGetInitialDataRetries > 0) {
        $timeout(function () {
          if (!$scope.isWidgetPostInitFinished) {
            $rootScope.$broadcast('reqDataUpdate');
          }
        }, 100);
      } else {
        console.warn('Max Retries exceeded to get the current Parent data for Tacho Event Details Widget..');
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;
        $scope.isDataNotAvailable = true;
        currentParentRowResEvent();
      }
    }
  });

  function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName) {
    var set, rowDetails;

    switch (dashboardName) {
      case 'dashboard.driverWrkHrsDashboard':
        // contains only tab 0
        switch (tabNumber) {
          case 0:
            if (!_.isEmpty(rowData)) {
              loadTachoGraphicsGrid(rowData.driverworkingdate, rowData.driverid, true);
              setWidgetData(rowData.driverworkingdate, rowData);
            } else {
              $scope.isDataNotAvailable = true;
            }
            break;
        }
        break;
      case 'dashboard.tachohistory':
        // contains only tab 0
        switch (tabNumber) {
          case 0:
            if (!_.isEmpty(rowData)) {

              set = getSetData(widgetName);
              loadTachoGraphicsGrid(set.date.value, rowData.driverid, true);
              setWidgetData(set.date.value, rowData);
            } else {
              $scope.isDataNotAvailable = true;
            }

            break;

        }
        break;
      case 'dashboard.fmsDashboard':
      case 'dashboard.vehicleList':
        switch (tabNumber) {
          case 0:
            // first tab use device id to  load data from server
            set = getSetData(widgetName);
            rowData = set['tab_' + 0 + '_selectedRow'];
            if (!_.isEmpty(rowData.value)) {
              rowDetails = Object.assign({}, rowData.value);
              rowDetails.date = rowDetails.date.indexOf('T') > -1 ? moment(rowDetails.date).toDate() : moment(rowDetails.date, 'DD/MM/YYYY').toDate();
              setWidgetData(rowData.date, rowDetails);
              loadDependentDataFromServer({ selectedRow: rowDetails });
            } else {
              $scope.isDataNotAvailable = true;
            }
            break;
          case 1: // use the Service stored Data
          case 2:
          case 3:
            if (isWidgetIsinfullScreen) {
              var cahchedData = tachoEventDetailWidgetService.getGrpahicsCachedList();
              if (!_.isEmpty(cahchedData)) {
                _handleGrphicsdataList(cahchedData, true);
              } else {
                set = getSetData(widgetName);
                rowData = set['tab_' + 0 + '_selectedRow'];
                if (!_.isEmpty(rowData.value)) {
                  rowDetails = Object.assign({}, rowData.value);
                  rowDetails.date = rowDetails.date.indexOf('T') > -1 ? moment(rowDetails.date).toDate() : moment(rowDetails.date, 'DD/MM/YYYY').toDate();
                  setWidgetData(rowDetails.date, rowDetails);
                  loadDependentDataFromServer({ selectedRow: rowDetails });
                } else {
                  $scope.isDataNotAvailable = true;
                }
              }
            }

            break;
        }
        break;

    }
  }
  $scope.$on('$destroy', function () {
    currentParentRowResEvent();
    dataStateUpdateListener();
  });
}]).controller('tachoEventDetailEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {

  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '25', '50', '75', '100'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoEventDetails/tachoEventDetailWidget.tpl.html', '<div class=""><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><no-authorize ng-if="isNotAuthorized=== true"></no-authorize><no-data-available ng-if="isDataNotAvailable === true"></no-data-available></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12" ng-show="isDataNotAvailable === false"><uib-tabset style="" class="track-tab-dsa" active="driverEventDetailTab"><uib-tab><uib-tab-heading translate="dashBoard.fleetManagement.tachoEventDetail.tachoGraphicsListTabTitle"></uib-tab-heading><div class="row" style="padding-top: 5px;" id="tachoGraphicListTab"><div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 2.5px;"><div jqx-delete-directive="{{overviewGridPrefix}}tachoGraphicsDetailsGridList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}tachoGraphicsDetailsGridList" jqx-settings="tachoGraphicsDetailsGridSettings" jqx-create="createTachoGraphicsGrid" class="custom-header"></jqx-grid></div></div></div></uib-tab><uib-tab ng-click="initTachoDetailsGraphic()"><uib-tab-heading translate="dashBoard.fleetManagement.tachoEventDetail.tachoDetaiGrpahicTabTitle"></uib-tab-heading><div class="row" style="padding: 2.5px;"><div class="col-sm-12 col-md-12 col-xs-12"><div style="text-align:center;"><tacho-event-graphic></tacho-event-graphic></div></div></div><div class="row"><div class="col-sm-12 col-md-12 col-xs-12" style="padding-bottom: 5px; padding-left: 10%; padding-right: 10%;"><table style="width: 100%;" cellpadding="10"><tr><td class="col-sm-3 col-md-3 col-xs-3"><div style="display: inline-flex;"><div style="text-align: right;display:inline; padding-left: 5px;"><img class="dsa-black-background dsa-icon" src="assets/images/driver_rest_white.png" alt=""></div><div class="dsa-icon-label" translate="dashBoard.fleetManagement.tachoEventDetail.graphicsTab.breakLabel"></div></div></td><td class="col-sm-3 col-md-3 col-xs-3"><div style="display: inline-flex;"><div style="text-align: right;display:inline; padding-left: 5px;"><img class="dsa-blue-background dsa-icon" src="assets/images/driver_poa_white.png" alt=""></div><div class="dsa-icon-label" translate="dashBoard.fleetManagement.tachoEventDetail.graphicsTab.avialableLabel"></div></div></td><td class="col-sm-3 col-md-3 col-xs-3"><div style="display: inline-flex;"><div style="text-align: right;display:inline;padding-left: 5px;"><img class="dsa-gray-background dsa-icon" src="assets/images/driver_other_work_white.png" alt=""></div><div class="dsa-icon-label" translate="dashBoard.fleetManagement.tachoEventDetail.graphicsTab.wrokLabel"></div></div></td><td class="col-sm-3 col-md-3 col-xs-3"><div style="display: inline-flex;"><div style="text-align: right;display:inline;padding-left: 5px;"><img class="dsa-red-background dsa-icon" src="assets/images/driver_driving_mode_white.png" alt=""></div><div class="dsa-icon-label" translate="dashBoard.fleetManagement.tachoEventDetail.graphicsTab.driveLabel"></div></div></td></tr></table></div></div></uib-tab><uib-tab select="stampingEventsTabSelect()"><uib-tab-heading translate="dashBoard.fleetManagement.tachoEventDetail.tachoStampingTimesTitle"></uib-tab-heading><no-authorize ng-if="isStampingNotAuth=== true"></no-authorize><div ng-if="isStampingNotAuth=== false" class="row" style="padding-top: 5px;" id="tachoStampingTimesTab"><div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 2.5px;"><div jqx-delete-directive="{{overviewGridPrefix}}tachoStampingTimesGridList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}tachoStampingTimesGridList" jqx-settings="tachoStampingTimesGridSettings" jqx-create="dataStampingLoadingFinished" jqx-on-rowselect="tachoStampingTimeRowSelectHandler(event)" class="custom-header"></jqx-grid></div></div></div></uib-tab></uib-tabset></div></div>');
  }]);
})();

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoEventDetails/tachoEventDetailWidgetEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 8/24/2018.
 */


angular.module('dashboard.tachoHistory', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('tachoHistoryWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.tachoHistory.description';
      }
    },
    controller: 'tachoHistoryCtrl',
    templateUrl: 'components/dashboard/tachoHistory/tachoHistoryWidget.tpl.html',
    isSingleInstance: true,
    edit: {
      templateUrl: 'components/dashboard/tachoHistory/tachoHistoryWidgetEdit.tpl.html',
      reload: false,
      controller: 'tachoHistoryEditCtrl'
    }
  });
}]).service('tachoHistoryService', ["crudService", "$filter", function (crudService, $filter) {

  var lastSelectedHisotoryRowData;
  this.getTachoeventHistoryList = function (dateFrom, isDataRefresh) {
    var requestParam = {
      dataRefresh: isDataRefresh,
      timeTo: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '23:59:59',
      timeFrom: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '00:00:00',
      reportOptions: {}
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('driverdashboard/tachoeventhistory', '', param);
  };

  this.getLastSelectedHstoryRowData = function () {
    return lastSelectedHisotoryRowData;
  };

  this.setLastSelectedHstoryRowData = function (rowData) {
    lastSelectedHisotoryRowData = rowData;
  };
}]).controller('tachoHistoryCtrl', ["$scope", "config", "commonTrackService", "errorHandlingService", "$rootScope", "tachoHistoryService", "widgetSettingsCreatorService", "$filter", "vehicleListWidgetService", "$timeout", "stateManagerService", function ($scope, config, commonTrackService, errorHandlingService, $rootScope, tachoHistoryService, widgetSettingsCreatorService, $filter, vehicleListWidgetService, $timeout, stateManagerService) {

  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.isReady = false;
  $scope.datePicker = widgetSettingsCreatorService.createDatePickerInstance('dd.MM.yyyy');
  $scope.dateFilter = {
    date: new Date()
  };
  var rowSize = vehicleListWidgetService.getRowSize();

  $scope.customGridProperties = {
    eventDetailHistory: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
      pageable: false,
      columns: []
    }
  };

  var eventDetailHistoryListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };
  $scope.uuidForElement = $scope.$id;

  var locadTachoEventHistoryList = function locadTachoEventHistoryList(date) {
    $scope.isReady = true;
    $scope.isNotAuthorized = false;
    $scope.isDataNotAvailable = false;
    return tachoHistoryService.getTachoeventHistoryList(date, true).then(function (eventDetailHistoryList) {
      if (eventDetailHistoryList.dataList) {
        $scope.isDataAvailable = true;
        if (!$scope.tachoEventListdataAdapter) {
          $scope.customGridProperties.eventDetailHistory.columns = commonTrackService.getColumnProperties(eventDetailHistoryList.gridSettings.overviewListGrids[0].columnProperties, eventDetailHistoryList.columnTranslation, { moduleName: 'tachoEventListGridSettings' });
          $scope.tachoEventListGridSettings = commonTrackService.getGridSettings('tachoEventListGridSettings', $scope.customGridProperties.eventDetailHistory, null);
          eventDetailHistoryListSource.localdata = eventDetailHistoryList.dataList;
          $scope.tachoEventListdataAdapter = new $.jqx.dataAdapter(eventDetailHistoryListSource);
          $scope.tachoEventListGridSettings.source = $scope.tachoEventListdataAdapter;
        } else {
          eventDetailHistoryListSource.localdata = eventDetailHistoryList.dataList;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoEventListGridSettingsList');
        }
      }

      if (eventDetailHistoryList.dataList.length === 0) {
        eventDetailHistoryListSource.localdata = eventDetailHistoryList.dataList;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoEventListGridSettingsList');
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $rootScope.$broadcast('rest-error-event', response);
        $scope.isDataAvailable = false;
        $scope.isDataNotAvailable = true;
        $scope.isNotAuthorized = true;
      }
    }).finally(function () {
      $scope.isWidgetPreInitFinished = true;
      if ($scope.driverHistorydataLoadingFinished) {
        $timeout(function () {
          var rowindex = $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getselectedrowindex');
          if (rowindex !== null && rowindex > 0 && eventDetailHistoryListSource.localdata.length > 0) {
            $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('selectrow', rowindex);
          } else if (eventDetailHistoryListSource.localdata.length > 0) {
            $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('selectrow', 0);
          } else {
            $rootScope.$broadcast('tacho_event_history_row_select', { date: $scope.dateFilter.date, selectedRow: null });

            stateManagerService.updateValue('tachoHistoryWidget', 'tab_0_selectedRow', {}, true);

            $rootScope.$broadcast('tacho_detail_widget_event', {
              date: $filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'),
              selectedRow: null,
              eventType: 'tacho_event_history_data_empty'
            });

            $rootScope.$broadcast('dataStateUpdate', {
              widget: 'tachoHistoryWidget',
              activeTab: 0,
              dashboardName: 'dashboard.tachohistory',
              timespan: new Date().getTime()
            });
          }

          $rootScope.$broadcast('updateStampTimeEvent', { date: $scope.dateFilter.date });
        }, 500);
      }

      if (!$scope.driverHistorydataLoadingFinished) {
        $scope.driverHistorydataLoadingFinished = true;
      }
    });
  };

  $scope.tachoEventListGridSettingsSelectHandler = function (event) {
    if (event.args.row && $scope.driverHistorydataLoadingFinished) {
      var broadcastEventData = {
        selectedRow: event.args.row
      };

      $rootScope.$broadcast('tacho_detail_widget_event', {
        date: $filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'),
        selectedRow: _formaDataForSvg(event.args.row),
        eventType: 'tacho_event_history_table_row_select'
      });
      broadcastEventData.date = $scope.dateFilter.date;

      $rootScope.$broadcast('tacho_event_history_row_select', broadcastEventData);

      stateManagerService.updateValue('tachoHistoryWidget', 'date', $scope.dateFilter.date, true);
      stateManagerService.updateValue('tachoHistoryWidget', 'deviceID', broadcastEventData.selectedRow.deviceID, true);
      stateManagerService.updateValue('tachoHistoryWidget', 'rowData', broadcastEventData, false); // outDated ?
      stateManagerService.updateValue('tachoHistoryWidget', 'tab_0_selectedRow', broadcastEventData.selectedRow, true);

      $rootScope.$broadcast('dataStateUpdate', {
        widget: 'tachoHistoryWidget',
        activeTab: 0,
        dashboardName: 'dashboard.tachohistory',
        timespan: new Date().getTime()
      });

      tachoHistoryService.setLastSelectedHstoryRowData(broadcastEventData);
    }
  };

  function _formaDataForSvg(rowdata) {
    rowdata.worktimebetweenpause = '00h 00m';
    rowdata.drivetimebetweenpause = '00h 00m';
    return rowdata;
  }

  $scope.dateFilterPrevDay = function () {
    $scope.dateFilter.date = new Date($scope.dateFilter.date.getTime() - 24 * 60 * 60 * 1000);
    $('#dateFilterInput').val($filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'));
  };
  $scope.dateFilterNextDay = function () {
    $scope.dateFilter.date = new Date($scope.dateFilter.date.getTime() + 24 * 60 * 60 * 1000);
    $('#dateFilterInput').val($filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'));
  };
  $scope.$watch('dateFilter.date', function (value) {
    if (value) {

      locadTachoEventHistoryList(value, true);

      stateManagerService.updateValue('tachoHistoryWidget', 'date', $scope.dateFilter.date, true);

      $rootScope.$broadcast('tacho_detail_widget_event', {
        date: $filter('date')(value, 'dd.MM.yyyy'),
        eventType: 'date_change'
      });
    }
  });

  locadTachoEventHistoryList($scope.dateFilter.date);
  var vehicleMapCurrentContextDataRegEv = $scope.$on('vehicleMap_req_current_context', function () {
    var rowindex = $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getselectedrowindex');
    var selectedRow = {};
    if (rowindex) {
      selectedRow = $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getrowdata', rowindex);
    }
    $rootScope.$broadcast('vehicleMap_res_current_context', {
      dashboardName: 'dashboard.tachohistory',
      isDataFromTab: true,
      tabNumber: 0,
      currentWidgetContextData: {
        selectedRow: selectedRow,
        selectedOrderRow: {},
        dashboardName: 'dashboard.tachohistory',
        isDataFromTab: true
      },
      dataLoadingFinished: $scope.dataLoadingFinished,
      isDataAvailable: $scope.isDataAvailable
    });
  });
  // stateManagerService
  // Used when unkown dependant (child) widget requests data.
  // Since this is a global request for data, widget needs to check if the,
  // requested fields is anything it can provide before updating.
  // Will call the dataStateUpdate event if it updates data.
  var updateRequest = $scope.$on('reqDataUpdate', function () {
    var selectedRowData = {};
    var selectIndex = -1;

    selectIndex = window.$('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getselectedrowindex');
    if (selectIndex > -1) {
      selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getrowdata', selectIndex);
    }
    // push the changes to stateManagerService
    stateManagerService.updateValue('tachoHistoryWidget', 'tab_0_selectedRow', selectedRowData, true);

    $rootScope.$broadcast('resDataUpdate', {
      widget: 'tachoHistoryWidget',
      activeTab: 0,
      dashboardName: 'dashboard.tachohistory',
      timespan: new Date().getTime()
    });
  });
  $scope.$on('$destroy', function () {
    vehicleMapCurrentContextDataRegEv();
    updateRequest();
  });
}]).controller('tachoHistoryEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {

  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '25', '50', '75', '100'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,

    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoHistory/tachoHistoryWidget.tpl.html', '<div class=""><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><no-authorize ng-if="isNotAuthorized=== true"></no-authorize><no-data-available ng-if="!isNotAuthorized && isDataNotAvailable === true"></no-data-available><div class="col-xs-12 col-sm-12 col-md-12 row" ng-show="isDataNotAvailable === false"><uib-tabset style="" class="track-tab-dsa"><uib-tab ng-click="_initDriverWorkingHoursHistory()"><uib-tab-heading translate="dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle"></uib-tab-heading><div flex="" layout="row" ng-if="isReady === true"><div flex="" layout="row" style="padding-top: 5px;"><div><a class="btn" ng-click="dateFilterPrevDay()"><i class="glyphicon glyphicon-triangle-left"></i></a></div><div flex="nogrow" style="width:135px;" id="filterDateWidget" class="callanderdown"><div class="calendarPicker"><div class="input-group"><input type="text" id="dateFilterInput" class="form-control" style="height:32px;" uib-datepicker-popup="{{datePicker.format}}" ng-model="dateFilter.date" datepicker-date="" datepicker-options="datePicker.options" is-open="datePicker.instances[\'date\']" ng-disabled="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" style="padding:15px;" ng-click="datePicker.open($event, \'date\')"><i class="glyphicon glyphicon-calendar" style="top:-7px; left:-7px;"></i></button></span></div></div></div><div><a class="btn" ng-click="dateFilterNextDay()"><i class="glyphicon glyphicon-triangle-right"></i></a></div></div><span flex=""></span></div><div class="row" style="padding-top: 5px;" ng-if="isReady === true"><div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 2.5px;"><div jqx-delete-directive="{{overviewGridPrefix}}tachoEventListGridSettingsList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}tachoEventListGridSettingsList" jqx-settings="tachoEventListGridSettings" jqx-on-rowselect="tachoEventListGridSettingsSelectHandler(event)" jqx-create="driverHistorydataLoadingFinished" class="custom-header"></jqx-grid></div><jqx-menu jqx-settings="ctxMenuSettings" id="{{uuidForElement}}_betoTrack_tachoEventDBCtx" jqx-on-itemclick="tachoEventContextHandler($event)" jqx-create="createCdayDrvrWrkHours"></jqx-menu></div></div></uib-tab></uib-tabset></div></div>');
  }]);
})();

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoHistory/tachoHistoryWidgetEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 8/24/2018.
 */


angular.module('tachoHistoryDashboard', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('tachohistorydashboard', {
    parent: 'driverdashboard',
    url: '/tachohistorydashboard',
    ncyBreadcrumb: {
      label: 'Track'
    },
    views: {
      'content@app': {
        templateUrl: 'components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.tpl.html',
        controller: 'TachoHistoryCtrl'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Fleet Management Dashboard';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    }
  });
}]);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/tachoHistoryDashboard/tachoHistoryDashboard.tpl.html', '<div class="container-fluid mainContent"><div class="row"><div class="col-sm-12"><adf-dashboard name="{{dashBoardName}}" collapsible="{{collapsible}}" maximizable="{{maximizable}}" structure="7-5 (12/6-6)" adf-model="dashBoardModel" adf-widget-filter="widgetFilter"></adf-dashboard></div></div></div>');
  }]);
})();

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 8/24/2018.
 */
/**
 * Created by rak on 3/24/2016.
 */


angular.module('betosyswebapp').controller('TachoHistoryCtrl', ["$rootScope", "$scope", "AuthenticationService", "base64", "localStorageService", "$translate", "commonTrackService", "dashboardService", "customerService", function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
  $scope.pageHeader = 'Driver Dashboard';

  var loginID = AuthenticationService.GetLoginID();

  //dash board
  $scope.username = loginID.username;
  $scope.dashBoardName = 'dashBoard.TachoHistoryDashboard.' + $scope.username;
  var model = localStorageService.get($scope.dashBoardName);

  if (!model) {
    model = customerService.getTachoHistoryDashboardConfig(commonTrackService.getViewPortName());
  }

  $scope.dashBoardModel = model;
  $scope.collapsible = true;
  $scope.maximizable = true;

  $scope.widgetFilter = function (widget, type) {
    if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
      return type;
    }
  };

  var isExculdedParentWidgetArr = ['vehicleListWidget', 'FMSVehicleWidget', 'DriverWrkHrsWidget', 'fleetMapWidget', 'tachoDownloadStatusWidget'];

  function isExculdedParentWidget(type) {
    for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
      if (type === isExculdedParentWidgetArr[j]) {
        return true;
      }
    }
    return false;
  }

  function notExist(type) {
    return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
  }

  var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
    localStorageService.set(name, model);
  });

  var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
    if (data.selectedRow) {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
    } else {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
    }
  });

  var tachoDetailWidgtEvet = $scope.$on('tacho_detail_widget_event', function (event, data) {
    if (data.eventType === 'date_change') {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
        name: 'tachoEventDetailWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
      }], data.date);
      //data
    } else if (data.eventType === 'tacho_event_history_table_row_select' || data.eventType === 'working_hours_row_select') {
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
        name: 'DriverWrkHrsSVGWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.driverWhrkHrsSVG.title'
      }, {
        name: 'DriverDigitalTachoStatusWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'
      }], data.date);

      if (data.selectedRow) {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
          name: 'vehicleMapWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.deviceMap.deviceMapTitle'
        }, {
          name: 'vehicleDetailsWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'
        }, {
          name: 'TempMonitoringWidget',
          titleTranslationKey: 'dashBoard.fleetManagement.tempMonitoringWidget.title'
        }], data.selectedRow.devicedesc);
      }
      // update drive name
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
        name: 'tachoEventDetailWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
      }], data.date + ' / ' + data.selectedRow.driverdesc);
    }
  });

  $scope.$on('$destroy', function () {
    rowSelectedEvnt();
    adfDashboardChangedEvnt();
    tachoDetailWidgtEvet();
  });
}]);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/trackDashboard.tpl.html', '<div class="container-fluid mainContent"><div class="row"><div class="col-sm-12"><adf-dashboard name="{{dashBoardName}}" collapsible="{{collapsible}}" maximizable="{{maximizable}}" structure="3-9 (12/6-6)" adf-model="dashBoardModel" adf-widget-filter="widgetFilter"></adf-dashboard></div></div></div>');
  }]);
})();

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('betosyswebapp').controller('TrackDashboardCtrl', ["$rootScope", "$scope", "AuthenticationService", "base64", "localStorageService", "$translate", "commonTrackService", "dashboardService", "customerService", function ($rootScope, $scope, AuthenticationService, base64, localStorageService, $translate, commonTrackService, dashboardService, customerService) {
  $scope.pageHeader = 'BetoTrack Dashboard';

  var loginID = AuthenticationService.GetLoginID();
  //var password = base64.decode($rootScope.globals.currentUser.authdata).split(':')[1];
  /*
    $scope.mapUrl = 'track/Track?account=' + loginID.Account + '&user=' +loginID.username+'&password='+password+'&page=report.show&page_cmd=rptsel&page_cmd_arg&device=0056&r_report=EventDetail&r_option&r_text&date_fr=2015%2f07%2f01%2f00%3a00&date_to=2015%2f12%2f01%2f23%3a59&date_tz=Europe%2fBerlin&r_limit&r_limType&r_emailAddr&r_menu=menu.rpt.devDetail&fmt=map';
   */

  //$scope.mapUrl = 'fleetapi/map';


  $scope.closeAlert = function () {
    $scope.error = false;
  };

  //dash board
  $scope.username = loginID.username;
  $scope.dashBoardName = 'dashBoard.Plan.' + $scope.username;
  var model = localStorageService.get($scope.dashBoardName);
  if (model) {
    commonTrackService._loopWidgetsInDashboard(model, commonTrackService.getVehicleBasedWidgetNameArray(), null);
    commonTrackService._loopWidgetsInDashboard(model, commonTrackService.getVehicleBasedWidgetNameArray(), null);
  }
  if (!model) {
    // set default model
    model = customerService.getLastLocationDashboardConfig(commonTrackService.getViewPortName());
  }

  $scope.dashBoardModel = model;
  $scope.collapsible = true;
  $scope.maximizable = true;

  $scope.widgetFilter = function (widget, type) {
    if (!isExculdedParentWidget(type) && (widget.isSingleInstance === undefined || notExist(type))) {
      return type;
    }
  };

  function notExist(type) {
    return !dashboardService.getDashboardWidget($scope.dashBoardModel, type);
  }
  var isExculdedParentWidgetArr = ['DriverWrkHrsWidget', 'tachoHistoryWidget', 'FMSVehicleWidget', 'tachoDownloadStatusWidget'];

  function isExculdedParentWidget(type) {
    for (var j = 0; j < isExculdedParentWidgetArr.length; j++) {
      if (type === isExculdedParentWidgetArr[j]) {
        return true;
      }
    }
    return false;
  }
  var adfDashboardChangedEvnt = $scope.$on('adfDashboardChanged', function (event, name, model) {
    localStorageService.set(name, model);
  });

  var vehicleGroupChangedEvnt = $scope.$on('vehicleGroupChanged', function (event, data) {
    commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getFleetBasedWidgetNameArray(), data.selectedVehicleGroupLabel);
  });

  var widgetDataFromServer = $scope.$on('init-widget-data-from-server', function (event, data) {
    if (data.selectedRow) {
      var dateSting = moment(data.selectedRow.date).format('DD.MM.YYYY');
      commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, [{
        name: 'tachoEventDetailWidget',
        titleTranslationKey: 'dashBoard.fleetManagement.tachoEventDetail.tachoEventDetailTitle'
      }], dateSting);
    }
  });

  var rowSelectedEvnt = $scope.$on('rowSelected', function (event, data) {
    if (data.updateWidgetTitle) {
      if (data.selectedRow) {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), data.selectedRow.devicedesc);
      } else {
        commonTrackService._loopWidgetsInDashboard($scope.dashBoardModel, commonTrackService.getVehicleBasedWidgetNameArray(), null);
      }
    }
  });

  $scope.$on('$destroy', function () {
    adfDashboardChangedEvnt();
    vehicleGroupChangedEvnt();
    rowSelectedEvnt();
    widgetDataFromServer();
  });
}]);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicle/vehicleListEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 4/28/2015.
 */



angular.module('dashboard.vehicleList', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('vehicleListWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.vehicleList.vehicleListTitle';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.vehicleList.description';
      }
    },
    controller: 'vehicleListCtrl',
    templateUrl: 'components/dashboard/vehicle/vehicleListWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      vehicleGroup: null,
      noOfGridRows: ''
    },
    edit: {
      templateUrl: 'components/dashboard/vehicle/vehicleListEdit.tpl.html',
      reload: false,
      controller: 'vehicleListEditCtrl'
    }
  });
}]).service('vehicleListWidgetService', ["dsaComponentsConfig", "crudService", "$translate", "commonTrackService", "widgetSettingsCreatorService", function (dsaComponentsConfig, crudService, $translate, commonTrackService, widgetSettingsCreatorService) {

  this.getVehicleList = function (vechileGroup, isDataRefresh) {
    var requestParam = {
      statusCode: 'all',
      vehicleGroup: vechileGroup,
      dataRefresh: isDataRefresh,
      timeTo: '-0d',
      timeFrom: ''
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'vehiclelist', param);
  };

  this.getStatusCodeComboList = function () {
    return crudService.get('overview/statuscode');
  };

  this.getVehicleEventDetailList = function (deviceId, isDataRefresh, startDate, endDate) {
    var requestParam = {
      statusCode: '',
      vehicleGroup: '',
      dataRefresh: isDataRefresh,
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'EventDetail'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'vehicleeventdetail/' + deviceId, param);
  };

  this.getVehicleOrdersList = function (deviceId, isDataRefresh, startDate, endDate) {
    var requestParam = {
      statusCode: '',
      vehicleGroup: '',
      dataRefresh: isDataRefresh,
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'DeviceWorkOrders'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'deviceworkorders/' + deviceId, param);
  };

  this.getCargoQualityList = function (deviceId, isDataRefresh, startDate, endDate) {
    var requestParam = {
      statusCode: '',
      vehicleGroup: '',
      dataRefresh: isDataRefresh,
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'EventDetailCargoQuality'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'cargoquality/' + deviceId, param);
  };

  this.getMoreFunctionSettings = function () {
    var _moreFunctionSetting = {
      placeHolder: $translate.instant('moreFunction.button.function'),
      displayMember: 'name',
      valueMember: 'value',
      source: [{
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
        execute: 'createMessageEvent',
        value: 'sendMsg'
      }, {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
        execute: 'createCommandEvent',
        value: 'sendCommand'
      }, {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showReports'),
        value: 'showReport',
        execute: 'contextFuntion-EventDetailAll'
      }, {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
        value: 'showDriverDashboard',
        execute: 'showDriverDashboard'
      }, /*{
         name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
         value: 'showPortalCommand',
         execute: 'showPortalCommand'
         },*/{
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
        value: 'showFmsDashboard',
        execute: 'showFmsDashboard'
      }, {
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.copyLocationToClipboard'),
        value: 'copyLocation',
        execute: 'copyLocation'
      }],

      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      width: '100%',
      height: dsaComponentsConfig.jqxDefaultSetting.comboxHeight,
      autoDropDownHeight: true
    };
    return _moreFunctionSetting;
  };

  this.getContextMenuSettings = function (height) {
    var settings = { width: 200, height: height ? height : 30, autoOpenPopup: false, mode: 'popup' };
    return settings;
  };
  this.getRowSize = function () {
    var rowSize = {
      XS: {
        4: 280,
        5: 350,
        8: 300, // yet to define
        10: 580,
        20: 1025,
        15: 800,
        25: 1250,
        50: 2375,
        75: 3500,
        100: 4625
      },
      SM: {
        4: 200, // yet to define
        5: 325,
        8: 300, // yet to define
        10: 525,
        15: 730,
        20: 930,
        25: 1125,
        50: 2125,
        75: 3125,
        100: 4125
      },
      MD: {
        4: 200,
        5: 310,
        8: 395,
        10: 480,
        15: 655,
        20: 830,
        25: 1005,
        50: 1880,
        75: 2755,
        100: 3630
      },
      LG: {
        4: 200, //yet to define
        5: 285,
        8: 300,
        10: 430,
        15: 585,
        20: 735,
        25: 885,
        50: 1630,
        75: 2390,
        100: 3135
      }
    };
    return rowSize[commonTrackService.getViewPortName()];
  };
}]).controller('vehicleListCtrl', ["$scope", "config", "widgetSettingsCreatorService", "vehicleListWidgetService", "$rootScope", "$timeout", "$q", "$translate", "commonTrackService", "$state", "$filter", "localStorageService", "AuthenticationService", "errorHandlingService", "toastService", "$interval", "stateManagerService", function ($scope, config, widgetSettingsCreatorService, vehicleListWidgetService, $rootScope, $timeout, $q, $translate, commonTrackService, $state, $filter, localStorageService, AuthenticationService, errorHandlingService, toastService, $interval, stateManagerService) {

  //  $scope.statusCode = config.statusCode;
  $scope.selectedFunction = '';
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();

  var TAB_VEHICLE_LIST = 0,
      TAB_ORDERS = 1,
      TAB_VEHICLE_DETAILS = 2,
      TAB_CARGO_QUALITY = 3;
  $scope.activeTab = TAB_VEHICLE_LIST;
  $scope.previousTab = TAB_VEHICLE_LIST;
  $scope.vehicleDetailTab = {
    disable: true
  };
  $scope.vehicleOrdersTab = {
    disable: true
  };
  $scope.cargoQualityTab = {
    disable: true
  };

  var dateRangePickerSettings = {};
  var errorObj = { type: 'F', message: '' };
  var _lastRefreshTimeS = null;
  var counterSeconds = 60;
  var counterTimeout;
  var rowSize = vehicleListWidgetService.getRowSize();
  $scope.isDataAvailable = true;
  $scope.isOrderAvailable = true;
  $scope.isDetialAvailable = true;
  $scope.uuidForElement = $scope.$id;
  $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
    //theme: 'material' use default theme instead
  });

  $scope.customGridProperties = {
    vehicleOrders: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
      pageable: false,
      columns: []
    },
    vehicleLastLocation: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
      pageable: false,
      columns: []
    },
    vehicleEventDetails: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
      pageable: false,
      columns: []
    },
    cargoQualityDetail: {
      height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
      pageable: false,
      columns: []
    }
  };

  $scope.vehicleDetail = {
    date: {
      startDate: new Date().setHours(0, 0, 0, 0),
      endDate: new Date()
    }
  };

  $scope.cargoQualityDetail = {
    date: {
      startDate: new Date().setHours(0, 0, 0, 0),
      endDate: new Date()
    }
  };

  $scope.vehicleOrders = {
    date: {
      startDate: new Date().setHours(0, 0, 0, 0),
      endDate: new Date()
    }
  };

  // stateManagerService
  // Defines important params used in the widget,
  // params that can be provided to other widgets
  $scope.dataSet = {
    deviceID: null,
    startDate: null,
    endDate: null,
    lastUpdateRequest: 0
  };

  var vehicleListSource = {
    datatype: 'array',
    datafields: [],
    sort: null,
    localdata: []
  };

  /**
   *  temporay private variable  to store some global values , created to avoid using config object .
   *  dont use config which will be stored to localstorage and may cuase issues when reused from localstorage
   */
  var _tmpConfig = {};

  // stateManagerService
  // Used when unkown dependant (child) widget requests data.
  // Since this is a global request for data, widget needs to check if the,
  // requested fields is anything it can provide before updating.
  // Will call the dataStateUpdate event if it updates data.
  var updateRequest = $scope.$on('reqDataUpdate', function () {
    var selectedRowData = {};
    var slectedLatLocationrowData = {};
    var selectIndex = -1;
    selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getselectedrowindex');
    if (selectIndex > -1) {
      slectedLatLocationrowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getrowdata', selectIndex);
    }
    switch ($scope.activeTab) {
      case 1:
        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('getrowdata', selectIndex);
        }
        break;
      case 2:
        //uses same row select Logic
        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleEventDetailsList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleEventDetailsList').jqxGrid('getrowdata', selectIndex);
        }
        break;
      case 3:
        selectIndex = window.$('#' + $scope.overviewGridPrefix + 'cargoQualityDetailList').jqxGrid('getselectedrowindex');
        if (selectIndex > -1) {
          selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'cargoQualityDetailList').jqxGrid('getrowdata', selectIndex);
        }
        break;
    }
    // push the changes to stateManagerService
    stateManagerService.updateDeviceID('vehicleListWidget', selectedRowData.deviceid, true);
    stateManagerService.updateStartDate('vehicleListWidget', $scope.dataSet.startDate, true);
    stateManagerService.updateValue('vehicleListWidget', 'endDate', $scope.dataSet.endDate, true);
    if ($scope.activeTab > TAB_VEHICLE_LIST) {
      stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', selectedRowData, true);
      stateManagerService.updateValue('vehicleListWidget', 'tab_' + TAB_VEHICLE_LIST + '_selectedRow', slectedLatLocationrowData, true);
    } else if (!_.isEmpty(slectedLatLocationrowData)) {
      // first tab must always return a valid selected values
      stateManagerService.updateValue('vehicleListWidget', 'tab_' + TAB_VEHICLE_LIST + '_selectedRow', slectedLatLocationrowData, true);
    }

    $rootScope.$broadcast('resDataUpdate', {
      widget: 'vehicleListWidget',
      activeTab: $scope.activeTab,
      dashboardName: 'dashboard.vehicleList',
      timespan: new Date().getTime()
    });
  });

  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        if ($scope.activeTab === TAB_VEHICLE_DETAILS) {
          $scope.vehicleDetail.date.startDate = moment($scope.vehicleDetail.date.startDate);
          $scope.vehicleDetail.date.endDate = moment($scope.vehicleDetail.date.endDate);

          _tmpConfig.startDate = $scope.vehicleDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
          _tmpConfig.endDate = $scope.vehicleDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
          loadVehicleEventDetailList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate);
        }
        if ($scope.activeTab === TAB_ORDERS) {
          $scope.vehicleOrders.date.startDate = moment($scope.vehicleOrders.date.startDate);
          $scope.vehicleOrders.date.endDate = moment($scope.vehicleOrders.date.endDate);
          _tmpConfig.startDate = $scope.vehicleOrders.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
          _tmpConfig.endDate = $scope.vehicleOrders.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
          loadVehicleOrdersList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate).then(function (orderList) {
            if (orderList && orderList.length > 0) {
              //select the first as default
              var rowindex = _getCurrentRowIndex('vehicleOrdersList', orderList.length);
              if (rowindex) {
                var rowData = orderList[rowindex];
                if (rowData) {
                  var _tmpStartDate = commonTrackService.formatReportDateTime(rowData.workorderstartdate, rowData.workorderstarttime, false);
                  var _tmpEndDate = commonTrackService.formatReportDateTime(rowData.workorderenddate, rowData.workorderendtime, false);
                  if (_tmpStartDate && _tmpStartDate) {
                    broadcastEventData.selectedOrderRow = rowData;
                    if ($scope.activeTab === TAB_ORDERS) {
                      $rootScope.$broadcast('tabEvent', {
                        'tabName': 'vehicleOrders',
                        'repoVehicle': rowData.deviceid,
                        'startDate': _tmpStartDate,
                        'endDate': _tmpEndDate,
                        dashboardName: 'dashboard.vehicleList',
                        isDataFromTab: true,
                        tabNumber: 1

                      });

                      // stateManagerService
                      // Push values to the stateManagerService
                      stateManagerService.updateDeviceID('vehicleListWidget', rowData.deviceid, true);
                      stateManagerService.updateStartDate('vehicleListWidget', _tmpStartDate, true);
                      stateManagerService.updateValue('vehicleListWidget', 'endDate', _tmpStartDate, true);
                      stateManagerService.updateValue('vehicleListWidget', 'orderData', rowData, false);
                      stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', rowData, true);

                      $rootScope.$broadcast('dataStateUpdate', {
                        widget: 'vehicleListWidget',
                        activeTab: $scope.activeTab,
                        dashboardName: 'dashboard.vehicleList',
                        timespan: new Date().getTime()
                      });
                    }
                  }
                }
              }
            }
          });
        }

        //  The tab is hidden and its not , enable when the related tab is activated again
        /* if ($scope.activeTab === 3) {
          $scope.cargoQualityDetail.date.startDate = moment($scope.cargoQualityDetail.date.startDate);
          $scope.cargoQualityDetail.date.endDate = moment($scope.cargoQualityDetail.date.endDate);
          _tmpConfig.startDate = $scope.cargoQualityDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
          _tmpConfig.endDate = $scope.cargoQualityDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
          loadCragoQualityList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate);
        } */
      }

    }
  };
  var lastLocationContextMenu = {};
  var ordersContextMenu = {};

  var isLastLocationCtxInitialized = false;
  var isOrdersCtxInitialized = false;

  //var orderCntxMenu = {};
  commonTrackService.getDatePickerDetails().then(function (settings) {
    var tab = $scope.activeTab === TAB_CARGO_QUALITY ? 'EventDetailCargoQuality' : $scope.activeTab === TAB_VEHICLE_DETAILS ? 'EventDetail' : undefined;
    $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, tab));
    dateRangePickerSettings = settings;
  });
  $scope.moreFuctionSetting = vehicleListWidgetService.getMoreFunctionSettings();

  var broadcastEventData = {
    selectedRow: {},
    selectedVehicleGroup: '',
    selectedStatusCode: '',
    selectedVehicleGroupLabel: '',
    eventSource: '',
    selectedOrderRow: {},
    isRefreshStarted: false,
    lastTabName: '',
    dashboardName: 'dashboard.vehicleList',
    isDataFromTab: true
  };

  var _lastSelctedDeviceId = null;
  var gtsUserSettings = null;

  //  status code not needed for 1'st release
  /* $scope.statusCodeSettings = widgetSettingsCreatorService.createComboxSettings({
   displayMember: 'displayName',
   valueMember: 'key'
   });*/

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {
        $scope.vehicleGroupSettings.source = vechileGroupList;
        var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

        if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) {
          // validate the local storage group is still valid ( group can change based on login )
          $scope.vehicleGroup = config.vehicleGroup;
        }

        if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {
            // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = cachedGroup;
            config.vehicleGroup = cachedGroup;
          }
        }

        if (!$scope.vehicleGroup) {
          $scope.vehicleGroup = vechileGroupList[0].groupID;
        }
      }
    });
  };

  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
    });
  };

  var loadVechileList = function loadVechileList(vehicleGroup, dataRefresh, isAutorefresh) {
    $scope.stop();
    //statusCode = statusCode !== undefined && statusCode !== null ? statusCode : 'all';
    return vehicleListWidgetService.getVehicleList(vehicleGroup, dataRefresh).then(function (vehicleResult) {
      if (vehicleResult.dataList) {
        $scope.isDataAvailable = true;
        if (dataRefresh) {
          $scope.customGridProperties.vehicleLastLocation.columns = commonTrackService.getColumnProperties(vehicleResult.gridSettings.overviewListGrids[0].columnProperties, vehicleResult.columnTranslation, { moduleName: 'vehicleLastLocation' });
          vehicleListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'vehicleLastLocationList', vehicleListSource);
          vehicleListSource.localdata = vehicleResult.dataList;
          _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
          var _preferedDeviceId = gtsUserSettings.preferredDeviceID;
          var _preferedVehicleRowIndex = null;
          // users preferred vehicle selection from user settings.
          if (_preferedDeviceId && dataRefresh && $state.previous.name === 'login') {
            _preferedVehicleRowIndex = getRowIndex(vehicleListSource, _preferedDeviceId);
          }
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.lastLocation') };
          $scope.vehicleLastLocGridSettings = commonTrackService.getGridSettings('vehicleLastLocation', $scope.customGridProperties.vehicleLastLocation, _preferedVehicleRowIndex, _additionalProperties);
          $scope.vehicleListdataAdapter = new window.$.jqx.dataAdapter(vehicleListSource);
          $scope.vehicleLastLocGridSettings.source = $scope.vehicleListdataAdapter;
        } else {
          vehicleListSource.localdata = vehicleResult.dataList;
          _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehicleLastLocationList');
        }
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      $scope.counter = counterSeconds;
      $scope.createVehicleListGrid = true;

      // When widget loaded first time , The auto refresh should start by default
      $timeout(function () {
        if (_isDefaultAutoRefreshBeginValid()) {
          $scope.startCounter();
        } else {
          $scope.stop(); // stop ROUGE running AutoRefresh if any .
        }
      }, 0);

      // send row select event after evey request to update the broadcastEventData[selected grid row details].
      if (isAutorefresh && _lastSelctedDeviceId || !dataRefresh && _lastSelctedDeviceId || _lastSelctedDeviceId === 0) {
        $timeout(function () {
          broadcastEventData.isRefreshStarted = true;
          var _rowIndex = getRowIndex(vehicleListSource, _lastSelctedDeviceId); // find row index based on device id
          var sortinformation = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getsortinformation');
          if (_rowIndex && !sortinformation.sortcolumn && !sortinformation.sortdirection) {
            // if sort available the custom sort will do the row selection .
            window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('selectrow', _rowIndex);
          }
          if ($scope.vehicleOrdersTab.disable) {
            broadcastEventData.selectedOrderRow = null;
          }
        }, 0);
      }
    });
  };

  /**
   * Decides when to intiate DEFAULT auto refresh.
   * ----------------------------------------------------------------------------------------------------------------------------------------------------------------------
   * Auto refresh only valid for main TAB  under following situations
   *
   *  grid data is already read from backend '$scope.isDataAvailable'  AND no existing auto refresh is statred :: When the widget first loaded / when comes to dashboard
   *
   * OR
   *
   *  grid data is already read from backend '$scope.isDataAvailable'  AND auto refresh refence object in the state of 'canceled'
   * ----------------------------------------------------------------------------------------------------------------------------------------------------------------------
   *
   */
  function _isDefaultAutoRefreshBeginValid() {
    if ($scope.activeTab === TAB_VEHICLE_LIST) {
      // TAB check is must to prevent unexpeted behaviour under Async situations.

      // grid data is already read from backend '$scope.isDataAvailable'  AND no existing auto refresh statred
      if ($scope.isDataAvailable && !counterTimeout) {
        return true;
      }
      //grid data is already read from backend '$scope.isDataAvailable'  AND auto refresh refence object in the state of 'canceled'
      if ($scope.isDataAvailable && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled') {
        return true;
      }
    }
    return false;
  }

  function getRowIndex(vehicleListSource, _preferedDeviceId) {
    for (var i = 0; i < vehicleListSource.localdata.length; i++) {
      if (_preferedDeviceId === vehicleListSource.localdata[i].deviceid) {
        return i;
      }
    }
    return null;
  }

  function contextFuntion(reportName) {
    var selectedData = _initRequestData(undefined, '-');

    $state.go('reports.vehicleDetail', {
      'reportName': reportName,
      'vehicleId': _tmpConfig.deviceId,
      'dateFrom': selectedData._tmpStartDate,
      'dateTo': selectedData._tmpEndDate
    });
  }

  function createMessageEvent() {
    $rootScope.$broadcast('newMsgEvent', {});
  }

  function createCommandEvent() {
    $rootScope.$broadcast('newCommandEvent', {});
  }

  function showDriverDashboard() {
    $state.go('driverdashboard');
  }

  function showPortalCommand() {
    $state.go('portalcommand');
  }

  function showFmsDashboard() {
    $state.go('fmsdashboard');
  }

  var _commonFunction = {
    'contextFuntion': contextFuntion,
    'createMessageEvent': createMessageEvent,
    'createCommandEvent': createCommandEvent,
    'showDriverDashboard': showDriverDashboard,
    'showPortalCommand': showPortalCommand,
    'showFmsDashboard': showFmsDashboard,
    'copyLocation': copyLocation
  };
  var _contextSourceObj = {
    lastLocCtxSource: [{
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showReports'),
      'execute': contextFuntion,
      'reportName': 'EventDetailAll'
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
      execute: createMessageEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
      execute: createCommandEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
      execute: showDriverDashboard
    }, /*{
       label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
       execute: showPortalCommand
       }, */{
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
      execute: showFmsDashboard
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.copyLocationToClipboard'),
      execute: copyLocation
    }],
    ordersCtxSource: [{
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showReports'),
      'execute': contextFuntion,
      'reportName': 'EventDetailAll'
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
      execute: createMessageEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
      execute: createCommandEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
      execute: showDriverDashboard /*, {
                                    label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
                                    execute: showPortalCommand
                                   }*/ }]
  };

  $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(165);
  $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
    source: _contextSourceObj.lastLocCtxSource, popupZIndex: 999999
  });
  commonTrackService.getGtsUserSettings(false).then(function (userSettings) {
    gtsUserSettings = userSettings;
    return commonTrackService.getGtsAccountSettings(true);
  }).then(function () {
    return loadVehicleGroup();
  }).then(function () {
    return loadFleetServerDetails();
  }).finally(function () {
    $scope.dataLoadingFinished = true;
    if ($scope.vehicleGroup) {
      loadVechileList($scope.vehicleGroup, true);
    }
  });

  $scope.vehicleGroupComboChange = function (event) {
    var vehicleGroup = event.args.item;
    // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
    if (config.vehicleGroup !== vehicleGroup.value) {
      if ($scope.vehicleLastLocGridSettings) {
        loadVechileList(vehicleGroup.value, $scope.vehicleLastLocGridSettings.columns.length > 0 ? false : true);
      }
    }
    if (vehicleGroup) {
      broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
      broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
      config.vehicleGroup = vehicleGroup.value;
      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, config.vehicleGroup);
      commonTrackService.setLastLocatioWidgetData(broadcastEventData);
      broadcastEventData.dashboardName = 'dashboard.vehicleList';
      broadcastEventData.isDataFromTab = true;
      broadcastEventData.tabNumber = $scope.activeTab;
      $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
    }
  };

  function copyLocation() {
    var selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getselectedrowindex');
    if (selectIndex > -1) {
      var rowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getrowdata', selectIndex);
      //console.log(rowData);
      if (rowData.geopoint) {
        var location = {
          lat: rowData.geopoint.split('/')[0],
          lon: rowData.geopoint.split('/')[1]
        };
        commonTrackService.copyToClipboard(JSON.stringify(location));
      }
    }
  }

  // update vehicle map widget  based on selected vechile id
  $scope.vehicleLastLocRowSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      _lastSelctedDeviceId = event.args.row.deviceid || null;
      $rootScope.$broadcast('init-widget-data-from-server', { deviceID: _lastSelctedDeviceId, selectedRow: event.args.row });

      broadcastEventData.selectedRow = event.args.row;
      //https://bugzilla.app.dsa.de/bugzilla/show_bug.cgi?id=105358#c6 , updateMapUrl flag should be based set based on '$scope.activeTab',
      // broadcastEventData.lastTabName can be inconsistent
      broadcastEventData.updateMapUrl = $scope.activeTab === TAB_VEHICLE_DETAILS || $scope.activeTab === TAB_CARGO_QUALITY ? false : true;
      broadcastEventData.updateWidgetTitle = true;
      broadcastEventData.selectedOrderRow = null;
      broadcastEventData.gridName = 'vehicleLastLocation';
      broadcastEventData.isTermoWidgetDependent = true;
      // tab check necessary to prevent async row select which result in wrong map URL in Vehicle Map widget.
      if ($scope.activeTab === TAB_VEHICLE_LIST) {
        broadcastEventData.dashboardName = 'dashboard.vehicleList';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = TAB_VEHICLE_LIST;
        $rootScope.$broadcast('rowSelected', broadcastEventData);
      }

      // stateManagerService
      // on row select push data to service, and broadcast dataStateUpdate
      var date = commonTrackService.formatReportDateTime(event.args.row.date, event.args.row.time);

      $scope.dataSet.deviceID = _lastSelctedDeviceId;
      $scope.dataSet.startDate = date;
      $scope.dataSet.endDate = date;

      stateManagerService.updateDeviceID('vehicleListWidget', _lastSelctedDeviceId, true);
      stateManagerService.updateStartDate('vehicleListWidget', date, true);
      stateManagerService.updateValue('vehicleListWidget', 'endDate', date, true);
      stateManagerService.updateValue('vehicleListWidget', 'rowData', event.args.row, false);
      stateManagerService.updateValue('vehicleListWidget', 'vehicleListRowData', event.args.row, false);
      stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', event.args.row, true);

      $rootScope.$broadcast('dataStateUpdate', {
        widget: 'vehicleListWidget',
        activeTab: $scope.activeTab,
        dashboardName: 'dashboard.vehicleList',
        rowSelectOriginalEvent: event.args.originarlEvent || null // pass the original event to determine if the select from user or programatic
      });

      commonTrackService.setLastLocatioWidgetData(broadcastEventData);
      var pushPinIndex = event.args.row.index - 1;
      $rootScope.$broadcast('fleet-map-update', { pushPinIndex: pushPinIndex, deviceId: event.args.row.deviceid });
      $scope.vehicleDetailTab.disable = false;
      $scope.vehicleOrdersTab.disable = false;
      $scope.cargoQualityTab.disable = false;
      // refresh other dependent grid
      if ($scope.activeTab === TAB_ORDERS) {
        var _tmpTimeFormat = _initRequestData('vehicleOrders', undefined, true);
        if (_tmpTimeFormat) {
          loadVehicleOrdersList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleOrders.columns.length > 0 ? false : true, _tmpTimeFormat._tmpStartDate, _tmpTimeFormat._tmpEndDate);
        }
        broadcastEventData.lastTabName = 'orders';
      } else if ($scope.activeTab === TAB_VEHICLE_DETAILS) {
        var _tmpVehicleDetailsTimefrmt = _initRequestData('vehicleDetail', undefined, true);
        if (_tmpVehicleDetailsTimefrmt) {
          loadVehicleEventDetailList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleEventDetails.columns.length > 0 ? false : true, _tmpVehicleDetailsTimefrmt._tmpStartDate, _tmpVehicleDetailsTimefrmt._tmpEndDate);
        }
        broadcastEventData.lastTabName = 'vehicleDetails';
      } else {
        broadcastEventData.lastTabName = 'lastLocation';
      }
      //save
      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
        'deviceid': broadcastEventData.selectedRow.deviceid,
        'driverid': broadcastEventData.selectedRow.driverid
      });
    }
  };
  $scope.gridRowClickHandler = function (event) {
    if (event.args.rightclick) {
      if (!isLastLocationCtxInitialized) {
        lastLocationContextMenu = $('#' + $scope.uuidForElement + '_betoTrack_vehicleLastLocationCtx').jqxMenu($scope.ctxMenuSettings);
        $('#' + $scope.uuidForElement + '_betoTrack_vehicleLastLocationCtx').on('itemclick', lastLocationContextHandler);
        isLastLocationCtxInitialized = true;
      }
      commonTrackService.initGridRightClickContextMenu(event, lastLocationContextMenu);
    }
  };

  function lastLocationContextHandler(event) {

    commonTrackService.executeContextMenuClick(event, 'lastLocCtxSource', _contextSourceObj);
  }

  $scope.vehicleOrdersRowSelectHandler = function (event) {
    if (event.args.rightclick) {

      if (!isOrdersCtxInitialized) {
        ordersContextMenu = $('#' + $scope.uuidForElement + '_betoTrack_vehicleOrdersCtx').jqxMenu($scope.ctxMenuSettings);
        $('#' + $scope.uuidForElement + '_betoTrack_vehicleOrdersCtx').on('itemclick', lastLocationContextHandler);
        isOrdersCtxInitialized = true;
      }
      commonTrackService.initGridRightClickContextMenu(event, ordersContextMenu);
    }
    if (event.type === 'rowselect') {
      broadcastEventData.selectedOrderRow = event.args.row;
      if (event.args.row) {
        // tab check necessary to prevent async row select which result in wrong map URL in Vehicle Map widget.
        if ($scope.activeTab === TAB_ORDERS) {
          stateManagerService.updateValue('vehicleListWidget', 'orderRowData', event.args.row, false);
          stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', event.args.row, true);

          $rootScope.$broadcast('ordersRowSelected', {
            'repoVehicle': event.args.row.deviceid,
            'startDate': commonTrackService.formatReportDateTime(event.args.row.workorderstartdate, event.args.row.workorderstarttime, false),
            'endDate': commonTrackService.formatReportDateTime(event.args.row.workorderenddate, event.args.row.workorderendtime, false),
            updateWidgetTitle: false,
            dashboardName: 'dashboard.vehicleList',
            isDataFromTab: true,
            tabNumber: 1,
            orderid: event.args.row.orderid
          });
          stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', event.args.row, true);

          $rootScope.$broadcast('dataStateUpdate', {
            widget: 'vehicleListWidget',
            timespan: new Date().getTime(),
            dashboardName: 'dashboard.vehicleList',
            activeTab: $scope.activeTab
          });
        }
      }
    }
  };

  $scope.rowSelectHandler = function (event) {
    var _vehicleDetailRow = {};
    var isEventValidforSelectedTab = false;
    _vehicleDetailRow.selectedRow = event.args.row;
    _vehicleDetailRow.selectedRow.deviceid = broadcastEventData.selectedRow.deviceid;
    if (event.currentTarget.id.indexOf('cargoQualityDetail') > 0) {
      _vehicleDetailRow.gridName = 'cargoQuality';
      isEventValidforSelectedTab = $scope.activeTab === TAB_CARGO_QUALITY ? true : false;
      _vehicleDetailRow.updateMapUrl = false;
      stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, false);
    }
    if (event.currentTarget.id.indexOf('vehicleEventDetail') > 0) {
      _vehicleDetailRow.gridName = 'vehicleDetail';
      _vehicleDetailRow.updateMapUrl = false;
      isEventValidforSelectedTab = $scope.activeTab === TAB_VEHICLE_DETAILS ? true : false;
      stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, false);
    }
    _vehicleDetailRow.updateWidgetTitle = false;
    _vehicleDetailRow.tabIndex = $scope.activeTab;

    // tab check necessary to prevent async row select which result in wrong map URL in Vehicle Map widget.
    if (isEventValidforSelectedTab) {
      _vehicleDetailRow.dashboardName = 'dashboard.vehicleList';
      _vehicleDetailRow.isDataFromTab = true;
      _vehicleDetailRow.tabNumber = $scope.activeTab;
      $rootScope.$broadcast('rowSelected', _vehicleDetailRow);
      if (event.type === 'rowselect') {
        commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'vehicleMap');
      }
    }

    // stateManagerService
    var date = commonTrackService.formatReportDateTime(event.args.row.date, event.args.row.time);

    $scope.dataSet.deviceID = _vehicleDetailRow.selectedRow.deviceid;
    $scope.dataSet.startDate = date;
    $scope.dataSet.endDate = date;

    stateManagerService.updateDeviceID('vehicleListWidget', _vehicleDetailRow.selectedRow.deviceid, true);
    stateManagerService.updateStartDate('vehicleListWidget', date, true);
    stateManagerService.updateValue('vehicleListWidget', 'endDate', date, true);
    stateManagerService.updateValue('vehicleListWidget', 'rowData', _vehicleDetailRow.selectedRow, false);
    stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, true);

    $rootScope.$broadcast('dataStateUpdate', {
      widget: 'vehicleListWidget',
      timespan: new Date().getTime(),
      dashboardName: _vehicleDetailRow.dashboardName,
      isDataFromTab: _vehicleDetailRow.isDataFromTab,
      activeTab: $scope.activeTab
    });
  };

  $scope.startCounter = function () {
    $scope.stop();
    $scope.isTimerStated = true;
    $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
    if ($scope.counter - 1 >= 1) {
      $scope.counter--;
      counterTimeout = $interval($scope.startCounter, 1000);
    } else {
      var _vehicleGroup = window.$('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');

      if (_vehicleGroup && _vehicleGroup.value) {
        loadVechileList(_vehicleGroup.value, false, true);
      } else {
        errorObj.message = $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleGroupValidation');
        toastService.showErrorToast(errorObj);
        $scope.stop();
      }
    }
  };

  $scope.stop = function () {
    $interval.cancel(counterTimeout);
  };

  function _updateSelectedRowData() {
    var selectedRowIndex = $('#_betoTrack_vehicleLastLocationList').jqxGrid('getselectedrowindex');
    if (selectedRowIndex >= 0) {
      var rowData = $('#_betoTrack_vehicleLastLocationList').jqxGrid('getrowdata', selectedRowIndex);
      broadcastEventData.selectedRow = rowData;
    }
  }

  function _initRequestData(dateRangeScopeName, formatType, isRefresh) {
    var _typeOfGridRow = $scope.activeTab === TAB_ORDERS && broadcastEventData.selectedOrderRow && !isRefresh ? 'selectedOrderRow' : 'selectedRow';
    return _getRequestTimeRange(dateRangeScopeName, _typeOfGridRow, formatType);
  }

  /**
   * Prepares the Request From and To time based on the provided grid ddetails .
   * if _typeOfGridRow is 'selectedOrderRow' : the Selected Row from the orders used to determine the From/To request time stamp
   * if _typeOfGridRow is 'selectedRow' : the Selected Row from the Main grid to determine the From/To request time stamp
   *
   * @param {*} dateRangeScopeName scope object name to store the request details
   * @param {*} _typeOfGridRow 'selectedOrderRow' from Orders TAB OR  'selectedRow' from the main Grid
   * @param {*} formatType  custom data format to override default
   * @returns request From/To time for the current tab.
   */
  function _getRequestTimeRange(dateRangeScopeName, _typeOfGridRow, formatType) {
    if (_typeOfGridRow === 'selectedRow') {
      _updateSelectedRowData();
    }
    if (broadcastEventData[_typeOfGridRow].deviceid) {
      _tmpConfig.deviceId = broadcastEventData[_typeOfGridRow].deviceid;
      var _serverTimeFormat = {};
      _serverTimeFormat._tmpEndDate = _typeOfGridRow === 'selectedOrderRow' ? commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].workorderenddate, broadcastEventData[_typeOfGridRow].workorderendtime, formatType) : commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, broadcastEventData[_typeOfGridRow].time, formatType);
      _serverTimeFormat._tmpStartDate = _typeOfGridRow === 'selectedOrderRow' ? commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].workorderstartdate, broadcastEventData[_typeOfGridRow].workorderstarttime, formatType) : commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, '00:00:00', formatType);

      $scope[dateRangeScopeName] = {
        date: {
          startDate: new Date(_serverTimeFormat._tmpStartDate.replaceAt(10, ' ')),
          endDate: new Date(_serverTimeFormat._tmpEndDate.replaceAt(10, ' '))
        }
      };

      return _serverTimeFormat;
    } else {
      return null;
    }
  }

  /**
   * The Request Time range changes based on the 'TAB' the user previously clicked.
   *
   * Time range of selected ORDER if : User previously visited the Orders TAB
   *
   * Time range of selected VEHICLE from the main dashboard should be used if : User previously visited not 'Orders' Tab
   *
   * Prepares the Request data and assgin it to scope object 'scope.vehicleDetail'
   *
   */
  function _intiVehicleDetailRequestData() {
    //used the selected row details from the orders grid : IF  Previous tab is 'Orders'
    //  use selected row details from main dashboard grid:IF  Previous tab is NOT 'Orders'
    var _typeOfGridRow = $scope.previousTab === TAB_ORDERS && broadcastEventData.selectedOrderRow ? 'selectedOrderRow' : 'selectedRow';
    return _getRequestTimeRange('vehicleDetail', _typeOfGridRow);
  }

  // vehicle details tab functions
  var loadVehicleEventDetailList = function loadVehicleEventDetailList(deviceId, dataRefresh, startDate, endDate) {
    return vehicleListWidgetService.getVehicleEventDetailList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleEventDetailResult) {
      $scope.isDetialAvailable = true;
      if (vehicleEventDetailResult.dataList) {
        if (dataRefresh) {
          $scope.customGridProperties.vehicleEventDetails.columns = commonTrackService.getColumnProperties(vehicleEventDetailResult.gridSettings.overviewListGrids[0].columnProperties, vehicleEventDetailResult.columnTranslation, { moduleName: 'vehicleEventDetails' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleDetailsTab.vehicleDetails') };
          $scope.vehicleDetailsGridSettings = commonTrackService.getGridSettings('vehicleEventDetails', $scope.customGridProperties.vehicleEventDetails, null, _additionalProperties);
          $scope.vehicleDetailsGridSettings.source = vehicleEventDetailResult.dataList;
        } else {
          $scope.vehicleDetailsGridSettings.source = vehicleEventDetailResult.dataList;
        }
        if ($scope.activeTab === TAB_VEHICLE_DETAILS) {
          // race condition this may come latter when tab is actually changed
          if (vehicleEventDetailResult.dataList.length === 0) {
            // reset exising map details
            deviceId = null;
            startDate = null;
            endDate = null;
          }
          $rootScope.$broadcast('tabEvent', {
            'tabName': 'vechileEventDetail',
            'repoVehicle': deviceId,
            'startDate': startDate,
            'endDate': endDate,
            dashboardName: 'dashboard.vehicleList',
            isDataFromTab: true,
            tabNumber: TAB_VEHICLE_DETAILS
          });
        }

        // expecting map to be ready after 4 seconds and send row select which will update map for pushpin

        $timeout(function () {
          var rowindex = _getCurrentRowIndex('vehicleEventDetailsList', vehicleEventDetailResult.dataList.length);
          if (rowindex) {
            window.$('#' + $scope.overviewGridPrefix + 'vehicleEventDetailsList').jqxGrid('selectrow', rowindex);
          }
        }, 3000);
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDetialAvailable = false;
      }
    }).finally(function () {
      $scope.createVehicleDetilListGrid = true;
      broadcastEventData.lastTabName = 'vehicleDetails';
    });
  };

  // vehicle orders
  function clearVehicleOrdersList() {
    try {
      $('#_betoTrack_vehicleOrdersList').jqxGrid('clear');
    } catch (err) {
      //continue with code
    }
  }

  function updateVehicleOrdersList() {
    try {
      $('#_betoTrack_vehicleOrdersList').jqxGrid('updatebounddata');
    } catch (err) {
      //continue with code
    }
  }

  var loadVehicleOrdersList = function loadVehicleOrdersList(deviceId, dataRefresh, startDate, endDate) {
    clearVehicleOrdersList();

    return vehicleListWidgetService.getVehicleOrdersList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleOrdersResult) {
      $scope.isOrderAvailable = true;
      if (vehicleOrdersResult.dataList) {
        if (dataRefresh) {

          $scope.customGridProperties.vehicleOrders.columns = commonTrackService.getColumnProperties(vehicleOrdersResult.gridSettings.overviewListGrids[0].columnProperties, vehicleOrdersResult.columnTranslation, { moduleName: 'vehicleOrders' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.ordersTab.orders') };
          $scope.vehicleOrdersSettings = commonTrackService.getGridSettings('vehicleOrders', $scope.customGridProperties.vehicleOrders, null, _additionalProperties);
          $scope.vehicleOrdersSettings.source = vehicleOrdersResult.dataList;
        } else {
          $scope.vehicleOrdersSettings.source = vehicleOrdersResult.dataList;
        }
      }
      return vehicleOrdersResult.dataList;
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isOrderAvailable = false;
      }
    }).finally(function () {
      $scope.createVehicleOrdersListGrid = true;
      updateVehicleOrdersList();
    });
  };
  $scope._initLastLocationTab = function () {
    commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));
    //$scope.ctxMenuSettings.source = _contextSourceObj.lastLocCtxSource;

    $rootScope.$broadcast('tabEvent', {
      'tabName': 'lastLocation',
      dashboardName: 'dashboard.vehicleList',
      isDataFromTab: true,
      tabNumber: 0,
      deviceId: _lastSelctedDeviceId
    });

    broadcastEventData.lastTabName = 'lastLocation';
    $scope.previousTab = $scope.activeTab;

    if (!$scope.isStopedByUser) {
      $scope.stop();
      $scope.stopAutoRefresh(null, 'start');
    }
  };

  $scope._initOrderTab = function () {
    commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));

    // $scope.ctxMenuSettings.source = _contextSourceObj.ordersCtxSource;
    $scope.stopAutoRefresh(null, 'stop');
    var timeFormat = {};
    var lastTabBasedTime = {};
    //---------------------------------------------------------------------------------------------------------------------------------------
    // Following code should be improved in a seprate bug , with a more detialed test case
    // The use case is the following
    // 1. when you clcik orders tab form the main TAB (0) , use the selected row information from the TAB(0)
    // 2. when you ckick orders tab from the vehicleDetails TAB(2) , use the selected row information from the TAB(2)
    //----------------------------------------------------------------------------------------------------------------------------------------
    // 2. when you ckick orders tab from the vehicleDetails TAB(2) , use the selected row information from the TAB(2)
    if (broadcastEventData.lastTabName === 'vehicleDetails') {
      if (broadcastEventData.selectedOrderRow) {
        timeFormat._tmpStartDate = $filter('date')($scope.vehicleOrders.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        timeFormat._tmpEndDate = $filter('date')($scope.vehicleOrders.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
      } else {

        timeFormat._tmpStartDate = $filter('date')($scope.vehicleDetail.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        timeFormat._tmpEndDate = $filter('date')($scope.vehicleDetail.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

        $scope.vehicleOrders = {
          date: {
            startDate: timeFormat._tmpStartDate._isAMomentObject ? timeFormat._tmpStartDate.format('YYYY/MM/DD HH:mm:ss') : new Date(timeFormat._tmpStartDate.replaceAt(10, ' ')),
            endDate: timeFormat._tmpEndDate._isAMomentObject ? timeFormat._tmpEndDate.format('YYYY/MM/DD HH:mm:ss') : new Date(timeFormat._tmpEndDate.replaceAt(10, ' '))
          }
        };
      }
    } else {
      // 1. when you clcik orders tab form the main TAB (0) , use the selected row information from the TAB(0)
      timeFormat = _initRequestData('vehicleOrders');
      window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('clearselection');
    }

    //---------------------------------------------------------------------------------------------------------------------------------------

    broadcastEventData.lastTabName = 'orders';
    if (timeFormat) {
      loadVehicleOrdersList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleOrders.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate).then(function (orderList) {
        $timeout(function () {
          if (orderList && orderList.length > 0) {
            //default select the first one
            var rowIndex = _getCurrentRowIndex('vehicleOrdersList', orderList.length);
            if (rowIndex) {
              var rowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('getrowdata', rowIndex);
              if (rowData) {
                lastTabBasedTime._tmpStartDate = commonTrackService.formatReportDateTime(rowData.workorderstartdate, rowData.workorderstarttime, false);
                lastTabBasedTime._tmpEndDate = commonTrackService.formatReportDateTime(rowData.workorderenddate, rowData.workorderendtime, false);
                broadcastEventData.selectedOrderRow = rowData;
                if ($scope.activeTab === TAB_ORDERS) {
                  $rootScope.$broadcast('tabEvent', {
                    'tabName': 'vehicleOrders',
                    'repoVehicle': rowData.deviceid,
                    'startDate': lastTabBasedTime._tmpStartDate ? lastTabBasedTime._tmpStartDate : timeFormat._tmpStartDate,
                    'endDate': lastTabBasedTime._tmpEndDate ? lastTabBasedTime._tmpEndDate : timeFormat._tmpEndDate,
                    dashboardName: 'dashboard.vehicleList',
                    isDataFromTab: true,
                    tabNumber: 0 // check why this 0 ,
                  });
                }
              }
            }
          } else {
            //no record in the grid.
            if ($scope.activeTab === TAB_ORDERS) {
              $rootScope.$broadcast('tabEvent', {
                'tabName': 'vehicleOrders',
                'repoVehicle': null,
                'startDate': null,
                'endDate': null,
                dashboardName: 'dashboard.vehicleList',
                isDataFromTab: true,
                tabNumber: TAB_ORDERS
              });
            }
          }
        }, 0);
      });
    }
    $scope.previousTab = $scope.activeTab;
  };

  function _getCurrentRowIndex(gridName, dataLenght) {
    var rowindex = window.$('#' + $scope.overviewGridPrefix + gridName).jqxGrid('getselectedrowindex');
    if (rowindex > dataLenght - 1 || rowindex <= 0) {
      rowindex = 0;
      window.$('#' + $scope.overviewGridPrefix + gridName).jqxGrid('selectrow', rowindex);
      return null;
    }
    return rowindex;
  }

  $scope._initVehicleDetailTab = function () {
    commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, 'EventDetail'));

    $scope.stopAutoRefresh(null, 'stop');
    var timeFormat = _intiVehicleDetailRequestData('vehicleDetail');
    if (timeFormat) {
      if ($scope.previousTab === 0 || $scope.previousTab === 1 && !broadcastEventData.selectedOrderRow) {
        // if last tab =1 OR condition is for  order tab with empty list

        var tmpFromDate = moment(timeFormat._tmpEndDate, 'YYYY/MM/DD/HH:mm:ss');
        tmpFromDate.subtract({ hours: 2 });
        timeFormat._tmpStartDate = tmpFromDate.format('YYYY/MM/DD/HH:mm:ss');
        $scope.vehicleDetail.date.startDate = timeFormat._tmpStartDate;
      }
      loadVehicleEventDetailList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleEventDetails.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate);
    }
    $scope.previousTab = $scope.activeTab;
  };

  $scope._initCargoQualityTabTab = function () {
    commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, 'EventDetailCargoQuality'));

    $scope.stopAutoRefresh(null, 'stop');
    var timeFormat = _initRequestData('cargoQualityDetail');
    if (timeFormat) {
      if ($scope.previousTab === 0 || $scope.previousTab === 1 && !broadcastEventData.selectedOrderRow) {
        // if last tab =1 OR condition is for  order tab with empty list
        var tmpFromDate = moment(timeFormat._tmpEndDate, 'YYYY/MM/DD/HH:mm:ss');
        tmpFromDate.subtract({ hours: 2 });
        timeFormat._tmpStartDate = tmpFromDate.format('YYYY/MM/DD/HH:mm:ss');
        $scope.cargoQualityDetail.date.startDate = timeFormat._tmpStartDate;
      }
      loadCragoQualityList(_tmpConfig.deviceId, $scope.customGridProperties.cargoQualityDetail.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate);
    }
    $scope.previousTab = $scope.activeTab;
  };

  var loadCragoQualityList = function loadCragoQualityList(deviceId, dataRefresh, startDate, endDate) {
    return vehicleListWidgetService.getCargoQualityList(deviceId, dataRefresh, startDate, endDate).then(function (cargoQualityList) {
      if (cargoQualityList.dataList) {
        if (dataRefresh) {
          $scope.customGridProperties.cargoQualityDetail.columns = commonTrackService.getColumnProperties(cargoQualityList.gridSettings.overviewListGrids[0].columnProperties, cargoQualityList.columnTranslation, { moduleName: 'cargoQualityDetail' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.cargoQualityTab.cargoQuality') };
          $scope.cargoQualityGridSettings = commonTrackService.getGridSettings('cargoQualityDetail', $scope.customGridProperties.cargoQualityDetail, null, _additionalProperties);
          $scope.cargoQualityGridSettings.source = cargoQualityList.dataList;
        } else {
          $scope.cargoQualityGridSettings.source = cargoQualityList.dataList;
        }
        $timeout(function () {
          var rowindex = _getCurrentRowIndex('cargoQualityDetailList', cargoQualityList.dataList.length);
          if (rowindex) {
            window.$('#' + $scope.overviewGridPrefix + 'cargoQualityDetailList').jqxGrid('selectrow', rowindex);
          }
        }, 3000);
        if ($scope.activeTab === TAB_CARGO_QUALITY) {
          $rootScope.$broadcast('tabEvent', {
            'tabName': 'cargoQuality',
            'repoVehicle': deviceId,
            'startDate': startDate,
            'endDate': endDate,
            dashboardName: 'dashboard.vehicleList',
            isDataFromTab: true,
            tabNumber: TAB_CARGO_QUALITY
          });
        }
      }
    }).finally(function () {

      $scope.createCargoQualityGrid = true;
    });
  };

  var jobEvent = $scope.$on('job-event', function (event, data) {
    var _eventDateTime = new Date(data.eventTimeStamp * 1000);
    var _gridRefreshDateTime = new Date(_lastRefreshTimeS * 1000);
    // console.log('data.eventTimeStamp - ' + _eventDateTime);
    // console.log('grid refresh time - ' + _gridRefreshDateTime);
    // console.log(_eventDateTime > _gridRefreshDateTime);

    if (_eventDateTime > _gridRefreshDateTime) {
      var _tmpGridsource = vehicleListSource.localdata;
      for (var i = 0; i < _tmpGridsource.length; i++) {
        if (_tmpGridsource[i].deviceid === data.dev) {
          _tmpGridsource[i].statusdesc = data.statusdescription;
          _tmpGridsource[i].statusdescColor = data.statusdescFgColor;
          _tmpGridsource[i].statusdescBgColor = data.statusdescBgColor;
          _tmpGridsource[i].lastjobstatusdesc = data.statusdescription;
          _tmpGridsource[i].lastjobstatusdescColor = data.statusdescFgColor;
          _tmpGridsource[i].lastjobstatusdescBgColor = data.statusdescBgColor;
          _tmpGridsource[i].driverdesc = data.driverdesc !== null ? data.driverdesc : '';
          _tmpGridsource[i].date = $filter('date')(_eventDateTime, 'dd/MM/yyyy');
          _tmpGridsource[i].time = $filter('date')(_eventDateTime, 'HH:mm:ss');
          $scope.vehicleLastLocGridSettings.source = _tmpGridsource;
          window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('updatebounddata', 'data');
          break;
        }
      }
    }
  });

  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    var tab = $scope.activeTab === TAB_CARGO_QUALITY ? 'EventDetailCargoQuality' : $scope.activeTab === TAB_VEHICLE_DETAILS ? 'EventDetail' : undefined;
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, tab));
  });

  $scope.moreFunctionsOnChange = function (event) {
    if (event.args.item.value === 'showReport') {
      var _objNameParam = event.args.item.originalItem.execute.split('-');
      _commonFunction[_objNameParam[0]](_objNameParam[1]);
    } else {
      if (event.args.item.originalItem.execute) {
        _commonFunction[event.args.item.originalItem.execute]();
      }
    }
    window.$('#moreFunDropDown').jqxDropDownList('clearSelection');
  };

  $scope.stopAutoRefresh = function (event, type) {
    if (event) {
      commonTrackService.getRefreshStartStopfunction($scope, true, true, loadVechileList, 'vehicleGroupComboBox', false, true, event)();
    } else {
      if (type === 'start') {
        $scope.isTimerStated = false;
      } else {
        $scope.isTimerStated = true;
      }
      commonTrackService.getRefreshStartStopfunction($scope, true, true, loadVechileList, 'vehicleGroupComboBox', false, true)();
    }
  };

  var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
    $rootScope.$broadcast('vehicleMap_res_current_context', {
      dashboardName: 'dashboard.vehicleList',
      isDataFromTab: true,
      tabNumber: $scope.activeTab,
      currentWidgetContextData: broadcastEventData,
      dataLoadingFinished: $scope.dataLoadingFinished,
      isDataAvailable: $scope.isDataAvailable
    });
  });

  var currentSelectedGroupEvent = $scope.$on('fleetMap_req_current_context', function () {
    $rootScope.$broadcast('fleetMap_res_current_context', {
      dashboardName: 'dashboard.vehicleList',
      vehicleGroup: $scope.vehicleGroup
    });
  });

  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  // Google maps takes focus if the auto refresh enabled
  // Auto refresh must be stoped if the chat window is open to solve focus switching
  var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
    // stop the auto refresh only if an existing timer is detected under the last location tab
    // bug 105133
    if ($scope.isTimerStated && $scope.activeTab === TAB_VEHICLE_LIST) {
      // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
      $scope.stopAutoRefresh(null, 'stop');
    }
  });
  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  //  restart the auto refresh is the chat window is closed
  var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
    if (!$scope.isTimerStated && $scope.activeTab === TAB_VEHICLE_LIST) {
      // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
      $scope.stopAutoRefresh(null, 'start');
    }
  });

  $scope.$on('$destroy', function () {
    $scope.stop();
    jobEvent();
    updateDateRangeInternalDateEvent();
    currentSelectedRowReqEvent();
    destroyLastLocationCtxMenu();
    destroyVehicleOrdersCtxMenu();
    updateRequest();
    if (chatWindowOpenEvent) {
      chatWindowOpenEvent();
    }
    if (chatWindowCloseEvent) {
      chatWindowCloseEvent();
    }
    if ($scope.vehicleLastLocGridSettings && $scope.vehicleLastLocGridSettings.source) {
      delete $scope.vehicleLastLocGridSettings.source;
    }
    if ($scope.vehicleOrdersSettings && $scope.vehicleOrdersSettings.source) {
      delete $scope.vehicleOrdersSettings.source;
    }
    if ($scope.vehicleDetailsGridSettings && $scope.vehicleDetailsGridSettings.source) {
      delete $scope.vehicleDetailsGridSettings.source;
    }
    if ($scope.cargoQualityGridSettings && $scope.cargoQualityGridSettings.source) {
      delete $scope.cargoQualityGridSettings.source;
    }
    delete $scope.vehicleListdataAdapter;
    currentSelectedGroupEvent();
  });

  $scope.$on('$locationChangeStart', function () {
    destroyLastLocationCtxMenu();
    destroyVehicleOrdersCtxMenu();
  });

  function destroyLastLocationCtxMenu() {
    $('#' + $scope.uuidForElement + '_betoTrack_vehicleLastLocationCtx').unbind('itemclick', lastLocationContextHandler);
    $('#' + $scope.uuidForElement + '_betoTrack_vehicleLastLocationCtx').jqxMenu('destroy');
  }

  function destroyVehicleOrdersCtxMenu() {
    $('#' + $scope.uuidForElement + '_betoTrack_vehicleOrdersCtx').unbind('itemclick', lastLocationContextHandler);
    $('#' + $scope.uuidForElement + '_betoTrack_vehicleOrdersCtx').jqxMenu('destroy');
  }
}]).controller('vehicleListEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {
  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '25', '50', '75', '100'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,

    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicle/vehicleListWidget.tpl.html', '<div class="row"><div ng-if="!dataLoadingFinished"><loading-animation></loading-animation></div><div class="col-xs-12 col-sm-12 col-md-12"><uib-tabset style="" active="activeTab" class="track-tab-dsa"><uib-tab ng-click="_initLastLocationTab()" id="lastLocationTab" index="0"><uib-tab-heading translate="dashBoard.fleetManagement.vehicleList.lastLocation"></uib-tab-heading><div class="row" style="margin-top: 5px;"><div class="vehicle-list-widget-ctrl" style="padding:2px;"><div class="col-md-5 col-sm-12 col-xs-12"><div jqx-delete-directive="vehicleGroupComboBox" type="comboBox"><jqx-combo-box id="vehicleGroupComboBox" jqx-settings="vehicleGroupSettings" class="jqx-combo-box-dsa required" jqx-create="dataLoadingFinished" jqx-on-change="vehicleGroupComboChange(event)" ng-model="vehicleGroup" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-5 col-sm-12 col-xs-12"><div jqx-delete-directive="moreFunDropDown" type="dropDownList"><jqx-drop-down-list id="moreFunDropDown" ng-model="selectedFunction" jqx-ng-model="" jqx-settings="moreFuctionSetting" jqx-on-change="moreFunctionsOnChange(event)" jqx-create="createVehicleListGrid" ignore-dirty=""></jqx-drop-down-list></div></div><div id="refreshBtn" class="col-md-2 col-sm-12 col-xs-12" ng-if="timerDesc"><button ng-click="stopAutoRefresh($event)" type="button" style="" id="autoRefreshButton" class="btn btn-default"><span class="badge" ng-show="isTimerStated">{{counter}}</span><i ng-show="!isTimerStated" class="fa fa-play" aria-hidden="true"></i></button></div></div></div><div class="row" style="padding-top: 5px;" ng-show="isDataAvailable"><div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 2.5px;"><div contextmenu=""><div jqx-delete-directive="{{overviewGridPrefix}}vehicleLastLocationList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}vehicleLastLocationList" jqx-settings="vehicleLastLocGridSettings" jqx-on-rowselect="vehicleLastLocRowSelectHandler(event)" jqx-on-rowclick="gridRowClickHandler(event, \'lastLocation\')" jqx-create="createVehicleListGrid" class="custom-header"></jqx-grid></div><div id="{{uuidForElement}}_betoTrack_vehicleLastLocationCtx"></div></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></uib-tab><uib-tab disable="vehicleOrdersTab.disable" ng-click="_initOrderTab()" id="ordersTab" index="1"><uib-tab-heading translate="dashBoard.fleetManagement.vehicleList.ordersTab.orders"></uib-tab-heading><div ng-show="isOrderAvailable"><div class="row" style="margin-top: 5px;"><div class="col-md-5 col-sm-10 col-xs-10" style="margin-bottom: 2.5px;padding-left:18px;"><div ng-show="!vehicleOrdersTab.disable"><input date-range-picker="" id="ordersDateRange" class="form-control date-picker" type="text" ng-model="vehicleOrders.date" clearable="true" options="options" required=""></div></div></div><div class="row" style="padding-top: 5px;"><div class="col-md-12 col-sm-12 col-xs-12" style=""><div contextmenu=""><div jqx-delete-directive="{{overviewGridPrefix}}vehicleOrdersList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}vehicleOrdersList" jqx-settings="vehicleOrdersSettings" jqx-create="createVehicleOrdersListGrid" jqx-on-rowselect="vehicleOrdersRowSelectHandler(event)" jqx-on-rowclick="gridRowClickHandler(event, \'orders\')" class="custom-header"></jqx-grid></div><div id="{{uuidForElement}}_betoTrack_vehicleOrdersCtx"></div></div></div></div></div><div ng-show="!isOrderAvailable"><no-authorize></no-authorize></div></uib-tab><uib-tab disable="vehicleDetailTab.disable" ng-click="_initVehicleDetailTab()" id="vehicleDetailsTab" index="2"><uib-tab-heading translate="dashBoard.fleetManagement.vehicleList.vehicleDetailsTab.vehicleDetails"></uib-tab-heading><div class="row" style="margin-top: 5px;"><div class="col-md-5 col-sm-10 col-xs-10" style="margin-bottom: 2.5px;padding-left:18px;"><div ng-show="!vehicleDetailTab.disable"><input date-range-picker="" id="daterange4" name="daterange4" class="form-control date-picker" type="text" ng-model="vehicleDetail.date" clearable="true" options="options" required=""></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12" style=""><div ng-show="isDetialAvailable"><div jqx-delete-directive="{{overviewGridPrefix}}vehicleEventDetailsList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}vehicleEventDetailsList" jqx-settings="vehicleDetailsGridSettings" jqx-on-rowselect="rowSelectHandler(event)" jqx-create="createVehicleDetilListGrid" class="custom-header"></jqx-grid></div></div><div ng-show="!isDetialAvailable"><no-authorize></no-authorize></div></div></div></uib-tab><uib-tab disable="cargoQualityTab.disable" ng-click="_initCargoQualityTabTab()" id="cargoQualityTab" index="3" ng-hide="true"><uib-tab-heading translate="dashBoard.fleetManagement.vehicleList.cargoQualityTab.cargoQuality"></uib-tab-heading><div class="row" style="margin-top: 5px;"><div class="col-md-5 col-sm-10 col-xs-10" style="margin-bottom: 2.5px;padding-left:18px;"><div ng-show="!cargoQualityTab.disable"><input date-range-picker="" id="cargoquality-daterange" name="cargoqualityDaterange" class="form-control date-picker" type="text" ng-model="cargoQualityDetail.date" clearable="true" options="options" required=""></div></div></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12" style=""><div jqx-delete-directive="{{overviewGridPrefix}}cargoQualityDetailList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}cargoQualityDetailList" jqx-settings="cargoQualityGridSettings" jqx-on-rowselect="rowSelectHandler(event)" jqx-create="createCargoQualityGrid" class="custom-header"></jqx-grid></div></div></div></uib-tab></uib-tabset></div></div>');
  }]);
})();

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicleDetails/vehicleDetailEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 4/28/2015.
 */



angular.module('dashboard.vehicleDetails', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('vehicleDetailsWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.vehicleDetails.description';
      }
    },
    controller: 'vehicleDetailCtrl',
    templateUrl: 'components/dashboard/vehicleDetails/vehicleDetailWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      selectedRowDetails: {
        deviceId: null,
        startDate: null,
        endDate: null
      },
      noOfGridRows: 10
    },
    edit: {
      templateUrl: 'components/dashboard/vehicleDetails/vehicleDetailEdit.tpl.html',
      reload: false,
      controller: 'vehicleDetailEditCtrl'
    }
  });
}]).service('vehicleDetailWidgetService', ["crudService", function (crudService) {
  this.getVehicleEvntDetailList = function (deviceId, isDataRefresh, startDate, endDate) {
    var requestParam = {
      statusCode: '',
      vehicleGroup: '',
      dataRefresh: isDataRefresh,
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'EventDetailAll'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('overview', 'vehicleeventdetailall/' + deviceId, param);
  };

  this.getVehicleEvntDetailViewSettingsList = function (deviceId, isDataRefresh, startDate, endDate) {
    var requestParam = {
      statusCode: '',
      vehicleGroup: '',
      dataRefresh: isDataRefresh,
      timeTo: endDate,
      timeFrom: startDate,
      reportName: 'EventDetailAll'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('viewsettings/dataset', 'eventdetailall', param);
  };
}]).controller('vehicleDetailCtrl', ["$scope", "$rootScope", "vehicleDetailWidgetService", "config", "localStorageService", "commonTrackService", "$translate", "$filter", "errorHandlingService", "vehicleListWidgetService", "stateManagerService", "$timeout", "AuthenticationService", function ($scope, $rootScope, vehicleDetailWidgetService, config, localStorageService, commonTrackService, $translate, $filter, errorHandlingService, vehicleListWidgetService, stateManagerService, $timeout, AuthenticationService) {
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.dataLoadingFinished = false;

  $scope.isNotAuthorized = false;
  $scope.isDataNotAvailable = false;
  $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
  $scope.isWidgetPostInitFinished = false;

  var rowSize = vehicleListWidgetService.getRowSize();
  var allData;

  // Test bug
  // Required params
  $scope.dataSet = {
    deviceID: null,
    startDate: null,
    endDate: null,
    refresh: null,
    lastUpdateRequest: 0
  };

  var _tmpColumnProperties = [{
    name: 'name', width: '50%',
    hasIcon: true,
    type: 'string'
  }, {
    name: 'value', width: '50%',
    type: 'string'
  }];

  $scope.customGridProperties = {
    settings: {
      vehicleDetails: {
        autoheight: false,
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] - 15 : 455,
        pageable: false,
        pagesize: null,
        showfilterrow: true,
        filterable: true,
        columns: []
      },
      customcolumnproperties: []
    }
  };
  var columnProperties = commonTrackService.getColumnProperties(_tmpColumnProperties, {
    name: $translate.instant('dashBoard.fleetManagement.vehicleDetails.name'),
    value: $translate.instant('dashBoard.fleetManagement.vehicleDetails.value')
  }, { moduleName: 'vehicleDetailsWidget' });

  var vehicleDetailsListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    unfiltereddata: []
  };

  $scope.customGridProperties.settings.vehicleDetails.columns = columnProperties;
  var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle') };
  $scope.vehicleDetialsWidgGridSettings = commonTrackService.getGridSettings('vehicleDetailsWidget', $scope.customGridProperties.settings.vehicleDetails, null, _additionalProperties);
  $scope.vehicleDetailListdataAdapter = new window.$.jqx.dataAdapter(vehicleDetailsListSource);
  $scope.vehicleDetialsWidgGridSettings.source = $scope.vehicleDetailListdataAdapter;

  $scope.updateFilter = function (buttonID) {
    var checkedItems = [];
    var selectedButtons = [];

    if (localStorageService.get('selectedEventDetailsButtons') !== null) {
      selectedButtons = localStorageService.get('selectedEventDetailsButtons');
    }

    //restore filters that were previously saved to local storage
    //done on refresh etc
    for (var x = selectedButtons.length - 1; x >= 0; x--) {
      if (getDataSetListItem(selectedButtons[x]) === undefined) {
        //remove this invalid selected button from list of selected buttons
        selectedButtons.splice(x, 1);
        continue;
      }

      var arrayOfDataSetTagsForLocalStorage = getAllRowsMatchingDataSetTags(selectedButtons[x]);
      checkedItems.push.apply(checkedItems, arrayOfDataSetTagsForLocalStorage);
    }

    if (buttonID !== undefined) {
      //manage filters for when a button is clicked
      var arrayOfDataSetTagsForbuttonID = getAllRowsMatchingDataSetTags(buttonID);

      if (selectedButtons.includes(buttonID)) {
        //Remove the button items
        var index = selectedButtons.indexOf(buttonID);
        selectedButtons.splice(index, 1);

        for (var y = 0; y < arrayOfDataSetTagsForbuttonID.length; y++) {
          var indexOfItemToRemove = checkedItems.lastIndexOf(arrayOfDataSetTagsForbuttonID[y]);
          if (index > -1) {
            checkedItems.splice(indexOfItemToRemove, 1);
          }
        }
      } else {
        //Add the button items
        selectedButtons.push(buttonID);
        checkedItems.push.apply(checkedItems, arrayOfDataSetTagsForbuttonID);
      }
    }
    localStorageService.set('selectedEventDetailsButtons', selectedButtons);

    filterFunction(checkedItems);
  };

  var getDataSetListItem = function getDataSetListItem(itemID) {
    var dataSetListItem = allData.dataSetList.find(function (item) {
      return item.id === itemID;
    });
    return dataSetListItem;
  };

  var getAllRowsMatchingDataSetTags = function getAllRowsMatchingDataSetTags(itemID) {
    var arrayOfDataSetTagsColumns = [];
    var dataSetListItem = getDataSetListItem(itemID);
    if (dataSetListItem !== undefined) {
      for (var x = 0; x < dataSetListItem.tags.length; x++) {
        //get the filter columns
        var tagsName = dataSetListItem.tags[x].name.toLowerCase();
        var checkedItem = $scope.customGridProperties.settings.columnTranslation[tagsName];
        if (checkedItem !== undefined && checkedItem !== '') {
          arrayOfDataSetTagsColumns.push(checkedItem.replace(/\\n/gm, ' - '));
        }
      }
    }
    return arrayOfDataSetTagsColumns;
  };

  var getAllDataSetTagsObjects = function getAllDataSetTagsObjects() {
    var allTagsObjects = [];
    for (var a = 0; a < allData.dataSetList.length; a++) {
      var allDataSetListItem = allData.dataSetList[a];
      for (var b = 0; b < allDataSetListItem.tags.length; b++) {
        var tagsItem = allDataSetListItem.tags[b];
        if (tagsItem.iconRulesRef !== undefined && tagsItem.iconRulesRef !== '') {
          // this is a tags item with icon
          allTagsObjects.push(tagsItem);
        }
      }
    }
    return allTagsObjects;
  };

  var loadVehicleEventDetail = function loadVehicleEventDetail(deviceId, dataRefresh, startDate, endDate) {

    $scope.isNotAuthorized = false; // Reset if its already set to true so that if permissions enabled on fly 'UI no autorized message will be removed'
    $scope.isDataNotAvailable = false;

    vehicleDetailWidgetService.getVehicleEvntDetailViewSettingsList(deviceId, dataRefresh, startDate, endDate).then(function (viewSettingsData) {
      allData = viewSettingsData;

      return vehicleDetailWidgetService.getVehicleEvntDetailList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleEvntDetail) {
        var allTagsObjects = getAllDataSetTagsObjects();

        var _tmpDetail = [];
        if ($scope.customGridProperties.settings.customcolumnproperties.length === 0) {
          $scope.customGridProperties.settings.customcolumnproperties = vehicleEvntDetail.gridSettings.overviewListGrids[0].columnProperties;
          $scope.customGridProperties.settings.columnTranslation = vehicleEvntDetail.columnTranslation;
        }
        var findColumnPropertiesItem = function findColumnPropertiesItem(item) {
          return item.name.toLowerCase() === columnPropertiesItem.name;
        };
        for (var i = 0; i < $scope.customGridProperties.settings.customcolumnproperties.length; i++) {
          var columnPropertiesItem = $scope.customGridProperties.settings.customcolumnproperties[i];
          var tagsObject = allTagsObjects.find(findColumnPropertiesItem);

          if (vehicleEvntDetail.dataList.length === 1) {
            var name = $scope.customGridProperties.settings.customcolumnproperties[i].name;
            var type = $scope.customGridProperties.settings.customcolumnproperties[i].type;
            var value = vehicleEvntDetail.dataList[0][name] ? vehicleEvntDetail.dataList[0][name] : null;
            if (typeof vehicleEvntDetail.dataList[0][name] === 'number' && type !== 'TIMESTAMP') {
              if (value) {
                if (value._isInt(value)) {
                  /*if (name.indexOf('timestamp') > -1) {
                   value = $filter('date')(new Date(value), 'dd/MM/yyyy HH:mm:ss');
                   } else {
                   value = String(value);
                   }*/
                  value = String(value);
                } else {
                  if (value._isFloat(value)) {
                    value = String(value.toFixed(4));
                  }
                }
              }
            }
            if (type === 'TIMESTAMP' && value) {
              value = $filter('date')(new Date(value * 1000), 'dd/MM/yyyy HH:mm:ss');
            }
            //add column icons using icon rules
            var nameIcon = evaluateIconRule(columnPropertiesItem, value, tagsObject, nameIcon);
            if ($scope.customGridProperties.settings.columnTranslation[name]) {
              var _detailObjFormat = {
                name: $scope.customGridProperties.settings.columnTranslation[name].replace(/\\n/gm, ' - '),
                value: value,
                nameIcon: nameIcon,
                nameIconDisplayType: 'COMBINATION'
              };
              _tmpDetail.push(_detailObjFormat);
            }
          }
        }

        vehicleDetailsListSource.localdata = _tmpDetail;
        vehicleDetailsListSource.unfiltereddata = _tmpDetail;
        $scope.isDataNotAvailable = _tmpDetail.length > 0 ? false : true;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehicleDetailsWidgetList');

        //add all nessisary buttons to screen
        var buttonsArray = [];
        var selectedButtons = [];
        if (localStorageService.get('selectedEventDetailsButtons') !== null) {
          selectedButtons = localStorageService.get('selectedEventDetailsButtons');
        }
        for (var x = 0; x < allData.dataSetList.length; x++) {
          var buttonName = allData.dataSetList[x].name;
          var buttonID = allData.dataSetList[x].id;
          var isStoredLocally = selectedButtons.includes(buttonID) ? 'active' : '';
          buttonsArray.push({ _buttonName: buttonName, _buttonID: buttonID, _isActive: isStoredLocally });
        }
        $scope.buttonsArray = buttonsArray;
      }, function (response) {
        $scope.isDataNotAvailable = true;
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isNotAuthorized = true;
        }
      }).finally(function () {
        $scope.dataLoadingFinished = true;
        $scope.updateFilter();
      });
    }, function (response) {
      $scope.isDataNotAvailable = true;
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isNotAuthorized = true;
      }
    });
  };

  var filterFunction = function filterFunction(checkedItems) {
    //Update the grid data with the filtered items
    $timeout(function () {
      var filteredItems = [];
      var findCheckedItemFunction = function findCheckedItemFunction(item) {
        return item.name === checkedItems[i];
      };
      for (var i = 0; i < checkedItems.length; i++) {
        // add checked values to the filter
        var filteredItem = vehicleDetailsListSource.unfiltereddata.find(findCheckedItemFunction);
        if (filteredItem !== undefined && !filteredItems.includes(filteredItem)) {
          filteredItems.push(filteredItem);
        }
      }
      // add the filters.
      if (filteredItems.length === 0) {
        vehicleDetailsListSource.localdata = vehicleDetailsListSource.unfiltereddata;
      } else {
        vehicleDetailsListSource.localdata = filteredItems;
      }
      commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehicleDetailsWidgetList');
    }, 0);
  };

  var evaluateIconRule = function evaluateIconRule(columnPropertiesItem, value, tagsObject) {
    var nameIcon = 'NONE';
    if (tagsObject !== undefined) {
      //this column contains an icon
      columnPropertiesItem.hasIcon = true;
      //calculate which icon should be displayed
      var iconRule = allData.iconRules.find(function (item) {
        return item.name === tagsObject.iconRulesRef;
      });
      if (iconRule !== undefined) {
        if (iconRule.enumValue !== undefined) {
          //icon rule is of type enum
          //evaluate enum
          var enumValue = iconRule.enumValue;
          var enumIcon = iconRule.enumIcon;

          for (var x = 0; x < enumValue.length; x++) {
            if (enumValue[x] === value) {
              nameIcon = enumIcon[x];
            }
          }
        } else if (iconRule.conditions !== undefined) {
          //icon rule is of type conditions
          //evaluate conditions
          for (var y = 0; y < iconRule.conditions.length; y++) {
            var operator = iconRule.conditions[y].operator;

            var icon = iconRule.conditions[y].icon;
            var comparatorNumber = parseFloat(value);

            if (isNaN(comparatorNumber)) {
              var thresholdString = iconRule.conditions[y].threshold;
              switch (operator) {
                case 'equals':
                  if (value === thresholdString) {
                    nameIcon = icon;
                  }
                  break;
              }
            } else {
              var thresholdNumber = parseFloat(iconRule.conditions[y].threshold);
              switch (operator) {
                case 'equals':
                  if (comparatorNumber === thresholdNumber) {
                    nameIcon = icon;
                  }
                  break;
                case 'lower_than':
                  if (comparatorNumber < thresholdNumber) {
                    nameIcon = icon;
                  }
                  break;
                case 'lower_or_equal':
                  if (comparatorNumber <= thresholdNumber) {
                    nameIcon = icon;
                  }
                  break;
                case 'greater_or_equal':
                  if (comparatorNumber >= thresholdNumber) {
                    nameIcon = icon;
                  }
                  break;
                case 'greater_than':
                  if (comparatorNumber > thresholdNumber) {
                    nameIcon = icon;
                  }
                  break;
              }
            }
          }
        }
      }
    }
    return nameIcon;
  };

  // Test bug
  $scope.$on('dataStateUpdate', function (event, data) {
    if ($scope.isWidgetPostInitFinished) {
      var set = getSetData(data.widget);
      _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value);
    } else {
      console.log('Ignoring dataState update from widget: ' + data.widget);
    }
  });

  var maxGetInitialDataRetries = 30;
  var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
    if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
      currentParentRowResEvent();
      return;
    }
    //console.info('VehcielDetail Widget Requesting Parent for Data ..');
    --maxGetInitialDataRetries;
    var set = getSetData(data.widget);
    var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];

    // parents First tab must always retrun a  valid selected row
    if (data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value) || data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues)) {
      $scope.isWidgetPreInitFinished = true;
      $scope.isWidgetPostInitFinished = true;
      _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value);
    } else {
      // Repeatedly try to get the data from parent .
      if (maxGetInitialDataRetries > 0) {
        $timeout(function () {
          if (!$scope.isWidgetPostInitFinished) {
            $rootScope.$broadcast('reqDataUpdate');
          }
        }, 100);
      } else {
        console.warn('Max Retries exceeded to get the current Parent data for VehcielDetail widget..');
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;
        $scope.isDataNotAvailable = true;
        currentParentRowResEvent();
      }
    }
  });

  $scope.$on('$destroy', function () {
    delete $scope.vehicleDetailListdataAdapter;
    delete $scope.vehicleDetialsWidgGridSettings.source;
    currentParentRowResEvent();
  });

  var getSetData = function getSetData(widget) {
    var loginID = AuthenticationService.GetLoginID();
    widget = loginID.Account + '_' + loginID.username + '_' + widget;
    var stateData = stateManagerService.getStateData();
    var set = stateData && stateData[widget] ? stateData[widget] : {};
    return set;
  };

  this.init = function () {
    $timeout(function () {
      $scope.dataSet.lastUpdateRequest = new Date().getTime();
      $rootScope.$broadcast('reqDataUpdate');
    }, 0);
  };

  function _handleDataUpdate(dashboardName, tabNumber, rowData) {
    var reportDatetime, set;

    switch (dashboardName) {
      case 'dashboard.vehicleList':
      case 'dashboard.driverWrkHrsDashboard': // contains only 0 tab
      case 'dashboard.tachohistory':
        // contains only 0 tab

        switch (tabNumber) {
          case 1:
            set = getSetData('vehicleListWidget'); // hard coded  values since other dashboard does not contain tab 1
            if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
              rowData = set['tab_' + 0 + '_selectedRow'].value;
              reportDatetime = commonTrackService.formatReportDateTime(rowData.date, rowData.time);
              loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
            }
            break;
          case 0:
          case 2:
          case 3:
            reportDatetime = commonTrackService.formatReportDateTime(rowData.date, rowData.time);
            loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
            break;
        }
        break;
      case 'dashboard.fmsDashboard':

        switch (tabNumber) {
          case 0:
          case 1:
            reportDatetime = commonTrackService.formatReportDateTime(rowData.date, rowData.time);
            loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
            break;
          case 2:
            set = getSetData('fmsVehicleWidget');
            if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
              rowData = set['tab_' + 0 + '_selectedRow'].value;
              var tellTaletimestamp = rowData.telltaletimestamp;
              var hastellTale = tellTaletimestamp > 0;
              if (hastellTale) {
                var tellTaledate = (hastellTale ? moment.unix($scope.telltaleData.timestamp) : moment(0)).format('YYYY/MM/DD/HH:mm:ss');

                loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, tellTaledate, tellTaledate);
              } else {
                $scope.isDataNotAvailable = true;
              }
            }
            break;

        }
        break;
      case 'dashboard.tachoDownloadStatusList':
        set = getSetData('tachoDownloadStatusWidget'); // hard coded  values since other dashboard does not contain tab 1
        if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
          rowData = set['tab_' + 0 + '_selectedRow'].value;
          if (rowData.tacholasteventtimestamp && rowData.tacholasteventtimestamp !== '') {
            reportDatetime = moment(rowData.tacholasteventtimestamp * 1000).format('YYYY/MM/DD/HH:mm:ss');
            loadVehicleEventDetail(rowData.deviceid, $scope.customGridProperties.settings.customcolumnproperties.length > 0 ? false : true, reportDatetime, reportDatetime);
          } else {
            $scope.isDataNotAvailable = true;
          }
        }
        break;

    }
  }
  this.init();
}]).controller('vehicleDetailEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {
  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '25'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicleDetails/vehicleDetailWidget.tpl.html', '<div class=""><loading-animation ng-if="!isWidgetPreInitFinished"></loading-animation><no-authorize ng-if="isNotAuthorized=== true"></no-authorize><no-data-available ng-if="isNotAuthorized=== false && isDataNotAvailable === true"></no-data-available></div><div class="row"><div class="col-md-12 col-sm-12 col-xs-12" style=""><div ng-if="isDataNotAvailable === false && dataLoadingFinished === true"><span ng-repeat="item in buttonsArray"><button type="button" class="btn btn-primary btn-filter {{item._isActive}}" id="{{item._buttonName}}Button" style="margin: 5px" data-toggle="button" aria-pressed="false" autocomplete="off" ng-click="updateFilter(item._buttonID)"><span ng-bind="item._buttonName"></span></button></span><jqx-grid id="{{overviewGridPrefix}}vehicleDetailsWidgetList" jqx-settings="vehicleDetialsWidgGridSettings" jqx-create="dataLoadingFinished"></jqx-grid></div></div></div>');
  }]);
})();

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicleMap/vehicleMapEdit.tpl.html', '<label translate="dashBoard.fleetManagement.vehicleList.frameHeight"></label> <input type="text" ng-model="fleetMap.height" class="form-control" font-weight="bolder" maxlength="4">');
  }]);
})();

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 4/28/2015.
 */



angular.module('dashboard.vehicleMap', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('vehicleMapWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.deviceMap.deviceMapTitle';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.deviceMap.description';
      }
    },
    controller: 'vehicleMapCtrl',
    templateUrl: 'components/dashboard/vehicleMap/vehicleMapWidget.tpl.html',
    isSingleInstance: true,
    config: {
      height: 400
    },
    edit: {
      templateUrl: 'components/dashboard/vehicleMap/vehicleMapEdit.tpl.html',
      reload: false,
      controller: 'vehicleMapEditCtrl'
    }
  });
}]).service('vehicleMapWidgetService', function () {

  var _crrentTabName = '';
  var _lastMapUrl = {
    dashboardName: '',
    isDataFromTab: false,
    tabNumber: null,
    mapURL: ''
  };
  var _isWidgetInitialized = false;
  var _groupId = '';

  this.getCurrentTabName = function () {
    return _crrentTabName;
  };

  this.setCurrentTabName = function (tabName) {
    _crrentTabName = tabName;
  };

  this.setLatMapUrl = function (mapUrl) {
    _lastMapUrl = mapUrl;
    // Store group ID if provided in the mapUrl object
    if (mapUrl && mapUrl.groupId !== undefined) {
      _groupId = mapUrl.groupId;
    }
  };

  this.getLastMapUrl = function () {
    return _lastMapUrl;
  };
  this.isWigetInitialized = function () {
    return _isWidgetInitialized;
  };
  this.setWigetInitialized = function (value) {
    _isWidgetInitialized = value;
  };

  this.getGroupId = function () {
    return _groupId;
  };

  this.setGroupId = function (groupId) {
    _groupId = groupId;
  };
}).controller('vehicleMapCtrl', ["$scope", "stateManagerService", "AuthenticationService", "base64", "$rootScope", "crudService", "$timeout", "commonTrackService", "config", "vehicleMapWidgetService", "$window", function ($scope, stateManagerService, AuthenticationService, base64, $rootScope, crudService, $timeout, commonTrackService, config, vehicleMapWidgetService, $window) {
  $scope.height = config.height;
  $scope.height = vehicleMapWidgetService.isWigetInitialized() ? $window.innerHeight - 200 : config.height;
  var _notFoundURL = '404.html';
  $scope.mapUrl = '';
  $scope.groupId = vehicleMapWidgetService.getGroupId() || '';
  $scope.isWidgetPostInitFinished = false;

  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
    });
  };
  loadFleetServerDetails().then(function () {
    vehicleMapWidgetService.setWigetInitialized(true);
  }).finally(function () {
    // if Parent not Rendered Then the 'vehicleMap_req_current_context' is lost so try mutiple times to get valid Response or Request
    $timeout(function () {
      $rootScope.$broadcast('vehicleMap_req_current_context');
    }, 0);
  });

  // if under a model dialog / initial loading sent a event Parent widget to get the current selected row/other information

  // Response from current Parent Widget for the request event 'leetMap_req_current_context'
  /**
   * Try to get the parent selected  row / related  data if not avilable will try 20 times in the interval of 50 milli seconds each
   */
  var maxGetInitialDataRetries = 30;
  var currentSelectedRowResEvent = $scope.$on('vehicleMap_res_current_context', function (event, data) {
    $scope.isResponseRecievedFromParent = true;
    --maxGetInitialDataRetries;
    var tmpLastTabIURL = vehicleMapWidgetService.getLastMapUrl();
    if (!_.isEmpty(data.currentWidgetContextData.selectedRow)) {
      // id parent widget loaded .

      // console.log(data.currentWidgetContextData);
      $scope.isWidgetPostInitFinished = true;
      switch (data.dashboardName) {
        case 'dashboard.vehicleList':
        case 'dashboard.driverWrkHrsDashboard':
        case 'dashboard.fmsDashboard':
        case 'dashboard.tachohistory':
          switch (data.tabNumber) {// for all dashboard intial tab '0' show cu
            case 0:
              rowSelectHandler(data.currentWidgetContextData);
              break;
            case 1:
            case 2:
            case 3:
              // if not default tab then the parent is already loaded and can get data from vehicleMapWidgetService
              if (tmpLastTabIURL && tmpLastTabIURL.dashboardName === data.dashboardName) {
                if (data.isDataFromTab === tmpLastTabIURL.isDataFromTab && data.tabNumber === tmpLastTabIURL.tabNumber) {

                  $scope.mapUrl = tmpLastTabIURL.mapURL;
                  // to show loading progress
                }
              } else {
                $scope.mapUrl = _notFoundURL;
              }
              break;

          }

          break;
        case 'dashboard.tachoDownloadStatusList':
          mapEventReportUpdate(data);
          break;
      }
    } else if (!$scope.isWidgetPostInitFinished) {
      if (maxGetInitialDataRetries > 0) {
        $timeout(function () {
          $rootScope.$broadcast('vehicleMap_req_current_context');
        }, 100);
      } else {
        console.warn('Max Retries exceeded to get the current Parent data for VehicleMap widget..');
        $scope.isWidgetPostInitFinished = true;
        /* if (data.isDataAvailable === false) { // To show Report not autorized if the parent Widget Report is not Autorized
           $scope.isNotAuthorized = true;
          return;
        } */
        $scope.mapUrl = _notFoundURL;
        currentSelectedRowResEvent();
      }
      // Repeatedly try to get the data from parent .
    }
  });
  // (scl-1340) used to trigger specific updates with regards to telltale specific map events
  var telltaleDataUpdate = $scope.$on('telltaleDataUpdate', function (event, data) {
    $scope.isWidgetPostInitFinished = true;

    _functionUpdateMapUrl(data.deviceId);
    vehicleMapWidgetService.setLatMapUrl({
      dashboardName: data.dashboardName,
      isDataFromTab: data.isDataFromTab,
      tabNumber: data.tabNumber,
      mapURL: $scope.mapUrl,
      groupId: $scope.groupId
    });
  });

  var eventMapUpdateEvent = $scope.$on('eventReportMapUpdate', function (event, data) {

    if ($scope.isWidgetPostInitFinished) {
      mapEventReportUpdate(data);
    }
  });

  var rowSlectedEvent = $scope.$on('rowSelected', function (event, data) {

    if ($scope.isWidgetPostInitFinished) {
      rowSelectHandler(data);
    }
  });

  function rowSelectHandler(data) {
    if (data.updateMapUrl === undefined || data.updateMapUrl) {
      _functionUpdateMapUrl(data.selectedRow !== null && data.selectedRow !== undefined ? data.selectedRow.deviceid : null);
      vehicleMapWidgetService.setLatMapUrl({
        dashboardName: data.dashboardName,
        isDataFromTab: data.isDataFromTab,
        tabNumber: data.tabNumber,
        mapURL: $scope.mapUrl,
        groupId: $scope.groupId
      });
    }
  }

  // user to update event report specific event map updates.
  var mapEventReportUpdate = function mapEventReportUpdate(data) {
    $scope.isWidgetPostInitFinished = true;
    $scope.mapUrl = '';
    vehicleMapWidgetService.setCurrentTabName(data.tabName);
    if (data.repoVehicle) {
      $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', data.repoVehicle, '', data.startDate, data.endDate);
      if (data.showPushpins) {
        $scope.mapUrl += '&pushpins_dsa=all';
      }
    } else {
      _functionUpdateMapUrl(data.deviceId !== null && data.deviceId !== undefined ? data.deviceId : null);
    }

    vehicleMapWidgetService.setLatMapUrl({
      dashboardName: data.dashboardName,
      isDataFromTab: data.isDataFromTab,
      tabNumber: data.tabNumber,
      mapURL: $scope.mapUrl,
      groupId: $scope.groupId
    });
  };

  $scope.$on('tacho_event_history_row_select', function (event, data) {

    if ($scope.isWidgetPostInitFinished) {
      rowSelectHandler(data);
    }
  });

  var vehicleGroupChengedEvent = $scope.$on('vehicleGroupChanged', function (event, data) {
    if ($scope.isWidgetPostInitFinished) {
      $scope.groupId = data.selectedVehicleGroup || '';
      vehicleMapWidgetService.setGroupId($scope.groupId);
      _functionUpdateMapUrl(data.selectedRow !== null && data.selectedRow !== undefined ? data.selectedRow.deviceid : null);

      vehicleMapWidgetService.setLatMapUrl({
        dashboardName: data.dashboardName,
        isDataFromTab: data.isDataFromTab,
        tabNumber: data.tabNumber,
        mapURL: $scope.mapUrl + '&group=' + $scope.groupId,
        groupId: $scope.groupId
      });
    }
  });

  var tabEvent = $scope.$on('tabEvent', function (event, data) {
    $scope.isWidgetPostInitFinished = true;
    $scope.mapUrl = '';
    vehicleMapWidgetService.setCurrentTabName(data.tabName);
    if (data.tabName !== 'lastLocation' && data.tabName !== 'FMSVehicle' && data.tabName !== 'vehicleTellTale') {
      // TODO : REMOVE tab specific coupling use property based
      if (data.repoVehicle) {
        $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', data.repoVehicle, '', data.startDate, data.endDate);
        if (data.tabName === 'vehicleOrders') {
          $scope.mapUrl += '&pushpins_dsa=all';
        }
      } else {
        $scope.mapUrl = _notFoundURL;
      }
    } else {
      _functionUpdateMapUrl(data.deviceId !== null && data.deviceId !== undefined ? data.deviceId : null);
    }
    vehicleMapWidgetService.setLatMapUrl({
      dashboardName: data.dashboardName,
      isDataFromTab: data.isDataFromTab,
      tabNumber: data.tabNumber,
      mapURL: $scope.mapUrl,
      groupId: $scope.groupId
    });
  });

  var orderRowSelectedEvnt = $scope.$on('ordersRowSelected', function (event, data) {
    $scope.isWidgetPostInitFinished = true;
    $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', data.repoVehicle, '', data.startDate, data.endDate);
    $scope.mapUrl += '&pushpins_dsa=all&workorderid=' + data.orderid;
    vehicleMapWidgetService.setLatMapUrl({
      dashboardName: data.dashboardName,
      isDataFromTab: data.isDataFromTab,
      tabNumber: data.tabNumber,
      mapURL: $scope.mapUrl,
      groupId: $scope.groupId
    });
  });

  function _functionUpdateMapUrl(deviceID) {
    if (deviceID) {
      $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, '&page=map.device.full&device=' + deviceID, 'vehicleMap');
    } else {
      return;
    }
    var currentGroupId = $scope.groupId || vehicleMapWidgetService.getGroupId() || '';
    $scope.mapUrl += '&geoZoneWorkOrder=true&required_session=false&group=' + currentGroupId;
  }

  $scope.$on('$locationChangeStart ', function () {
    vehicleMapWidgetService.setWigetInitialized(false);
  });

  $scope.$on('$destroy', function () {
    orderRowSelectedEvnt();
    tabEvent();
    vehicleGroupChengedEvent();
    rowSlectedEvent();
    currentSelectedRowResEvent();
    telltaleDataUpdate();
    eventMapUpdateEvent();
  });
  $scope.vehicleMapLoadEvent = function () {
    $scope.isWidgetPreInitFinished = true; // Pre init animation must disaaper
    //console.log('iframe "#vehicleMap" loaded ....');
  };
}]).controller('vehicleMapEditCtrl', ["$scope", "config", function ($scope, config) {
  $scope.fleetMap = {
    height: config.height
  };
  $scope.$watch('fleetMap.height', function (height) {
    if (height) {
      config.height = height;
    }
  });
}]);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicleMap/vehicleMapWidget.tpl.html', '<div id="vehicleMapWidget"><div ng-if="!isWidgetPostInitFinished || isWidgetPreInitFinished === false"><loading-animation></loading-animation></div><div ng-if="mapUrl.indexOf(\'404.html\') > -1"><no-data-available></no-data-available></div><div ng-show="isWidgetPostInitFinished && isDataAvailable === false"><no-authorize></no-authorize></div></div><div ng-if="!(mapUrl.indexOf(\'404.html\') > -1)" class="row" style="min-height: 100px"><div class="col-sm-12 col-md-12"><div><iframe id="vehicleMap" ng-onload="vehicleMapLoadEvent()" ng-src="{{mapUrl | trustAsResourceUrl}}" style="height : {{height}}px; width : 100%;border: 0; overflow: hidden;"></iframe></div></div></div>');
  }]);
})();

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicles/vehiclesListEdit.tpl.html', '<div class="form-group"><label for="widgetTitle" translate="dashBoard.fleetManagement.vehicleList.noOfGridRows"></label><div><jqx-drop-down-list jqx-settings="noOfRowsettings" ng-model="noOfGridRows" jqx-on-change="noOfGridOnChange(event)"></jqx-drop-down-list></div></div>');
  }]);
})();

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by zhj on 3/28/2016.
 */


angular.module('dashboard.vehiclesList', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('vehiclesListWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.vehiclesListWidget.title';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.vehiclesListWidget.description';
      }
    },
    controller: 'vehiclesListCtrl',
    templateUrl: 'components/dashboard/vehicles/vehiclesListWidget.tpl.html',
    isSingleInstance: true,
    reload: true,
    config: {
      statusCodeList: [],
      vehicleList: [],
      vehicleGroup: null,
      vehicleGroupList: [],
      statusCode: null,
      noOfGridRows: 10
    },
    edit: {
      templateUrl: 'components/dashboard/vehicles/vehiclesListEdit.tpl.html',
      reload: false,
      controller: 'vehiclesListEditCtrl'
    }
  });
}]).service('vehiclesListService', ["crudService", function (crudService) {
  var selectedRow = {};
  this.getVehicleList = function (vehicleGroup, dataRefresh) {
    var requestParam = {
      statusCode: 'all',
      vehicleGroup: vehicleGroup,
      dataRefresh: dataRefresh,
      reportName: 'DeviceCommandDashboardInfo',
      timeTo: '-0d',
      timeFrom: ''
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('portalcommands', 'vehiclelist', param);
  };

  this.setSelectedRow = function (row) {
    selectedRow = row;
  };
  this.getSelectedRow = function () {
    return selectedRow;
  };
}]).controller('vehiclesListCtrl', ["$scope", "widgetSettingsCreatorService", "commonTrackService", "config", "vehiclesListService", "$timeout", "$rootScope", "$translate", "vehicleListWidgetService", "localStorageService", "AuthenticationService", "$state", "errorHandlingService", "$interval", function ($scope, widgetSettingsCreatorService, commonTrackService, config, vehiclesListService, $timeout, $rootScope, $translate, vehicleListWidgetService, localStorageService, AuthenticationService, $state, errorHandlingService, $interval) {

  $scope.isDataAvailable = true;
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var counterSeconds = 60;
  var counterTimeout;
  var broadcastEventData = {
    selectedRow: {},
    selectedVehicleGroup: '',
    selectedStatusCode: '',
    selectedVehicleGroupLabel: '',
    eventSource: ''
  };
  var contextMenu = {};

  $scope.startCounter = function () {
    $scope.stop();
    $scope.isTimerStated = true;
    $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
    if ($scope.counter - 1 >= 1) {
      $scope.counter--;
      counterTimeout = $interval($scope.startCounter, 1000);
    } else {
      loadVehicleList(config.vehicleGroup, true);
    }
  };

  $scope.stop = function () {
    $interval.cancel(counterTimeout);
  };
  var rowSize = vehicleListWidgetService.getRowSize();
  $scope.customGridProperties = {
    height: config.noOfGridRows ? rowSize[config.noOfGridRows] - 15 : 455,
    pageable: false,
    columns: []
  };

  $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
  });

  $scope.vehicleGroupComboChange = function (event) {
    var vehicleGroup = event.args.item;
    if (vehicleGroup) {
      if (config.vehicleGroup !== vehicleGroup.value || $scope.createVehiclesListGrid) {
        loadVehicleList(vehicleGroup.value, true);
      }
      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, vehicleGroup.value);
      config.vehicleGroup = vehicleGroup.value;
    }
  };

  $scope.vehiclesListRowSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      broadcastEventData.selectedRow = event.args.row;
      broadcastEventData.selectedRow.jobstatuscode = broadcastEventData.selectedRow.jobstatuscode;
      vehiclesListService.setSelectedRow(event.args.row);
      $rootScope.$broadcast('vehiclesListRowSelected', broadcastEventData);

      var loginid = AuthenticationService.GetLoginID();
      localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
        'deviceid': broadcastEventData.selectedRow.deviceid,
        'driverid': broadcastEventData.selectedRow.driverid
      });
    }
  };

  function createMessageEvent() {
    $rootScope.$broadcast('newMsgEvent', {});
  }

  function createCommandEvent() {
    $rootScope.$broadcast('newCommandEvent', {});
  }

  function showDashboard() {
    $state.go('betotrack.dashboard');
  }

  function showDriverDashboard() {
    $state.go('driverdashboard');
  }

  function showFmsDashboard() {
    $state.go('fmsdashboard');
  }

  var _contextSourceObj = {
    portalCommandCtxSource: [{
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
      execute: createMessageEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
      execute: createCommandEvent
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDashboard'),
      execute: showDashboard
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
      execute: showDriverDashboard
    }, {
      label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
      execute: showFmsDashboard
    }]
  };

  $scope.gridRowClickHandler = function (event) {
    if (event.args.rightclick) {
      commonTrackService.initGridRightClickContextMenu(event, contextMenu);
    }
  };

  $scope.portalCommandContextHandler = function (event) {
    commonTrackService.executeContextMenuClick(event, 'portalCommandCtxSource', _contextSourceObj);
  };

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {
        $scope.vehicleGroupSettings.source = vechileGroupList;
        config.vehicleGroupList = vechileGroupList;

        var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

        if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) {
          // validate the local storage group is still valid ( group can change based on login )
          $scope.vehicleGroup = config.vehicleGroup;
        }

        if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {
            // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = cachedGroup;
            config.vehicleGroup = cachedGroup;
          }
        }

        if (!$scope.vehicleGroup) {
          $scope.vehicleGroup = vechileGroupList[0].groupID;
        }
      }
    });
  };

  var loadOverviewListSettings = function loadOverviewListSettings() {
    return commonTrackService.getOverviewListSettings('vehiclelists').then(function (overviewListSetting) {
      $scope.columnPropertiesList = overviewListSetting.overviewListGrids[0].columnProperties;
    });
  };
  var pendingCommandsVehicleListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };

  var loadVehicleList = function loadVehicleList(vehicleGroup, dataRefresh) {
    $scope.stop();
    return vehiclesListService.getVehicleList(vehicleGroup, dataRefresh).then(function (vehicleResult) {
      if (vehicleResult) {
        var dataSource;
        if (vehicleResult.dataList) {
          $scope.translationMap = vehicleResult.columnTranslation;
          $scope.customGridProperties.columns = commonTrackService.getColumnProperties($scope.columnPropertiesList, $scope.translationMap, { moduleName: 'vehicles' });
          var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehiclesListWidget.title') };
          $scope.vehiclesListSettings = commonTrackService.getGridSettings('vehicles', $scope.customGridProperties, null, _additionalProperties);
          pendingCommandsVehicleListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'vehiclesList', pendingCommandsVehicleListSource);
          $scope.vehiclesListdataAdapter = new $.jqx.dataAdapter(pendingCommandsVehicleListSource);
        }
        dataSource = vehicleResult.dataList;
        $scope.isDataAvailable = true;

        commonTrackService.rebuildDataSource($scope.columnPropertiesList, $scope.translationMap, dataSource);
        pendingCommandsVehicleListSource.localdata = dataSource;
        $scope.vehiclesListSettings.source = $scope.vehiclesListdataAdapter;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehiclesList');
      }
    }, function (response) {
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      $scope.counter = counterSeconds;
      if ($scope.isDataAvailable && !counterTimeout || counterTimeout.$$state && counterTimeout.$$state.value === 'canceled' && $scope.isDataAvailable) {
        $scope.startCounter();
      } else {
        $scope.stop();
      }

      $timeout(function () {
        var rows = $('#' + $scope.overviewGridPrefix + 'vehiclesList').jqxGrid('getrows');
        var _lastLocSelectedRowIndex = commonTrackService.getSelectRowIndexByCache(rows);
        if (_lastLocSelectedRowIndex < 0) {
          broadcastEventData.selectedRow = null;
          $rootScope.$broadcast('vehiclesListRowSelected', broadcastEventData);
          return;
        } else {
          $('#' + $scope.overviewGridPrefix + 'vehiclesList').jqxGrid('selectrow', _lastLocSelectedRowIndex);
        }
      }, 0);
      if ($scope.createVehiclesListGrid) {
        $rootScope.$broadcast('pendingDashboardVehiclesRefreshed');
      }
      $scope.createVehiclesListGrid = true;
    });
  };

  loadVehicleGroup().then(function () {
    loadOverviewListSettings();
  }).finally(function () {
    $scope.dataLoadingFinished = true;
    if ($scope.vehicleGroup) {
      loadVehicleList($scope.vehicleGroup, true);
    }
    $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(165);
    $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
      created: function created(args) {
        contextMenu = args.instance;
      }, source: _contextSourceObj.portalCommandCtxSource
    });
  });
  $scope.stopAutoRefresh = commonTrackService.getRefreshStartStopfunction($scope, false, false, loadVehicleList, 'vehicleGroupComboBox', true);
  $scope.$on('$destroy', function () {
    $scope.stop();
    if ($scope.vehiclesListSettings && $scope.vehiclesListSettings.source) {
      delete $scope.vehiclesListSettings.source;
    }
    if ($scope.vehiclesListdataAdapter) {
      delete $scope.vehiclesListdataAdapter;
    }
  });
}]).controller('vehiclesListEditCtrl', ["$scope", "config", "$translate", "widgetSettingsCreatorService", function ($scope, config, $translate, widgetSettingsCreatorService) {
  $scope.noOfGridRows = config.noOfGridRows;
  var source = ['5', '10', '15', '25', '50', '75', '100'];

  // init DropDownList's settings object.
  $scope.noOfRowsettings = {
    placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
    width: 200, height: 25,
    autoDropDownHeight: true,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
    source: source
  };

  $scope.noOfGridOnChange = function (event) {
    config.noOfGridRows = event.args.item.value;
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicles/vehiclesListWidget.tpl.html', '<div class="row" style=""><div class="col-sm-12 col-md-12" ng-if="isDataAvailable"><div class="row" style="margin-top: 5px;"><div class="vehicle-list-widget-ctrl" style="padding:2px;"><div class="col-md-5 col-sm-12 col-xs-12"><div jqx-delete-directive="vehicleGroupComboBox" type="comboBox"><jqx-combo-box id="vehicleGroupComboBox" jqx-settings="vehicleGroupSettings" class="jqx-combo-box-dsa required" jqx-create="dataLoadingFinished" jqx-on-change="vehicleGroupComboChange(event)" ng-model="vehicleGroup" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-5 col-sm-12 col-xs-12"></div><div id="refreshBtn" class="col-md-2 col-sm-12 col-xs-12" ng-if="timerDesc"><button ng-click="stopAutoRefresh($event)" type="button" id="autoRefreshButton" class="btn btn-default"><span class="badge" ng-show="isTimerStated">{{counter}}</span><i ng-show="!isTimerStated" class="fa fa-play" aria-hidden="true"></i></button></div></div><div class="row" style="margin-top: 5px;" ng-if="isDataAvailable"><div class="col-sm-12 col-md-12"><div contextmenu=""><div jqx-delete-directive="{{overviewGridPrefix}}vehiclesList" type="grid" style="margin-right: 2.5px;"><jqx-grid id="{{overviewGridPrefix}}vehiclesList" jqx-settings="vehiclesListSettings" jqx-on-rowselect="vehiclesListRowSelectHandler(event)" jqx-on-rowclick="gridRowClickHandler(event)" jqx-create="createVehiclesListGrid" class="custom-header"></jqx-grid></div><jqx-menu jqx-settings="ctxMenuSettings" jqx-on-itemclick="portalCommandContextHandler($event)" jqx-create="createVehiclesListGrid"></jqx-menu></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></div></div></div>');
  }]);
})();

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicleStatus/vehicleStatusDialog.tpl.html', '<div xmlns="http://www.w3.org/1999/html"><form name="settingsForm" novalidate=""><div class="modal-header"><h3 class="modal-title" translate="truckmixerList.modelDialog.{{vehicleStatusDialog.stateName}}" <="" h3=""></h3></div><div class="modal-body"><span ng-if="vehicleStatusDialog.stateName === \'vehicleState\'"><div style="padding-bottom: 15px;"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4" style="padding:2.5px;padding-left:20px;"><label class="input-label" translate="truckmixerList.modelDialog.orderDate"></label></div><div class="col-xs-5 col-sm-5 col-md-5" style="padding:2.5px;"><label>{{vehicleStatusDialog.orderDate}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4" style="padding:2.5px;padding-left:20px;"><label class="input-label" translate="truckmixerList.modelDialog.vehicle"></label></div><div class="col-xs-5 col-sm-5 col-md-5" style="padding:2.5px;"><label>{{vehicleStatusDialog.deviceDesc}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4" style="padding:2.5px;padding-left:20px;"><label class="input-label" translate="truckmixerList.modelDialog.currentStatus"></label></div><div class="col-xs-5 col-sm-5 col-md-5" style="padding:2.5px;"><label>{{vehicleStatusDialog.statusCode }} - {{vehicleStatusDialog.stateDesc}}</label></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4" style="padding:2.5px;padding-left:20px;"><label class="input-label" translate="truckmixerList.modelDialog.newStatus"></label></div><div class="col-xs-4 col-sm-4 col-md-4" style="padding:2.5px;"><jqx-combo-box id="vehicleStateComboBox" name="newState" ng-model="vehicleStatusDialog.state" jqx-settings="vehicleStateSettings" class="jqx-combo-box-dsa input-background" focus-on="dataLoadingFinished" clear-input="" required="" focus-blur=""></jqx-combo-box></div></div></div></span> <span ng-if="vehicleStatusDialog.stateName === \'pauseBegin\'"><div class="row" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3"><label style="padding-top: 6px;padding-left: 10px" translate="vehicleStatus.dialog.startTime"></label></div><div class="col-xs-7 col-sm-7 col-md-7"><jqx-date-time-input id="startTimeWidget" tabindex="42" ng-model="vehicleStatusDialog.recordTime" class="input-background" jqx-settings="startTimeWidget"></jqx-date-time-input></div></div><div class="row" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3"><label style="padding-top: 6px;padding-left: 10px" translate="vehicleStatus.dialog.duration"></label></div><div class="col-xs-2 col-sm-2 col-md-2"><input type="text" class="form-control required" ng-model="vehicleStatusDialog.duration" focus-on="dataLoadingFinished" maxlength="3/"></div></div></span></div><div class="modal-footer"><button class="btn btn-primary" ng-click="save(vehicleStatusDialog.stateName)" translate="vehicleStatus.dialog.save"></button> <button class="btn btn-warning" ng-click="cancel()" translate="vehicleStatus.dialog.cancel"></button></div></form></div>');
  }]);
})();

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/25/2016.
 */


angular.module('betosyswebapp').service('vehicleStatusDialogService', ["crudService", function (crudService) {

  this.getVehicleStatesComboList = function () {
    return crudService.get('portalcommands/vehiclestates');
  };
}]).controller('VehicleStatusDialogCtrl', ["$scope", "$uibModalInstance", "vehicleStatusDialogService", "items", "widgetSettingsCreatorService", "vehiclesListService", "$filter", "vehicleStatusService", "$translate", "$timeout", "$rootScope", "toastService", function ($scope, $uibModalInstance, vehicleStatusDialogService, items, widgetSettingsCreatorService, vehiclesListService, $filter, vehicleStatusService, $translate, $timeout, $rootScope, toastService) {
  var selectedRow = vehiclesListService.getSelectedRow();
  var statusTimeoutObj = {};
  $scope.vehicleStatusDialog = {
    recordTime: new Date(),
    duration: '',
    stateName: items.stateName,
    deviceID: items.deviceID,
    statusCode: '',
    deviceDesc: selectedRow.devicedesc,
    stateDesc: selectedRow.jobstatusdesc,
    orderDate: selectedRow.date
  };

  $scope.startTimeWidget = {
    allowNullDate: true,
    formatString: 'HH:mm',
    showCalendarButton: false,

    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
    width: 68,
    height: 30
  };

  $scope.vehicleStateSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  var loadVehicleStates = function loadVehicleStates() {
    vehicleStatusDialogService.getVehicleStatesComboList().then(function (states) {
      $scope.vehicleStateSettings.source = states;
      var _translatedSttausCode = vehicleStatusService.convertGtsStatusCodeToBetoplanCode(selectedRow.jobstatuscode);
      $scope.vehicleStatusDialog.statusCode = _translatedSttausCode;
      if (_translatedSttausCode) {
        $scope.vehicleStatusDialog.state = getNextState(_translatedSttausCode);
      }
    }).finally(function () {
      $timeout(function () {
        $scope.dataLoadingFinished = true;
      }, 0);
    });
  };
  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.save = function (statusDesc) {

    var pendingCommandParams = vehicleStatusService.getPendingCommand($scope.vehicleStatusDialog.deviceID);
    var object = {};
    if (statusDesc === 'pauseBegin') {
      object = vehicleStatusService.getPendingCommandArgs(selectedRow.orderid, statusDesc);
      object.starttime = $filter('date')($scope.vehicleStatusDialog.recordTime, 'HH:mm') || null;
      object.duration = $scope.vehicleStatusDialog.duration || null;
    }
    if (statusDesc === 'vehicleState') {
      object = vehicleStatusService.getPendingCommandArgs(selectedRow.orderid, Number($scope.vehicleStatusDialog.state));
    }
    pendingCommandParams = _.extend(pendingCommandParams, object);
    return vehicleStatusService.savePendingCommand(pendingCommandParams).then(function () {
      toastService.showSuccessToast($translate.instant('vehicleStatus.operationSuccess'));
      statusTimeoutObj = $timeout(function () {
        $uibModalInstance.close();
      }, 100);
      $rootScope.$broadcast('portalCommandSaved');
    }, function () {});
  };
  loadVehicleStates();

  function getNextState(currentState) {
    var newState = null;
    for (var i = 0; i < $scope.vehicleStateSettings.source.length; i++) {
      if (Number($scope.vehicleStateSettings.source[i].key) === currentState + 1) {
        newState = $scope.vehicleStateSettings.source[i].key;
        break;
      }
    }
    return newState !== null ? newState : currentState;
  }

  $scope.$on('$destroy', function () {});
}]);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/25/2016.
 */


angular.module('dashboard.vehicleStatus', ['adf.provider']).config(["dashboardProvider", function (dashboardProvider) {
  dashboardProvider.widget('vehicleStatusWidget', {
    resolve: {
      title: function title() {
        return 'dashBoard.fleetManagement.vehicleStatusWidget.title';
      },
      description: function description() {
        return 'dashBoard.fleetManagement.vehicleStatusWidget.description';
      }
    },
    controller: 'vehicleStatusCtrl',
    templateUrl: 'components/dashboard/vehicleStatus/vehicleStatusWidget.tpl.html',
    isSingleInstance: true,
    config: {
      statusCodeList: [],
      vehicleList: [],
      vehicleGroup: null,
      vehicleGroupList: [],
      statusCode: null,
      noOfGridRows: ''
    }
  });
}]).service('vehicleStatusService', ["crudService", "$filter", function (crudService, $filter) {

  this.getPendingCommand = function (deviceId) {
    var pendingCommandParams = {
      deviceID: deviceId,
      commandType: 'FNG',
      sendState: 0,
      commandArgs: ''
    };

    return pendingCommandParams;
  };

  this.getPendingCommandArgs = function (orderid, stateDesc) {
    var commandArgs = {
      date: $filter('date')(new Date(), 'yyyyMMdd'),
      time: $filter('date')(new Date(), 'HHmmss'),
      orderid: orderid || 0,
      status: typeof stateDesc === 'number' ? stateDesc : this.convertStateDescToStateNo(stateDesc) || null
    };
    return commandArgs;
  };

  this.convertStateDescToStateNo = function (stateDesc) {
    switch (stateDesc) {
      case 'pauseBegin':
        return 12; // as described in Enterprise GTS (Data.BETONPLAN_PAUSE)
      case 'pauseEnd':
        return 14; // as described in Enterprise GTS (DATA.BETONPLAN_PAUSE_END)
      case 'maintenanceBegin':
        return 13; // as described in Enterprise GTS (Data.BETONPLAN_INSERVICE)
      case 'maintenanceEnd':
        return 15; // as described in Enterprise GTS (Data.BETONPLAN_INSERVICE_END)
      case 'login':
        return 9; // as described in Enterprise GTS (Data.BETONPLAN_LOGIN)
      case 'logout':
        return 10; // as described in Enterprise GTS (Data.BETONPLAN_LOGOUT)
    }
  };

  this.convertGtsStatusCodeToBetoplanCode = function (GTSstatusCode) {
    switch (GTSstatusCode) {
      case 61831:
        return 1;
      case 4097:
        return 2;
      case 62005:
        return 3;
      case 61973:
        return 4;
      case 4101:
        return 5;
      case 4102:
        return 6;
      case 4103:
        return 7;
      case 4104:
        return 8;
      case 63505:
        return 9;
      case 63506:
        return 10;
      case 4107:
        return 12;
      case 4109:
        return 13;
      case 4110:
        return 14;
      case 4111:
        return 15;
      default:
        return null;
    }
  };
  this.savePendingCommand = function (params) {
    return crudService.post('portalcommands/vehiclestatus', params);
  };
}]).controller('vehicleStatusCtrl', ["$scope", "$uibModal", "$rootScope", "vehicleStatusService", "$translate", "toastService", function ($scope, $uibModal, $rootScope, vehicleStatusService, $translate, toastService) {
  $scope.vehicleStatus = {
    deviceID: '',
    order: ''
  };
  $scope.alerts = [];
  var selectedRow;
  var functionalProperties = {
    truckmixerFree: ['pauseBegin', 'maintenanceBegin', 'login', 'logout'],
    truckmixerReturnPlant: ['vehicleState', 'pauseBegin', 'maintenanceBegin'],
    truckmixerBusy: ['vehicleState', 'pauseBegin', 'maintenanceBegin'],
    truckmixerPause: ['pauseEnd'],
    truckmixerMaintenance: ['maintenanceEnd'],
    buttonNames: ['vehicleStateDisabled', 'retourDisabled', 'pauseBeginDisabled', 'maintenanceBeginDisabled', 'loginDisabled', 'orderDisabled', 'plantDisabled', 'pauseEndDisabled', 'maintenanceEndDisabled', 'logoutDisabled']
  };

  var disableButtons = function disableButtons() {
    for (var i = 0; i < functionalProperties.buttonNames.length; i++) {
      $scope[functionalProperties.buttonNames[i]] = true;
    }
  };

  function activeButton(description) {
    var keys = _.keys(functionalProperties);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var lowerCaseKey = key.toLowerCase();
      if (lowerCaseKey.indexOf(description) !== -1) {
        for (var j = 0; j < functionalProperties[key].length; j++) {
          $scope[functionalProperties[key][j] + 'Disabled'] = false;
        }
      }
    }
  }

  var enableSupportedOperation = function enableSupportedOperation(selectedRow) {
    disableButtons();
    var statusCode = selectedRow.jobstatuscode;
    var description;
    switch (statusCode) {
      case 63505:
      case 63506:
      case 4104:
        description = 'free';
        break;
      case 4103:
        description = 'returnplant';
        break;
      case 4097:
      case 61831:
      case 62005:
      case 61973:
      case 4101:
      case 4102:
        description = 'busy';
        break;
      case 4107:
        description = 'pause';
        break;
      case 4109:
        description = 'maintenance';
        break;
    }
    if (description) {
      activeButton(description);
    }
  };

  var openDialogOfTruckMixer = function openDialogOfTruckMixer(state) {
    if (state === 'pauseBegin' || state === 'vehicleState') {
      var dialogModel = {
        deviceID: $scope.vehicleStatus.deviceID,
        stateName: state
      };
      var modalInstance = $uibModal.open({
        templateUrl: 'components/dashboard/vehicleStatus/vehicleStatusDialog.tpl.html',
        controller: 'VehicleStatusDialogCtrl',
        resolve: {
          items: function items() {
            return dialogModel;
          }
        }
      });

      modalInstance.result.then(function () {});
    }
  };
  $scope.vehicleStatusDialog = function (state) {
    openDialogOfTruckMixer(state);
  };

  $scope.updateVehicleState = function (statusDesc) {
    var pendingCommandParams = vehicleStatusService.getPendingCommand($scope.vehicleStatus.deviceID);
    var object = vehicleStatusService.getPendingCommandArgs(selectedRow.orderid, statusDesc);
    pendingCommandParams = _.extend(pendingCommandParams, object);
    return vehicleStatusService.savePendingCommand(pendingCommandParams).then(function () {
      toastService.showSuccessToast($translate.instant('vehicleStatus.operationSuccess'));
      $rootScope.$broadcast('portalCommandSaved');
    }, function () {});
  };

  $scope.buttonGroups = [{
    buttons: [{
      name: 'vehicleStatus.button.setvehicleState',
      state: 'vehicleState',
      visibility: 'vehicleStateDisabled',
      operation: $scope.vehicleStatusDialog,
      operationParam: 'vehicleState',
      isOpenModal: true
    }, {
      name: 'vehicleStatus.button.pauseBegin',
      state: 'pauseBegin',
      visibility: 'pauseBeginDisabled',
      operation: $scope.vehicleStatusDialog,
      operationParam: 'pauseBegin',
      isOpenModal: true
    }, {
      name: 'vehicleStatus.button.maintenanceBegin',
      state: 'maintenanceBegin',
      visibility: 'maintenanceBeginDisabled',
      operation: $scope.updateVehicleState,
      operationParam: 'maintenanceBegin',
      isOpenModal: false
    }, {
      name: 'vehicleStatus.button.login',
      state: 'login',
      visibility: 'loginDisabled',
      operation: $scope.updateVehicleState,
      operationParam: 'login',
      isOpenModal: false
    }]
  }, {
    buttons: [{
      name: 'vehicleStatus.button.order',
      state: 'order',
      visibility: 'orderDisabled',
      operation: $scope.vehicleStatusDialog,
      operationParam: '',
      isOpenModal: true
    }, {
      name: 'vehicleStatus.button.pauseEnd',
      state: 'pauseEnd',
      visibility: 'pauseEndDisabled',
      operation: $scope.updateVehicleState,
      operationParam: 'pauseEnd',
      isOpenModal: false
    }, {
      name: 'vehicleStatus.button.maintenanceEnd',
      state: 'maintenanceEnd',
      visibility: 'maintenanceEndDisabled',
      operation: $scope.updateVehicleState,
      operationParam: 'maintenanceEnd',
      isOpenModal: false
    }, {
      name: 'vehicleStatus.button.logout',
      state: 'logout',
      visibility: 'logoutDisabled',
      operation: $scope.updateVehicleState,
      operationParam: 'logout',
      isOpenModal: false
    }]
  }];

  $scope.$on('vehiclesListRowSelected', function (event, args) {
    if (args) {
      var broadcastEventData = args;
      selectedRow = broadcastEventData.selectedRow;
      if (!selectedRow) {
        $scope.isDataAvailable = false;
        return;
      }
      $scope.isDataAvailable = true;
      $scope.vehicleStatus.deviceID = selectedRow.deviceid;
      if (selectedRow.workorderjobdate && selectedRow.workorderjoblocation && selectedRow.workorderjobnumber) {
        $scope.vehicleStatus.order = selectedRow.workorderjobdate + '/' + selectedRow.workorderjoblocation + '/' + selectedRow.workorderjobnumber + '/';
      }
      enableSupportedOperation(selectedRow);
    } else {
      $scope.isDataAvailable = false;
    }
  });
  $scope.closeAlertByIndex = function (index) {
    $scope.alerts.splice(index, 1);
  };
}]);

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/dashboard/vehicleStatus/vehicleStatusWidget.tpl.html', '<div class="row" style="padding: 2.5px;"><div class="col-sm-12 col-md-12" style="padding: 2px"><div ng-if="isDataAvailable"><div class="buttonGroups" ng-repeat="buttonGroup in buttonGroups"><div class="buttonGroup" ng-repeat="button in buttonGroup.buttons"><button type="button" class="btn btn-default" ng-click="button.operation(button.operationParam)" ng-disabled="{{button.visibility}}"><span translate="{{button.name}}"></span></button></div></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></div></div>');
  }]);
})();

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/footerbar.tpl.html', '<footer class="main-footer" ui-view="footer"><div class="col-xs-12 col-sm-12 col-md-12" style="padding:0px" ng-controller="FootbarCtrl"><div class="col-xs-9 col-sm-9 col-md-9" style="padding:0px" ng-show="isBiggerScreen"><a class="copyright" href="https://www.dsa.de/de/">&copy; 2024 DSA Daten- und Systemtechnik GmbH Deutschland</a> <a class="copyright" href="https://www.dsa.de/de/datenschutzerklaerung.html">{{\'foot.dataprivacy\'| translate}}</a> <a class="copyright" href="https://www.dsa.de/de/impressum.html">{{\'foot.imprint\'| translate}}</a></div><div class="col-xs-12 col-sm-12 col-md-3" style="color:#FFFFFF;padding:0px;text-align: right;"><label ng-show="isBiggerScreen">{{ \'foot.application\' | translate }}&nbsp;V{{clientVersion}} <span ng-show="isShowGtseVersion">/ {{gtseVersion}}</span></label> <label ng-show="!isBiggerScreen" style="text-align: left">{{smallerScreenFooterText}}</label></div></div></footer>');
  }]);
})();

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/footerbar/footerbar.tpl.html', '<footer class="main-footer" ui-view="footer"><div class="col-xs-12 col-sm-12 col-md-12" style="padding:0px" ng-controller="FootbarCtrl"><div class="col-xs-9 col-sm-9 col-md-9" style="padding:0px" ng-show="isBiggerScreen"><a class="copyright" href="https://www.dsa.de/de/">&copy; 2025 DSA Daten- und Systemtechnik GmbH Deutschland</a> <a class="copyright" ng-if="accountID === \'sph\'" href="{{ dataPrivacyUrl }}">{{\'foot.dataprivacy\'| translate}}</a></div><div class="col-xs-12 col-sm-12 col-md-3" style="color:#FFFFFF;padding:0px;text-align: right;"><label ng-show="isBiggerScreen">{{ \'foot.application\' | translate }}&nbsp;V{{clientVersion}} <span ng-show="isShowGtseVersion">/ {{gtseVersion}}</span></label> <label ng-show="!isBiggerScreen" style="text-align: left">{{smallerScreenFooterText}}</label></div></div></footer>');
  }]);
})();

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 2/2/2015.
 */


angular.module('betosyswebapp').controller('FootbarCtrl', ["$scope", "versionService", "AuthenticationService", "version", "commonTrackService", "accountConfig", function ($scope, versionService, AuthenticationService, version, commonTrackService, accountConfig) {
  $scope.cVersion = '';
  $scope.clientVersion = version;
  $scope.gtseVersion = '';
  $scope.imprintUrl = '';
  $scope.dataPrivacyUrl = '';

  var accountID = window.location.hostname.split('.')[0];
  $scope.accountID = accountID;
  $scope.imprintUrl = accountConfig.imprintUrls[accountID] || accountConfig.imprintUrls['default'];
  $scope.dataPrivacyUrl = accountConfig.dataPrivacyUrls[accountID] || accountConfig.dataPrivacyUrls['default'];

  $scope.isShowDatabaseVersion = false;
  $scope.isShowGtseVersion = false;
  var viewPortName = commonTrackService.getViewPortName();
  $scope.isBiggerScreen = viewPortName === 'MD' || viewPortName === 'LG' ? true : false;
  $scope.smallerScreenFooterText = 'DSA - ';

  $scope.$watch(function () {
    return AuthenticationService.IsLogin();
  }, function (data) {
    if (data) {
      versionService.getVersion().then(function (versionInfo) {
        $scope.cVersion = versionInfo.dbVersion;
        $scope.smallerScreenFooterText += $scope.clientVersion;
        $scope.isShowGtseVersion = true;
        $scope.gtseVersion = versionInfo.gtseVersion.trim();
        $scope.smallerScreenFooterText += ' / ' + $scope.gtseVersion;
      });
    } else {
      $scope.isShowGtseVersion = false;
    }
  }, true);
}]);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by zml on 4/22/2016.
 */
(function () {
  'use strict';

  FrameworkController.$inject = ["$scope", "$timeout", "$window", "PubSubService", "$translate", "customerService"];
  angular.module('betosyswebapp').controller('FrameworkController', FrameworkController);

  // FrameworkController.$inject = ['$scope', '$timeout', '$window', 'PubSubService', 'AuthenticationService', 'Restangular'];

  /* @ngInject */
  function FrameworkController($scope, $timeout, $window, PubSubService, $translate, customerService) {
    var vm = this;

    //var campaignMenuItem = createCampaignMenuItem();

    vm.headerModel = createHeaderModel();
    vm.languageModel = createLanguageModel();
    // vm.sidebarModel = createSideBarModel();

    init();

    ////////////////

    function init() {
      //onStateChanged();
      onSideBarToggle();
      //onCampaignStatusChanged();
    }

    function createLanguageModel() {
      var model = {
        languages: ['en', 'de', 'nl']
      };
      return model;
    }

    function createHeaderModel() {
      var model = {
        logo: '<b>' + customerService.getProductLogText() + '</b>',
        miniLogo: '<b>' + customerService.getProductLogoShortText() + '</b>',
        href: 'home'
      };
      return model;
    }

    /**
     * This method will register one listener on toggling side bar to trigger WINDOW RESIZE EVENT for jqxWidget to
     * do relayout.
     */
    function onSideBarToggle() {

      PubSubService.subscribe('_TOGGLE_SIDEBAR_', function () {

        $timeout(function () {
          $window.dispatchEvent(new Event('resize'));
        }, 500);
      }, $scope);
    }
  }
})();

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/framework/framework.tpl.html', '<adm-framework><adm-header model="framework.headerModel"><header-nav></header-nav><adm-header-language model="framework.languageModel"></adm-header-language></adm-header><adm-sidebar></adm-sidebar><adm-content></adm-content><div ng-include="\'components/footerbar/footerbar.tpl.html\'"></div></adm-framework>');
  }]);
})();

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('betosyswebapp').config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('home', {
    parent: 'app',
    url: '/',
    views: {
      'content@app': {
        templateUrl: 'components/home/home.tpl.html',
        controller: 'MainController',
        controllerAs: 'framework'
      }
    },
    resolve: {
      $title: function $title() {
        return 'DSA';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(false);
        return false;
      }]
    }
  });
}]);

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/home/home.tpl.html', '');
  }]);
})();

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  MainController.$inject = ["$state", "AuthenticationService", "dataContainerService", "messageService"];
  angular.module('betosyswebapp').controller('MainController', MainController);

  /* @ngInject */
  function MainController($state, AuthenticationService, dataContainerService, messageService) {
    var vm = this;
    var credentials = AuthenticationService.getCredentials();

    vm.modules = {
      'sref': 'betotrack.dashboard',
      'name': 'track',
      'img': 'assets/images/betocon_small.jpg'
    };

    active();
    openModule(vm.modules);
    ////////////////
    function active() {
      if (credentials) {
        AuthenticationService.logout();

        dataContainerService.cleanAllCache();
        messageService.deInitialize();
      }
    }

    function openModule(module) {
      if (credentials) {
        AuthenticationService.Login(credentials.loginID, credentials.password).finally(function () {
          $state.go(module.sref, { reload: true });
        });
      } else {
        $state.go(module.sref, { reload: true });
      }
    }
  }
})();

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('betosyswebapp').config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('login', {
    parent: 'app',
    url: '/login',
    views: {
      'content@app': {
        templateUrl: 'components/login/login.tpl.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack Login';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(false);
        return false;
      }]
    }
  });
}]);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/login/login.tpl.html', '<div class="container"><dsa-login title="{{loginTitle}}" loginid="{\'Account\':\'\',\'username\':\'\'}"></dsa-login></div><img style="width:100%;position: absolute;bottom:0px;margin-bottom: 51px" ng-src="assets/images/betosys_big.jpg">');
  }]);
})();

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('betosyswebapp').controller('LoginController', LoginController);

  LoginController.$inject = ['$scope', 'customerService', 'AuthenticationService'];

  /** @ngInject */
  function LoginController($scope, customerService, AuthenticationService) {

    ////////////////
    function init() {
      AuthenticationService.clearUserCredentials();
    }

    $scope.loginTitle = customerService.getLoginWindowText();
    init();
  }
})();

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  routerConfig.$inject = ["$stateProvider"];
  angular.module('betosyswebapp').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider.state('logout', {
      parent: 'app',
      url: '/logout',
      views: {
        'content@app': {
          controller: 'LogoutController'

        }
      },
      resolve: {
        $title: function $title() {
          return 'Logout';
        }
      }
    });
  }
})();

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by rak on 11/12/2014.
 */
(function () {
  'use strict';

  LogoutController.$inject = ["AuthenticationService", "dataContainerService", "messageService", "$state"];
  angular.module('betosyswebapp').controller('LogoutController', LogoutController);

  /** @ngInject */
  function LogoutController(AuthenticationService, dataContainerService, messageService, $state) {
    AuthenticationService.logout().finally(function () {
      dataContainerService.cleanAllCache();
      messageService.deInitialize();
      $state.go('home');
    });
  }
})();

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 11/14/2014.
 */


angular.module('betosyswebapp').controller('passwordController', ["$scope", "$rootScope", "$uibModalInstance", "$http", "base64", "AuthenticationService", "$translate", "errorCode", function ($scope, $rootScope, $uibModalInstance, $http, base64, AuthenticationService, $translate, errorCode) {
  $scope.credentials = {
    OldPassword: '',
    NewPassword: '',
    ConfirmPswrd: ''
  };
  $scope.alerts = [];
  var errorAlert = null;
  $scope.save = function () {
    $scope.alerts = [];
    if ($scope.credentials.OldPassword !== '' && $scope.credentials.NewPassword !== '' && $scope.credentials.ConfirmPswrd !== '') {
      if (angular.equals($scope.credentials.NewPassword, $scope.credentials.ConfirmPswrd)) {
        AuthenticationService.changePassword($scope.credentials.OldPassword, $scope.credentials.NewPassword).then(function () {
          var successAlert = { type: 'success', msg: $translate.instant('passwordChange.success'), autoDismiss: true };
          $scope.alerts.push(successAlert);
          if (errorCode === 'PE0010') {
            $uibModalInstance.close($scope.credentials.NewPassword);
          }
        }, function (response) {
          if (response.data && response.data.errors && response.data.errors.length > 0) {
            angular.forEach(response.data.errors, function (value) {
              if (value.code === '60000') {
                $scope.alerts.push({ type: 'error', msg: $translate.instant('passwordChange.accountmismatch'), autoDismiss: true });
              } else if (value.code === '60001') {
                $scope.alerts.push({ type: 'error', msg: $translate.instant('passwordChange.oldpasswordwrong'), autoDismiss: true });
              } else {
                // No specific translation: Fall back to message
                errorAlert = { type: 'error', msg: response.data.message, autoDismiss: true };
                $scope.alerts.push(errorAlert);
              }
            });
          } else if (response.data) {
            errorAlert = { type: 'error', msg: response.data.message, autoDismiss: true };
            $scope.alerts.push(errorAlert);
          }
        });
      } else {
        errorAlert = { type: 'error', msg: $translate.instant('passwordChange.mismatch'), autoDismiss: true };
        $scope.alerts.push(errorAlert);
      }
    } else {
      errorAlert = { type: 'error', msg: $translate.instant('passwordChange.requiredField'), autoDismiss: true };
      $scope.alerts.push(errorAlert);
    }
  };

  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.onKeyPress = function ($event) {
    if ($event.keyCode === 13) {
      // Here is where I must fire the click event of the button
      $scope.save();
    }
  };

  $scope.closeAlertByIndex = function (index) {
    $scope.alerts.splice(index, 1);
  };
}]);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/login/pswdChange.tpl.html', '<div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">x</span><span class="sr-only">Close</span></button><h4 class="modal-title" translate="nav.user.changePassword"></h4></div><div class="modal-body"><div style="margin-top: 5px;" class="input-group"><span class="input-group-addon" style="padding:3px 8px;"><i class="glyphicon glyphicon-lock"></i></span> <input type="password" class="form-control" name="OldPassword" ng-model="credentials.OldPassword" placeholder="{{ \'passwordChange.placeHolder.oldPassword\'| translate}}" ng-keypress="onKeyPress($event)" required=""></div><div style="margin-top: 25px" class="input-group"><span class="input-group-addon" style="padding:3px 8px;"><i class="glyphicon glyphicon-lock"></i></span> <input type="password" class="form-control" name="NewPassword" ng-model="credentials.NewPassword" placeholder="{{ \'passwordChange.placeHolder.newPassword\'| translate}}" ng-keypress="onKeyPress($event)" required=""></div><div style="margin-top: 25px" class="input-group"><span class="input-group-addon" style="padding:3px 8px;"><i class="glyphicon glyphicon-lock"></i></span> <input type="password" class="form-control" name="ConfirmPswrd" ng-model="credentials.ConfirmPswrd" placeholder="{{ \'passwordChange.placeHolder.confirmPassword\'| translate}}" ng-keypress="onKeyPress($event)" required=""></div></div><div ng-repeat="alert in alerts" class="col-xs-12 col-sm-12 col-md-12"><uib-alert ng-if="true == alert.autoDismiss" type="{{alert.type}}" close="closeAlertByIndex($index)" dismiss-on-timeout="3000" style="margin-bottom: 5px;">{{alert.msg}}</uib-alert><uib-alert ng-if="true != alert.autoDismiss" type="{{alert.type}}" close="closeAlertByIndex($index)" style="margin-bottom: 5px;">{{alert.msg}}</uib-alert></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="save()" translate="passwordChange.save"></button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="close()" translate="passwordChange.close"></button></div></div>');
  }]);
})();

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by thk on 4/16/2021.
 */


angular.module('betosyswebapp').controller('CommandController', ["$scope", "$uibModalInstance", "$filter", "AuthenticationService", "widgetSettingsCreatorService", "commonTrackService", "toastService", "$translate", function ($scope, $uibModalInstance, $filter, AuthenticationService, widgetSettingsCreatorService, commonTrackService, toastService, $translate) {
  var commandType = 'config';
  $scope.deviceCommand = {
    deviceID: '',
    commandID: ''
  };
  $scope.userName = $scope.userName = AuthenticationService.GetLoginUserName();
  $scope.commandVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'deviceID'
  });
  $scope.commandCommandSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });
  var fleetServerDetails;
  var loadDevices = function loadDevices() {
    return commonTrackService.getDeviceComboList().then(function (vehicleList) {
      $scope.commandVehicleSettings.source = vehicleList;
      var LstLocationSectedData = commonTrackService.getsetLastLocatioWidgetData();
      if (LstLocationSectedData && LstLocationSectedData.selectedRow && LstLocationSectedData.selectedRow.deviceid) {
        $scope.deviceCommand.deviceID = LstLocationSectedData.selectedRow.deviceid;
      }
    }).then(function () {
      commonTrackService.getFleetServerDetails().then(function (fleetDetails) {
        fleetServerDetails = fleetDetails;
      });
    }).finally(function () {
      $scope.deviceLoadingFinished = true;
      loadCommands();
    });
  };

  var loadCommands = function loadCommands() {
    $scope.commandCommandSettings.source = [];
    if ($scope.deviceCommand.deviceID) {
      commonTrackService.getVehicleGridCommandList($scope.deviceCommand.deviceID).then(function (commandList) {
        $scope.commandCommandSettings.source = commandList;
      }).finally(function () {
        $scope.commandLoadingFinished = true;
      });
    }
  };

  loadDevices();
  $scope.ok = function () {
    $uibModalInstance.close($scope.selected.item);
  };

  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.send = function () {
    if ($scope.deviceCommand.commandID) {
      if ($scope.deviceCommand.deviceID) {

        commonTrackService.sendCommand($scope.deviceCommand.deviceID, commandType, $scope.deviceCommand.commandID).then(function () {
          toastService.showSuccessToast($translate.instant('deviceCommands.sendSuccess'));
        }, function (response) {
          var _messsage = response.data && response.data.errors && response.data.errors[0].code ? $translate.instant('errorCodes.restAPI.' + response.data.errors[0].code + '.message') : response.data.message;
          var errorAlert = { type: 'F', message: _messsage };
          toastService.showErrorToast(errorAlert);
        }).finally(function () {});
      }
    }
  };
  $scope.commandCommandComboChange = function (event) {
    if (event.args && event.args.item && event.args.item.value) {
      loadCommands();
    }
  };
}]);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/navbar/commands.tpl.html', '<div class="message-pane"><div class="modal-header" xmlns="http://www.w3.org/1999/html"><div class="row" style="padding: 7.5px;"><div class="col-md-11"><h4 class="modal-title" translate="dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand"></h4></div><div class="col-md-1"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button></div></div><div class="row" style="padding: 7.5px;"><div class="col-md-2 col-sm-2 col-xs-2" style="padding-right: 0px;"><label translate="deviceMessaging.vehicle"></label></div><div class="col-md-8 col-sm-8 col-xs-8"><jqx-combo-box id="commandVehicleComboBox" jqx-settings="commandVehicleSettings" class="jqx-combo-box-dsa required" jqx-create="deviceLoadingFinished" jqx-on-change="commandVehicleComboChange(event)" ng-model="deviceCommand.deviceID" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="row" style="padding: 7.5px;"><div class="col-md-2 col-sm-2 col-xs-2" style="padding-right: 0px;"><label translate="deviceCommands.command"></label></div><div class="col-md-8 col-sm-8 col-xs-8"><jqx-combo-box id="commandCommandComboBox" jqx-settings="commandCommandSettings" class="jqx-combo-box-dsa required" jqx-create="commandLoadingFinished" ng-model="deviceCommand.commandID" clear-input="" focus-blur=""></jqx-combo-box></div></div></div><div class="modal-footer" style="margin-left:0px;"><div class="row"><div style="padding-right: 7.5px;margin-top:2.5px" align="right"><div class="input-group input-group-lg"><button class="btn btn-info" type="button" id="commandSendBtn" align="right" ng-click="send()" ng-disabled="!deviceCommand.deviceID || !deviceCommand.commandID" translate="deviceMessaging.sendBtn"></button> <button class="btn btn-warning" type="button" id="commandCancelBtn" align="right" ng-click="close()" translate="button.cancel"></button></div></div></div></div></div>');
  }]);
})();

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/sidebar/sidebar.tpl.html', '<ul class="nav nav-sidebar list-unstyled"><li class="nav-header"><a ui-sref="track" data-toggle="collapse" translate="sidebar.betotrack.dashboard"></a></li><li class="nav-header"><a data-toggle="collapse" data-target="#mapMenu"><span translate="sidebar.betotrack.maps"></span><i class="glyphicon glyphicon-chevron-right"></i></a></li></ul>');
  }]);
})();

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 1/11/2016.
 */


angular.module('betosyswebapp').controller('sideBarCtrl', ["$scope", "$location", "$timeout", function ($scope, $location, $timeout) {

  $scope.menu = [{
    label: 'nav.menuOptions.dashboard',
    iconClasses: 'fa fa-map-marker',
    url: '#/track'
  }, {
    label: 'nav.menuOptions.driverDashboard',
    iconClasses: 'fa fa-truck',
    url: '#/driverdashboard'
  }, {
    label: 'nav.menuOptions.portalCommand',
    iconClasses: 'fa fa-pencil-square-o',
    url: '#/portalcommand'
  }, {
    label: 'nav.menuOptions.maps',
    iconClasses: 'fa fa-globe',
    children: [{
      label: 'nav.menuOptions.mapsSubMenu.lastLocation',
      iconClasses: 'fa fa-location-arrow',
      url: '#/mapping/last'

    }, {
      label: 'Vehicle Map',
      iconClasses: 'fa fa-truck',
      url: '#/mapping/device'
    }, {
      label: 'nav.menuOptions.mapsSubMenu.groupMap',
      iconClasses: 'fa fa-sitemap',
      url: '#/mapping/fleet'
    }, {
      label: 'nav.menuOptions.mapsSubMenu.sosEmergencyMap',
      iconClasses: 'fa fa-ambulance',
      url: '#/mapping/panic'

    }, {
      label: 'nav.menuOptions.mapsSubMenu.freeDeviceMap',
      iconClasses: 'fa fa-hand-paper-o',
      url: '#/mapping/idle'

    }, {
      label: 'nav.menuOptions.mapsSubMenu.busyDeviceMap',
      iconClasses: 'fa fa-usd',
      url: '#/mapping/busy'

    }]
  }, {
    label: 'nav.menuOptions.reports',
    iconClasses: 'fa fa-list-alt',
    children: [{
      label: 'nav.menuOptions.reportsSubMenu.vehicleDetails',
      iconClasses: 'fa fa-location-arrow',
      url: '#/reports/vehicle.detail'

    }, {
      label: 'nav.menuOptions.reportsSubMenu.groupDetails',
      iconClasses: 'fa fa-sitemap',
      url: '#/reports/group.detail'
    }, {
      label: 'nav.menuOptions.reportsSubMenu.groupSummary',
      iconClasses: 'fa fa-sitemap',
      url: '#/reports/group.summary'
    }, {
      label: 'nav.menuOptions.reportsSubMenu.performance',
      iconClasses: 'fa fa-stethoscope',
      url: '#/reports/performance'

    }]
  }, {
    label: 'nav.menuOptions.admin',
    iconClasses: 'fa fa-list-alt',
    children: [{
      label: 'nav.menuOptions.telephone',
      iconClasses: 'fa fa-phone',
      url: '#/telephone/list'
    }, {
      label: 'nav.menuOptions.contacts',
      iconClasses: 'fa fa-phone',
      url: '#/contact/list'
    }]

  }];
  var setParent = function setParent(children, parent) {
    angular.forEach(children, function (child) {
      child.parent = parent;
      setParent(child.children, child);
    });
  };

  $scope.findItemByUrl = function (children, url) {
    for (var i = 0, length = children.length; length > i; i++) {
      if (children[i].url && children[i].url.replace('#', '') === url) {
        return children[i];
      }
      if (void 0 !== children[i].children) {
        var item = $scope.findItemByUrl(children[i].children, url);
        if (item) {
          return item;
        }
      }
    }
  };

  setParent($scope.menu, null);
  $scope.openItems = [];
  $scope.selectedItems = [];
  $scope.selectedFromNavMenu = !1;
  $scope.select = function (item) {
    if (item.open) {
      return void (item.open = !1);
    }
    for (var i = $scope.openItems.length - 1; i >= 0; i--) {
      $scope.openItems[i].open = !1;
      $scope.openItems = [];
    }

    for (var parentRef = item; null !== parentRef;) {
      parentRef.open = !0;
      $scope.openItems.push(parentRef);
      parentRef = parentRef.parent;
      if (!item.children || item.children && item.children.length < 1) {
        $scope.selectedFromNavMenu = !0;
        for (var j = $scope.selectedItems.length - 1; j >= 0; j--) {
          $scope.selectedItems[j].selected = !1;
        }
        $scope.selectedItems = [];
        for (parentRef = item; null !== parentRef;) {
          parentRef.selected = !0;
          $scope.selectedItems.push(parentRef);
          parentRef = parentRef.parent;
        }
      }
    }
  };

  $scope.$watch(function () {
    return $location.path();
  }, function (newVal) {
    if (!$scope.selectedFromNavMenu) {
      var item = $scope.findItemByUrl($scope.menu, newVal);
      if (item) {
        $timeout(function () {
          $scope.select(item);
        });
      }
    }
    $scope.selectedFromNavMenu = !1;
  });
}]);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/admin/bookDownload.tpl.html', '<div xmlns="http://www.w3.org/1999/html"><form name="downloadForm" ng-submit="save()"><div class="modal-header"><h3 class="modal-title" translate="bookDownload.title"></h3></div><div class="modal-body"><div class="row" style="padding-bottom: 5px"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 5px;"><label translate="bookDownload.vehicleGroup"></label></div><div class="col-xs-9 col-sm-9 col-md-9"><jqx-combo-box id="vehicleGroupComboBox" ng-model="vehicleGroup" focus-blur="" jqx-settings="vehicleGroupComboBoxSettings" jqx-create="dataLoadingFinished" clear-input=""></jqx-combo-box></div></div><div class="row" style="padding-bottom: 5px"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 5px;"><label translate="bookDownload.vehicleName"></label></div><div class="col-xs-5 col-sm-5 col-md-5"><jqx-list-box id="vehicleNameListBox" jqx-settings="vehicleNameListBoxSettings"></jqx-list-box></div><div class="col-xs-4 col-sm-4 col-md-4"><button type="button" id="slectAllBtn" class="btn btn-default unified-btn" ng-click="selectAll(\'vehicleNameListBox\')"><span class="span-btn-font" translate="bookDownload.selectAll"></span></button> <button type="button" id="deselectAllBtn" class="btn btn-default unified-btn" ng-click="deselectAll(\'vehicleNameListBox\')"><span class="span-btn-font" translate="bookDownload.deselectAll"></span></button></div></div><div class="row" style="padding-bottom: 5px"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 5px;"><label translate="bookDownload.bookName"></label></div><div class="col-xs-5 col-sm-5 col-md-5"><jqx-list-box id="bookListBox" jqx-settings="bookListBoxSettings"></jqx-list-box></div><div class="col-xs-4 col-sm-4 col-md-4"><button type="button" id="slectAllBtn" class="btn btn-default unified-btn" ng-click="selectAll(\'bookListBox\')"><span class="span-btn-font" translate="bookDownload.selectAll"></span></button> <button type="button" id="deselectAllBtn" class="btn btn-default unified-btn" ng-click="deselectAll(\'bookListBox\')"><span class="span-btn-font" translate="bookDownload.deselectAll"></span></button></div></div></div><div class="modal-footer"><button class="btn btn-primary" type="submit" translate="bookDownload.ok" ng-disabled="visibility"></button> <a class="btn btn-warning" ng-click="cancel()" translate="bookDownload.cancel"></a></div></form></div>');
  }]);
})();

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by luo on 03/09/2020.
 */


angular.module('bookManagement', ['adf.provider']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('books', {
    parent: 'betotrack',
    abstract: true,
    url: '/book',
    ncyBreadcrumb: {
      skip: true
    }
  }).state('books.list', {
    url: '/list',
    views: {
      'content@app': {
        controller: 'bookManangementCtrl',
        templateUrl: 'components/track/admin/bookManagementList.tpl.html'
      }
    },
    ncyBreadcrumb: {
      label: 'booksList.moduleName'
    }
  }).state('books.add', {
    url: '/add',
    views: {
      'content@app': {
        controller: 'bookManagementAddEditCtrl',
        templateUrl: 'components/track/admin/bookManagementAddEdit.tpl.html'
      }
    },
    resolve: {
      editorModel: function editorModel() {
        return {
          mode: 'new'
        };
      }
    },
    ncyBreadcrumb: {
      parent: 'books.list',
      label: 'contactNew.new'
    }
  }).state('books.edit', {
    url: '/edit',
    views: {
      'content@app': {
        controller: 'bookManagementAddEditCtrl',
        templateUrl: 'components/track/admin/bookManagementAddEdit.tpl.html'
      }
    },
    resolve: {
      editorModel: function editorModel() {
        return {
          mode: 'edit'
        };
      }
    },

    ncyBreadcrumb: {
      parent: 'books.list',
      label: 'contactNew.edit'
    }
  });
}]).controller('bookManangementCtrl', ["$scope", "$timeout", "$translate", "$uibModal", "commonTrackService", "widgetSettingsCreatorService", "bookManangementService", "$state", function ($scope, $timeout, $translate, $uibModal, commonTrackService, widgetSettingsCreatorService, bookManangementService, $state) {

  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.isDataAvailable = false;
  $scope.isListEmpty = true;
  $scope.bookManagementDetails = {
    selectedFunction: ''
  };
  $scope.dataLoading = true;

  // More functions Start
  var deleteBook = function deleteBook() {
    var modalInstance = $uibModal.open({
      templateUrl: 'components/track/telephone/deleteConfirm.tpl.html',
      controller: 'bookManagementDeleteCtrl',
      resolve: {
        selectedRowData: function selectedRowData() {
          return {};
        }
      }
    });
    modalInstance.result.then(function (result) {
      var gridName = '#' + $scope.overviewGridPrefix + 'booksList';
      if (result === 'success') {
        var rowindex = $(gridName).jqxGrid('getselectedrowindex');
        if (rowindex > -1) {
          var id = $(gridName).jqxGrid('getrowid', rowindex);
          $(gridName).jqxGrid('deleterow', id);
        }

        if ($(gridName).jqxGrid('source').records.length === 0) {
          // list is empty
          $scope.isListEmpty = true;
        } else {
          // select first row in list
          $(gridName).jqxGrid('selectrow', 0);
        }
      } else if (result === 'error') {
        console.log('delete error');
      }
    });
  };

  var downloadFunction = function downloadFunction() {
    $uibModal.open({
      templateUrl: 'components/track/admin/bookDownload.tpl.html',
      controller: 'bookManagementDownloadCtrl'
    });
  };

  $scope.moreFunctionsSource = [{
    name: $translate.instant('moreFunction.functionList.download'),
    operation: 'download',
    disabled: true,
    execute: downloadFunction
  }, {
    name: $translate.instant('moreFunction.functionList.delete'),
    operation: 'delete',
    disabled: true,
    execute: deleteBook
  }];

  $scope.moreFuctionSetting = {
    placeHolder: $translate.instant('moreFunction.button.function'),
    displayMember: 'name',
    valueMember: 'operation',
    source: $scope.moreFunctionsSource,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
    width: '200px',
    height: 30,
    autoDropDownHeight: true
  };

  $scope.moreFunctions = function () {
    for (var index in $scope.moreFunctionsSource) {
      var moreFunctionsItem = $scope.moreFunctionsSource[index];
      if (moreFunctionsItem.operation && moreFunctionsItem.operation === $scope.bookManagementDetails.selectedFunction.operation) {
        moreFunctionsItem.execute();
        $scope.bookManagementDetails.selectedFunction = '';
        break;
      }

      moreFunctionsItem = moreFunctionsItem;
    }
    $('#moreFunDropDown').jqxDropDownList('clearSelection');
  };

  // More functions End

  // BookListGrid start

  $scope.customGridProperties = {
    pagesize: 25,
    height: 600,
    autoheight: false,
    showfilterrow: true,
    filterable: true,
    columns: []
  };

  $scope.bookListRowSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      var selectedRow = event.args.row;
      bookManangementService.setSelectedBook({
        identifier: selectedRow.bookidentifier,
        displayName: selectedRow.bookdisplayname,
        row: selectedRow
      });
    }
  };

  var _tmpColumnProperties = [{
    name: 'displayName', width: '25%',
    type: 'string'
  }];

  $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, { moduleName: 'books' });
  var _additionalProperties = { translatedName: $translate.instant('booksList.moduleName') };
  //$scope.booksListGridSettings = commonTrackService.getGridSettings('booksGrid', $scope.customGridProperties, null, _additionalProperties);

  var getBookList = function getBookList() {
    var booksListSource = {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };

    var requestParam = {
      dataRefresh: true,
      reportOptions: {}
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return bookManangementService.getBookList(param).then(function (bookIndexes) {
      $scope.isDataAvailable = true;

      if (bookIndexes.dataList && bookIndexes.dataList.length > 0) {
        $scope.isListEmpty = false;
      } else {
        $scope.isListEmpty = true;
      }

      if (!$scope.bookListdataAdapter) {
        $scope.customGridProperties.columns = commonTrackService.getColumnProperties(bookIndexes.gridSettings.overviewListGrids[0].columnProperties, bookIndexes.columnTranslation, { moduleName: 'books' });
        $scope.booksListGridSettings = commonTrackService.getGridSettings('books', $scope.customGridProperties, null, _additionalProperties);
        booksListSource.localdata = bookIndexes.dataList;
        $scope.bookListdataAdapter = new $.jqx.dataAdapter(booksListSource);
        $scope.booksListGridSettings.source = $scope.bookListdataAdapter;
      } else {
        booksListSource.localdata = bookIndexes.dataList;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'booksList');
      }
    }, function (errorReponse) {
      if (errorReponse.data && errorReponse.data.message) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      if (!$scope.dataLoadingFinished) {
        $scope.dataLoadingFinished = true;
      }
    });
  };

  $scope.new = function () {
    $state.go('books.add');
  };

  $scope.edit = function () {
    $state.go('books.edit');
  };

  $scope.permissions = {};

  var checkBookPermission = function checkBookPermission() {
    $scope.dataLoading = true;
    return bookManangementService.getBookListAclRight().then(function (permission) {
      $scope.permissions.bookACL = permission;
    }, function () {
      // handle error
      $scope.permissions.bookACL = { aclRightLvel: 0 };
    });
  };

  var checkBookDownPermission = function checkBookDownPermission() {

    return bookManangementService.getBookDownloadAclRight().then(function (permission) {
      $scope.permissions.bookDownloadACL = permission;
    }, function () {
      // handle error
      $scope.permissions.bookDownloadACL = { aclRightLvel: 0 };
    });
  };

  checkBookPermission().then(function () {
    if ($scope.permissions.bookACL && $scope.permissions.bookACL.aclRightLvel > 0) {
      return getBookList().then(function () {
        return checkBookDownPermission();
      }, function () {
        // handle error
        $scope.permissions.bookACL = { aclRightLvel: 0 };
      });
    }
  }).finally(function () {
    $scope.dataLoading = false;
    if ($scope.permissions.bookACL && $scope.permissions.bookACL.aclRightLvel > 0) {
      // enable more options > delete
      $scope.dataLoading = false;
      if ($scope.permissions.bookACL.aclRightLvel === 3) {
        enableDropDown(1);
      } else {
        disableDropDown(1);
      }
      // enable more options > download
      if ($scope.permissions.bookDownloadACL.aclRightLvel === 3 && $scope.permissions.bookACL.aclRightLvel === 3) {
        enableDropDown(0);
      } else {
        disableDropDown(0);
      }
    }
  });

  function enableDropDown(index) {
    $timeout(function () {
      $('#moreFunDropDown').jqxDropDownList('enableAt', index); // this does not working check onece more
    }, 0, false);
  }

  function disableDropDown(index) {
    $timeout(function () {
      $('#moreFunDropDown').jqxDropDownList('disableAt', index); // this does not working check onece more
    }, 0, false);
  }

  // BookListGrid end
}]).controller('bookManagementAddEditCtrl', ["$scope", "$translate", "$state", "editorModel", "bookManangementService", "commonTrackService", "toastService", function ($scope, $translate, $state, editorModel, bookManangementService, commonTrackService, toastService) {
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.bookDetail = {
    identifier: '',
    displayName: ''
  };
  $scope.saveInProgress = false;

  $scope.cancel = function () {
    $state.go('books.list');
  };

  $scope.save = function (isStayOnSave) {
    $scope.saveInProgress = true;
    $scope.saveSuccessful = false;
    var allocations = $scope.bookAllocationListGridSettings.source.records;
    var originalAllocations = $scope.bookAllocationListGridSettings.source.originaldata;
    bookManangementService.saveBook($scope.bookDetail, allocations, originalAllocations).then(function () {
      if (isStayOnSave) {
        $scope.bookDetail = {
          identifier: 'newBook',
          displayName: ''
        };

        // De-allocate all allocations for new book creation.
        // Refetches the list to check for new contacts
        getBookAllocations($scope.bookDetail.identifier);
      }
      $scope.saveSuccessful = true;
      toastService.showSuccessToast($translate.instant('booksList.saveSuccess'));
    }, function (response) {
      console.error('Error saving Book: ', response);
      toastService.showErrorToast({ message: $translate.instant('booksList.saveError'), type: 'F' });
    }).finally(function () {
      $scope.saveInProgress = false;
      if ($scope.saveSuccessful && !isStayOnSave) {
        $scope.cancel();
      }
    });
  };

  $scope.customGridProperties = {
    pagesize: 25,
    height: 600,
    autoheight: false,
    showfilterrow: true,
    filterable: true,
    editable: true,
    columns: []
  };

  var _tmpColumnProperties = [{
    name: 'displayName', width: '25%',
    type: 'string'
  }];

  $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, { moduleName: 'bookAllocations' });
  var _additionalProperties = { translatedName: $translate.instant('booksList.allocationList') };
  //$scope.bookAllocationListGridSettings = commonTrackService.getGridSettings('bookAllocationListGrid', $scope.customGridProperties, null, _additionalProperties);

  $scope.setAllAllocations = function (selected) {
    for (var j = 0; j < $scope.bookAllocationListGridSettings.source.records.length; j++) {
      $scope.bookAllocationListGridSettings.source.records[j].contactassigned = selected;
    }
    $('#' + $scope.overviewGridPrefix + 'bookAllocationsList').jqxGrid('refresh');
  };

  var getBookAllocations = function getBookAllocations(bookID) {

    $scope.bookAllocationListSource = {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };
    bookID = bookID;
    var requestParam = {
      dataRefresh: true,
      reportOptions: {},
      //reportOptions: {'test' : bookID},
      reportOption: bookID
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return bookManangementService.getBookAllocationsForSelectedBook(param).then(function (allocations) {
      $scope.isDataAvailable = true;

      $scope.customGridProperties.columns = commonTrackService.getColumnProperties(allocations.gridSettings.overviewListGrids[0].columnProperties, allocations.columnTranslation, { moduleName: 'bookAllocations' });
      $scope.bookAllocationListGridSettings = commonTrackService.getGridSettings('bookAllocations', $scope.customGridProperties, null, _additionalProperties);
      $scope.bookAllocationListSource.localdata = allocations.dataList;
      if (!$scope.bookAllocationListdataAdapter) {
        $scope.bookAllocationListGridSettings.pagesize = 15;
      }
      $scope.bookAllocationListdataAdapter = new $.jqx.dataAdapter($scope.bookAllocationListSource);
      $scope.bookAllocationListGridSettings.source = $scope.bookAllocationListdataAdapter;
    }, function (errorReponse) {
      console.error(errorReponse);
      if (errorReponse.data && errorReponse.data.message) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      if (!$scope.dataLoadingFinished) {
        $scope.dataLoadingFinished = true;
      }
    });
  };

  if (editorModel.mode === 'new') {
    $scope.bookDetail = {
      identifier: 'newBook',
      displayName: ''
    };
  } else {
    $scope.bookDetail = bookManangementService.getSelectedBook();
  }

  $scope.permissions = {};

  var checkBookPermission = function checkBookPermission() {
    return bookManangementService.getBookListAclRight().then(function (permission) {
      $scope.permissions.bookACL = permission;
    });
  };

  var checkContactsPermission = function checkContactsPermission() {
    return bookManangementService.getContactAclRight().then(function (permission) {
      $scope.permissions.contactsACL = permission;
    });
  };

  checkBookPermission().then(function () {
    return checkContactsPermission();
  }).then(function () {
    if ($scope.permissions.contactsACL.aclRightLvel === 0) {
      // dont get allocation list
      return;
    }
    return getBookAllocations($scope.bookDetail.identifier);
  });
}]).controller('bookManagementDownloadCtrl', ["$scope", "commonTrackService", "widgetSettingsCreatorService", "$uibModalInstance", "bookManangementService", "$timeout", "$translate", "errorHandlingService", "toastService", function ($scope, commonTrackService, widgetSettingsCreatorService, $uibModalInstance, bookManangementService, $timeout, $translate, errorHandlingService, toastService) {
  $scope.visibility = true;

  $scope.vehicleGroupComboBoxSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID',
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
    selectedIndex: 0,
    change: function change(event) {
      var args = event.args;
      var vehicleGroupItem = $('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');
      if (args && vehicleGroupItem) {
        var groupId = vehicleGroupItem.value;
        loadVehicle(groupId);
      }
    }
  });

  var loadVehicle = function loadVehicle(groupId) {
    return commonTrackService.getVehicleListFilterByGroupId(groupId).then(function (vehicleList) {
      $scope.vehicleNameListBoxSettings.source = _.uniq(vehicleList, 'deviceID');
    });
  };

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vehicleGroupList) {
      $scope.vehicleGroupComboBoxSettings.source = vehicleGroupList;
    });
  };

  var loadBookList = function loadBookList() {
    var requestParam = {
      dataRefresh: false,
      reportOptions: {}
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return bookManangementService.getBookList(param).then(function (data) {
      $scope.bookListBoxSettings.source = data.dataList;
    });
  };

  $timeout(function () {
    $('#vehicleNameListBox').on('checkChange', function (event) {
      var item = event.args;
      if (item) {
        if (item.checked) {
          $timeout(function () {
            $scope.visibility = false;
          });
        } else {
          var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
          if (checkedItems.length === 0) {
            $timeout(function () {
              $scope.visibility = true;
            });
          } else {
            $scope.visibility = false;
          }
        }
      }
    });
  }, 0, false);

  $scope.vehicleNameListBoxSettings = {
    displayMember: 'description',
    valueMember: 'deviceID',
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
    checkboxes: true
  };

  $scope.bookListBoxSettings = {
    displayMember: 'bookdisplayname',
    valueMember: 'bookidentifier',
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
    checkboxes: true
  };

  loadBookList();

  loadVehicleGroup().then(function () {
    var vehicleGroupSource = $scope.vehicleGroupComboBoxSettings.source;
    if (vehicleGroupSource !== null && vehicleGroupSource !== undefined) {
      loadVehicle(vehicleGroupSource[0].groupID);
    }
  }).finally(function () {
    $scope.dataLoadingFinished = true;
  });

  $scope.selectAll = function (id) {
    $('#' + id).jqxListBox('checkAll');
  };

  $scope.deselectAll = function (id) {
    $('#' + id).jqxListBox('uncheckAll');
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.save = function () {
    var downloadParams = {
      deviceIds: [],
      bookIds: [],
      commandType: 'config',
      commandID: 'TEL',
      sendState: 0
    };
    var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
    var deviceIds = [];
    for (var i = 0; i < checkedItems.length; i++) {
      var item = checkedItems[i];
      deviceIds.push(item.value);
    }
    downloadParams.deviceIds = deviceIds;
    var checkedBookItems = $('#bookListBox').jqxListBox('getCheckedItems');
    var bookIds = [];
    for (var j = 0; j < checkedBookItems.length; j++) {
      var bookitem = checkedBookItems[j];
      bookIds.push(bookitem.value);
    }
    downloadParams.bookIds = bookIds;
    bookManangementService.downloadRequest(downloadParams).then(function () {
      $uibModalInstance.close();
      toastService.showSuccessToast($translate.instant('download.success'));
    }, function (response) {
      $uibModalInstance.close();
      errorHandlingService.handleForCommonResponse(response);
    });
  };
}]).controller('bookManagementDeleteCtrl', ["$scope", "$uibModalInstance", "$state", "errorHandlingService", "bookManangementService", function ($scope, $uibModalInstance, $state, errorHandlingService, bookManangementService) {
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.onKeyPress = function ($event) {
    if ($event.keyCode === 13) {
      $scope.delete();
    }
  };

  $scope.delete = function () {
    var bookDetail = bookManangementService.getSelectedBook();
    bookManangementService.deleteBook(bookDetail.identifier).then(function () {
      $uibModalInstance.close('success');
      $state.go('books.list');
    }, function (response) {
      $uibModalInstance.close('error');
      errorHandlingService.handleForCommonResponse(response);
    });
  };
}]).service('bookManangementService', ["crudService", function (crudService) {
  var model = 'admin';

  this.selectedBook = {};

  this.setSelectedBook = function (bookDetails) {
    this.selectedBook = bookDetails;
  };

  this.getSelectedBook = function () {
    return this.selectedBook;
  };

  this.getBookAllocationsForSelectedBook = function (param) {
    return crudService.customGET(model, 'bookallocations', param);
  };

  this.getBookList = function (param) {
    return crudService.customGET(model, 'booklist', param);
  };

  this.saveBook = function (bookDetails, allocations, originalAllocations) {

    var allocationsToAdd = [];
    var allocationsToDelete = [];
    for (var i = 0; i < allocations.length; i++) {
      var allo = allocations[i];
      var oldAllo = originalAllocations[i];
      var newAllo = {
        bookidentifier: allo.bookidentifier,
        contactidentifier: allo.contactidentifier
      };

      if (allo.contactassigned !== oldAllo.contactassigned) {
        if (allo.contactassigned) {
          allocationsToAdd.push(newAllo);
        } else {
          allocationsToDelete.push(newAllo);
        }
      }
    }

    var bookPostObj = {
      bookDetails: {
        bookidentifier: bookDetails.identifier,
        bookdisplayname: bookDetails.displayName
      },
      newAllocaitons: allocationsToAdd,
      removedAllocaitons: allocationsToDelete
    };
    return crudService.post(model + '/book', bookPostObj);
  };

  this.downloadRequest = function (param) {
    return crudService.post('pendingcommands', param);
  };

  this.deleteBook = function (bookIdentifier) {
    return crudService.delete(model + '/book?key=' + encodeURIComponent(bookIdentifier));
  };

  this.getBookListAclRight = function () {
    return crudService.get(model + '/booklistaclright');
  };

  this.getBookDownloadAclRight = function () {
    return crudService.get(model + '/pendingcmndaclright');
  };

  this.getContactAclRight = function () {
    return crudService.get(model + '/contactsaclright');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/admin/bookManagementAddEdit.tpl.html', '<form class="col-xs-12 col-sm-12 col-md-12 editForm" name="contactForm" novalidate="" confirm-on-exit=""><div class="col-xs-12 col-sm-12 col-md-12 customer-header" style="padding: 2.5px"><div ncy-breadcrumb="" style="margin: 0px;padding-left: 0px;font-size: 24px;"></div><div class="row" style="margin: 0"><div class="col-xs-8 col-sm-8 col-md-4"><button type="button" class="btn btn-default unified-btn" ng-disabled="saveInProgress || permissions.bookACL.aclRightLvel < 2" ng-click="save(false)"><span class="glyphicon glyphicon-save"></span><span class="span-btn-font" translate="contactNew.save"></span></button> <button type="button" class="btn btn-default unified-btn" ng-disabled="saveInProgress || permissions.bookACL.aclRightLvel !==3" ng-click="save(true)"><span class="glyphicon glyphicon-check"></span><span class="span-btn-font" translate="contactNew.saveNew"></span></button> <button type="button" class="btn btn-default unified-btn" ng-click="cancel()"><span class="glyphicon glyphicon-arrow-left"></span><span class="span-btn-font" translate="contactNew.cancel"></span></button></div></div></div><div class="form-group-dsa"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 2.5px;"><label style="padding-left: 15px" translate="contactNew.firstName"></label></div><div class="col-xs-4 col-sm-4 col-md-4" style="padding: 2.5px;"><input type="text" name="{{\'contactNew.name\' | translate}}" class="form-control required" ng-model="bookDetail.displayName" upper-case="" ng-disabled="permissions.bookACL.aclRightLvel < 2" maxlength="50" required=""></div></div></div></div><div class="form-group-dsa"><div class="row" style="margin: 0; float: right; margin-bottom: 2px;" ng-if="isDataAvailable && permissions.contactsACL.aclRightLvel !== 0"><button type="button" class="btn btn-default unified-btn" ng-click="setAllAllocations(true)"><span class="glyphicon"></span><span class="span-btn-font">Assign All</span></button> <button type="button" class="btn btn-default unified-btn" ng-click="setAllAllocations(false)"><span class="glyphicon"></span><span class="span-btn-font">Unassign All</span></button></div><div class="row" style="margin: 0" ng-if="isDataAvailable && permissions.contactsACL.aclRightLvel !== 0"><div jqx-delete-directive="{{overviewGridPrefix}}bookAllocationList" type="grid"><jqx-grid id="{{overviewGridPrefix}}bookAllocationsList" jqx-settings="bookAllocationListGridSettings" jqx-create="dataLoadingFinished"></jqx-grid></div></div></div><div ng-if="permissions.contactsACL.aclRightLvel === 0 || !isDataAvailable"><no-authorize></no-authorize></div></form>');
  }]);
})();

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/admin/bookManagementList.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12" style="padding: 0px;"><div class="row" id="breadcrump"><div class="col-xs-12 col-sm-12 col-md-12 customer-header"><div ncy-breadcrumb="" style="margin-bottom: 5px;margin-top: 0px;font-size: 24px;"></div><div class="col-xs-4 col-sm-4 col-md-4"><div class="row"><button type="button" ng-disabled="permissions.bookACL.aclRightLvel === 0 || isListEmpty" class="btn btn-default unified-btn" ng-click="edit()"><span class="glyphicon glyphicon-edit" ng-if="permissions.bookACL.aclRightLvel > 1"></span> <span class="span-btn-font" translate="contactNew.edit" ng-if="permissions.bookACL.aclRightLvel > 1"></span> <span class="glyphicon glyphicon-eye-open" ng-if="permissions.bookACL.aclRightLvel === 1"></span> <span class="span-btn-font" translate="contactNew.view" ng-if="permissions.bookACL.aclRightLvel === 1"></span></button> <button type="button" ng-disabled="permissions.bookACL.aclRightLvel !==3" class="btn btn-default unified-btn" ng-click="new()"><span class="glyphicon glyphicon-plus"></span> <span class="span-btn-font" translate="contactNew.new"></span></button></div></div><div class="col-xs-5 col-sm-5 col-md-5" style="display:inline-flex;;padding: 0px"><div jqx-delete-directive="moreFunDropDown" type="dropDownList" ng-if="isDataAvailable"><jqx-drop-down-list id="moreFunDropDown" ng-model="bookManagementDetails.selectedFunction" jqx-ng-model="" jqx-settings="moreFuctionSetting" ng-change="moreFunctions()" ignore-dirty=""></jqx-drop-down-list></div></div></div></div></div></div><div class="row" style="margin: 0" ng-if="isDataAvailable && permissions.bookACL.aclRightLvel !== 0"><div jqx-delete-directive="{{overviewGridPrefix}}booksList" type="grid"><jqx-grid id="{{overviewGridPrefix}}booksList" jqx-settings="booksListGridSettings" jqx-on-rowselect="bookListRowSelectHandler(event)" jqx-create="dataLoadingFinished"></jqx-grid></div></div><div ng-if="dataLoading"><loading-animation></loading-animation></div><div ng-if="!dataLoading && permissions.bookACL.aclRightLvel === 0"><no-authorize></no-authorize></div></div>');
  }]);
})();

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/admin/contactFileImport.tpl.html', '<div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title" translate="contactsList.importDiagTitle"></h3></div><div class="modal-body"><div><input onchange="angular.element(this).scope().fileChanged(this)" id="importFileBrowserBtn" type="file" accept="text/plain" ng-disabled="isFileinputDisabled"></div><div style="padding: 15px;"></div><div><div><div id="contact-import-check" translate="contactsList.importIntoBook"></div></div><div ng-if="importIntoBook" style="padding: 5px;"><label translate="contactsList.importBookName"></label> <input id="import-bookName" type="text" class="form-control" name="import-bookName" ng-model="importBookName"></div><div ng-if="!isValid"><label ng-bind="invalidDataErrorMessage" class="dsa-validation-error"></label></div></div></div><div style="padding: 15px;"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="import()" translate="contactsList.importBtn" ng-disabled="isImportBtnDisabled"></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="close()" translate="deleteConfirm.cancel_button"></button></div></div>');
  }]);
})();

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by luo on 03/09/2020.
 */


angular.module('contact', ['adf.provider', 'ui.router']).config(["$stateProvider", function ($stateProvider) {

  $stateProvider.state('contacts', {
    parent: 'betotrack',
    abstract: true,
    url: '/contact',
    ncyBreadcrumb: {
      skip: true
    }
  }).state('contacts.list', {
    url: '/list',
    views: {
      'content@app': {
        controller: 'contactsManagementCtrl',
        templateUrl: 'components/track/admin/contactManagement.tpl.html'
      }
    },
    ncyBreadcrumb: {
      label: 'contactsList.moduleName'
    }
  }).state('contacts.add', {
    url: '/add',
    views: {
      'content@app': {
        controller: 'contactsManagementAddEditCtrl',
        templateUrl: 'components/track/admin/contactManagementAddEdit.tpl.html'
      }
    },
    resolve: {
      editorModel: function editorModel() {
        return {
          mode: 'new'
        };
      }
    },
    ncyBreadcrumb: {
      parent: 'contacts.list',
      label: 'contactNew.new'
    }
  }).state('contacts.edit', {
    url: '/edit',
    views: {
      'content@app': {
        controller: 'contactsManagementAddEditCtrl',
        templateUrl: 'components/track/admin/contactManagementAddEdit.tpl.html'
      }
    },
    resolve: {
      editorModel: function editorModel() {
        return {
          mode: 'edit'
        };
      }
    },

    ncyBreadcrumb: {
      parent: 'contacts.list',
      label: 'contactNew.edit'
    }
  });
}]).controller('contactsManagementAddEditCtrl', ["$state", "$scope", "editorModel", "contactMgmtService", "toastService", "$translate", function ($state, $scope, editorModel, contactMgmtService, toastService, $translate) {

  $scope.contactDetail = {
    identifier: '',
    displayName: '',
    tellandline: '',
    telmobile: ''
  };

  $scope.saveInProgress = false;

  $scope.cancel = function () {
    $state.go('contacts.list');
  };

  $scope.save = function (isStayOnSave) {
    $scope.saveInProgress = true;
    $scope.saveSuccessful = false;
    contactMgmtService.saveContact($scope.contactDetail).then(function () {
      if (isStayOnSave) {
        $scope.contactDetail = {
          identifier: '',
          displayName: '',
          tellandline: '',
          telmobile: ''
        };
      }
      $scope.saveSuccessful = true;
      toastService.showSuccessToast($translate.instant('contactsList.saveSuccess'));
    }, function (response) {
      console.error('Error saving Contact: ', response);
      toastService.showErrorToast({ message: $translate.instant('contactsList.saveError'), type: 'F' });
    }).finally(function () {
      $scope.saveInProgress = false;
      if ($scope.saveSuccessful && !isStayOnSave) {
        $state.go('contacts.list');
      }
    });
  };

  if (editorModel.mode === 'new') {
    $scope.contactDetail = {
      identifier: '',
      displayName: '',
      tellandline: '',
      telmobile: ''
    };
  } else {
    $scope.contactDetail = contactMgmtService.getSelectedContact();
  }

  $scope.permissions = {};

  var checkContactsPermission = function checkContactsPermission() {
    return contactMgmtService.getContactAclRight().then(function (permission) {
      $scope.permissions.contactsACL = permission;
    });
  };

  checkContactsPermission();
}]).controller('contactsManagementCtrl', ["$scope", "$timeout", "toastService", "$state", "$window", "commonTrackService", "contactMgmtService", "$uibModal", "widgetSettingsCreatorService", "$translate", function ($scope, $timeout, toastService, $state, $window, commonTrackService, contactMgmtService, $uibModal, widgetSettingsCreatorService, $translate) {
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.isDataAvailable = false;
  $scope.dataLoading = true;
  $scope.contactsManagementDetails = {
    selectedFunction: ''
  };

  var deleteContact = function deleteContact() {
    var modalInstance = $uibModal.open({
      templateUrl: 'components/track/telephone/deleteConfirm.tpl.html',
      controller: 'contactsDeleteCtrl',
      resolve: {
        selectedRowData: function selectedRowData() {
          return {};
        }
      }
    });

    modalInstance.result.then(function (result) {
      if (result === 'success') {
        var rowindex = $('#' + $scope.overviewGridPrefix + 'contactsList').jqxGrid('getselectedrowindex');
        if (rowindex > -1) {
          var id = $('#' + $scope.overviewGridPrefix + 'contactsList').jqxGrid('getrowid', rowindex);
          $('#' + $scope.overviewGridPrefix + 'contactsList').jqxGrid('deleterow', id);
        }
      } else if (result === 'error') {
        console.error('delete error');
      }
    });
  };

  var importFunction = function importFunction() {
    var modalInstance = $uibModal.open({
      templateUrl: 'components/track/admin/contactFileImport.tpl.html',
      controller: 'contactImportDilaogCtrl'
    });

    modalInstance.result.then(function (result) {
      toastService.showSuccessToast(result);
      $timeout(function () {
        $window.location.reload();
      }, 400);
    });
  };

  var showPositioningFunction = function showPositioningFunction() {
    $scope.showPositionOptions = true;
    disableDropDown(2);
  };

  $scope.savePositioning = function () {

    var positionData = [];

    for (var i = 0; i < $scope.contactsListSource.localdata.length; i++) {
      var contact = $scope.contactsListSource.localdata[i];
      positionData.push({
        contactidentifier: contact.contactidentifier,
        position: i
      });
    }
    contactMgmtService.savePositions(positionData).then(function () {
      $scope.showPositionOptions = false;
      enableDropDown(2);
      toastService.showSuccessToast($translate.instant('contactsList.saveSuccess'));
      //reload contacts (retrieve the new positions from the db)..
      getContactList();
    }, function (response) {
      console.error('Error saving Positions: ', response);
      toastService.showErrorToast({ message: $translate.instant('contactsList.saveError'), type: 'F' });
    });
  };

  $scope.cancelPositioning = function () {

    $scope.showPositionOptions = false;
    // reload contacts (fetch new ones if any and refresh positions)
    enableDropDown(2);
    getContactList();
    var gridName = '#' + $scope.overviewGridPrefix + 'contactsList';
    $(gridName).jqxGrid({ selectedrowindex: 0 });
  };

  $scope.showPositionOptions = false;

  $scope.moreFunctionsSource = [{
    name: $translate.instant('moreFunction.functionList.delete'),
    operation: 'delete',
    disabled: true,
    execute: deleteContact
  }, {
    name: $translate.instant('moreFunction.functionList.fileImport'),
    operation: 'import',
    disabled: true,
    execute: importFunction
  }, {
    name: $translate.instant('moreFunction.functionList.contactPosition'), //'Show Positioning Options',//$translate.instant('moreFunction.functionList.fileImport'),
    operation: 'positionShow',
    disabled: false,
    execute: showPositioningFunction
  }];

  $scope.moreFuctionSetting = {
    placeHolder: $translate.instant('moreFunction.button.function'),
    displayMember: 'name',
    valueMember: 'operation',
    source: $scope.moreFunctionsSource,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
    width: '200px',
    height: 30,
    autoDropDownHeight: true
  };

  $scope.moreFunctions = function () {
    for (var index in $scope.moreFunctionsSource) {
      var moreFunctionsItem = $scope.moreFunctionsSource[index];
      if (moreFunctionsItem.operation && moreFunctionsItem.operation === $scope.contactsManagementDetails.selectedFunction.operation) {
        moreFunctionsItem.execute();
        $scope.contactsManagementDetails.selectedFunction = '';
        break;
      }

      moreFunctionsItem = moreFunctionsItem;
    }
    $('#moreFunDropDown').jqxDropDownList('clearSelection');
  };

  var _tmpColumnProperties = [{
    name: 'name', width: '25%',
    type: 'string'
  }, {
    name: 'landline', width: '25%',
    type: 'string'
  }, {
    name: 'mobile', width: '25%',
    type: 'string'
  }];

  $scope.customGridProperties = {
    pagesize: 25,
    height: 600,
    autoheight: false,
    showfilterrow: true,
    filterable: true,
    columns: []
  };

  $scope.contactListRowSelectHandler = function (event) {
    if (event.type === 'rowselect' && event.args.row) {
      var selectedRow = event.args.row;
      var obj = {
        identifier: selectedRow.contactidentifier,
        displayName: selectedRow.contactdisplayname,
        tellandline: selectedRow.tellandline,
        telmobile: selectedRow.telmobile,
        position: selectedRow.position,
        row: selectedRow
      };
      contactMgmtService.setSelectedContact(obj);
    }
  };

  $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, { moduleName: 'contacts' });
  var _additionalProperties = { translatedName: $translate.instant('contactsList.moduleName') };

  $scope.contactsListGridSettings = {};
  $scope.contactsListSource = {
    datatype: 'array',
    datafields: [],
    localdata: [],
    sort: null
  };

  $scope.swapRowPosition = function (isUp) {
    var gridName = '#' + $scope.overviewGridPrefix + 'contactsList';
    var selectedIndex = $(gridName).jqxGrid('getselectedrowindex');
    var tempRow = $scope.contactsListGridSettings.source.records[selectedIndex];
    var rowIndex = selectedIndex;
    if (selectedIndex > -1) {
      if (isUp && selectedIndex > 0) {
        //console.log('Moving Row Up');
        $scope.contactsListSource.localdata[selectedIndex] = $scope.contactsListSource.localdata[selectedIndex - 1];
        $scope.contactsListSource.localdata[selectedIndex - 1] = tempRow;
        rowIndex = selectedIndex - 1;
      } else if (!isUp && selectedIndex < $scope.contactsListGridSettings.source.records.length - 1) {
        //console.log('Moving Row Down');
        $scope.contactsListSource.localdata[selectedIndex] = $scope.contactsListSource.localdata[selectedIndex + 1];
        $scope.contactsListSource.localdata[selectedIndex + 1] = tempRow;
        rowIndex = selectedIndex + 1;
      }
      $scope.contactsListdataAdapter = new $.jqx.dataAdapter($scope.contactsListSource, {
        autoBind: true
      });
      $scope.contactsListGridSettings.source = $scope.contactsListdataAdapter;
      $(gridName).jqxGrid('updatebounddata');
      $(gridName).jqxGrid({ selectedrowindex: rowIndex });
      $(gridName).jqxGrid('gotopage', Math.floor(rowIndex / $(gridName).jqxGrid('getpaginginformation').pagesize));
    }
  };

  //contactsListGridSettings
  var getContactList = function getContactList() {
    var requestParam = {
      statusCode: 'all',
      vehicleGroup: null,
      dataRefresh: true,
      reportOptions: {}
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };

    $scope.dataLoading = true;

    return contactMgmtService.getContactList(param).then(function (contactIndexes) {
      $scope.isDataAvailable = true;
      if (!$scope.contactsListdataAdapter) {
        $scope.customGridProperties.columns = commonTrackService.getColumnProperties(contactIndexes.gridSettings.overviewListGrids[0].columnProperties, contactIndexes.columnTranslation, { moduleName: 'contacts' });
        $scope.contactsListGridSettings = commonTrackService.getGridSettings('contacts', $scope.customGridProperties, null, _additionalProperties);
        $scope.contactsListSource.localdata = contactIndexes.dataList;
        $scope.contactsListdataAdapter = new $.jqx.dataAdapter($scope.contactsListSource, {
          autoBind: true
        });
        $scope.contactsListGridSettings.source = $scope.contactsListdataAdapter;
        $scope.contactsListGridSettings.pagesize = 15;
      } else {
        $scope.contactsListSource.localdata = contactIndexes.dataList;
        commonTrackService.updateBoundData($scope.overviewGridPrefix + 'contactsList');
      }
    }, function (response) {
      if (response.data && response.data.message) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      if (!$scope.dataLoadingFinished) {
        $scope.dataLoadingFinished = true;
      }
      $scope.dataLoading = false;
    });
  };

  $scope.new = function () {
    $state.go('contacts.add');
  };

  $scope.edit = function () {
    $state.go('contacts.edit');
  };

  $scope.permissions = {};

  var checkContactsPermission = function checkContactsPermission() {
    return contactMgmtService.getContactAclRight().then(function (permission) {
      $scope.permissions.contactsACL = permission;
    });
  };

  function enableDropDown(index) {
    $timeout(function () {
      $scope.moreFunctionsSource[index].disabled = false;
    }, 0, false);
  }

  function disableDropDown(index) {
    $timeout(function () {
      $scope.moreFunctionsSource[index].disabled = true;
    }, 0, false);
  }

  checkContactsPermission().then(function () {
    if ($scope.permissions.contactsACL.aclRightLvel === 0) {
      return;
    }
    return getContactList();
  }).finally(function () {
    $scope.dataLoading = false;
    if ($scope.permissions.contactsACL && $scope.permissions.contactsACL.aclRightLvel > 0) {
      if (Number($scope.permissions.contactsACL.aclRightLvel) === 3) {
        // enable delete
        enableDropDown(0);
        // enable import
        enableDropDown(1);
      } else {
        // disable delete
        disableDropDown(0);
        // disable import
        disableDropDown(1);
      }
    }
  });

  $scope.$on('$destroy', function () {
    delete $scope.contactsListGridSettings.source;
  });
}]).controller('contactsDeleteCtrl', ["$scope", "$uibModalInstance", "$state", "errorHandlingService", "contactMgmtService", function ($scope, $uibModalInstance, $state, errorHandlingService, contactMgmtService) {
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.onKeyPress = function ($event) {
    if ($event.keyCode === 13) {
      $scope.delete();
    }
  };

  $scope.delete = function () {
    var contactDetail = contactMgmtService.getSelectedContact();
    contactMgmtService.deleteContact(contactDetail.identifier).then(function () {
      $uibModalInstance.close('success');
      $state.go('contacts.list');
    }, function (response) {
      $uibModalInstance.close('error');
      errorHandlingService.handleForCommonResponse(response);
    });
  };
}]).controller('contactImportDilaogCtrl', ["$scope", "widgetSettingsCreatorService", "bookManangementService", "$timeout", "$uibModalInstance", "$translate", "contactMgmtService", "toastService", function ($scope, widgetSettingsCreatorService, bookManangementService, $timeout, $uibModalInstance, $translate, contactMgmtService, toastService) {
  $scope.isImportBtnDisabled = true;
  $scope.isImportBtnDisabled = true;
  $scope.importIntoBook = false;
  $scope.importBookName = '';
  $scope.bookList = [];
  $scope.isValid = true;

  $scope.fileChanged = function (element) {
    $scope.isFileinputDisabled = true;
    var file = element.files[0];
    var reader = new FileReader();
    $scope.isImportBtnDisabled = true;

    reader.onloadend = function (e) {
      //callback after files finish loading
      $scope.encodedData = e.target.result;
      $scope.isImportBtnDisabled = false;
      $scope.$apply();
      $scope.encodedData = $scope.encodedData.replace(/^data:text\/plain;base64,/, '');
      $scope.isFileinputDisabled = false;
      //here you can send data over your server as desired
    };
    reader.readAsDataURL(file);
  };

  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.getBookList = function () {

    var requestParam = {
      dataRefresh: true,
      reportOptions: {}
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return bookManangementService.getBookList(param).then(function (bookIndexes) {
      var _booklist = [];
      for (var x = 0; x < bookIndexes.dataList.length; x++) {
        _booklist.push(bookIndexes.dataList[x].bookdisplayname);
      }
      $scope.bookList = _booklist;
      console.log($scope.bookList);
    });
  };

  $scope.import = function () {

    $scope.isValid = true;
    $scope.importBookName = $('#import-bookName').val();
    $scope.invalidDataErrorMessage = '';
    if ($scope.importIntoBook) {
      if ($scope.importBookName === '') {
        $scope.isValid = false;
        $scope.invalidDataErrorMessage = $translate.instant('contactsList.importErrorBookBlank');
      } else {
        for (var x = 0; x < $scope.bookList.length; x++) {
          if ($scope.importBookName === $scope.bookList[x]) {
            $scope.isValid = false;

            $scope.invalidDataErrorMessage = $translate.instant('contactsList.importErrorBookDuplicate');
            break;
          }
        }
      }
    }

    if ($scope.isValid) {
      if ($scope.encodedData) {
        contactMgmtService.importContacts($scope.encodedData, $scope.importIntoBook, $scope.importBookName).then(function () {
          $uibModalInstance.close($translate.instant('telephonesList.telephoneImport.successAlert'));
        }, function (response) {
          var _messsage = response.data && response.data.errors && response.data.errors[0].code ? $translate.instant('errorCodes.restAPI.' + response.data.errors[0].code + '.message') : response.data.message;
          var errorAlert = { type: 'F', message: _messsage };
          toastService.showErrorToast(errorAlert);
        });
      }
    } else {
      console.error($scope.invalidDataErrorMessage);
      $timeout(function () {
        $scope.$digest();
      });
    }
  };

  $scope.getBookList();

  $timeout(function () {
    $('#contact-import-check').jqxCheckBox({ theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme });
    $('#contact-import-check').bind('change', function (event) {
      $scope.importIntoBook = event.args.checked;
      $scope.$digest();
    });
  });
}]).service('contactMgmtService', ["crudService", function (crudService) {
  var model = 'admin';

  this.getContactList = function (param) {
    return crudService.customGET(model, 'contactlist', param);
  };

  this.selectedContact = {
    identifier: '',
    displayName: '',
    tellandline: '',
    telmobile: ''
  };

  this.getSelectedContact = function () {
    return this.selectedContact;
  };

  this.setSelectedContact = function (contactDetails) {
    this.selectedContact = contactDetails;
  };

  this.saveContact = function (contactDetails) {
    // filter out unneeded data from contact Details object
    var postObj = {
      contactidentifier: contactDetails.identifier,
      contactdisplayname: contactDetails.displayName,
      tellandline: contactDetails.tellandline ? contactDetails.tellandline : '',
      telmobile: contactDetails.telmobile ? contactDetails.telmobile : '',
      position: contactDetails.position
    };
    return crudService.post(model + '/contact', postObj);
  };

  this.savePositions = function (contactPositions) {
    return crudService.post(model + '/contactpositions', contactPositions);
  };

  this.deleteContact = function (contactIdentifier) {
    return crudService.delete(model + '/contact?key=' + encodeURIComponent(contactIdentifier));
  };

  this.importContacts = function (encodedFileString, bookImport, bookName) {

    if (bookImport) {
      return crudService.post(model + '/contact/import?bookImport=' + bookImport + '&bookName=' + bookName, encodedFileString);
    } else {
      return crudService.post(model + '/contact/import', encodedFileString);
    }
  };

  this.getContactAclRight = function () {
    return crudService.get(model + '/contactsaclright');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/admin/contactManagement.tpl.html', '<shortcut></shortcut><div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12" style="padding: 0px;"><div class="row" id="breadcrump"><div class="col-xs-12 col-sm-12 col-md-12 customer-header" style=""><div ncy-breadcrumb="" style="margin-bottom: 5px;margin-top: 0px;font-size: 24px;"></div><div class="col-xs-4 col-sm-4 col-md-4"><div class="row"><button type="button" class="btn btn-default unified-btn" ng-disabled="permissions.contactsACL.aclRightLvel < 2" ng-click="edit()"><span class="glyphicon glyphicon-edit"></span> <span class="span-btn-font" translate="contactNew.edit"></span></button> <button type="button" class="btn btn-default unified-btn" ng-disabled="permissions.contactsACL.aclRightLvel !== 3" ng-click="new()"><span class="glyphicon glyphicon-plus"></span> <span class="span-btn-font" translate="contactNew.new"></span></button></div></div><div class="col-xs-6 col-sm-6 col-md-6" style="display:inline-flex;;padding: 0px"><div jqx-delete-directive="moreFunDropDown" type="dropDownList" ng-if="isDataAvailable"><jqx-drop-down-list id="moreFunDropDown" ng-model="contactsManagementDetails.selectedFunction" jqx-ng-model="" jqx-settings="moreFuctionSetting" ng-change="moreFunctions()" ignore-dirty=""></jqx-drop-down-list></div></div><div class="col-xs-12 col-sm-12 col-md-12"><div class="row" ng-if="showPositionOptions"><button type="button" class="btn btn-default unified-btn" ng-click="swapRowPosition(true)"><span class="glyphicon glyphicon-chevron-up"></span> <span class="span-btn-font" translate="contactNew.posUp"></span></button> <button type="button" class="btn btn-default unified-btn" ng-click="swapRowPosition(false)"><span class="glyphicon glyphicon-chevron-down"></span> <span class="span-btn-font" translate="contactNew.posDown"></span></button> <button type="button" class="btn btn-default unified-btn" ng-click="savePositioning()"><span class="glyphicon glyphicon-save"></span> <span class="span-btn-font" translate="contactNew.posSave"></span></button> <button type="button" class="btn btn-default unified-btn" ng-click="cancelPositioning()"><span class="glyphicon glyphicon-remove"></span> <span class="span-btn-font" translate="contactNew.posCancel"></span></button></div></div></div></div></div></div><div class="row" style="margin: 0" ng-if="isDataAvailable && permissions.contactsACL.aclRightLvel !== 0"><div jqx-delete-directive="{{overviewGridPrefix}}contactsList" type="grid"><jqx-grid id="{{overviewGridPrefix}}contactsList" jqx-settings="contactsListGridSettings" jqx-on-rowselect="contactListRowSelectHandler(event)" jqx-create="dataLoadingFinished"></jqx-grid></div></div><div ng-if="dataLoading"><loading-animation></loading-animation></div><div ng-if="(permissions.contactsACL.aclRightLvel === 0 || !isDataAvailable) && !dataLoading"><no-authorize></no-authorize></div></div>');
  }]);
})();

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/admin/contactManagementAddEdit.tpl.html', '<form class="col-xs-12 col-sm-12 col-md-12 editForm" name="contactForm" novalidate="" confirm-on-exit=""><div class="col-xs-12 col-sm-12 col-md-12 customer-header" style="padding: 2.5px"><div ncy-breadcrumb="" style="margin: 0px;padding-left: 0px;font-size: 24px;"></div><div class="row" style="margin: 0"><div class="col-xs-8 col-sm-8 col-md-4"><button type="button" class="btn btn-default unified-btn" ng-disabled="saveInProgress || permissions.contactsACL.aclRightLvel < 2" ng-click="save(false)"><span class="glyphicon glyphicon-save"></span><span class="span-btn-font" translate="contactNew.save"></span></button> <button type="button" class="btn btn-default unified-btn" ng-disabled="saveInProgress || permissions.contactsACL.aclRightLvel !== 3" ng-click="save(true)"><span class="glyphicon glyphicon-check"></span><span class="span-btn-font" translate="contactNew.saveNew"></span></button> <button type="button" class="btn btn-default unified-btn" ng-click="cancel()"><span class="glyphicon glyphicon-arrow-left"></span><span class="span-btn-font" translate="contactNew.cancel"></span></button></div></div></div><div class="form-group-dsa"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 2.5px;"><label style="padding-left: 15px" translate="contactNew.firstName"></label></div><div class="col-xs-4 col-sm-4 col-md-4" style="padding: 2.5px;"><input type="text" name="{{\'contactNew.name\' | translate}}" class="form-control required" ng-model="contactDetail.displayName" upper-case="" ng-disabled="permissions.contactsACL.aclRightLvel < 2" maxlength="50" required=""></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 2.5px;"><label style="padding-left: 15px" translate="contactNew.landline"></label></div><div class="col-xs-4 col-sm-4 col-md-4" style="padding: 2.5px;"><input type="text" id="tellandlineInput" name="{{\'contactNew.telephone\' | translate}}" class="form-control required" ng-disabled="permissions.contactsACL.aclRightLvel < 2" ng-model="contactDetail.tellandline" required="false" phone-input=""></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 2.5px;"><label style="padding-left: 15px" translate="contactNew.mobile"></label></div><div class="col-xs-4 col-sm-4 col-md-4" style="padding: 2.5px;"><input type="text" id="telmobileInput" name="{{\'contactNew.telephone\' | translate}}" class="form-control required" ng-disabled="permissions.contactsACL.aclRightLvel < 2" ng-model="contactDetail.telmobile" required="false" phone-input=""></div></div></div></div></form>');
  }]);
})();

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 1/15/2016.
 */


angular.module('trackMap', ['ui.router']).config(["$stateProvider", function ($stateProvider) {

  $stateProvider.state('trackMap', {
    parent: 'betotrack',
    url: '/map',
    views: {
      'content@app': {
        controller: 'MappingGroupCtrl',
        templateUrl: 'components/track/mapping/groupMap.tpl.html'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Map';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    },
    ncyBreadcrumb: {
      label: ''
    }
  });
}]);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/mapping/groupMap.tpl.html', '<div><div class="row" id="mapping-options" ng-if="dataLoadingFinished" style="padding-top: 2px;"><div class="vehicle-list-widget-ctrl" style="padding:2px;"><div class="col-md-3 col-sm-12 col-xs-12"><jqx-combo-box id="mVehicGroupComboBox" jqx-settings="mVehicGroupSettings" class="jqx-combo-box-dsa required" jqx-on-change="mVehicleGroupComboChange" ng-model="vehicleGroup" clear-input=\'{"responseType":1}\' focus-blurs=""></jqx-combo-box></div><div class="col-md-3 col-sm-12 col-xs-12"><div jqx-delete-directive="repoVehicleComboBox" type="comboBox"><jqx-combo-box id="mapVehicleComboBox" jqx-settings="mapVehicleSettings" class="jqx-combo-box-dsa required" jqx-on-change="mapVehicleComboChange" ng-model="mapVehicle" clear-input="" focus-blur=""></jqx-combo-box></div></div><div id="refreshBtn" class="col-md-1 col-sm-12 col-xs-12"><button ng-click="stopAutoRefresh($event)" type="button" id="autoRefreshButton" class="btn btn-default"><span class="badge" ng-show="isTimerStated">{{counter}}</span><i ng-show="!isTimerStated" class="fa fa-play" aria-hidden="true"></i></button></div></div></div><div style="padding-top: 4px;"><iframe id="trackMapDashboard" ng-src="{{mapUrl | trustAsResourceUrl}}" style="display:block; width:100%; height:100%;" fit-iframe-height="" divid="\'mapping-options\'"></iframe></div></div>');
  }]);
})();

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/15/2016.
 */


angular.module('trackMap').controller('MappingGroupCtrl', ["$scope", "widgetSettingsCreatorService", "commonTrackService", "$timeout", "$rootScope", "$interval", function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, $rootScope, $interval) {
  //var vehicleGroup = {};

  var mainUrlDetails = '';

  mainUrlDetails = '&page=map.fleet.full&searchAndRoute_dsa=true&buildingSiteLocationBtn=true';

  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails, 'trackMapDashboard');
    });
  };
  // remove for Exhibition
  //loadFleetServerDetails();
  $scope.mVehicGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
  });

  $scope.mapVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'deviceID',
    disabled: true
  });

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {
        $scope.mVehicGroupSettings.source = vechileGroupList;
        var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

        if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {
          // validate the local storage group is still valid ( group can change based on login )
          $scope.vehicleGroup = cachedGroup;
        }

        if (!$scope.vehicleGroup) {
          $scope.vehicleGroup = vechileGroupList[0].groupID;
        }
      }
    });
  };

  var loadVehicle = function loadVehicle(groupId) {
    return commonTrackService.getVehicleListFilterByGroupId(groupId).then(function (vehicleList) {
      $scope.mapVehicleSettings.source = _.uniq(vehicleList, 'deviceID');
      $timeout(function () {
        $('#mapVehicleComboBox').jqxComboBox({
          disabled: false,
          selectedIndex: -1,
          height: 32,
          autoDropDownHeight: false
        });
      }, 0);
    });
  };

  loadFleetServerDetails().then(function () {
    return loadVehicleGroup();
  }).finally(function () {
    $scope.dataLoadingFinished = true;
  });

  // remove for Exhibition
  $scope.$on('mVehicleGroupComboChange', function () {
    var vehicleGroup = $('#mVehicGroupComboBox').jqxComboBox('getSelectedItem');
    if (vehicleGroup.value) {
      $scope.mapVehicleSettings.source = [];
      $('#mapVehicleComboBox').jqxComboBox({ disabled: true, selectedIndex: -1 });
      loadVehicle(vehicleGroup.value);
      $timeout(function () {
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails, 'trackMapDashboard');
        $scope.mapUrl += '&group=' + vehicleGroup.value;
      }, 0);
    }
  });
  $scope.$on('mapVehicleComboChange', function () {
    var vehicle = $('#mapVehicleComboBox').jqxComboBox('getSelectedItem');
    if (vehicle && vehicle.value) {
      commonTrackService.iframePostMessage('jsmShowDetailPushpin(' + 0 + ', 0 ,' + '"' + vehicle.value + '"' + ' ,' + true + ')', 'trackMapDashboard');
    }
  });

  $scope.$on('map_init_event', function () {
    $scope.counter = counterSeconds;
    $scope.startCounter();
  });
  //
  $scope.$on('map_place_route_int_event', function () {
    commonTrackService.iframePostMessage('stopAutoUpdateMapTimer()', 'trackMapDashboard');
    $scope.$apply($scope.isTimerStated = false);
    $scope.stop();
  });
  $scope.$on('map_option_canceled_event', function () {
    if (!$scope.isTimerStated) {
      commonTrackService.iframePostMessage('stopAutoUpdateMapTimer()', 'trackMapDashboard');
      $scope.isTimerStated = false;
      $scope.stop();
      commonTrackService.iframePostMessage('startAutoUpdateMapTimer()', 'trackMapDashboard');
      $scope.counter = counterSeconds;
      $scope.startCounter();
    }
  });

  var mapVehicleComboBoxClearEvt = $rootScope.$on('combobox-clear-selection-evt', function (event, data) {
    if (data.id === 'mVehicGroupComboBox') {
      $scope.mapVehicleSettings.source = [];
    }
  });

  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  // Google maps takes focus if the auto refresh enabled
  // Auto refresh must be stoped if the chat window is open to solve focus switching
  var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
    $scope.stopAutoRefresh(null, 'stop');
  });
  //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
  //  restart the auto refresh is the chat window is closed
  var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
    $scope.stopAutoRefresh(null, 'start');
  });

  $scope.$on('$destroy', function () {
    if (chatWindowOpenEvent) {
      chatWindowOpenEvent();
    }
    if (chatWindowCloseEvent) {
      chatWindowCloseEvent();
    }
    mapVehicleComboBoxClearEvt();
  });

  var counterSeconds = 60;
  var counterTimeout;

  $scope.startCounter = function () {
    $scope.stop();
    $scope.isTimerStated = true;
    if ($scope.counter - 1 >= 1) {
      $scope.counter--;
      counterTimeout = $interval($scope.startCounter, 1000);
    } else {
      $scope.stop();
      $scope.counter = counterSeconds;
      $scope.startCounter();
    }
  };
  $scope.stop = function () {
    $interval.cancel(counterTimeout);
  };

  $scope.stopAutoRefresh = function () {

    if ($scope.isTimerStated) {
      $scope.isTimerStated = false;
      $scope.stop();
      commonTrackService.iframePostMessage('stopAutoUpdateMapTimer()', 'trackMapDashboard');
    } else {
      $scope.counter = counterSeconds;
      $scope.startCounter();
      commonTrackService.iframePostMessage('startAutoUpdateMapTimer()', 'trackMapDashboard');
      $scope.isTimerStated = true;
    }
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 1/15/2016.
 */


angular.module('trackReporting', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'restangular', 'ui.router', 'pascalprecht.translate', 'jqwidgets', 'ab-base64', 'ui.bootstrap', 'LocalStorageModule']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('reports', {
    parent: 'betotrack',
    url: '/reports',
    abstract: true,
    ncyBreadcrumb: {
      skip: true
    }
  }).state('reports.vehicleDetail', {
    url: '/vehicle.detail?reportName&vehicleId&dateFrom&dateTo&hasCustomDateRange',
    views: {
      'content@app': {
        controller: 'RepoVehicleDetailCtrl',
        templateUrl: 'components/track/reports/vehicleDetailReport.tpl.html'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Vehicle Details';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    },
    ncyBreadcrumb: {
      label: '{{breadCrumbLabel}}'
    }
  }) /*.state('reports.groupDetail', {
     url: '/group.detail?reportName&groupId&dateFrom&dateTo',
     views: {
       'content@app': {
         controller: 'RepoGroupDetailCtrl',
         templateUrl: 'components/track/reports/groupDetailReport.tpl.html'
       }
     },
     resolve: {
       $title: function () {
         return 'BetoTrack', 'Group Detail';
       },
       $sibebar: ['AdmStatusService', function (AdmStatusService) {
         AdmStatusService.setSidebarVisible(true);
         return true;
       }]
     },
     ncyBreadcrumb: {
       label: '{{breadCrumbLabel}}'
     }
     })*/
  .state('reports.groupSummary', {
    url: '/group.summary?reportName&groupId&dateFrom&dateTo',
    views: {
      'content@app': {
        controller: 'RepoGroupSummaryCtrl',
        templateUrl: 'components/track/reports/groupSummary.tpl.html'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Group Summary';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    },
    ncyBreadcrumb: {
      label: '{{breadCrumbLabel}}'
    }
  }).state('reports.performance', {
    url: '/performance?reportName&vehicleId&dateFrom&dateTo',
    views: {
      'content@app': {
        controller: 'RepoPerformanceCtrl',
        templateUrl: 'components/track/reports/performance.tpl.html'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Performance';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    },
    ncyBreadcrumb: {
      label: '{{breadCrumbLabel}}'
    }
  });
}]);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/reports/betoTrackReports.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12 mainContent" style="padding: 2px"><div ui-view="vehicleDetail" ng-show="$state.includes(\'reports.vehicleDetail\')"></div><div ui-view="groupDetail" ng-show="$state.includes(\'reports.groupDetail\')"></div><div ui-view="groupSummary" ng-show="$state.includes(\'reports.groupSummary\')"></div><div ui-view="performance" ng-show="$state.includes(\'reports.performance\')"></div></div></div></div>');
  }]);
})();

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/reports/groupDetailReport.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12"><div class="row customer-header" id="breadcrump" style="padding:2.5px;"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div ncy-breadcrumb="" style="font-size: 24px;"></div></div></div><div class="row" style="padding:2.5px;"><div class="col-xs-8 col-sm-8 col-md-4"><button type="button" ng-show="showRepoTab ===1" class="btn btn-default unified-btn" ng-click="cancel()"><span class="glyphicon glyphicon-arrow-left"></span><span class="span-btn-font" translate="telephoneNew.cancel"></span></button></div></div></div><div class="row" id="mappingPage"><div class="col-md-2"><label translate="trackReporting.group"></label><div jqx-delete-directive="repoGroupComboBox" type="comboBox"><jqx-combo-box id="repoGroupComboBox" jqx-settings="repoGroupSettings" class="jqx-combo-box-dsa required" jqx-create="dataLoadingFinished" jqx-on-change="repoGroupComboChange(event)" ng-model="repoGroup" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-4"><div ng-show="!error" class="form-group"><label for="daterange4" class="control-label" translate="dashBoard.fleetManagement.vehicleDetails.dateRange"></label> <input date-range-picker="" id="daterange4" name="daterange4" class="form-control date-picker" type="text" ng-model="date" clearable="true" options="options" required=""></div></div><div class="col-md-2" ng-show="showRepoTab ===1"><label translate="trackReporting.export"></label><div style="margin-top: 3px;"><div jqx-delete-directive="report_exportDropDown" type="dropDownList"><jqx-drop-down-list id="report_exportDropDown" jqx-settings="exportSetting" ng-model="exportOption" jqx-on-change="exportChange(event)" jqx-create="showRepoTab ===1"></jqx-drop-down-list></div></div></div></div></div></div><div class="row" style="margin-top: 0px;"><div class="col-md-2 col-md-offset-6" ng-show="showRepoTab ===1&&exportOption===\'EMail\'"><p translate="trackReporting.emailInfo"></p><div class="input-group"><input type="text" name="email" class="form-control" ng-model="emailAddresses"> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-show="showRepoTab ===1&&exportOption===\'EMail\'" ng-click="exportChange(\'EMail\')" translate="trackReporting.exportEmailsendBtn"></button></span></div></div></div><div class="row" style="padding:2.5px;"><div class="row" style="padding:2.5px;"><div class="col-xs-12 col-sm-12 col-md-12"><uib-tabset active="showRepoTab" style="" class="track-tab-dsa"><uib-tab index="0"><uib-tab-heading translate="trackReporting.reportOption"></uib-tab-heading><div class="row" style="margin-left: 2.5px;"><div class="col-xs-12 col-sm-12 col-md-12"><fieldset ng-disabled="date.startDate===null || !repoGroup" style="border:none"><form name="myForm"><div class="row"><div ng-repeat="item in groupDetailReportPropList"><div ng-if="!item._hasOption && item._isEnabled"><div class="row" style="padding-top: 2.5px;"><div class="col-xs-5 col-sm-5 col-md-3"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-5 col-sm-5 col-xs-5"></div><button type="button" ng-show="radio.name ===item._reportName" class="btn btn-info" ng-click="getReport(item._reportName, item._hasMap)" translate="trackReporting.getReport"></button></div></div><div ng-if="item._hasOption && item._isEnabled"><div class="row" style="padding-top: 5px;"><div class="col-xs-5 col-sm-5 col-md-3"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-5 col-sm-5 col-xs-5"><div jqx-delete-directive="{{item._comboID}}" type="comboBox"><jqx-combo-box id="{{item._comboID}}" class="jqx-combo-box-dsa required" ng-model="reportComboOption[item._comboModelName]" jqx-create="dataLoadingFinished" ng-disabled="radio.name!==item._reportName" clear-input="" focus-blur="" jqx-settings="{{item._comboSettings}}"></jqx-combo-box></div></div><button type="button" ng-show="radio.name ===item._reportName" class="btn btn-info" ng-click="getReport(item._reportName, item._hasMap, item._comboModelName)" translate="trackReporting.getReport"></button></div></div></div></div></form></fieldset></div></div></uib-tab><uib-tab index="1" disable="diableRepoTab.report"><uib-tab-heading translate="trackReporting.report"></uib-tab-heading><div id="grpDetailRepoSpliter" ng-show="isDataAvailable"><div class="splitter-panel"><div jqx-delete-directive="{{overviewGridPrefix}}groupDetailReportList" type="grid"><div id="{{overviewGridPrefix}}groupDetailReportList" ng-show="showRepoTab ===1" class="custom-header"></div></div></div><div class="splitter-panel" ng-show="hasMap"><iframe id="groupMap" ng-src="{{mapUrl | trustAsResourceUrl}}" style="display:block; width:100%; height:725px;;"></iframe></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></uib-tab></uib-tabset></div></div></div></div>');
  }]);
})();

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/15/2016.
 */


angular.module('trackReporting').controller('RepoGroupDetailCtrl', ["$scope", "widgetSettingsCreatorService", "commonTrackService", "$timeout", "reportService", "$stateParams", "$filter", "$translate", "errorHandlingService", function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, errorHandlingService) {
  //var device = {};
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var startDate = '';
  var endDate = '';
  var mainUrlDetails = '&page=map.device.full';
  var column = [];
  var reportOptions = ['tripReport', 'motionSummary', 'eventSpeedOption', 'eventSpeedPosted', 'digitalInputDetailReport'];
  var _selectedReportOption = '';
  var _selectedReportOptionModel = '';
  $scope.moduleName = 'groupdetailsreport';
  $scope.isDataAvailable = true;
  var isGridCreated = false;
  var radioCache = commonTrackService.getDataFromLocalStorage('groupDetailRadioName');
  $scope.radio = {
    name: $stateParams.reportName ? $stateParams.reportName : radioCache ? radioCache : 'EventDetail_Group'
  };
  var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();

  $scope.reportComboOption = {
    tripReport: null,
    motionSummary: null,
    eventSpeedOption: null,
    eventSpeedPosted: null,
    digitalInputDetailReport: null
  };

  $scope.groupDetailReportPropList = [{
    _isEnabled: true,
    _reportName: 'EventDetail_Group',
    _idName: 'eventDetail_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.eventDetail_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'EventDetailOBDLight_Group',
    _idName: 'eventDetailOBDLight_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.eventDetailOBDLight_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'TripReport_Group',
    _idName: 'tripReport_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.tripReport_Group',
    _hasOption: true,
    _comboID: 'tripreportComboBox',
    _comboModelName: 'tripReport',
    _comboSettings: 'tripReportSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'MotionSummary_Group',
    _idName: 'motionSummary_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.motionSummary_Group',
    _hasOption: true,
    _comboID: 'motionsummaryComboBox',
    _comboModelName: 'motionSummary',
    _comboSettings: 'motionSummarySettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'GeozoneReport_Group',
    _idName: 'geozoneReport_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.geozoneReport_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'GeozoneDriving_Group',
    _idName: 'geozoneDriving_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.geozoneDriving_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'EventSpeedOption_Group',
    _idName: 'eventSpeedOption_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.eventSpeedOption_Group',
    _hasOption: true,
    _comboID: 'speedOverComboBox',
    _comboModelName: 'eventSpeedOption',
    _comboSettings: 'eventSpeedOptionSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'EventExcessSpeed_Group',
    _idName: 'eventExcessSpeed_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.eventExcessSpeed_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'EventSpeedPosted_Group',
    _idName: 'eventSpeedPosted_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.eventSpeedPosted_Group',
    _hasOption: true,
    _comboID: 'eventSpeedPostedComboBox',
    _comboModelName: 'eventSpeedPosted',
    _comboSettings: 'eventSpeedPostedSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'EventIdle_Group',
    _idName: 'eventIdle_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.eventIdle_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'EventExcessiveIdle_Group',
    _idName: 'eventExcessiveIdle_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.eventExcessiveIdle_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'DigitalInputDetailReport_Group',
    _idName: 'digitalInputDetailReport_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.digitalInputDetailReport_Group',
    _hasOption: true,
    _comboID: 'digitalinputdetailreportComboBox',
    _comboModelName: 'digitalInputDetailReport',
    _comboSettings: 'digitalInputDetailReportSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'NotifyQueueDetail_Group',
    _idName: 'notifyQueueDetail_GroupRadio',
    _translationProp: 'trackReporting.groupDetailReport.notifyQueueDetail_Group',
    _hasOption: false,
    _hasMap: false
  }];

  $scope.reportHistory = '';

  $scope.diableRepoTab = {
    report: true
  };

  $scope.showRepoTab = 0;

  var source = {
    datatype: 'array',
    datafields: [],
    localdata: []
  };
  $scope.date = {
    startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
    endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
  };
  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
        if ($scope.showRepoTab === 1) {
          $scope.getReport($scope.reportHistory, $scope.hasMap, _selectedReportOptionModel);
        }
        /* $timeout(function () {
         $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
         }, 0);*/
      }
    }
  };
  $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler);
  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
    });
  };

  $scope.repoGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
  });

  $scope.tripReportSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.motionSummarySettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.eventSpeedOptionSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.eventSpeedPostedSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.digitalInputDetailReportSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  var loaddevice = function loaddevice() {
    return commonTrackService.getVehicleGroupComboList().then(function (groupList) {
      var cacheData = commonTrackService.getDataFromLocalStorage('groupDetailReport');
      $scope.repoGroupSettings.source = groupList;
      if ($stateParams.groupId) {
        $scope.repoGroup = $stateParams.groupId;
      } else if (lastlocationWidgetData.selectedVehicleGroup && lastlocationWidgetData.selectedVehicleGroup !== 'all') {
        $scope.repoGroup = lastlocationWidgetData.selectedVehicleGroup;
      } else if (cacheData) {
        $scope.repoGroup = cacheData;
      } else {
        $scope.repoGroup = $scope.repoGroupSettings.source[0].groupID;
      }
    });
  };
  var loadReportOptions = function loadReportOptions(name) {
    reportService.getCustomGroupRepotOptionComboData(name).then(function (reportOptionData) {
      for (var i = 0; i < reportOptionData.length; i++) {
        reportOptionData[i].displayName = $translate.instant('trackReporting.groupDetailReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
      }
      $scope[name + 'Settings'].source = reportOptionData;
      $scope.reportComboOption[name] = reportOptionData[0].key;
    });
  };

  loadFleetServerDetails().then(function () {
    return loaddevice();
  }).finally(function () {
    $('#grpDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());

    for (var i = 0; i < reportOptions.length; i++) {
      loadReportOptions(reportOptions[i]);
    }
    initExport();

    $scope.dataLoadingFinished = true;

    if ($stateParams.reportName && $stateParams.groupId && $stateParams.dateFrom && $stateParams.dateTo) {
      $timeout(function () {
        $scope.getReport($stateParams.reportName, false);
        $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('bindingcomplete', function () {
          isGridCreated = true;
          $timeout(function () {
            $('#grpDetailRepoSpliter').jqxSplitter('render');
          }, 400);
        });
      }, 100);
    }

    $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('bindingcomplete', function () {
      isGridCreated = true;
      $timeout(function () {
        $('#grpDetailRepoSpliter').jqxSplitter('render');
      }, 100);
    });

    $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('rowselect', function (event) {
      if (event.args && event.args.row && event.args.row.timestamp) {
        commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');
      }
    });
  });

  $scope.getReport = function (reportName, hasMap, reportOption, event) {
    $scope.mapUrl = '';
    var gridState = reportService.getReportGridState('groupDetailReport', reportName);
    _selectedReportOptionModel = reportOption;
    $scope.error = false;
    $scope.exportOption = 'HTML';
    $scope.diableRepoTab.report = false;
    $scope.hasMap = hasMap;
    $scope.dataLoadingFinished = false;

    startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
    endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

    _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';
    if ($scope.hasMap) {
      $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'group', event ? event.args.item.value : $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
    }
    var _tmpReportData = null;
    reportService.getGroupReport($scope.moduleName, event ? event.args.item.value : $scope.repoGroup, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption !== null ? _selectedReportOption : '').then(function (detailReport) {
      $scope.isDataAvailable = true;
      _tmpReportData = detailReport;
      if ($scope.reportHistory !== reportName) {
        $scope.reportHistory = reportName;
        source.localdata = detailReport.dataList;
        column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
          moduleName: reportName,
          reportModel: 'groupDetailReport'
        });
        var isGroupable = false;
        if (column[0].datafield === 'deviceid') {
          isGroupable = true;
        }
        var _additionalProperties = {
          translatedName: $translate.instant('trackReporting.groupDetailReport.' + reportName.toLoawerCaseAt(0)),
          isDynamicGrid: true,
          dynamicModuleName: reportName
        };
        $scope.gridSettings = commonTrackService.getGridSettings('groupDetailReport', {
          pagesizeoptions: ['25', '50', '100'],
          pagesize: 25,
          columns: column,
          autosavestate: false,
          height: 675,
          autoloadstate: false,
          groupable: isGroupable,
          groups: [column[0].datafield]
        }, null, _additionalProperties);
        $scope.dataAdapter = new $.jqx.dataAdapter(source);
        $scope.gridSettings.source = $scope.dataAdapter;
        // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
        if (isGridCreated) {
          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid({
            source: $scope.dataAdapter,
            columns: column
          });
        }
        $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid($scope.gridSettings);
      } else {
        source.localdata = detailReport.dataList;
        $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid('updatebounddata', 'data');
      }
    }, function (response) {
      $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid('clear');
      $scope.reportHistory = '';
      $scope.mapUrl = '';
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {

      $timeout(function () {
        $scope.showRepoTab = 1;
        if (!$scope.hasMap) {
          $('#grpDetailRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
        } else {
          $('#grpDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
        }
        if (!$scope.isEventRegistered) {
          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('filter', function () {
            saveGridSate();
          });
          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('columnresized', function () {
            saveGridSate(reportName);
          });

          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('columnreordered', function () {
            saveGridSate(reportName);
          });

          $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').on('sort', function () {
            saveGridSate(reportName);
          });
          $scope.isEventRegistered = true;
        }
      }, 0);
      //  $('#vehicleDetailReportList').jqxGrid('render');
      $timeout(function () {
        var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'groupDetailReportList';
        reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'groupDetailReportList', $scope.gridSettings, gridState, gridLocalStorageUserSettingKey);
      }, 1000);
      column = null;
    });
  };

  function saveGridSate() {
    var reportSate = $('#' + $scope.overviewGridPrefix + 'groupDetailReportList').jqxGrid('getstate');
    reportService.setReportGridState('groupDetailReport', $scope.radio.name, reportSate);
  }

  function initExport() {
    $scope.exportSetting = reportService.getExportSettings();
    $scope.exportSetting.selectedIndex = 0;
    $scope.exportOption = 'HTML';
  }

  $scope.exportChange = function (event) {
    $scope.exportURL = '';
    if (event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event.args.item.value, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
      reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);
    } else {
      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.emailAddresses);
      if (!event.args) {
        reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
      }
    }
  };

  $scope.repoGroupComboChange = function (event) {
    var selectItem = event.args.item;
    if (selectItem) {
      commonTrackService.setDataToLocalStorage('groupDetailReport', selectItem.value);
    }
    if ($scope.showRepoTab === 1) {
      $scope.getReport($scope.reportHistory, $scope.hasMap, _selectedReportOptionModel, event);
    }
  };
  $scope.$watch('radio.name', function (value) {
    if (value) {
      // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
      $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupDetail') + ' / ' + $translate.instant('trackReporting.groupDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
      $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupDetail') + ' / ' + $translate.instant('trackReporting.groupDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
      commonTrackService.setDataToLocalStorage('groupDetailRadioName', value);
    }
  });

  $scope.cancel = function () {
    $scope.showRepoTab = 0;
  };
  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options);
  });

  $scope.$on('$destroy', function () {
    updateDateRangeInternalDateEvent();
    if ($scope.dataAdapter) {
      delete $scope.dataAdapter;
    }
    if ($scope.gridSettings && $scope.gridSettings.source) {
      delete $scope.gridSettings.source;
    }
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/reports/groupSummary.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12"><div class="row customer-header" id="breadcrump" style="padding: 2.5px;"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div ncy-breadcrumb="" style="font-size: 24px;"></div></div></div><div class="row" style="padding:2.5px;"><div class="col-xs-8 col-sm-8 col-md-4"><button type="button" ng-show="showRepoTab ===1" class="btn btn-default unified-btn" ng-click="cancel()"><span class="glyphicon glyphicon-arrow-left"></span><span class="span-btn-font" translate="telephoneNew.cancel"></span></button></div></div></div><div class="row" id="mappingPage"><div class="col-md-2"><label translate="trackReporting.group"></label><div jqx-delete-directive="repoGroupComboBox" type="comboBox" ng-if="isCreateCombobox"><jqx-combo-box id="repoGroupComboBox" jqx-settings="repoGroupSettings" class="jqx-combo-box-dsa required" jqx-on-change="repoGroupComboChange(event)" ng-model="repoGroup" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-4"><div ng-show="!error" class="form-group"><label for="daterange4" class="control-label" translate="dashBoard.fleetManagement.vehicleDetails.dateRange"></label> <input date-range-picker="" id="daterange4" name="daterange4" class="form-control date-picker" type="text" ng-model="date" clearable="true" options="options" required=""></div></div><div class="col-md-2" ng-if="showRepoTab ===1"><label translate="trackReporting.export"></label><div style="margin-top: 3px;"><div jqx-delete-directive="report_exportDropDown" type="dropDownList"><jqx-drop-down-list id="report_exportDropDown" jqx-settings="exportSetting" jqx-on-change="exportChange(event)" jqx-create="showRepoTab ===1"></jqx-drop-down-list></div></div></div></div></div></div><div class="row" style="margin-top: 0px;"><div class="col-md-2 col-md-offset-6" ng-show="showRepoTab ===1&&exportOption===\'EMail\'"><p translate="trackReporting.emailInfo"></p><div class="input-group"><input type="text" name="email" class="form-control" ng-model="reportDetail.emailAddresses"> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-show="showRepoTab ===1&&exportOption===\'EMail\'" ng-click="exportChange(\'EMail\')" translate="trackReporting.exportEmailsendBtn"></button></span></div></div></div><div class="row" style="padding:2.5px;"><div class="row" style="padding:2.5px;"><div class="col-xs-12 col-sm-12 col-md-12"><uib-tabset active="showRepoTab" class="track-tab-dsa"><uib-tab index="0"><uib-tab-heading translate="trackReporting.reportOption"></uib-tab-heading><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><fieldset ng-disabled="date.startDate===null || !repoGroup" style="border:none"><form name="myForm" class="report-form"><div ng-repeat="item in groupSummaryReportPropList"><div ng-if="!item._hasOption && item._isEnabled"><div class="row" style="padding-top: 5px;"><div class="col-xs-12 col-sm-12 col-md-6"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-2 col-sm-12 col-xs-12 get-report-btn"><button type="button" ng-show="radio.name ===item._reportName" class="btn btn-info" ng-click="getReport(item._reportName, item._hasMap)" translate="trackReporting.getReport"></button></div></div></div><div ng-if="item._hasOption && item._isEnabled"><div class="row" style="padding-top: 5px;"><div class="col-xs-12 col-sm-12 col-md-3"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-3 col-sm-12 col-xs-12"><div jqx-delete-directive="{{item._comboID}}" type="comboBox"><jqx-combo-box id="{{item._comboID}}" class="jqx-combo-box-dsa required" ng-model="reportComboOption[item._comboModelName]" jqx-create="dataLoadingFinished" ng-disabled="radio.name!==item._reportName" clear-input="" focus-blur="" jqx-settings="{{item._comboSettings}}"></jqx-combo-box></div></div><div class="col-md-2 col-sm-12 col-xs-12 get-report-btn"><button type="button" ng-show="radio.name ===item._reportName" class="btn btn-info" ng-click="getReport(item._reportName, item._hasMap, item._comboModelName)" translate="trackReporting.getReport"></button></div></div></div></div></form></fieldset></div></div></uib-tab><uib-tab index="1" disable="diableRepoTab.report"><uib-tab-heading translate="trackReporting.report"></uib-tab-heading><div id="grpSumryRepoSpliter" ng-show="isDataAvailable"><div class="splitter-panel"><div jqx-delete-directive="{{overviewGridPrefix}}groupSummaryReportList" type="grid"><div id="{{overviewGridPrefix}}groupSummaryReportList" ng-show="showRepoTab ===1" class="custom-header"></div></div></div><div class="splitter-panel" ng-show="hasMap"><iframe id="groupMap" src="{{mapUrl | trustAsResourceUrl}}" style="display:block; width:100%; height:725px;;"></iframe></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></uib-tab></uib-tabset></div></div></div></div>');
  }]);
})();

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/15/2016.
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('trackReporting').controller('RepoGroupSummaryCtrl', ["$scope", "widgetSettingsCreatorService", "commonTrackService", "$timeout", "reportService", "$stateParams", "$filter", "$translate", "errorHandlingService", function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, errorHandlingService) {
  //var device = {};
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var startDate = '';
  var endDate = '';
  var mainUrlDetails = '&page=map.device.full';
  var column = [];
  var reportOptions = ['eventSummary', 'firstEventSummary', 'excessiveLastCheckIn', 'eventCount', 'digitalInputSummaryReport', 'fleetMotion', 'fleetIdle'];
  $scope.moduleName = 'groupsummary';
  var isGridCreated = false;
  var dateRangePickerSettings = {};
  $scope.isDataAvailable = true;
  var radioCache = commonTrackService.getDataFromLocalStorage('groupSummaryRadioName');
  $scope.radio = {
    name: $stateParams.reportName ? $stateParams.reportName : radioCache ? radioCache : 'EventSummary'
  };
  var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();

  $scope.reportComboOption = {
    eventSummary: null,
    firstEventSummary: null,
    excessiveLastCheckIn: null,
    eventCount: null,
    digitalInputSummaryReport: null,
    fleetMotion: null,
    fleetIdle: null
  };

  var _selectedReportOption = '';
  var _selectedReportOptionModel = '';

  $scope.reportHistory = '';
  $scope.reportDetail = {};
  $scope.diableRepoTab = {
    report: true
  };

  $scope.showRepoTab = 0;

  var source = {
    datatype: 'array',
    datafields: [],
    localdata: []
  };
  $scope.date = {
    startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
    endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
  };

  $scope.groupSummaryReportPropList = [{
    _isEnabled: false,
    _reportName: 'EventSummary',
    _idName: 'eventSummaryRadio',
    _translationProp: 'trackReporting.groupsummaryReport.eventSummary',
    _hasOption: true,
    _comboID: 'eventSummaryComboBox',
    _comboModelName: 'eventSummary',
    _comboSettings: 'eventSummarySettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'FirstEventSummary',
    _idName: 'firstEventSummaryRadio',
    _translationProp: 'trackReporting.groupsummaryReport.firstEventSummary',
    _hasOption: true,
    _comboID: 'firstEventSummaryComboBox',
    _comboModelName: 'firstEventSummary',
    _comboSettings: 'firstEventSummarySettings',
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'ExcessiveLastCheckIn',
    _idName: 'excessiveLastCheckInradio',
    _translationProp: 'trackReporting.groupsummaryReport.excessiveLastCheckIn',
    _hasOption: true,
    _comboID: 'excessiveLastCheckInComboBox',
    _comboModelName: 'excessiveLastCheckIn',
    _comboSettings: 'excessiveLastCheckInSettings',
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'DeviceLastCheckIn',
    _idName: 'deviceLastCheckInRadio',
    _translationProp: 'trackReporting.groupsummaryReport.deviceLastCheckIn',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'DeviceNeverCheckIn',
    _idName: 'deviceNeverCheckInRadio',
    _translationProp: 'trackReporting.groupsummaryReport.deviceNeverCheckIn',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'EventCount',
    _idName: 'eventCountRadio',
    _translationProp: 'trackReporting.groupsummaryReport.eventCount',
    _hasOption: true,
    _comboID: 'eventCountComboBox',
    _comboModelName: 'eventCount',
    _comboSettings: 'eventCountSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'EventSessionStatus',
    _idName: 'eventSessionStatusRadio',
    _translationProp: 'trackReporting.groupsummaryReport.eventSessionStatus',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'PeriodicServiceOdom',
    _idName: 'periodicServiceOdomRadio',
    _translationProp: 'trackReporting.groupsummaryReport.periodicServiceOdom',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'PeriodicServiceHours',
    _idName: 'periodicServiceHoursRadio',
    _translationProp: 'trackReporting.groupsummaryReport.periodicServiceHours',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'DistanceTraveled',
    _idName: 'distanceTraveledRadio',
    _translationProp: 'trackReporting.groupsummaryReport.distanceTraveled',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'IgnitionSummaryReport',
    _idName: 'ignitionSummaryReportRadio',
    _translationProp: 'trackReporting.groupsummaryReport.ignitionSummaryReport',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'DigitalInputSummaryReport',
    _idName: 'digitalInputSummaryReportRadio',
    _translationProp: 'trackReporting.groupsummaryReport.digitalInputSummaryReport',
    _hasOption: true,
    _comboID: 'digitalInputSummaryReportComboBox',
    _comboModelName: 'digitalInputSummaryReport',
    _comboSettings: 'digitalInputSummaryReportSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'FleetMotion',
    _idName: 'fleetMotionRadio',
    _translationProp: 'trackReporting.groupsummaryReport.fleetMotion',
    _hasOption: true,
    _comboID: 'fleetMotionComboBox',
    _comboModelName: 'fleetMotion',
    _comboSettings: 'fleetMotionSettings',
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'FleetIdle',
    _idName: 'fleetIdleRadio',
    _translationProp: 'trackReporting.groupsummaryReport.fleetIdle',
    _hasOption: true,
    _comboID: 'fleetIdleComboBox',
    _comboModelName: 'fleetIdle',
    _comboSettings: 'fleetIdleSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'FuelSummaryReport',
    _idName: 'fuelSummaryReportRadio',
    _translationProp: 'trackReporting.groupsummaryReport.fuelSummaryReport',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'StatusSummaryCount',
    _idName: 'statusSummaryCountRadio',
    _translationProp: 'trackReporting.groupsummaryReport.statusSummaryCount',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'UserLogin',
    _idName: 'userLoginRadio',
    _translationProp: 'trackReporting.groupsummaryReport.userLogin',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'GeozoneNearbyDevices',
    _idName: 'geozoneNearbyDevicesRadio',
    _translationProp: 'trackReporting.groupsummaryReport.geozoneNearbyDevices',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'GeozoneHotspotReport',
    _idName: 'geozoneHotspotReportRadio',
    _translationProp: 'trackReporting.groupsummaryReport.geozoneHotspotReport',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'ReportedRefuel',
    _idName: 'reportedRefuelReportRadio',
    _translationProp: 'trackReporting.groupsummaryReport.reportedRefuel',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'RefuelMileage',
    _idName: 'refuelMileageReportRadio',
    _translationProp: 'trackReporting.groupsummaryReport.refuelMileage',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'MonthlyVehicleFuelUse',
    _idName: 'MonthlyVehicleFuelUseReportRadio',
    _translationProp: 'trackReporting.groupsummaryReport.monthlyVehicleFuelUse',
    _hasOption: false,
    _hasMap: false
  }];

  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
        if ($scope.showRepoTab === 1) {
          $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel);
        }
        /* $timeout(function () {
         $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
         }, 0);*/
      }
    }
  };

  commonTrackService.getDatePickerDetails().then(function (settings) {
    $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, $scope.radio.name));
    dateRangePickerSettings = settings;
  });

  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
    });
  };

  $scope.repoGroupSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID'
  });

  $scope.eventSummarySettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.firstEventSummarySettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.excessiveLastCheckInSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.eventCountSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.digitalInputSummaryReportSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.fleetMotionSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });
  $scope.fleetIdleSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  var loaddevice = function loaddevice() {
    return commonTrackService.getVehicleGroupComboList().then(function (groupList) {
      var cacheData = commonTrackService.getDataFromLocalStorage('groupSummaryReport');
      $scope.repoGroupSettings.source = groupList;
      if ($stateParams.groupId) {
        $scope.repoGroup = $stateParams.groupId;
      } else if (lastlocationWidgetData.selectedVehicleGroup && lastlocationWidgetData.selectedVehicleGroup !== 'all') {
        $scope.repoGroup = lastlocationWidgetData.selectedVehicleGroup;
      } else if (cacheData) {
        $scope.repoGroup = cacheData;
      } else {
        $scope.repoGroup = $scope.repoGroupSettings.source[0].groupID;
      }
    });
  };
  var loadReportOptions = function loadReportOptions(name) {
    reportService.getCustomGroupSummaryRepotOptions(name).then(function (reportOptionData) {
      for (var i = 0; i < reportOptionData.length; i++) {
        reportOptionData[i].displayName = $translate.instant('trackReporting.groupsummaryReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
      }
      $scope[name + 'Settings'].source = reportOptionData;
      $scope.reportComboOption[name] = reportOptionData[0].key;
    });
  };

  loadFleetServerDetails().then(function () {
    return loaddevice();
  }).finally(function () {

    for (var i = 0; i < reportOptions.length; i++) {
      loadReportOptions(reportOptions[i]);
    }
    initExport();
    $scope.dataLoadingFinished = true;
    $scope.isCreateCombobox = true;
    $('#grpSumryRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
    $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('bindingcomplete', function () {
      isGridCreated = true;
      $timeout(function () {
        $('#grpSumryRepoSpliter').jqxSplitter('render');
      }, 100);
    });
  });

  $scope.getReport = function (reportName, hasMap, reportOption, event) {
    $scope.mapUrl = '';
    var gridState = reportService.getReportGridState('groupSummaryReport', reportName);
    _selectedReportOptionModel = reportOption;
    $scope.error = false;
    $scope.exportOption = 'HTML';
    $scope.diableRepoTab.report = false;
    $scope.hasMap = hasMap;
    $scope.dataLoadingFinished = false;

    startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
    endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

    _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';
    if ($scope.hasMap) {
      $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'group', event ? event.args.item.value : $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
    }
    var _tmpReportData = null;
    reportService.getGroupReport($scope.moduleName, event ? event.args.item.value : $scope.repoGroup, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption !== null ? _selectedReportOption : '').then(function (detailReport) {
      $scope.isDataAvailable = true;
      _tmpReportData = detailReport;
      if ($scope.reportHistory !== reportName) {
        $scope.reportHistory = reportName;
        source.localdata = detailReport.dataList;
        source.sort = commonTrackService.getCustomReportSortFunction($scope.overviewGridPrefix + 'groupSummaryReportList', source);
        column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
          moduleName: reportName,
          reportModel: 'groupSummaryReport'
        });
        var _additionalProperties = {
          translatedName: $translate.instant('trackReporting.groupsummaryReport.' + reportName.toLoawerCaseAt(0)),
          isDynamicGrid: true,
          dynamicModuleName: reportName
        };
        $scope.gridSettings = commonTrackService.getGridSettings('groupSummaryReport', {
          pagesizeoptions: ['25', '50', '100'],
          pagesize: 25,
          columns: column,
          autosavestate: false,
          height: 670,
          autoloadstate: false
        }, null, _additionalProperties);
        $scope.dataAdapter = new $.jqx.dataAdapter(source);
        $scope.gridSettings.source = $scope.dataAdapter;
        // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
        if (isGridCreated) {
          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid({
            source: $scope.dataAdapter,
            columns: column
          });
        }
        $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid($scope.gridSettings);
      } else {
        source.localdata = detailReport.dataList;
        $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('updatebounddata', 'data');
      }
    }, function (response) {
      $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('clear');
      $scope.reportHistory = '';
      $scope.mapUrl = '';
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {
      $timeout(function () {

        $scope.showRepoTab = 1;
        if (!$scope.hasMap) {
          $('#grpSumryRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
        } else {
          $('#grpSumryRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
        }

        if (!$scope.isEventRegistered) {
          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('filter', function () {
            saveGridSate();
          });
          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('columnresized', function () {
            saveGridSate(reportName);
          });

          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('columnreordered', function () {
            saveGridSate(reportName);
          });

          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('sort', function () {
            saveGridSate(reportName);
          });
          $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('loadstate', gridState);
          $scope.isEventRegistered = true;
        }
      }, 0);
      //  $('#vehicleDetailReportList').jqxGrid('render');
      $timeout(function () {
        var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'groupSummaryReportList';
        reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'groupSummaryReportList', $scope.gridSettings, gridState, gridLocalStorageUserSettingKey);
      }, 1000);
      column = null;
      $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').on('rowselect', function (event) {
        if (event.args && event.args.row && event.args.row.timestamp) {
          commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');
        }
      });
    });
  };

  function saveGridSate() {
    var reportSate = $('#' + $scope.overviewGridPrefix + 'groupSummaryReportList').jqxGrid('getstate');
    reportService.setReportGridState('groupSummaryReport', $scope.radio.name, reportSate);
  }

  function initExport() {
    $scope.exportSetting = reportService.getExportSettings();
    $scope.exportSetting.selectedIndex = 0;
    $scope.exportOption = 'HTML';
  }

  $scope.exportChange = function (event) {
    $scope.exportURL = '';
    if (event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event.args.item.value, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
      reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);
    } else {
      $scope.exportOption = (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && event.args && event.args.item.value ? event.args.item.value : event;
      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event, 'group', $scope.repoGroup, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.reportDetail.emailAddresses);
      if (!event.args) {
        reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
      }
    }
  };

  $scope.repoGroupComboChange = function (event) {
    var selectItem = event.args.item;
    if (selectItem) {
      commonTrackService.setDataToLocalStorage('groupSummaryReport', selectItem.value);
    }
    if (event.args && event.args.item.value) {
      $scope.repoGroup = event.args.item.value;
    }
    if ($scope.showRepoTab === 1) {

      $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel, event);
    }
  };
  $scope.$watch('radio.name', function (value) {
    if (value) {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, value));
      var range = commonTrackService.getDateRangePickerRange(dateRangePickerSettings, value);
      if (range === commonTrackService.dateRange.SHORT) {
        $scope.date = {
          startDate: moment().clone().startOf('day'),
          endDate: moment()
        };
      } else if (range === commonTrackService.dateRange.MID) {
        $scope.date = {
          startDate: moment().clone().startOf('week'),
          endDate: moment()
        };
      }
      startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
      endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

      // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
      $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupSummary') + ' / ' + $translate.instant('trackReporting.groupsummaryReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
      $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.groupSummary') + ' / ' + $translate.instant('trackReporting.groupsummaryReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
      commonTrackService.setDataToLocalStorage('groupSummaryRadioName', value);
    }
  });

  $scope.cancel = function () {
    $scope.showRepoTab = 0;
  };
  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, $scope.radio.name));
    angular.element('#daterange4').trigger('show.daterangepicker');
  });

  $scope.$on('$destroy', function () {
    updateDateRangeInternalDateEvent();
    if ($scope.dataAdapter) {
      delete $scope.dataAdapter;
    }
    if ($scope.gridSettings && $scope.gridSettings.source) {
      delete $scope.gridSettings.source;
    }
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/reports/performance.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12"><div class="row customer-header" id="breadcrump" style="padding: 2.5px;"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div ncy-breadcrumb="" style="font-size: 24px;"></div></div></div><div class="row" style="padding:2.5px;"><div class="col-xs-8 col-sm-8 col-md-4"><button type="button" ng-show="showRepoTab ===1" class="btn btn-default unified-btn" ng-click="cancel()"><span class="glyphicon glyphicon-arrow-left"></span><span class="span-btn-font" translate="telephoneNew.cancel"></span></button></div></div></div><div class="row" id="mappingPage"><div class="col-md-2"><label translate="trackReporting.vehicle"></label><div jqx-delete-directive="repoVehicleComboBox" type="comboBox" ng-if="isCreateCombobox"><jqx-combo-box id="repoVehicleComboBox" jqx-settings="repoVehicleSettings" class="jqx-combo-box-dsa required" jqx-on-change="repoVehicleComboChange(event)" ng-model="repoVehicle" focus-blur=""></jqx-combo-box></div></div><div class="col-md-4"><div ng-show="!error" class="form-group"><label for="daterange4" class="control-label" translate="dashBoard.fleetManagement.vehicleDetails.dateRange"></label> <input date-range-picker="" id="daterange4" name="daterange4" class="form-control date-picker" type="text" ng-model="date" clearable="true" options="options" required=""></div></div><div class="col-md-2" ng-if="showRepoTab ===1"><label translate="trackReporting.export"></label><div style="margin-top: 3px;"><div jqx-delete-directive="report_exportDropDown" type="dropDownList"><jqx-drop-down-list id="report_exportDropDown" jqx-settings="exportSetting" jqx-on-change="exportChange(event)" jqx-create="showRepoTab ===1"></jqx-drop-down-list></div></div></div></div></div></div><div class="row" style="margin-top: 0px;"><div class="col-md-2 col-md-offset-6" ng-show="showRepoTab ===1&&exportOption===\'EMail\'"><p translate="trackReporting.emailInfo"></p><div class="input-group"><input type="text" name="email" class="form-control" ng-model="reportDetail.emailAddresses"> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-show="showRepoTab ===1&&exportOption===\'EMail\'" ng-click="exportChange(\'EMail\')" translate="trackReporting.exportEmailsendBtn"></button></span></div></div></div><div class="row" style="padding:2.5px;"><div class="row" style="padding:2.5px;"><div class="col-xs-12 col-sm-12 col-md-12"><uib-tabset active="showRepoTab" class="track-tab-dsa"><uib-tab index="0" ng-click="_reportOption()"><uib-tab-heading translate="trackReporting.reportOption"></uib-tab-heading><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><fieldset ng-disabled="date.startDate===null || !repoVehicle" style="border:none"><form name="myForm" class="report-form"><div ng-repeat="item in performanceReportPropList"><div ng-if="!item._hasOption && item._isEnabled"><div class="row" style="padding-top: 5px;"><div class="col-xs-12 col-sm-12 col-md-6"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-2 col-sm-12 col-xs-12 get-report-btn"><button type="button" ng-show="radio.name ===item._reportName" class="btn btn-info" ng-click="getReport(item)" translate="trackReporting.getReport"></button> <button type="button" ng-show="radio.name ===item._reportName&&item._hasExportBtn" class="btn btn-info" ng-click="customExport(item)" translate="trackReporting.performanceReport.customExport"></button></div></div></div><div ng-if="item._hasOption && item._isEnabled"><div class="row" style="padding-top: 5px;"><div class="col-xs-12 col-sm-12 col-md-3"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-3 col-sm-12 col-xs-12"><div jqx-delete-directive="{{item._comboID}}" type="comboBox"><jqx-combo-box id="{{item._comboID}}" class="jqx-combo-box-dsa required" ng-model="reportComboOption[item._comboModelName]" jqx-create="dataLoadingFinished" ng-disabled="radio.name!==item._reportName" clear-input=\'{"responseType":1}\' focus-blur="" jqx-settings="{{item._comboSettings}}"></jqx-combo-box></div></div><div class="col-md-4 col-sm-12 col-xs-12 get-report-btn"><button type="button" ng-show="radio.name ===item._reportName" id="{{\'reportBtn\'+item._reportName}}" class="btn btn-info" ng-click="getReport(item)" translate="trackReporting.getReport"></button> <button type="button" id="{{\'exportBtn\'+item._reportName}}" ng-show="radio.name ===item._reportName&&item._hasExportBtn" class="btn btn-info" ng-click="customExport(item)" translate="trackReporting.performanceReport.customExport"></button></div></div></div></div></form></fieldset></div></div></uib-tab><uib-tab index="1" disable="diableRepoTab.report"><uib-tab-heading translate="trackReporting.report"></uib-tab-heading><div id="perforManceRepoSpliter" ng-show="isDataAvailable"><div class="splitter-panel"><div jqx-delete-directive="{{overviewGridPrefix}}vehiclePerformanceReportList" type="grid"><div id="{{overviewGridPrefix}}vehiclePerformanceReportList" ng-show="showRepoTab ===1" class="custom-header"></div></div></div><div class="splitter-panel" ng-show="hasMap"><iframe id="groupMap" ng-src="{{mapUrl | trustAsResourceUrl}}" style="display:block; width:100%; height:725px;;"></iframe></div></div><div ng-show="!isDataAvailable"><no-authorize></no-authorize></div></uib-tab></uib-tabset></div></div></div></div>');
  }]);
})();

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/15/2016.
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('trackReporting').controller('RepoPerformanceCtrl', ["$scope", "widgetSettingsCreatorService", "commonTrackService", "$timeout", "reportService", "$stateParams", "$filter", "$translate", "$uibModal", "errorHandlingService", "$rootScope", function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, $uibModal, errorHandlingService, $rootScope) {
  //var device = {};
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var startDate = '';
  var endDate = '';
  var mainUrlDetails = '&page=report.show';
  var column = [];
  var reportOptions = [];
  var _selectedReportOption = '';
  var _selectedReportOptionModel = '';
  var exportPath = '';
  var dateRangePickerSettings = {};
  $scope.moduleName = 'performancereport';
  var isGridCreated = false;
  var radioCache = commonTrackService.getDataFromLocalStorage('performanceRadioName');
  $scope.radio = {
    name: $stateParams.reportName ? $stateParams.reportName : radioCache ? radioCache : 'EventSpeedOption'
  };
  var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
  $scope.isDataAvailable = true;
  $scope.isDriverWorkingHours = true;
  $scope.reportComboOption = {
    eventSpeedOption: null,
    driverExpiringLicense: null,
    driverWorkingHours: null,
    hasDefaultReportOption: {
      eventSpeedOption: true,
      driverExpiringLicense: true,
      driverWorkingHours: false
    }
  };
  var multiSelectReportOptionNames = {
    driverWorkingHours: {
      driverID: []
    }
  };
  $scope.reportHistory = '';

  $scope.diableRepoTab = {
    report: true
  };

  $scope.showRepoTab = 0;
  $scope.reportDetail = {};
  var source = {
    datatype: 'array',
    datafields: [],
    localdata: []
  };
  $scope.date = {
    startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
    endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
  };
  $scope.performanceReportPropList = [];
  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

        if ($scope.showRepoTab === 1) {
          $scope.getReport({
            _reportName: $scope.radio.name,
            _hasMap: $scope.hasMap,
            _comboModelName: _selectedReportOptionModel
          });
        }
        /* $timeout(function () {
         $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
         }, 0);*/
      }
    }
  };

  commonTrackService.getDatePickerDetails().then(function (settings) {
    $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, $scope.radio.name));
    dateRangePickerSettings = settings;
  });

  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
    });
  };

  $scope.repoVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'deviceID',
    disabled: radioCache === 'DriverWorkingHours'
  });

  var loadReportSettings = function loadReportSettings() {
    return reportService.getReportSettings($scope.moduleName).then(function (performaceReportSettings) {
      $scope.performanceReportPropList = performaceReportSettings.reportList;
      reportOptions = performaceReportSettings.reportOptionList;
      exportPath = performaceReportSettings.exportPath;
    });
  };
  var loaddevice = function loaddevice() {
    return commonTrackService.getDeviceComboList(false).then(function (vehicleList) {
      $scope.repoVehicleSettings.source = vehicleList;
      var cacheData = commonTrackService.getDataFromLocalStorage('performanceReport');
      if ($stateParams.vehicleId) {
        $scope.repoVehicle = $stateParams.vehicleId;
      } else if (lastlocationWidgetData.selectedRow && lastlocationWidgetData.selectedRow.deviceid) {
        $scope.repoVehicle = lastlocationWidgetData.selectedRow.deviceid;
      } else if (cacheData) {
        $scope.repoVehicle = cacheData;
      } else {
        $scope.repoVehicle = $scope.repoVehicleSettings.source[0].deviceID;
      }
    });
  };
  var loadReportOptions = function loadReportOptions(name) {
    reportService.getCustomPerformanceRepotOptionComboData(name).then(function (reportOptionData) {
      if (name !== 'driverWorkingHours') {
        for (var i = 0; i < reportOptionData.length; i++) {
          reportOptionData[i].displayName = $translate.instant('trackReporting.performanceReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
        }
      }
      $scope[name + 'Settings'].source = reportOptionData;
      if ($scope.reportComboOption.hasDefaultReportOption[name]) {
        $scope.reportComboOption[name] = reportOptionData[0].key;
      }
      if (name === 'driverWorkingHours') {
        $scope[name + 'Settings'].source = _.sortBy(reportOptionData, function (optopnobj) {
          return optopnobj.description.toLowerCase();
        });
        if ($scope[name + 'Settings'].source[0].key !== 'selectAll') {
          $scope[name + 'Settings'].source.unshift({
            displayName: $translate.instant('additionalTranslation.comboboxOptionALL'),
            key: 'selectAll'
          });
        }
      }
    });
  };

  loadFleetServerDetails().then(function () {
    return loadReportSettings();
  }).then(function () {
    return loaddevice();
  }).finally(function () {

    for (var i = 0; i < reportOptions.length; i++) {
      /* create repot option combobox based on the option name specified under the reportSettings 'performanceReportSettings'
       * (e.g) 'driverWorkingHours' -> driverWorkingHoursSettings
       * refer reportService.getReportSettings()  for model, id other details of combobox.
       */
      $scope[reportOptions[i] + 'Settings'] = widgetSettingsCreatorService.createComboxSettings({
        displayMember: 'displayName',
        valueMember: 'key'
      });
      if (reportOptions[i] === 'driverWorkingHours') {
        $scope[reportOptions[i] + 'Settings'].checkboxes = true;
        $scope[reportOptions[i] + 'Settings'].autoComplete = false;
        $scope[reportOptions[i] + 'Settings'].dropDownHeight = '300px';
      }
      for (var j = 0; j < $scope.performanceReportPropList.length; j++) {
        if ($scope.performanceReportPropList[j]._comboModelName === reportOptions[i]) {
          $scope[reportOptions[i] + 'Settings'].multiSelect = $scope.performanceReportPropList[j]._isReportOptionMultiSelect;
          break;
        }
      }

      loadReportOptions(reportOptions[i]);
    }

    initExport();

    $scope.dataLoadingFinished = true;
    $('#perforManceRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
    $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('bindingcomplete', function () {
      isGridCreated = true;
      $timeout(function () {
        $('#perforManceRepoSpliter').jqxSplitter('render');
      }, 100);
    });
    $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('rowselect', function (event) {
      if (event.args && event.args.row && event.args.row.timestamp) {
        commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');
      }
    });
    $scope.initSelectionFinished = true;
    $scope.isCreateCombobox = true;
    $timeout(function () {
      $('#driverWorkingHoursComboBox').on('checkChange', driverWorkingHoursCheckBoxChangeEvent);
    }, 100);
  });

  $scope.getReport = function (reportItem, event) {
    $scope.mapUrl = '';
    var reportName = reportItem._reportName,
        hasMap = reportItem._hasMap,
        reportOption = reportItem._comboModelName,
        multiSelectedComboboxOption;
    var gridState = reportService.getReportGridState('performanceReport', reportName);
    _selectedReportOptionModel = reportOption;
    $scope.error = false;
    $scope.exportOption = 'HTML';
    $scope.diableRepoTab.report = false;
    $scope.hasMap = hasMap;
    $scope.dataLoadingFinished = false;
    if (reportItem._isReportOptionMultiSelect) {
      multiSelectedComboboxOption = $('#' + reportItem._comboID).jqxComboBox('getSelectedItems');
    }

    var multiReportOption;

    if (multiSelectedComboboxOption && multiSelectedComboboxOption.length > 0) {
      multiSelectReportOptionNames[reportItem._comboModelName][reportItem._multiSelectPropertyName] = [];
      for (var i = 0; i < multiSelectedComboboxOption.length; i++) {
        multiSelectReportOptionNames[reportItem._comboModelName][reportItem._multiSelectPropertyName].push(multiSelectedComboboxOption[i].value);
      }
      multiReportOption = multiSelectReportOptionNames[reportItem._comboModelName];
      _selectedReportOption = null;
    } else {
      _selectedReportOption = _selectedReportOption ? _selectedReportOption : '';
    }

    startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
    endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
    _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';
    $timeout(function () {
      if ($scope.hasMap) {
        $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'Device', event ? event.args.item.value : $scope.repoVehicle, _selectedReportOption, startDate, endDate);
      }
    }, 0);
    if (reportName === 'DriverWorkingHours') {
      multiReportOption = {
        driverID: _getDriverIds(hasAllOptionInSelectedList())
      };
    }
    var _tmpReportData = null;

    reportService.getVehilceReport($scope.moduleName, event ? event.args.item.value : $scope.repoVehicle, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption, multiReportOption).then(function (detailReport) {
      $scope.isDataAvailable = true;
      _tmpReportData = detailReport;
      if ($scope.reportHistory !== reportName) {
        $scope.reportHistory = reportName;
        source.localdata = detailReport.dataList;
        column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
          moduleName: reportName,
          reportModel: 'vehiclePerformanceReport'
        });
        var _additionalProperties = {
          translatedName: $translate.instant('trackReporting.performanceReport.' + reportName.toLoawerCaseAt(0)),
          isDynamicGrid: true,
          dynamicModuleName: reportName
        };
        $scope.gridSettings = commonTrackService.getGridSettings('vehiclePerformanceReport', {
          pagesizeoptions: ['25', '50', '100'],
          pagesize: 25,
          columns: column,
          autosavestate: false,
          height: 670,
          autoloadstate: false
        }, null, _additionalProperties);
        $scope.dataAdapter = new $.jqx.dataAdapter(source);
        $scope.gridSettings.source = $scope.dataAdapter;
        // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
        if (isGridCreated) {
          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid({
            source: $scope.dataAdapter,
            columns: column
          });
        }
        $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid($scope.gridSettings);
      } else {
        source.localdata = detailReport.dataList;
        $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('updatebounddata', 'data');
      }
      if ($scope.hasMap) {
        // code is not fool proof , 4 seconds wait is for map to show up and select event try to show pushpin if map is already there
        $timeout(function () {
          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('selectrow', 0);
        }, 4000);
      }
    }, function (response) {
      $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('clear');
      $scope.reportHistory = '';
      $scope.mapUrl = '';
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {

      $timeout(function () {
        $scope.showRepoTab = 1;
        if (!$scope.hasMap) {
          $('#perforManceRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
        } else {
          $('#perforManceRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
        }
        if (!$scope.isEventRegistered) {
          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('filter', function () {
            saveGridSate();
          });
          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('columnresized', function () {
            saveGridSate();
          });

          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('columnreordered', function () {
            saveGridSate();
          });

          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('sort', function () {
            saveGridSate();
          });
          $scope.isEventRegistered = true;
        }
        $scope.dataLoadingFinished = true;
        $scope.initSelectionFinished = true;
      }, 0);
      //  $('#'+$scope.overviewGridPrefix+'vehiclePerformanceReportList').jqxGrid('render');
      $timeout(function () {
        var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList';
        reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList', $scope.gridSettings, gridState, gridLocalStorageUserSettingKey);
      }, 1000);
      column = null;
    });
  };

  function saveGridSate() {
    var reportSate = $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('getstate');
    reportService.setReportGridState('performanceReport', $scope.radio.name, reportSate);
  }

  function initExport() {
    $scope.exportSetting = reportService.getExportSettings();
    $scope.exportSetting.selectedIndex = 0;
    $scope.exportOption = 'HTML';
  }

  $scope.exportChange = function (event) {
    $scope.exportURL = '';
    if (event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event.args.item.value, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, null, $scope.performanceReportPropList);
      reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);
    } else {
      $scope.exportOption = (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && event.args && event.args.item.value ? event.args.item.value : event;
      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.reportDetail.emailAddresses, $scope.performanceReportPropList);
      if (!event.args) {
        reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
      }
    }
  };

  $scope.repoVehicleComboChange = function (event) {
    var selectItem = event.args.item;
    if (selectItem) {
      commonTrackService.setDataToLocalStorage('performanceReport', selectItem.value);
    }
    if (event.args && event.args.item.value) {
      $scope.repoVehicle = event.args.item.value;
    }

    if ($scope.showRepoTab === 1) {
      $scope.getReport({
        _reportName: $scope.radio.name,
        _hasMap: $scope.hasMap,
        _comboModelName: _selectedReportOptionModel
      }, event);
    }
  };
  $scope.$watch('radio.name', function (value) {
    if (value) {
      // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
      $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.performance') + ' / ' + $translate.instant('trackReporting.performanceReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
      $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.performance') + ' / ' + $translate.instant('trackReporting.performanceReport.' + $scope.radio.name._toLowerCaseAtIndex(0));

      commonTrackService.setDataToLocalStorage('performanceRadioName', value);
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, value));
      if ($scope.dataLoadingFinished || value === 'DriverWorkingHours') {
        if (value === 'DriverWorkingHours') {
          $('#repoVehicleComboBox').jqxComboBox({ disabled: true });
          $scope.date = {
            startDate: moment().subtract(1, 'months').startOf('month').clone().startOf('day'),
            endDate: moment().subtract(1, 'months').endOf('month').clone().endOf('day')
          };
        } else {
          $('#repoVehicleComboBox').jqxComboBox({ disabled: false });
          $scope.date = {
            startDate: moment().clone().startOf('day'),
            endDate: moment()
          };
        }
      }
      startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
      endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
    }
  });

  // Model dialog for the report 'DriverWorkingHoursDatev'
  $scope.customExport = function (reportItem) {
    var dialogModel = {
      dataRange: $scope.date,
      exportPath: exportPath,
      driverOptionSetting: $scope.driverWorkingHoursSettings,
      selctedOption: $('#' + reportItem._comboID).jqxComboBox('getCheckedItems'),
      deviceId: $scope.repoVehicle
    };
    var modalInstance = $uibModal.open({
      templateUrl: 'components/track/reports/workingHoursDatevDialog.tpl.html',
      sticky: true,
      size: 'lg',
      controller: 'DriverWhDatevExportCtrl',
      resolve: {
        items: function items() {
          return dialogModel;
        }
      }
    });

    modalInstance.result.then(function () /* result */{
      //console.log(result);
    });
  };

  $scope.cancel = function () {
    $scope.showRepoTab = 0;
  };

  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, $scope.radio.name));
    angular.element('#daterange4').trigger('show.daterangepicker');
  });

  function _getDriverIds(isAll, forceUnselect) {
    var driverArr = [];
    if (!isAll) {
      var selectedDrivers = $('#driverWorkingHoursComboBox').jqxComboBox('getCheckedItems');
      for (var i = 0; i < selectedDrivers.length; i++) {
        if (selectedDrivers[i].value !== 'selectAll') {
          driverArr.push(selectedDrivers[i].value);
        }
      }
      return driverArr;
    } else {
      for (var j = 0; j < $scope.driverWorkingHoursSettings.source.length; j++) {
        if ($scope.driverWorkingHoursSettings.source[j].key !== 'selectAll') {
          driverArr.push($scope.driverWorkingHoursSettings.source[j].key);
        } else {
          if (forceUnselect) {
            isAllUncheck = true;
            $('#driverWorkingHoursComboBox').jqxComboBox('uncheckItem', 'selectAll');
            isAllUncheck = false;
          }
        }
      }
      return driverArr;
    }
  }

  function hasAllOptionInSelectedList() {
    var selectedDrivers = $('#driverWorkingHoursComboBox').jqxComboBox('getCheckedItems');
    var isAllFound = false;
    for (var i = 0; i < selectedDrivers.length; i++) {
      if (selectedDrivers[i].value === 'selectAll') {
        isAllFound = true;
        break;
      }
    }
    return isAllFound;
  }

  var isSelectAll = false;
  var isAllUncheck = false;

  function _checkOrUncheckItem(operation) {
    for (var k = 0; k < $scope.driverWorkingHoursSettings.source.length; k++) {
      $('#driverWorkingHoursComboBox').jqxComboBox(operation, $scope.driverWorkingHoursSettings.source[k].key);
    }
  }

  function driverWorkingHoursCheckBoxChangeEvent(event) {
    if (isAllUncheck || isSelectAll) {
      return;
    }
    if (event.args.item.value === 'selectAll' && event.args.checked === true) {
      isSelectAll = true;
      _checkOrUncheckItem('checkItem');
      isSelectAll = false;
      return;
    } else if (event.args.item.value === 'selectAll' && event.args.checked === false) {
      isAllUncheck = true;
      _checkOrUncheckItem('uncheckItem');
      isAllUncheck = false;
    }

    if (event.args && event.args.item) {
      isAllUncheck = true;
      $('#driverWorkingHoursComboBox').jqxComboBox('uncheckItem', 'selectAll');
      isAllUncheck = false;
    }
  }

  var workingHoursOptionClearClearEvent = $rootScope.$on('combobox-clear-selection-evt', function (event, data) {
    if (data.id === 'driverWorkingHoursComboBox') {
      // when plant combobox cleared update  related concrete type f8 object .
      isAllUncheck = true;
      _checkOrUncheckItem('uncheckItem');
      isAllUncheck = false;
    }
  });

  $scope.$on('$destroy', function () {
    updateDateRangeInternalDateEvent();
    workingHoursOptionClearClearEvent();
    if ($scope.dataAdapter) {
      delete $scope.dataAdapter;
    }
    if ($scope.gridSettings && $scope.gridSettings.source) {
      delete $scope.gridSettings.source;
    }
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/15/2016.
 */


angular.module('trackReporting').service('reportService', ["crudService", "$q", "Restangular", "AuthenticationService", "localStorageService", "$window", "$translate", "toastService", "widgetSettingsCreatorService", "commonTrackService", function (crudService, $q, Restangular, AuthenticationService, localStorageService, $window, $translate, toastService, widgetSettingsCreatorService, commonTrackService) {

  var ReportProps = function ReportProps() {
    return {
      reportList: [],
      reportOptionList: [],
      exportPath: ''
    };
  };
  var reportSettingsObj = {
    performancereport: new ReportProps(),
    groupdetailsreport: new ReportProps(),
    vehicledetailsreport: new ReportProps(),
    groupsummary: new ReportProps()
  };

  this.getVehilceReport = function (modelName, deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, reportOptions) {
    var param = generateReqParms(deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'device', reportOptions);
    return crudService.customGET(modelName, reportName.toLowerCase(), param);
  };

  this.getGroupReport = function (modelName, groupId, timeTo, timeFrom, dataRefresh, reportName, reportOption) {
    var param = generateReqParms(groupId, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'group');
    return crudService.customGET(modelName, reportName.split('_Group')[0].toLowerCase(), param);
  };

  function generateReqParms(typeId, timeTo, timeFrom, dataRefresh, reportName, reportOption, type, reportOptions) {
    var requestParam = {};
    if (type === 'group') {
      requestParam.vehicleGroup = typeId;
    }
    if (type === 'device') {
      requestParam.deviceid = typeId;
    }
    requestParam.dataRefresh = dataRefresh;
    requestParam.timeTo = timeTo;
    requestParam.timeFrom = timeFrom;
    requestParam.reportName = reportName;
    requestParam.reportOption = reportOption;
    requestParam.reportOptions = reportOptions;
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return param;
  }

  this.getTripReportOptions = function () {
    return crudService.get('vehicledetailsreport/options/tripreport');
  };

  this.getMotionSummaryOptions = function () {
    return crudService.get('vehicledetailsreport/options/motionsummary');
  };

  this.getDigitalInputDetailReportOptions = function () {
    return crudService.get('vehicledetailsreport/options/digitalinputdetailreport');
  };

  this.getEventCountByDayOptions = function () {
    return crudService.get('vehicledetailsreport/options/eventcountbyday');
  };

  this.getDeviceNearbyDevicesOptions = function () {
    return crudService.get('vehicledetailsreport/options/devicenearbydevices');
  };

  this.getCustomVehicleRepotOptionComboData = function (reportOptionComboType) {
    return crudService.get('vehicledetailsreport/options/' + reportOptionComboType.toLowerCase());
  };

  this.getCustomGroupRepotOptionComboData = function (reportOptionComboType) {
    return crudService.get('groupdetailsreport/options/' + reportOptionComboType.toLowerCase());
  };

  this.getCustomPerformanceRepotOptionComboData = function (reportOptionComboType) {
    return crudService.get('performancereport/options/' + reportOptionComboType.toLowerCase());
  };

  this.getCustomGroupSummaryRepotOptions = function (reportOptionComboType) {
    return crudService.get('groupsummary/options/' + reportOptionComboType.toLowerCase());
  };

  this.getExportSettings = function () {
    var source = ['HTML', 'CSV', 'XLS', 'EMail'];

    // init DropDownList's settings object.
    var exportSettings = {
      placeHolder: 'format : ',
      width: 200, height: 25,
      autoDropDownHeight: true,

      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
      source: source
    };

    return exportSettings;
  };

  this.vehicleDetailReportProperties = function () {
    var repotProperty = {
      'EventDetailAll': {
        hasMap: true
      }
    };
    return repotProperty;
  };

  String.prototype._toLowerCaseAtIndex = function (index) {
    return this.charAt(index).toLocaleLowerCase() + this.slice(1);
  };

  this.driverWrkHrsDatevVtmDownload = function (modelName, deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, reportOptions) {
    var param = generateReqParms(deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'device', reportOptions);
    return Restangular.one(modelName + '/' + reportName.toLowerCase() + '/download/vtm' + '?filter=' + encodeURI(param.filter)).withHttpConfig({ responseType: 'arraybuffer' }).get();
  };
  this.driverWrkHrsDatevExcelDownload = function (modelName, deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, reportOptions) {
    var param = generateReqParms(deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'device', reportOptions);
    return Restangular.one(modelName + '/' + reportName.toLowerCase() + '/download/xls' + '?filter=' + encodeURI(param.filter)).withHttpConfig({ responseType: 'arraybuffer' }).get();
  };

  this.getReportSettings = function (moduleName) {
    if (reportSettingsObj[moduleName].reportList.length > 0) {
      var deferred = $q.defer();
      deferred.resolve(reportSettingsObj[moduleName]);
      return deferred.promise;
    } else {
      return crudService.get(moduleName + '/reportsettings/').then(function (repoSetting) {

        for (var i = 0; i < repoSetting.reportSettings.length; i++) {
          var _tmpRepName = repoSetting.reportSettings[i].reportName.toLoawerCaseAt(0);
          reportSettingsObj[moduleName].reportList.push({
            _isEnabled: repoSetting.reportSettings[i].enabled,
            _reportName: repoSetting.reportSettings[i].reportName,
            _idName: _tmpRepName + 'Radio',
            _translationProp: 'trackReporting.performanceReport.' + _tmpRepName,
            _hasOption: repoSetting.reportSettings[i].reportOptionName ? true : false,
            _isReportOptionMultiSelect: repoSetting.reportSettings[i].reporOptionMultiSelect || false,
            _multiSelectPropertyName: repoSetting.reportSettings[i].multiSelectPropertyName || '',
            _comboID: repoSetting.reportSettings[i].reportOptionName + 'ComboBox' || '',
            _comboModelName: repoSetting.reportSettings[i].reportOptionName || '',
            _comboSettings: _tmpRepName + 'Settings',
            _hasMap: repoSetting.reportSettings[i].hasMap,
            _hasExportBtn: repoSetting.reportSettings[i].hasCustomExportBtn || false
          });
        }
        reportSettingsObj[moduleName].reportOptionList = repoSetting.reportOptionsList;
        reportSettingsObj[moduleName].exportPath = repoSetting.exportPath;
        return reportSettingsObj[moduleName];
      });
    }
  };

  this.getReportSpliterWithMapPanel = function () {
    return {
      width: '100%',
      height: 725,
      orientation: 'vertical',
      splitBarSize: 10,
      panels: [{ size: '80%', collapsible: true }, { size: '20%', collapsible: false }]
    };
  };
  this.getReportSplitterWithoutMapPannel = function () {
    return {
      width: '100%',
      height: 725,
      orientation: 'vertical',
      splitBarSize: 0,
      panels: [{ size: '100%', collapsible: false }]
    };
  };
  /**
   * Following method used to store GridState to manually to the local storage
   * @param reportType
   * @param reportName
   * @param gridState
   */
  this.setReportGridState = function (reportType, reportName, gridState) {
    var loginID = AuthenticationService.GetLoginID();
    localStorageService.set(reportType + '.' + reportName + '.' + loginID.Account + '.' + loginID.username, gridState);
  };
  /**
   * Following method used o retrieve the GridState of the specified Report
   * @param reportType
   * @param reportName
   */
  this.getReportGridState = function (reportType, reportName) {
    var loginID = AuthenticationService.GetLoginID();
    return localStorageService.get(reportType + '.' + reportName + '.' + loginID.Account + '.' + loginID.username);
  };

  this.doExport = function (exportURL, reportName, type) {

    Restangular.one('reportexport' + '/initexport/' + reportName + '/' + type + '?filter=' + exportURL).withHttpConfig({ responseType: 'arraybuffer' }).get().then(function (data) {

      var blob;
      switch (type) {
        case 'XLS':
          blob = new $window.Blob([data], {
            type: 'application/vnd.ms-excel ;charset=windows-1252'
          });
          break;
        case 'EMail':
          toastService.showSuccessToast($translate.instant('trackReporting.emailSendSuccessfully'));
          return data;
        default:
          blob = new $window.Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), data], { type: 'text/' + type.toLocaleLowerCase() });
      }

      var repoExportName = 'Track_' + reportName + '.' + type.toLocaleLowerCase();
      saveAs(blob, repoExportName);
      toastService.showSuccessToast($translate.instant('trackReporting.reportExportSuccess'));
    }, function () /* response */{
      if (type === 'EMail') {
        toastService.showWarningToast($translate.instant('trackReporting.emailSendingFailed'));
      } else {
        toastService.showWarningToast($translate.instant('trackReporting.reportExportFailed'));
      }
    });
  };

  this.loadReportCustomGridState = function (translationObj, gridId, gridSetting, localStorageCustomVal, gridLocalStorageUserSettingKey) {
    var userSettings = commonTrackService.getGtsLocalStorageSettings();
    if (translationObj !== null && translationObj.columnTranslation) {
      if (localStorageCustomVal && localStorageCustomVal.columns) {
        for (var gridColumn in localStorageCustomVal.columns) {
          if (translationObj.columnTranslation[gridColumn] !== undefined) {
            localStorageCustomVal.columns[gridColumn].text = translationObj.columnTranslation[gridColumn]; //rewrite
          }
          if (gridSetting && gridSetting.columns) {
            for (var f = 0; f < gridSetting.columns.length; f++) {
              if (localStorageCustomVal.columns[gridColumn].text === gridSetting.columns[f].text) {
                localStorageCustomVal.columns[gridColumn].hidden = gridSetting.columns[f].hidden;
                localStorageCustomVal.columns[gridColumn].pinned = false; // reset pinned column
                break;
              }
            }
          }
        }
      }
    }
    if (userSettings && userSettings.gridsSetting[gridLocalStorageUserSettingKey]) {
      //set column order
      if (userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders) {
        for (var showIndex in userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders) {

          var fieldName = userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders[showIndex].name;
          if (localStorageCustomVal.columns[fieldName]) {
            localStorageCustomVal.columns[fieldName].index = parseInt(showIndex);
          }
        }
      }
      // set the frozen column from userSetting local object to grdi custom local storage entry .
      if (userSettings.gridsSetting[gridLocalStorageUserSettingKey].frozenColumns) {
        for (var pinnedIndex in userSettings.gridsSetting[gridLocalStorageUserSettingKey].frozenColumns) {
          var pinnedfieldName = userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders[pinnedIndex].name;
          if (localStorageCustomVal.columns[pinnedfieldName]) {
            localStorageCustomVal.columns[pinnedfieldName].pinned = true;
          }
        }
      }
    }

    $(gridId).jqxGrid('loadstate', localStorageCustomVal);
    $(gridId).jqxGrid('selectrow', 0);
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/reports/vehicleDetailReport.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12"><div class="row customer-header" id="breadcrump" style="padding:2.5px;"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><div ncy-breadcrumb="" style="font-size: 24px;"></div></div></div><div class="row" style="padding:2.5px;"><div class="col-xs-8 col-sm-8 col-md-4"><button type="button" ng-show="showRepoTab ===1" class="btn btn-default unified-btn" ng-click="cancel()"><span class="glyphicon glyphicon-arrow-left"></span><span class="span-btn-font" translate="telephoneNew.cancel"></span></button></div></div></div><div class="row" id="mappingPage"><div class="col-md-2"><label translate="trackReporting.vehicle"></label><div jqx-delete-directive="repoVehicleComboBox" type="comboBox" ng-if="isCreateCombobox"><jqx-combo-box id="repoVehicleComboBox" jqx-settings="repoVehicleSettings" class="jqx-combo-box-dsa required" jqx-on-change="repoVehicleComboChange(event)" ng-model="repoVehicle" clear-input="" focus-blur=""></jqx-combo-box></div></div><div class="col-md-4"><div ng-show="!error" class="form-group"><label for="daterange4" class="control-label" translate="dashBoard.fleetManagement.vehicleDetails.dateRange"></label> <input date-range-picker="" id="daterange4" name="daterange4" class="form-control date-picker" type="text" ng-model="date" clearable="true" options="options" required=""></div></div><div class="col-md-2" ng-if="showRepoTab ===1"><label translate="trackReporting.export"></label><div style="margin-top: 3px;"><div jqx-delete-directive="report_exportDropDown" type="dropDownList"><jqx-drop-down-list id="report_exportDropDown" jqx-settings="exportSetting" jqx-on-change="exportChange(event)" jqx-create="showRepoTab ===1"></jqx-drop-down-list></div></div></div></div></div></div><div class="row" style="margin-top: 0px;"><div class="col-md-2 col-md-offset-6" ng-if="showRepoTab ===1&&exportOption===\'EMail\'"><p translate="trackReporting.emailInfo"></p><div class="input-group"><input type="text" name="email" class="form-control" ng-model="reportDetail.emailAddresses"> <span class="input-group-btn"><button class="btn btn-info" type="button" ng-if="showRepoTab ===1&&exportOption===\'EMail\'" ng-click="exportChange(\'EMail\')" translate="trackReporting.exportEmailsendBtn"></button></span></div></div></div><div class="row" style="padding:2.5px;"><div class="row" style="padding:2.5px;"><div class="col-xs-12 col-sm-12 col-md-12"><uib-tabset active="showRepoTab" class="track-tab-dsa"><uib-tab index="0"><uib-tab-heading translate="trackReporting.reportOption"></uib-tab-heading><div class="row"><div class="col-xs-12 col-sm-12 col-md-12"><fieldset ng-disabled="date.startDate===null || !repoVehicle" style="border:none"><form name="myForm" class="report-form"><div ng-repeat="item in vehicleDetailReportPropList"><div ng-if="!item._hasOption && item._isEnabled"><div class="row" style="padding-top: 5px;"><div class="col-xs-12 col-sm-12 col-md-6"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-2 col-sm-12 col-xs-12 get-report-btn"><button type="button" ng-show="radio.name ===item._reportName" class="btn btn-info" ng-click="getReport(item._reportName, item._hasMap)" translate="trackReporting.getReport"></button></div></div></div><div ng-if="item._hasOption && item._isEnabled"><div class="row" style="padding-top: 5px;"><div class="col-xs-12 col-sm-12 col-md-3"><input id="{{item._idName}}" type="radio" ng-model="radio.name" value="{{item._reportName}}" style="vertical-align:sub;"> <label for="{{item._idName}}" translate="{{item._translationProp}}"></label></div><div class="col-md-3 col-sm-12 col-xs-12"><div jqx-delete-directive="{{item._comboID}}" type="comboBox"><jqx-combo-box id="{{item._comboID}}" class="jqx-combo-box-dsa required" ng-model="reportComboOption[item._comboModelName]" jqx-create="dataLoadingFinished" ng-disabled="radio.name!==item._reportName" clear-input="" focus-blur="" jqx-settings="{{item._comboSettings}}"></jqx-combo-box></div></div><div class="col-md-2 col-sm-12 col-xs-12 get-report-btn"><button type="button" ng-show="radio.name ===item._reportName" class="btn btn-info" ng-click="getReport(item._reportName, item._hasMap, item._comboModelName)" translate="trackReporting.getReport"></button></div></div></div></div></form></fieldset></div></div></uib-tab><uib-tab index="1" disable="diableRepoTab.report"><uib-tab-heading translate="trackReporting.report"></uib-tab-heading><div id="vhlDetailRepoSpliter" ng-show="isDataAvailable"><div class="splitter-panel"><div jqx-delete-directive="{{overviewGridPrefix}}vehicleDetailReportList" type="grid"><div id="{{overviewGridPrefix}}vehicleDetailReportList" ng-show="showRepoTab ===1" class="custom-header"></div></div></div><div class="splitter-panel" ng-show="hasMap"><iframe id="groupMap" ng-src="{{mapUrl | trustAsResourceUrl}}" style="display:block; width:100%; height:725px;"></iframe></div></div><div ng-if="!isDataAvailable"><no-authorize></no-authorize></div></uib-tab></uib-tabset></div></div></div></div>');
  }]);
})();

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 1/15/2016.
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('trackReporting').controller('RepoVehicleDetailCtrl', ["$scope", "widgetSettingsCreatorService", "commonTrackService", "$timeout", "reportService", "$stateParams", "$filter", "$translate", "errorHandlingService", function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, errorHandlingService) {
  //var device = {};
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var startDate = '';
  var endDate = '';
  var mainUrlDetails = '&page=map.device.full';
  var column = [];
  var reportOptions = ['tripReport', 'motionSummary', 'digitalInputDetailReport', 'eventCountByDay', 'deviceNearbyDevices'];
  var dateRangePickerSettings = {};
  var _selectedReportOption = '';
  var _selectedReportOptionModel = '';
  var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
  var radioCache = commonTrackService.getDataFromLocalStorage('vehicleDetailRadioName');
  $scope.isDataAvailable = true;
  $scope.radio = {
    name: $stateParams.reportName ? $stateParams.reportName : radioCache ? radioCache : 'EventDetail'
  };

  $scope.reportDetail = {};
  $scope.repoVehicle = $stateParams.vehicleId;
  $scope.moduleName = 'vehicledetailsreport';
  var isGridCreated = false;
  $scope.reportComboOption = {
    tripReport: null,
    motionSummary: null,
    digitalInputDetailReport: null,
    eventCountByDay: null,
    deviceNearbyDevices: null
  };
  var reportPropertiesObject = reportService.vehicleDetailReportProperties();
  $scope.reportHistory = '';

  $scope.diableRepoTab = {
    report: true
  };

  $scope.showRepoTab = 0;

  var source = {
    datatype: 'array',
    datafields: [],
    localdata: []
  };
  $scope.date = {
    startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
    endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
  };

  $scope.vehicleDetailReportPropList = [{
    _isEnabled: true,
    _reportName: 'EventDetail',
    _idName: 'eventDetailRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.eventDetail',
    _hasOption: false,
    _hasMap: true
  }, {
    _isEnabled: true,
    _reportName: 'EventDetailAll',
    _idName: 'eventDetailAllRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.eventDetailAll',
    _hasOption: false,
    _hasMap: true
  }, {
    _isEnabled: true,
    _reportName: 'TripReport',
    _idName: 'tripReportRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.tripReport',
    _hasOption: true,
    _comboID: 'tripreportComboBox',
    _comboModelName: 'tripReport',
    _comboSettings: 'tripReportSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'MotionSummary',
    _idName: 'motionSummaryRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.motionSummary',
    _hasOption: true,
    _comboID: 'motionsummaryComboBox',
    _comboModelName: 'motionSummary',
    _comboSettings: 'motionSummarySettings',
    _hasMap: true
  }, {
    _isEnabled: true,
    _reportName: 'DeviceWorkOrders',
    _idName: 'deviceWorkOrdersRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.deviceWorkOrders',
    _hasOption: false,
    _hasMap: true
  }, {
    _isEnabled: false,
    _reportName: 'GeozoneDriving',
    _idName: 'geozoneDrivingRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.geozoneDriving',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'JobReport',
    _idName: 'jobReportRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.jobReport',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'DigitalInputDetailReport',
    _idName: 'digitalInputDetailReportRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.digitalInputDetailReport',
    _hasOption: true,
    _comboID: 'digitalinputdetailreportComboBox',
    _comboModelName: 'digitalInputDetailReport',
    _comboSettings: 'digitalInputDetailReportSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'EventCountByDay',
    _idName: 'eventCountByDayRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.eventCountByDay',
    _hasOption: true,
    _comboID: 'eventcountbydayComboBox',
    _comboModelName: 'eventCountByDay',
    _comboSettings: 'eventCountByDaySettings',
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'EventIdle',
    _idName: 'eventIdleRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.eventIdle',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'DriverMessageDetail',
    _idName: 'driverMessageDetailRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.driverMessageDetail',
    _hasOption: false,
    _hasMap: true
  }, {
    _isEnabled: false,
    _reportName: 'EventDetailOBDLight',
    _idName: 'eventDetailOBDLightRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.eventDetailOBDLight',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'FuelRegisterDetail',
    _idName: 'fuelRegisterDetailRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.fuelRegisterDetail',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'DailyDistanceDetail',
    _idName: 'dailyDistanceDetailRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.dailyDistanceDetail',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: false,
    _reportName: 'DeviceNearbyDevices',
    _idName: 'deviceNearbyDevicesRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.deviceNearbyDevices',
    _hasOption: true,
    _comboID: 'devicenearbydevicesComboBox',
    _comboModelName: 'deviceNearbyDevices',
    _comboSettings: 'deviceNearbyDevicesSettings',
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'EventDetailCargoQuality',
    _idName: 'eventDetailCargoQualityRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.eventDetailCargoQuality',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'NotifyQueueDetail',
    _idName: 'notifyQueueDetailRadio',
    _translationProp: 'trackReporting.groupDetailReport.notifyQueueDetail_Group',
    _hasOption: false,
    _hasMap: false
  }, {
    _isEnabled: true,
    _reportName: 'FuelTracker',
    _idName: 'fuelTrackerReportRadio',
    _translationProp: 'trackReporting.vehicleDetailReport.fuelTracker',
    _hasOption: false,
    _hasMap: false
  }];
  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
        if ($scope.showRepoTab === 1) {
          $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel);
        }
        /* $timeout(function () {
         $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
         }, 0);*/
      }
    }
  };
  commonTrackService.getDatePickerDetails().then(function (settings) {
    $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, $scope.radio.name));
    dateRangePickerSettings = settings;
  });

  var loadFleetServerDetails = function loadFleetServerDetails() {
    return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
      $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
    });
  };

  $scope.repoVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'deviceID'
  });

  $scope.tripReportSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.motionsummarySettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.motionSummarySettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.digitalInputDetailReportSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.eventCountByDaySettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  $scope.deviceNearbyDevicesSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'displayName',
    valueMember: 'key'
  });

  var loaddevice = function loaddevice() {
    return commonTrackService.getDeviceComboList(false).then(function (vehicleList) {
      $scope.repoVehicleSettings.source = vehicleList;
      var cacheData = commonTrackService.getDataFromLocalStorage('vehicleDetailReport');
      if ($stateParams.vehicleId) {
        $scope.repoVehicle = $stateParams.vehicleId;
      } else if (lastlocationWidgetData.selectedRow && lastlocationWidgetData.selectedRow.deviceid) {
        $scope.repoVehicle = lastlocationWidgetData.selectedRow.deviceid;
      } else if (cacheData) {
        $scope.repoVehicle = cacheData;
      } else {
        $scope.repoVehicle = $scope.repoVehicleSettings.source[0].deviceID;
      }
    });
  };
  var loadReportOptions = function loadReportOptions(name) {
    reportService.getCustomVehicleRepotOptionComboData(name).then(function (reportOptionData) {
      for (var i = 0; i < reportOptionData.length; i++) {
        reportOptionData[i].displayName = $translate.instant('trackReporting.vehicleDetailReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
      }
      $scope[name + 'Settings'].source = reportOptionData;
      $scope.reportComboOption[name] = reportOptionData[0].key;
    });
  };

  loadFleetServerDetails().then(function () {

    return loaddevice();
  }).finally(function () {
    $('#vhlDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());

    for (var i = 0; i < reportOptions.length; i++) {
      loadReportOptions(reportOptions[i]);
    }
    initExport();
    $scope.dataLoadingFinished = true;
    $scope.isCreateCombobox = true;

    if ($stateParams.reportName && $stateParams.vehicleId && $stateParams.dateFrom && $stateParams.dateTo) {
      $timeout(function () {
        $scope.getReport($stateParams.reportName, reportPropertiesObject[$stateParams.reportName] ? reportPropertiesObject[$stateParams.reportName].hasMap : false);

        $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('bindingcomplete', function () {
          isGridCreated = true;
          $timeout(function () {
            $('#vhlDetailRepoSpliter').jqxSplitter('render');
          }, 400);
        });
      }, 100);
    }
    $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('bindingcomplete', function () {
      isGridCreated = true;
      $timeout(function () {
        $('#vhlDetailRepoSpliter').jqxSplitter('render');
      }, 100);
    });

    $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('rowselect', function (event) {
      if (event.args && event.args.row) {
        if (event.args.row.timestamp) {
          commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');
        }
        if ($scope.reportHistory === 'DeviceWorkOrders') {
          var _tmpStartDate = commonTrackService.formatReportDateTime(event.args.row.workorderstartdate, event.args.row.workorderstarttime, false);
          var _tmpEndDate = commonTrackService.formatReportDateTime(event.args.row.workorderenddate, event.args.row.workorderendtime, false);
          $scope.$apply(function () {
            $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', $scope.repoVehicle, '', _tmpStartDate, _tmpEndDate);
            $scope.mapUrl += '&pushpins_dsa=all';
          });
        }
        if ($scope.reportHistory === 'MotionSummary' && event.args.row.startdatetime && event.args.row.stopdatetime) {
          var _tmpStartDateTime = commonTrackService.formatReportDateTime(event.args.row.startdatetime.split(' ')[0], event.args.row.startdatetime.split(' ')[1], false);
          var _tmpEndDateTime = commonTrackService.formatReportDateTime(event.args.row.stopdatetime.split(' ')[0], event.args.row.stopdatetime.split(' ')[1], false);
          $scope.$apply(function () {
            $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', $scope.repoVehicle, '', _tmpStartDateTime, _tmpEndDateTime);
            $scope.mapUrl += '&pushpins_dsa=all';
          });
        }
      }
    });
  });

  $scope.getReport = function (reportName, hasMap, reportOption, event) {
    $scope.mapUrl = '';
    var gridState = reportService.getReportGridState('vehicleDetailReport', reportName);
    _selectedReportOptionModel = reportOption;

    $scope.error = false;
    $scope.exportOption = 'HTML';
    $scope.diableRepoTab.report = false;
    $scope.hasMap = hasMap;
    $scope.dataLoadingFinished = false;

    startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
    endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

    // remove state param date range so that it is not used again
    delete $stateParams.dateFrom;
    delete $stateParams.dateTo;

    _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';

    var _tmpReportData = null;
    reportService.getVehilceReport($scope.moduleName, event ? event.args.item.value : $scope.repoVehicle, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption !== null ? _selectedReportOption : '').then(function (detailReport) {
      $scope.isDataAvailable = true;
      _tmpReportData = detailReport;
      if ($scope.reportHistory !== reportName) {
        $scope.reportHistory = reportName;
        source.localdata = detailReport.dataList;
        source.sort = commonTrackService.getCustomReportSortFunction($scope.overviewGridPrefix + 'vehicleDetailReportList', source);
        column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
          moduleName: reportName,
          reportModel: 'vehicleDetailReport'
        });
        var _additionalProperties = {
          translatedName: $translate.instant('trackReporting.vehicleDetailReport.' + reportName.toLoawerCaseAt(0)),
          isDynamicGrid: true,
          dynamicModuleName: reportName
        };
        $scope.gridSettings = commonTrackService.getGridSettings('vehicleDetailReport', {
          pagesizeoptions: ['25', '50', '100'],
          pagesize: 25,
          columns: column,
          autosavestate: false,
          height: 730,
          autoloadstate: false
        }, null, _additionalProperties);
        $scope.dataAdapter = new $.jqx.dataAdapter(source);
        $scope.gridSettings.source = $scope.dataAdapter;
        // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
        if (isGridCreated) {
          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid({
            source: $scope.dataAdapter,
            columns: column
          });
        }
        $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid($scope.gridSettings);
      } else {
        source.localdata = detailReport.dataList;
        $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('updatebounddata', 'data');
      }

      if ($scope.hasMap) {
        // code is not fool proof , 4 seconds wait is for map to show up and select event try to show pushpin if map is already there
        $timeout(function () {
          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('selectrow', 0);
        }, 4000);
      }
    }, function (response) {
      $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('clear');
      $scope.reportHistory = '';
      $scope.mapUrl = '';
      if (errorHandlingService.errorForNoAuthorized(response)) {
        $scope.isDataAvailable = false;
      }
    }).finally(function () {

      $timeout(function () {
        $scope.showRepoTab = 1;
        if (!$scope.hasMap) {
          $('#vhlDetailRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
        } else {
          $('#vhlDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
        }

        if ($scope.hasMap) {
          $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'Device', event ? event.args.item.value : $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
        }
        if (!$scope.isEventRegistered) {
          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('filter', function () {
            saveGridSate();
          });
          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('columnresized', function () {
            saveGridSate(reportName);
          });

          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('columnreordered', function () {
            saveGridSate(reportName);
          });

          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('sort', function () {
            saveGridSate(reportName);
          });
          $scope.isEventRegistered = true;
        }
      }, 0);
      $timeout(function () {
        var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'vehicleDetailReportList';
        reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'vehicleDetailReportList', $scope.gridSettings, gridState, gridLocalStorageUserSettingKey);
      }, 1000);
      column = null;
    });
  };

  function saveGridSate() {
    var reportSate = $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('getstate');
    reportService.setReportGridState('vehicleDetailReport', $scope.radio.name, reportSate);
  }

  function initExport() {
    $scope.exportSetting = reportService.getExportSettings();
    $scope.exportSetting.selectedIndex = 0;
    $scope.exportOption = 'HTML';
  }

  $scope.exportChange = function (event) {
    $scope.exportURL = '';

    if ((typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event.args.item.value, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
      reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);
    } else {
      $scope.exportOption = (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object' && event.args && event.args.item.value ? event.args.item.value : event;
      $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.reportDetail.emailAddresses);
      if (!event.args) {
        reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
      }
    }
  };
  $scope.repoVehicleComboChange = function (event) {
    var selectItem = event.args.item;
    if (selectItem) {
      commonTrackService.setDataToLocalStorage('vehicleDetailReport', selectItem.value);
    }
    if (event.args && event.args.item.value) {
      $scope.repoVehicle = event.args.item.value;
    }
    if ($scope.showRepoTab === 1) {

      $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel, event);
    }
  };
  $scope.$watch('radio.name', function (value) {
    if (value) {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, value));
      var range = commonTrackService.getDateRangePickerRange(dateRangePickerSettings, value);
      if ($stateParams.dateFrom && $stateParams.dateTo && $stateParams.hasCustomDateRange) {
        $scope.date = {
          startDate: new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')),
          endDate: new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' '))
        };
      } else if (range === commonTrackService.dateRange.SHORT) {
        $scope.date = {
          startDate: moment().clone().startOf('day'),
          endDate: moment()
        };
      } else if (range === commonTrackService.dateRange.MID) {
        $scope.date = {
          startDate: moment().clone().startOf('week'),
          endDate: moment()
        };
      }
      startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
      endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

      // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
      $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.vehicleDetail') + ' / ' + $translate.instant('trackReporting.vehicleDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
      $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.vehicleDetail') + ' / ' + $translate.instant('trackReporting.vehicleDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
      commonTrackService.setDataToLocalStorage('vehicleDetailRadioName', value);
    }
  });
  $scope.cancel = function () {
    $scope.showRepoTab = 0;
  };
  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings, $scope.radio.name));
    angular.element('#daterange4').trigger('show.daterangepicker');
  });

  $scope.$on('$destroy', function () {
    updateDateRangeInternalDateEvent();
    if ($scope.dataAdapter) {
      delete $scope.dataAdapter;
    }
    if ($scope.gridSettings && $scope.gridSettings.source) {
      delete $scope.gridSettings.source;
    }
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/reports/workingHoursDatevDialog.tpl.html', '<div xmlns="http://www.w3.org/1999/html"><form name="workingHoursDatevForm"><div class="modal-header"><h3 class="modal-title" translate="trackReporting.performanceReport.customExportDialog.title"></h3></div><div class="modal-body"><div class="row" style="padding: 2.5px;"><div class="col-md-4 col-sm-4 col-xs-4"><div class="form-group"><label for="daterange4" class="control-label" translate="dashBoard.fleetManagement.vehicleDetails.dateRange"></label> <input date-range-picker="" id="daterange4" name="daterange4" class="form-control date-picker" type="text" ng-model="date" clearable="true" options="options" required=""></div></div><div class="col-md-6 col-sm-6 col-xs-6"><label translate="trackReporting.performanceReport.customExportDialog.driver"></label><jqx-combo-box id="driverComboBoxDateEvDialog" jqx-settings="workingHoursDatev.driverComboSettings" class="jqx-combo-box-dsa" ng-model="workingHoursDatev.driver" jqx-on-select="driverSelectEvt(event)" clear-input=\'{"responseType":1}\' focus-blur=""></jqx-combo-box></div><div class="col-md-2 col-sm-2 col-xs-2"><button type="button" class="btn btn-info" ng-click="getReport()" style="margin-top: 25px;" translate="trackReporting.getReport"></button></div></div><div class="row" style="padding: 2.5px;"><div class="col-md-12 col-sm-12 col-xs-12"><div id="{{overviewGridPrefix}}driverWorkingHrsDatevReportList" class="custom-header"></div></div></div><div class="modal-footer"><div class="row"><div class="col-sm-8 col-md-8 col-xs-8"></div><div class="col-sm-2 col-md-2 col-xs-2"><button type="button" class="btn btn-primary" ng-click="exportDatev()" translate="trackReporting.performanceReport.customExportDialog.export"></button></div><div class="col-sm-1 col-md-1 col-xs-1"><button type="button" class="btn btn-warning" ng-click="cancel()" translate="trackReporting.performanceReport.customExportDialog.cancel"></button></div></div></div></div></form></div>');
  }]);
})();

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by rak on 8/15/2016.
 */


angular.module('trackReporting').controller('DriverWhDatevExportCtrl', ["$scope", "commonTrackService", "widgetSettingsCreatorService", "items", "reportService", "$filter", "$translate", "$window", "toastService", "errorHandlingService", "$timeout", "$rootScope", function ($scope, commonTrackService, widgetSettingsCreatorService, items, reportService, $filter, $translate, $window, toastService, errorHandlingService, $timeout, $rootScope) {
  var startDate = '';
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  var endDate = '';
  var source = {
    datatype: 'array',
    datafields: [],
    localdata: []
  };
  $scope.alerts = [];
  var dataAdapter;
  var column = [];
  var isInitialLoading = false;
  var gridSettings;
  $scope.moduleName = 'performancereport';
  var dialogModelData = items.dataRange;
  $scope.date = {
    startDate: dialogModelData.startDate || new Date(),
    endDate: dialogModelData.endDate || new Date()
  };
  $scope.workingHoursDatev = {};

  var dateRangeCustomEventHandler = {
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        startDate = $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
        endDate = $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
        loadRport();
      }
    }
  };
  $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler);

  $scope.workingHoursDatev.driverComboSettings = items.driverOptionSetting;
  $scope.workingHoursDatev.driverComboSettings.checkboxes = true;
  $scope.workingHoursDatev.driverComboSettings.autoComplete = false;
  if ($scope.workingHoursDatev.driverComboSettings.source[0].key !== 'selectAll') {
    $scope.workingHoursDatev.driverComboSettings.source.unshift({
      displayName: $translate.instant('additionalTranslation.comboboxOptionALL'),
      key: 'selectAll'
    });
  }

  $scope.workingHoursDatev.driverComboSettings.multiSelect = true;

  function setSelectedVehicles(item) {
    $timeout(function () {
      $('#driverComboBoxDateEvDialog').jqxComboBox('checkItem', item.value);
    }, 100);
  }

  function hasAllOptionInSelectedList() {
    var selectedDrivers = $('#driverComboBoxDateEvDialog').jqxComboBox('getCheckedItems');
    var isAllFound = false;
    for (var i = 0; i < selectedDrivers.length; i++) {
      if (selectedDrivers[i].value === 'selectAll') {
        isAllFound = true;
        break;
      }
    }
    return isAllFound;
  }

  $timeout(function () {
    $('#driverComboBoxDateEvDialog').on('checkChange', checkChangeEvent);
  });
  var loadRport = function loadRport(driverIdsFromLoadCall) {
    $scope.date.startDate = moment($scope.date.startDate);
    $scope.date.endDate = moment($scope.date.endDate);
    startDate = $filter('date')($scope.date.startDate._d, 'yyyy/MM/dd/HH:mm:ss');
    endDate = $filter('date')($scope.date.endDate._d, 'yyyy/MM/dd/HH:mm:ss');
    var driverIds = {
      driverID: []
    };

    driverIds.driverID = driverIdsFromLoadCall && driverIdsFromLoadCall.length > 0 || isInitialLoading ? driverIdsFromLoadCall : _getDriverIds(hasAllOptionInSelectedList());

    reportService.getVehilceReport($scope.moduleName, items.deviceId, endDate, startDate, true, 'DriverWorkingHoursDatev', null, driverIds).then(function (datevRepotList) {

      source.localdata = datevRepotList.dataList;
      column = commonTrackService.getColumnProperties(datevRepotList.gridSettings.overviewListGrids[0].columnProperties, datevRepotList.columnTranslation, {
        moduleName: 'DriverWorkingHoursDatev',
        reportModel: 'driverWorkingHrsDatevReport'
      });
      var _additionalProperties = {
        translatedName: $translate.instant('trackReporting.performanceReport.customExportDialog.title'),
        isDynamicGrid: true,
        dynamicModuleName: 'DriverWorkingHoursDatev'
      };
      gridSettings = commonTrackService.getGridSettings('driverWorkingHrsDatevReport', {
        pagesizeoptions: ['10', '15', '25'],
        pagesize: 10,
        columns: column,
        autosavestate: false,
        height: 360,
        autoloadstate: false
      }, null, _additionalProperties);
      dataAdapter = new $.jqx.dataAdapter(source);
      gridSettings.source = dataAdapter;
      //$('#'+$scope.overviewGridPrefix+'driverWorkingHrsDatevReportList').jqxGrid({columns: column});
      $('#' + $scope.overviewGridPrefix + 'driverWorkingHrsDatevReportList').jqxGrid(gridSettings);
    }, function () {}).finally(function () {

      $scope.dataLoadingFinished = true;
      $scope.initSelectionFinished = true;
      //column = null;
    });
  };

  $scope.exportDatev = function () {
    $scope.date.startDate = moment($scope.date.startDate);
    $scope.date.endDate = moment($scope.date.endDate);
    startDate = $filter('date')($scope.date.startDate._d, 'yyyy/MM/dd/HH:mm:ss');
    endDate = $filter('date')($scope.date.endDate._d, 'yyyy/MM/dd/HH:mm:ss');

    var driverIds = {
      driverID: _getDriverIds(hasAllOptionInSelectedList())
    };

    reportService.driverWrkHrsDatevVtmDownload($scope.moduleName, items.deviceId, endDate, startDate, true, 'DriverWorkingHoursDatev', null, driverIds).then(function (result) {
      var blob = new $window.Blob([result]);
      saveAs(blob, $filter('date')($scope.date.endDate._d, 'MMyyyy') + '.vtm');
      return reportService.driverWrkHrsDatevExcelDownload($scope.moduleName, items.deviceId, endDate, startDate, true, 'DriverWorkingHoursDatev', null, driverIds).then(function (result) {
        var blob2 = new $window.Blob([result]);
        saveAs(blob2, $filter('date')($scope.date.endDate._d, 'ddMMyyyy') + '.xls');
        toastService.showSuccessToast($translate.instant('trackReporting.performanceReport.customExportDialog.exportSuccess'));
      }, function (response) {
        errorHandlingService.handleForCommonResponse(response);
      });
    }, function (response) {
      errorHandlingService.handleForCommonResponse(response);
    });
  };

  $scope.cancel = function () {
    $scope.$dismiss('cancel');
  };

  $scope.closeAlertByIndex = function (index) {
    $scope.alerts.splice(index, 1);
  };

  $scope.getReport = function () {
    loadRport(_getDriverIds(hasAllOptionInSelectedList()));
  };

  var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
    $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options);
  });

  var clearFilterevnt = $rootScope.$on('combobox-clear-selection-evt', function (event, data) {
    if (data.id === 'driverComboBoxDateEvDialog') {
      isAllUncheck = true;
      _checkOrUncheckItem('uncheckItem');
      isAllUncheck = false;
      loadRport([]);
    }
  });

  if (items.selctedOption.length > 0 && items.selctedOption[0].value !== 'selectAll') {
    isInitialLoading = true;
    var initialSelectedDriverId = [];
    for (var i = 0; i < items.selctedOption.length; i++) {
      setSelectedVehicles(items.selctedOption[i]);
      initialSelectedDriverId.push(items.selctedOption[i].value);
    }
    loadRport(initialSelectedDriverId);
    isInitialLoading = false;
  } else {
    isInitialLoading = true;
    loadRport([]);
    isInitialLoading = false;
  }

  $scope.$on('$destroy', function () {
    clearFilterevnt();
    updateDateRangeInternalDateEvent();
  });

  function _checkOrUncheckItem(operation) {
    for (var k = 0; k < $scope.workingHoursDatev.driverComboSettings.source.length; k++) {
      $('#driverComboBoxDateEvDialog').jqxComboBox(operation, $scope.workingHoursDatev.driverComboSettings.source[k].key);
    }
  }

  var isSelectAll = false;
  var isAllUncheck = false;

  function _getDriverIds(isAll, forceUnselect) {
    var driverArr = [];
    if (!isAll) {
      var selectedDrivers = $('#driverComboBoxDateEvDialog').jqxComboBox('getCheckedItems');
      for (var i = 0; i < selectedDrivers.length; i++) {
        if (selectedDrivers[i].value !== 'selectAll') {
          driverArr.push(selectedDrivers[i].value);
        } else {
          if (forceUnselect) {
            isAllUncheck = true;
            $('#driverComboBoxDateEvDialog').jqxComboBox('uncheckItem', 'selectAll');
            isAllUncheck = false;
          }
        }
      }
      return driverArr;
    } else {
      for (var j = 0; j < $scope.workingHoursDatev.driverComboSettings.source.length; j++) {
        if ($scope.workingHoursDatev.driverComboSettings.source[j].key !== 'selectAll') {
          driverArr.push($scope.workingHoursDatev.driverComboSettings.source[j].key);
        }
      }
      return driverArr;
    }
  }

  function checkChangeEvent(event) {
    if (event.args && event.args.item) {
      if (isAllUncheck || isSelectAll) {
        return;
      }
      try {
        if (event.args.item.value === 'selectAll' && event.args.checked === true) {
          isSelectAll = true;
          $('#driverComboBoxDateEvDialog').jqxComboBox('clearSelection');
          _checkOrUncheckItem('checkItem');
          isSelectAll = false;
          return;
        } else if (event.args.item.value === 'selectAll' && event.args.checked === false) {
          isAllUncheck = true;
          _checkOrUncheckItem('uncheckItem');
          isAllUncheck = false;
          return;
        }
      } finally {
        loadRport();
      }
    }
  }
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/telephone/deleteConfirm.tpl.html', '<div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title" translate="deleteConfirm.delete_title"></h3></div><div class="modal-body"><div style="margin-top: 5px" class="input-group"><p translate="deleteConfirm.delete_body"></p></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="delete()" translate="deleteConfirm.delete_button"></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="close()" translate="deleteConfirm.cancel_button"></button></div></div>');
  }]);
})();

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by fky on 02/23/2017.
 */


angular.module('betosyswebapp').controller('DeleteCtrl', ["$scope", "$uibModalInstance", "selectedRowData", "telephoneService", "errorHandlingService", function ($scope, $uibModalInstance, selectedRowData, telephoneService, errorHandlingService) {
  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.onKeyPress = function ($event) {
    if ($event.keyCode === 13) {
      $scope.delete();
    }
  };
  $scope.delete = function () {
    var telephoneDetail = {
      key: selectedRowData.key,
      name: selectedRowData.name,
      telephoneNumber: selectedRowData.telephoneNumber
    };
    telephoneService.deleteTelephone(telephoneDetail).then(function () {
      $uibModalInstance.close('success');
    }, function (response) {
      $uibModalInstance.close('error');
      errorHandlingService.handleForCommonResponse(response);
    });
  };
}]);

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/telephone/download.tpl.html', '<div xmlns="http://www.w3.org/1999/html"><form name="downloadForm" ng-submit="save()"><div class="modal-header"><h3 class="modal-title" translate="download.title"></h3></div><div class="modal-body"><div class="row" style="padding-bottom: 5px"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 5px;"><label translate="download.vehicleGroup"></label></div><div class="col-xs-9 col-sm-9 col-md-9"><jqx-combo-box id="vehicleGroupComboBox" ng-model="vehicleGroup" focus-blur="" jqx-settings="vehicleGroupComboBoxSettings" jqx-create="dataLoadingFinished" clear-input=""></jqx-combo-box></div></div><div class="row" style="padding-bottom: 5px"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 5px;"><label translate="download.vehicleName"></label></div><div class="col-xs-5 col-sm-5 col-md-5"><jqx-list-box id="vehicleNameListBox" jqx-settings="vehicleNameListBoxSettings"></jqx-list-box></div><div class="col-xs-4 col-sm-4 col-md-4"><button type="button" id="slectAllBtn" class="btn btn-default unified-btn" ng-click="selectAll()"><span class="span-btn-font" translate="download.selectAll"></span></button> <button type="button" id="deselectAllBtn" class="btn btn-default unified-btn" ng-click="deselectAll()"><span class="span-btn-font" translate="download.deselectAll"></span></button></div></div></div><div class="modal-footer"><button class="btn btn-primary" type="submit" translate="download.ok" ng-disabled="visibility"></button> <a class="btn btn-warning" ng-click="cancel()" translate="download.cancel"></a></div></form></div>');
  }]);
})();

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by zhj on 3/16/2016.
 */


angular.module('betosyswebapp').controller('PendingCommandCtrl', ["$scope", "commonTrackService", "widgetSettingsCreatorService", "$uibModalInstance", "pendingCommandService", "$timeout", "errorHandlingService", function ($scope, commonTrackService, widgetSettingsCreatorService, $uibModalInstance, pendingCommandService, $timeout, errorHandlingService) {
  $scope.visibility = true;
  $scope.vehicleGroupComboBoxSettings = widgetSettingsCreatorService.createComboxSettings({
    displayMember: 'description',
    valueMember: 'groupID',
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
    selectedIndex: 0,
    change: function change(event) {
      var args = event.args;
      var vehicleGroupItem = $('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');
      if (args && vehicleGroupItem) {
        var groupId = vehicleGroupItem.value;
        loadVehicle(groupId);
      }
    }
  });

  var loadVehicleGroup = function loadVehicleGroup() {
    return commonTrackService.getVehicleGroupComboList().then(function (vehicleGroupList) {
      $scope.vehicleGroupComboBoxSettings.source = vehicleGroupList;
    });
  };

  var loadVehicle = function loadVehicle(groupId) {
    return commonTrackService.getVehicleListFilterByGroupId(groupId).then(function (vehicleList) {
      $scope.vehicleNameListBoxSettings.source = _.uniq(vehicleList, 'deviceID');
    });
  };

  $scope.vehicleNameListBoxSettings = {
    displayMember: 'description',
    valueMember: 'deviceID',
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme,
    checkboxes: true
  };

  $timeout(function () {
    $('#vehicleNameListBox').on('checkChange', function (event) {
      var item = event.args;
      if (item) {
        if (item.checked) {
          $timeout(function () {
            $scope.visibility = false;
          });
        } else {
          var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
          if (checkedItems.length === 0) {
            $timeout(function () {
              $scope.visibility = true;
            });
          } else {
            $scope.visibility = false;
          }
        }
      }
    });
  }, 0);

  loadVehicleGroup().then(function () {
    var vehicleGroupSource = $scope.vehicleGroupComboBoxSettings.source;
    if (vehicleGroupSource !== null && vehicleGroupSource !== undefined) {
      loadVehicle(vehicleGroupSource[0].groupID);
    }
  }).finally(function () {
    $scope.dataLoadingFinished = true;
  });

  $scope.selectAll = function () {
    $('#vehicleNameListBox').jqxListBox('checkAll');
  };

  $scope.deselectAll = function () {
    $('#vehicleNameListBox').jqxListBox('uncheckAll');
  };

  $scope.save = function () {
    var downloadParams = {
      deviceIds: [],
      commandType: 'config',
      commandID: 'TEL',
      sendState: 0
    };
    var checkedItems = $('#vehicleNameListBox').jqxListBox('getCheckedItems');
    var deviceIds = [];
    for (var i = 0; i < checkedItems.length; i++) {
      var item = checkedItems[i];
      deviceIds.push(item.value);
    }
    downloadParams.deviceIds = deviceIds;
    pendingCommandService.downloadRequest(downloadParams).then(function () {
      $uibModalInstance.close();
    }, function (response) {
      $uibModalInstance.close();
      errorHandlingService.handleForCommonResponse(response);
    });
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/18/2016.
 */


angular.module('betosyswebapp').service('pendingCommandService', ["crudService", function (crudService) {

  this.downloadRequest = function (downloadParams) {
    return crudService.post('pendingcommands', downloadParams);
  };
}]);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/14/2016.
 */


angular.module('telephone', ['ui.router']).config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('telephones', {
    parent: 'betotrack',
    abstract: true,
    url: '/telephone',
    ncyBreadcrumb: {
      skip: true
    }
  }).state('telephones.list', {
    url: '/list',
    views: {
      'content@app': {
        controller: 'TelephoneCtrl',
        templateUrl: 'components/track/telephone/telephoneList.tpl.html'
      }
    },
    ncyBreadcrumb: {
      label: 'telephonesList.moduleName'
    }
  }).state('telephones.new', {
    url: '/new',
    views: {
      'content@app': {
        controller: 'TelephoneEditCtrl',
        templateUrl: 'components/track/telephone/telephoneOperate.tpl.html'
      }
    },
    resolve: {
      editorModel: ["telephoneService", function editorModel(telephoneService) {
        return {
          mode: 'new',
          getTelephone: telephoneService.getNewTelephone(),
          save: function save(telephoneDetail) {
            return telephoneService.saveTelephone(telephoneDetail);
          }
        };
      }]
    },
    ncyBreadcrumb: {
      parent: 'telephones.list',
      label: 'telephoneNew.new'
    }
  }).state('telephones.edit', {
    url: '/{telephoneNumber}/edit',
    params: {
      key: null,
      firstName: null,
      lastName: null,
      fullName: null,
      telephoneNumber: null
    },
    views: {
      'content@app': {
        controller: 'TelephoneEditCtrl',
        templateUrl: 'components/track/telephone/telephoneOperate.tpl.html'
      }
    },
    resolve: {
      editorModel: ["telephoneService", "$stateParams", function editorModel(telephoneService, $stateParams) {
        return {
          mode: 'edit',
          getTelephone: telephoneService.getTelephoneDetail($stateParams),
          save: function save(telephoneDetail) {
            return telephoneService.updateTelephone(telephoneDetail);
          }
        };
      }]
    },
    ncyBreadcrumb: {
      parent: 'telephones.list',
      label: '{{telephoneNumber}}'
    }
  }).state('telephones.copy', {
    url: '/{telephoneNumber}/copy',
    params: {
      key: null,
      firstName: null,
      lastName: null,
      fullName: null,
      telephoneNumber: null
    },
    views: {
      'content@app': {
        controller: 'TelephoneEditCtrl',
        templateUrl: 'components/track/telephone/telephoneOperate.tpl.html'
      }
    },
    resolve: {
      editorModel: ["telephoneService", "$stateParams", function editorModel(telephoneService, $stateParams) {
        return {
          mode: 'copy',
          getTelephone: telephoneService.getCopyTelephone($stateParams.key),
          save: function save(telephoneDetail) {
            return telephoneService.saveTelephone(telephoneDetail);
          }
        };
      }]
    },
    ncyBreadcrumb: {
      parent: 'telephones.list',
      label: 'telephoneNew.copy'
    }
  });
}]);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/telephone/telephone.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12 mainContent" style="padding: 2px"><div ui-view="list" ng-show="$state.includes(\'telephones.list\')"></div><div ui-view="edit" ng-show="$state.includes(\'telephones.edit\')"></div><div ui-view="new" ng-show="$state.includes(\'telephones.new\')"></div><div ui-view="copy" ng-show="$state.includes(\'telephones.copy\')"></div></div></div></div>');
  }]);
})();

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/15/2016.
 */


angular.module('telephone').controller('TelephoneEditCtrl', ["$scope", "$stateParams", "editorModel", "$state", "toastService", "errorHandlingService", "telephoneService", function ($scope, $stateParams, editorModel, $state, toastService, errorHandlingService, telephoneService) {

  $scope.telephondeResourceAcl = null;

  $scope.telephoneNumber = $stateParams.telephoneNumber;
  var telpehoneResourceAclRight = function telpehoneResourceAclRight() {
    return telephoneService.getTelephoneAclRight().then(function (telephondeAclRights) {
      $scope.telephondeResourceAcl = telephondeAclRights;
      if ($scope.telephondeResourceAcl.aclRightLvel > 0) {}
    });
  };
  telpehoneResourceAclRight().then(function () {
    if ($stateParams.name) {
      $scope.name = $stateParams.name;
      $scope.telephoneDetail = $stateParams;
    } else {
      editorModel.getTelephone.then(function (telephoneDetail) {
        $scope.name = telephoneDetail.name;
        $scope.telephoneDetail = telephoneDetail;
      });
    }
  });

  $scope.save = function (isSaveAndNew) {
    if ($scope.telephoneForm.$error.required) {
      var requiredName = $scope.telephoneForm.$error.required[0].$name;
      var errorAlert = { type: 'F', message: requiredName + ' is required!' };
      toastService.showErrorToast(errorAlert);
    } else {
      if ($state.saveEnabled !== false) {
        var telephoneDetail = {
          key: $scope.telephoneDetail.key,
          name: $scope.telephoneDetail.name,
          telephoneNumber: $scope.telephoneDetail.telephoneNumber
        };
        $state.saveEnabled = false;
        editorModel.save(telephoneDetail).then(function () {
          $state.saveEnabled = true;
          toastService.showSuccessToast('Save Successfully!');
          if (isSaveAndNew) {
            $state.go('telephones.new', {}, { reload: true });
          } else {
            $state.go('telephones.list');
          }
        }, function (response) {
          $state.saveEnabled = true;
          errorHandlingService.handleForCommonResponse(response);
        });
      }
    }
  };

  $scope.cancel = function () {
    $state.go('telephones.list');
  };
}]);

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/telephone/telephoneImportDialog.tpl.html', '<div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="close()"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button><h3 class="modal-title" translate="telephonesList.telephoneImport.dialogTitle"></h3></div><div class="modal-body"><div><input onchange="angular.element(this).scope().fileChanged(this)" id="importFileBrowserBtn" type="file" accept="text/plain" ng-disabled="isFileinputDisabled"></div></div><div style="padding: 15px;"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="import()" translate="telephonesList.telephoneImport.importBtn" ng-disabled="isImportBtnDisabled"></button> <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="close()" translate="deleteConfirm.cancel_button"></button></div></div>');
  }]);
})();

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by rak on 11/16/2017.
 */


angular.module('betosyswebapp').controller('ImportDilaogCtrl', ["$scope", "$uibModalInstance", "$translate", "telephoneService", "toastService", function ($scope, $uibModalInstance, $translate, telephoneService, toastService) {
  $scope.isImportBtnDisabled = true;

  $scope.fileChanged = function (element) {
    $scope.isFileinputDisabled = true;
    var file = element.files[0];
    var reader = new FileReader();
    $scope.isImportBtnDisabled = true;

    reader.onloadend = function (e) {
      //callback after files finish loading
      $scope.encodedData = e.target.result;
      $scope.isImportBtnDisabled = false;
      $scope.$apply();
      $scope.encodedData = $scope.encodedData.replace(/^data:text\/plain;base64,/, '');
      $scope.isFileinputDisabled = false;
      //here you can send data over your server as desired
    };
    reader.readAsDataURL(file);
  };

  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.import = function () {
    if ($scope.encodedData) {
      telephoneService.importTelephone($scope.encodedData).then(function () {
        $uibModalInstance.close($translate.instant('telephonesList.telephoneImport.successAlert'));
      }, function (response) {
        var _messsage = response.data && response.data.errors && response.data.errors[0].code ? $translate.instant('errorCodes.restAPI.' + response.data.errors[0].code + '.message') : response.data.message;
        var errorAlert = { type: 'F', message: _messsage };
        toastService.showErrorToast(errorAlert);
      });
    }
  };
}]);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/telephone/telephoneList.tpl.html', '<div class="container-fluid"><div class="row"><div class="col-sm-12 col-md-12" style="padding: 0px;"><div class="row" id="breadcrump"><div class="col-xs-12 col-sm-12 col-md-12 customer-header" style=""><div ncy-breadcrumb="" style="margin-bottom: 5px;margin-top: 0px;font-size: 24px;"></div><div class="col-xs-4 col-sm-4 col-md-4"><div class="row"><button type="button" ng-disabled="telephondeResourceAcl.aclRightLvel ===0" class="btn btn-default unified-btn" ng-click="toEditPage()"><span class="glyphicon glyphicon-edit"></span> <span class="span-btn-font" translate="telephoneNew.edit"></span></button> <button type="button" ng-disabled="telephondeResourceAcl.aclRightLvel !==3" class="btn btn-default unified-btn" ng-click="new()"><span class="glyphicon glyphicon-plus"></span> <span class="span-btn-font" translate="telephoneNew.new"></span></button> <button type="button" ng-disabled="telephondeResourceAcl.aclRightLvel !==3" class="btn btn-default unified-btn" ng-click="copy()"><span class="glyphicon glyphicon-copy"></span> <span class="span-btn-font" translate="telephoneNew.copy"></span></button></div></div><div class="col-xs-5 col-sm-5 col-md-5" style="display:inline-flex;;padding: 0px"><div jqx-delete-directive="moreFunDropDown" type="dropDownList" ng-if="isDataAvailable"><jqx-drop-down-list id="moreFunDropDown" ng-model="telephoneListDetails.selectedFunction" jqx-ng-model="" jqx-settings="moreFuctionSetting" ng-change="moreFunctions()" ignore-dirty=""></jqx-drop-down-list></div></div></div></div></div></div><div class="row" style="margin: 0" ng-if="isDataAvailable"><div jqx-delete-directive="{{overviewGridPrefix}}telephonesList" type="grid"><jqx-grid id="{{overviewGridPrefix}}telephonesList" jqx-settings="telephonesListGridSettings" jqx-create="dataLoadingFinished"></jqx-grid></div></div><div ng-if="telephondeResourceAcl.aclRightLvel === 0"><no-authorize></no-authorize></div></div>');
  }]);
})();

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Created by zhj on 3/14/2016.
 */


angular.module('telephone').controller('TelephoneCtrl', ["$scope", "$rootScope", "telephoneService", "commonTrackService", "$uibModal", "$state", "$translate", "$timeout", "toastService", "$window", "widgetSettingsCreatorService", function ($scope, $rootScope, telephoneService, commonTrackService, $uibModal, $state, $translate, $timeout, toastService, $window, widgetSettingsCreatorService) {
  $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
  $scope.isDataAvailable = false;
  $scope.hasUpdateRight = false;
  $scope.telephondeResourceAcl = null;
  $scope.pendingCommandsAcl = null;
  $scope.telephoneListDetails = {
    selectedFunction: ''
  };

  // var downloadFunction = function () {
  //   $uibModal.open({
  //     templateUrl: 'components/track/telephone/download.tpl.html',
  //     controller: 'PendingCommandCtrl'
  //   });
  // };

  var deleteTel = function deleteTel() {
    var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
    var data = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowdata', rowindex);
    var modalInstance = $uibModal.open({
      templateUrl: 'components/track/telephone/deleteConfirm.tpl.html',
      controller: 'DeleteCtrl',
      resolve: {
        selectedRowData: function selectedRowData() {
          return data;
        }
      }
    });

    modalInstance.result.then(function (result) {
      if (result === 'success') {
        var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
        if (rowindex > -1) {
          var id = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowid', rowindex);
          $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('deleterow', id);
        }
      } else if (result === 'error') {
        console.error('delete error');
      }
    });
  };

  var importFunction = function importFunction() {
    var modalInstance = $uibModal.open({
      templateUrl: 'components/track/telephone/telephoneImportDialog.tpl.html',
      controller: 'ImportDilaogCtrl'
    });

    modalInstance.result.then(function (result) {
      toastService.showSuccessToast(result);
      $timeout(function () {
        $window.location.reload();
      }, 400);
    });
  };

  $scope.moreFunctionsSource = [
  //  {
  //   name: $translate.instant('moreFunction.functionList.download'),
  //   operation: 'download',
  //   disabled: true,
  //   execute: downloadFunction
  // },
  {
    name: $translate.instant('moreFunction.functionList.delete'),
    operation: 'delete',
    disabled: true,
    execute: deleteTel
  }, {
    name: $translate.instant('moreFunction.functionList.fileImport'),
    operation: 'import',
    disabled: true,
    execute: importFunction
  }];

  $scope.moreFuctionSetting = {
    placeHolder: $translate.instant('moreFunction.button.function'),
    displayMember: 'name',
    valueMember: 'operation',
    source: $scope.moreFunctionsSource,
    theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
    width: '200px',
    height: 30,
    autoDropDownHeight: true
  };

  $scope.moreFunctions = function () {
    for (var index in $scope.moreFunctionsSource) {
      var moreFunctionsItem = $scope.moreFunctionsSource[index];
      if (moreFunctionsItem.operation && moreFunctionsItem.operation === $scope.telephoneListDetails.selectedFunction.operation) {
        moreFunctionsItem.execute();
        $scope.telephoneListDetails.selectedFunction = '';
        break;
      }
    }
    $('#moreFunDropDown').jqxDropDownList('clearSelection');
  };

  var _tmpColumnProperties = [{
    name: 'name', width: '25%',
    type: 'string'
  }, {
    name: 'telephoneNumber', width: '25%',
    type: 'string'
  }];

  $scope.customGridProperties = {
    pagesize: 25,
    height: 600,
    autoheight: false,
    showfilterrow: true,
    filterable: true,
    columns: []
  };

  $scope.customGridProperties.columns = commonTrackService.getColumnProperties(_tmpColumnProperties, {}, { moduleName: 'telephones' });
  var _additionalProperties = { translatedName: $translate.instant('telephonesList.moduleName') };
  $scope.telephonesListGridSettings = commonTrackService.getGridSettings('telephones', $scope.customGridProperties, null, _additionalProperties);

  var getTelephoneList = function getTelephoneList() {
    return telephoneService.getTelephoneList().then(function (telephoneIndexes) {
      $scope.isDataAvailable = true;
      var _tmpDetail = [];
      for (var i = 0; i < telephoneIndexes.length; i++) {
        var telephone = telephoneIndexes[i];
        var _detailObjFormat = {
          key: telephone.key,
          name: telephone.name,
          telephoneNumber: telephone.telephoneNumber
        };
        _tmpDetail.push(_detailObjFormat);
      }
      $scope.telephonesListGridSettings.source = _tmpDetail;
    }, function (response) {
      if (response.data && response.data.message) {
        $scope.isDataAvailable = false;
      }
    });
  };

  var pendingCommandsAclRight = function pendingCommandsAclRight() {
    return telephoneService.getPendingCommandsAclRight().then(function (pendingCommandsAclRights) {
      $scope.pendingCommandsAcl = pendingCommandsAclRights;
    });
  };

  var telpehoneResourceAclRight = function telpehoneResourceAclRight() {
    return telephoneService.getTelephoneAclRight().then(function (telephondeAclRights) {
      $scope.telephondeResourceAcl = telephondeAclRights;
    });
  };

  telpehoneResourceAclRight().then(function () {
    return getTelephoneList();
  }).then(function () {
    return pendingCommandsAclRight();
  }).finally(function () {
    if ($scope.isDataAvailable) {
      if ($scope.telephondeResourceAcl && $scope.telephondeResourceAcl.aclRightLvel === 3) {
        enableDropDoen(0); // delete  menu index 1
        enableDropDoen(1); // import menu index 2
      } else {
        disabbleDropDown(0); // delete menu index 1
        disabbleDropDown(1); // import menu index 2
      }
      // if ($scope.pendingCommandsAcl && $scope.pendingCommandsAcl.aclRightLvel === 3) {
      //   enableDropDoen(0); // download menu index 0
      // }
      // else {
      //   disabbleDropDown(0);// download menu index 0
      // }
    }

    $scope.dataLoadingFinished = true;

    if ($scope.telephondeResourceAcl.aclRightLvel > 0) {
      enableDoubleClickEvent();
    }
  });

  function enableDropDoen(index) {
    $timeout(function () {
      $('#moreFunDropDown').jqxDropDownList('enableAt', index); // this does not working check onece more
    });
  }

  function disabbleDropDown(index) {
    $timeout(function () {
      $('#moreFunDropDown').jqxDropDownList('disableAt', index); // this does not working check onece more
    });
  }

  function enableDoubleClickEvent() {
    $timeout(function () {
      $('#' + $scope.overviewGridPrefix + 'telephonesList').on('rowdoubleclick', function () {
        $scope.toEditPage();
      });
    }, 0);
  }

  $scope.toEditPage = function () {
    var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
    if (rowindex !== -1) {
      var data = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowdata', rowindex);
      $state.go('telephones.edit', data);
    } else {
      toastService.showWarningToast('No Selected Item!');
    }
  };

  $scope.new = function () {
    $state.go('telephones.new');
  };

  $scope.copy = function () {
    var rowindex = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getselectedrowindex');
    if (rowindex !== -1) {
      var data = $('#' + $scope.overviewGridPrefix + 'telephonesList').jqxGrid('getrowdata', rowindex);
      $state.go('telephones.copy', data);
    } else {
      toastService.showWarningToast('No Selected Item!');
    }
  };

  $scope.$on('$destroy', function () {
    delete $scope.telephonesListGridSettings.source;
  });
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (module) {
  try {
    module = angular.module('betosyswebapp');
  } catch (e) {
    module = angular.module('betosyswebapp', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('components/track/telephone/telephoneOperate.tpl.html', '<form class="col-xs-12 col-sm-12 col-md-12 editForm" name="telephoneForm" novalidate="" confirm-on-exit="" style="background-color: white"><div class="col-xs-12 col-sm-12 col-md-12 customer-header" style="padding: 2.5px"><div ncy-breadcrumb="" style="margin: 0px;padding-left: 0px;font-size: 24px;"></div><div class="row" style="margin: 0"><div class="col-xs-8 col-sm-8 col-md-4"><button type="button" class="btn btn-default unified-btn" ng-disabled="telephondeResourceAcl.aclRightLvel <=1" ng-click="save(false)"><span class="glyphicon glyphicon-save"></span><span class="span-btn-font" translate="telephoneNew.save"></span></button> <button type="button" class="btn btn-default unified-btn" ng-disabled="telephondeResourceAcl.aclRightLvel < 3" ng-click="save(true)"><span class="glyphicon glyphicon-check"></span><span class="span-btn-font" translate="telephoneNew.saveNew"></span></button> <button type="button" class="btn btn-default unified-btn" ng-click="cancel()"><span class="glyphicon glyphicon-arrow-left"></span><span class="span-btn-font" translate="telephoneNew.cancel"></span></button></div></div></div><div class="form-group-dsa"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 2.5px;"><label style="padding-left: 15px" translate="telephoneNew.firstName"></label></div><div class="col-xs-4 col-sm-4 col-md-4" style="padding: 2.5px;"><input type="text" name="{{\'telephoneNew.name\' | translate}}" class="form-control required" ng-model="telephoneDetail.name" upper-case="" maxlength="50" required=""></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6" style="padding: 2.5px;"><div class="col-xs-3 col-sm-3 col-md-3" style="padding: 2.5px;"><label style="padding-left: 15px" translate="telephoneNew.telephone"></label></div><div class="col-xs-4 col-sm-4 col-md-4" style="padding: 2.5px;"><input type="text" id="phoneInput" name="{{\'telephoneNew.telephone\' | translate}}" class="form-control required" ng-model="telephoneDetail.telephoneNumber" required="true" phone-input=""></div></div></div></div></form>');
  }]);
})();

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by zhj on 3/14/2016.
 */


angular.module('telephone').service('telephoneService', ["crudService", "$q", function (crudService, $q) {
  var model = 'telephones';

  this.getTelephoneList = function () {
    return crudService.getList(model + '/telephoneindexlist');
  };

  this.getNewTelephone = function () {
    var telephone = {
      key: null,
      firstName: null,
      lastName: null,
      fullName: null,
      telephoneNumber: null
    };
    var deferred = $q.defer();
    deferred.resolve(telephone);
    return deferred.promise;
  };

  this.getTelephoneDetail = function (details) {
    if (details.key) {
      return crudService.get(model, details.key);
    }
    return crudService.get(model, details.telephoneNumber);
  };

  this.getCopyTelephone = function (key) {
    return crudService.get(model, key).then(function (telephone) {
      telephone.resourceID = null;
      return telephone;
    });
  };

  this.saveTelephone = function (telephoneDetail) {
    return crudService.post(model, telephoneDetail);
  };

  this.updateTelephone = function (telephoneDetail) {
    return crudService.put(model, telephoneDetail);
  };

  this.deleteTelephone = function (telephoneDetail) {
    if (telephoneDetail.key) {
      return crudService.delete(model + '/' + telephoneDetail.key);
    }
    return crudService.delete(model + '/' + telephoneDetail.telephoneNumber);
    //return crudService.delete(model + '/' + telephoneDetail.name +'/' + telephoneDetail.telephoneNumber);
  };

  this.checkUserRight = function () {
    return crudService.get(model + '/checkdownload');
  };

  this.checkPhoneDBRight = function () {
    return crudService.get(model + '/phonedbright');
  };
  this.importTelephone = function (encodedFileString) {
    return crudService.post(model + '/import', encodedFileString);
  };
  this.getTelephoneAclRight = function () {
    return crudService.get(model + '/resourceaclright');
  };
  this.getPendingCommandsAclRight = function () {
    return crudService.get(model + '/pendingcmndaclright');
  };
}]);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by fky on 11/2/2016.
 */


angular.module('betosyswebapp').config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state('betotrack', {
    parent: 'app',
    abstract: true,
    url: '/track',
    ncyBreadcrumb: {
      label: 'Track',
      skip: true
    },
    views: {
      'sidebar@app': {
        template: '<adm-sidebar model="framework.sidebarModel"></adm-sidebar>',
        controller: 'TrackController',
        controllerAs: 'framework'
      }
    }
  }).state('betotrack.dashboard', {
    url: '/dashboard',
    ncyBreadcrumb: {
      label: 'Track'
    },
    views: {
      'content@app': {
        templateUrl: 'components/dashboard/trackDashboard.tpl.html',
        controller: 'TrackDashboardCtrl'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack', 'Fleet Management Dashboard';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(true);
        return true;
      }]
    }
  }).state('betotrack.login', {
    url: '/login',
    views: {
      'content@app': {
        templateUrl: 'components/login/login.tpl.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      }
    },
    resolve: {
      $title: function $title() {
        return 'BetoTrack Login';
      },
      $sibebar: ['AdmStatusService', function (AdmStatusService) {
        AdmStatusService.setSidebarVisible(false);
        return false;
      }]
    }
  });
}]);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Created by cxh on 8/10/2016.
 */
(function () {
  'use strict';

  TrackController.$inject = ["$scope", "customerService", "AuthenticationService", "updaterService", "$interval"];
  angular.module('betosyswebapp').controller('TrackController', TrackController);

  /* @ngInject */
  function TrackController($scope, customerService, AuthenticationService, updaterService, $interval) {
    var vm = this;
    var failuresInterval = null;
    vm.sidebarModel = createSideBarModel();

    $scope.$on('$destroy', function () {
      if (failuresInterval !== null) {
        $interval.cancel(failuresInterval);
      }
    });

    activate();

    ////////////////
    function activate() {
      $scope.$watch(function () {
        return AuthenticationService.IsLogin();
      }, function (data) {
        if (data) {
          updaterService.doUpdate();
        }
      }, true);
    }

    function createSideBarModel() {

      var model = {};

      model.showUserPanel = false;

      // menu items.
      model.treeItems = customerService.getCustomerSideBarMenu();
      // periodically update the sidebar failures count (Every 5 mins)
      updateFailuresCount(model);
      failuresInterval = $interval(function () {
        updateFailuresCount(model);
      }, 300000);

      // search panel.
      model.showSearchPanel = false;

      return model;
    }

    function updateFailuresCount(model) {
      customerService.getVehicleFailuresCount().then(function (data) {
        if (data.dataList !== null) {
          var fmsItem = model.treeItems.find(function (item) {
            return item.text === 'sidebar.betotrack.fms';
          });
          if (fmsItem !== null) {
            var failuresCount = data.dataList[0].telltalecount;
            if (failuresCount > 99) {
              fmsItem.failures = '99+';
            } else {
              fmsItem.failures = failuresCount;
            }
          }
        }
      });
    }
  }
})();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/app.3f001f377bffb05fe42e.bundle.js